
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6a43"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6a43"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aPfka", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7e1a8de1463f8dc5$export$ffb0004e005737fa, (v) => $7e1a8de1463f8dc5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7e1a8de1463f8dc5$export$34b9dba7ce09269b, (v) => $7e1a8de1463f8dc5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7e1a8de1463f8dc5$export$25062201e9e25d76, (v) => $7e1a8de1463f8dc5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e1a8de1463f8dc5$export$ffb0004e005737fa;
var $7e1a8de1463f8dc5$export$34b9dba7ce09269b;
var $7e1a8de1463f8dc5$export$25062201e9e25d76;
'use strict';

var $aqdBs = parcelRequire("aqdBs");
var $7e1a8de1463f8dc5$var$k = Symbol.for("react.element"), $7e1a8de1463f8dc5$var$l = Symbol.for("react.fragment"), $7e1a8de1463f8dc5$var$m = Object.prototype.hasOwnProperty, $7e1a8de1463f8dc5$var$n = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7e1a8de1463f8dc5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7e1a8de1463f8dc5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7e1a8de1463f8dc5$var$m.call(a, b) && !$7e1a8de1463f8dc5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7e1a8de1463f8dc5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7e1a8de1463f8dc5$var$n.current
    };
}
$7e1a8de1463f8dc5$export$ffb0004e005737fa = $7e1a8de1463f8dc5$var$l;
$7e1a8de1463f8dc5$export$34b9dba7ce09269b = $7e1a8de1463f8dc5$var$q;
$7e1a8de1463f8dc5$export$25062201e9e25d76 = $7e1a8de1463f8dc5$var$q;

});
parcelRegister("aqdBs", function(module, exports) {
'use strict';

module.exports = (parcelRequire("WCsmQ"));

});
parcelRegister("WCsmQ", function(module, exports) {

$parcel$export(module.exports, "Children", () => $0b033f8fda7971e0$export$dca3b0875bd9a954, (v) => $0b033f8fda7971e0$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $0b033f8fda7971e0$export$16fa2f45be04daa8, (v) => $0b033f8fda7971e0$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $0b033f8fda7971e0$export$ffb0004e005737fa, (v) => $0b033f8fda7971e0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $0b033f8fda7971e0$export$e2c29f18771995cb, (v) => $0b033f8fda7971e0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $0b033f8fda7971e0$export$221d75b3f55bb0bd, (v) => $0b033f8fda7971e0$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $0b033f8fda7971e0$export$5f8d39834fd61797, (v) => $0b033f8fda7971e0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0b033f8fda7971e0$export$74bf444e3cd11ea5, (v) => $0b033f8fda7971e0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b033f8fda7971e0$export$ae55be85d98224ed, (v) => $0b033f8fda7971e0$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $0b033f8fda7971e0$export$3ba232387fd5d6dd, (v) => $0b033f8fda7971e0$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $0b033f8fda7971e0$export$e530037191fcd5d7, (v) => $0b033f8fda7971e0$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $0b033f8fda7971e0$export$fd42f52fd3ae1109, (v) => $0b033f8fda7971e0$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $0b033f8fda7971e0$export$c8a8987d4410bf2d, (v) => $0b033f8fda7971e0$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $0b033f8fda7971e0$export$d38cd72104c1f0e9, (v) => $0b033f8fda7971e0$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $0b033f8fda7971e0$export$7d1e3a5e95ceca43, (v) => $0b033f8fda7971e0$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $0b033f8fda7971e0$export$257a8862b851cb5b, (v) => $0b033f8fda7971e0$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $0b033f8fda7971e0$export$a8257692ac88316c, (v) => $0b033f8fda7971e0$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $0b033f8fda7971e0$export$488013bae63b21da, (v) => $0b033f8fda7971e0$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $0b033f8fda7971e0$export$7c73462e0d25e514, (v) => $0b033f8fda7971e0$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $0b033f8fda7971e0$export$7568632d0d33d16d, (v) => $0b033f8fda7971e0$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $0b033f8fda7971e0$export$88948ce120ea2619, (v) => $0b033f8fda7971e0$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $0b033f8fda7971e0$export$35808ee640e87ca7, (v) => $0b033f8fda7971e0$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $0b033f8fda7971e0$export$fae74005e78b1a27, (v) => $0b033f8fda7971e0$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e, (v) => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $0b033f8fda7971e0$export$6a7bc4e911dc01cf, (v) => $0b033f8fda7971e0$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $0b033f8fda7971e0$export$6d9c69b0de29b591, (v) => $0b033f8fda7971e0$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $0b033f8fda7971e0$export$f680877a34711e37, (v) => $0b033f8fda7971e0$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $0b033f8fda7971e0$export$d5a552a76deda3c2, (v) => $0b033f8fda7971e0$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $0b033f8fda7971e0$export$aaabe4eda9ed9969, (v) => $0b033f8fda7971e0$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $0b033f8fda7971e0$export$e5c5a5f917a5871c, (v) => $0b033f8fda7971e0$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $0b033f8fda7971e0$export$1538c33de8887b59, (v) => $0b033f8fda7971e0$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $0b033f8fda7971e0$export$13e3392192263954, (v) => $0b033f8fda7971e0$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $0b033f8fda7971e0$export$b8f5890fc79d6aca, (v) => $0b033f8fda7971e0$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $0b033f8fda7971e0$export$60241385465d0a34, (v) => $0b033f8fda7971e0$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $0b033f8fda7971e0$export$306c0aa65ff9ec16, (v) => $0b033f8fda7971e0$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $0b033f8fda7971e0$export$7b286972b8d8ccbf, (v) => $0b033f8fda7971e0$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $0b033f8fda7971e0$export$83d89fbfd8236492, (v) => $0b033f8fda7971e0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b033f8fda7971e0$export$dca3b0875bd9a954;
var $0b033f8fda7971e0$export$16fa2f45be04daa8;
var $0b033f8fda7971e0$export$ffb0004e005737fa;
var $0b033f8fda7971e0$export$e2c29f18771995cb;
var $0b033f8fda7971e0$export$221d75b3f55bb0bd;
var $0b033f8fda7971e0$export$5f8d39834fd61797;
var $0b033f8fda7971e0$export$74bf444e3cd11ea5;
var $0b033f8fda7971e0$export$ae55be85d98224ed;
var $0b033f8fda7971e0$export$3ba232387fd5d6dd;
var $0b033f8fda7971e0$export$e530037191fcd5d7;
var $0b033f8fda7971e0$export$fd42f52fd3ae1109;
var $0b033f8fda7971e0$export$c8a8987d4410bf2d;
var $0b033f8fda7971e0$export$d38cd72104c1f0e9;
var $0b033f8fda7971e0$export$7d1e3a5e95ceca43;
var $0b033f8fda7971e0$export$257a8862b851cb5b;
var $0b033f8fda7971e0$export$a8257692ac88316c;
var $0b033f8fda7971e0$export$488013bae63b21da;
var $0b033f8fda7971e0$export$7c73462e0d25e514;
var $0b033f8fda7971e0$export$7568632d0d33d16d;
var $0b033f8fda7971e0$export$88948ce120ea2619;
var $0b033f8fda7971e0$export$35808ee640e87ca7;
var $0b033f8fda7971e0$export$fae74005e78b1a27;
var $0b033f8fda7971e0$export$dc8fbce3eb94dc1e;
var $0b033f8fda7971e0$export$6a7bc4e911dc01cf;
var $0b033f8fda7971e0$export$6d9c69b0de29b591;
var $0b033f8fda7971e0$export$f680877a34711e37;
var $0b033f8fda7971e0$export$d5a552a76deda3c2;
var $0b033f8fda7971e0$export$aaabe4eda9ed9969;
var $0b033f8fda7971e0$export$e5c5a5f917a5871c;
var $0b033f8fda7971e0$export$1538c33de8887b59;
var $0b033f8fda7971e0$export$13e3392192263954;
var $0b033f8fda7971e0$export$b8f5890fc79d6aca;
var $0b033f8fda7971e0$export$60241385465d0a34;
var $0b033f8fda7971e0$export$306c0aa65ff9ec16;
var $0b033f8fda7971e0$export$7b286972b8d8ccbf;
var $0b033f8fda7971e0$export$83d89fbfd8236492;
'use strict';
var $0b033f8fda7971e0$var$l = Symbol.for("react.element"), $0b033f8fda7971e0$var$n = Symbol.for("react.portal"), $0b033f8fda7971e0$var$p = Symbol.for("react.fragment"), $0b033f8fda7971e0$var$q = Symbol.for("react.strict_mode"), $0b033f8fda7971e0$var$r = Symbol.for("react.profiler"), $0b033f8fda7971e0$var$t = Symbol.for("react.provider"), $0b033f8fda7971e0$var$u = Symbol.for("react.context"), $0b033f8fda7971e0$var$v = Symbol.for("react.forward_ref"), $0b033f8fda7971e0$var$w = Symbol.for("react.suspense"), $0b033f8fda7971e0$var$x = Symbol.for("react.memo"), $0b033f8fda7971e0$var$y = Symbol.for("react.lazy"), $0b033f8fda7971e0$var$z = Symbol.iterator;
function $0b033f8fda7971e0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b033f8fda7971e0$var$z && a[$0b033f8fda7971e0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b033f8fda7971e0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0b033f8fda7971e0$var$C = Object.assign, $0b033f8fda7971e0$var$D = {};
function $0b033f8fda7971e0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
$0b033f8fda7971e0$var$E.prototype.isReactComponent = {};
$0b033f8fda7971e0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0b033f8fda7971e0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0b033f8fda7971e0$var$F() {}
$0b033f8fda7971e0$var$F.prototype = $0b033f8fda7971e0$var$E.prototype;
function $0b033f8fda7971e0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
var $0b033f8fda7971e0$var$H = $0b033f8fda7971e0$var$G.prototype = new $0b033f8fda7971e0$var$F;
$0b033f8fda7971e0$var$H.constructor = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$var$C($0b033f8fda7971e0$var$H, $0b033f8fda7971e0$var$E.prototype);
$0b033f8fda7971e0$var$H.isPureReactComponent = !0;
var $0b033f8fda7971e0$var$I = Array.isArray, $0b033f8fda7971e0$var$J = Object.prototype.hasOwnProperty, $0b033f8fda7971e0$var$K = {
    current: null
}, $0b033f8fda7971e0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0b033f8fda7971e0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0b033f8fda7971e0$var$J.call(b, d) && !$0b033f8fda7971e0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0b033f8fda7971e0$var$K.current
    };
}
function $0b033f8fda7971e0$var$N(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0b033f8fda7971e0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0b033f8fda7971e0$var$l;
}
function $0b033f8fda7971e0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0b033f8fda7971e0$var$P = /\/+/g;
function $0b033f8fda7971e0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0b033f8fda7971e0$var$escape("" + a.key) : b.toString(36);
}
function $0b033f8fda7971e0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0b033f8fda7971e0$var$l:
                case $0b033f8fda7971e0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0b033f8fda7971e0$var$Q(h, 0) : d, $0b033f8fda7971e0$var$I(c) ? (e = "", null != a && (e = a.replace($0b033f8fda7971e0$var$P, "$&/") + "/"), $0b033f8fda7971e0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0b033f8fda7971e0$var$O(c) && (c = $0b033f8fda7971e0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0b033f8fda7971e0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0b033f8fda7971e0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0b033f8fda7971e0$var$Q(k, g);
        h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    }
    else if (f = $0b033f8fda7971e0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0b033f8fda7971e0$var$Q(k, g++), h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0b033f8fda7971e0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0b033f8fda7971e0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0b033f8fda7971e0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0b033f8fda7971e0$var$U = {
    current: null
}, $0b033f8fda7971e0$var$V = {
    transition: null
}, $0b033f8fda7971e0$var$W = {
    ReactCurrentDispatcher: $0b033f8fda7971e0$var$U,
    ReactCurrentBatchConfig: $0b033f8fda7971e0$var$V,
    ReactCurrentOwner: $0b033f8fda7971e0$var$K
};
function $0b033f8fda7971e0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0b033f8fda7971e0$export$dca3b0875bd9a954 = {
    map: $0b033f8fda7971e0$var$S,
    forEach: function(a, b, e) {
        $0b033f8fda7971e0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0b033f8fda7971e0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0b033f8fda7971e0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0b033f8fda7971e0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0b033f8fda7971e0$export$16fa2f45be04daa8 = $0b033f8fda7971e0$var$E;
$0b033f8fda7971e0$export$ffb0004e005737fa = $0b033f8fda7971e0$var$p;
$0b033f8fda7971e0$export$e2c29f18771995cb = $0b033f8fda7971e0$var$r;
$0b033f8fda7971e0$export$221d75b3f55bb0bd = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$export$5f8d39834fd61797 = $0b033f8fda7971e0$var$q;
$0b033f8fda7971e0$export$74bf444e3cd11ea5 = $0b033f8fda7971e0$var$w;
$0b033f8fda7971e0$export$ae55be85d98224ed = $0b033f8fda7971e0$var$W;
$0b033f8fda7971e0$export$3ba232387fd5d6dd = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0b033f8fda7971e0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0b033f8fda7971e0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0b033f8fda7971e0$var$J.call(b, f) && !$0b033f8fda7971e0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0b033f8fda7971e0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0b033f8fda7971e0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0b033f8fda7971e0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0b033f8fda7971e0$export$c8a8987d4410bf2d = $0b033f8fda7971e0$var$M;
$0b033f8fda7971e0$export$d38cd72104c1f0e9 = function(a) {
    var b = $0b033f8fda7971e0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0b033f8fda7971e0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0b033f8fda7971e0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$v,
        render: a
    };
};
$0b033f8fda7971e0$export$a8257692ac88316c = $0b033f8fda7971e0$var$O;
$0b033f8fda7971e0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0b033f8fda7971e0$var$T
    };
};
$0b033f8fda7971e0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0b033f8fda7971e0$export$7568632d0d33d16d = function(a) {
    var b = $0b033f8fda7971e0$var$V.transition;
    $0b033f8fda7971e0$var$V.transition = {};
    try {
        a();
    } finally{
        $0b033f8fda7971e0$var$V.transition = b;
    }
};
$0b033f8fda7971e0$export$88948ce120ea2619 = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$35808ee640e87ca7 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useCallback(a, b);
};
$0b033f8fda7971e0$export$fae74005e78b1a27 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useContext(a);
};
$0b033f8fda7971e0$export$dc8fbce3eb94dc1e = function() {};
$0b033f8fda7971e0$export$6a7bc4e911dc01cf = function(a) {
    return $0b033f8fda7971e0$var$U.current.useDeferredValue(a);
};
$0b033f8fda7971e0$export$6d9c69b0de29b591 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useEffect(a, b);
};
$0b033f8fda7971e0$export$f680877a34711e37 = function() {
    return $0b033f8fda7971e0$var$U.current.useId();
};
$0b033f8fda7971e0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useImperativeHandle(a, b, e);
};
$0b033f8fda7971e0$export$aaabe4eda9ed9969 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useInsertionEffect(a, b);
};
$0b033f8fda7971e0$export$e5c5a5f917a5871c = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useLayoutEffect(a, b);
};
$0b033f8fda7971e0$export$1538c33de8887b59 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useMemo(a, b);
};
$0b033f8fda7971e0$export$13e3392192263954 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useReducer(a, b, e);
};
$0b033f8fda7971e0$export$b8f5890fc79d6aca = function(a) {
    return $0b033f8fda7971e0$var$U.current.useRef(a);
};
$0b033f8fda7971e0$export$60241385465d0a34 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useState(a);
};
$0b033f8fda7971e0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useSyncExternalStore(a, b, e);
};
$0b033f8fda7971e0$export$7b286972b8d8ccbf = function() {
    return $0b033f8fda7971e0$var$U.current.useTransition();
};
$0b033f8fda7971e0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("l8cRS", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $f62453a6e3b4559e$export$ae55be85d98224ed, (v) => $f62453a6e3b4559e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $f62453a6e3b4559e$export$d39a5bbd09211389, (v) => $f62453a6e3b4559e$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $f62453a6e3b4559e$export$882461b6382ed46c, (v) => $f62453a6e3b4559e$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $f62453a6e3b4559e$export$466bfc07425424d5, (v) => $f62453a6e3b4559e$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $f62453a6e3b4559e$export$cd75ccfd720a3cd4, (v) => $f62453a6e3b4559e$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $f62453a6e3b4559e$export$fa8d919ba61d84db, (v) => $f62453a6e3b4559e$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $f62453a6e3b4559e$export$757ceba2d55c277e, (v) => $f62453a6e3b4559e$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $f62453a6e3b4559e$export$b3890eb0ae9dca99, (v) => $f62453a6e3b4559e$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $f62453a6e3b4559e$export$502457920280e6be, (v) => $f62453a6e3b4559e$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $f62453a6e3b4559e$export$c78a37762a8d58e1, (v) => $f62453a6e3b4559e$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $f62453a6e3b4559e$export$dc54d992c10e8a18, (v) => $f62453a6e3b4559e$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $f62453a6e3b4559e$export$83d89fbfd8236492, (v) => $f62453a6e3b4559e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f62453a6e3b4559e$export$ae55be85d98224ed;
var $f62453a6e3b4559e$export$d39a5bbd09211389;
var $f62453a6e3b4559e$export$882461b6382ed46c;
var $f62453a6e3b4559e$export$466bfc07425424d5;
var $f62453a6e3b4559e$export$cd75ccfd720a3cd4;
var $f62453a6e3b4559e$export$fa8d919ba61d84db;
var $f62453a6e3b4559e$export$757ceba2d55c277e;
var $f62453a6e3b4559e$export$b3890eb0ae9dca99;
var $f62453a6e3b4559e$export$502457920280e6be;
var $f62453a6e3b4559e$export$c78a37762a8d58e1;
var $f62453a6e3b4559e$export$dc54d992c10e8a18;
var $f62453a6e3b4559e$export$83d89fbfd8236492;
'use strict';

var $aqdBs = parcelRequire("aqdBs");

var $7zDBh = parcelRequire("7zDBh");
function $f62453a6e3b4559e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f62453a6e3b4559e$var$da = new Set, $f62453a6e3b4559e$var$ea = {};
function $f62453a6e3b4559e$var$fa(a, b) {
    $f62453a6e3b4559e$var$ha(a, b);
    $f62453a6e3b4559e$var$ha(a + "Capture", b);
}
function $f62453a6e3b4559e$var$ha(a, b) {
    $f62453a6e3b4559e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$da.add(b[a]);
}
var $f62453a6e3b4559e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f62453a6e3b4559e$var$ja = Object.prototype.hasOwnProperty, $f62453a6e3b4559e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f62453a6e3b4559e$var$la = {}, $f62453a6e3b4559e$var$ma = {};
function $f62453a6e3b4559e$var$oa(a) {
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$ma, a)) return !0;
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$la, a)) return !1;
    if ($f62453a6e3b4559e$var$ka.test(a)) return $f62453a6e3b4559e$var$ma[a] = !0;
    $f62453a6e3b4559e$var$la[a] = !0;
    return !1;
}
function $f62453a6e3b4559e$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f62453a6e3b4559e$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f62453a6e3b4559e$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f62453a6e3b4559e$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f62453a6e3b4559e$var$ra = /[\-:]([a-z])/g;
function $f62453a6e3b4559e$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f62453a6e3b4559e$var$z.xlinkHref = new $f62453a6e3b4559e$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f62453a6e3b4559e$var$ta(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$z.hasOwnProperty(b) ? $f62453a6e3b4559e$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f62453a6e3b4559e$var$qa(b, c, e, d) && (c = null), d || null === e ? $f62453a6e3b4559e$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f62453a6e3b4559e$var$ua = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f62453a6e3b4559e$var$va = Symbol.for("react.element"), $f62453a6e3b4559e$var$wa = Symbol.for("react.portal"), $f62453a6e3b4559e$var$ya = Symbol.for("react.fragment"), $f62453a6e3b4559e$var$za = Symbol.for("react.strict_mode"), $f62453a6e3b4559e$var$Aa = Symbol.for("react.profiler"), $f62453a6e3b4559e$var$Ba = Symbol.for("react.provider"), $f62453a6e3b4559e$var$Ca = Symbol.for("react.context"), $f62453a6e3b4559e$var$Da = Symbol.for("react.forward_ref"), $f62453a6e3b4559e$var$Ea = Symbol.for("react.suspense"), $f62453a6e3b4559e$var$Fa = Symbol.for("react.suspense_list"), $f62453a6e3b4559e$var$Ga = Symbol.for("react.memo"), $f62453a6e3b4559e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f62453a6e3b4559e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f62453a6e3b4559e$var$Ja = Symbol.iterator;
function $f62453a6e3b4559e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f62453a6e3b4559e$var$Ja && a[$f62453a6e3b4559e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f62453a6e3b4559e$var$A = Object.assign, $f62453a6e3b4559e$var$La;
function $f62453a6e3b4559e$var$Ma(a) {
    if (void 0 === $f62453a6e3b4559e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f62453a6e3b4559e$var$La = b && b[1] || "";
    }
    return "\n" + $f62453a6e3b4559e$var$La + a;
}
var $f62453a6e3b4559e$var$Na = !1;
function $f62453a6e3b4559e$var$Oa(a, b) {
    if (!a || $f62453a6e3b4559e$var$Na) return "";
    $f62453a6e3b4559e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f62453a6e3b4559e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f62453a6e3b4559e$var$Ma(a) : "";
}
function $f62453a6e3b4559e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f62453a6e3b4559e$var$Ma(a.type);
        case 16:
            return $f62453a6e3b4559e$var$Ma("Lazy");
        case 13:
            return $f62453a6e3b4559e$var$Ma("Suspense");
        case 19:
            return $f62453a6e3b4559e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !1), a;
        case 11:
            return a = $f62453a6e3b4559e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f62453a6e3b4559e$var$ya:
            return "Fragment";
        case $f62453a6e3b4559e$var$wa:
            return "Portal";
        case $f62453a6e3b4559e$var$Aa:
            return "Profiler";
        case $f62453a6e3b4559e$var$za:
            return "StrictMode";
        case $f62453a6e3b4559e$var$Ea:
            return "Suspense";
        case $f62453a6e3b4559e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f62453a6e3b4559e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f62453a6e3b4559e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f62453a6e3b4559e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f62453a6e3b4559e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f62453a6e3b4559e$var$Qa(a.type) || "Memo";
        case $f62453a6e3b4559e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f62453a6e3b4559e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f62453a6e3b4559e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f62453a6e3b4559e$var$Qa(b);
        case 8:
            return b === $f62453a6e3b4559e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f62453a6e3b4559e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f62453a6e3b4559e$var$Ua(a) {
    var b = $f62453a6e3b4559e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f62453a6e3b4559e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f62453a6e3b4559e$var$Ua(a));
}
function $f62453a6e3b4559e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f62453a6e3b4559e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f62453a6e3b4559e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f62453a6e3b4559e$var$Ya(a, b) {
    var c = b.checked;
    return $f62453a6e3b4559e$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f62453a6e3b4559e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f62453a6e3b4559e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f62453a6e3b4559e$var$ab(a, b) {
    b = b.checked;
    null != b && $f62453a6e3b4559e$var$ta(a, "checked", b, !1);
}
function $f62453a6e3b4559e$var$bb(a, b) {
    $f62453a6e3b4559e$var$ab(a, b);
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f62453a6e3b4559e$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f62453a6e3b4559e$var$cb(a, b.type, $f62453a6e3b4559e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f62453a6e3b4559e$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f62453a6e3b4559e$var$cb(a, b, c) {
    if ("number" !== b || $f62453a6e3b4559e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f62453a6e3b4559e$var$eb = Array.isArray;
function $f62453a6e3b4559e$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f62453a6e3b4559e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f62453a6e3b4559e$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f62453a6e3b4559e$var$p(91));
    return $f62453a6e3b4559e$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f62453a6e3b4559e$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f62453a6e3b4559e$var$p(92));
            if ($f62453a6e3b4559e$var$eb(c)) {
                if (1 < c.length) throw Error($f62453a6e3b4559e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f62453a6e3b4559e$var$Sa(c)
    };
}
function $f62453a6e3b4559e$var$ib(a, b) {
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = $f62453a6e3b4559e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f62453a6e3b4559e$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f62453a6e3b4559e$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f62453a6e3b4559e$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f62453a6e3b4559e$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f62453a6e3b4559e$var$mb, $f62453a6e3b4559e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f62453a6e3b4559e$var$mb = $f62453a6e3b4559e$var$mb || document.createElement("div");
        $f62453a6e3b4559e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f62453a6e3b4559e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f62453a6e3b4559e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f62453a6e3b4559e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f62453a6e3b4559e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f62453a6e3b4559e$var$pb).forEach(function(a) {
    $f62453a6e3b4559e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f62453a6e3b4559e$var$pb[b] = $f62453a6e3b4559e$var$pb[a];
    });
});
function $f62453a6e3b4559e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f62453a6e3b4559e$var$pb.hasOwnProperty(a) && $f62453a6e3b4559e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f62453a6e3b4559e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f62453a6e3b4559e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f62453a6e3b4559e$var$tb = $f62453a6e3b4559e$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f62453a6e3b4559e$var$ub(a, b) {
    if (b) {
        if ($f62453a6e3b4559e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f62453a6e3b4559e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f62453a6e3b4559e$var$p(62));
    }
}
function $f62453a6e3b4559e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f62453a6e3b4559e$var$wb = null;
function $f62453a6e3b4559e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f62453a6e3b4559e$var$yb = null, $f62453a6e3b4559e$var$zb = null, $f62453a6e3b4559e$var$Ab = null;
function $f62453a6e3b4559e$var$Bb(a) {
    if (a = $f62453a6e3b4559e$var$Cb(a)) {
        if ("function" !== typeof $f62453a6e3b4559e$var$yb) throw Error($f62453a6e3b4559e$var$p(280));
        var b = a.stateNode;
        b && (b = $f62453a6e3b4559e$var$Db(b), $f62453a6e3b4559e$var$yb(a.stateNode, a.type, b));
    }
}
function $f62453a6e3b4559e$var$Eb(a) {
    $f62453a6e3b4559e$var$zb ? $f62453a6e3b4559e$var$Ab ? $f62453a6e3b4559e$var$Ab.push(a) : $f62453a6e3b4559e$var$Ab = [
        a
    ] : $f62453a6e3b4559e$var$zb = a;
}
function $f62453a6e3b4559e$var$Fb() {
    if ($f62453a6e3b4559e$var$zb) {
        var a = $f62453a6e3b4559e$var$zb, b = $f62453a6e3b4559e$var$Ab;
        $f62453a6e3b4559e$var$Ab = $f62453a6e3b4559e$var$zb = null;
        $f62453a6e3b4559e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$Bb(b[a]);
    }
}
function $f62453a6e3b4559e$var$Gb(a, b) {
    return a(b);
}
function $f62453a6e3b4559e$var$Hb() {}
var $f62453a6e3b4559e$var$Ib = !1;
function $f62453a6e3b4559e$var$Jb(a, b, c) {
    if ($f62453a6e3b4559e$var$Ib) return a(b, c);
    $f62453a6e3b4559e$var$Ib = !0;
    try {
        return $f62453a6e3b4559e$var$Gb(a, b, c);
    } finally{
        if ($f62453a6e3b4559e$var$Ib = !1, null !== $f62453a6e3b4559e$var$zb || null !== $f62453a6e3b4559e$var$Ab) $f62453a6e3b4559e$var$Hb(), $f62453a6e3b4559e$var$Fb();
    }
}
function $f62453a6e3b4559e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f62453a6e3b4559e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f62453a6e3b4559e$var$p(231, b, typeof c));
    return c;
}
var $f62453a6e3b4559e$var$Lb = !1;
if ($f62453a6e3b4559e$var$ia) try {
    var $f62453a6e3b4559e$var$Mb = {};
    Object.defineProperty($f62453a6e3b4559e$var$Mb, "passive", {
        get: function() {
            $f62453a6e3b4559e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
    window.removeEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
} catch (a) {
    $f62453a6e3b4559e$var$Lb = !1;
}
function $f62453a6e3b4559e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f62453a6e3b4559e$var$Ob = !1, $f62453a6e3b4559e$var$Pb = null, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, $f62453a6e3b4559e$var$Sb = {
    onError: function(a) {
        $f62453a6e3b4559e$var$Ob = !0;
        $f62453a6e3b4559e$var$Pb = a;
    }
};
function $f62453a6e3b4559e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Ob = !1;
    $f62453a6e3b4559e$var$Pb = null;
    $f62453a6e3b4559e$var$Nb.apply($f62453a6e3b4559e$var$Sb, arguments);
}
function $f62453a6e3b4559e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Tb.apply(this, arguments);
    if ($f62453a6e3b4559e$var$Ob) {
        if ($f62453a6e3b4559e$var$Ob) {
            var l = $f62453a6e3b4559e$var$Pb;
            $f62453a6e3b4559e$var$Ob = !1;
            $f62453a6e3b4559e$var$Pb = null;
        } else throw Error($f62453a6e3b4559e$var$p(198));
        $f62453a6e3b4559e$var$Qb || ($f62453a6e3b4559e$var$Qb = !0, $f62453a6e3b4559e$var$Rb = l);
    }
}
function $f62453a6e3b4559e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f62453a6e3b4559e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f62453a6e3b4559e$var$Xb(a) {
    if ($f62453a6e3b4559e$var$Vb(a) !== a) throw Error($f62453a6e3b4559e$var$p(188));
}
function $f62453a6e3b4559e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f62453a6e3b4559e$var$Vb(a);
        if (null === b) throw Error($f62453a6e3b4559e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f62453a6e3b4559e$var$Xb(e), a;
                if (f === d) return $f62453a6e3b4559e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f62453a6e3b4559e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f62453a6e3b4559e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f62453a6e3b4559e$var$p(190));
    }
    if (3 !== c.tag) throw Error($f62453a6e3b4559e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f62453a6e3b4559e$var$Zb(a) {
    a = $f62453a6e3b4559e$var$Yb(a);
    return null !== a ? $f62453a6e3b4559e$var$$b(a) : null;
}
function $f62453a6e3b4559e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f62453a6e3b4559e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$ac = $7zDBh.unstable_scheduleCallback, $f62453a6e3b4559e$var$bc = $7zDBh.unstable_cancelCallback, $f62453a6e3b4559e$var$cc = $7zDBh.unstable_shouldYield, $f62453a6e3b4559e$var$dc = $7zDBh.unstable_requestPaint, $f62453a6e3b4559e$var$B = $7zDBh.unstable_now, $f62453a6e3b4559e$var$ec = $7zDBh.unstable_getCurrentPriorityLevel, $f62453a6e3b4559e$var$fc = $7zDBh.unstable_ImmediatePriority, $f62453a6e3b4559e$var$gc = $7zDBh.unstable_UserBlockingPriority, $f62453a6e3b4559e$var$hc = $7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$ic = $7zDBh.unstable_LowPriority, $f62453a6e3b4559e$var$jc = $7zDBh.unstable_IdlePriority, $f62453a6e3b4559e$var$kc = null, $f62453a6e3b4559e$var$lc = null;
function $f62453a6e3b4559e$var$mc(a) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberRoot) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberRoot($f62453a6e3b4559e$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f62453a6e3b4559e$var$oc = Math.clz32 ? Math.clz32 : $f62453a6e3b4559e$var$nc, $f62453a6e3b4559e$var$pc = Math.log, $f62453a6e3b4559e$var$qc = Math.LN2;
function $f62453a6e3b4559e$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f62453a6e3b4559e$var$pc(a) / $f62453a6e3b4559e$var$qc | 0) | 0;
}
var $f62453a6e3b4559e$var$rc = 64, $f62453a6e3b4559e$var$sc = 4194304;
function $f62453a6e3b4559e$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f62453a6e3b4559e$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f62453a6e3b4559e$var$tc(h) : (f &= g, 0 !== f && (d = $f62453a6e3b4559e$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f62453a6e3b4559e$var$tc(g) : 0 !== f && (d = $f62453a6e3b4559e$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f62453a6e3b4559e$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f62453a6e3b4559e$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f62453a6e3b4559e$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f62453a6e3b4559e$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f62453a6e3b4559e$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f62453a6e3b4559e$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f62453a6e3b4559e$var$yc() {
    var a = $f62453a6e3b4559e$var$rc;
    $f62453a6e3b4559e$var$rc <<= 1;
    0 === ($f62453a6e3b4559e$var$rc & 4194240) && ($f62453a6e3b4559e$var$rc = 64);
    return a;
}
function $f62453a6e3b4559e$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f62453a6e3b4559e$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f62453a6e3b4559e$var$oc(b);
    a[b] = c;
}
function $f62453a6e3b4559e$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f62453a6e3b4559e$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f62453a6e3b4559e$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f62453a6e3b4559e$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f62453a6e3b4559e$var$C = 0;
function $f62453a6e3b4559e$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f62453a6e3b4559e$var$Ec, $f62453a6e3b4559e$var$Fc, $f62453a6e3b4559e$var$Gc, $f62453a6e3b4559e$var$Hc, $f62453a6e3b4559e$var$Ic, $f62453a6e3b4559e$var$Jc = !1, $f62453a6e3b4559e$var$Kc = [], $f62453a6e3b4559e$var$Lc = null, $f62453a6e3b4559e$var$Mc = null, $f62453a6e3b4559e$var$Nc = null, $f62453a6e3b4559e$var$Oc = new Map, $f62453a6e3b4559e$var$Pc = new Map, $f62453a6e3b4559e$var$Qc = [], $f62453a6e3b4559e$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f62453a6e3b4559e$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f62453a6e3b4559e$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f62453a6e3b4559e$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f62453a6e3b4559e$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f62453a6e3b4559e$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f62453a6e3b4559e$var$Pc.delete(b.pointerId);
    }
}
function $f62453a6e3b4559e$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f62453a6e3b4559e$var$Cb(b), null !== b && $f62453a6e3b4559e$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f62453a6e3b4559e$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f62453a6e3b4559e$var$Lc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f62453a6e3b4559e$var$Mc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f62453a6e3b4559e$var$Nc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f62453a6e3b4559e$var$Oc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f62453a6e3b4559e$var$Pc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f62453a6e3b4559e$var$Vc(a) {
    var b = $f62453a6e3b4559e$var$Wc(a.target);
    if (null !== b) {
        var c = $f62453a6e3b4559e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f62453a6e3b4559e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f62453a6e3b4559e$var$Ic(a.priority, function() {
                        $f62453a6e3b4559e$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f62453a6e3b4559e$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f62453a6e3b4559e$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f62453a6e3b4559e$var$wb = d;
            c.target.dispatchEvent(d);
            $f62453a6e3b4559e$var$wb = null;
        } else return b = $f62453a6e3b4559e$var$Cb(c), null !== b && $f62453a6e3b4559e$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f62453a6e3b4559e$var$Zc(a, b, c) {
    $f62453a6e3b4559e$var$Xc(a) && c.delete(b);
}
function $f62453a6e3b4559e$var$$c() {
    $f62453a6e3b4559e$var$Jc = !1;
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Lc) && ($f62453a6e3b4559e$var$Lc = null);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Mc) && ($f62453a6e3b4559e$var$Mc = null);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Nc) && ($f62453a6e3b4559e$var$Nc = null);
    $f62453a6e3b4559e$var$Oc.forEach($f62453a6e3b4559e$var$Zc);
    $f62453a6e3b4559e$var$Pc.forEach($f62453a6e3b4559e$var$Zc);
}
function $f62453a6e3b4559e$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f62453a6e3b4559e$var$Jc || ($f62453a6e3b4559e$var$Jc = !0, $7zDBh.unstable_scheduleCallback($7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$$c)));
}
function $f62453a6e3b4559e$var$bd(a) {
    function b(b) {
        return $f62453a6e3b4559e$var$ad(b, a);
    }
    if (0 < $f62453a6e3b4559e$var$Kc.length) {
        $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Kc[0], a);
        for(var c = 1; c < $f62453a6e3b4559e$var$Kc.length; c++){
            var d = $f62453a6e3b4559e$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Lc, a);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Mc, a);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Nc, a);
    $f62453a6e3b4559e$var$Oc.forEach(b);
    $f62453a6e3b4559e$var$Pc.forEach(b);
    for(c = 0; c < $f62453a6e3b4559e$var$Qc.length; c++)d = $f62453a6e3b4559e$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f62453a6e3b4559e$var$Qc.length && (c = $f62453a6e3b4559e$var$Qc[0], null === c.blockedOn);)$f62453a6e3b4559e$var$Vc(c), null === c.blockedOn && $f62453a6e3b4559e$var$Qc.shift();
}
var $f62453a6e3b4559e$var$cd = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$dd = !0;
function $f62453a6e3b4559e$var$ed(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$gd(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 4, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$fd(a, b, c, d) {
    if ($f62453a6e3b4559e$var$dd) {
        var e = $f62453a6e3b4559e$var$Yc(a, b, c, d);
        if (null === e) $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c), $f62453a6e3b4559e$var$Sc(a, d);
        else if ($f62453a6e3b4559e$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f62453a6e3b4559e$var$Sc(a, d), b & 4 && -1 < $f62453a6e3b4559e$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f62453a6e3b4559e$var$Cb(e);
                null !== f && $f62453a6e3b4559e$var$Ec(f);
                f = $f62453a6e3b4559e$var$Yc(a, b, c, d);
                null === f && $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f62453a6e3b4559e$var$hd(a, b, d, null, c);
    }
}
var $f62453a6e3b4559e$var$id = null;
function $f62453a6e3b4559e$var$Yc(a, b, c, d) {
    $f62453a6e3b4559e$var$id = null;
    a = $f62453a6e3b4559e$var$xb(d);
    a = $f62453a6e3b4559e$var$Wc(a);
    if (null !== a) {
        if (b = $f62453a6e3b4559e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f62453a6e3b4559e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f62453a6e3b4559e$var$id = a;
    return null;
}
function $f62453a6e3b4559e$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f62453a6e3b4559e$var$ec()){
                case $f62453a6e3b4559e$var$fc:
                    return 1;
                case $f62453a6e3b4559e$var$gc:
                    return 4;
                case $f62453a6e3b4559e$var$hc:
                case $f62453a6e3b4559e$var$ic:
                    return 16;
                case $f62453a6e3b4559e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ld = null, $f62453a6e3b4559e$var$md = null;
function $f62453a6e3b4559e$var$nd() {
    if ($f62453a6e3b4559e$var$md) return $f62453a6e3b4559e$var$md;
    var a, b = $f62453a6e3b4559e$var$ld, c = b.length, d, e = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f62453a6e3b4559e$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f62453a6e3b4559e$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f62453a6e3b4559e$var$pd() {
    return !0;
}
function $f62453a6e3b4559e$var$qd() {
    return !1;
}
function $f62453a6e3b4559e$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f62453a6e3b4559e$var$pd : $f62453a6e3b4559e$var$qd;
        this.isPropagationStopped = $f62453a6e3b4559e$var$qd;
        return this;
    }
    $f62453a6e3b4559e$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f62453a6e3b4559e$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f62453a6e3b4559e$var$pd);
        },
        persist: function() {},
        isPersistent: $f62453a6e3b4559e$var$pd
    });
    return b;
}
var $f62453a6e3b4559e$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f62453a6e3b4559e$var$td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$sd), $f62453a6e3b4559e$var$ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    view: 0,
    detail: 0
}), $f62453a6e3b4559e$var$vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$ud), $f62453a6e3b4559e$var$wd, $f62453a6e3b4559e$var$xd, $f62453a6e3b4559e$var$yd, $f62453a6e3b4559e$var$Ad = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f62453a6e3b4559e$var$yd && ($f62453a6e3b4559e$var$yd && "mousemove" === a.type ? ($f62453a6e3b4559e$var$wd = a.screenX - $f62453a6e3b4559e$var$yd.screenX, $f62453a6e3b4559e$var$xd = a.screenY - $f62453a6e3b4559e$var$yd.screenY) : $f62453a6e3b4559e$var$xd = $f62453a6e3b4559e$var$wd = 0, $f62453a6e3b4559e$var$yd = a);
        return $f62453a6e3b4559e$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f62453a6e3b4559e$var$xd;
    }
}), $f62453a6e3b4559e$var$Bd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ad), $f62453a6e3b4559e$var$Cd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    dataTransfer: 0
}), $f62453a6e3b4559e$var$Dd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Cd), $f62453a6e3b4559e$var$Ed = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    relatedTarget: 0
}), $f62453a6e3b4559e$var$Fd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ed), $f62453a6e3b4559e$var$Gd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Hd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Gd), $f62453a6e3b4559e$var$Id = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f62453a6e3b4559e$var$Jd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Id), $f62453a6e3b4559e$var$Kd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    data: 0
}), $f62453a6e3b4559e$var$Ld = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Kd), $f62453a6e3b4559e$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f62453a6e3b4559e$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f62453a6e3b4559e$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f62453a6e3b4559e$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f62453a6e3b4559e$var$Od[a]) ? !!b[a] : !1;
}
function $f62453a6e3b4559e$var$zd() {
    return $f62453a6e3b4559e$var$Pd;
}
var $f62453a6e3b4559e$var$Qd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f62453a6e3b4559e$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f62453a6e3b4559e$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f62453a6e3b4559e$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f62453a6e3b4559e$var$Rd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Qd), $f62453a6e3b4559e$var$Sd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f62453a6e3b4559e$var$Td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Sd), $f62453a6e3b4559e$var$Ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd
}), $f62453a6e3b4559e$var$Vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ud), $f62453a6e3b4559e$var$Wd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Xd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Wd), $f62453a6e3b4559e$var$Yd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f62453a6e3b4559e$var$Zd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Yd), $f62453a6e3b4559e$var$$d = [
    9,
    13,
    27,
    32
], $f62453a6e3b4559e$var$ae = $f62453a6e3b4559e$var$ia && "CompositionEvent" in window, $f62453a6e3b4559e$var$be = null;
$f62453a6e3b4559e$var$ia && "documentMode" in document && ($f62453a6e3b4559e$var$be = document.documentMode);
var $f62453a6e3b4559e$var$ce = $f62453a6e3b4559e$var$ia && "TextEvent" in window && !$f62453a6e3b4559e$var$be, $f62453a6e3b4559e$var$de = $f62453a6e3b4559e$var$ia && (!$f62453a6e3b4559e$var$ae || $f62453a6e3b4559e$var$be && 8 < $f62453a6e3b4559e$var$be && 11 >= $f62453a6e3b4559e$var$be), $f62453a6e3b4559e$var$ee = String.fromCharCode(32), $f62453a6e3b4559e$var$fe = !1;
function $f62453a6e3b4559e$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f62453a6e3b4559e$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f62453a6e3b4559e$var$ie = !1;
function $f62453a6e3b4559e$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f62453a6e3b4559e$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f62453a6e3b4559e$var$fe = !0;
            return $f62453a6e3b4559e$var$ee;
        case "textInput":
            return a = b.data, a === $f62453a6e3b4559e$var$ee && $f62453a6e3b4559e$var$fe ? null : a;
        default:
            return null;
    }
}
function $f62453a6e3b4559e$var$ke(a, b) {
    if ($f62453a6e3b4559e$var$ie) return "compositionend" === a || !$f62453a6e3b4559e$var$ae && $f62453a6e3b4559e$var$ge(a, b) ? (a = $f62453a6e3b4559e$var$nd(), $f62453a6e3b4559e$var$md = $f62453a6e3b4559e$var$ld = $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f62453a6e3b4559e$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f62453a6e3b4559e$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f62453a6e3b4559e$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f62453a6e3b4559e$var$ne(a, b, c, d) {
    $f62453a6e3b4559e$var$Eb(d);
    b = $f62453a6e3b4559e$var$oe(b, "onChange");
    0 < b.length && (c = new $f62453a6e3b4559e$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f62453a6e3b4559e$var$pe = null, $f62453a6e3b4559e$var$qe = null;
function $f62453a6e3b4559e$var$re(a) {
    $f62453a6e3b4559e$var$se(a, 0);
}
function $f62453a6e3b4559e$var$te(a) {
    var b = $f62453a6e3b4559e$var$ue(a);
    if ($f62453a6e3b4559e$var$Wa(b)) return a;
}
function $f62453a6e3b4559e$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f62453a6e3b4559e$var$we = !1;
if ($f62453a6e3b4559e$var$ia) {
    var $f62453a6e3b4559e$var$xe;
    if ($f62453a6e3b4559e$var$ia) {
        var $f62453a6e3b4559e$var$ye = "oninput" in document;
        if (!$f62453a6e3b4559e$var$ye) {
            var $f62453a6e3b4559e$var$ze = document.createElement("div");
            $f62453a6e3b4559e$var$ze.setAttribute("oninput", "return;");
            $f62453a6e3b4559e$var$ye = "function" === typeof $f62453a6e3b4559e$var$ze.oninput;
        }
        $f62453a6e3b4559e$var$xe = $f62453a6e3b4559e$var$ye;
    } else $f62453a6e3b4559e$var$xe = !1;
    $f62453a6e3b4559e$var$we = $f62453a6e3b4559e$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f62453a6e3b4559e$var$Ae() {
    $f62453a6e3b4559e$var$pe && ($f62453a6e3b4559e$var$pe.detachEvent("onpropertychange", $f62453a6e3b4559e$var$Be), $f62453a6e3b4559e$var$qe = $f62453a6e3b4559e$var$pe = null);
}
function $f62453a6e3b4559e$var$Be(a) {
    if ("value" === a.propertyName && $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe)) {
        var b = [];
        $f62453a6e3b4559e$var$ne(b, $f62453a6e3b4559e$var$qe, a, $f62453a6e3b4559e$var$xb(a));
        $f62453a6e3b4559e$var$Jb($f62453a6e3b4559e$var$re, b);
    }
}
function $f62453a6e3b4559e$var$Ce(a, b, c) {
    "focusin" === a ? ($f62453a6e3b4559e$var$Ae(), $f62453a6e3b4559e$var$pe = b, $f62453a6e3b4559e$var$qe = c, $f62453a6e3b4559e$var$pe.attachEvent("onpropertychange", $f62453a6e3b4559e$var$Be)) : "focusout" === a && $f62453a6e3b4559e$var$Ae();
}
function $f62453a6e3b4559e$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe);
}
function $f62453a6e3b4559e$var$Ee(a, b) {
    if ("click" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f62453a6e3b4559e$var$He = "function" === typeof Object.is ? Object.is : $f62453a6e3b4559e$var$Ge;
function $f62453a6e3b4559e$var$Ie(a, b) {
    if ($f62453a6e3b4559e$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f62453a6e3b4559e$var$ja.call(b, e) || !$f62453a6e3b4559e$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f62453a6e3b4559e$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f62453a6e3b4559e$var$Ke(a, b) {
    var c = $f62453a6e3b4559e$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f62453a6e3b4559e$var$Je(c);
    }
}
function $f62453a6e3b4559e$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f62453a6e3b4559e$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f62453a6e3b4559e$var$Me() {
    for(var a = window, b = $f62453a6e3b4559e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f62453a6e3b4559e$var$Xa(a.document);
    }
    return b;
}
function $f62453a6e3b4559e$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f62453a6e3b4559e$var$Oe(a) {
    var b = $f62453a6e3b4559e$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f62453a6e3b4559e$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f62453a6e3b4559e$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f62453a6e3b4559e$var$Ke(c, f);
                var g = $f62453a6e3b4559e$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f62453a6e3b4559e$var$Pe = $f62453a6e3b4559e$var$ia && "documentMode" in document && 11 >= document.documentMode, $f62453a6e3b4559e$var$Qe = null, $f62453a6e3b4559e$var$Re = null, $f62453a6e3b4559e$var$Se = null, $f62453a6e3b4559e$var$Te = !1;
function $f62453a6e3b4559e$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f62453a6e3b4559e$var$Te || null == $f62453a6e3b4559e$var$Qe || $f62453a6e3b4559e$var$Qe !== $f62453a6e3b4559e$var$Xa(d) || (d = $f62453a6e3b4559e$var$Qe, "selectionStart" in d && $f62453a6e3b4559e$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f62453a6e3b4559e$var$Se && $f62453a6e3b4559e$var$Ie($f62453a6e3b4559e$var$Se, d) || ($f62453a6e3b4559e$var$Se = d, d = $f62453a6e3b4559e$var$oe($f62453a6e3b4559e$var$Re, "onSelect"), 0 < d.length && (b = new $f62453a6e3b4559e$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f62453a6e3b4559e$var$Qe)));
}
function $f62453a6e3b4559e$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f62453a6e3b4559e$var$We = {
    animationend: $f62453a6e3b4559e$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f62453a6e3b4559e$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f62453a6e3b4559e$var$Ve("Animation", "AnimationStart"),
    transitionend: $f62453a6e3b4559e$var$Ve("Transition", "TransitionEnd")
}, $f62453a6e3b4559e$var$Xe = {}, $f62453a6e3b4559e$var$Ye = {};
$f62453a6e3b4559e$var$ia && ($f62453a6e3b4559e$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f62453a6e3b4559e$var$We.animationend.animation, delete $f62453a6e3b4559e$var$We.animationiteration.animation, delete $f62453a6e3b4559e$var$We.animationstart.animation), "TransitionEvent" in window || delete $f62453a6e3b4559e$var$We.transitionend.transition);
function $f62453a6e3b4559e$var$Ze(a) {
    if ($f62453a6e3b4559e$var$Xe[a]) return $f62453a6e3b4559e$var$Xe[a];
    if (!$f62453a6e3b4559e$var$We[a]) return a;
    var b = $f62453a6e3b4559e$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f62453a6e3b4559e$var$Ye) return $f62453a6e3b4559e$var$Xe[a] = b[c];
    return a;
}
var $f62453a6e3b4559e$var$$e = $f62453a6e3b4559e$var$Ze("animationend"), $f62453a6e3b4559e$var$af = $f62453a6e3b4559e$var$Ze("animationiteration"), $f62453a6e3b4559e$var$bf = $f62453a6e3b4559e$var$Ze("animationstart"), $f62453a6e3b4559e$var$cf = $f62453a6e3b4559e$var$Ze("transitionend"), $f62453a6e3b4559e$var$df = new Map, $f62453a6e3b4559e$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f62453a6e3b4559e$var$ff(a, b) {
    $f62453a6e3b4559e$var$df.set(a, b);
    $f62453a6e3b4559e$var$fa(b, [
        a
    ]);
}
for(var $f62453a6e3b4559e$var$gf = 0; $f62453a6e3b4559e$var$gf < $f62453a6e3b4559e$var$ef.length; $f62453a6e3b4559e$var$gf++){
    var $f62453a6e3b4559e$var$hf = $f62453a6e3b4559e$var$ef[$f62453a6e3b4559e$var$gf], $f62453a6e3b4559e$var$jf = $f62453a6e3b4559e$var$hf.toLowerCase(), $f62453a6e3b4559e$var$kf = $f62453a6e3b4559e$var$hf[0].toUpperCase() + $f62453a6e3b4559e$var$hf.slice(1);
    $f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$jf, "on" + $f62453a6e3b4559e$var$kf);
}
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$$e, "onAnimationEnd");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$af, "onAnimationIteration");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$bf, "onAnimationStart");
$f62453a6e3b4559e$var$ff("dblclick", "onDoubleClick");
$f62453a6e3b4559e$var$ff("focusin", "onFocus");
$f62453a6e3b4559e$var$ff("focusout", "onBlur");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$cf, "onTransitionEnd");
$f62453a6e3b4559e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f62453a6e3b4559e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f62453a6e3b4559e$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f62453a6e3b4559e$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f62453a6e3b4559e$var$lf));
function $f62453a6e3b4559e$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f62453a6e3b4559e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f62453a6e3b4559e$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f62453a6e3b4559e$var$Qb) throw a = $f62453a6e3b4559e$var$Rb, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, a;
}
function $f62453a6e3b4559e$var$D(a, b) {
    var c = b[$f62453a6e3b4559e$var$of];
    void 0 === c && (c = b[$f62453a6e3b4559e$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f62453a6e3b4559e$var$pf(b, a, 2, !1), c.add(d));
}
function $f62453a6e3b4559e$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f62453a6e3b4559e$var$pf(c, a, d, b);
}
var $f62453a6e3b4559e$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f62453a6e3b4559e$var$sf(a) {
    if (!a[$f62453a6e3b4559e$var$rf]) {
        a[$f62453a6e3b4559e$var$rf] = !0;
        $f62453a6e3b4559e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f62453a6e3b4559e$var$mf.has(b) || $f62453a6e3b4559e$var$qf(b, !1, a), $f62453a6e3b4559e$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f62453a6e3b4559e$var$rf] || (b[$f62453a6e3b4559e$var$rf] = !0, $f62453a6e3b4559e$var$qf("selectionchange", !1, b));
    }
}
function $f62453a6e3b4559e$var$pf(a, b, c, d) {
    switch($f62453a6e3b4559e$var$jd(b)){
        case 1:
            var e = $f62453a6e3b4559e$var$ed;
            break;
        case 4:
            e = $f62453a6e3b4559e$var$gd;
            break;
        default:
            e = $f62453a6e3b4559e$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f62453a6e3b4559e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f62453a6e3b4559e$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f62453a6e3b4559e$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f62453a6e3b4559e$var$Jb(function() {
        var d = f, e = $f62453a6e3b4559e$var$xb(c), g = [];
        a: {
            var h = $f62453a6e3b4559e$var$df.get(a);
            if (void 0 !== h) {
                var k = $f62453a6e3b4559e$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f62453a6e3b4559e$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f62453a6e3b4559e$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f62453a6e3b4559e$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f62453a6e3b4559e$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f62453a6e3b4559e$var$Vd;
                        break;
                    case $f62453a6e3b4559e$var$$e:
                    case $f62453a6e3b4559e$var$af:
                    case $f62453a6e3b4559e$var$bf:
                        k = $f62453a6e3b4559e$var$Hd;
                        break;
                    case $f62453a6e3b4559e$var$cf:
                        k = $f62453a6e3b4559e$var$Xd;
                        break;
                    case "scroll":
                        k = $f62453a6e3b4559e$var$vd;
                        break;
                    case "wheel":
                        k = $f62453a6e3b4559e$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f62453a6e3b4559e$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f62453a6e3b4559e$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f62453a6e3b4559e$var$Kb(w, x), null != F && t.push($f62453a6e3b4559e$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f62453a6e3b4559e$var$wb && (n = c.relatedTarget || c.fromElement) && ($f62453a6e3b4559e$var$Wc(n) || n[$f62453a6e3b4559e$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f62453a6e3b4559e$var$Wc(n) : null, null !== n && (J = $f62453a6e3b4559e$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f62453a6e3b4559e$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f62453a6e3b4559e$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f62453a6e3b4559e$var$ue(k);
                        u = null == n ? h : $f62453a6e3b4559e$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f62453a6e3b4559e$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f62453a6e3b4559e$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f62453a6e3b4559e$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f62453a6e3b4559e$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f62453a6e3b4559e$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f62453a6e3b4559e$var$vf(t);
                                x = $f62453a6e3b4559e$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f62453a6e3b4559e$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f62453a6e3b4559e$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f62453a6e3b4559e$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f62453a6e3b4559e$var$ve;
                else if ($f62453a6e3b4559e$var$me(h)) {
                    if ($f62453a6e3b4559e$var$we) na = $f62453a6e3b4559e$var$Fe;
                    else {
                        na = $f62453a6e3b4559e$var$De;
                        var xa = $f62453a6e3b4559e$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f62453a6e3b4559e$var$Ee);
                if (na && (na = na(a, d))) {
                    $f62453a6e3b4559e$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f62453a6e3b4559e$var$cb(h, "number", h.value);
            }
            xa = d ? $f62453a6e3b4559e$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f62453a6e3b4559e$var$me(xa) || "true" === xa.contentEditable) $f62453a6e3b4559e$var$Qe = xa, $f62453a6e3b4559e$var$Re = d, $f62453a6e3b4559e$var$Se = null;
                    break;
                case "focusout":
                    $f62453a6e3b4559e$var$Se = $f62453a6e3b4559e$var$Re = $f62453a6e3b4559e$var$Qe = null;
                    break;
                case "mousedown":
                    $f62453a6e3b4559e$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f62453a6e3b4559e$var$Te = !1;
                    $f62453a6e3b4559e$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f62453a6e3b4559e$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f62453a6e3b4559e$var$Ue(g, c, e);
            }
            var $a;
            if ($f62453a6e3b4559e$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f62453a6e3b4559e$var$ie ? $f62453a6e3b4559e$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f62453a6e3b4559e$var$de && "ko" !== c.locale && ($f62453a6e3b4559e$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f62453a6e3b4559e$var$ie && ($a = $f62453a6e3b4559e$var$nd()) : ($f62453a6e3b4559e$var$kd = e, $f62453a6e3b4559e$var$ld = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, $f62453a6e3b4559e$var$ie = !0)), xa = $f62453a6e3b4559e$var$oe(d, ba), 0 < xa.length && (ba = new $f62453a6e3b4559e$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f62453a6e3b4559e$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f62453a6e3b4559e$var$ce ? $f62453a6e3b4559e$var$je(a, c) : $f62453a6e3b4559e$var$ke(a, c)) d = $f62453a6e3b4559e$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f62453a6e3b4559e$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f62453a6e3b4559e$var$se(g, b);
    });
}
function $f62453a6e3b4559e$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f62453a6e3b4559e$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f62453a6e3b4559e$var$Kb(a, c), null != f && d.unshift($f62453a6e3b4559e$var$tf(a, f, e)), f = $f62453a6e3b4559e$var$Kb(a, b), null != f && d.push($f62453a6e3b4559e$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f62453a6e3b4559e$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f62453a6e3b4559e$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.unshift($f62453a6e3b4559e$var$tf(c, k, h))) : e || (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.push($f62453a6e3b4559e$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f62453a6e3b4559e$var$xf = /\r\n?/g, $f62453a6e3b4559e$var$yf = /\u0000|\uFFFD/g;
function $f62453a6e3b4559e$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f62453a6e3b4559e$var$xf, "\n").replace($f62453a6e3b4559e$var$yf, "");
}
function $f62453a6e3b4559e$var$Af(a, b, c) {
    b = $f62453a6e3b4559e$var$zf(b);
    if ($f62453a6e3b4559e$var$zf(a) !== b && c) throw Error($f62453a6e3b4559e$var$p(425));
}
function $f62453a6e3b4559e$var$Bf() {}
var $f62453a6e3b4559e$var$Cf = null, $f62453a6e3b4559e$var$Df = null;
function $f62453a6e3b4559e$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f62453a6e3b4559e$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f62453a6e3b4559e$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f62453a6e3b4559e$var$Hf = "function" === typeof Promise ? Promise : void 0, $f62453a6e3b4559e$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f62453a6e3b4559e$var$Hf ? function(a) {
    return $f62453a6e3b4559e$var$Hf.resolve(null).then(a).catch($f62453a6e3b4559e$var$If);
} : $f62453a6e3b4559e$var$Ff;
function $f62453a6e3b4559e$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f62453a6e3b4559e$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f62453a6e3b4559e$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f62453a6e3b4559e$var$bd(b);
}
function $f62453a6e3b4559e$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f62453a6e3b4559e$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Nf = Math.random().toString(36).slice(2), $f62453a6e3b4559e$var$Of = "__reactFiber$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Pf = "__reactProps$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$uf = "__reactContainer$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$of = "__reactEvents$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Qf = "__reactListeners$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Rf = "__reactHandles$" + $f62453a6e3b4559e$var$Nf;
function $f62453a6e3b4559e$var$Wc(a) {
    var b = a[$f62453a6e3b4559e$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f62453a6e3b4559e$var$uf] || c[$f62453a6e3b4559e$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f62453a6e3b4559e$var$Mf(a); null !== a;){
                if (c = a[$f62453a6e3b4559e$var$Of]) return c;
                a = $f62453a6e3b4559e$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f62453a6e3b4559e$var$Cb(a) {
    a = a[$f62453a6e3b4559e$var$Of] || a[$f62453a6e3b4559e$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f62453a6e3b4559e$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f62453a6e3b4559e$var$p(33));
}
function $f62453a6e3b4559e$var$Db(a) {
    return a[$f62453a6e3b4559e$var$Pf] || null;
}
var $f62453a6e3b4559e$var$Sf = [], $f62453a6e3b4559e$var$Tf = -1;
function $f62453a6e3b4559e$var$Uf(a) {
    return {
        current: a
    };
}
function $f62453a6e3b4559e$var$E(a) {
    0 > $f62453a6e3b4559e$var$Tf || (a.current = $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf], $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = null, $f62453a6e3b4559e$var$Tf--);
}
function $f62453a6e3b4559e$var$G(a, b) {
    $f62453a6e3b4559e$var$Tf++;
    $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = a.current;
    a.current = b;
}
var $f62453a6e3b4559e$var$Vf = {}, $f62453a6e3b4559e$var$H = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$Vf), $f62453a6e3b4559e$var$Wf = $f62453a6e3b4559e$var$Uf(!1), $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$Vf;
function $f62453a6e3b4559e$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f62453a6e3b4559e$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f62453a6e3b4559e$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f62453a6e3b4559e$var$$f() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
}
function $f62453a6e3b4559e$var$ag(a, b, c) {
    if ($f62453a6e3b4559e$var$H.current !== $f62453a6e3b4559e$var$Vf) throw Error($f62453a6e3b4559e$var$p(168));
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
function $f62453a6e3b4559e$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f62453a6e3b4559e$var$p(108, $f62453a6e3b4559e$var$Ra(a) || "Unknown", e));
    return $f62453a6e3b4559e$var$A({}, c, d);
}
function $f62453a6e3b4559e$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f62453a6e3b4559e$var$Vf;
    $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$H.current;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, $f62453a6e3b4559e$var$Wf.current);
    return !0;
}
function $f62453a6e3b4559e$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f62453a6e3b4559e$var$p(169));
    c ? (a = $f62453a6e3b4559e$var$bg(a, b, $f62453a6e3b4559e$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a)) : $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
var $f62453a6e3b4559e$var$eg = null, $f62453a6e3b4559e$var$fg = !1, $f62453a6e3b4559e$var$gg = !1;
function $f62453a6e3b4559e$var$hg(a) {
    null === $f62453a6e3b4559e$var$eg ? $f62453a6e3b4559e$var$eg = [
        a
    ] : $f62453a6e3b4559e$var$eg.push(a);
}
function $f62453a6e3b4559e$var$ig(a) {
    $f62453a6e3b4559e$var$fg = !0;
    $f62453a6e3b4559e$var$hg(a);
}
function $f62453a6e3b4559e$var$jg() {
    if (!$f62453a6e3b4559e$var$gg && null !== $f62453a6e3b4559e$var$eg) {
        $f62453a6e3b4559e$var$gg = !0;
        var a = 0, b = $f62453a6e3b4559e$var$C;
        try {
            var c = $f62453a6e3b4559e$var$eg;
            for($f62453a6e3b4559e$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f62453a6e3b4559e$var$eg = null;
            $f62453a6e3b4559e$var$fg = !1;
        } catch (e) {
            throw null !== $f62453a6e3b4559e$var$eg && ($f62453a6e3b4559e$var$eg = $f62453a6e3b4559e$var$eg.slice(a + 1)), $f62453a6e3b4559e$var$ac($f62453a6e3b4559e$var$fc, $f62453a6e3b4559e$var$jg), e;
        } finally{
            $f62453a6e3b4559e$var$C = b, $f62453a6e3b4559e$var$gg = !1;
        }
    }
    return null;
}
var $f62453a6e3b4559e$var$kg = [], $f62453a6e3b4559e$var$lg = 0, $f62453a6e3b4559e$var$mg = null, $f62453a6e3b4559e$var$ng = 0, $f62453a6e3b4559e$var$og = [], $f62453a6e3b4559e$var$pg = 0, $f62453a6e3b4559e$var$qg = null, $f62453a6e3b4559e$var$rg = 1, $f62453a6e3b4559e$var$sg = "";
function $f62453a6e3b4559e$var$tg(a, b) {
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$ng;
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$mg;
    $f62453a6e3b4559e$var$mg = a;
    $f62453a6e3b4559e$var$ng = b;
}
function $f62453a6e3b4559e$var$ug(a, b, c) {
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg;
    $f62453a6e3b4559e$var$qg = a;
    var d = $f62453a6e3b4559e$var$rg;
    a = $f62453a6e3b4559e$var$sg;
    var e = 32 - $f62453a6e3b4559e$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f62453a6e3b4559e$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f62453a6e3b4559e$var$rg = 1 << 32 - $f62453a6e3b4559e$var$oc(b) + e | c << e | d;
        $f62453a6e3b4559e$var$sg = f + a;
    } else $f62453a6e3b4559e$var$rg = 1 << f | c << e | d, $f62453a6e3b4559e$var$sg = a;
}
function $f62453a6e3b4559e$var$vg(a) {
    null !== a.return && ($f62453a6e3b4559e$var$tg(a, 1), $f62453a6e3b4559e$var$ug(a, 1, 0));
}
function $f62453a6e3b4559e$var$wg(a) {
    for(; a === $f62453a6e3b4559e$var$mg;)$f62453a6e3b4559e$var$mg = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null, $f62453a6e3b4559e$var$ng = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null;
    for(; a === $f62453a6e3b4559e$var$qg;)$f62453a6e3b4559e$var$qg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$sg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$rg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null;
}
var $f62453a6e3b4559e$var$xg = null, $f62453a6e3b4559e$var$yg = null, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$zg = null;
function $f62453a6e3b4559e$var$Ag(a, b) {
    var c = $f62453a6e3b4559e$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f62453a6e3b4559e$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f62453a6e3b4559e$var$qg ? {
                id: $f62453a6e3b4559e$var$rg,
                overflow: $f62453a6e3b4559e$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f62453a6e3b4559e$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f62453a6e3b4559e$var$Eg(a) {
    if ($f62453a6e3b4559e$var$I) {
        var b = $f62453a6e3b4559e$var$yg;
        if (b) {
            var c = b;
            if (!$f62453a6e3b4559e$var$Cg(a, b)) {
                if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
                b = $f62453a6e3b4559e$var$Lf(c.nextSibling);
                var d = $f62453a6e3b4559e$var$xg;
                b && $f62453a6e3b4559e$var$Cg(a, b) ? $f62453a6e3b4559e$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$xg = a);
            }
        } else {
            if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f62453a6e3b4559e$var$I = !1;
            $f62453a6e3b4559e$var$xg = a;
        }
    }
}
function $f62453a6e3b4559e$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f62453a6e3b4559e$var$xg = a;
}
function $f62453a6e3b4559e$var$Gg(a) {
    if (a !== $f62453a6e3b4559e$var$xg) return !1;
    if (!$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$Fg(a), $f62453a6e3b4559e$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f62453a6e3b4559e$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f62453a6e3b4559e$var$yg)) {
        if ($f62453a6e3b4559e$var$Dg(a)) throw $f62453a6e3b4559e$var$Hg(), Error($f62453a6e3b4559e$var$p(418));
        for(; b;)$f62453a6e3b4559e$var$Ag(a, b), b = $f62453a6e3b4559e$var$Lf(b.nextSibling);
    }
    $f62453a6e3b4559e$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f62453a6e3b4559e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f62453a6e3b4559e$var$yg = null;
        }
    } else $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg ? $f62453a6e3b4559e$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f62453a6e3b4559e$var$Hg() {
    for(var a = $f62453a6e3b4559e$var$yg; a;)a = $f62453a6e3b4559e$var$Lf(a.nextSibling);
}
function $f62453a6e3b4559e$var$Ig() {
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg = null;
    $f62453a6e3b4559e$var$I = !1;
}
function $f62453a6e3b4559e$var$Jg(a) {
    null === $f62453a6e3b4559e$var$zg ? $f62453a6e3b4559e$var$zg = [
        a
    ] : $f62453a6e3b4559e$var$zg.push(a);
}
var $f62453a6e3b4559e$var$Kg = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig;
function $f62453a6e3b4559e$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f62453a6e3b4559e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f62453a6e3b4559e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f62453a6e3b4559e$var$p(284));
        if (!c._owner) throw Error($f62453a6e3b4559e$var$p(290, a));
    }
    return a;
}
function $f62453a6e3b4559e$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f62453a6e3b4559e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f62453a6e3b4559e$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $f62453a6e3b4559e$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f62453a6e3b4559e$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f62453a6e3b4559e$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f62453a6e3b4559e$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $f62453a6e3b4559e$var$Lg(a, b, c), d.return = a, d;
        d = $f62453a6e3b4559e$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f62453a6e3b4559e$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f62453a6e3b4559e$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f62453a6e3b4559e$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f62453a6e3b4559e$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c = $f62453a6e3b4559e$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $f62453a6e3b4559e$var$Lg(a, null, b), c.return = a, c;
                case $f62453a6e3b4559e$var$wa:
                    return b = $f62453a6e3b4559e$var$Sg(b, a.mode, c), b.return = a, b;
                case $f62453a6e3b4559e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f62453a6e3b4559e$var$eb(b) || $f62453a6e3b4559e$var$Ka(b)) return b = $f62453a6e3b4559e$var$Tg(b, a.mode, c, null), b.return = a, b;
            $f62453a6e3b4559e$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f62453a6e3b4559e$var$eb(c) || $f62453a6e3b4559e$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f62453a6e3b4559e$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f62453a6e3b4559e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f62453a6e3b4559e$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f62453a6e3b4559e$var$eb(d) || $f62453a6e3b4559e$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f62453a6e3b4559e$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f62453a6e3b4559e$var$Ka(h);
        if ("function" !== typeof l) throw Error($f62453a6e3b4559e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f62453a6e3b4559e$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f62453a6e3b4559e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f62453a6e3b4559e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f62453a6e3b4559e$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f62453a6e3b4559e$var$ya ? (d = $f62453a6e3b4559e$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f62453a6e3b4559e$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $f62453a6e3b4559e$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f62453a6e3b4559e$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f62453a6e3b4559e$var$eb(f)) return n(a, d, f, h);
            if ($f62453a6e3b4559e$var$Ka(f)) return t(a, d, f, h);
            $f62453a6e3b4559e$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f62453a6e3b4559e$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f62453a6e3b4559e$var$Ug = $f62453a6e3b4559e$var$Og(!0), $f62453a6e3b4559e$var$Vg = $f62453a6e3b4559e$var$Og(!1), $f62453a6e3b4559e$var$Wg = $f62453a6e3b4559e$var$Uf(null), $f62453a6e3b4559e$var$Xg = null, $f62453a6e3b4559e$var$Yg = null, $f62453a6e3b4559e$var$Zg = null;
function $f62453a6e3b4559e$var$$g() {
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Xg = null;
}
function $f62453a6e3b4559e$var$ah(a) {
    var b = $f62453a6e3b4559e$var$Wg.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wg);
    a._currentValue = b;
}
function $f62453a6e3b4559e$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f62453a6e3b4559e$var$ch(a, b) {
    $f62453a6e3b4559e$var$Xg = a;
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f62453a6e3b4559e$var$dh = !0), a.firstContext = null);
}
function $f62453a6e3b4559e$var$eh(a) {
    var b = a._currentValue;
    if ($f62453a6e3b4559e$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f62453a6e3b4559e$var$Yg) {
            if (null === $f62453a6e3b4559e$var$Xg) throw Error($f62453a6e3b4559e$var$p(308));
            $f62453a6e3b4559e$var$Yg = a;
            $f62453a6e3b4559e$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Yg.next = a;
    }
    return b;
}
var $f62453a6e3b4559e$var$fh = null;
function $f62453a6e3b4559e$var$gh(a) {
    null === $f62453a6e3b4559e$var$fh ? $f62453a6e3b4559e$var$fh = [
        a
    ] : $f62453a6e3b4559e$var$fh.push(a);
}
function $f62453a6e3b4559e$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f62453a6e3b4559e$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f62453a6e3b4559e$var$ih(a, d);
}
function $f62453a6e3b4559e$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f62453a6e3b4559e$var$jh = !1;
function $f62453a6e3b4559e$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f62453a6e3b4559e$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f62453a6e3b4559e$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f62453a6e3b4559e$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f62453a6e3b4559e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f62453a6e3b4559e$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f62453a6e3b4559e$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f62453a6e3b4559e$var$ih(a, c);
}
function $f62453a6e3b4559e$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
function $f62453a6e3b4559e$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f62453a6e3b4559e$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $f62453a6e3b4559e$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f62453a6e3b4559e$var$A({}, q, r);
                            break a;
                        case 2:
                            $f62453a6e3b4559e$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f62453a6e3b4559e$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f62453a6e3b4559e$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f62453a6e3b4559e$var$p(191, e));
            e.call(d);
        }
    }
}
var $f62453a6e3b4559e$var$th = {}, $f62453a6e3b4559e$var$uh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$vh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$wh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th);
function $f62453a6e3b4559e$var$xh(a) {
    if (a === $f62453a6e3b4559e$var$th) throw Error($f62453a6e3b4559e$var$p(174));
    return a;
}
function $f62453a6e3b4559e$var$yh(a, b) {
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$wh, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, $f62453a6e3b4559e$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f62453a6e3b4559e$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f62453a6e3b4559e$var$lb(b, a);
    }
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, b);
}
function $f62453a6e3b4559e$var$zh() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$wh);
}
function $f62453a6e3b4559e$var$Ah(a) {
    $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
    var b = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
    var c = $f62453a6e3b4559e$var$lb(b, a.type);
    b !== c && ($f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, c));
}
function $f62453a6e3b4559e$var$Bh(a) {
    $f62453a6e3b4559e$var$vh.current === a && ($f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh));
}
var $f62453a6e3b4559e$var$L = $f62453a6e3b4559e$var$Uf(0);
function $f62453a6e3b4559e$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Dh = [];
function $f62453a6e3b4559e$var$Eh() {
    for(var a = 0; a < $f62453a6e3b4559e$var$Dh.length; a++)$f62453a6e3b4559e$var$Dh[a]._workInProgressVersionPrimary = null;
    $f62453a6e3b4559e$var$Dh.length = 0;
}
var $f62453a6e3b4559e$var$Fh = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$Gh = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$Hh = 0, $f62453a6e3b4559e$var$M = null, $f62453a6e3b4559e$var$N = null, $f62453a6e3b4559e$var$O = null, $f62453a6e3b4559e$var$Ih = !1, $f62453a6e3b4559e$var$Jh = !1, $f62453a6e3b4559e$var$Kh = 0, $f62453a6e3b4559e$var$Lh = 0;
function $f62453a6e3b4559e$var$P() {
    throw Error($f62453a6e3b4559e$var$p(321));
}
function $f62453a6e3b4559e$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f62453a6e3b4559e$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f62453a6e3b4559e$var$Nh(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$Hh = f;
    $f62453a6e3b4559e$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f62453a6e3b4559e$var$Fh.current = null === a || null === a.memoizedState ? $f62453a6e3b4559e$var$Oh : $f62453a6e3b4559e$var$Ph;
    a = c(d, e);
    if ($f62453a6e3b4559e$var$Jh) {
        f = 0;
        do {
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            if (25 <= f) throw Error($f62453a6e3b4559e$var$p(301));
            f += 1;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = null;
            b.updateQueue = null;
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Qh;
            a = c(d, e);
        }while ($f62453a6e3b4559e$var$Jh);
    }
    $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
    b = null !== $f62453a6e3b4559e$var$N && null !== $f62453a6e3b4559e$var$N.next;
    $f62453a6e3b4559e$var$Hh = 0;
    $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
    $f62453a6e3b4559e$var$Ih = !1;
    if (b) throw Error($f62453a6e3b4559e$var$p(300));
    return a;
}
function $f62453a6e3b4559e$var$Sh() {
    var a = 0 !== $f62453a6e3b4559e$var$Kh;
    $f62453a6e3b4559e$var$Kh = 0;
    return a;
}
function $f62453a6e3b4559e$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Uh() {
    if (null === $f62453a6e3b4559e$var$N) {
        var a = $f62453a6e3b4559e$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f62453a6e3b4559e$var$N.next;
    var b = null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState : $f62453a6e3b4559e$var$O.next;
    if (null !== b) $f62453a6e3b4559e$var$O = b, $f62453a6e3b4559e$var$N = a;
    else {
        if (null === a) throw Error($f62453a6e3b4559e$var$p(310));
        $f62453a6e3b4559e$var$N = a;
        a = {
            memoizedState: $f62453a6e3b4559e$var$N.memoizedState,
            baseState: $f62453a6e3b4559e$var$N.baseState,
            baseQueue: $f62453a6e3b4559e$var$N.baseQueue,
            queue: $f62453a6e3b4559e$var$N.queue,
            next: null
        };
        null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    }
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f62453a6e3b4559e$var$Wh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f62453a6e3b4559e$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f62453a6e3b4559e$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f62453a6e3b4559e$var$M.lanes |= m;
                $f62453a6e3b4559e$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f62453a6e3b4559e$var$He(d, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f62453a6e3b4559e$var$M.lanes |= f, $f62453a6e3b4559e$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f62453a6e3b4559e$var$Xh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f62453a6e3b4559e$var$He(f, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f62453a6e3b4559e$var$Yh() {}
function $f62453a6e3b4559e$var$Zh(a, b) {
    var c = $f62453a6e3b4559e$var$M, d = $f62453a6e3b4559e$var$Uh(), e = b(), f = !$f62453a6e3b4559e$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f62453a6e3b4559e$var$dh = !0);
    d = d.queue;
    $f62453a6e3b4559e$var$$h($f62453a6e3b4559e$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f62453a6e3b4559e$var$O && $f62453a6e3b4559e$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
        0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(c, b, e);
    }
    return e;
}
function $f62453a6e3b4559e$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f62453a6e3b4559e$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
}
function $f62453a6e3b4559e$var$ai(a, b, c) {
    return c(function() {
        $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
    });
}
function $f62453a6e3b4559e$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f62453a6e3b4559e$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f62453a6e3b4559e$var$fi(a) {
    var b = $f62453a6e3b4559e$var$ih(a, 1);
    null !== b && $f62453a6e3b4559e$var$gi(b, a, 1, -1);
}
function $f62453a6e3b4559e$var$hi(a) {
    var b = $f62453a6e3b4559e$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f62453a6e3b4559e$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f62453a6e3b4559e$var$ii.bind(null, $f62453a6e3b4559e$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f62453a6e3b4559e$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f62453a6e3b4559e$var$ji() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$ki(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Th();
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f62453a6e3b4559e$var$li(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f62453a6e3b4559e$var$N) {
        var g = $f62453a6e3b4559e$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $f62453a6e3b4559e$var$Mh(d, g.deps)) {
            e.memoizedState = $f62453a6e3b4559e$var$bi(b, c, f, d);
            return;
        }
    }
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, f, d);
}
function $f62453a6e3b4559e$var$mi(a, b) {
    return $f62453a6e3b4559e$var$ki(8390656, 8, a, b);
}
function $f62453a6e3b4559e$var$$h(a, b) {
    return $f62453a6e3b4559e$var$li(2048, 8, a, b);
}
function $f62453a6e3b4559e$var$ni(a, b) {
    return $f62453a6e3b4559e$var$li(4, 2, a, b);
}
function $f62453a6e3b4559e$var$oi(a, b) {
    return $f62453a6e3b4559e$var$li(4, 4, a, b);
}
function $f62453a6e3b4559e$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f62453a6e3b4559e$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f62453a6e3b4559e$var$li(4, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
}
function $f62453a6e3b4559e$var$ri() {}
function $f62453a6e3b4559e$var$si(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ti(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ui(a, b, c) {
    if (0 === ($f62453a6e3b4559e$var$Hh & 21)) return a.baseState && (a.baseState = !1, $f62453a6e3b4559e$var$dh = !0), a.memoizedState = c;
    $f62453a6e3b4559e$var$He(c, b) || (c = $f62453a6e3b4559e$var$yc(), $f62453a6e3b4559e$var$M.lanes |= c, $f62453a6e3b4559e$var$rh |= c, a.baseState = !0);
    return b;
}
function $f62453a6e3b4559e$var$vi(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    $f62453a6e3b4559e$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f62453a6e3b4559e$var$Gh.transition;
    $f62453a6e3b4559e$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$Gh.transition = d;
    }
}
function $f62453a6e3b4559e$var$wi() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$xi(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, c);
    else if (c = $f62453a6e3b4559e$var$hh(a, b, c, d), null !== c) {
        var e = $f62453a6e3b4559e$var$R();
        $f62453a6e3b4559e$var$gi(c, a, d, e);
        $f62453a6e3b4559e$var$Bi(c, b, d);
    }
}
function $f62453a6e3b4559e$var$ii(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f62453a6e3b4559e$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f62453a6e3b4559e$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f62453a6e3b4559e$var$hh(a, b, e, d);
        null !== c && (e = $f62453a6e3b4559e$var$R(), $f62453a6e3b4559e$var$gi(c, a, d, e), $f62453a6e3b4559e$var$Bi(c, b, d));
    }
}
function $f62453a6e3b4559e$var$zi(a) {
    var b = a.alternate;
    return a === $f62453a6e3b4559e$var$M || null !== b && b === $f62453a6e3b4559e$var$M;
}
function $f62453a6e3b4559e$var$Ai(a, b) {
    $f62453a6e3b4559e$var$Jh = $f62453a6e3b4559e$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f62453a6e3b4559e$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
var $f62453a6e3b4559e$var$Rh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$P,
    useContext: $f62453a6e3b4559e$var$P,
    useEffect: $f62453a6e3b4559e$var$P,
    useImperativeHandle: $f62453a6e3b4559e$var$P,
    useInsertionEffect: $f62453a6e3b4559e$var$P,
    useLayoutEffect: $f62453a6e3b4559e$var$P,
    useMemo: $f62453a6e3b4559e$var$P,
    useReducer: $f62453a6e3b4559e$var$P,
    useRef: $f62453a6e3b4559e$var$P,
    useState: $f62453a6e3b4559e$var$P,
    useDebugValue: $f62453a6e3b4559e$var$P,
    useDeferredValue: $f62453a6e3b4559e$var$P,
    useTransition: $f62453a6e3b4559e$var$P,
    useMutableSource: $f62453a6e3b4559e$var$P,
    useSyncExternalStore: $f62453a6e3b4559e$var$P,
    useId: $f62453a6e3b4559e$var$P,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Oh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: function(a, b) {
        $f62453a6e3b4559e$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f62453a6e3b4559e$var$ki(4194308, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f62453a6e3b4559e$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f62453a6e3b4559e$var$xi.bind(null, $f62453a6e3b4559e$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f62453a6e3b4559e$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f62453a6e3b4559e$var$hi,
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        return $f62453a6e3b4559e$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$hi(!1), b = a[0];
        a = $f62453a6e3b4559e$var$vi.bind(null, a[1]);
        $f62453a6e3b4559e$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$M, e = $f62453a6e3b4559e$var$Th();
        if ($f62453a6e3b4559e$var$I) {
            if (void 0 === c) throw Error($f62453a6e3b4559e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
            0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f62453a6e3b4559e$var$mi($f62453a6e3b4559e$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f62453a6e3b4559e$var$Th(), b = $f62453a6e3b4559e$var$Q.identifierPrefix;
        if ($f62453a6e3b4559e$var$I) {
            var c = $f62453a6e3b4559e$var$sg;
            var d = $f62453a6e3b4559e$var$rg;
            c = (d & ~(1 << 32 - $f62453a6e3b4559e$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f62453a6e3b4559e$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f62453a6e3b4559e$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Ph = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Wh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Qh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Xh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return null === $f62453a6e3b4559e$var$N ? b.memoizedState = a : $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
};
function $f62453a6e3b4559e$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $f62453a6e3b4559e$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f62453a6e3b4559e$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f62453a6e3b4559e$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f62453a6e3b4559e$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f62453a6e3b4559e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f62453a6e3b4559e$var$R(), d = $f62453a6e3b4559e$var$yi(a), e = $f62453a6e3b4559e$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f62453a6e3b4559e$var$nh(a, e, d);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, d, c), $f62453a6e3b4559e$var$oh(b, a, d));
    }
};
function $f62453a6e3b4559e$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f62453a6e3b4559e$var$Ie(c, d) || !$f62453a6e3b4559e$var$Ie(e, f) : !0;
}
function $f62453a6e3b4559e$var$Gi(a, b, c) {
    var d = !1, e = $f62453a6e3b4559e$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f62453a6e3b4559e$var$eh(f) : (e = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f62453a6e3b4559e$var$Yf(a, e) : $f62453a6e3b4559e$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f62453a6e3b4559e$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f62453a6e3b4559e$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $f62453a6e3b4559e$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $f62453a6e3b4559e$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f62453a6e3b4559e$var$eh(f) : (f = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, e.context = $f62453a6e3b4559e$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f62453a6e3b4559e$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(e, e.state, null), $f62453a6e3b4559e$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f62453a6e3b4559e$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $f62453a6e3b4559e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f62453a6e3b4559e$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f62453a6e3b4559e$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f62453a6e3b4559e$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $f62453a6e3b4559e$var$Ni(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f62453a6e3b4559e$var$Oi || ($f62453a6e3b4559e$var$Oi = !0, $f62453a6e3b4559e$var$Pi = d);
        $f62453a6e3b4559e$var$Li(a, b);
    };
    return c;
}
function $f62453a6e3b4559e$var$Qi(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f62453a6e3b4559e$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f62453a6e3b4559e$var$Li(a, b);
        "function" !== typeof d && (null === $f62453a6e3b4559e$var$Ri ? $f62453a6e3b4559e$var$Ri = new Set([
            this
        ]) : $f62453a6e3b4559e$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f62453a6e3b4559e$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f62453a6e3b4559e$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f62453a6e3b4559e$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $f62453a6e3b4559e$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f62453a6e3b4559e$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f62453a6e3b4559e$var$mh(-1, 1), b.tag = 2, $f62453a6e3b4559e$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f62453a6e3b4559e$var$Wi = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$dh = !1;
function $f62453a6e3b4559e$var$Xi(a, b, c, d) {
    b.child = null === a ? $f62453a6e3b4559e$var$Vg(b, null, c, d) : $f62453a6e3b4559e$var$Ug(b, a.child, c, d);
}
function $f62453a6e3b4559e$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f62453a6e3b4559e$var$ch(b, e);
    d = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    c = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && c && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, d, e);
    return b.child;
}
function $f62453a6e3b4559e$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f62453a6e3b4559e$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f62453a6e3b4559e$var$bj(a, b, f, d, e);
        a = $f62453a6e3b4559e$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f62453a6e3b4559e$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f62453a6e3b4559e$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $f62453a6e3b4559e$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f62453a6e3b4559e$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f62453a6e3b4559e$var$Ie(f, d) && a.ref === b.ref) {
            if ($f62453a6e3b4559e$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f62453a6e3b4559e$var$dh = !0);
            else return b.lanes = a.lanes, $f62453a6e3b4559e$var$Zi(a, b, e);
        }
    }
    return $f62453a6e3b4559e$var$cj(a, b, c, d, e);
}
function $f62453a6e3b4559e$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj);
            $f62453a6e3b4559e$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= d;
    $f62453a6e3b4559e$var$Xi(a, b, e, c);
    return b.child;
}
function $f62453a6e3b4559e$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f62453a6e3b4559e$var$cj(a, b, c, d, e) {
    var f = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current;
    f = $f62453a6e3b4559e$var$Yf(b, f);
    $f62453a6e3b4559e$var$ch(b, e);
    c = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    d = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && d && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, c, e);
    return b.child;
}
function $f62453a6e3b4559e$var$hj(a, b, c, d, e) {
    if ($f62453a6e3b4559e$var$Zf(c)) {
        var f = !0;
        $f62453a6e3b4559e$var$cg(b);
    } else f = !1;
    $f62453a6e3b4559e$var$ch(b, e);
    if (null === b.stateNode) $f62453a6e3b4559e$var$ij(a, b), $f62453a6e3b4559e$var$Gi(b, c, d), $f62453a6e3b4559e$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f62453a6e3b4559e$var$eh(l) : (l = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, l = $f62453a6e3b4559e$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f62453a6e3b4559e$var$Hi(b, g, d, l);
        $f62453a6e3b4559e$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof m && ($f62453a6e3b4559e$var$Di(b, c, m, d), k = b.memoizedState), (h = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f62453a6e3b4559e$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f62453a6e3b4559e$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f62453a6e3b4559e$var$eh(k) : (k = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, k = $f62453a6e3b4559e$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f62453a6e3b4559e$var$Hi(b, g, d, k);
        $f62453a6e3b4559e$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof y && ($f62453a6e3b4559e$var$Di(b, c, y, d), n = b.memoizedState), (l = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f62453a6e3b4559e$var$jj(a, b, c, d, f, e);
}
function $f62453a6e3b4559e$var$jj(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f62453a6e3b4559e$var$dg(b, c, !1), $f62453a6e3b4559e$var$Zi(a, b, f);
    d = b.stateNode;
    $f62453a6e3b4559e$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f62453a6e3b4559e$var$Ug(b, a.child, null, f), b.child = $f62453a6e3b4559e$var$Ug(b, null, h, f)) : $f62453a6e3b4559e$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f62453a6e3b4559e$var$dg(b, c, !0);
    return b.child;
}
function $f62453a6e3b4559e$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f62453a6e3b4559e$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f62453a6e3b4559e$var$ag(a, b.context, !1);
    $f62453a6e3b4559e$var$yh(a, b.containerInfo);
}
function $f62453a6e3b4559e$var$lj(a, b, c, d, e) {
    $f62453a6e3b4559e$var$Ig();
    $f62453a6e3b4559e$var$Jg(e);
    b.flags |= 256;
    $f62453a6e3b4559e$var$Xi(a, b, c, d);
    return b.child;
}
var $f62453a6e3b4559e$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f62453a6e3b4559e$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f62453a6e3b4559e$var$oj(a, b, c) {
    var d = b.pendingProps, e = $f62453a6e3b4559e$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, e & 1);
    if (null === a) {
        $f62453a6e3b4559e$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f62453a6e3b4559e$var$pj(g, d, 0, null), a = $f62453a6e3b4559e$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f62453a6e3b4559e$var$nj(c), b.memoizedState = $f62453a6e3b4559e$var$mj, a) : $f62453a6e3b4559e$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f62453a6e3b4559e$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f62453a6e3b4559e$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f62453a6e3b4559e$var$Pg(h, f) : (f = $f62453a6e3b4559e$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f62453a6e3b4559e$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f62453a6e3b4559e$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f62453a6e3b4559e$var$qj(a, b) {
    b = $f62453a6e3b4559e$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f62453a6e3b4559e$var$sj(a, b, c, d) {
    null !== d && $f62453a6e3b4559e$var$Jg(d);
    $f62453a6e3b4559e$var$Ug(b, a.child, null, c);
    a = $f62453a6e3b4559e$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f62453a6e3b4559e$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(422))), $f62453a6e3b4559e$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f62453a6e3b4559e$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f62453a6e3b4559e$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f62453a6e3b4559e$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $f62453a6e3b4559e$var$nj(g);
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f62453a6e3b4559e$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f62453a6e3b4559e$var$p(419));
        d = $f62453a6e3b4559e$var$Ki(f, d, void 0);
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f62453a6e3b4559e$var$dh || h) {
        d = $f62453a6e3b4559e$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f62453a6e3b4559e$var$ih(a, e), $f62453a6e3b4559e$var$gi(d, a, e, -1));
        }
        $f62453a6e3b4559e$var$tj();
        d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(421)));
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f62453a6e3b4559e$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(e.nextSibling);
    $f62453a6e3b4559e$var$xg = b;
    $f62453a6e3b4559e$var$I = !0;
    $f62453a6e3b4559e$var$zg = null;
    null !== a && ($f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg, $f62453a6e3b4559e$var$rg = a.id, $f62453a6e3b4559e$var$sg = a.overflow, $f62453a6e3b4559e$var$qg = b);
    b = $f62453a6e3b4559e$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f62453a6e3b4559e$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f62453a6e3b4559e$var$bh(a.return, b, c);
}
function $f62453a6e3b4559e$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f62453a6e3b4559e$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f62453a6e3b4559e$var$Xi(a, b, d.children, c);
    d = $f62453a6e3b4559e$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f62453a6e3b4559e$var$vj(a, c, b);
            else if (19 === a.tag) $f62453a6e3b4559e$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f62453a6e3b4559e$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f62453a6e3b4559e$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f62453a6e3b4559e$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f62453a6e3b4559e$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $f62453a6e3b4559e$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f62453a6e3b4559e$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f62453a6e3b4559e$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f62453a6e3b4559e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f62453a6e3b4559e$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f62453a6e3b4559e$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $f62453a6e3b4559e$var$kj(b);
            $f62453a6e3b4559e$var$Ig();
            break;
        case 5:
            $f62453a6e3b4559e$var$Ah(b);
            break;
        case 1:
            $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$cg(b);
            break;
        case 4:
            $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f62453a6e3b4559e$var$oj(a, b, c);
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
                a = $f62453a6e3b4559e$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f62453a6e3b4559e$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f62453a6e3b4559e$var$dj(a, b, c);
    }
    return $f62453a6e3b4559e$var$Zi(a, b, c);
}
var $f62453a6e3b4559e$var$zj, $f62453a6e3b4559e$var$Aj, $f62453a6e3b4559e$var$Bj, $f62453a6e3b4559e$var$Cj;
$f62453a6e3b4559e$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f62453a6e3b4559e$var$Aj = function() {};
$f62453a6e3b4559e$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f62453a6e3b4559e$var$Ya(a, e);
                d = $f62453a6e3b4559e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f62453a6e3b4559e$var$A({}, e, {
                    value: void 0
                });
                d = $f62453a6e3b4559e$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f62453a6e3b4559e$var$gb(a, e);
                d = $f62453a6e3b4559e$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
        }
        $f62453a6e3b4559e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f62453a6e3b4559e$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f62453a6e3b4559e$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f62453a6e3b4559e$var$Dj(a, b) {
    if (!$f62453a6e3b4559e$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f62453a6e3b4559e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f62453a6e3b4559e$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f62453a6e3b4559e$var$S(b), null;
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f62453a6e3b4559e$var$zh();
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
            $f62453a6e3b4559e$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f62453a6e3b4559e$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null));
            $f62453a6e3b4559e$var$Aj(a, b);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 5:
            $f62453a6e3b4559e$var$Bh(b);
            var e = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f62453a6e3b4559e$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                    $f62453a6e3b4559e$var$S(b);
                    return null;
                }
                a = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    d[$f62453a6e3b4559e$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f62453a6e3b4559e$var$D("cancel", d);
                            $f62453a6e3b4559e$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], d);
                            break;
                        case "source":
                            $f62453a6e3b4559e$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f62453a6e3b4559e$var$D("error", d);
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "details":
                            $f62453a6e3b4559e$var$D("toggle", d);
                            break;
                        case "input":
                            $f62453a6e3b4559e$var$Za(d, f);
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$hb(d, f), $f62453a6e3b4559e$var$D("invalid", d);
                    }
                    $f62453a6e3b4559e$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f62453a6e3b4559e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f62453a6e3b4559e$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f62453a6e3b4559e$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f62453a6e3b4559e$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f62453a6e3b4559e$var$Of] = b;
                    a[$f62453a6e3b4559e$var$Pf] = d;
                    $f62453a6e3b4559e$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f62453a6e3b4559e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f62453a6e3b4559e$var$D("cancel", a);
                                $f62453a6e3b4559e$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f62453a6e3b4559e$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f62453a6e3b4559e$var$D("error", a);
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f62453a6e3b4559e$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f62453a6e3b4559e$var$Za(a, d);
                                e = $f62453a6e3b4559e$var$Ya(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f62453a6e3b4559e$var$A({}, d, {
                                    value: void 0
                                });
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$hb(a, d);
                                e = $f62453a6e3b4559e$var$gb(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f62453a6e3b4559e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f62453a6e3b4559e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f62453a6e3b4559e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f62453a6e3b4559e$var$ob(a, k) : "number" === typeof k && $f62453a6e3b4559e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f62453a6e3b4559e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f62453a6e3b4559e$var$D("scroll", a) : null != k && $f62453a6e3b4559e$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f62453a6e3b4559e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f62453a6e3b4559e$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f62453a6e3b4559e$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f62453a6e3b4559e$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                c = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
                $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f62453a6e3b4559e$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f62453a6e3b4559e$var$Of] = b, b.stateNode = d;
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f62453a6e3b4559e$var$I && null !== $f62453a6e3b4559e$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f62453a6e3b4559e$var$Hg(), $f62453a6e3b4559e$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f62453a6e3b4559e$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f62453a6e3b4559e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f62453a6e3b4559e$var$p(317));
                        f[$f62453a6e3b4559e$var$Of] = b;
                    } else $f62453a6e3b4559e$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f62453a6e3b4559e$var$S(b);
                    f = !1;
                } else null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f62453a6e3b4559e$var$L.current & 1) ? 0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 3) : $f62453a6e3b4559e$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$Aj(a, b), null === a && $f62453a6e3b4559e$var$sf(b.stateNode.containerInfo), $f62453a6e3b4559e$var$S(b), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), $f62453a6e3b4559e$var$S(b), null;
        case 17:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 19:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            f = b.memoizedState;
            if (null === f) return $f62453a6e3b4559e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f62453a6e3b4559e$var$Dj(f, !1);
                else {
                    if (0 !== $f62453a6e3b4559e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f62453a6e3b4559e$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f62453a6e3b4559e$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f62453a6e3b4559e$var$B() > $f62453a6e3b4559e$var$Gj && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f62453a6e3b4559e$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f62453a6e3b4559e$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$S(b), null;
                    } else 2 * $f62453a6e3b4559e$var$B() - f.renderingStartTime > $f62453a6e3b4559e$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f62453a6e3b4559e$var$B(), b.sibling = null, c = $f62453a6e3b4559e$var$L.current, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d ? c & 1 | 2 : c & 1), b;
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f62453a6e3b4559e$var$fj & 1073741824) && ($f62453a6e3b4559e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f62453a6e3b4559e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
}
function $f62453a6e3b4559e$var$Ij(a, b) {
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f62453a6e3b4559e$var$Bh(b), null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f62453a6e3b4559e$var$p(340));
                $f62453a6e3b4559e$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L), null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$Jj = !1, $f62453a6e3b4559e$var$U = !1, $f62453a6e3b4559e$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $f62453a6e3b4559e$var$V = null;
function $f62453a6e3b4559e$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f62453a6e3b4559e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f62453a6e3b4559e$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f62453a6e3b4559e$var$W(a, b, d);
    }
}
var $f62453a6e3b4559e$var$Nj = !1;
function $f62453a6e3b4559e$var$Oj(a, b) {
    $f62453a6e3b4559e$var$Cf = $f62453a6e3b4559e$var$dd;
    a = $f62453a6e3b4559e$var$Me();
    if ($f62453a6e3b4559e$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f62453a6e3b4559e$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f62453a6e3b4559e$var$dd = !1;
    for($f62453a6e3b4559e$var$V = b; null !== $f62453a6e3b4559e$var$V;)if (b = $f62453a6e3b4559e$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f62453a6e3b4559e$var$V = a;
    else for(; null !== $f62453a6e3b4559e$var$V;){
        b = $f62453a6e3b4559e$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f62453a6e3b4559e$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(163));
            }
        } catch (F) {
            $f62453a6e3b4559e$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f62453a6e3b4559e$var$V = a;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
    n = $f62453a6e3b4559e$var$Nj;
    $f62453a6e3b4559e$var$Nj = !1;
    return n;
}
function $f62453a6e3b4559e$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f62453a6e3b4559e$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f62453a6e3b4559e$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f62453a6e3b4559e$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f62453a6e3b4559e$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f62453a6e3b4559e$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f62453a6e3b4559e$var$Of], delete b[$f62453a6e3b4559e$var$Pf], delete b[$f62453a6e3b4559e$var$of], delete b[$f62453a6e3b4559e$var$Qf], delete b[$f62453a6e3b4559e$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f62453a6e3b4559e$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f62453a6e3b4559e$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f62453a6e3b4559e$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f62453a6e3b4559e$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f62453a6e3b4559e$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling;
}
function $f62453a6e3b4559e$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling;
}
var $f62453a6e3b4559e$var$X = null, $f62453a6e3b4559e$var$Xj = !1;
function $f62453a6e3b4559e$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$f62453a6e3b4559e$var$Zj(a, b, c), c = c.sibling;
}
function $f62453a6e3b4559e$var$Zj(a, b, c) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberUnmount) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberUnmount($f62453a6e3b4559e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Lj(c, b);
        case 6:
            var d = $f62453a6e3b4559e$var$X, e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f62453a6e3b4559e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? $f62453a6e3b4559e$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f62453a6e3b4559e$var$Kf(a, c), $f62453a6e3b4559e$var$bd(a)) : $f62453a6e3b4559e$var$Kf($f62453a6e3b4559e$var$X, c.stateNode));
            break;
        case 4:
            d = $f62453a6e3b4559e$var$X;
            e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = c.stateNode.containerInfo;
            $f62453a6e3b4559e$var$Xj = !0;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f62453a6e3b4559e$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f62453a6e3b4559e$var$Mj(c, b, g) : 0 !== (f & 4) && $f62453a6e3b4559e$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 1:
            if (!$f62453a6e3b4559e$var$U && ($f62453a6e3b4559e$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f62453a6e3b4559e$var$W(c, b, h);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 21:
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f62453a6e3b4559e$var$U = (d = $f62453a6e3b4559e$var$U) || null !== c.memoizedState, $f62453a6e3b4559e$var$Yj(a, b, c), $f62453a6e3b4559e$var$U = d) : $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        default:
            $f62453a6e3b4559e$var$Yj(a, b, c);
    }
}
function $f62453a6e3b4559e$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f62453a6e3b4559e$var$Kj);
        b.forEach(function(b) {
            var d = $f62453a6e3b4559e$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f62453a6e3b4559e$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f62453a6e3b4559e$var$X = h.stateNode;
                        $f62453a6e3b4559e$var$Xj = !1;
                        break a;
                    case 3:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                    case 4:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f62453a6e3b4559e$var$X) throw Error($f62453a6e3b4559e$var$p(160));
            $f62453a6e3b4559e$var$Zj(f, g, e);
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f62453a6e3b4559e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f62453a6e3b4559e$var$dk(b, a), b = b.sibling;
}
function $f62453a6e3b4559e$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                try {
                    $f62453a6e3b4559e$var$Pj(3, a, a.return), $f62453a6e3b4559e$var$Qj(3, a);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
                try {
                    $f62453a6e3b4559e$var$Pj(5, a, a.return);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            break;
        case 5:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f62453a6e3b4559e$var$ob(e, "");
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f62453a6e3b4559e$var$ab(e, f);
                    $f62453a6e3b4559e$var$vb(h, g);
                    var l = $f62453a6e3b4559e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f62453a6e3b4559e$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f62453a6e3b4559e$var$nb(e, q) : "children" === m ? $f62453a6e3b4559e$var$ob(e, q) : $f62453a6e3b4559e$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f62453a6e3b4559e$var$bb(e, f);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f62453a6e3b4559e$var$Pf] = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f62453a6e3b4559e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f62453a6e3b4559e$var$bd(b.containerInfo);
            } catch (t) {
                $f62453a6e3b4559e$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            break;
        case 13:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f62453a6e3b4559e$var$fk = $f62453a6e3b4559e$var$B()));
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f62453a6e3b4559e$var$U = (l = $f62453a6e3b4559e$var$U) || m, $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$U = l) : $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f62453a6e3b4559e$var$V = a, m = a.child; null !== m;){
                    for(q = $f62453a6e3b4559e$var$V = m; null !== $f62453a6e3b4559e$var$V;){
                        r = $f62453a6e3b4559e$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f62453a6e3b4559e$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f62453a6e3b4559e$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f62453a6e3b4559e$var$V = y) : $f62453a6e3b4559e$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f62453a6e3b4559e$var$rb("display", g));
                            } catch (t) {
                                $f62453a6e3b4559e$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f62453a6e3b4559e$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 21:
            break;
        default:
            $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$ek(a);
    }
}
function $f62453a6e3b4559e$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f62453a6e3b4559e$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f62453a6e3b4559e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f62453a6e3b4559e$var$ob(e, ""), d.flags &= -33);
                    var f = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(161));
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f62453a6e3b4559e$var$hk(a, b, c) {
    $f62453a6e3b4559e$var$V = a;
    $f62453a6e3b4559e$var$ik(a, b, c);
}
function $f62453a6e3b4559e$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f62453a6e3b4559e$var$V;){
        var e = $f62453a6e3b4559e$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f62453a6e3b4559e$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f62453a6e3b4559e$var$U;
                h = $f62453a6e3b4559e$var$Jj;
                var l = $f62453a6e3b4559e$var$U;
                $f62453a6e3b4559e$var$Jj = g;
                if (($f62453a6e3b4559e$var$U = k) && !l) for($f62453a6e3b4559e$var$V = e; null !== $f62453a6e3b4559e$var$V;)g = $f62453a6e3b4559e$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f62453a6e3b4559e$var$jk(e) : null !== k ? (k.return = g, $f62453a6e3b4559e$var$V = k) : $f62453a6e3b4559e$var$jk(e);
                for(; null !== f;)$f62453a6e3b4559e$var$V = f, $f62453a6e3b4559e$var$ik(f, b, c), f = f.sibling;
                $f62453a6e3b4559e$var$V = e;
                $f62453a6e3b4559e$var$Jj = h;
                $f62453a6e3b4559e$var$U = l;
            }
            $f62453a6e3b4559e$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f62453a6e3b4559e$var$V = f) : $f62453a6e3b4559e$var$kk(a, b, c);
    }
}
function $f62453a6e3b4559e$var$kk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f62453a6e3b4559e$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f62453a6e3b4559e$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f62453a6e3b4559e$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f62453a6e3b4559e$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f62453a6e3b4559e$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f62453a6e3b4559e$var$p(163));
                }
                $f62453a6e3b4559e$var$U || b.flags & 512 && $f62453a6e3b4559e$var$Rj(b);
            } catch (r) {
                $f62453a6e3b4559e$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$gk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$jk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f62453a6e3b4559e$var$Qj(4, b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f62453a6e3b4559e$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(b, b.return, k);
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f62453a6e3b4559e$var$V = h;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
var $f62453a6e3b4559e$var$lk = Math.ceil, $f62453a6e3b4559e$var$mk = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$nk = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$ok = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$K = 0, $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Y = null, $f62453a6e3b4559e$var$Z = 0, $f62453a6e3b4559e$var$fj = 0, $f62453a6e3b4559e$var$ej = $f62453a6e3b4559e$var$Uf(0), $f62453a6e3b4559e$var$T = 0, $f62453a6e3b4559e$var$pk = null, $f62453a6e3b4559e$var$rh = 0, $f62453a6e3b4559e$var$qk = 0, $f62453a6e3b4559e$var$rk = 0, $f62453a6e3b4559e$var$sk = null, $f62453a6e3b4559e$var$tk = null, $f62453a6e3b4559e$var$fk = 0, $f62453a6e3b4559e$var$Gj = Infinity, $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Oi = !1, $f62453a6e3b4559e$var$Pi = null, $f62453a6e3b4559e$var$Ri = null, $f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = null, $f62453a6e3b4559e$var$xk = 0, $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, $f62453a6e3b4559e$var$Ak = -1, $f62453a6e3b4559e$var$Bk = 0;
function $f62453a6e3b4559e$var$R() {
    return 0 !== ($f62453a6e3b4559e$var$K & 6) ? $f62453a6e3b4559e$var$B() : -1 !== $f62453a6e3b4559e$var$Ak ? $f62453a6e3b4559e$var$Ak : $f62453a6e3b4559e$var$Ak = $f62453a6e3b4559e$var$B();
}
function $f62453a6e3b4559e$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f62453a6e3b4559e$var$K & 2) && 0 !== $f62453a6e3b4559e$var$Z) return $f62453a6e3b4559e$var$Z & -$f62453a6e3b4559e$var$Z;
    if (null !== $f62453a6e3b4559e$var$Kg.transition) return 0 === $f62453a6e3b4559e$var$Bk && ($f62453a6e3b4559e$var$Bk = $f62453a6e3b4559e$var$yc()), $f62453a6e3b4559e$var$Bk;
    a = $f62453a6e3b4559e$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f62453a6e3b4559e$var$jd(a.type);
    return a;
}
function $f62453a6e3b4559e$var$gi(a, b, c, d) {
    if (50 < $f62453a6e3b4559e$var$yk) throw $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, Error($f62453a6e3b4559e$var$p(185));
    $f62453a6e3b4559e$var$Ac(a, c, d);
    if (0 === ($f62453a6e3b4559e$var$K & 2) || a !== $f62453a6e3b4559e$var$Q) a === $f62453a6e3b4559e$var$Q && (0 === ($f62453a6e3b4559e$var$K & 2) && ($f62453a6e3b4559e$var$qk |= c), 4 === $f62453a6e3b4559e$var$T && $f62453a6e3b4559e$var$Ck(a, $f62453a6e3b4559e$var$Z)), $f62453a6e3b4559e$var$Dk(a, d), 1 === c && 0 === $f62453a6e3b4559e$var$K && 0 === (b.mode & 1) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
}
function $f62453a6e3b4559e$var$Dk(a, b) {
    var c = a.callbackNode;
    $f62453a6e3b4559e$var$wc(a, b);
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) null !== c && $f62453a6e3b4559e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f62453a6e3b4559e$var$bc(c);
        if (1 === b) 0 === a.tag ? $f62453a6e3b4559e$var$ig($f62453a6e3b4559e$var$Ek.bind(null, a)) : $f62453a6e3b4559e$var$hg($f62453a6e3b4559e$var$Ek.bind(null, a)), $f62453a6e3b4559e$var$Jf(function() {
            0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
        }), c = null;
        else {
            switch($f62453a6e3b4559e$var$Dc(d)){
                case 1:
                    c = $f62453a6e3b4559e$var$fc;
                    break;
                case 4:
                    c = $f62453a6e3b4559e$var$gc;
                    break;
                case 16:
                    c = $f62453a6e3b4559e$var$hc;
                    break;
                case 536870912:
                    c = $f62453a6e3b4559e$var$jc;
                    break;
                default:
                    c = $f62453a6e3b4559e$var$hc;
            }
            c = $f62453a6e3b4559e$var$Fk(c, $f62453a6e3b4559e$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f62453a6e3b4559e$var$Gk(a, b) {
    $f62453a6e3b4559e$var$Ak = -1;
    $f62453a6e3b4559e$var$Bk = 0;
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    var c = a.callbackNode;
    if ($f62453a6e3b4559e$var$Hk() && a.callbackNode !== c) return null;
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f62453a6e3b4559e$var$Ik(a, d);
    else {
        b = d;
        var e = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 2;
        var f = $f62453a6e3b4559e$var$Jk();
        if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$Kk(a, b);
        for(;;)try {
            $f62453a6e3b4559e$var$Lk();
            break;
        } catch (h) {
            $f62453a6e3b4559e$var$Mk(a, h);
        }
        $f62453a6e3b4559e$var$$g();
        $f62453a6e3b4559e$var$mk.current = f;
        $f62453a6e3b4559e$var$K = e;
        null !== $f62453a6e3b4559e$var$Y ? b = 0 : ($f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0, b = $f62453a6e3b4559e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f62453a6e3b4559e$var$xc(a), 0 !== e && (d = e, b = $f62453a6e3b4559e$var$Nk(a, e)));
        if (1 === b) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
        if (6 === b) $f62453a6e3b4559e$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f62453a6e3b4559e$var$Ok(e) && (b = $f62453a6e3b4559e$var$Ik(a, d), 2 === b && (f = $f62453a6e3b4559e$var$xc(a), 0 !== f && (d = f, b = $f62453a6e3b4559e$var$Nk(a, f))), 1 === b)) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f62453a6e3b4559e$var$p(345));
                case 2:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 3:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $f62453a6e3b4559e$var$fk + 500 - $f62453a6e3b4559e$var$B(), 10 < b)) {
                        if (0 !== $f62453a6e3b4559e$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f62453a6e3b4559e$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), b);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 4:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f62453a6e3b4559e$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f62453a6e3b4559e$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f62453a6e3b4559e$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), d);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 5:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(329));
            }
        }
    }
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return a.callbackNode === c ? $f62453a6e3b4559e$var$Gk.bind(null, a) : null;
}
function $f62453a6e3b4559e$var$Nk(a, b) {
    var c = $f62453a6e3b4559e$var$sk;
    a.current.memoizedState.isDehydrated && ($f62453a6e3b4559e$var$Kk(a, b).flags |= 256);
    a = $f62453a6e3b4559e$var$Ik(a, b);
    2 !== a && (b = $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$tk = c, null !== b && $f62453a6e3b4559e$var$Fj(b));
    return a;
}
function $f62453a6e3b4559e$var$Fj(a) {
    null === $f62453a6e3b4559e$var$tk ? $f62453a6e3b4559e$var$tk = a : $f62453a6e3b4559e$var$tk.push.apply($f62453a6e3b4559e$var$tk, a);
}
function $f62453a6e3b4559e$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f62453a6e3b4559e$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f62453a6e3b4559e$var$Ck(a, b) {
    b &= ~$f62453a6e3b4559e$var$rk;
    b &= ~$f62453a6e3b4559e$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f62453a6e3b4559e$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f62453a6e3b4559e$var$Ek(a) {
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$uc(a, 0);
    if (0 === (b & 1)) return $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), null;
    var c = $f62453a6e3b4559e$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f62453a6e3b4559e$var$xc(a);
        0 !== d && (b = d, c = $f62453a6e3b4559e$var$Nk(a, d));
    }
    if (1 === c) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, b), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
    if (6 === c) throw Error($f62453a6e3b4559e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return null;
}
function $f62453a6e3b4559e$var$Qk(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f62453a6e3b4559e$var$K = c, 0 === $f62453a6e3b4559e$var$K && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
    }
}
function $f62453a6e3b4559e$var$Rk(a) {
    null !== $f62453a6e3b4559e$var$wk && 0 === $f62453a6e3b4559e$var$wk.tag && 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    var c = $f62453a6e3b4559e$var$ok.transition, d = $f62453a6e3b4559e$var$C;
    try {
        if ($f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, a) return a();
    } finally{
        $f62453a6e3b4559e$var$C = d, $f62453a6e3b4559e$var$ok.transition = c, $f62453a6e3b4559e$var$K = b, 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
    }
}
function $f62453a6e3b4559e$var$Hj() {
    $f62453a6e3b4559e$var$fj = $f62453a6e3b4559e$var$ej.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$ej);
}
function $f62453a6e3b4559e$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f62453a6e3b4559e$var$Gf(c));
    if (null !== $f62453a6e3b4559e$var$Y) for(c = $f62453a6e3b4559e$var$Y.return; null !== c;){
        var d = c;
        $f62453a6e3b4559e$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f62453a6e3b4559e$var$$f();
                break;
            case 3:
                $f62453a6e3b4559e$var$zh();
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
                $f62453a6e3b4559e$var$Eh();
                break;
            case 5:
                $f62453a6e3b4559e$var$Bh(d);
                break;
            case 4:
                $f62453a6e3b4559e$var$zh();
                break;
            case 13:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 19:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 10:
                $f62453a6e3b4559e$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $f62453a6e3b4559e$var$Hj();
        }
        c = c.return;
    }
    $f62453a6e3b4559e$var$Q = a;
    $f62453a6e3b4559e$var$Y = a = $f62453a6e3b4559e$var$Pg(a.current, null);
    $f62453a6e3b4559e$var$Z = $f62453a6e3b4559e$var$fj = b;
    $f62453a6e3b4559e$var$T = 0;
    $f62453a6e3b4559e$var$pk = null;
    $f62453a6e3b4559e$var$rk = $f62453a6e3b4559e$var$qk = $f62453a6e3b4559e$var$rh = 0;
    $f62453a6e3b4559e$var$tk = $f62453a6e3b4559e$var$sk = null;
    if (null !== $f62453a6e3b4559e$var$fh) {
        for(b = 0; b < $f62453a6e3b4559e$var$fh.length; b++)if (c = $f62453a6e3b4559e$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f62453a6e3b4559e$var$fh = null;
    }
    return a;
}
function $f62453a6e3b4559e$var$Mk(a, b) {
    do {
        var c = $f62453a6e3b4559e$var$Y;
        try {
            $f62453a6e3b4559e$var$$g();
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
            if ($f62453a6e3b4559e$var$Ih) {
                for(var d = $f62453a6e3b4559e$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f62453a6e3b4559e$var$Ih = !1;
            }
            $f62453a6e3b4559e$var$Hh = 0;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            $f62453a6e3b4559e$var$nk.current = null;
            if (null === c || null === c.return) {
                $f62453a6e3b4559e$var$T = 1;
                $f62453a6e3b4559e$var$pk = b;
                $f62453a6e3b4559e$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f62453a6e3b4559e$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f62453a6e3b4559e$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $f62453a6e3b4559e$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f62453a6e3b4559e$var$Si(f, l, b);
                            $f62453a6e3b4559e$var$tj();
                            break a;
                        }
                        k = Error($f62453a6e3b4559e$var$p(426));
                    }
                } else if ($f62453a6e3b4559e$var$I && h.mode & 1) {
                    var J = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f62453a6e3b4559e$var$Vi(J, g, h, f, b);
                        $f62453a6e3b4559e$var$Jg($f62453a6e3b4559e$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $f62453a6e3b4559e$var$Ji(k, h);
                4 !== $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 2);
                null === $f62453a6e3b4559e$var$sk ? $f62453a6e3b4559e$var$sk = [
                    f
                ] : $f62453a6e3b4559e$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f62453a6e3b4559e$var$Ni(f, k, b);
                            $f62453a6e3b4559e$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f62453a6e3b4559e$var$Qi(f, h, b);
                                $f62453a6e3b4559e$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f62453a6e3b4559e$var$Sk(c);
        } catch (na) {
            b = na;
            $f62453a6e3b4559e$var$Y === c && null !== c && ($f62453a6e3b4559e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f62453a6e3b4559e$var$Jk() {
    var a = $f62453a6e3b4559e$var$mk.current;
    $f62453a6e3b4559e$var$mk.current = $f62453a6e3b4559e$var$Rh;
    return null === a ? $f62453a6e3b4559e$var$Rh : a;
}
function $f62453a6e3b4559e$var$tj() {
    if (0 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T || 2 === $f62453a6e3b4559e$var$T) $f62453a6e3b4559e$var$T = 4;
    null === $f62453a6e3b4559e$var$Q || 0 === ($f62453a6e3b4559e$var$rh & 268435455) && 0 === ($f62453a6e3b4559e$var$qk & 268435455) || $f62453a6e3b4559e$var$Ck($f62453a6e3b4559e$var$Q, $f62453a6e3b4559e$var$Z);
}
function $f62453a6e3b4559e$var$Ik(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 2;
    var d = $f62453a6e3b4559e$var$Jk();
    if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Kk(a, b);
    for(;;)try {
        $f62453a6e3b4559e$var$Tk();
        break;
    } catch (e) {
        $f62453a6e3b4559e$var$Mk(a, e);
    }
    $f62453a6e3b4559e$var$$g();
    $f62453a6e3b4559e$var$K = c;
    $f62453a6e3b4559e$var$mk.current = d;
    if (null !== $f62453a6e3b4559e$var$Y) throw Error($f62453a6e3b4559e$var$p(261));
    $f62453a6e3b4559e$var$Q = null;
    $f62453a6e3b4559e$var$Z = 0;
    return $f62453a6e3b4559e$var$T;
}
function $f62453a6e3b4559e$var$Tk() {
    for(; null !== $f62453a6e3b4559e$var$Y;)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Lk() {
    for(; null !== $f62453a6e3b4559e$var$Y && !$f62453a6e3b4559e$var$cc();)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Uk(a) {
    var b = $f62453a6e3b4559e$var$Vk(a.alternate, a, $f62453a6e3b4559e$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f62453a6e3b4559e$var$Sk(a) : $f62453a6e3b4559e$var$Y = b;
    $f62453a6e3b4559e$var$nk.current = null;
}
function $f62453a6e3b4559e$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f62453a6e3b4559e$var$Ej(c, b, $f62453a6e3b4559e$var$fj), null !== c) {
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
        } else {
            c = $f62453a6e3b4559e$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f62453a6e3b4559e$var$T = 6;
                $f62453a6e3b4559e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f62453a6e3b4559e$var$Y = b;
            return;
        }
        $f62453a6e3b4559e$var$Y = b = a;
    }while (null !== b);
    0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 5);
}
function $f62453a6e3b4559e$var$Pk(a, b, c) {
    var d = $f62453a6e3b4559e$var$C, e = $f62453a6e3b4559e$var$ok.transition;
    try {
        $f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$Wk(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$ok.transition = e, $f62453a6e3b4559e$var$C = d;
    }
    return null;
}
function $f62453a6e3b4559e$var$Wk(a, b, c, d) {
    do $f62453a6e3b4559e$var$Hk();
    while (null !== $f62453a6e3b4559e$var$wk);
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f62453a6e3b4559e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f62453a6e3b4559e$var$Bc(a, f);
    a === $f62453a6e3b4559e$var$Q && ($f62453a6e3b4559e$var$Y = $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f62453a6e3b4559e$var$vk || ($f62453a6e3b4559e$var$vk = !0, $f62453a6e3b4559e$var$Fk($f62453a6e3b4559e$var$hc, function() {
        $f62453a6e3b4559e$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f62453a6e3b4559e$var$ok.transition;
        $f62453a6e3b4559e$var$ok.transition = null;
        var g = $f62453a6e3b4559e$var$C;
        $f62453a6e3b4559e$var$C = 1;
        var h = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 4;
        $f62453a6e3b4559e$var$nk.current = null;
        $f62453a6e3b4559e$var$Oj(a, c);
        $f62453a6e3b4559e$var$dk(c, a);
        $f62453a6e3b4559e$var$Oe($f62453a6e3b4559e$var$Df);
        $f62453a6e3b4559e$var$dd = !!$f62453a6e3b4559e$var$Cf;
        $f62453a6e3b4559e$var$Df = $f62453a6e3b4559e$var$Cf = null;
        a.current = c;
        $f62453a6e3b4559e$var$hk(c, a, e);
        $f62453a6e3b4559e$var$dc();
        $f62453a6e3b4559e$var$K = h;
        $f62453a6e3b4559e$var$C = g;
        $f62453a6e3b4559e$var$ok.transition = f;
    } else a.current = c;
    $f62453a6e3b4559e$var$vk && ($f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = a, $f62453a6e3b4559e$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($f62453a6e3b4559e$var$Ri = null);
    $f62453a6e3b4559e$var$mc(c.stateNode, d);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f62453a6e3b4559e$var$Oi) throw $f62453a6e3b4559e$var$Oi = !1, a = $f62453a6e3b4559e$var$Pi, $f62453a6e3b4559e$var$Pi = null, a;
    0 !== ($f62453a6e3b4559e$var$xk & 1) && 0 !== a.tag && $f62453a6e3b4559e$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f62453a6e3b4559e$var$zk ? $f62453a6e3b4559e$var$yk++ : ($f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = a) : $f62453a6e3b4559e$var$yk = 0;
    $f62453a6e3b4559e$var$jg();
    return null;
}
function $f62453a6e3b4559e$var$Hk() {
    if (null !== $f62453a6e3b4559e$var$wk) {
        var a = $f62453a6e3b4559e$var$Dc($f62453a6e3b4559e$var$xk), b = $f62453a6e3b4559e$var$ok.transition, c = $f62453a6e3b4559e$var$C;
        try {
            $f62453a6e3b4559e$var$ok.transition = null;
            $f62453a6e3b4559e$var$C = 16 > a ? 16 : a;
            if (null === $f62453a6e3b4559e$var$wk) var d = !1;
            else {
                a = $f62453a6e3b4559e$var$wk;
                $f62453a6e3b4559e$var$wk = null;
                $f62453a6e3b4559e$var$xk = 0;
                if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(331));
                var e = $f62453a6e3b4559e$var$K;
                $f62453a6e3b4559e$var$K |= 4;
                for($f62453a6e3b4559e$var$V = a.current; null !== $f62453a6e3b4559e$var$V;){
                    var f = $f62453a6e3b4559e$var$V, g = f.child;
                    if (0 !== ($f62453a6e3b4559e$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f62453a6e3b4559e$var$V = l; null !== $f62453a6e3b4559e$var$V;){
                                    var m = $f62453a6e3b4559e$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f62453a6e3b4559e$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f62453a6e3b4559e$var$V = q;
                                    else for(; null !== $f62453a6e3b4559e$var$V;){
                                        m = $f62453a6e3b4559e$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f62453a6e3b4559e$var$Sj(m);
                                        if (m === l) {
                                            $f62453a6e3b4559e$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f62453a6e3b4559e$var$V = r;
                                            break;
                                        }
                                        $f62453a6e3b4559e$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f62453a6e3b4559e$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f62453a6e3b4559e$var$V = g;
                    else b: for(; null !== $f62453a6e3b4559e$var$V;){
                        f = $f62453a6e3b4559e$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f62453a6e3b4559e$var$V = x;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f62453a6e3b4559e$var$V = w; null !== $f62453a6e3b4559e$var$V;){
                    g = $f62453a6e3b4559e$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f62453a6e3b4559e$var$V = u;
                    else b: for(g = w; null !== $f62453a6e3b4559e$var$V;){
                        h = $f62453a6e3b4559e$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f62453a6e3b4559e$var$Qj(9, h);
                            }
                        } catch (na) {
                            $f62453a6e3b4559e$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f62453a6e3b4559e$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f62453a6e3b4559e$var$V = F;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = h.return;
                    }
                }
                $f62453a6e3b4559e$var$K = e;
                $f62453a6e3b4559e$var$jg();
                if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot) try {
                    $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot($f62453a6e3b4559e$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$ok.transition = b;
        }
    }
    return !1;
}
function $f62453a6e3b4559e$var$Xk(a, b, c) {
    b = $f62453a6e3b4559e$var$Ji(c, b);
    b = $f62453a6e3b4559e$var$Ni(a, b, 1);
    a = $f62453a6e3b4559e$var$nh(a, b, 1);
    b = $f62453a6e3b4559e$var$R();
    null !== a && ($f62453a6e3b4559e$var$Ac(a, 1, b), $f62453a6e3b4559e$var$Dk(a, b));
}
function $f62453a6e3b4559e$var$W(a, b, c) {
    if (3 === a.tag) $f62453a6e3b4559e$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f62453a6e3b4559e$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(d))) {
                a = $f62453a6e3b4559e$var$Ji(c, a);
                a = $f62453a6e3b4559e$var$Qi(b, a, 1);
                b = $f62453a6e3b4559e$var$nh(b, a, 1);
                a = $f62453a6e3b4559e$var$R();
                null !== b && ($f62453a6e3b4559e$var$Ac(b, 1, a), $f62453a6e3b4559e$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f62453a6e3b4559e$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f62453a6e3b4559e$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $f62453a6e3b4559e$var$Q === a && ($f62453a6e3b4559e$var$Z & c) === c && (4 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$Z & 130023424) === $f62453a6e3b4559e$var$Z && 500 > $f62453a6e3b4559e$var$B() - $f62453a6e3b4559e$var$fk ? $f62453a6e3b4559e$var$Kk(a, 0) : $f62453a6e3b4559e$var$rk |= c);
    $f62453a6e3b4559e$var$Dk(a, b);
}
function $f62453a6e3b4559e$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f62453a6e3b4559e$var$sc, $f62453a6e3b4559e$var$sc <<= 1, 0 === ($f62453a6e3b4559e$var$sc & 130023424) && ($f62453a6e3b4559e$var$sc = 4194304)));
    var c = $f62453a6e3b4559e$var$R();
    a = $f62453a6e3b4559e$var$ih(a, b);
    null !== a && ($f62453a6e3b4559e$var$Ac(a, b, c), $f62453a6e3b4559e$var$Dk(a, c));
}
function $f62453a6e3b4559e$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f62453a6e3b4559e$var$Yk(a, c);
}
function $f62453a6e3b4559e$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f62453a6e3b4559e$var$p(314));
    }
    null !== d && d.delete(b);
    $f62453a6e3b4559e$var$Yk(a, c);
}
var $f62453a6e3b4559e$var$Vk;
$f62453a6e3b4559e$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f62453a6e3b4559e$var$Wf.current) $f62453a6e3b4559e$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$yj(a, b, c);
            $f62453a6e3b4559e$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$I && 0 !== (b.flags & 1048576) && $f62453a6e3b4559e$var$ug(b, $f62453a6e3b4559e$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f62453a6e3b4559e$var$ij(a, b);
            a = b.pendingProps;
            var e = $f62453a6e3b4559e$var$Yf(b, $f62453a6e3b4559e$var$H.current);
            $f62453a6e3b4559e$var$ch(b, c);
            e = $f62453a6e3b4559e$var$Nh(null, b, d, a, e, c);
            var f = $f62453a6e3b4559e$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f62453a6e3b4559e$var$Zf(d) ? (f = !0, $f62453a6e3b4559e$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f62453a6e3b4559e$var$kh(b), e.updater = $f62453a6e3b4559e$var$Ei, b.stateNode = e, e._reactInternals = b, $f62453a6e3b4559e$var$Ii(b, d, a, c), b = $f62453a6e3b4559e$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $f62453a6e3b4559e$var$I && f && $f62453a6e3b4559e$var$vg(b), $f62453a6e3b4559e$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f62453a6e3b4559e$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f62453a6e3b4559e$var$Zk(d);
                a = $f62453a6e3b4559e$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $f62453a6e3b4559e$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f62453a6e3b4559e$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f62453a6e3b4559e$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f62453a6e3b4559e$var$$i(null, b, d, $f62453a6e3b4559e$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($f62453a6e3b4559e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $f62453a6e3b4559e$var$kj(b);
                if (null === a) throw Error($f62453a6e3b4559e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f62453a6e3b4559e$var$lh(a, b);
                $f62453a6e3b4559e$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(423)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(424)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else for($f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.stateNode.containerInfo.firstChild), $f62453a6e3b4559e$var$xg = b, $f62453a6e3b4559e$var$I = !0, $f62453a6e3b4559e$var$zg = null, c = $f62453a6e3b4559e$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f62453a6e3b4559e$var$Ig();
                    if (d === e) {
                        b = $f62453a6e3b4559e$var$Zi(a, b, c);
                        break a;
                    }
                    $f62453a6e3b4559e$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f62453a6e3b4559e$var$Ah(b), null === a && $f62453a6e3b4559e$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f62453a6e3b4559e$var$Ef(d, e) ? g = null : null !== f && $f62453a6e3b4559e$var$Ef(d, f) && (b.flags |= 32), $f62453a6e3b4559e$var$gj(a, b), $f62453a6e3b4559e$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $f62453a6e3b4559e$var$Eg(b), null;
        case 13:
            return $f62453a6e3b4559e$var$oj(a, b, c);
        case 4:
            return $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f62453a6e3b4559e$var$Ug(b, null, d, c) : $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$Yi(a, b, d, e, c);
        case 7:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f62453a6e3b4559e$var$He(f.value, g)) {
                        if (f.children === e.children && !$f62453a6e3b4559e$var$Wf.current) {
                            b = $f62453a6e3b4559e$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f62453a6e3b4559e$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f62453a6e3b4559e$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f62453a6e3b4559e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f62453a6e3b4559e$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f62453a6e3b4559e$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f62453a6e3b4559e$var$ch(b, c), e = $f62453a6e3b4559e$var$eh(e), d = d(e), b.flags |= 1, $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f62453a6e3b4559e$var$Ci(d, b.pendingProps), e = $f62453a6e3b4559e$var$Ci(d.type, e), $f62453a6e3b4559e$var$$i(a, b, d, e, c);
        case 15:
            return $f62453a6e3b4559e$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$ij(a, b), b.tag = 1, $f62453a6e3b4559e$var$Zf(d) ? (a = !0, $f62453a6e3b4559e$var$cg(b)) : a = !1, $f62453a6e3b4559e$var$ch(b, c), $f62453a6e3b4559e$var$Gi(b, d, e), $f62453a6e3b4559e$var$Ii(b, d, e, c), $f62453a6e3b4559e$var$jj(null, b, d, !0, a, c);
        case 19:
            return $f62453a6e3b4559e$var$xj(a, b, c);
        case 22:
            return $f62453a6e3b4559e$var$dj(a, b, c);
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
};
function $f62453a6e3b4559e$var$Fk(a, b) {
    return $f62453a6e3b4559e$var$ac(a, b);
}
function $f62453a6e3b4559e$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f62453a6e3b4559e$var$Bg(a, b, c, d) {
    return new $f62453a6e3b4559e$var$$k(a, b, c, d);
}
function $f62453a6e3b4559e$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f62453a6e3b4559e$var$Zk(a) {
    if ("function" === typeof a) return $f62453a6e3b4559e$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f62453a6e3b4559e$var$Da) return 11;
        if (a === $f62453a6e3b4559e$var$Ga) return 14;
    }
    return 2;
}
function $f62453a6e3b4559e$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $f62453a6e3b4559e$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f62453a6e3b4559e$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f62453a6e3b4559e$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f62453a6e3b4559e$var$ya:
            return $f62453a6e3b4559e$var$Tg(c.children, e, f, b);
        case $f62453a6e3b4559e$var$za:
            g = 8;
            e |= 8;
            break;
        case $f62453a6e3b4559e$var$Aa:
            return a = $f62453a6e3b4559e$var$Bg(12, c, b, e | 2), a.elementType = $f62453a6e3b4559e$var$Aa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ea:
            return a = $f62453a6e3b4559e$var$Bg(13, c, b, e), a.elementType = $f62453a6e3b4559e$var$Ea, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Fa:
            return a = $f62453a6e3b4559e$var$Bg(19, c, b, e), a.elementType = $f62453a6e3b4559e$var$Fa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ia:
            return $f62453a6e3b4559e$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f62453a6e3b4559e$var$Ba:
                    g = 10;
                    break a;
                case $f62453a6e3b4559e$var$Ca:
                    g = 9;
                    break a;
                case $f62453a6e3b4559e$var$Da:
                    g = 11;
                    break a;
                case $f62453a6e3b4559e$var$Ga:
                    g = 14;
                    break a;
                case $f62453a6e3b4559e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f62453a6e3b4559e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f62453a6e3b4559e$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f62453a6e3b4559e$var$Tg(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$pj(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(22, a, d, b);
    a.elementType = $f62453a6e3b4559e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f62453a6e3b4559e$var$Qg(a, b, c) {
    a = $f62453a6e3b4559e$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$Sg(a, b, c) {
    b = $f62453a6e3b4559e$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f62453a6e3b4559e$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f62453a6e3b4559e$var$zc(0);
    this.expirationTimes = $f62453a6e3b4559e$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f62453a6e3b4559e$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f62453a6e3b4559e$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $f62453a6e3b4559e$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f62453a6e3b4559e$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f62453a6e3b4559e$var$kh(f);
    return a;
}
function $f62453a6e3b4559e$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f62453a6e3b4559e$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f62453a6e3b4559e$var$dl(a) {
    if (!a) return $f62453a6e3b4559e$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f62453a6e3b4559e$var$Vb(a) !== a || 1 !== a.tag) throw Error($f62453a6e3b4559e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f62453a6e3b4559e$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f62453a6e3b4559e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f62453a6e3b4559e$var$Zf(c)) return $f62453a6e3b4559e$var$bg(a, c, b);
    }
    return b;
}
function $f62453a6e3b4559e$var$el(a, b, c, d, e, f, g, h, k) {
    a = $f62453a6e3b4559e$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $f62453a6e3b4559e$var$dl(null);
    c = a.current;
    d = $f62453a6e3b4559e$var$R();
    e = $f62453a6e3b4559e$var$yi(c);
    f = $f62453a6e3b4559e$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f62453a6e3b4559e$var$nh(c, f, e);
    a.current.lanes = e;
    $f62453a6e3b4559e$var$Ac(a, e, d);
    $f62453a6e3b4559e$var$Dk(a, d);
    return a;
}
function $f62453a6e3b4559e$var$fl(a, b, c, d) {
    var e = b.current, f = $f62453a6e3b4559e$var$R(), g = $f62453a6e3b4559e$var$yi(e);
    c = $f62453a6e3b4559e$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f62453a6e3b4559e$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f62453a6e3b4559e$var$nh(e, b, g);
    null !== a && ($f62453a6e3b4559e$var$gi(a, e, g, f), $f62453a6e3b4559e$var$oh(a, e, g));
    return g;
}
function $f62453a6e3b4559e$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f62453a6e3b4559e$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f62453a6e3b4559e$var$il(a, b) {
    $f62453a6e3b4559e$var$hl(a, b);
    (a = a.alternate) && $f62453a6e3b4559e$var$hl(a, b);
}
function $f62453a6e3b4559e$var$jl() {
    return null;
}
var $f62453a6e3b4559e$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f62453a6e3b4559e$var$ll(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.render = $f62453a6e3b4559e$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f62453a6e3b4559e$var$p(409));
    $f62453a6e3b4559e$var$fl(a, b, null, null);
};
$f62453a6e3b4559e$var$ml.prototype.unmount = $f62453a6e3b4559e$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f62453a6e3b4559e$var$Rk(function() {
            $f62453a6e3b4559e$var$fl(null, a, null, null);
        });
        b[$f62453a6e3b4559e$var$uf] = null;
    }
};
function $f62453a6e3b4559e$var$ml(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f62453a6e3b4559e$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f62453a6e3b4559e$var$Qc.length && 0 !== b && b < $f62453a6e3b4559e$var$Qc[c].priority; c++);
        $f62453a6e3b4559e$var$Qc.splice(c, 0, a);
        0 === c && $f62453a6e3b4559e$var$Vc(a);
    }
};
function $f62453a6e3b4559e$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f62453a6e3b4559e$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f62453a6e3b4559e$var$pl() {}
function $f62453a6e3b4559e$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                f.call(a);
            };
        }
        var g = $f62453a6e3b4559e$var$el(b, d, a, 0, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
        a._reactRootContainer = g;
        a[$f62453a6e3b4559e$var$uf] = g.current;
        $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f62453a6e3b4559e$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f62453a6e3b4559e$var$gl(k);
            h.call(a);
        };
    }
    var k = $f62453a6e3b4559e$var$bl(a, 0, !1, null, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
    a._reactRootContainer = k;
    a[$f62453a6e3b4559e$var$uf] = k.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$fl(b, k, c, d);
    });
    return k;
}
function $f62453a6e3b4559e$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                h.call(a);
            };
        }
        $f62453a6e3b4559e$var$fl(b, g, a, e);
    } else g = $f62453a6e3b4559e$var$ql(c, b, a, e, d);
    return $f62453a6e3b4559e$var$gl(g);
}
$f62453a6e3b4559e$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f62453a6e3b4559e$var$tc(b.pendingLanes);
                0 !== c && ($f62453a6e3b4559e$var$Cc(b, c | 1), $f62453a6e3b4559e$var$Dk(b, $f62453a6e3b4559e$var$B()), 0 === ($f62453a6e3b4559e$var$K & 6) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$jg()));
            }
            break;
        case 13:
            $f62453a6e3b4559e$var$Rk(function() {
                var b = $f62453a6e3b4559e$var$ih(a, 1);
                if (null !== b) {
                    var c = $f62453a6e3b4559e$var$R();
                    $f62453a6e3b4559e$var$gi(b, a, 1, c);
                }
            }), $f62453a6e3b4559e$var$il(a, 1);
    }
};
$f62453a6e3b4559e$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$ih(a, 134217728);
        if (null !== b) {
            var c = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(b, a, 134217728, c);
        }
        $f62453a6e3b4559e$var$il(a, 134217728);
    }
};
$f62453a6e3b4559e$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$yi(a), c = $f62453a6e3b4559e$var$ih(a, b);
        if (null !== c) {
            var d = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(c, a, b, d);
        }
        $f62453a6e3b4559e$var$il(a, b);
    }
};
$f62453a6e3b4559e$var$Hc = function() {
    return $f62453a6e3b4559e$var$C;
};
$f62453a6e3b4559e$var$Ic = function(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    try {
        return $f62453a6e3b4559e$var$C = a, b();
    } finally{
        $f62453a6e3b4559e$var$C = c;
    }
};
$f62453a6e3b4559e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f62453a6e3b4559e$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f62453a6e3b4559e$var$Db(d);
                        if (!e) throw Error($f62453a6e3b4559e$var$p(90));
                        $f62453a6e3b4559e$var$Wa(d);
                        $f62453a6e3b4559e$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f62453a6e3b4559e$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f62453a6e3b4559e$var$fb(a, !!c.multiple, b, !1);
    }
};
$f62453a6e3b4559e$var$Gb = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$var$Hb = $f62453a6e3b4559e$var$Rk;
var $f62453a6e3b4559e$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $f62453a6e3b4559e$var$Cb,
        $f62453a6e3b4559e$var$ue,
        $f62453a6e3b4559e$var$Db,
        $f62453a6e3b4559e$var$Eb,
        $f62453a6e3b4559e$var$Fb,
        $f62453a6e3b4559e$var$Qk
    ]
}, $f62453a6e3b4559e$var$tl = {
    findFiberByHostInstance: $f62453a6e3b4559e$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $f62453a6e3b4559e$var$ul = {
    bundleType: $f62453a6e3b4559e$var$tl.bundleType,
    version: $f62453a6e3b4559e$var$tl.version,
    rendererPackageName: $f62453a6e3b4559e$var$tl.rendererPackageName,
    rendererConfig: $f62453a6e3b4559e$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f62453a6e3b4559e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f62453a6e3b4559e$var$tl.findFiberByHostInstance || $f62453a6e3b4559e$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f62453a6e3b4559e$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f62453a6e3b4559e$var$vl.isDisabled && $f62453a6e3b4559e$var$vl.supportsFiber) try {
        $f62453a6e3b4559e$var$kc = $f62453a6e3b4559e$var$vl.inject($f62453a6e3b4559e$var$ul), $f62453a6e3b4559e$var$lc = $f62453a6e3b4559e$var$vl;
    } catch (a) {}
}
$f62453a6e3b4559e$export$ae55be85d98224ed = $f62453a6e3b4559e$var$sl;
$f62453a6e3b4559e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f62453a6e3b4559e$var$nl(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$cl(a, b, null, c);
};
$f62453a6e3b4559e$export$882461b6382ed46c = function(a, b) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(299));
    var c = !1, d = "", e = $f62453a6e3b4559e$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f62453a6e3b4559e$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f62453a6e3b4559e$var$ll(b);
};
$f62453a6e3b4559e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f62453a6e3b4559e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f62453a6e3b4559e$var$p(268, a));
    }
    a = $f62453a6e3b4559e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f62453a6e3b4559e$export$cd75ccfd720a3cd4 = function(a) {
    return $f62453a6e3b4559e$var$Rk(a);
};
$f62453a6e3b4559e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !0, c);
};
$f62453a6e3b4559e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f62453a6e3b4559e$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f62453a6e3b4559e$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f62453a6e3b4559e$var$ml(b);
};
$f62453a6e3b4559e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !1, c);
};
$f62453a6e3b4559e$export$502457920280e6be = function(a) {
    if (!$f62453a6e3b4559e$var$ol(a)) throw Error($f62453a6e3b4559e$var$p(40));
    return a._reactRootContainer ? ($f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f62453a6e3b4559e$var$uf] = null;
        });
    }), !0) : !1;
};
$f62453a6e3b4559e$export$c78a37762a8d58e1 = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f62453a6e3b4559e$var$ol(c)) throw Error($f62453a6e3b4559e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f62453a6e3b4559e$var$p(38));
    return $f62453a6e3b4559e$var$rl(a, b, c, !1, d);
};
$f62453a6e3b4559e$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7zDBh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1uxJf"));

});
parcelRegister("1uxJf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1162c1a406d3f6f8$export$c4744153514ff05d, (v) => $1162c1a406d3f6f8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7, (v) => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1162c1a406d3f6f8$export$e26fe2ed2fa76875, (v) => $1162c1a406d3f6f8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1162c1a406d3f6f8$export$502329bbf4b505b1, (v) => $1162c1a406d3f6f8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1162c1a406d3f6f8$export$6e3807111c4874c4, (v) => $1162c1a406d3f6f8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1162c1a406d3f6f8$export$c27134553091fb3a, (v) => $1162c1a406d3f6f8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2, (v) => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1162c1a406d3f6f8$export$b00a404bbd5edef2, (v) => $1162c1a406d3f6f8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1162c1a406d3f6f8$export$8352ce38b91d0c62, (v) => $1162c1a406d3f6f8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1162c1a406d3f6f8$export$d66a1c1c77bd778b, (v) => $1162c1a406d3f6f8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1162c1a406d3f6f8$export$d3dfb8e4810cb555, (v) => $1162c1a406d3f6f8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1162c1a406d3f6f8$export$839f9183b0465a69, (v) => $1162c1a406d3f6f8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1162c1a406d3f6f8$export$72fdf0e06517287b, (v) => $1162c1a406d3f6f8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1162c1a406d3f6f8$export$4b844e58a3e414b4, (v) => $1162c1a406d3f6f8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1162c1a406d3f6f8$export$816d2913ae6b83b1, (v) => $1162c1a406d3f6f8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1162c1a406d3f6f8$export$61bcfe829111a1d0, (v) => $1162c1a406d3f6f8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f, (v) => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1162c1a406d3f6f8$export$b5836b71941fa3ed, (v) => $1162c1a406d3f6f8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1162c1a406d3f6f8$export$cf845f2c119da08a, (v) => $1162c1a406d3f6f8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1162c1a406d3f6f8$export$c4744153514ff05d;
var $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7;
var $1162c1a406d3f6f8$export$e26fe2ed2fa76875;
var $1162c1a406d3f6f8$export$502329bbf4b505b1;
var $1162c1a406d3f6f8$export$6e3807111c4874c4;
var $1162c1a406d3f6f8$export$c27134553091fb3a;
var $1162c1a406d3f6f8$export$33ee1acdc04fd2a2;
var $1162c1a406d3f6f8$export$b00a404bbd5edef2;
var $1162c1a406d3f6f8$export$8352ce38b91d0c62;
var $1162c1a406d3f6f8$export$d66a1c1c77bd778b;
var $1162c1a406d3f6f8$export$d3dfb8e4810cb555;
var $1162c1a406d3f6f8$export$839f9183b0465a69;
var $1162c1a406d3f6f8$export$72fdf0e06517287b;
var $1162c1a406d3f6f8$export$4b844e58a3e414b4;
var $1162c1a406d3f6f8$export$816d2913ae6b83b1;
var $1162c1a406d3f6f8$export$61bcfe829111a1d0;
var $1162c1a406d3f6f8$export$7ee8c9beb337bc3f;
var $1162c1a406d3f6f8$export$b5836b71941fa3ed;
var $1162c1a406d3f6f8$export$cf845f2c119da08a;
'use strict';
function $1162c1a406d3f6f8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1162c1a406d3f6f8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1162c1a406d3f6f8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1162c1a406d3f6f8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1162c1a406d3f6f8$var$g(C, c)) n < e && 0 > $1162c1a406d3f6f8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1162c1a406d3f6f8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1162c1a406d3f6f8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1162c1a406d3f6f8$var$l = performance;
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$l.now();
    };
} else {
    var $1162c1a406d3f6f8$var$p = Date, $1162c1a406d3f6f8$var$q = $1162c1a406d3f6f8$var$p.now();
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$p.now() - $1162c1a406d3f6f8$var$q;
    };
}
var $1162c1a406d3f6f8$var$r = [], $1162c1a406d3f6f8$var$t = [], $1162c1a406d3f6f8$var$u = 1, $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = 3, $1162c1a406d3f6f8$var$z = !1, $1162c1a406d3f6f8$var$A = !1, $1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$D = "function" === typeof setTimeout ? setTimeout : null, $1162c1a406d3f6f8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1162c1a406d3f6f8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1162c1a406d3f6f8$var$G(a) {
    for(var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t); null !== b;){
        if (null === b.callback) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t);
        else if (b.startTime <= a) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t), b.sortIndex = b.expirationTime, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, b);
        else break;
        b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
    }
}
function $1162c1a406d3f6f8$var$H(a) {
    $1162c1a406d3f6f8$var$B = !1;
    $1162c1a406d3f6f8$var$G(a);
    if (!$1162c1a406d3f6f8$var$A) {
        if (null !== $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r)) $1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J);
        else {
            var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== b && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, b.startTime - a);
        }
    }
}
function $1162c1a406d3f6f8$var$J(a, b) {
    $1162c1a406d3f6f8$var$A = !1;
    $1162c1a406d3f6f8$var$B && ($1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1);
    $1162c1a406d3f6f8$var$z = !0;
    var c = $1162c1a406d3f6f8$var$y;
    try {
        $1162c1a406d3f6f8$var$G(b);
        for($1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r); null !== $1162c1a406d3f6f8$var$v && (!($1162c1a406d3f6f8$var$v.expirationTime > b) || a && !$1162c1a406d3f6f8$var$M());){
            var d = $1162c1a406d3f6f8$var$v.callback;
            if ("function" === typeof d) {
                $1162c1a406d3f6f8$var$v.callback = null;
                $1162c1a406d3f6f8$var$y = $1162c1a406d3f6f8$var$v.priorityLevel;
                var e = d($1162c1a406d3f6f8$var$v.expirationTime <= b);
                b = $1162c1a406d3f6f8$export$c4744153514ff05d();
                "function" === typeof e ? $1162c1a406d3f6f8$var$v.callback = e : $1162c1a406d3f6f8$var$v === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
                $1162c1a406d3f6f8$var$G(b);
            } else $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
            $1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
        }
        if (null !== $1162c1a406d3f6f8$var$v) var w = !0;
        else {
            var m = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== m && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = c, $1162c1a406d3f6f8$var$z = !1;
    }
}
var $1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null, $1162c1a406d3f6f8$var$L = -1, $1162c1a406d3f6f8$var$P = 5, $1162c1a406d3f6f8$var$Q = -1;
function $1162c1a406d3f6f8$var$M() {
    return $1162c1a406d3f6f8$export$c4744153514ff05d() - $1162c1a406d3f6f8$var$Q < $1162c1a406d3f6f8$var$P ? !1 : !0;
}
function $1162c1a406d3f6f8$var$R() {
    if (null !== $1162c1a406d3f6f8$var$O) {
        var a = $1162c1a406d3f6f8$export$c4744153514ff05d();
        $1162c1a406d3f6f8$var$Q = a;
        var b = !0;
        try {
            b = $1162c1a406d3f6f8$var$O(!0, a);
        } finally{
            b ? $1162c1a406d3f6f8$var$S() : ($1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null);
        }
    } else $1162c1a406d3f6f8$var$N = !1;
}
var $1162c1a406d3f6f8$var$S;
if ("function" === typeof $1162c1a406d3f6f8$var$F) $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$F($1162c1a406d3f6f8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1162c1a406d3f6f8$var$T = new MessageChannel, $1162c1a406d3f6f8$var$U = $1162c1a406d3f6f8$var$T.port2;
    $1162c1a406d3f6f8$var$T.port1.onmessage = $1162c1a406d3f6f8$var$R;
    $1162c1a406d3f6f8$var$S = function() {
        $1162c1a406d3f6f8$var$U.postMessage(null);
    };
} else $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$D($1162c1a406d3f6f8$var$R, 0);
};
function $1162c1a406d3f6f8$var$I(a) {
    $1162c1a406d3f6f8$var$O = a;
    $1162c1a406d3f6f8$var$N || ($1162c1a406d3f6f8$var$N = !0, $1162c1a406d3f6f8$var$S());
}
function $1162c1a406d3f6f8$var$K(a, b) {
    $1162c1a406d3f6f8$var$L = $1162c1a406d3f6f8$var$D(function() {
        a($1162c1a406d3f6f8$export$c4744153514ff05d());
    }, b);
}
$1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = 5;
$1162c1a406d3f6f8$export$e26fe2ed2fa76875 = 1;
$1162c1a406d3f6f8$export$502329bbf4b505b1 = 4;
$1162c1a406d3f6f8$export$6e3807111c4874c4 = 3;
$1162c1a406d3f6f8$export$c27134553091fb3a = null;
$1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = 2;
$1162c1a406d3f6f8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1162c1a406d3f6f8$export$8352ce38b91d0c62 = function() {
    $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J));
};
$1162c1a406d3f6f8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1162c1a406d3f6f8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1162c1a406d3f6f8$export$d3dfb8e4810cb555 = function() {
    return $1162c1a406d3f6f8$var$y;
};
$1162c1a406d3f6f8$export$839f9183b0465a69 = function() {
    return $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
};
$1162c1a406d3f6f8$export$72fdf0e06517287b = function(a) {
    switch($1162c1a406d3f6f8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1162c1a406d3f6f8$var$y;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = b;
    try {
        return a();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$4b844e58a3e414b4 = function() {};
$1162c1a406d3f6f8$export$816d2913ae6b83b1 = function() {};
$1162c1a406d3f6f8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = a;
    try {
        return b();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1162c1a406d3f6f8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1162c1a406d3f6f8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$t, a), null === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && a === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t) && ($1162c1a406d3f6f8$var$B ? ($1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1) : $1162c1a406d3f6f8$var$B = !0, $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, c - d))) : (a.sortIndex = e, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, a), $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J)));
    return a;
};
$1162c1a406d3f6f8$export$b5836b71941fa3ed = $1162c1a406d3f6f8$var$M;
$1162c1a406d3f6f8$export$cf845f2c119da08a = function(a) {
    var b = $1162c1a406d3f6f8$var$y;
    return function() {
        var c = $1162c1a406d3f6f8$var$y;
        $1162c1a406d3f6f8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1162c1a406d3f6f8$var$y = c;
        }
    };
};

});



parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


parcelRegister("fFeqb", function(module, exports) {
'use strict';
module.exports = ()=>{
    const ret = {};
    ret.promise = new Promise((resolve, reject)=>{
        ret.resolve = resolve;
        ret.reject = reject;
    });
    return ret;
};

});

var $14024a6d51999040$exports = {};
'use strict';

$14024a6d51999040$exports = (parcelRequire("aPfka"));


parcelRequire("aqdBs");
var $c920eedc27eaef64$export$882461b6382ed46c;
var $c920eedc27eaef64$export$757ceba2d55c277e;
'use strict';
var $e813d4480671d45c$exports = {};
'use strict';
function $e813d4480671d45c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e813d4480671d45c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e813d4480671d45c$var$checkDCE();

$e813d4480671d45c$exports = (parcelRequire("l8cRS"));


var $c920eedc27eaef64$var$i;
$c920eedc27eaef64$export$882461b6382ed46c = $e813d4480671d45c$exports.createRoot;
$c920eedc27eaef64$export$757ceba2d55c277e = $e813d4480671d45c$exports.hydrateRoot;



parcelRequire("aqdBs");
/**
 * react-router v7.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aqdBs = parcelRequire("aqdBs");
var $341c792fffde747f$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.12.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-router/dist/development/chunk-EPOLDU6W.mjs"
});
var $341c792fffde747f$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $341c792fffde747f$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $341c792fffde747f$var$__typeError("Cannot " + msg);
var $341c792fffde747f$var$__privateGet = (obj, member, getter)=>($341c792fffde747f$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $341c792fffde747f$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $341c792fffde747f$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $341c792fffde747f$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($341c792fffde747f$export$e19cd5f9376f8cee || {});
var $341c792fffde747f$var$PopStateEventType = "popstate";
function $341c792fffde747f$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $341c792fffde747f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $341c792fffde747f$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $341c792fffde747f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $341c792fffde747f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $341c792fffde747f$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $341c792fffde747f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $341c792fffde747f$export$fe53371bee54353d(to);
    }
    return $341c792fffde747f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $341c792fffde747f$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $341c792fffde747f$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $341c792fffde747f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $341c792fffde747f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $341c792fffde747f$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $341c792fffde747f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $341c792fffde747f$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $341c792fffde747f$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $341c792fffde747f$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $341c792fffde747f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $341c792fffde747f$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $341c792fffde747f$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $341c792fffde747f$var$createKey()
    };
    return location;
}
function $341c792fffde747f$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $341c792fffde747f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $341c792fffde747f$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $341c792fffde747f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $341c792fffde747f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $341c792fffde747f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $341c792fffde747f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $341c792fffde747f$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($341c792fffde747f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($341c792fffde747f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $341c792fffde747f$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $341c792fffde747f$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $341c792fffde747f$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $341c792fffde747f$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $341c792fffde747f$var$_map;
var $341c792fffde747f$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $341c792fffde747f$var$__privateAdd(this, $341c792fffde747f$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($341c792fffde747f$var$__privateGet(this, $341c792fffde747f$var$_map).has(context)) return $341c792fffde747f$var$__privateGet(this, $341c792fffde747f$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $341c792fffde747f$var$__privateGet(this, $341c792fffde747f$var$_map).set(context, value);
    }
};
$341c792fffde747f$var$_map = new WeakMap();
var $341c792fffde747f$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $341c792fffde747f$var$isUnsupportedLazyRouteObjectKey(key) {
    return $341c792fffde747f$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $341c792fffde747f$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $341c792fffde747f$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $341c792fffde747f$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $341c792fffde747f$var$isIndexRoute(route) {
    return route.index === true;
}
function $341c792fffde747f$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $341c792fffde747f$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $341c792fffde747f$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($341c792fffde747f$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $341c792fffde747f$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $341c792fffde747f$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $341c792fffde747f$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $341c792fffde747f$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $341c792fffde747f$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $341c792fffde747f$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $341c792fffde747f$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $341c792fffde747f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $341c792fffde747f$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $341c792fffde747f$var$flattenRoutes(routes);
    $341c792fffde747f$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $341c792fffde747f$var$decodePath(pathname);
        matches = $341c792fffde747f$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $341c792fffde747f$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $341c792fffde747f$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $341c792fffde747f$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $341c792fffde747f$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $341c792fffde747f$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $341c792fffde747f$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $341c792fffde747f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $341c792fffde747f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $341c792fffde747f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $341c792fffde747f$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $341c792fffde747f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $341c792fffde747f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $341c792fffde747f$var$paramRe = /^:[\w-]+$/;
var $341c792fffde747f$var$dynamicSegmentValue = 3;
var $341c792fffde747f$var$indexRouteValue = 2;
var $341c792fffde747f$var$emptySegmentValue = 1;
var $341c792fffde747f$var$staticSegmentValue = 10;
var $341c792fffde747f$var$splatPenalty = -2;
var $341c792fffde747f$var$isSplat = (s)=>s === "*";
function $341c792fffde747f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($341c792fffde747f$var$isSplat)) initialScore += $341c792fffde747f$var$splatPenalty;
    if (index) initialScore += $341c792fffde747f$var$indexRouteValue;
    return segments.filter((s)=>!$341c792fffde747f$var$isSplat(s)).reduce((score, segment)=>score + ($341c792fffde747f$var$paramRe.test(segment) ? $341c792fffde747f$var$dynamicSegmentValue : segment === "" ? $341c792fffde747f$var$emptySegmentValue : $341c792fffde747f$var$staticSegmentValue), initialScore);
}
function $341c792fffde747f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $341c792fffde747f$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $341c792fffde747f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $341c792fffde747f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $341c792fffde747f$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $341c792fffde747f$var$normalizePathname($341c792fffde747f$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $341c792fffde747f$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $341c792fffde747f$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $341c792fffde747f$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $341c792fffde747f$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $341c792fffde747f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $341c792fffde747f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $341c792fffde747f$var$compilePath(path, caseSensitive = false, end = true) {
    $341c792fffde747f$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $341c792fffde747f$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $341c792fffde747f$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $341c792fffde747f$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $341c792fffde747f$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $341c792fffde747f$var$joinPaths([
        basename,
        pathname
    ]);
}
var $341c792fffde747f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $341c792fffde747f$var$isAbsoluteUrl = (url)=>$341c792fffde747f$var$ABSOLUTE_URL_REGEX.test(url);
function $341c792fffde747f$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $341c792fffde747f$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($341c792fffde747f$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $341c792fffde747f$var$warning(false, `Pathnames cannot have embedded double slashes - normalizing ${oldPathname} -> ${toPathname}`);
            }
            if (toPathname.startsWith("/")) pathname = $341c792fffde747f$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $341c792fffde747f$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $341c792fffde747f$var$normalizeSearch(search),
        hash: $341c792fffde747f$var$normalizeHash(hash)
    };
}
function $341c792fffde747f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $341c792fffde747f$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $341c792fffde747f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $341c792fffde747f$var$getResolveToMatches(matches) {
    let pathMatches = $341c792fffde747f$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $341c792fffde747f$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $341c792fffde747f$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $341c792fffde747f$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $341c792fffde747f$var$getInvalidPathError("?", "pathname", "search", to));
        $341c792fffde747f$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $341c792fffde747f$var$getInvalidPathError("#", "pathname", "hash", to));
        $341c792fffde747f$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $341c792fffde747f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $341c792fffde747f$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $341c792fffde747f$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $341c792fffde747f$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $341c792fffde747f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $341c792fffde747f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $341c792fffde747f$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $341c792fffde747f$export$4051a07651545597(data2, init) {
    return new $341c792fffde747f$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $341c792fffde747f$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $341c792fffde747f$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $341c792fffde747f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $341c792fffde747f$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $341c792fffde747f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $341c792fffde747f$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $341c792fffde747f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $341c792fffde747f$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
var $341c792fffde747f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $341c792fffde747f$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$341c792fffde747f$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($341c792fffde747f$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $341c792fffde747f$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $341c792fffde747f$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $341c792fffde747f$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $341c792fffde747f$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $341c792fffde747f$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $341c792fffde747f$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$341c792fffde747f$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $341c792fffde747f$var$wrapImpl(aggregated[key], original, (...args)=>$341c792fffde747f$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$341c792fffde747f$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$341c792fffde747f$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $341c792fffde747f$var$wrapImpl(aggregated.middleware, original, (...args)=>$341c792fffde747f$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$341c792fffde747f$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $341c792fffde747f$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$341c792fffde747f$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $341c792fffde747f$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $341c792fffde747f$export$fe53371bee54353d(to) : ".",
                ...$341c792fffde747f$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$341c792fffde747f$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$341c792fffde747f$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $341c792fffde747f$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$341c792fffde747f$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$341c792fffde747f$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $341c792fffde747f$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $341c792fffde747f$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $341c792fffde747f$var$getReadonlyRequest(request),
            context: context != null ? $341c792fffde747f$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $341c792fffde747f$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $341c792fffde747f$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $341c792fffde747f$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $341c792fffde747f$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $341c792fffde747f$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $341c792fffde747f$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $341c792fffde747f$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $341c792fffde747f$var$getReadonlyContext(context)
    };
}
function $341c792fffde747f$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $341c792fffde747f$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $341c792fffde747f$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $341c792fffde747f$var$getReadonlyContext(context) {
    if ($341c792fffde747f$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $341c792fffde747f$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $341c792fffde747f$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $341c792fffde747f$var$objectProtoNames;
}
// lib/router/router.ts
var $341c792fffde747f$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $341c792fffde747f$var$validMutationMethods = new Set($341c792fffde747f$var$validMutationMethodsArr);
var $341c792fffde747f$var$validRequestMethodsArr = [
    "GET",
    ...$341c792fffde747f$var$validMutationMethodsArr
];
var $341c792fffde747f$var$validRequestMethods = new Set($341c792fffde747f$var$validRequestMethodsArr);
var $341c792fffde747f$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $341c792fffde747f$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $341c792fffde747f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $341c792fffde747f$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $341c792fffde747f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $341c792fffde747f$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $341c792fffde747f$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $341c792fffde747f$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $341c792fffde747f$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $341c792fffde747f$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $341c792fffde747f$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$341c792fffde747f$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $341c792fffde747f$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $341c792fffde747f$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $341c792fffde747f$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $341c792fffde747f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $341c792fffde747f$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$341c792fffde747f$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$341c792fffde747f$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$341c792fffde747f$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $341c792fffde747f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $341c792fffde747f$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $341c792fffde747f$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $341c792fffde747f$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$341c792fffde747f$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $341c792fffde747f$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $341c792fffde747f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $341c792fffde747f$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $341c792fffde747f$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $341c792fffde747f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $341c792fffde747f$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $341c792fffde747f$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $341c792fffde747f$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $341c792fffde747f$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $341c792fffde747f$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $341c792fffde747f$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $341c792fffde747f$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $341c792fffde747f$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $341c792fffde747f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $341c792fffde747f$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $341c792fffde747f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $341c792fffde747f$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $341c792fffde747f$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $341c792fffde747f$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($341c792fffde747f$var$isErrorResult(result) && $341c792fffde747f$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $341c792fffde747f$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $341c792fffde747f$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$341c792fffde747f$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $341c792fffde747f$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $341c792fffde747f$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $341c792fffde747f$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $341c792fffde747f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $341c792fffde747f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($341c792fffde747f$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $341c792fffde747f$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($341c792fffde747f$var$isErrorResult(result)) {
            let boundaryMatch = $341c792fffde747f$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $341c792fffde747f$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $341c792fffde747f$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $341c792fffde747f$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $341c792fffde747f$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $341c792fffde747f$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $341c792fffde747f$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$341c792fffde747f$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $341c792fffde747f$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $341c792fffde747f$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $341c792fffde747f$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$341c792fffde747f$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $341c792fffde747f$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $341c792fffde747f$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $341c792fffde747f$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $341c792fffde747f$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $341c792fffde747f$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $341c792fffde747f$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $341c792fffde747f$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $341c792fffde747f$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $341c792fffde747f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $341c792fffde747f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $341c792fffde747f$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $341c792fffde747f$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($341c792fffde747f$var$isRedirectResult(actionResult) || $341c792fffde747f$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $341c792fffde747f$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($341c792fffde747f$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $341c792fffde747f$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $341c792fffde747f$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($341c792fffde747f$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $341c792fffde747f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $341c792fffde747f$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $341c792fffde747f$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $341c792fffde747f$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $341c792fffde747f$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $341c792fffde747f$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $341c792fffde747f$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $341c792fffde747f$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $341c792fffde747f$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $341c792fffde747f$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $341c792fffde747f$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $341c792fffde747f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $341c792fffde747f$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $341c792fffde747f$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $341c792fffde747f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $341c792fffde747f$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $341c792fffde747f$var$getDoneFetcher(void 0));
            return;
        }
        if ($341c792fffde747f$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $341c792fffde747f$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($341c792fffde747f$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $341c792fffde747f$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $341c792fffde747f$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $341c792fffde747f$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $341c792fffde747f$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($341c792fffde747f$var$isAbsoluteUrl(location)) {
                const url = $341c792fffde747f$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $341c792fffde747f$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $341c792fffde747f$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($341c792fffde747f$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $341c792fffde747f$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $341c792fffde747f$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $341c792fffde747f$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$341c792fffde747f$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($341c792fffde747f$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $341c792fffde747f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $341c792fffde747f$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $341c792fffde747f$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $341c792fffde747f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $341c792fffde747f$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $341c792fffde747f$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $341c792fffde747f$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $341c792fffde747f$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $341c792fffde747f$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $341c792fffde747f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $341c792fffde747f$export$386d57f03f0b2883;
        $341c792fffde747f$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $341c792fffde747f$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $341c792fffde747f$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $341c792fffde747f$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $341c792fffde747f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$341c792fffde747f$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $341c792fffde747f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $341c792fffde747f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $341c792fffde747f$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $341c792fffde747f$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $341c792fffde747f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $341c792fffde747f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $341c792fffde747f$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $341c792fffde747f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $341c792fffde747f$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $341c792fffde747f$export$3336b097a6fbc59a(routes, opts) {
    $341c792fffde747f$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $341c792fffde747f$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$341c792fffde747f$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $341c792fffde747f$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $341c792fffde747f$var$createLocation("", $341c792fffde747f$export$fe53371bee54353d(url), null, "default");
        let matches = $341c792fffde747f$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $341c792fffde747f$export$b8d3e69d4b3eff04();
        if (!$341c792fffde747f$var$isValidMethod(method) && method !== "HEAD") {
            let error = $341c792fffde747f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $341c792fffde747f$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $341c792fffde747f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $341c792fffde747f$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $341c792fffde747f$export$f5708dca728d7177(requestContext instanceof $341c792fffde747f$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $341c792fffde747f$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $341c792fffde747f$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $341c792fffde747f$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($341c792fffde747f$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($341c792fffde747f$export$6e80290866a84dd4(error)) return error;
                    if ($341c792fffde747f$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $341c792fffde747f$export$f2680fa305b734ca(error.status, error.statusText, await $341c792fffde747f$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($341c792fffde747f$export$e0163cfdf7bc9cfa(error)) error = $341c792fffde747f$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $341c792fffde747f$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $341c792fffde747f$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $341c792fffde747f$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $341c792fffde747f$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $341c792fffde747f$export$f5708dca728d7177($341c792fffde747f$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($341c792fffde747f$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($341c792fffde747f$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $341c792fffde747f$var$createLocation("", $341c792fffde747f$export$fe53371bee54353d(url), null, "default");
        let matches = $341c792fffde747f$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $341c792fffde747f$export$b8d3e69d4b3eff04();
        if (!$341c792fffde747f$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $341c792fffde747f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $341c792fffde747f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $341c792fffde747f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $341c792fffde747f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $341c792fffde747f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $341c792fffde747f$export$f5708dca728d7177(requestContext instanceof $341c792fffde747f$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $341c792fffde747f$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $341c792fffde747f$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $341c792fffde747f$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $341c792fffde747f$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($341c792fffde747f$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($341c792fffde747f$var$dataWithResponseInitToResponse(error));
                if ($341c792fffde747f$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($341c792fffde747f$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $341c792fffde747f$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($341c792fffde747f$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $341c792fffde747f$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $341c792fffde747f$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($341c792fffde747f$var$isDataStrategyResult(e) && $341c792fffde747f$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($341c792fffde747f$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $341c792fffde747f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $341c792fffde747f$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($341c792fffde747f$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($341c792fffde747f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($341c792fffde747f$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $341c792fffde747f$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $341c792fffde747f$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($341c792fffde747f$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $341c792fffde747f$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $341c792fffde747f$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $341c792fffde747f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $341c792fffde747f$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $341c792fffde747f$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $341c792fffde747f$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $341c792fffde747f$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $341c792fffde747f$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $341c792fffde747f$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $341c792fffde747f$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $341c792fffde747f$var$callDataStrategyImpl(dataStrategy || $341c792fffde747f$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($341c792fffde747f$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $341c792fffde747f$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($341c792fffde747f$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($341c792fffde747f$export$e0163cfdf7bc9cfa(result.result)) throw $341c792fffde747f$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $341c792fffde747f$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $341c792fffde747f$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $341c792fffde747f$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $341c792fffde747f$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $341c792fffde747f$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $341c792fffde747f$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $341c792fffde747f$var$resolveTo(to ? to : ".", $341c792fffde747f$var$getResolveToMatches(contextualMatches), $341c792fffde747f$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $341c792fffde747f$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $341c792fffde747f$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $341c792fffde747f$export$fe53371bee54353d(path);
}
function $341c792fffde747f$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$341c792fffde747f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$341c792fffde747f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $341c792fffde747f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $341c792fffde747f$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $341c792fffde747f$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$341c792fffde747f$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$341c792fffde747f$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $341c792fffde747f$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $341c792fffde747f$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $341c792fffde747f$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $341c792fffde747f$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $341c792fffde747f$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($341c792fffde747f$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $341c792fffde747f$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $341c792fffde747f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $341c792fffde747f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $341c792fffde747f$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $341c792fffde747f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $341c792fffde747f$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $341c792fffde747f$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$341c792fffde747f$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $341c792fffde747f$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($341c792fffde747f$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $341c792fffde747f$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($341c792fffde747f$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $341c792fffde747f$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $341c792fffde747f$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $341c792fffde747f$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $341c792fffde747f$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $341c792fffde747f$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($341c792fffde747f$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $341c792fffde747f$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $341c792fffde747f$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$341c792fffde747f$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $341c792fffde747f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $341c792fffde747f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $341c792fffde747f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $341c792fffde747f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $341c792fffde747f$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$341c792fffde747f$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $341c792fffde747f$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $341c792fffde747f$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $341c792fffde747f$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$341c792fffde747f$var$isSameRoute(aChild, bChild)));
}
var $341c792fffde747f$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $341c792fffde747f$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $341c792fffde747f$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $341c792fffde747f$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $341c792fffde747f$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $341c792fffde747f$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $341c792fffde747f$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $341c792fffde747f$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $341c792fffde747f$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $341c792fffde747f$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $341c792fffde747f$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $341c792fffde747f$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $341c792fffde747f$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $341c792fffde747f$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $341c792fffde747f$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $341c792fffde747f$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $341c792fffde747f$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $341c792fffde747f$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $341c792fffde747f$var$isNonNullable(value) {
    return value !== void 0;
}
function $341c792fffde747f$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $341c792fffde747f$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($341c792fffde747f$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $341c792fffde747f$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $341c792fffde747f$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $341c792fffde747f$var$defaultDataStrategy(args);
    return $341c792fffde747f$var$runClientMiddlewarePipeline(args, ()=>$341c792fffde747f$var$defaultDataStrategy(args));
}
function $341c792fffde747f$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $341c792fffde747f$var$runMiddlewarePipeline(args, handler, processResult, $341c792fffde747f$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $341c792fffde747f$export$e0163cfdf7bc9cfa(result) ? $341c792fffde747f$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $341c792fffde747f$var$runClientMiddlewarePipeline(args, handler) {
    return $341c792fffde747f$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($341c792fffde747f$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $341c792fffde747f$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $341c792fffde747f$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $341c792fffde747f$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $341c792fffde747f$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $341c792fffde747f$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $341c792fffde747f$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $341c792fffde747f$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $341c792fffde747f$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $341c792fffde747f$var$loadLazyRoute(match.route, $341c792fffde747f$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $341c792fffde747f$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $341c792fffde747f$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $341c792fffde747f$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $341c792fffde747f$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $341c792fffde747f$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$341c792fffde747f$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($341c792fffde747f$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $341c792fffde747f$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $341c792fffde747f$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $341c792fffde747f$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $341c792fffde747f$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $341c792fffde747f$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $341c792fffde747f$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $341c792fffde747f$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $341c792fffde747f$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $341c792fffde747f$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $341c792fffde747f$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $341c792fffde747f$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $341c792fffde747f$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $341c792fffde747f$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $341c792fffde747f$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($341c792fffde747f$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $341c792fffde747f$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $341c792fffde747f$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($341c792fffde747f$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $341c792fffde747f$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $341c792fffde747f$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $341c792fffde747f$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($341c792fffde747f$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $341c792fffde747f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $341c792fffde747f$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$341c792fffde747f$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $341c792fffde747f$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $341c792fffde747f$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($341c792fffde747f$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $341c792fffde747f$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $341c792fffde747f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($341c792fffde747f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $341c792fffde747f$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $341c792fffde747f$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $341c792fffde747f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $341c792fffde747f$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $341c792fffde747f$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $341c792fffde747f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $341c792fffde747f$export$f5708dca728d7177(!$341c792fffde747f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($341c792fffde747f$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $341c792fffde747f$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $341c792fffde747f$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $341c792fffde747f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $341c792fffde747f$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $341c792fffde747f$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $341c792fffde747f$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($341c792fffde747f$var$isErrorResult(result)) {
            let boundaryMatch = $341c792fffde747f$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($341c792fffde747f$var$isRedirectResult(result)) $341c792fffde747f$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $341c792fffde747f$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $341c792fffde747f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $341c792fffde747f$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $341c792fffde747f$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $341c792fffde747f$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $341c792fffde747f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $341c792fffde747f$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $341c792fffde747f$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $341c792fffde747f$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $341c792fffde747f$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($341c792fffde747f$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $341c792fffde747f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $341c792fffde747f$export$8ccf933b0513f8d0(path) : path;
    return $341c792fffde747f$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $341c792fffde747f$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $341c792fffde747f$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $341c792fffde747f$var$dataWithResponseInitToErrorResponse(data2) {
    return new $341c792fffde747f$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $341c792fffde747f$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $341c792fffde747f$var$isDataStrategyResult(value));
}
function $341c792fffde747f$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $341c792fffde747f$var$isRedirectDataStrategyResult(result) {
    return $341c792fffde747f$export$3f1eb41d9a6a6a27(result.result) && $341c792fffde747f$var$redirectStatusCodes.has(result.result.status);
}
function $341c792fffde747f$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $341c792fffde747f$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $341c792fffde747f$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $341c792fffde747f$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $341c792fffde747f$export$794b2760043cf8cd(statusCode) {
    return $341c792fffde747f$var$redirectStatusCodes.has(statusCode);
}
function $341c792fffde747f$export$6e80290866a84dd4(result) {
    return $341c792fffde747f$export$3f1eb41d9a6a6a27(result) && $341c792fffde747f$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $341c792fffde747f$var$isValidMethod(method) {
    return $341c792fffde747f$var$validRequestMethods.has(method.toUpperCase());
}
function $341c792fffde747f$export$cbae47800eb95bc3(method) {
    return $341c792fffde747f$var$validMutationMethods.has(method.toUpperCase());
}
function $341c792fffde747f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $341c792fffde747f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $341c792fffde747f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $341c792fffde747f$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $341c792fffde747f$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $341c792fffde747f$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $341c792fffde747f$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $341c792fffde747f$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $341c792fffde747f$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $341c792fffde747f$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $341c792fffde747f$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $341c792fffde747f$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($341c792fffde747f$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $341c792fffde747f$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($341c792fffde747f$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $341c792fffde747f$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $341c792fffde747f$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $341c792fffde747f$export$2eeee58951ff3c1c = $aqdBs.createContext(null);
$341c792fffde747f$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $341c792fffde747f$export$315e3ffb01f217 = $aqdBs.createContext(null);
$341c792fffde747f$export$315e3ffb01f217.displayName = "DataRouterState";
var $341c792fffde747f$export$717f757c655223f1 = $aqdBs.createContext(false);
function $341c792fffde747f$var$useIsRSCRouterContext() {
    return $aqdBs.useContext($341c792fffde747f$export$717f757c655223f1);
}
var $341c792fffde747f$export$3681f408decb40d1 = $aqdBs.createContext({
    isTransitioning: false
});
$341c792fffde747f$export$3681f408decb40d1.displayName = "ViewTransition";
var $341c792fffde747f$export$cb3f1df1bef00a39 = $aqdBs.createContext(/* @__PURE__ */ new Map());
$341c792fffde747f$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $341c792fffde747f$var$AwaitContext = $aqdBs.createContext(null);
$341c792fffde747f$var$AwaitContext.displayName = "Await";
var $341c792fffde747f$export$2666c20e15407622 = (props)=>$aqdBs.createElement($341c792fffde747f$var$AwaitContext.Provider, props);
var $341c792fffde747f$export$3044ab7fdabeaee6 = $aqdBs.createContext(null);
$341c792fffde747f$export$3044ab7fdabeaee6.displayName = "Navigation";
var $341c792fffde747f$export$e6a44b110a0c44d3 = $aqdBs.createContext(null);
$341c792fffde747f$export$e6a44b110a0c44d3.displayName = "Location";
var $341c792fffde747f$export$aac280ed165a4397 = $aqdBs.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$341c792fffde747f$export$aac280ed165a4397.displayName = "Route";
var $341c792fffde747f$var$RouteErrorContext = $aqdBs.createContext(null);
$341c792fffde747f$var$RouteErrorContext.displayName = "RouteError";
var $341c792fffde747f$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $341c792fffde747f$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $341c792fffde747f$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $341c792fffde747f$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $341c792fffde747f$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$341c792fffde747f$var$ERROR_DIGEST_BASE}:${$341c792fffde747f$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $341c792fffde747f$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$341c792fffde747f$var$ERROR_DIGEST_BASE}:${$341c792fffde747f$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $341c792fffde747f$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $341c792fffde747f$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $341c792fffde747f$export$f5708dca728d7177($341c792fffde747f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $341c792fffde747f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $341c792fffde747f$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $341c792fffde747f$export$9c954a9d03d32f4a() {
    return $aqdBs.useContext($341c792fffde747f$export$e6a44b110a0c44d3) != null;
}
function $341c792fffde747f$export$45d76561a5302f2b() {
    $341c792fffde747f$export$f5708dca728d7177($341c792fffde747f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $aqdBs.useContext($341c792fffde747f$export$e6a44b110a0c44d3).location;
}
function $341c792fffde747f$export$1b3f31771c5d07c() {
    return $aqdBs.useContext($341c792fffde747f$export$e6a44b110a0c44d3).navigationType;
}
function $341c792fffde747f$export$6c330e8992e8a295(pattern) {
    $341c792fffde747f$export$f5708dca728d7177($341c792fffde747f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $341c792fffde747f$export$45d76561a5302f2b();
    return $aqdBs.useMemo(()=>$341c792fffde747f$export$81336c211d5ff295(pattern, $341c792fffde747f$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $341c792fffde747f$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $341c792fffde747f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6).static;
    if (!isStatic) $aqdBs.useLayoutEffect(cb);
}
function $341c792fffde747f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    return isDataRoute ? $341c792fffde747f$var$useNavigateStable() : $341c792fffde747f$var$useNavigateUnstable();
}
function $341c792fffde747f$var$useNavigateUnstable() {
    $341c792fffde747f$export$f5708dca728d7177($341c792fffde747f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $aqdBs.useContext($341c792fffde747f$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let { matches: matches } = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    let { pathname: locationPathname } = $341c792fffde747f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($341c792fffde747f$var$getResolveToMatches(matches));
    let activeRef = $aqdBs.useRef(false);
    $341c792fffde747f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback((to, options = {})=>{
        $341c792fffde747f$var$warning(activeRef.current, $341c792fffde747f$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $341c792fffde747f$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $341c792fffde747f$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $341c792fffde747f$var$OutletContext = $aqdBs.createContext(null);
function $341c792fffde747f$export$4138103a3ae699cc() {
    return $aqdBs.useContext($341c792fffde747f$var$OutletContext);
}
function $341c792fffde747f$export$a3be3530d8e40d0b(context) {
    let outlet = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397).outlet;
    return $aqdBs.useMemo(()=>outlet && /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $341c792fffde747f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $341c792fffde747f$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    let { pathname: locationPathname } = $341c792fffde747f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($341c792fffde747f$var$getResolveToMatches(matches));
    return $aqdBs.useMemo(()=>$341c792fffde747f$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $341c792fffde747f$export$5d3fca4a98652595(routes, locationArg) {
    return $341c792fffde747f$var$useRoutesImpl(routes, locationArg);
}
function $341c792fffde747f$var$useRoutesImpl(routes, locationArg, dataRouterState, onError, future) {
    $341c792fffde747f$export$f5708dca728d7177($341c792fffde747f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($341c792fffde747f$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $341c792fffde747f$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $341c792fffde747f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $341c792fffde747f$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $341c792fffde747f$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $341c792fffde747f$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($341c792fffde747f$export$945fecf35a8ef089) {
        $341c792fffde747f$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $341c792fffde747f$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $341c792fffde747f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $341c792fffde747f$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $341c792fffde747f$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $341c792fffde747f$var$DefaultErrorComponent() {
    let error = $341c792fffde747f$export$ed527bf60f6e05f2();
    let message = $341c792fffde747f$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($341c792fffde747f$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $aqdBs.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $aqdBs.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $aqdBs.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $aqdBs.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $aqdBs.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $341c792fffde747f$var$defaultErrorElement = /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$DefaultErrorComponent, null);
var $341c792fffde747f$var$RenderErrorBoundary = class extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $341c792fffde747f$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$341c792fffde747f$var$RenderErrorBoundary.contextType = $341c792fffde747f$export$717f757c655223f1;
var $341c792fffde747f$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $341c792fffde747f$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $341c792fffde747f$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $341c792fffde747f$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $341c792fffde747f$var$parseToInfo(redirect2.location, basename);
            if ($341c792fffde747f$var$isBrowser && !$341c792fffde747f$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $341c792fffde747f$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $aqdBs.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $341c792fffde747f$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $aqdBs.useContext($341c792fffde747f$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $341c792fffde747f$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, onErrorHandler = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $341c792fffde747f$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $341c792fffde747f$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $341c792fffde747f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $341c792fffde747f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $aqdBs.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $341c792fffde747f$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $341c792fffde747f$var$useDataRouterContext(hookName) {
    let ctx = $aqdBs.useContext($341c792fffde747f$export$2eeee58951ff3c1c);
    $341c792fffde747f$export$f5708dca728d7177(ctx, $341c792fffde747f$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $341c792fffde747f$var$useDataRouterState(hookName) {
    let state = $aqdBs.useContext($341c792fffde747f$export$315e3ffb01f217);
    $341c792fffde747f$export$f5708dca728d7177(state, $341c792fffde747f$var$getDataRouterConsoleError(hookName));
    return state;
}
function $341c792fffde747f$var$useRouteContext(hookName) {
    let route = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    $341c792fffde747f$export$f5708dca728d7177(route, $341c792fffde747f$var$getDataRouterConsoleError(hookName));
    return route;
}
function $341c792fffde747f$var$useCurrentRouteId(hookName) {
    let route = $341c792fffde747f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $341c792fffde747f$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $341c792fffde747f$var$useRouteId() {
    return $341c792fffde747f$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $341c792fffde747f$export$d0fd4b7106de2769() {
    let state = $341c792fffde747f$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $341c792fffde747f$export$600dc272ed516c15() {
    let dataRouterContext = $341c792fffde747f$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $341c792fffde747f$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $aqdBs.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $aqdBs.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $341c792fffde747f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $341c792fffde747f$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $aqdBs.useMemo(()=>matches.map((m)=>$341c792fffde747f$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $341c792fffde747f$export$1448a5050d252c4d() {
    let state = $341c792fffde747f$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $341c792fffde747f$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $341c792fffde747f$export$fd5d37484eab868d(routeId) {
    let state = $341c792fffde747f$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $341c792fffde747f$export$fdc00f3f26066d5e() {
    let state = $341c792fffde747f$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $341c792fffde747f$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $341c792fffde747f$export$ed527bf60f6e05f2() {
    let error = $aqdBs.useContext($341c792fffde747f$var$RouteErrorContext);
    let state = $341c792fffde747f$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $341c792fffde747f$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $341c792fffde747f$export$78a72ddb39bdd145() {
    let value = $aqdBs.useContext($341c792fffde747f$var$AwaitContext);
    return value?._data;
}
function $341c792fffde747f$export$17f53340677d5831() {
    let value = $aqdBs.useContext($341c792fffde747f$var$AwaitContext);
    return value?._error;
}
var $341c792fffde747f$var$blockerId = 0;
function $341c792fffde747f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $341c792fffde747f$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $341c792fffde747f$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $aqdBs.useState("");
    let blockerFunction = $aqdBs.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $341c792fffde747f$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $341c792fffde747f$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $aqdBs.useEffect(()=>{
        let key = String(++$341c792fffde747f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $aqdBs.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $341c792fffde747f$export$386d57f03f0b2883;
}
function $341c792fffde747f$var$useNavigateStable() {
    let { router: router } = $341c792fffde747f$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $341c792fffde747f$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $aqdBs.useRef(false);
    $341c792fffde747f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback(async (to, options = {})=>{
        $341c792fffde747f$var$warning(activeRef.current, $341c792fffde747f$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $341c792fffde747f$var$alreadyWarned = {};
function $341c792fffde747f$var$warningOnce(key, cond, message) {
    if (!cond && !$341c792fffde747f$var$alreadyWarned[key]) {
        $341c792fffde747f$var$alreadyWarned[key] = true;
        $341c792fffde747f$var$warning(false, message);
    }
}
function $341c792fffde747f$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $341c792fffde747f$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $341c792fffde747f$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $341c792fffde747f$var$alreadyWarned2 = {};
function $341c792fffde747f$export$5b28268982f175ba(condition, message) {
    if (!condition && !$341c792fffde747f$var$alreadyWarned2[message]) {
        $341c792fffde747f$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $341c792fffde747f$var$USE_OPTIMISTIC = "useOptimistic";
var $341c792fffde747f$var$useOptimisticImpl = $aqdBs[$341c792fffde747f$var$USE_OPTIMISTIC];
var $341c792fffde747f$var$stableUseOptimisticSetter = ()=>void 0;
function $341c792fffde747f$var$useOptimisticSafe(val) {
    if ($341c792fffde747f$var$useOptimisticImpl) return $341c792fffde747f$var$useOptimisticImpl(val);
    else return [
        val,
        $341c792fffde747f$var$stableUseOptimisticSetter
    ];
}
function $341c792fffde747f$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($341c792fffde747f$export$945fecf35a8ef089) {
            if (route.element) $341c792fffde747f$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $aqdBs.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($341c792fffde747f$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $341c792fffde747f$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $aqdBs.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($341c792fffde747f$export$945fecf35a8ef089) {
            if (route.errorElement) $341c792fffde747f$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $aqdBs.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $341c792fffde747f$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $341c792fffde747f$export$f30f7e456d254e83(routes, opts) {
    return $341c792fffde747f$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $341c792fffde747f$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $341c792fffde747f$export$e2fd2c03906469db,
        mapRouteProperties: $341c792fffde747f$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $341c792fffde747f$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $341c792fffde747f$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $341c792fffde747f$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $aqdBs.useState(router.state);
    let [state, setOptimisticState] = $341c792fffde747f$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $aqdBs.useState();
    let [vtContext, setVtContext] = $aqdBs.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $aqdBs.useState();
    let [transition, setTransition] = $aqdBs.useState();
    let [interruption, setInterruption] = $aqdBs.useState();
    let fetcherData = $aqdBs.useRef(/* @__PURE__ */ new Map());
    let setState = $aqdBs.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $341c792fffde747f$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $341c792fffde747f$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $341c792fffde747f$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $aqdBs.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$341c792fffde747f$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $aqdBs.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $aqdBs.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $341c792fffde747f$var$Deferred());
    }, [
        vtContext
    ]);
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $aqdBs.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$341c792fffde747f$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $aqdBs.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $aqdBs.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aqdBs.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        onError: onError
    })))))), null);
}
function $341c792fffde747f$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $341c792fffde747f$var$MemoizedDataRoutes = $aqdBs.memo($341c792fffde747f$var$DataRoutes);
function $341c792fffde747f$var$DataRoutes({ routes: routes, future: future, state: state, onError: onError }) {
    return $341c792fffde747f$var$useRoutesImpl(routes, void 0, state, onError, future);
}
function $341c792fffde747f$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = $341c792fffde747f$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aqdBs.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $aqdBs.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $341c792fffde747f$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $341c792fffde747f$export$f5708dca728d7177($341c792fffde747f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    $341c792fffde747f$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    let { pathname: locationPathname } = $341c792fffde747f$export$45d76561a5302f2b();
    let navigate = $341c792fffde747f$export$9770f232ac06a008();
    let path = $341c792fffde747f$var$resolveTo(to, $341c792fffde747f$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $aqdBs.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $341c792fffde747f$export$910ae8079b2c2852(props) {
    return $341c792fffde747f$export$a3be3530d8e40d0b(props.context);
}
function $341c792fffde747f$export$e7b0ac011bb776c6(props) {
    $341c792fffde747f$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $341c792fffde747f$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $341c792fffde747f$export$f5708dca728d7177(!$341c792fffde747f$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aqdBs.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $341c792fffde747f$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $aqdBs.useMemo(()=>{
        let trailingPathname = $341c792fffde747f$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $341c792fffde747f$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $341c792fffde747f$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $341c792fffde747f$export$5d3fca4a98652595($341c792fffde747f$export$16da398f5434bdec(children), location);
}
function $341c792fffde747f$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $aqdBs.useContext($341c792fffde747f$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $aqdBs.useContext($341c792fffde747f$export$315e3ffb01f217);
    let onError = $aqdBs.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $341c792fffde747f$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$ResolveAwait, null, children));
}
var $341c792fffde747f$var$AwaitErrorBoundary = class extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $341c792fffde747f$var$ResolveAwait({ children: children }) {
    let data2 = $341c792fffde747f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, toRender);
}
function $341c792fffde747f$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $aqdBs.Children.forEach(children, (element, index)=>{
        if (!$aqdBs.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aqdBs.Fragment) {
            routes.push.apply(routes, $341c792fffde747f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $341c792fffde747f$export$f5708dca728d7177(element.type === $341c792fffde747f$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $341c792fffde747f$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $341c792fffde747f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $341c792fffde747f$export$9b5b6d122dea0c88 = $341c792fffde747f$export$16da398f5434bdec;
function $341c792fffde747f$export$daf73786167a7f72(matches) {
    return $341c792fffde747f$var$_renderMatches(matches);
}
function $341c792fffde747f$var$useRouteComponentProps() {
    return {
        params: $341c792fffde747f$export$99eaa27ddbbb95ef(),
        loaderData: $341c792fffde747f$export$1448a5050d252c4d(),
        actionData: $341c792fffde747f$export$fdc00f3f26066d5e(),
        matches: $341c792fffde747f$export$2378eb7f5ff86053()
    };
}
function $341c792fffde747f$export$6c4f3826290c37af({ children: children }) {
    const props = $341c792fffde747f$var$useRouteComponentProps();
    return $aqdBs.cloneElement(children, props);
}
function $341c792fffde747f$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $341c792fffde747f$var$useRouteComponentProps();
        return $aqdBs.createElement(Component4, props);
    };
}
function $341c792fffde747f$var$useHydrateFallbackProps() {
    return {
        params: $341c792fffde747f$export$99eaa27ddbbb95ef(),
        loaderData: $341c792fffde747f$export$1448a5050d252c4d(),
        actionData: $341c792fffde747f$export$fdc00f3f26066d5e()
    };
}
function $341c792fffde747f$export$f8cff34f39c1932a({ children: children }) {
    const props = $341c792fffde747f$var$useHydrateFallbackProps();
    return $aqdBs.cloneElement(children, props);
}
function $341c792fffde747f$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $341c792fffde747f$var$useHydrateFallbackProps();
        return $aqdBs.createElement(HydrateFallback, props);
    };
}
function $341c792fffde747f$var$useErrorBoundaryProps() {
    return {
        params: $341c792fffde747f$export$99eaa27ddbbb95ef(),
        loaderData: $341c792fffde747f$export$1448a5050d252c4d(),
        actionData: $341c792fffde747f$export$fdc00f3f26066d5e(),
        error: $341c792fffde747f$export$ed527bf60f6e05f2()
    };
}
function $341c792fffde747f$export$e5afde5c4b6d747b({ children: children }) {
    const props = $341c792fffde747f$var$useErrorBoundaryProps();
    return $aqdBs.cloneElement(children, props);
}
function $341c792fffde747f$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $341c792fffde747f$var$useErrorBoundaryProps();
        return $aqdBs.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $341c792fffde747f$var$defaultMethod = "get";
var $341c792fffde747f$var$defaultEncType = "application/x-www-form-urlencoded";
function $341c792fffde747f$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $341c792fffde747f$var$isButtonElement(object) {
    return $341c792fffde747f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $341c792fffde747f$var$isFormElement(object) {
    return $341c792fffde747f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $341c792fffde747f$var$isInputElement(object) {
    return $341c792fffde747f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $341c792fffde747f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $341c792fffde747f$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$341c792fffde747f$var$isModifiedEvent(event);
}
function $341c792fffde747f$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $341c792fffde747f$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $341c792fffde747f$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $341c792fffde747f$var$_formDataSupportsSubmitter = null;
function $341c792fffde747f$var$isFormDataSubmitterSupported() {
    if ($341c792fffde747f$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $341c792fffde747f$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $341c792fffde747f$var$_formDataSupportsSubmitter = true;
    }
    return $341c792fffde747f$var$_formDataSupportsSubmitter;
}
var $341c792fffde747f$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $341c792fffde747f$var$getFormEncType(encType) {
    if (encType != null && !$341c792fffde747f$var$supportedFormEncTypes.has(encType)) {
        $341c792fffde747f$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$341c792fffde747f$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $341c792fffde747f$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($341c792fffde747f$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $341c792fffde747f$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $341c792fffde747f$var$defaultMethod;
        encType = $341c792fffde747f$var$getFormEncType(target.getAttribute("enctype")) || $341c792fffde747f$var$defaultEncType;
        formData = new FormData(target);
    } else if ($341c792fffde747f$var$isButtonElement(target) || $341c792fffde747f$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $341c792fffde747f$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $341c792fffde747f$var$defaultMethod;
        encType = $341c792fffde747f$var$getFormEncType(target.getAttribute("formenctype")) || $341c792fffde747f$var$getFormEncType(form.getAttribute("enctype")) || $341c792fffde747f$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$341c792fffde747f$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($341c792fffde747f$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $341c792fffde747f$var$defaultMethod;
        action = null;
        encType = $341c792fffde747f$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $341c792fffde747f$var$HOLE = -1;
var $341c792fffde747f$var$NAN = -2;
var $341c792fffde747f$var$NEGATIVE_INFINITY = -3;
var $341c792fffde747f$var$NEGATIVE_ZERO = -4;
var $341c792fffde747f$var$NULL = -5;
var $341c792fffde747f$var$POSITIVE_INFINITY = -6;
var $341c792fffde747f$var$UNDEFINED = -7;
var $341c792fffde747f$var$TYPE_BIGINT = "B";
var $341c792fffde747f$var$TYPE_DATE = "D";
var $341c792fffde747f$var$TYPE_ERROR = "E";
var $341c792fffde747f$var$TYPE_MAP = "M";
var $341c792fffde747f$var$TYPE_NULL_OBJECT = "N";
var $341c792fffde747f$var$TYPE_PROMISE = "P";
var $341c792fffde747f$var$TYPE_REGEXP = "R";
var $341c792fffde747f$var$TYPE_SET = "S";
var $341c792fffde747f$var$TYPE_SYMBOL = "Y";
var $341c792fffde747f$var$TYPE_URL = "U";
var $341c792fffde747f$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $341c792fffde747f$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $341c792fffde747f$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $341c792fffde747f$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $341c792fffde747f$var$UNDEFINED;
    if (input === null) return $341c792fffde747f$var$NULL;
    if (Number.isNaN(input)) return $341c792fffde747f$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $341c792fffde747f$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $341c792fffde747f$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $341c792fffde747f$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $341c792fffde747f$var$stringify.call(this, input, index);
    return index;
}
function $341c792fffde747f$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$341c792fffde747f$var$flatten.call(this, k)}":${$341c792fffde747f$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$341c792fffde747f$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$341c792fffde747f$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$341c792fffde747f$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$341c792fffde747f$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $341c792fffde747f$var$flatten.call(this, input2[i]) : $341c792fffde747f$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$341c792fffde747f$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$341c792fffde747f$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$341c792fffde747f$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$341c792fffde747f$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$341c792fffde747f$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$341c792fffde747f$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$341c792fffde747f$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $341c792fffde747f$var$flatten.call(this, k),
                                    $341c792fffde747f$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$341c792fffde747f$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$341c792fffde747f$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$341c792fffde747f$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$341c792fffde747f$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($341c792fffde747f$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$341c792fffde747f$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$341c792fffde747f$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $341c792fffde747f$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $341c792fffde747f$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $341c792fffde747f$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $341c792fffde747f$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $341c792fffde747f$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $341c792fffde747f$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $341c792fffde747f$var$hydrate.call(this, startIndex);
}
function $341c792fffde747f$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $341c792fffde747f$var$UNDEFINED:
                set(void 0);
                continue;
            case $341c792fffde747f$var$NULL:
                set(null);
                continue;
            case $341c792fffde747f$var$NAN:
                set(NaN);
                continue;
            case $341c792fffde747f$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $341c792fffde747f$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $341c792fffde747f$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $341c792fffde747f$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $341c792fffde747f$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $341c792fffde747f$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $341c792fffde747f$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $341c792fffde747f$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $341c792fffde747f$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $341c792fffde747f$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $341c792fffde747f$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $341c792fffde747f$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $341c792fffde747f$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $341c792fffde747f$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $341c792fffde747f$var$globalObj && $341c792fffde747f$var$globalObj[errorType] ? new $341c792fffde747f$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $341c792fffde747f$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $341c792fffde747f$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $341c792fffde747f$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $341c792fffde747f$var$Deferred2();
    const reader = readable.pipeThrough($341c792fffde747f$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $341c792fffde747f$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $341c792fffde747f$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $341c792fffde747f$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $341c792fffde747f$var$unflatten.call(this, line)
    };
}
async function $341c792fffde747f$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $341c792fffde747f$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $341c792fffde747f$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $341c792fffde747f$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $341c792fffde747f$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $341c792fffde747f$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $341c792fffde747f$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $341c792fffde747f$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$341c792fffde747f$var$TYPE_PROMISE}${deferredId}:[["${$341c792fffde747f$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$341c792fffde747f$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$341c792fffde747f$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $341c792fffde747f$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$341c792fffde747f$var$TYPE_ERROR}${deferredId}:[["${$341c792fffde747f$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$341c792fffde747f$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$341c792fffde747f$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $341c792fffde747f$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $341c792fffde747f$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $341c792fffde747f$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $341c792fffde747f$export$4cf11838cdc2a8a8(html) {
    return html.replace($341c792fffde747f$var$ESCAPE_REGEX, (match)=>$341c792fffde747f$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $341c792fffde747f$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $341c792fffde747f$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $341c792fffde747f$var$SingleFetchNoResultError = class extends Error {
};
var $341c792fffde747f$export$ae9272e641ead836 = 202;
var $341c792fffde747f$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $341c792fffde747f$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $aqdBs.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$341c792fffde747f$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, scriptTag, /* @__PURE__ */ $aqdBs.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, scriptTag, /* @__PURE__ */ $aqdBs.createElement($aqdBs.Suspense, null, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $341c792fffde747f$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $341c792fffde747f$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $341c792fffde747f$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $341c792fffde747f$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $341c792fffde747f$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $341c792fffde747f$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $341c792fffde747f$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $341c792fffde747f$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $341c792fffde747f$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $341c792fffde747f$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $341c792fffde747f$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $341c792fffde747f$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($341c792fffde747f$export$3f1eb41d9a6a6a27(result.result) || $341c792fffde747f$export$972111febbeef05b(result.result) || $341c792fffde747f$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $341c792fffde747f$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $341c792fffde747f$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $341c792fffde747f$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $341c792fffde747f$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$341c792fffde747f$var$createDeferred2());
    let singleFetchDfd = $341c792fffde747f$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $341c792fffde747f$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $341c792fffde747f$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $341c792fffde747f$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $341c792fffde747f$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $341c792fffde747f$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $341c792fffde747f$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $341c792fffde747f$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $341c792fffde747f$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $341c792fffde747f$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $341c792fffde747f$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $341c792fffde747f$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
        else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    }
    return url;
}
async function $341c792fffde747f$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $341c792fffde747f$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $341c792fffde747f$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $341c792fffde747f$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $341c792fffde747f$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $341c792fffde747f$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($341c792fffde747f$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $341c792fffde747f$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $341c792fffde747f$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($341c792fffde747f$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$341c792fffde747f$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $341c792fffde747f$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $341c792fffde747f$export$4023ad4ecd4126a2(body, global) {
    return $341c792fffde747f$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $341c792fffde747f$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$341c792fffde747f$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $341c792fffde747f$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $341c792fffde747f$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $341c792fffde747f$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $341c792fffde747f$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $341c792fffde747f$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $341c792fffde747f$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $341c792fffde747f$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $341c792fffde747f$var$getModuleLinkHrefs(matches, manifest);
    return $341c792fffde747f$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $341c792fffde747f$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $341c792fffde747f$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $341c792fffde747f$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($341c792fffde747f$var$prefetchStyleLink));
}
async function $341c792fffde747f$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$341c792fffde747f$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$341c792fffde747f$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$341c792fffde747f$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($341c792fffde747f$var$prefetchStyleLink));
}
async function $341c792fffde747f$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $341c792fffde747f$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $341c792fffde747f$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $341c792fffde747f$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $341c792fffde747f$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $341c792fffde747f$var$dedupeLinkDescriptors(links.flat(1).filter($341c792fffde747f$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $341c792fffde747f$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $341c792fffde747f$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $341c792fffde747f$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $341c792fffde747f$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $341c792fffde747f$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $341c792fffde747f$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$341c792fffde747f$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($341c792fffde747f$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $341c792fffde747f$var$_isPreloadSupported;
function $341c792fffde747f$var$isPreloadSupported() {
    if ($341c792fffde747f$var$_isPreloadSupported !== void 0) return $341c792fffde747f$var$_isPreloadSupported;
    let el = document.createElement("link");
    $341c792fffde747f$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $341c792fffde747f$var$_isPreloadSupported;
}
function $341c792fffde747f$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $341c792fffde747f$export$945fecf35a8ef089 ? /* @__PURE__ */ $aqdBs.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $341c792fffde747f$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $341c792fffde747f$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $341c792fffde747f$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $341c792fffde747f$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$RemixRootDefaultErrorBoundary, {
            error: $341c792fffde747f$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $aqdBs.createElement(routeModule.Layout, null, /* @__PURE__ */ $aqdBs.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $aqdBs.createElement(routeModule.Layout, null, /* @__PURE__ */ $aqdBs.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $aqdBs.createElement(routeModule.Layout, null, /* @__PURE__ */ $aqdBs.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $341c792fffde747f$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $341c792fffde747f$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $341c792fffde747f$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$341c792fffde747f$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $341c792fffde747f$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $341c792fffde747f$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $341c792fffde747f$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $341c792fffde747f$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $341c792fffde747f$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $341c792fffde747f$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $341c792fffde747f$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $341c792fffde747f$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $341c792fffde747f$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $341c792fffde747f$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $341c792fffde747f$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $341c792fffde747f$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $341c792fffde747f$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$341c792fffde747f$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $341c792fffde747f$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $341c792fffde747f$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $341c792fffde747f$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $341c792fffde747f$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $341c792fffde747f$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $341c792fffde747f$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $341c792fffde747f$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $341c792fffde747f$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $341c792fffde747f$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $341c792fffde747f$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $341c792fffde747f$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $341c792fffde747f$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $341c792fffde747f$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $341c792fffde747f$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $341c792fffde747f$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $341c792fffde747f$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $341c792fffde747f$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $341c792fffde747f$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $341c792fffde747f$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $341c792fffde747f$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $341c792fffde747f$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $341c792fffde747f$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $341c792fffde747f$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $341c792fffde747f$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $341c792fffde747f$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $341c792fffde747f$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $341c792fffde747f$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $341c792fffde747f$var$nextPaths = /* @__PURE__ */ new Set();
var $341c792fffde747f$var$discoveredPathsMaxSize = 1e3;
var $341c792fffde747f$var$discoveredPaths = /* @__PURE__ */ new Set();
var $341c792fffde747f$var$URL_LIMIT = 7680;
function $341c792fffde747f$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $341c792fffde747f$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $341c792fffde747f$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $341c792fffde747f$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$341c792fffde747f$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($341c792fffde747f$var$discoveredPaths.has(path)) return;
        await $341c792fffde747f$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $341c792fffde747f$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $aqdBs.useEffect(()=>{
        if (!$341c792fffde747f$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$341c792fffde747f$var$discoveredPaths.has(pathname)) $341c792fffde747f$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($341c792fffde747f$var$nextPaths.keys()).filter((path)=>{
                if ($341c792fffde747f$var$discoveredPaths.has(path)) {
                    $341c792fffde747f$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $341c792fffde747f$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $341c792fffde747f$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $341c792fffde747f$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $341c792fffde747f$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $341c792fffde747f$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($341c792fffde747f$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $341c792fffde747f$var$URL_LIMIT) {
        $341c792fffde747f$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($341c792fffde747f$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($341c792fffde747f$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($341c792fffde747f$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$341c792fffde747f$var$addToFifoQueue(p, $341c792fffde747f$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $341c792fffde747f$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $341c792fffde747f$var$addToFifoQueue(path, queue) {
    if (queue.size >= $341c792fffde747f$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $341c792fffde747f$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $341c792fffde747f$var$useDataRouterContext2() {
    let context = $aqdBs.useContext($341c792fffde747f$export$2eeee58951ff3c1c);
    $341c792fffde747f$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $341c792fffde747f$var$useDataRouterStateContext() {
    let context = $aqdBs.useContext($341c792fffde747f$export$315e3ffb01f217);
    $341c792fffde747f$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $341c792fffde747f$export$208d6a3bc3aa62bd = $aqdBs.createContext(void 0);
$341c792fffde747f$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $341c792fffde747f$var$useFrameworkContext() {
    let context = $aqdBs.useContext($341c792fffde747f$export$208d6a3bc3aa62bd);
    $341c792fffde747f$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $341c792fffde747f$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $aqdBs.useContext($341c792fffde747f$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $aqdBs.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $aqdBs.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $aqdBs.useRef(null);
    $aqdBs.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $aqdBs.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $341c792fffde747f$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $341c792fffde747f$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $341c792fffde747f$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $341c792fffde747f$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $341c792fffde747f$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $341c792fffde747f$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $341c792fffde747f$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$341c792fffde747f$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $341c792fffde747f$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $341c792fffde747f$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $341c792fffde747f$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $341c792fffde747f$var$useDataRouterStateContext();
    let matches = $341c792fffde747f$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $aqdBs.useMemo(()=>$341c792fffde747f$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $aqdBs.createElement("style", {
        [$341c792fffde747f$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $aqdBs.createElement("link", {
        [$341c792fffde747f$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$341c792fffde747f$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $aqdBs.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $341c792fffde747f$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $341c792fffde747f$var$useDataRouterContext2();
    let matches = $aqdBs.useMemo(()=>$341c792fffde747f$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $341c792fffde747f$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $341c792fffde747f$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $aqdBs.useState([]);
    $aqdBs.useEffect(()=>{
        let interrupted = false;
        $341c792fffde747f$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $341c792fffde747f$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $341c792fffde747f$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $341c792fffde747f$var$useFrameworkContext();
    let { basename: basename } = $341c792fffde747f$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $341c792fffde747f$var$useDataRouterStateContext();
    let newMatchesForData = $aqdBs.useMemo(()=>$341c792fffde747f$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $aqdBs.useMemo(()=>$341c792fffde747f$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $aqdBs.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $341c792fffde747f$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $aqdBs.useMemo(()=>$341c792fffde747f$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $341c792fffde747f$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $aqdBs.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $aqdBs.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $aqdBs.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $341c792fffde747f$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $341c792fffde747f$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $341c792fffde747f$var$useDataRouterStateContext();
    let location = $341c792fffde747f$export$45d76561a5302f2b();
    let _matches = $341c792fffde747f$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$341c792fffde747f$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $aqdBs.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $aqdBs.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $aqdBs.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $aqdBs.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $341c792fffde747f$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $aqdBs.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $341c792fffde747f$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $341c792fffde747f$var$isHydrated = false;
function $341c792fffde747f$export$3be068dde909e563() {
    $341c792fffde747f$var$isHydrated = true;
}
function $341c792fffde747f$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $341c792fffde747f$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $341c792fffde747f$var$useDataRouterContext2();
    let { matches: routerMatches } = $341c792fffde747f$var$useDataRouterStateContext();
    let isRSCRouterContext = $341c792fffde747f$var$useIsRSCRouterContext();
    let enableFogOfWar = $341c792fffde747f$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $341c792fffde747f$var$getActiveMatches(routerMatches, null, isSpaMode);
    $aqdBs.useEffect(()=>{
        $341c792fffde747f$export$3be068dde909e563();
    }, []);
    let initialScripts = $aqdBs.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $341c792fffde747f$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($341c792fffde747f$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $aqdBs.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $341c792fffde747f$var$isHydrated || isRSCRouterContext ? [] : $341c792fffde747f$var$dedupe(manifest.entry.imports.concat($341c792fffde747f$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $341c792fffde747f$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $341c792fffde747f$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $aqdBs.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $aqdBs.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $aqdBs.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $aqdBs.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $341c792fffde747f$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $341c792fffde747f$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $341c792fffde747f$export$32e57f52df4b6e34 = class extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $341c792fffde747f$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $aqdBs.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($341c792fffde747f$export$972111febbeef05b(error)) return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $aqdBs.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $341c792fffde747f$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $aqdBs.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $aqdBs.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $341c792fffde747f$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $341c792fffde747f$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $aqdBs.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $aqdBs.createElement("head", null, /* @__PURE__ */ $aqdBs.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $aqdBs.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $aqdBs.createElement("title", null, title)), /* @__PURE__ */ $aqdBs.createElement("body", null, /* @__PURE__ */ $aqdBs.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$ff0bf87698939488, null) : null)));
}
var $341c792fffde747f$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($341c792fffde747f$var$isBrowser2) window.__reactRouterVersion = "7.12.0";
} catch (e) {}
function $341c792fffde747f$export$1f3f55432a00e06d(routes, opts) {
    return $341c792fffde747f$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $341c792fffde747f$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $341c792fffde747f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $341c792fffde747f$export$9269a41d8c4635e,
        hydrationRouteProperties: $341c792fffde747f$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $341c792fffde747f$export$1ba7ed8a3a7b3765(routes, opts) {
    return $341c792fffde747f$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $341c792fffde747f$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $341c792fffde747f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $341c792fffde747f$export$9269a41d8c4635e,
        hydrationRouteProperties: $341c792fffde747f$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $341c792fffde747f$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $341c792fffde747f$var$deserializeErrors(state.errors)
    };
    return state;
}
function $341c792fffde747f$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $341c792fffde747f$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $341c792fffde747f$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = $341c792fffde747f$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aqdBs.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $aqdBs.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $341c792fffde747f$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = $341c792fffde747f$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aqdBs.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $aqdBs.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $341c792fffde747f$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aqdBs.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $aqdBs.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$341c792fffde747f$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $341c792fffde747f$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $341c792fffde747f$export$a6c7ac8248d6e38a = $aqdBs.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, unstable_useTransitions: unstable_useTransitions } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $341c792fffde747f$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $341c792fffde747f$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $341c792fffde747f$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $341c792fffde747f$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $341c792fffde747f$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $aqdBs.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: parsed.absoluteURL || href,
        onClick: parsed.isExternal || reloadDocument ? onClick : handleClick,
        ref: $341c792fffde747f$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, link, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$341c792fffde747f$export$a6c7ac8248d6e38a.displayName = "Link";
var $341c792fffde747f$export$b0d92dbee9b5b60d = $aqdBs.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $341c792fffde747f$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $341c792fffde747f$export$45d76561a5302f2b();
    let routerState = $aqdBs.useContext($341c792fffde747f$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $341c792fffde747f$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $341c792fffde747f$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$341c792fffde747f$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $341c792fffde747f$export$a7fed597f4b8afd8 = $aqdBs.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $341c792fffde747f$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let submit = $341c792fffde747f$export$47c85c6e3a081d3();
    let formAction = $341c792fffde747f$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $341c792fffde747f$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $aqdBs.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $aqdBs.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$341c792fffde747f$export$a7fed597f4b8afd8.displayName = "Form";
function $341c792fffde747f$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $aqdBs.useContext($341c792fffde747f$export$208d6a3bc3aa62bd);
    let { basename: basename } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let location = $341c792fffde747f$export$45d76561a5302f2b();
    let matches = $341c792fffde747f$export$2378eb7f5ff86053();
    $341c792fffde747f$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $aqdBs.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $341c792fffde747f$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $aqdBs.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$341c792fffde747f$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $341c792fffde747f$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$341c792fffde747f$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$341c792fffde747f$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $341c792fffde747f$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $341c792fffde747f$var$useDataRouterContext3(hookName) {
    let ctx = $aqdBs.useContext($341c792fffde747f$export$2eeee58951ff3c1c);
    $341c792fffde747f$export$f5708dca728d7177(ctx, $341c792fffde747f$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $341c792fffde747f$var$useDataRouterState2(hookName) {
    let state = $aqdBs.useContext($341c792fffde747f$export$315e3ffb01f217);
    $341c792fffde747f$export$f5708dca728d7177(state, $341c792fffde747f$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $341c792fffde747f$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $341c792fffde747f$export$9770f232ac06a008();
    let location = $341c792fffde747f$export$45d76561a5302f2b();
    let path = $341c792fffde747f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $aqdBs.useCallback((event)=>{
        if ($341c792fffde747f$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $341c792fffde747f$export$fe53371bee54353d(location) === $341c792fffde747f$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $aqdBs.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $341c792fffde747f$export$f1a78c17382fe22a(defaultInit) {
    $341c792fffde747f$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $aqdBs.useRef($341c792fffde747f$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $aqdBs.useRef(false);
    let location = $341c792fffde747f$export$45d76561a5302f2b();
    let searchParams = $aqdBs.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $341c792fffde747f$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $341c792fffde747f$export$9770f232ac06a008();
    let setSearchParams = $aqdBs.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $341c792fffde747f$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $341c792fffde747f$var$fetcherId = 0;
var $341c792fffde747f$var$getUniqueFetcherId = ()=>`__${String(++$341c792fffde747f$var$fetcherId)}__`;
function $341c792fffde747f$export$47c85c6e3a081d3() {
    let { router: router } = $341c792fffde747f$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let currentRouteId = $341c792fffde747f$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $aqdBs.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $341c792fffde747f$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $341c792fffde747f$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $341c792fffde747f$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let routeContext = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    $341c792fffde747f$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$341c792fffde747f$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $341c792fffde747f$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $341c792fffde747f$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $341c792fffde747f$export$fe53371bee54353d(path);
}
function $341c792fffde747f$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $341c792fffde747f$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $341c792fffde747f$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $aqdBs.useContext($341c792fffde747f$export$cb3f1df1bef00a39);
    let route = $aqdBs.useContext($341c792fffde747f$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $341c792fffde747f$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $341c792fffde747f$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $341c792fffde747f$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $aqdBs.useId();
    let [fetcherKey, setFetcherKey] = $aqdBs.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $aqdBs.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $aqdBs.useCallback(async (href, opts)=>{
        $341c792fffde747f$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $341c792fffde747f$export$47c85c6e3a081d3();
    let submit = $aqdBs.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $aqdBs.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $aqdBs.useMemo(()=>{
        let FetcherForm2 = $aqdBs.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $341c792fffde747f$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $aqdBs.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $341c792fffde747f$export$fa996778a3a31087() {
    let state = $341c792fffde747f$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $341c792fffde747f$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $341c792fffde747f$var$savedScrollPositions = {};
function $341c792fffde747f$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $341c792fffde747f$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $341c792fffde747f$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $341c792fffde747f$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $341c792fffde747f$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $aqdBs.useContext($341c792fffde747f$export$3044ab7fdabeaee6);
    let location = $341c792fffde747f$export$45d76561a5302f2b();
    let matches = $341c792fffde747f$export$2378eb7f5ff86053();
    let navigation = $341c792fffde747f$export$d0fd4b7106de2769();
    $aqdBs.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $341c792fffde747f$var$usePageHide($aqdBs.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $341c792fffde747f$var$getScrollRestorationKey(location, matches, basename, getKey);
            $341c792fffde747f$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $341c792fffde747f$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($341c792fffde747f$var$savedScrollPositions));
        } catch (error) {
            $341c792fffde747f$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $aqdBs.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $341c792fffde747f$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $341c792fffde747f$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $aqdBs.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($341c792fffde747f$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$341c792fffde747f$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $aqdBs.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $341c792fffde747f$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $341c792fffde747f$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $341c792fffde747f$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $341c792fffde747f$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $341c792fffde747f$export$b273b3273281a049(when);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $341c792fffde747f$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $aqdBs.useContext($341c792fffde747f$export$3681f408decb40d1);
    $341c792fffde747f$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $341c792fffde747f$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $341c792fffde747f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $341c792fffde747f$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $341c792fffde747f$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $341c792fffde747f$export$81336c211d5ff295(path.pathname, nextPath) != null || $341c792fffde747f$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $341c792fffde747f$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $341c792fffde747f$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $341c792fffde747f$var$getStatelessNavigator();
    return /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $341c792fffde747f$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $341c792fffde747f$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $341c792fffde747f$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $341c792fffde747f$var$serializeErrors(context.errors)
        };
        let json = $341c792fffde747f$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $aqdBs.createElement($341c792fffde747f$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $aqdBs.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $341c792fffde747f$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $341c792fffde747f$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $341c792fffde747f$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($341c792fffde747f$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $341c792fffde747f$var$getStatelessNavigator() {
    return {
        createHref: $341c792fffde747f$var$createHref,
        encodeLocation: $341c792fffde747f$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $341c792fffde747f$export$69163f0b72ec60d9(routes, opts) {
    return $341c792fffde747f$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $341c792fffde747f$export$9269a41d8c4635e
    });
}
function $341c792fffde747f$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $341c792fffde747f$export$87cb1a9238dc3fba(routes, $341c792fffde747f$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $341c792fffde747f$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $341c792fffde747f$var$createHref,
        encodeLocation: $341c792fffde747f$var$encodeLocation,
        getFetcher () {
            return $341c792fffde747f$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $341c792fffde747f$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $341c792fffde747f$var$createHref(to) {
    return typeof to === "string" ? to : $341c792fffde747f$export$fe53371bee54353d(to);
}
function $341c792fffde747f$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $341c792fffde747f$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $341c792fffde747f$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $341c792fffde747f$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;




var $aqdBs = parcelRequire("aqdBs");


parcelRequire("aqdBs");
var $99899ff752f57db8$export$356109f9df11377f = /*#__PURE__*/ function(IconLibrary) {
    IconLibrary["ACKNOWLEDGED"] = "ACKNOWLEDGED";
    IconLibrary["ACKNOWLEDGEMENT_DISABLED"] = "ACKNOWLEDGEMENT_DISABLED";
    IconLibrary["ACTIVITY"] = "ACTIVITY";
    IconLibrary["ALERT_INFO"] = "ALERT_INFO";
    IconLibrary["ALIGN_LEFT"] = "ALIGN_LEFT";
    IconLibrary["ARCHIVE"] = "ARCHIVE";
    IconLibrary["ARTICLE"] = "ARTICLE";
    IconLibrary["ARROW_LEFT"] = "ARROW_LEFT";
    IconLibrary["AUDIO"] = "AUDIO";
    IconLibrary["BELL"] = "BELL";
    IconLibrary["BELL_RING"] = "BELL_RING";
    IconLibrary["BIN"] = "BIN";
    IconLibrary["BOOKMARK"] = "BOOKMARK";
    IconLibrary["BROADCAST"] = "BROADCAST";
    IconLibrary["BRIEFCASE"] = "BRIEFCASE";
    IconLibrary["BUOY"] = "BUOY";
    IconLibrary["CALENDAR"] = "CALENDAR";
    IconLibrary["CAMERA"] = "CAMERA";
    IconLibrary["CAMERA_OFF"] = "CAMERA_OFF";
    IconLibrary["CHECK"] = "CHECK";
    IconLibrary["CHECKBOX"] = "CHECKBOX";
    IconLibrary["CHECK_DOUBLE"] = "CHECK_DOUBLE";
    IconLibrary["CHEVRON_DOWN"] = "CHEVRON_DOWN";
    IconLibrary["CHEVRON_UP_DOWN"] = "CHEVRON_UP_DOWN";
    IconLibrary["CHEVRON_RIGHT"] = "CHEVRON_RIGHT";
    IconLibrary["CHOICE_PILL"] = "CHOICE_PILL";
    IconLibrary["CIRCLE_CHECK"] = "CIRCLE_CHECK";
    IconLibrary["CIRCLE_CLOSE"] = "CIRCLE_CLOSE";
    IconLibrary["CIRCLE_LEFT"] = "CIRCLE_LEFT";
    IconLibrary["CIRCLE_RIGHT"] = "CIRCLE_RIGHT";
    IconLibrary["CLEAR_FIELD"] = "CLEAR_FIELD";
    IconLibrary["CLOCK"] = "CLOCK";
    IconLibrary["CLOSE"] = "CLOSE";
    IconLibrary["COG"] = "COG";
    IconLibrary["COMMENT"] = "COMMENT";
    IconLibrary["COMMENT_ACTIVE"] = "COMMENT_ACTIVE";
    IconLibrary["COMPETITION"] = "COMPETITION";
    IconLibrary["COMPUTER_EXTERNAL"] = "COMPUTER_EXTERNAL";
    IconLibrary["CONTACT"] = "CONTACT";
    IconLibrary["COPY"] = "COPY";
    IconLibrary["DASH"] = "DASH";
    IconLibrary["DOWNLOAD"] = "DOWNLOAD";
    IconLibrary["DRAG"] = "DRAG";
    IconLibrary["DROPDOWN"] = "DROPDOWN";
    IconLibrary["EMPTY_SEARCH"] = "EMPTY_SEARCH";
    IconLibrary["EXISTING"] = "EXISTING";
    IconLibrary["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    IconLibrary["EYE_ON"] = "EYE_ON";
    IconLibrary["EYE_OFF"] = "EYE_OFF";
    IconLibrary["FACE_ID"] = "FACE_ID";
    IconLibrary["FILE_DOWNLOAD"] = "FILE_DOWNLOAD";
    IconLibrary["FILE_RESPONSE"] = "FILE_RESPONSE";
    IconLibrary["FILE_UPLOAD"] = "FILE_UPLOAD";
    IconLibrary["FILTERS"] = "FILTERS";
    IconLibrary["FILTERS_ACTIVE"] = "FILTERS_ACTIVE";
    IconLibrary["FLAG"] = "FLAG";
    IconLibrary["GLOBE"] = "GLOBE";
    IconLibrary["HOME"] = "HOME";
    IconLibrary["HEART"] = "HEART";
    IconLibrary["HEART_ACTIVE"] = "HEART_ACTIVE";
    IconLibrary["IMAGE"] = "IMAGE";
    IconLibrary["IMAGE_UPLOAD"] = "IMAGE_UPLOAD";
    IconLibrary["INFO"] = "INFO";
    IconLibrary["INPUT_DOTS"] = "INPUT_DOTS";
    IconLibrary["KEY"] = "KEY";
    IconLibrary["LIBRARY"] = "LIBRARY";
    IconLibrary["LIKE"] = "LIKE";
    IconLibrary["LIKE_ACTIVE"] = "LIKE_ACTIVE";
    IconLibrary["LINK"] = "LINK";
    IconLibrary["LINKED"] = "LINKED";
    IconLibrary["LIST"] = "LIST";
    IconLibrary["LIST_ITEM"] = "LIST_ITEM";
    IconLibrary["LOCK"] = "LOCK";
    IconLibrary["LOCKER"] = "LOCKER";
    IconLibrary["LOGOUT"] = "LOGOUT";
    IconLibrary["MAIL"] = "MAIL";
    IconLibrary["MAP_PIN"] = "MAP_PIN";
    IconLibrary["MAXIMISE"] = "MAXIMISE";
    IconLibrary["MENTIONS"] = "MENTIONS";
    IconLibrary["MENU"] = "MENU";
    IconLibrary["MENU_MORE"] = "MENU_MORE";
    IconLibrary["MIDDOT"] = "MIDDOT";
    IconLibrary["MINIMISE"] = "MINIMISE";
    IconLibrary["OLD_PHONE"] = "OLD_PHONE";
    IconLibrary["ORDER_BOTTOM"] = "ORDER_BOTTOM";
    IconLibrary["ORDER_DOWN"] = "ORDER_DOWN";
    IconLibrary["ORDER_TOP"] = "ORDER_TOP";
    IconLibrary["ORDER_UP"] = "ORDER_UP";
    IconLibrary["PARAGRAPH"] = "PARAGRAPH";
    IconLibrary["PASSKEY"] = "PASSKEY";
    IconLibrary["PAUSE"] = "PAUSE";
    IconLibrary["PENCIL"] = "PENCIL";
    IconLibrary["PERSON"] = "PERSON";
    IconLibrary["PHONE"] = "PHONE";
    IconLibrary["PLAY"] = "PLAY";
    IconLibrary["RECOVERY"] = "RECOVERY";
    IconLibrary["REPEAT"] = "REPEAT";
    IconLibrary["RIBBON"] = "RIBBON";
    IconLibrary["RSS"] = "RSS";
    IconLibrary["SEARCH_GLASS"] = "SEARCH_GLASS";
    IconLibrary["SEND"] = "SEND";
    IconLibrary["SETTINGS"] = "SETTINGS";
    IconLibrary["SHARE"] = "SHARE";
    IconLibrary["SKIP_BACK"] = "SKIP_BACK";
    IconLibrary["SKIP_FORWARD"] = "SKIP_FORWARD";
    IconLibrary["SKIP_TO_FIRST"] = "SKIP_TO_FIRST";
    IconLibrary["SKIP_TO_LAST"] = "SKIP_TO_LAST";
    IconLibrary["SKIP_TO_NEXT"] = "SKIP_TO_NEXT";
    IconLibrary["SKIP_TO_PREVIOUS"] = "SKIP_TO_PREVIOUS";
    IconLibrary["SMILEY_BELL"] = "SMILEY_BELL";
    IconLibrary["SOCIAL_FACEBOOK"] = "SOCIAL_FACEBOOK";
    IconLibrary["SOCIAL_X"] = "SOCIAL_X";
    IconLibrary["SOCIAL_LINKED_IN"] = "SOCIAL_LINKED_IN";
    IconLibrary["SPOTLIGHT"] = "SPOTLIGHT";
    IconLibrary["THRIVE"] = "THRIVE";
    IconLibrary["TOUCH_ID"] = "TOUCH_ID";
    IconLibrary["UNLOCK"] = "UNLOCK";
    IconLibrary["USER_COG"] = "USER_COG";
    IconLibrary["USER_NONE"] = " USER_NONE";
    IconLibrary["USER_PASSKEY"] = "USER_PASSKEY";
    IconLibrary["USER_PLUS"] = "USER_PLUS";
    IconLibrary["USER_SEARCH"] = "USER_SEARCH";
    IconLibrary["USERS"] = "USERS";
    IconLibrary["VIDEO"] = "VIDEO";
    IconLibrary["WARNING"] = "WARNING";
    IconLibrary["WARNING_BADGE"] = "WARNING_BADGE";
    IconLibrary["WEBPAGE"] = "WEBPAGE";
    return IconLibrary;
}({});



parcelRequire("aqdBs");

var $4c5a25ac8a95113d$export$9142130869e22063 = /*#__PURE__*/ function(ActionFeedback) {
    ActionFeedback["SUCCESS"] = "SUCCESS";
    ActionFeedback["ERROR"] = "ERROR";
    ActionFeedback["DELETED"] = "DELETED";
    return ActionFeedback;
}({});


function $ac411418a6b9347a$export$66f32c9c70bb3715(icon) {
    return $ac411418a6b9347a$export$effd17f3a6f74d3a[icon];
}
function $ac411418a6b9347a$export$a6898a2c052ba3c8(svgPaths) {
    const pathMatches = svgPaths.match(/<path([^>]*)\/>/g);
    if (!pathMatches) return [];
    const pathElements = pathMatches.map((match)=>{
        const pathDataMatch = match.match(/d="([^"]+)"/);
        if (pathDataMatch?.[1]) return pathDataMatch[1];
    });
    return pathElements;
}
function $ac411418a6b9347a$export$636f3250b1105469(action) {
    switch(action){
        case (0, $4c5a25ac8a95113d$export$9142130869e22063).SUCCESS:
            return (0, $99899ff752f57db8$export$356109f9df11377f).ACKNOWLEDGED;
        case (0, $4c5a25ac8a95113d$export$9142130869e22063).ERROR:
            return (0, $99899ff752f57db8$export$356109f9df11377f).CLEAR_FIELD;
        case (0, $4c5a25ac8a95113d$export$9142130869e22063).DELETED:
            return (0, $99899ff752f57db8$export$356109f9df11377f).BIN;
        default:
            return (0, $99899ff752f57db8$export$356109f9df11377f).ACKNOWLEDGED;
    }
}
function $ac411418a6b9347a$export$dd97b7e27ecaf77d(activity) {
    switch(activity){
        case "accountRecoveryRequest":
            return (0, $99899ff752f57db8$export$356109f9df11377f).USER_PASSKEY;
        case "contentLike":
        case "commentLike":
            return (0, $99899ff752f57db8$export$356109f9df11377f).LIKE_ACTIVE;
        case "comment":
        case "commentReply":
            return (0, $99899ff752f57db8$export$356109f9df11377f).COMMENT_ACTIVE;
        case "objectionableComment":
            return (0, $99899ff752f57db8$export$356109f9df11377f).WARNING_BADGE;
        case "moderatedRecognition":
        case "recognition":
            return (0, $99899ff752f57db8$export$356109f9df11377f).RIBBON;
        case "acknowledgementResponse":
            return (0, $99899ff752f57db8$export$356109f9df11377f).FLAG;
        case "contentPosted":
        case "moderatedContent":
            return (0, $99899ff752f57db8$export$356109f9df11377f).ARTICLE;
        case "competitionPost":
            return (0, $99899ff752f57db8$export$356109f9df11377f).COMPETITION;
        case "compliancePost":
            return (0, $99899ff752f57db8$export$356109f9df11377f).FLAG;
        case "eventPost":
            return (0, $99899ff752f57db8$export$356109f9df11377f).CALENDAR;
        case "formResponse":
            return (0, $99899ff752f57db8$export$356109f9df11377f).FILE_RESPONSE;
        default:
            return (0, $99899ff752f57db8$export$356109f9df11377f).LIKE_ACTIVE;
    }
}
function $ac411418a6b9347a$export$c0fec09c9ba54f32(itemType) {
    switch(itemType.toLowerCase()){
        case "list":
            return (0, $99899ff752f57db8$export$356109f9df11377f).LIST;
        case "page":
            return (0, $99899ff752f57db8$export$356109f9df11377f).LIST_ITEM;
        case "web":
            return (0, $99899ff752f57db8$export$356109f9df11377f).WEBPAGE;
        case "image":
            return (0, $99899ff752f57db8$export$356109f9df11377f).IMAGE;
        case "video":
            return (0, $99899ff752f57db8$export$356109f9df11377f).VIDEO;
        case "file":
            return (0, $99899ff752f57db8$export$356109f9df11377f).LIST_ITEM;
        case "contact":
            return (0, $99899ff752f57db8$export$356109f9df11377f).CONTACT;
        case "rss":
            return (0, $99899ff752f57db8$export$356109f9df11377f).RSS;
        case "audio":
            return (0, $99899ff752f57db8$export$356109f9df11377f).AUDIO;
        default:
            return (0, $99899ff752f57db8$export$356109f9df11377f).IMAGE_UPLOAD;
    }
}
const $ac411418a6b9347a$export$effd17f3a6f74d3a = {
    [(0, $99899ff752f57db8$export$356109f9df11377f).ACKNOWLEDGED]: `<path d="M39.9905 4C46.5127 4 52.5601 5.63291 58.1329 8.89873C63.5538 12.1171 67.8734 16.4367 71.0918 21.8576C74.3576 27.4209 75.9905 33.4684 75.9905 40C75.9905 46.5316 74.3576 52.5696 71.0918 58.1424C67.8734 63.5633 63.5538 67.8829 58.1329 71.1013C52.5696 74.3671 46.5222 76 39.9905 76C33.4589 76 27.4209 74.3671 21.8481 71.1013C16.4272 67.8829 12.1076 63.5633 8.88924 58.1424C5.63291 52.5696 4 46.5222 4 39.9905C4 33.4589 5.63291 27.4209 8.89873 21.8481C12.1171 16.4272 16.4367 12.1076 21.8576 8.88924C27.4209 5.63291 33.4684 4 39.9905 4ZM56.6899 25.019L35.0253 46.3228L26.3196 37.8259L22 42.0696L35.0253 54.9525L61.0095 29.2532L56.6899 25.0095V25.019Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ACKNOWLEDGEMENT_DISABLED]: `<path d="M39.9905 4C46.5127 4 52.5601 5.63291 58.1329 8.89873C63.5538 12.1171 67.8734 16.4367 71.0918 21.8576C74.3576 27.4209 75.9905 33.4684 75.9905 40C75.9905 46.5316 74.3576 52.5696 71.0918 58.1424C67.8734 63.5633 63.5538 67.8829 58.1329 71.1013C52.5696 74.3671 46.5222 76 39.9905 76C33.4589 76 27.4209 74.3671 21.8481 71.1013C16.4272 67.8829 12.1076 63.5633 8.88924 58.1424C5.63291 52.5696 4 46.5222 4 39.9905C4 33.4589 5.63291 27.4209 8.89873 21.8481C12.1171 16.4272 16.4367 12.1076 21.8576 8.88924C27.4209 5.63291 33.4684 4 39.9905 4ZM22.4272 36.3924L22.2848 43.5222L57.7057 43.4462V36.4684L22.4367 36.3924H22.4272Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ACTIVITY]: `<path d="M26.5215 23.8451L38.1004 73.078C38.9855 76.8411 44.2757 77.019 45.4115 73.3238L56.5703 37.0197L58.0293 42.8081C58.4536 44.4916 59.9677 45.6714 61.7038 45.6714H73.9999C76.0927 45.6714 77.7893 43.9748 77.7893 41.882C77.7893 39.7891 76.0927 38.0925 73.9999 38.0925H64.6567L60.6059 22.0212C59.6688 18.3034 54.4355 18.1692 53.3091 21.834L42.2761 57.7285L30.3271 6.92191C29.4177 3.05506 23.928 3.01513 22.9625 6.86834L15.1379 38.0925H5.78947C3.6966 38.0925 2 39.7891 2 41.882C2 43.9748 3.6966 45.6714 5.78947 45.6714H18.095C19.833 45.6714 21.3483 44.489 21.7708 42.8031L26.5215 23.8451Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ALERT_INFO]: `<path fillRule="evenodd" clipRule="evenodd" d="M4.00024 40C4.00024 20.1177 20.118 4 40.0002 4C59.8825 4 76.0002 20.1177 76.0002 40C76.0002 59.8823 59.8825 76 40.0002 76C20.118 76 4.00024 59.8823 4.00024 40ZM40.0002 10.5455C23.7329 10.5455 10.5457 23.7327 10.5457 40C10.5457 56.2673 23.7329 69.4545 40.0002 69.4545C56.2675 69.4545 69.4548 56.2673 69.4548 40C69.4548 23.7327 56.2675 10.5455 40.0002 10.5455ZM40.0002 23.6364C41.8077 23.6364 43.273 25.1016 43.273 26.9091V40.0001C43.273 41.8076 41.8077 43.2728 40.0002 43.2728C38.1928 43.2728 36.7275 41.8076 36.7275 40.0001V26.9091C36.7275 25.1016 38.1928 23.6364 40.0002 23.6364ZM36.7275 53.0909C36.7275 51.2834 38.1928 49.8182 40.0002 49.8182H40.0335C41.8409 49.8182 43.3062 51.2834 43.3062 53.0909C43.3062 54.8984 41.8409 56.3637 40.0335 56.3637H40.0002C38.1928 56.3637 36.7275 54.8984 36.7275 53.0909Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ALIGN_LEFT]: `<path fillRule="evenodd" clipRule="evenodd" d="M3.99976 18.6359C3.99976 16.6278 5.62758 15 7.63561 15H72.364C74.372 15 75.9998 16.6278 75.9998 18.6359C75.9998 20.6439 74.372 22.2717 72.364 22.2717H7.63561C5.62758 22.2717 3.99976 20.6439 3.99976 18.6359ZM3.99976 32.8618C3.99976 30.8537 5.62758 29.226 7.63561 29.226H57.9799C59.9879 29.226 61.6157 30.8537 61.6157 32.8618C61.6157 34.8699 59.9879 36.4976 57.9799 36.4976H7.63561C5.62758 36.4976 3.99976 34.8699 3.99976 32.8618ZM3.99976 47.0877C3.99976 45.0797 5.62758 43.4518 7.63561 43.4518H72.364C74.372 43.4518 75.9998 45.0797 75.9998 47.0877C75.9998 49.0958 74.372 50.7236 72.364 50.7236H7.63561C5.62758 50.7236 3.99976 49.0958 3.99976 47.0877ZM3.99976 61.314C3.99976 59.306 5.62758 57.6782 7.63561 57.6782H57.9799C59.9879 57.6782 61.6157 59.306 61.6157 61.314C61.6157 63.3221 59.9879 64.9499 57.9799 64.9499H7.63561C5.62758 64.9499 3.99976 63.3221 3.99976 61.314Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ARCHIVE]: `<path fillRule="evenodd" clipRule="evenodd" d="M4 13.5455C4 9.9305 6.9305 7 10.5455 7H69.4545C73.0695 7 76 9.9305 76 13.5455V23.3636C76 26.9786 73.0695 29.9091 69.4545 29.9091V62.6364C69.4545 65.2403 68.4201 67.7376 66.5789 69.5789C64.7376 71.4201 62.2403 72.4545 59.6364 72.4545H20.3636C17.7597 72.4545 15.2624 71.4201 13.4211 69.5789C11.5799 67.7376 10.5455 65.2403 10.5455 62.6364V29.9091C6.9305 29.9091 4 26.9786 4 23.3636V13.5455ZM17.0909 29.9091V62.6364C17.0909 63.5043 17.4357 64.3368 18.0495 64.9505C18.6632 65.5643 19.4957 65.9091 20.3636 65.9091H59.6364C60.5043 65.9091 61.3368 65.5643 61.9505 64.9505C62.5643 64.3368 62.9091 63.5043 62.9091 62.6364V29.9091H17.0909ZM10.5455 23.3636V13.5455H69.4545V23.3636H10.5455ZM30.1818 39.7273C30.1818 37.9198 31.6471 36.4545 33.4545 36.4545H46.5455C48.3529 36.4545 49.8182 37.9198 49.8182 39.7273C49.8182 41.5348 48.3529 43 46.5455 43H33.4545C31.6471 43 30.1818 41.5348 30.1818 39.7273Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ARTICLE]: `<path fillRule="evenodd" clipRule="evenodd" d="M21.1031 5.94654C23.3838 4.62973 26.2382 4 29.0273 4H63.7469C66.536 4 69.3904 4.62973 71.6711 5.94654C73.8947 7.23031 76 9.48306 76 12.5846V65.0949C76 67.7512 74.9214 70.2831 73.027 72.1378C71.1351 73.99 68.585 75.0174 65.9414 75.0174H14.0586C11.415 75.0174 8.86489 73.99 6.97301 72.1378C5.07855 70.2831 4 67.7512 4 65.0949V36.523C4 33.8666 5.07855 31.3348 6.97301 29.4801C8.86489 27.6279 11.415 26.6005 14.0586 26.6005H16.7742V12.5846C16.7742 9.48307 18.8795 7.23031 21.1031 5.94654ZM16.7742 33.7469H14.0586C13.2621 33.7469 12.513 34.0574 11.9724 34.5866C11.4344 35.1134 11.1464 35.8115 11.1464 36.523V65.0949C11.1464 65.8064 11.4344 66.5045 11.9724 67.0312C12.513 67.5605 13.2621 67.871 14.0586 67.871H16.7742V33.7469ZM23.9206 67.871H65.9414C66.7379 67.871 67.487 67.5605 68.0276 67.0312C68.5656 66.5045 68.8536 65.8064 68.8536 65.0949V12.7373C68.7705 12.6265 68.5535 12.3986 68.0979 12.1355C67.123 11.5726 65.5619 11.1464 63.7469 11.1464H29.0273C27.2123 11.1464 25.6512 11.5726 24.6763 12.1355C24.2207 12.3986 24.0037 12.6265 23.9206 12.7373V67.871Z"/>
<path fillRule="evenodd" clipRule="evenodd" d="M31 20.2727C31 18.4653 32.4652 17 34.2727 17H60.4545C62.262 17 63.7273 18.4653 63.7273 20.2727V33.3636C63.7273 35.1711 62.262 36.6364 60.4545 36.6364H34.2727C32.4652 36.6364 31 35.1711 31 33.3636V20.2727ZM37.5455 23.5455V30.0909H57.1818V23.5455H37.5455ZM31 46.4529C31 44.6455 32.4652 43.1802 34.2727 43.1802H60.4545C62.262 43.1802 63.7273 44.6455 63.7273 46.4529C63.7273 48.2604 62.262 49.7257 60.4545 49.7257H34.2727C32.4652 49.7257 31 48.2604 31 46.4529ZM31 59.5455C31 57.738 32.4652 56.2727 34.2727 56.2727H50.6364C52.4438 56.2727 53.9091 57.738 53.9091 59.5455C53.9091 61.3529 52.4438 62.8182 50.6364 62.8182H34.2727C32.4652 62.8182 31 61.3529 31 59.5455Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ARROW_LEFT]: `<path fillRule="evenodd" clipRule="evenodd" d="M43.182 5.31802C44.9393 7.07538 44.9393 9.92462 43.182 11.682L19.364 35.5H71.5C73.9853 35.5 76 37.5147 76 40C76 42.4853 73.9853 44.5 71.5 44.5H19.364L43.182 68.318C44.9393 70.0754 44.9393 72.9246 43.182 74.682C41.4246 76.4393 38.5754 76.4393 36.818 74.682L5.31802 43.182C3.56066 41.4246 3.56066 38.5754 5.31802 36.818L36.818 5.31802C38.5754 3.56066 41.4246 3.56066 43.182 5.31802Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).AUDIO]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 11.2C32.3618 11.2 25.0364 14.2343 19.6353 19.6353C14.2343 25.0364 11.2 32.3618 11.2 40V61.6C11.2 63.5882 9.58823 65.2 7.6 65.2C5.61177 65.2 4 63.5882 4 61.6V40C4 30.4522 7.79285 21.2955 14.5442 14.5442C21.2955 7.79285 30.4522 4 40 4C49.5478 4 58.7045 7.79285 65.4558 14.5442C72.2072 21.2955 76 30.4522 76 40V61.6C76 63.5882 74.3882 65.2 72.4 65.2C70.4118 65.2 68.8 63.5882 68.8 61.6V40C68.8 32.3618 65.7657 25.0364 60.3647 19.6353C54.9636 14.2343 47.6382 11.2 40 11.2Z"/><path fillRule="evenodd" clipRule="evenodd" d="M4 47.2C4 45.2118 5.61177 43.6 7.6 43.6H18.4C21.2643 43.6 24.0114 44.7379 26.0368 46.7633C28.0621 48.7886 29.2 51.5357 29.2 54.4V65.2C29.2 68.0643 28.0621 70.8114 26.0368 72.8368C24.0114 74.8621 21.2643 76 18.4 76H14.8C11.9357 76 9.18864 74.8621 7.16325 72.8368C5.13785 70.8114 4 68.0643 4 65.2V47.2ZM11.2 50.8V65.2C11.2 66.1548 11.5793 67.0705 12.2544 67.7456C12.9295 68.4207 13.8452 68.8 14.8 68.8H18.4C19.3548 68.8 20.2705 68.4207 20.9456 67.7456C21.6207 67.0705 22 66.1548 22 65.2V54.4C22 53.4452 21.6207 52.5296 20.9456 51.8544C20.2705 51.1793 19.3548 50.8 18.4 50.8H11.2ZM61.6 50.8C60.6452 50.8 59.7296 51.1793 59.0544 51.8544C58.3793 52.5296 58 53.4452 58 54.4V65.2C58 66.1548 58.3793 67.0704 59.0544 67.7456C59.7296 68.4207 60.6452 68.8 61.6 68.8H65.2C66.1548 68.8 67.0705 68.4207 67.7456 67.7456C68.4207 67.0704 68.8 66.1548 68.8 65.2V50.8H61.6ZM53.9633 46.7633C55.9886 44.7379 58.7357 43.6 61.6 43.6H72.4C74.3882 43.6 76 45.2118 76 47.2V65.2C76 68.0643 74.8621 70.8114 72.8368 72.8368C70.8114 74.8621 68.0643 76 65.2 76H61.6C58.7357 76 55.9886 74.8621 53.9633 72.8368C51.9379 70.8114 50.8 68.0643 50.8 65.2V54.4C50.8 51.5357 51.9379 48.7886 53.9633 46.7633Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).BELL]: `<path fillRule="evenodd" clipRule="evenodd" d="M23.531 10.711C27.828 6.41402 33.6559 4 39.7327 4C45.8096 4 51.6375 6.41402 55.9345 10.711C60.2315 15.008 62.6455 20.8359 62.6455 26.9128C62.6455 37.8869 64.9926 44.7017 67.1557 48.6673C68.2417 50.6584 69.2992 51.9646 70.0338 52.74C70.402 53.1286 70.6913 53.3863 70.8655 53.5314C70.9526 53.6041 71.0111 53.6486 71.0363 53.6674C71.0402 53.6703 71.0433 53.6726 71.0456 53.6743C72.219 54.4803 72.7383 55.9548 72.3248 57.3206C71.9068 58.7011 70.6344 59.6453 69.192 59.6453H10.2735C8.83109 59.6453 7.55869 58.7011 7.1407 57.3206C6.72715 55.9547 7.24641 54.4803 8.41982 53.6743C8.42211 53.6726 8.42524 53.6703 8.42918 53.6674C8.45438 53.6486 8.51282 53.6041 8.59996 53.5314C8.77415 53.3863 9.06345 53.1286 9.43161 52.74C10.1662 51.9646 11.2238 50.6584 12.3098 48.6673C14.4729 44.7017 16.82 37.8869 16.82 26.9128C16.82 20.8359 19.234 15.008 23.531 10.711ZM8.45365 53.6514C8.45363 53.6514 8.45361 53.6514 8.45359 53.6514ZM17.3088 53.0988H62.1567C61.9076 52.6907 61.6576 52.2588 61.4085 51.8021C58.6617 46.7663 56.099 38.8515 56.099 26.9128C56.099 22.5722 54.3747 18.4093 51.3054 15.3401C48.2361 12.2708 44.0733 10.5465 39.7327 10.5465C35.3921 10.5465 31.2293 12.2708 28.1601 15.3401C25.0908 18.4093 23.3665 22.5722 23.3665 26.9128C23.3665 38.8515 20.8038 46.7663 18.0569 51.8021C17.8079 52.2588 17.5578 52.6907 17.3088 53.0988ZM32.4276 66.6337C33.9913 65.7266 35.9943 66.2589 36.9014 67.8227C37.1891 68.3187 37.6021 68.7304 38.099 69.0166C38.5959 69.3028 39.1593 69.4535 39.7327 69.4535C40.3062 69.4535 40.8696 69.3028 41.3665 69.0166C41.8634 68.7304 42.2764 68.3187 42.5641 67.8227C43.4712 66.2589 45.4742 65.7266 47.0379 66.6337C48.6016 67.5408 49.1339 69.5438 48.2268 71.1075C47.3636 72.5956 46.1246 73.8308 44.6339 74.6894C43.1432 75.5481 41.453 76 39.7327 76C38.0124 76 36.3223 75.5481 34.8316 74.6894C33.3408 73.8308 32.1019 72.5956 31.2387 71.1075C30.3316 69.5438 30.8639 67.5408 32.4276 66.6337Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).BELL_RING]: `<path fillRule="evenodd" clipRule="evenodd" d="M23.8008 10.71C28.0971 6.41378 33.9241 4.00019 40 4.00019C46.0759 4.00019 51.9029 6.41378 56.1992 10.71C60.4955 15.0062 62.9091 20.8331 62.9091 26.9088C62.9091 37.881 65.2559 44.6946 67.4186 48.6595C68.5044 50.6502 69.5618 51.9561 70.2963 52.7314C70.6644 53.12 70.9537 53.3776 71.1278 53.5227C71.2149 53.5953 71.2734 53.6399 71.2986 53.6586L71.3079 53.6655C72.4811 54.4714 73.0003 55.9456 72.5868 57.3112C72.1689 58.6915 70.8967 59.6355 69.4545 59.6355H10.5455C9.10327 59.6355 7.83108 58.6915 7.41315 57.3112C6.99967 55.9456 7.51885 54.4714 8.69208 53.6655L8.70143 53.6586C8.72663 53.6399 8.78506 53.5953 8.87218 53.5227C9.04634 53.3776 9.3356 53.12 9.7037 52.7314C10.4382 51.9561 11.4956 50.6502 12.5814 48.6595C14.7441 44.6946 17.0909 37.881 17.0909 26.9088C17.0909 20.8331 19.5045 15.0062 23.8008 10.71Z"/><path fillRule="evenodd" clipRule="evenodd" d="M32.696 66.6226C34.2595 65.7157 36.2622 66.2479 37.1691 67.8114C37.4568 68.3073 37.8697 68.719 38.3665 69.0051C38.8634 69.2913 39.4266 69.4419 40 69.4419C40.5734 69.4419 41.1366 69.2913 41.6335 69.0051C42.1303 68.719 42.5432 68.3073 42.8309 67.8114C43.7378 66.2479 45.7405 65.7157 47.304 66.6226C48.8674 67.5296 49.3997 69.5322 48.4927 71.0956C47.6297 72.5834 46.3909 73.8184 44.9004 74.6769C43.4099 75.5354 41.72 75.9872 40 75.9872C38.28 75.9872 36.5901 75.5354 35.0996 74.6769C33.6091 73.8184 32.3703 72.5834 31.5073 71.0956C30.6003 69.5322 31.1326 67.5296 32.696 66.6226Z"/><path fillRule="evenodd" clipRule="evenodd" d="M15.8062 4.67319C17.242 5.77112 17.5159 7.82508 16.4179 9.26084C12.6128 14.2366 10.5455 20.4059 10.5455 26.9088C10.5455 28.7163 9.0802 30.1815 7.27273 30.1815C5.46525 30.1815 4 28.7163 4 26.9088C4 19.0121 6.51443 11.4362 11.2185 5.28488C12.3164 3.84912 14.3704 3.57526 15.8062 4.67319Z"/><path fillRule="evenodd" clipRule="evenodd" d="M64.2182 4.65473C65.6642 3.57026 67.7155 3.8633 68.8 5.30926C73.4736 11.5406 76 19.1197 76 26.9088C76 28.7163 74.5347 30.1815 72.7273 30.1815C70.9198 30.1815 69.4545 28.7163 69.4545 26.9088C69.4545 20.5359 67.3875 14.3348 63.5636 9.23646C62.4791 7.7905 62.7722 5.73919 64.2182 4.65473Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).BIN]: `<path fillRule="evenodd" clipRule="evenodd" d="M7.27258 20.3636C7.27258 18.5562 8.73784 17.0909 10.5453 17.0909H69.4547C71.2622 17.0909 72.7274 18.5562 72.7274 20.3636C72.7274 22.1711 71.2622 23.6364 69.4547 23.6364H10.5453C8.73784 23.6364 7.27258 22.1711 7.27258 20.3636Z"/> <path fillRule="evenodd" clipRule="evenodd" d="M33.4545 10.5455C32.5865 10.5455 31.7541 10.8903 31.1403 11.504C30.5266 12.1178 30.1818 12.9502 30.1818 13.8182V20.3636C30.1818 22.1711 28.7165 23.6364 26.909 23.6364C25.1016 23.6364 23.6363 22.1711 23.6363 20.3636V13.8182C23.6363 11.2142 24.6707 8.71694 26.512 6.87568C28.3533 5.03441 30.8506 4 33.4545 4H46.5455C49.1494 4 51.6468 5.03441 53.488 6.87568C55.3293 8.71694 56.3637 11.2142 56.3637 13.8182V20.3636C56.3637 22.1711 54.8985 23.6364 53.091 23.6364C51.2835 23.6364 49.8182 22.1711 49.8182 20.3636V13.8182C49.8182 12.9502 49.4734 12.1178 48.8597 11.504C48.2459 10.8903 47.4135 10.5455 46.5455 10.5455H33.4545ZM17.0908 17.0909C18.8983 17.0909 20.3636 18.5562 20.3636 20.3636V66.1818C20.3636 67.0498 20.7084 67.8822 21.3221 68.496C21.9359 69.1097 22.7683 69.4545 23.6363 69.4545H56.3637C57.2317 69.4545 58.0641 69.1097 58.6779 68.496C59.2917 67.8822 59.6365 67.0498 59.6365 66.1818V20.3636C59.6365 18.5562 61.1017 17.0909 62.9092 17.0909C64.7167 17.0909 66.1819 18.5562 66.1819 20.3636V66.1818C66.1819 68.7858 65.1475 71.2831 63.3063 73.1243C61.465 74.9656 58.9677 76 56.3637 76H23.6363C21.0323 76 18.535 74.9656 16.6938 73.1243C14.8525 71.2831 13.8181 68.7858 13.8181 66.1818V20.3636C13.8181 18.5562 15.2833 17.0909 17.0908 17.0909Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).BOOKMARK]: `<path fillRule="evenodd" clipRule="evenodd" d="M20 8C18.9391 8 17.9217 8.42143 17.1716 9.17157C16.4214 9.92172 16 10.9391 16 12V69.1073L38.0154 56.527C39.2452 55.8243 40.7548 55.8243 41.9846 56.527L64 69.1073V12C64 10.9391 63.5786 9.92172 62.8284 9.17157C62.0783 8.42143 61.0609 8 60 8H20ZM11.5147 3.51472C13.7652 1.26428 16.8174 0 20 0H60C63.1826 0 66.2348 1.26428 68.4853 3.51472C70.7357 5.76515 72 8.8174 72 12V76C72 77.4259 71.241 78.7439 70.0077 79.4596C68.7744 80.1753 67.2535 80.1804 66.0154 79.473L40 64.607L13.9846 79.473C12.7465 80.1804 11.2256 80.1753 9.99229 79.4596C8.75903 78.7439 8 77.4259 8 76V12C8 8.8174 9.26428 5.76516 11.5147 3.51472Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).BRIEFCASE]: `<path fillRule="evenodd"clipRule="evenodd" d="M13.8182 26.6365C12.0107 26.6365 10.5454 28.1017 10.5454 29.9092V62.6366C10.5454 64.4441 12.0107 65.9094 13.8182 65.9094H66.1818C67.9893 65.9094 69.4545 64.4441 69.4545 62.6366V29.9092C69.4545 28.1017 67.9893 26.6365 66.1818 26.6365H13.8182ZM3.99999 29.9092C3.99999 24.4867 8.39574 20.091 13.8182 20.091H66.1818C71.6042 20.091 76 24.4867 76 29.9092V62.6366C76 68.0591 71.6042 72.4549 66.1818 72.4549H13.8182C8.39574 72.4549 3.99999 68.0591 3.99999 62.6366V29.9092Z"/> <path fillRule="evenodd" clipRule="evenodd" d="M26.512 9.87569C28.3533 8.03442 30.8506 7 33.4545 7H46.5454C49.1494 7 51.6467 8.03442 53.4879 9.87569C55.3292 11.717 56.3636 14.2143 56.3636 16.8182V69.1821C56.3636 70.9896 54.8984 72.4549 53.0909 72.4549C51.2834 72.4549 49.8182 70.9896 49.8182 69.1821V16.8182C49.8182 15.9502 49.4734 15.1178 48.8596 14.5041C48.2459 13.8903 47.4134 13.5455 46.5454 13.5455H33.4545C32.5866 13.5455 31.7541 13.8903 31.1404 14.5041C30.5266 15.1178 30.1818 15.9502 30.1818 16.8182V69.1821C30.1818 70.9896 28.7166 72.4549 26.9091 72.4549C25.1016 72.4549 23.6364 70.9896 23.6364 69.1821V16.8182C23.6364 14.2143 24.6708 11.717 26.512 9.87569Z" /> `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).BROADCAST]: `<path fillRule="evenodd" clipRule="evenodd" d="M19.1253 14.9564C20.4004 16.2316 20.4004 18.299 19.1253 19.5742C7.66575 31.0337 7.66575 49.8642 19.1253 61.3237C20.4004 62.5989 20.4004 64.6664 19.1253 65.9416C17.8501 67.2168 15.7826 67.2168 14.5074 65.9416C0.497546 51.9317 0.497546 28.9663 14.5074 14.9564C15.7826 13.6812 17.8501 13.6812 19.1253 14.9564ZM60.8748 14.9564C62.1499 13.6812 64.2174 13.6812 65.4926 14.9564C79.5025 28.9663 79.5025 51.6052 65.4926 65.615C64.2174 66.8902 62.1499 66.8902 60.8748 65.615C59.5996 64.3399 59.5996 62.2724 60.8748 60.9972C72.3343 49.5377 72.3343 31.0337 60.8748 19.5742C59.5996 18.299 59.5996 16.2316 60.8748 14.9564ZM28.545 24.0468C29.847 25.2946 29.891 27.3616 28.6432 28.6636C22.317 35.2649 22.386 45.6419 28.5946 51.8505C29.8698 53.1257 29.8698 55.1932 28.5946 56.4684C27.3194 57.7435 25.252 57.7435 23.9768 56.4684C15.165 47.6565 15.234 33.2172 23.9282 24.1451C25.176 22.843 27.243 22.7991 28.545 24.0468ZM51.4053 24.427C52.6805 23.1519 54.748 23.1519 56.0232 24.427C64.835 33.2389 64.7659 47.6782 56.0718 56.7503C54.824 58.0524 52.757 58.0963 51.455 56.8486C50.153 55.6008 50.109 53.5338 51.3568 52.2318C57.683 45.6305 57.6139 35.2535 51.4053 29.0449C50.1302 27.7697 50.1302 25.7022 51.4053 24.427ZM40 37.1824C38.1966 37.1824 36.7347 38.6443 36.7347 40.4477C36.7347 42.2511 38.1966 43.713 40 43.713C41.8034 43.713 43.2653 42.2511 43.2653 40.4477C43.2653 38.6443 41.8034 37.1824 40 37.1824ZM30.2041 40.4477C30.2041 35.0376 34.5899 30.6518 40 30.6518C45.4101 30.6518 49.7959 35.0376 49.7959 40.4477C49.7959 45.8578 45.4101 50.2436 40 50.2436C34.5899 50.2436 30.2041 45.8578 30.2041 40.4477Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).BUOY]: `<path fillRule="evenodd" clipRule="evenodd" d="M16.9865 21.6148C12.9557 26.6538 10.5455 33.0454 10.5455 40C10.5455 46.9546 12.9557 53.3462 16.9865 58.3852L26.3475 49.0242C24.6341 46.4373 23.6364 43.3352 23.6364 40C23.6364 36.6648 24.6341 33.5627 26.3475 30.9758L16.9865 21.6148ZM21.6148 16.9865L30.9758 26.3475C33.5627 24.6341 36.6648 23.6364 40 23.6364C43.3352 23.6364 46.4373 24.6341 49.0242 26.3475L58.3852 16.9865C53.3462 12.9557 46.9546 10.5455 40 10.5455C33.0454 10.5455 26.6538 12.9557 21.6148 16.9865ZM63.0135 21.6148L53.6525 30.9758C55.3659 33.5627 56.3636 36.6648 56.3636 40C56.3636 43.3352 55.3659 46.4373 53.6525 49.0242L63.0135 58.3852C67.0443 53.3462 69.4545 46.9546 69.4545 40C69.4545 33.0454 67.0443 26.6538 63.0135 21.6148ZM58.3852 63.0135L49.0242 53.6525C46.4373 55.3659 43.3352 56.3636 40 56.3636C36.6648 56.3636 33.5627 55.3659 30.9758 53.6525L21.6148 63.0135C26.6538 67.0443 33.0454 69.4545 40 69.4545C46.9546 69.4545 53.3462 67.0443 58.3852 63.0135ZM4 40C4 20.1177 20.1177 4 40 4C59.8823 4 76 20.1177 76 40C76 59.8823 59.8823 76 40 76C20.1177 76 4 59.8823 4 40ZM40 30.1818C34.5776 30.1818 30.1818 34.5776 30.1818 40C30.1818 45.4224 34.5776 49.8182 40 49.8182C45.4224 49.8182 49.8182 45.4224 49.8182 40C49.8182 34.5776 45.4224 30.1818 40 30.1818Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CALENDAR]: `<path fillRule="evenodd" clipRule="evenodd" d="M26.6361 4C28.4436 4 29.9088 5.46525 29.9088 7.27272V10.5455H49.5452V7.27272C49.5452 5.46525 51.0104 4 52.8178 4C54.6254 4 56.0906 5.46525 56.0906 7.27272V10.5455H62.6361C68.0586 10.5455 72.4543 14.9412 72.4543 20.3637V66.1818C72.4543 71.6043 68.0586 76 62.6361 76H16.8179C11.3955 76 6.99976 71.6043 6.99976 66.1818V20.3637C6.99976 14.9412 11.3955 10.5455 16.8179 10.5455H23.3634V7.27272C23.3634 5.46525 24.8286 4 26.6361 4ZM23.3634 17.091H16.8179C15.0105 17.091 13.5452 18.5562 13.5452 20.3637V30.1818H65.9088V20.3637C65.9088 18.5562 64.4436 17.091 62.6361 17.091H56.0906V20.3636C56.0906 22.1711 54.6254 23.6363 52.8178 23.6363C51.0104 23.6363 49.5452 22.1711 49.5452 20.3636V17.091H29.9088V20.3636C29.9088 22.1711 28.4436 23.6363 26.6361 23.6363C24.8286 23.6363 23.3634 22.1711 23.3634 20.3636V17.091ZM65.9088 36.7271H13.5452V66.1818C13.5452 67.9893 15.0105 69.4546 16.8179 69.4546H62.6361C64.4437 69.4546 65.9088 67.9893 65.9088 66.1818V36.7271Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CAMERA]: `<path fillRule="evenodd" clipRule="evenodd" d="M29.3042 12.1776C29.926 11.4314 30.8471 11 31.8184 11H48.1821C49.1533 11 50.0744 11.4314 50.6962 12.1776L57.8967 20.8182H66.1821C68.786 20.8182 71.2833 21.8526 73.1246 23.6938C74.9658 25.5351 76.0002 28.0324 76.0002 30.6363V60.0908C76.0002 62.6947 74.9658 65.192 73.1246 67.0333C71.2833 68.8745 68.786 69.909 66.1821 69.909H13.8184C11.2145 69.909 8.71719 68.8746 6.87592 67.0333C5.03466 65.192 4.00024 62.6947 4.00024 60.0908V30.6363C4.00024 28.0324 5.03466 25.5351 6.87592 23.6938C8.71719 21.8526 11.2145 20.8182 13.8184 20.8182H22.1037L29.3042 12.1776ZM33.3513 17.5454L26.1508 26.186C25.529 26.9322 24.6079 27.3636 23.6366 27.3636H13.8184C12.9504 27.3636 12.118 27.7084 11.5043 28.3222C10.8905 28.9359 10.5457 29.7683 10.5457 30.6363V60.0908C10.5457 60.9588 10.8905 61.7912 11.5043 62.405C12.118 63.0187 12.9504 63.3635 13.8184 63.3635H66.1821C67.05 63.3635 67.8825 63.0187 68.4962 62.405C69.11 61.7912 69.4548 60.9588 69.4548 60.0908V30.6363C69.4548 29.7683 69.11 28.9359 68.4962 28.3222C67.8825 27.7084 67.05 27.3636 66.1821 27.3636H56.3639C55.3926 27.3636 54.4715 26.9322 53.8497 26.186L46.6492 17.5454H33.3513ZM40.0002 37.1818C36.3853 37.1818 33.4548 40.1123 33.4548 43.7272C33.4548 47.3421 36.3853 50.2726 40.0002 50.2726C43.6152 50.2726 46.5457 47.3421 46.5457 43.7272C46.5457 40.1123 43.6152 37.1818 40.0002 37.1818ZM26.9093 43.7272C26.9093 36.4973 32.7703 30.6363 40.0002 30.6363C47.2301 30.6363 53.0911 36.4973 53.0911 43.7272C53.0911 50.9571 47.2301 56.8181 40.0002 56.8181C32.7703 56.8181 26.9093 50.9571 26.9093 43.7272Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CAMERA_OFF]: `<path fillRule="evenodd" clipRule="evenodd" d="M4.95868 4.95856C6.23677 3.68048 8.30895 3.68048 9.58703 4.95856L75.0418 70.4131C76.3199 71.6912 76.3199 73.7634 75.0418 75.0414C73.7637 76.3195 71.6915 76.3195 70.4134 75.0414L64.8265 69.4545H13.8183C11.2144 69.4545 8.71708 68.4201 6.87581 66.5789C5.03454 64.7376 4.00012 62.2403 4.00012 59.6364V30.1818C4.00012 27.5779 5.03454 25.0806 6.87581 23.2393C8.71708 21.3981 11.2144 20.3636 13.8183 20.3636H15.7355L4.95868 9.5869C3.6806 8.30882 3.6806 6.23664 4.95868 4.95856ZM22.2809 26.9091H13.8183C12.9504 26.9091 12.1179 27.2539 11.5042 27.8677C10.8904 28.4814 10.5456 29.3138 10.5456 30.1818V59.6364C10.5456 60.5043 10.8904 61.3368 11.5042 61.9505C12.1179 62.5643 12.9504 62.9091 13.8183 62.9091H58.281L48.5681 53.1961C47.5316 54.1293 46.3509 54.8924 45.0697 55.4547C43.4674 56.1579 41.7405 56.5327 39.9909 56.5571C38.2413 56.5814 36.5045 56.2547 34.8833 55.5964C33.2621 54.938 31.7894 53.9614 30.5521 52.7241C29.3148 51.4868 28.3382 50.0141 27.6798 48.3929C27.0215 46.7717 26.6948 45.035 26.7191 43.2854C26.7435 41.5358 27.1183 39.8088 27.8215 38.2066C28.3838 36.9254 29.1469 35.7447 30.0801 34.7082L22.2809 26.9091ZM34.7212 39.3493C34.355 39.8016 34.05 40.3018 33.8151 40.837C33.4636 41.6381 33.2761 42.5016 33.264 43.3764C33.2518 44.2512 33.4151 45.1196 33.7443 45.9301C34.0735 46.7407 34.5618 47.4771 35.1805 48.0958C35.7991 48.7144 36.5355 49.2027 37.3461 49.5319C38.1567 49.8611 39.025 50.0244 39.8998 50.0122C40.7746 50.0001 41.6381 49.8127 42.4392 49.4611C42.9745 49.2262 43.4746 48.9212 43.927 48.5551L34.7212 39.3493ZM28.5457 13.8182C28.5457 12.0107 30.0109 10.5455 31.8184 10.5455H48.1821C49.1534 10.5455 50.0745 10.9769 50.6963 11.723L57.8968 20.3636H66.1821C68.7861 20.3636 71.2834 21.398 73.1247 23.2393C74.9659 25.0806 76.0004 27.5779 76.0004 30.1818V54.7273C76.0004 56.5348 74.5351 58 72.7276 58C70.9201 58 69.4549 56.5348 69.4549 54.7273V30.1818C69.4549 29.3138 69.1101 28.4814 68.4963 27.8677C67.8826 27.2539 67.0501 26.9091 66.1821 26.9091H56.3639C55.3926 26.9091 54.4715 26.4777 53.8497 25.7315L46.6492 17.0909H31.8184C30.0109 17.0909 28.5457 15.6257 28.5457 13.8182Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CHECK]: `<path fillRule="evenodd" clipRule="evenodd" d="M74.8284 15.1716C76.3905 16.7337 76.3905 19.2663 74.8284 20.8284L30.8284 64.8284C29.2663 66.3905 26.7337 66.3905 25.1716 64.8284L5.17157 44.8284C3.60948 43.2663 3.60948 40.7337 5.17157 39.1716C6.73367 37.6095 9.26633 37.6095 10.8284 39.1716L28 56.3431L69.1716 15.1716C70.7337 13.6095 73.2663 13.6095 74.8284 15.1716Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CHECKBOX]: `<path d="M68.7949 14.7992C68.7934 12.8133 67.1867 11.2066 65.2008 11.2051H14.7992C12.8133 11.2066 11.2066 12.8133 11.2051 14.7992V65.2008C11.2066 67.1867 12.8133 68.7934 14.7992 68.7949H65.2008C67.1867 68.7934 68.7934 67.1867 68.7949 65.2008V14.7992ZM48.2512 30.2554C49.657 28.8497 51.9413 28.8497 53.3471 30.2554C54.7505 31.6604 54.7496 33.9373 53.3471 35.3429L38.9454 49.7446C37.5401 51.1499 35.2639 51.1489 33.858 49.7446L26.6529 42.5479C25.2471 41.1422 25.2471 38.8579 26.6529 37.4521C28.0587 36.0463 30.343 36.0463 31.7488 37.4521L36.3975 42.1092L48.2512 30.2554ZM76 65.2008C75.9985 71.1628 71.1628 75.9985 65.2008 76H14.7992C8.83718 75.9985 4.00152 71.1628 4 65.2008V14.7992C4.00152 8.83718 8.83718 4.00152 14.7992 4H65.2008C71.1628 4.00152 75.9985 8.83718 76 14.7992V65.2008Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CHECK_DOUBLE]: `<path fillRule="evenodd" clipRule="evenodd" d="M61.9503 18.9586C63.2284 20.2366 63.2284 22.3088 61.9503 23.5869L25.9503 59.5869C24.6722 60.865 22.6 60.865 21.322 59.5869L4.95832 43.2233C3.68024 41.9452 3.68024 39.873 4.95832 38.5949C6.23639 37.3168 8.30857 37.3168 9.58665 38.5949L23.6361 52.6444L57.322 18.9586C58.6 17.6805 60.6722 17.6805 61.9503 18.9586ZM75.0412 32.0495C76.3193 33.3276 76.3193 35.3997 75.0412 36.6778L50.4957 61.2233C49.2177 62.5013 47.1455 62.5013 45.8674 61.2233L40.9583 56.3142C39.6802 55.0361 39.6802 52.9639 40.9583 51.6858C42.2364 50.4078 44.3086 50.4078 45.5866 51.6858L48.1816 54.2808L70.4129 32.0495C71.6909 30.7714 73.7631 30.7714 75.0412 32.0495Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CHEVRON_DOWN]: `<path fillRule="evenodd" clipRule="evenodd" d="M74.4937 20.5063C76.5021 22.5147 76.5021 25.7709 74.4937 27.7793L43.6365 58.6362C41.6281 60.6446 38.3719 60.6446 36.3634 58.6362L5.50632 27.7793C3.4979 25.7709 3.4979 22.5147 5.50632 20.5063C7.51472 18.4979 10.771 18.4979 12.7794 20.5063L40 47.7267L67.2206 20.5063C69.229 18.4979 72.4853 18.4979 74.4937 20.5063Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CHEVRON_UP_DOWN]: `<path fillRule="evenodd" clipRule="evenodd" d="M37.1716 5.17157C38.7337 3.60948 41.2663 3.60948 42.8284 5.17157L62.8284 25.1716C64.3905 26.7337 64.3905 29.2663 62.8284 30.8284C61.2663 32.3905 58.7337 32.3905 57.1716 30.8284L40 13.6569L22.8284 30.8284C21.2663 32.3905 18.7337 32.3905 17.1716 30.8284C15.6095 29.2663 15.6095 26.7337 17.1716 25.1716L37.1716 5.17157ZM17.1716 49.1716C18.7337 47.6095 21.2663 47.6095 22.8284 49.1716L40 66.3431L57.1716 49.1716C58.7337 47.6095 61.2663 47.6095 62.8284 49.1716C64.3905 50.7337 64.3905 53.2663 62.8284 54.8284L42.8284 74.8284C41.2663 76.3905 38.7337 76.3905 37.1716 74.8284L17.1716 54.8284C15.6095 53.2663 15.6095 50.7337 17.1716 49.1716Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CHEVRON_RIGHT]: `<path fillRule="evenodd" clipRule="evenodd" d="M20.5061 5.50631C22.5145 3.4979 25.7707 3.4979 27.7791 5.50631L58.636 36.3634C60.6444 38.3719 60.6444 41.6281 58.636 43.6365L27.7791 74.4937C25.7707 76.5021 22.5145 76.5021 20.5061 74.4937C18.4977 72.4853 18.4977 69.229 20.5061 67.2206L47.7264 40L20.5061 12.7794C18.4977 10.771 18.4977 7.51472 20.5061 5.50631Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CHOICE_PILL]: `<path  transform="scale(7)" d="M10.7393 1.25288C10.9702 1.48146 11.1537 1.75383 11.2788 2.05369C11.4039 2.35351 11.468 2.67515 11.468 3.00001C11.468 3.32486 11.4039 3.6465 11.2788 3.94632C11.1537 4.24618 10.9702 4.51855 10.7393 4.74713C10.5085 4.97566 10.2344 5.15602 9.93338 5.27806C9.63358 5.39958 9.31281 5.46023 8.98935 5.45751V5.45808H3.14658C2.82313 5.4608 2.50235 5.39958 2.20255 5.27806C1.9015 5.15602 1.62748 4.97566 1.3966 4.74713C1.1657 4.51855 0.982212 4.24618 0.857117 3.94632C0.732065 3.6465 0.667969 3.32486 0.667969 3.00001C0.667969 2.67515 0.732064 2.35351 0.857117 2.05369C0.982211 1.75383 1.1657 1.48146 1.3966 1.25288C1.62748 1.02436 1.9015 0.843989 2.20255 0.721952C2.50359 0.599932 2.82577 0.538675 3.15058 0.541932H8.98935C9.31281 0.539214 9.63358 0.600432 9.93338 0.721952C10.2344 0.843989 10.5085 1.02436 10.7393 1.25288ZM3.14259 1.36814C2.92693 1.36596 2.71283 1.40666 2.51295 1.48767C2.31305 1.56871 2.13103 1.68855 1.97774 1.84029C1.82448 1.99203 1.70274 2.17275 1.6197 2.37179C1.53669 2.57082 1.49417 2.78436 1.49417 3.00001C1.49417 3.21565 1.53669 3.42919 1.6197 3.62822C1.70274 3.82726 1.82449 4.00798 1.97774 4.15972C2.13103 4.31146 2.31305 4.43131 2.51295 4.51234C2.71283 4.59335 2.92693 4.63405 3.14259 4.63187H5.65487V1.36814H3.14259ZM10.1582 1.84029C10.0049 1.68855 9.82288 1.56871 9.62299 1.48767C9.42311 1.40666 9.20901 1.36596 8.99335 1.36814H6.48107V4.63187H8.99335C9.20901 4.63405 9.42311 4.59335 9.62299 4.51234C9.82288 4.43131 10.0049 4.31146 10.1582 4.15972C10.3115 4.00798 10.4332 3.82726 10.5162 3.62822C10.5992 3.42919 10.6418 3.21565 10.6418 3.00001C10.6418 2.78436 10.5992 2.57082 10.5162 2.37179C10.4332 2.17275 10.3115 1.99203 10.1582 1.84029Z"/>,`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CIRCLE_CHECK]: `<path fillRule="evenodd" clipRule="evenodd" d="M51.988 13.0954C46.1862 10.5103 39.7042 9.86984 33.5088 11.2696C27.3133 12.6694 21.7363 16.0344 17.6095 20.8627C13.4827 25.691 11.0272 31.724 10.6093 38.0618C10.1914 44.3997 11.8334 50.7028 15.2905 56.0312C18.7475 61.3596 23.8344 65.4278 29.7924 67.6289C35.7505 69.8301 42.2604 70.0464 48.3514 68.2455C54.4424 66.4446 59.788 62.723 63.5911 57.6358C67.3942 52.5486 69.4509 46.3683 69.4545 40.0167V37.0077C69.4545 35.2002 70.9198 33.7349 72.7273 33.7349C74.5347 33.7349 76 35.2002 76 37.0077V40.0204C75.9956 47.7835 73.4818 55.3372 68.8336 61.5549C64.1854 67.7726 57.6518 72.3212 50.2073 74.5223C42.7627 76.7234 34.8061 76.4591 27.5241 73.7687C20.242 71.0784 14.0248 66.1062 9.79946 59.5938C5.57416 53.0813 3.56725 45.3774 4.07804 37.6312C4.58882 29.8849 7.58994 22.5113 12.6338 16.61C17.6777 10.7087 24.494 6.59597 32.0663 4.88513C39.6385 3.17428 47.561 3.95702 54.652 7.11659C56.303 7.85223 57.045 9.78698 56.3094 11.438C55.5738 13.089 53.639 13.831 51.988 13.0954ZM75.0403 11.5216C76.319 12.799 76.32 14.8712 75.0426 16.1499L42.3153 48.9097C41.7017 49.524 40.8691 49.8692 40.0008 49.8694C39.1326 49.8696 38.2998 49.5248 37.6858 48.9108L27.8677 39.0927C26.5896 37.8146 26.5896 35.7425 27.8677 34.4644C29.1457 33.1863 31.2179 33.1863 32.496 34.4644L39.9989 41.9672L70.4119 11.5239C71.6894 10.2452 73.7616 10.2441 75.0403 11.5216Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CIRCLE_CLOSE]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 10.5454C23.7327 10.5454 10.5455 23.7326 10.5455 39.9998C10.5455 56.2671 23.7327 69.4542 40 69.4542C56.2673 69.4542 69.4546 56.2671 69.4546 39.9998C69.4546 23.7326 56.2673 10.5454 40 10.5454ZM4.00002 39.9998C4.00002 20.1177 20.1178 4 40 4C59.8823 4 76 20.1177 76 39.9998C76 59.882 59.8823 75.9997 40 75.9997C20.1178 75.9997 4.00002 59.882 4.00002 39.9998ZM27.8677 27.8675C29.1457 26.5895 31.2179 26.5895 32.496 27.8675L40 35.3715L47.504 27.8675C48.7821 26.5895 50.8543 26.5895 52.1324 27.8675C53.4104 29.1456 53.4104 31.2178 52.1324 32.4959L44.6283 39.9998L52.1324 47.5038C53.4104 48.7819 53.4104 50.8541 52.1324 52.1321C50.8543 53.4102 48.7821 53.4102 47.504 52.1321L40 44.6281L32.496 52.1321C31.2179 53.4102 29.1457 53.4102 27.8677 52.1321C26.5896 50.8541 26.5896 48.7819 27.8677 47.5038L35.3717 39.9998L27.8677 32.4959C26.5896 31.2178 26.5896 29.1456 27.8677 27.8675Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CIRCLE_LEFT]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 10.5455C23.7327 10.5455 10.5455 23.7329 10.5455 40.0003C10.5455 56.2678 23.7327 69.4551 40 69.4551C56.2673 69.4551 69.4545 56.2678 69.4545 40.0003C69.4545 23.7329 56.2673 10.5455 40 10.5455ZM4 40.0003C4 20.1179 20.1177 4 40 4C59.8822 4 76 20.1179 76 40.0003C76 59.8827 59.8822 76.0006 40 76.0006C20.1177 76.0006 4 59.8827 4 40.0003ZM42.3142 24.5951C43.5922 25.8732 43.5922 27.9454 42.3142 29.2235L34.8102 36.7276H53.0909C54.8984 36.7276 56.3636 38.1928 56.3636 40.0003C56.3636 41.8078 54.8984 43.2731 53.0909 43.2731H34.8102L42.3142 50.7771C43.5922 52.0552 43.5922 54.1274 42.3142 55.4055C41.0361 56.6836 38.9639 56.6836 37.6858 55.4055L24.5949 42.3145C23.3168 41.0364 23.3168 38.9642 24.5949 37.6861L37.6858 24.5951C38.9639 23.317 41.0361 23.317 42.3142 24.5951Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CIRCLE_RIGHT]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 10.5455C23.7327 10.5455 10.5455 23.7329 10.5455 40.0003C10.5455 56.2678 23.7327 69.4551 40 69.4551C56.2673 69.4551 69.4545 56.2678 69.4545 40.0003C69.4545 23.7329 56.2673 10.5455 40 10.5455ZM4 40.0003C4 20.1179 20.1177 4 40 4C59.8822 4 76 20.1179 76 40.0003C76 59.8827 59.8822 76.0006 40 76.0006C20.1177 76.0006 4 59.8827 4 40.0003ZM37.6858 29.2235C36.4078 27.9454 36.4078 25.8732 37.6858 24.5951C38.9639 23.317 41.0361 23.317 42.3142 24.5951L55.4051 37.6861C56.6832 38.9642 56.6832 41.0364 55.4051 42.3145L42.3142 55.4055C41.0361 56.6836 38.9639 56.6836 37.6858 55.4055C36.4078 54.1274 36.4078 52.0552 37.6858 50.7771L45.1898 43.2731H26.9091C25.1016 43.2731 23.6364 41.8078 23.6364 40.0003C23.6364 38.1928 25.1016 36.7276 26.9091 36.7276H45.1898L37.6858 29.2235Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CLEAR_FIELD]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 4C20.1123 4 4 20.1218 4 40C4 59.8782 20.1123 76 40 76C59.8877 76 76 59.8782 76 40C76 20.1218 59.8782 4 40 4ZM55.9693 52.6706L52.661 55.9693L39.9905 43.3083L27.3294 55.9693L24.0212 52.6706L36.6917 40L24.0212 27.339L27.3294 24.0307L39.9905 36.7013L52.661 24.0307L55.9693 27.339L43.2987 40L55.9693 52.6706Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CLOCK]: `<path fillRule="evenodd" clipRule="evenodd" d="M4.00005 40C4.00005 20.12 20.1044 4 39.9753 4C59.8463 4 75.9506 20.12 75.9506 40C75.9506 59.8799 59.8463 76 39.9753 76C20.1044 76 4.00005 59.8799 4.00005 40ZM39.9753 10.5455C23.724 10.5455 10.5455 23.7304 10.5455 40C10.5455 56.2697 23.724 69.4545 39.9753 69.4545C56.2267 69.4545 69.4053 56.2697 69.4053 40C69.4053 23.7304 56.2267 10.5455 39.9753 10.5455ZM39.9754 17.091C41.7829 17.091 43.2482 18.5562 43.2482 20.3637V37.9781L54.521 43.6188C56.1373 44.4276 56.792 46.3936 55.9833 48.01C55.1744 49.6264 53.2084 50.2811 51.592 49.4723L38.511 42.9268C37.4027 42.3723 36.7027 41.2394 36.7027 40V20.3637C36.7027 18.5562 38.168 17.091 39.9754 17.091Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CLOSE]: `<path fillRule="evenodd" clipRule="evenodd" d="M5.50631 5.50631C7.51472 3.4979 10.771 3.4979 12.7794 5.50631L40 32.7269L67.2206 5.50631C69.229 3.4979 72.4853 3.4979 74.4937 5.50631C76.5021 7.51472 76.5021 10.771 74.4937 12.7794L47.2731 40L74.4937 67.2206C76.5021 69.229 76.5021 72.4853 74.4937 74.4937C72.4853 76.5021 69.229 76.5021 67.2206 74.4937L40 47.2731L12.7794 74.4937C10.771 76.5021 7.51472 76.5021 5.50631 74.4937C3.4979 72.4853 3.4979 69.229 5.50631 67.2206L32.7269 40L5.50631 12.7794C3.4979 10.771 3.4979 7.51472 5.50631 5.50631Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).COG]: `<path fillRule="evenodd" clipRule="evenodd" d="M35.0971 5.3174C36.5882 4.45817 38.279 4.00586 40 4.00586C41.7211 4.00586 43.412 4.45821 44.9031 5.31753C44.9054 5.31885 44.9077 5.32017 44.91 5.32149L67.8107 18.4076L67.8234 18.4148C69.3147 19.2759 70.5534 20.5139 71.4152 22.0049C72.277 23.4958 72.7316 25.1871 72.7334 26.9091V53.1026C72.7316 54.8246 72.277 56.5159 71.4152 58.0069C70.5534 59.4978 69.3147 60.7358 67.8234 61.5969L67.8107 61.6041L44.91 74.6902C44.9077 74.6916 44.9054 74.6929 44.903 74.6942C43.4119 75.5535 41.7211 76.0059 40 76.0059C38.279 76.0059 36.5883 75.5536 35.0972 74.6944C35.0948 74.693 35.0924 74.6916 35.09 74.6902L12.1893 61.6041L12.1766 61.5969C10.6853 60.7358 9.44655 59.4978 8.58475 58.0069C7.72295 56.5159 7.26837 54.8246 7.2666 53.1026V26.9091C7.26837 25.1871 7.72295 23.4958 8.58475 22.0049C9.44655 20.5139 10.6853 19.2759 12.1766 18.4148L12.1893 18.4076L35.0971 5.3174ZM40 10.5525C39.4254 10.5525 38.8609 10.7038 38.3633 10.9911L15.4448 24.0874C14.95 24.3743 14.539 24.7859 14.2527 25.2811C13.9656 25.7777 13.8141 26.341 13.8133 26.9145V53.0972C13.8141 53.6707 13.9656 54.234 14.2527 54.7306C14.539 55.2259 14.9501 55.6375 15.445 55.9244L15.45 55.9273L38.3633 69.0206C38.8609 69.3079 39.4254 69.4592 40 69.4592C40.5746 69.4592 41.1391 69.3079 41.6367 69.0206L64.55 55.9273L64.5551 55.9244C65.0499 55.6375 65.461 55.2259 65.7473 54.7306C66.0346 54.2336 66.1861 53.6699 66.1867 53.0959V26.9159C66.1861 26.3418 66.0346 25.7781 65.7473 25.2811C65.4611 24.7859 65.0501 24.3744 64.5553 24.0875C64.5535 24.0865 64.5518 24.0854 64.55 24.0844L41.6367 10.9911C41.1391 10.7038 40.5746 10.5525 40 10.5525ZM40 30.1798C34.5766 30.1798 30.18 34.5763 30.18 39.9998C30.18 45.4232 34.5766 49.8198 40 49.8198C45.4234 49.8198 49.82 45.4232 49.82 39.9998C49.82 34.5763 45.4234 30.1798 40 30.1798ZM23.6333 39.9998C23.6333 30.9607 30.9609 23.6331 40 23.6331C49.0391 23.6331 56.3667 30.9607 56.3667 39.9998C56.3667 49.0389 49.0391 56.3665 40 56.3665C30.9609 56.3665 23.6333 49.0389 23.6333 39.9998Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).COMMENT]: `<path d="M73.4582 73.1706C73.0848 73.1706 72.8116 73.1251 72.6295 73.034L59.2336 68.681C58.3138 68.3623 57.4578 68.426 56.6746 68.8905C53.4509 70.5479 50.045 71.6953 46.4569 72.3419C42.8689 72.9885 39.2262 73.1251 35.5471 72.7608C30.1196 72.2053 25.0745 70.5297 20.4209 67.7157C15.9131 65.0019 12.2249 61.505 9.37455 57.2157C6.47863 52.8445 4.75747 48.1273 4.20196 43.0639C3.64645 38.0006 4.23839 33.1103 5.95955 28.3931C7.68982 23.6758 10.4127 19.5414 14.1464 15.9989C17.8711 12.4564 22.215 9.81546 27.1599 8.0943C32.1139 6.36403 37.2501 5.70835 42.5957 6.11815C47.9322 6.52795 52.9318 8.03055 57.5762 10.6077C62.1295 13.0939 65.9088 16.3814 68.9049 20.4794C72.0376 24.6229 74.0137 29.1763 74.8424 34.1485C75.3979 37.5089 75.4253 40.8601 74.9426 44.1932C74.46 47.5353 73.4309 50.7227 71.8736 53.7552C71.4547 54.5384 71.391 55.2487 71.6642 55.8953L75.9443 70.1927C76.0354 70.6481 76.0172 71.0943 75.8715 71.5041C75.7349 71.9139 75.4981 72.26 75.1794 72.5423C74.7149 72.9612 74.1412 73.1615 73.4491 73.1615L73.4582 73.1706ZM39.6269 9.50583C35.3468 9.50583 31.2397 10.2799 27.3056 11.8189C23.3715 13.358 19.8837 15.58 16.842 18.485C13.5272 21.6632 11.0866 25.3515 9.52026 29.5678C7.95391 33.7842 7.41662 38.1463 7.89927 42.6541C8.38192 47.162 9.91185 51.3783 12.489 55.2942C15.0662 59.119 18.3811 62.2244 22.4335 64.6195C26.5315 67.1511 31.0211 68.6719 35.9023 69.1728C39.1716 69.4915 42.4136 69.3822 45.6373 68.8267C48.8611 68.2712 51.9209 67.2604 54.8169 65.7851C55.6456 65.3207 56.5562 65.0475 57.5489 64.9564C58.5415 64.8653 59.4886 64.9746 60.4175 65.3025L71.6733 68.9633L68.0124 56.8788C67.7848 56.0956 67.7028 55.3033 67.7665 54.4928C67.8394 53.6914 68.0762 52.9174 68.4951 52.1797C69.8246 49.4659 70.7262 46.6064 71.1907 43.6195C71.646 40.6234 71.6278 37.6364 71.1178 34.6403C70.3801 30.2235 68.6317 26.1437 65.8724 22.4191C63.1586 18.8311 59.7709 15.9078 55.7184 13.6494C51.5293 11.3454 47.0671 10.0158 42.3225 9.64243C41.7215 9.55136 40.829 9.50583 39.6269 9.50583Z" /> <path d="M71.1347 70.8383C70.7873 70.8383 70.533 70.7959 70.3636 70.7112L57.8979 66.6605C57.042 66.3639 56.2454 66.4232 55.5167 66.8554C52.5168 68.3977 49.3474 69.4655 46.0085 70.0672C42.6697 70.6688 39.28 70.7959 35.8564 70.457C30.8057 69.94 26.111 68.3808 21.7806 65.7622C17.5858 63.2369 14.1538 59.9828 11.5013 55.9914C8.8065 51.9237 7.20487 47.5341 6.68794 42.8224C6.17101 38.1107 6.72183 33.56 8.32347 29.1703C9.93358 24.7806 12.4674 20.9333 15.9418 17.6368C19.4078 14.3403 23.45 11.8828 28.0516 10.2812C32.6616 8.67105 37.441 8.0609 42.4154 8.44224C47.3814 8.82358 52.0337 10.2218 56.3556 12.6201C60.5927 14.9335 64.1096 17.9927 66.8976 21.8062C69.8127 25.662 71.6517 29.8991 72.4228 34.5261C72.9398 37.6531 72.9652 40.7716 72.516 43.8732C72.0669 46.9832 71.1093 49.9492 69.6602 52.7712C69.2704 53.5 69.2111 54.161 69.4653 54.7626L73.4482 68.0672C73.5329 68.4909 73.516 68.9062 73.3804 69.2875C73.2533 69.6689 73.033 69.9909 72.7364 70.2536C72.3042 70.6434 71.7703 70.8298 71.1263 70.8298L71.1347 70.8383ZM39.6528 11.5947C35.6699 11.5947 31.848 12.315 28.1871 13.7471C24.5263 15.1793 21.2806 17.247 18.4502 19.9503C15.3656 22.9078 13.0945 26.3399 11.6369 30.2635C10.1793 34.1871 9.67935 38.2463 10.1285 42.441C10.5776 46.6358 12.0013 50.5594 14.3995 54.2033C16.7977 57.7625 19.8824 60.6522 23.6534 62.881C27.4668 65.2368 31.6446 66.652 36.1869 67.1181C39.2291 67.4147 42.246 67.313 45.2458 66.7961C48.2457 66.2792 51.0931 65.3385 53.7879 63.9657C54.5591 63.5335 55.4065 63.2793 56.3302 63.1945C57.2539 63.1098 58.1352 63.2115 58.9996 63.5166L69.4738 66.9232L66.0671 55.6778C65.8553 54.9491 65.779 54.2118 65.8383 53.4576C65.9061 52.7119 66.1264 51.9915 66.5163 51.3051C67.7535 48.7798 68.5924 46.1189 69.0246 43.3393C69.4483 40.5513 69.4314 37.7717 68.9568 34.9837C68.2704 30.8736 66.6434 27.0772 64.0757 23.6112C61.5503 20.2723 58.3979 17.5521 54.6269 15.4505C50.7287 13.3065 46.5763 12.0692 42.1612 11.7218C41.6019 11.637 40.7714 11.5947 39.6528 11.5947Z"/> `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).COMMENT_ACTIVE]: `<path d="M73.4582 73.1705C73.0848 73.1705 72.8116 73.125 72.6295 73.0339L59.2336 68.681C58.3138 68.3622 57.4578 68.426 56.6746 68.8904C53.4509 70.5478 50.045 71.6953 46.4569 72.3418C42.8689 72.9884 39.2262 73.125 35.5471 72.7607C30.1196 72.2052 25.0745 70.5296 20.4209 67.7156C15.9131 65.0019 12.2249 61.5049 9.37455 57.2157C6.47863 52.8445 4.75747 48.1272 4.20196 43.0639C3.64645 38.0006 4.23839 33.1103 5.95955 28.3931C7.68982 23.6758 10.4127 19.5414 14.1464 15.9989C17.8711 12.4564 22.215 9.81545 27.1599 8.09429C32.1139 6.36403 37.2501 5.70835 42.5957 6.11815C47.9322 6.52795 52.9318 8.03055 57.5762 10.6077C62.1295 13.0939 65.9088 16.3814 68.9049 20.4794C72.0376 24.6229 74.0137 29.1762 74.8424 34.1485C75.3979 37.5088 75.4253 40.8601 74.9426 44.1931C74.4599 47.5353 73.4309 50.7226 71.8736 53.7551C71.4547 54.5383 71.391 55.2486 71.6642 55.8952L75.9443 70.1927C76.0354 70.648 76.0172 71.0942 75.8715 71.504C75.7349 71.9138 75.4981 72.2599 75.1794 72.5422C74.7149 72.9611 74.1412 73.1614 73.4491 73.1614L73.4582 73.1705Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).COMPETITION]: `<path d="M75.9998 60.654C75.9523 62.0976 75.4109 63.3418 74.3757 64.396C73.3405 65.4502 72.0868 65.9821 70.5957 65.9821H9.7552C8.07415 65.9821 6.75401 65.5262 5.79477 64.6145C5.21543 64.1396 4.77854 63.5508 4.46513 62.8479C4.15171 62.1546 3.99976 61.4233 3.99976 60.654V49.4186C3.99976 49.1812 4.08523 48.9817 4.25619 48.8393C4.42714 48.6968 4.60759 48.6208 4.79754 48.6208C6.71602 48.6208 8.47304 48.0225 10.0591 46.8163C11.3983 45.7146 12.3005 44.3185 12.7564 42.6375C13.2123 40.9564 13.1553 39.3134 12.5759 37.7083C11.9966 36.1032 10.9899 34.8021 9.55575 33.8239C8.11214 32.8361 6.53557 32.3518 4.80704 32.3518C4.61709 32.3518 4.43664 32.2663 4.26568 32.0953C4.09473 31.9244 4.00925 31.7439 4.00925 31.554V20.328C4.05674 18.837 4.59809 17.5833 5.63331 16.5481C6.66853 15.5129 7.9032 15 9.39429 15H70.3108C71.9444 15 73.236 15.4559 74.1952 16.3676C74.7746 16.852 75.2115 17.4408 75.5249 18.1341C75.8383 18.8275 75.9903 19.5588 75.9903 20.328V31.5635C75.9903 31.7534 75.9143 31.9339 75.7718 32.1048C75.6294 32.2758 75.4394 32.3613 75.1925 32.3613C74.0908 32.3613 73.0366 32.5702 72.0203 32.9691C71.0136 33.3775 70.1208 33.9663 69.3516 34.7356C67.813 36.2267 66.9962 38.1452 66.9012 40.5005C66.9487 41.6022 67.1766 42.647 67.585 43.6347C67.9934 44.6224 68.5823 45.4962 69.3516 46.2655C70.1208 47.0348 71.0041 47.6236 72.0203 48.032C73.0271 48.4404 74.0813 48.6398 75.1925 48.6398C75.4299 48.6398 75.6294 48.7158 75.7718 48.8583C75.9143 49.0007 75.9903 49.1907 75.9903 49.4376V60.673L75.9998 60.654ZM60.9083 36.1317C60.7374 35.8183 60.462 35.6379 60.0821 35.5904L46.2538 34.5077C44.1454 29.9964 42.5308 26.6153 41.4291 24.3549L41.2867 24.07C41.2392 23.8801 41.1917 23.7376 41.1442 23.6426L40.7833 22.9968V22.8544C40.6408 22.6169 40.4224 22.4935 40.1375 22.4935H39.8525C39.5676 22.4935 39.3492 22.6169 39.2067 22.8544L34.2396 33.368C34.0496 33.8524 33.8787 34.2322 33.7362 34.5172L21.7125 35.4574C21.2756 35.4574 20.6772 35.5049 19.9079 35.5999C19.6705 35.5999 19.4616 35.6759 19.3001 35.8183C19.1292 35.9608 19.0342 36.1412 19.0152 36.3597C18.9867 36.5781 19.0722 36.7586 19.2716 36.901V36.977L29.8613 45.2587L26.6891 57.5009C26.5941 57.8333 26.7081 58.1087 27.05 58.3272C27.3824 58.5456 27.7243 58.5551 28.0567 58.3652L30.868 56.8551C34.4675 54.9366 37.1553 53.474 38.9313 52.4578C39.1687 52.3628 39.5296 52.1729 40.014 51.8784L51.9713 58.3557C52.3037 58.5456 52.6266 58.5361 52.94 58.3177C53.2534 58.0992 53.3579 57.8048 53.2629 57.4154L50.4517 46.3225C50.3567 46.085 50.2617 45.7241 50.1668 45.2397L59.3888 38.0407C59.7212 37.8033 60.177 37.4424 60.7564 36.958C61.0413 36.7206 61.1078 36.4451 60.9368 36.1317H60.9083Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).COMPUTER_EXTERNAL]: `<path d="M4 49.8189V17.0916C4 14.4877 5.03515 11.9911 6.87642 10.1499C8.71769 8.30859 11.2142 7.27344 13.8182 7.27344H43.2727C45.0802 7.27344 46.5455 8.73869 46.5455 10.5462C46.5455 12.3536 45.0802 13.8189 43.2727 13.8189H13.8182C12.9502 13.8189 12.118 14.1639 11.5043 14.7777C10.8905 15.3915 10.5455 16.2236 10.5455 17.0916V49.8189C10.5455 50.6869 10.8905 51.5191 11.5043 52.1328C12.118 52.7466 12.9502 53.0916 13.8182 53.0916H66.1818C67.0498 53.0916 67.882 52.7466 68.4957 52.1328C69.1095 51.5191 69.4545 50.6869 69.4545 49.8189V40.0007C69.4545 38.1932 70.9198 36.728 72.7273 36.728C74.5347 36.728 76 38.1932 76 40.0007V49.8189C76 52.4228 74.9648 54.9194 73.1236 56.7607C71.2823 58.6019 68.7858 59.6371 66.1818 59.6371H43.2727V66.1825H53.0909C54.8984 66.1825 56.3636 67.6478 56.3636 69.4553C56.3636 71.2627 54.8984 72.728 53.0909 72.728H26.9091C25.1016 72.728 23.6364 71.2627 23.6364 69.4553C23.6364 67.6478 25.1016 66.1825 26.9091 66.1825H36.7273V59.6371H13.8182C11.2142 59.6371 8.71769 58.6019 6.87642 56.7607C5.03515 54.9194 4 52.4228 4 49.8189ZM76 26.9098C76 28.7173 74.5347 30.1825 72.7273 30.1825C70.9198 30.1825 69.4545 28.7173 69.4545 26.9098V18.4467L58.6776 29.2237C57.3995 30.5018 55.3278 30.5018 54.0497 29.2237C52.7716 27.9456 52.7716 25.874 54.0497 24.5959L64.8267 13.8189H56.3636C54.5562 13.8189 53.0909 12.3536 53.0909 10.5462C53.0909 8.73869 54.5562 7.27344 56.3636 7.27344H72.7273C74.5347 7.27344 76 8.73869 76 10.5462V26.9098Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).CONTACT]: `<path fillRule="evenodd" clipRule="evenodd" d="M26.6361 4C28.4436 4 29.9089 5.46525 29.9089 7.27273V10.5455H49.5452V7.27273C49.5452 5.46525 51.0105 4 52.818 4C54.6254 4 56.0907 5.46525 56.0907 7.27273V10.5455H62.6361C68.0586 10.5455 72.4543 14.9412 72.4543 20.3636V66.1818C72.4543 71.6043 68.0586 76 62.6361 76H16.818C11.3955 76 6.99978 71.6043 6.99978 66.1818V20.3636C6.99978 14.9412 11.3955 10.5455 16.818 10.5455H23.3634V7.27273C23.3634 5.46525 24.8287 4 26.6361 4ZM16.818 17.0909C15.0105 17.0909 13.5452 18.5562 13.5452 20.3636V66.1818C13.5452 67.9893 15.0105 69.4545 16.818 69.4545H62.6361C64.4436 69.4545 65.9089 67.9893 65.9089 66.1818V20.3636C65.9089 18.5562 64.4436 17.0909 62.6361 17.0909H16.818ZM39.7271 30.1818C37.9196 30.1818 36.4543 31.6471 36.4543 33.4545C36.4543 35.262 37.9196 36.7273 39.7271 36.7273C41.5345 36.7273 42.9998 35.262 42.9998 33.4545C42.9998 31.6471 41.5345 30.1818 39.7271 30.1818ZM29.9089 33.4545C29.9089 28.0321 34.3046 23.6364 39.7271 23.6364C45.1495 23.6364 49.5452 28.0321 49.5452 33.4545C49.5452 38.877 45.1495 43.2727 39.7271 43.2727C34.3046 43.2727 29.9089 38.877 29.9089 33.4545ZM22.9664 52.6939C24.8076 50.8526 27.3049 49.8182 29.9089 49.8182H49.5452C52.1492 49.8182 54.6465 50.8526 56.4877 52.6939C58.329 54.5351 59.3634 57.0324 59.3634 59.6364C59.3634 61.4438 57.8982 62.9091 56.0907 62.9091C54.2832 62.9091 52.818 61.4438 52.818 59.6364C52.818 58.7684 52.4732 57.936 51.8594 57.3222C51.2456 56.7084 50.4132 56.3636 49.5452 56.3636H29.9089C29.0409 56.3636 28.2085 56.7084 27.5947 57.3222C26.9809 57.9359 26.6361 58.7684 26.6361 59.6364C26.6361 61.4438 25.1709 62.9091 23.3634 62.9091C21.5559 62.9091 20.0907 61.4438 20.0907 59.6364C20.0907 57.0324 21.1251 54.5351 22.9664 52.6939Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).COPY]: `<path fillRule="evenodd" clipRule="evenodd" d="M13.8182 10.5455C12.0257 10.5455 10.5455 12.0257 10.5455 13.8182V46.5455C10.5455 48.338 12.0257 49.8182 13.8182 49.8182C15.6257 49.8182 17.0909 51.2834 17.0909 53.0909C17.0909 54.8984 15.6257 56.3636 13.8182 56.3636C8.4107 56.3636 4 51.9529 4 46.5455V13.8182C4 8.4107 8.4107 4 13.8182 4H46.5455C51.9529 4 56.3636 8.4107 56.3636 13.8182C56.3636 15.6257 54.8984 17.0909 53.0909 17.0909C51.2834 17.0909 49.8182 15.6257 49.8182 13.8182C49.8182 12.0257 48.338 10.5455 46.5455 10.5455H13.8182ZM33.4545 30.1818C31.6471 30.1818 30.1818 31.6471 30.1818 33.4545V66.1818C30.1818 67.9893 31.6471 69.4545 33.4545 69.4545H66.1818C67.9893 69.4545 69.4545 67.9893 69.4545 66.1818V33.4545C69.4545 31.6471 67.9893 30.1818 66.1818 30.1818H33.4545ZM23.6364 33.4545C23.6364 28.0321 28.0321 23.6364 33.4545 23.6364H66.1818C71.6043 23.6364 76 28.0321 76 33.4545V66.1818C76 71.6043 71.6043 76 66.1818 76H33.4545C28.0321 76 23.6364 71.6043 23.6364 66.1818V33.4545Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).DASH]: `<path fillRule="evenodd" clipRule="evenodd" d="M3.99999 40.4996C3.99999 38.0145 6.01471 36 8.49999 36H71.5C73.9853 36 76 38.0145 76 40.4996C76 42.9846 73.9853 44.9991 71.5 44.9991H8.49999C6.01471 44.9991 3.99999 42.9846 3.99999 40.4996Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).DOWNLOAD]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 4C41.9882 4 43.6 5.61177 43.6 7.6V42.1088L55.4544 30.2544C56.8603 28.8485 59.1397 28.8485 60.5456 30.2544C61.9515 31.6603 61.9515 33.9397 60.5456 35.3456L42.5456 53.3456C41.1397 54.7515 38.8603 54.7515 37.4544 53.3456L19.4544 35.3456C18.0485 33.9397 18.0485 31.6603 19.4544 30.2544C20.8603 28.8485 23.1397 28.8485 24.5456 30.2544L36.4 42.1088V7.6C36.4 5.61177 38.0118 4 40 4ZM7.6 47.2C9.58823 47.2 11.2 48.8118 11.2 50.8V65.2C11.2 66.1548 11.5793 67.0704 12.2544 67.7456C12.9295 68.4207 13.8452 68.8 14.8 68.8H65.2C66.1548 68.8 67.0704 68.4207 67.7456 67.7456C68.4207 67.0704 68.8 66.1548 68.8 65.2V50.8C68.8 48.8118 70.4118 47.2 72.4 47.2C74.3882 47.2 76 48.8118 76 50.8V65.2C76 68.0643 74.8621 70.8114 72.8368 72.8368C70.8114 74.8621 68.0643 76 65.2 76H14.8C11.9357 76 9.18864 74.8621 7.16325 72.8368C5.13785 70.8114 4 68.0643 4 65.2V50.8C4 48.8118 5.61177 47.2 7.6 47.2Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).DRAG]: `<path fillRule="evenodd" clipRule="evenodd" d="M4 28C4 23.5818 7.58176 20 12 20C16.4182 20 20 23.5818 20 28C20 32.4182 16.4182 36 12 36C7.58176 36 4 32.4182 4 28ZM32 28C32 23.5818 35.5818 20 40 20C44.4182 20 48 23.5818 48 28C48 32.4182 44.4182 36 40 36C35.5818 36 32 32.4182 32 28ZM60 28C60 23.5818 63.5818 20 68 20C72.4184 20 76 23.5818 76 28C76 32.4182 72.4184 36 68 36C63.5818 36 60 32.4182 60 28ZM4 52C4 47.5818 7.58176 44 12 44C16.4182 44 20 47.5818 20 52C20 56.4182 16.4182 60 12 60C7.58176 60 4 56.4182 4 52ZM32 52C32 47.5818 35.5818 44 40 44C44.4182 44 48 47.5818 48 52C48 56.4182 44.4182 60 40 60C35.5818 60 32 56.4182 32 52ZM60 52C60 47.5818 63.5818 44 68 44C72.4184 44 76 47.5818 76 52C76 56.4182 72.4184 60 68 60C63.5818 60 60 56.4182 60 52Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).DROPDOWN]: `<path d="M4 19H76L39.5955 61.0674L4 19Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).EMPTY_SEARCH]: `<path fillRule="evenodd" clipRule="evenodd" d="M36.3998 11.2C22.4822 11.2 11.1998 22.4825 11.1998 36.4001C11.1998 50.3177 22.4822 61.6002 36.3998 61.6002C50.3173 61.6002 61.5998 50.3177 61.5998 36.4001C61.5998 22.4825 50.3173 11.2 36.3998 11.2ZM3.99976 36.4001C3.99976 18.506 18.5057 4 36.3998 4C54.2938 4 68.7998 18.506 68.7998 36.4001C68.7998 54.2942 54.2938 68.8002 36.3998 68.8002C18.5057 68.8002 3.99976 54.2942 3.99976 36.4001Z" /><path fillRule="evenodd" clipRule="evenodd" d="M26.0516 26.052C26.6542 25.4494 27.6311 25.4494 28.2336 26.052L36.3998 34.2182L44.5659 26.052C45.1685 25.4494 46.1453 25.4494 46.7479 26.052C47.3504 26.6545 47.3504 27.6314 46.7479 28.2339L38.5817 36.4001L46.7479 44.5663C47.3504 45.1689 47.3504 46.1457 46.7479 46.7483C46.1453 47.3508 45.1685 47.3508 44.5659 46.7483L36.3998 38.5821L28.2336 46.7483C27.6311 47.3508 26.6542 47.3508 26.0516 46.7483C25.4491 46.1457 25.4491 45.1689 26.0516 44.5663L34.2178 36.4001L26.0516 28.2339C25.4491 27.6314 25.4491 26.6545 26.0516 26.052Z"/><path fillRule="evenodd" clipRule="evenodd" d="M54.1942 54.1946C55.6001 52.7887 57.8794 52.7887 59.2853 54.1946L74.9453 69.8547C76.3512 71.2605 76.3512 73.54 74.9453 74.9458C73.5395 76.3517 71.2601 76.3517 69.8542 74.9458L54.1942 59.2858C52.7883 57.8799 52.7883 55.6005 54.1942 54.1946Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).EXISTING]: `<path fillRule="evenodd" clipRule="evenodd" d="M13.8757 6.87568C15.717 5.03441 18.2143 4 20.8182 4H48.6364C49.5044 4 50.3368 4.3448 50.9506 4.95856L68.9506 22.9586C69.5643 23.5723 69.9091 24.4047 69.9091 25.2727V66.1818C69.9091 68.7858 68.8747 71.2831 67.0335 73.1243C65.1922 74.9656 62.6949 76 60.091 76H14.2728C12.4653 76 11 74.5347 11 72.7273C11 70.9198 12.4653 69.4545 14.2728 69.4545H60.091C60.9589 69.4545 61.7914 69.1097 62.4051 68.496C63.0189 67.8822 63.3637 67.0498 63.3637 66.1818V30.1818H47C45.1926 30.1818 43.7273 28.7166 43.7273 26.9091V10.5455H20.8182C19.9502 10.5455 19.1178 10.8903 18.5041 11.504C17.8903 12.1178 17.5455 12.9502 17.5455 13.8182V36.7273C17.5455 38.5348 16.0803 40 14.2728 40C12.4653 40 11 38.5348 11 36.7273V13.8182C11 11.2142 12.0345 8.71695 13.8757 6.87568ZM50.2728 13.5374V23.6364H60.3717L50.2728 13.5374ZM31.595 37.6858C32.873 36.4078 34.9452 36.4078 36.2233 37.6858L46.0415 47.504C47.3196 48.7821 47.3196 50.8543 46.0415 52.1323L36.2233 61.9505C34.9452 63.2286 32.873 63.2286 31.595 61.9505C30.3169 60.6724 30.3169 58.6003 31.595 57.3222L35.8263 53.0909H20.8182C19.9502 53.0909 19.1178 53.4357 18.5041 54.0495C17.8903 54.6632 17.5455 55.4957 17.5455 56.3636V59.6364C17.5455 61.4438 16.0803 62.9091 14.2728 62.9091C12.4653 62.9091 11 61.4438 11 59.6364V56.3636C11 53.7597 12.0345 51.2624 13.8757 49.4211C15.717 47.5799 18.2143 46.5455 20.8182 46.5455H35.8263L31.595 42.3142C30.3169 41.0361 30.3169 38.9639 31.595 37.6858Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).EXTERNAL_LINK]: `<path fillRule="evenodd" clipRule="evenodd" d="M50.3333 13.6667C48.4924 13.6667 47 12.1743 47 10.3333C47 8.49238 48.4924 7 50.3333 7H70.3333C72.1743 7 73.6667 8.49238 73.6667 10.3333V30.3333C73.6667 32.1743 72.1743 33.6667 70.3333 33.6667C68.4924 33.6667 67 32.1743 67 30.3333V18.3807L36.0237 49.357C34.7219 50.6588 32.6114 50.6588 31.3096 49.357C30.0079 48.0553 30.0079 45.9447 31.3096 44.643L62.286 13.6667H50.3333ZM17 23.6667C16.1159 23.6667 15.2681 24.0179 14.643 24.643C14.0179 25.2681 13.6667 26.1159 13.6667 27V63.6667C13.6667 64.5507 14.0179 65.3986 14.643 66.0237C15.2681 66.6488 16.1159 67 17 67H53.6667C54.5507 67 55.3986 66.6488 56.0237 66.0237C56.6488 65.3986 57 64.5507 57 63.6667V43.6667C57 41.8257 58.4924 40.3333 60.3333 40.3333C62.1743 40.3333 63.6667 41.8257 63.6667 43.6667V63.6667C63.6667 66.3188 62.6131 68.8624 60.7377 70.7377C58.8624 72.6131 56.3188 73.6667 53.6667 73.6667H17C14.3478 73.6667 11.8043 72.6131 9.92893 70.7377C8.05357 68.8624 7 66.3188 7 63.6667V27C7 24.3478 8.05357 21.8043 9.92893 19.9289C11.8043 18.0536 14.3478 17 17 17H37C38.841 17 40.3333 18.4924 40.3333 20.3333C40.3333 22.1743 38.841 23.6667 37 23.6667H17Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).EYE_OFF]: `
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.87868 4.87868C6.05025 3.70711 7.94975 3.70711 9.12132 4.87868L24.2663 20.0237C24.2882 20.0449 24.3097 20.0664 24.331 20.0883L35.7495 31.5069C35.7565 31.5138 35.7635 31.5208 35.7704 31.5278L48.472 44.2294C48.4792 44.2364 48.4863 44.2435 48.4933 44.2507L59.9063 55.6637C59.9281 55.6848 59.9497 55.7064 59.971 55.7284L75.1213 70.8787C76.2929 72.0503 76.2929 73.9497 75.1213 75.1213C73.9497 76.2929 72.0503 76.2929 70.8787 75.1213L57.4783 61.7209C52.2887 65.0607 46.2543 66.8981 40.049 66.9996L40 67C28.3015 67 19.3134 60.3207 13.4364 54.0518C10.4705 50.8882 8.2062 47.7361 6.68301 45.3776C5.91955 44.1954 5.33738 43.2051 4.94191 42.502C4.74407 42.1503 4.59262 41.8699 4.48826 41.6727C4.43607 41.5741 4.39563 41.4962 4.36701 41.4405L4.33297 41.3739L4.32262 41.3534L4.31911 41.3464C4.31911 41.3464 4.31672 41.3416 7 40L4.31672 41.3416C3.88078 40.4698 3.89563 39.4405 4.35653 38.5815C7.75106 32.2555 12.2791 26.619 17.7054 21.9481L4.87868 9.12132C3.70711 7.94975 3.70711 6.05025 4.87868 4.87868ZM21.9613 26.2039C17.3509 30.1041 13.448 34.7745 10.4277 40.0095C10.7549 40.5746 11.1878 41.2933 11.7232 42.1224C13.1063 44.2639 15.1545 47.1118 17.8136 49.9482C23.1818 55.6743 30.6853 60.9907 39.9755 61C44.6119 60.92 49.1311 59.6572 53.1142 57.3569L46.1492 50.3919C45.673 50.6904 45.1752 50.9558 44.6594 51.1857C43.1875 51.8415 41.5984 52.1942 39.9872 52.2226C38.376 52.2511 36.7755 51.9547 35.2813 51.3511C33.7871 50.7476 32.4297 49.8493 31.2902 48.7098C30.1507 47.5703 29.2524 46.2129 28.6489 44.7187C28.0453 43.2245 27.7489 41.6241 27.7774 40.0128C27.8058 38.4016 28.1585 36.8125 28.8143 35.3406C29.0442 34.8248 29.3096 34.327 29.6081 33.8508L21.9613 26.2039ZM34.0837 38.3263C33.8911 38.9036 33.7872 39.5079 33.7764 40.1187C33.7622 40.9243 33.9104 41.7245 34.2122 42.4716C34.514 43.2187 34.9631 43.8974 35.5329 44.4671C36.1026 45.0369 36.7813 45.486 37.5284 45.7878C38.2755 46.0896 39.0757 46.2378 39.8813 46.2236C40.4921 46.2128 41.0964 46.1088 41.6737 45.9163L34.0837 38.3263Z"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M39.9944 16L40 16C51.6044 16 59.8453 21.8284 65.0734 27.4587C67.6883 30.2747 69.5917 33.0814 70.8435 35.1843C71.4711 36.2386 71.9395 37.124 72.2555 37.756C72.4137 38.0723 72.534 38.3258 72.6173 38.5062C72.6589 38.5964 72.6914 38.6683 72.7147 38.7208L72.7429 38.7846L72.7518 38.8053L72.7563 38.8157C72.7563 38.8157 72.7574 38.8182 70 40L72.7563 38.8157C73.093 39.6012 73.0797 40.4954 72.7181 41.2697C71.2749 44.3592 69.465 47.2638 67.3274 49.9206C66.2887 51.2115 64.4003 51.416 63.1094 50.3774C61.8185 49.3388 61.614 47.4503 62.6526 46.1594C64.1939 44.2437 65.5368 42.1781 66.6615 39.9943C66.4158 39.5235 66.0919 38.9322 65.6877 38.2532C64.5957 36.4187 62.9367 33.9753 60.6766 31.5414C56.1551 26.6721 49.3969 22.0009 40.0028 22C38.8522 22.0023 37.7027 22.0747 36.5609 22.217C34.9167 22.4218 33.4178 21.255 33.213 19.6109C33.0082 17.9668 34.1749 16.4679 35.8191 16.263C37.2042 16.0905 38.5986 16.0026 39.9944 16Z"/>
    `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).EYE_ON]: '<path d="M40 14C47.6152 14 55.0594 16.2609 61.3879 20.4965C67.7164 24.7322 72.6444 30.7517 75.5478 37.7916C75.5627 37.8276 75.5774 37.8643 75.591 37.9009C76.1363 39.3702 76.1364 40.9866 75.591 42.4559C75.5774 42.4924 75.5626 42.5283 75.5478 42.5643C72.6444 49.6043 67.7165 55.6246 61.3879 59.8602C55.0594 64.0959 47.6152 66.3568 40 66.3568C32.3848 66.3568 24.9406 64.0959 18.612 59.8602C12.2835 55.6246 7.35558 49.6042 4.45215 42.5643C4.43734 42.5283 4.42253 42.4923 4.40901 42.4559C3.86361 40.9866 3.86372 39.3702 4.40901 37.9009L4.45215 37.7916C7.35554 30.7517 12.2836 24.7322 18.612 20.4965C24.9406 16.2609 32.3848 14 40 14ZM40 20.5445C33.681 20.5445 27.5038 22.4209 22.2524 25.9356C17.034 29.4283 12.9639 34.3833 10.5489 40.1779C12.9638 45.9726 17.034 50.9275 22.2524 54.4202C27.5038 57.9349 33.681 59.8113 40 59.8113C46.319 59.8113 52.4962 57.9349 57.7475 54.4202C62.966 50.9275 67.0361 45.9726 69.4511 40.1779C67.0361 34.3833 62.966 29.4283 57.7475 25.9356C52.4962 22.4209 46.319 20.5445 40 20.5445ZM46.5454 40.1769C46.5454 36.5622 43.6148 33.6315 40 33.6315C36.3852 33.6315 33.4546 36.5622 33.4546 40.1769C33.4546 43.7917 36.3852 46.7224 40 46.7224C43.6148 46.7224 46.5454 43.7917 46.5454 40.1769ZM53.0899 40.1769C53.0899 47.4065 47.2295 53.2669 40 53.2669C32.7705 53.2669 26.9101 47.4065 26.9101 40.1769C26.9101 32.9474 32.7705 27.087 40 27.087C47.2295 27.087 53.0899 32.9474 53.0899 40.1769Z" />',
    [(0, $99899ff752f57db8$export$356109f9df11377f).FACE_ID]: `<path d="M26.1564 29.467V35.6054C26.1564 37.1841 24.884 38.4566 23.3288 38.4566C21.7736 38.4566 20.5012 37.1841 20.5012 35.6054V29.467C20.5012 27.9 21.7618 26.6158 23.3288 26.6158C24.8958 26.6158 26.1564 27.9 26.1564 29.467Z" /><path d="M59.5107 29.467V35.6171C59.5107 37.1841 58.25 38.4566 56.683 38.4566C55.1161 38.4566 53.8554 37.1841 53.8554 35.6171V29.467C53.8554 27.9 55.1278 26.6158 56.683 26.6158C58.2383 26.6158 59.5107 27.9 59.5107 29.467Z" /> <path d="M43.511 28.9604V43.6759C43.511 47.2223 40.648 50.097 37.137 50.097H35.7586C34.5686 50.097 33.5907 49.1191 33.5907 47.9174C33.5907 46.7156 34.5686 45.726 35.7586 45.726H37.137C38.2563 45.726 39.1753 44.807 39.1753 43.6759V28.9604C39.1753 27.7587 40.1414 26.7808 41.3431 26.7808C42.5449 26.7808 43.511 27.7587 43.511 28.9604Z" /> <path d="M54.2678 58.3325C51.0985 61.9731 45.7849 64.1527 40.0354 64.1527C34.2858 64.1527 28.8898 61.9495 25.7322 58.2501C24.9546 57.3429 25.0607 55.9644 25.9679 55.175C26.8751 54.3856 28.2418 54.4917 29.0194 55.4106C31.3286 58.1087 35.5465 59.7935 40.0354 59.7935C44.5242 59.7935 48.6832 58.1322 51.0042 55.4578C51.7936 54.5506 53.1603 54.4563 54.0557 55.2457C54.9629 56.0468 55.0454 57.4253 54.2678 58.3325Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M14.8 11.2C13.8452 11.2 12.9295 11.5793 12.2544 12.2544C11.5793 12.9295 11.2 13.8452 11.2 14.8V22C11.2 23.9882 9.58822 25.6 7.59999 25.6C5.61177 25.6 3.99999 23.9882 3.99999 22V14.8C3.99999 11.9357 5.13785 9.18864 7.16324 7.16325C9.18863 5.13785 11.9357 4 14.8 4H22C23.9882 4 25.6 5.61178 25.6 7.6C25.6 9.58823 23.9882 11.2 22 11.2H14.8Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M54.4 7.6C54.4 5.61178 56.0118 4 58 4H65.2C68.0643 4 70.8114 5.13785 72.8367 7.16325C74.8621 9.18864 76 11.9357 76 14.8V22C76 23.9882 74.3882 25.6 72.4 25.6C70.4118 25.6 68.8 23.9882 68.8 22V14.8C68.8 13.8452 68.4207 12.9296 67.7456 12.2544C67.0704 11.5793 66.1548 11.2 65.2 11.2H58C56.0118 11.2 54.4 9.58823 54.4 7.6Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M72.4 54.4001C74.3882 54.4001 76 56.0119 76 58.0001V65.2001C76 68.0645 74.8621 70.8115 72.8367 72.8369C70.8114 74.8623 68.0643 76.0001 65.2 76.0001H58C56.0118 76.0001 54.4 74.3883 54.4 72.4001C54.4 70.4119 56.0118 68.8001 58 68.8001H65.2C66.1548 68.8001 67.0704 68.4208 67.7456 67.7457C68.4207 67.0706 68.8 66.1549 68.8 65.2001V58.0001C68.8 56.0119 70.4118 54.4001 72.4 54.4001Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M7.59999 54.4001C9.58822 54.4001 11.2 56.0119 11.2 58.0001V65.2001C11.2 66.1549 11.5793 67.0706 12.2544 67.7457C12.9295 68.4208 13.8452 68.8001 14.8 68.8001H22C23.9882 68.8001 25.6 70.4119 25.6 72.4001C25.6 74.3883 23.9882 76.0001 22 76.0001H14.8C11.9357 76.0001 9.18863 74.8623 7.16324 72.8369C5.13785 70.8115 3.99999 68.0644 3.99999 65.2001V58.0001C3.99999 56.0119 5.61177 54.4001 7.59999 54.4001Z"/>
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).FILE_DOWNLOAD]: `<path fillRule="evenodd" clipRule="evenodd" d="M13.8757 6.87568C15.7169 5.03441 18.2142 4 20.8182 4H50.2727C51.1407 4 51.9731 4.3448 52.5869 4.95856L68.9505 21.3222C69.5643 21.936 69.9091 22.7684 69.9091 23.6364V66.1818C69.9091 68.7858 68.8747 71.2831 67.0334 73.1243C65.1921 74.9656 62.6949 76 60.0909 76H20.8182C18.2142 76 15.7169 74.9656 13.8757 73.1243C12.0344 71.2831 11 68.7858 11 66.1818V13.8182C11 11.2142 12.0344 8.71694 13.8757 6.87568ZM20.8182 10.5455C19.9502 10.5455 19.1178 10.8903 18.504 11.504C17.8903 12.1178 17.5455 12.9502 17.5455 13.8182V66.1818C17.5455 67.0498 17.8903 67.8822 18.504 68.496C19.1178 69.1097 19.9502 69.4545 20.8182 69.4545H60.0909C60.9589 69.4545 61.7913 69.1097 62.4051 68.496C63.0188 67.8822 63.3636 67.0498 63.3636 66.1818V24.992L48.9171 10.5455H20.8182Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M46.9961 4C48.8035 4 50.2688 5.46525 50.2688 7.27273V20.3636C50.2688 21.2316 50.6136 22.064 51.2274 22.6778C51.8411 23.2916 52.6735 23.6364 53.5415 23.6364H66.6324C68.4399 23.6364 69.9052 25.1016 69.9052 26.9091C69.9052 28.7166 68.4399 30.1818 66.6324 30.1818H53.5415C50.9376 30.1818 48.4403 29.1474 46.599 27.3061C44.7578 25.4649 43.7233 22.9676 43.7233 20.3636V7.27273C43.7233 5.46525 45.1886 4 46.9961 4Z"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M40.4555 36.7263C42.263 36.7263 43.7283 38.1915 43.7283 39.999V59.6354C43.7283 61.4429 42.263 62.9081 40.4555 62.9081C38.6481 62.9081 37.1828 61.4429 37.1828 59.6354V39.999C37.1828 38.1915 38.6481 36.7263 40.4555 36.7263Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M28.3232 47.503C29.6013 46.225 31.6734 46.225 32.9515 47.503L40.4555 55.007L47.9595 47.503C49.2376 46.225 51.3098 46.225 52.5879 47.503C53.866 48.7811 53.866 50.8533 52.5879 52.1314L42.7697 61.9495C41.4916 63.2276 39.4194 63.2276 38.1414 61.9495L28.3232 52.1314C27.0451 50.8533 27.0451 48.7811 28.3232 47.503Z"/>
    `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).FILE_UPLOAD]: `<path d="M11 66.1823V13.8187C11 11.2148 12.0342 8.71724 13.8755 6.87596C15.7167 5.03469 18.2143 4.00049 20.8182 4.00049H50.2729L50.4349 4.00432C51.2437 4.04446 52.0112 4.38315 52.5865 4.95834L68.9505 21.3224C69.5643 21.9361 69.9094 22.769 69.9094 23.6369V66.1823C69.9094 68.7862 68.8742 71.2837 67.0329 73.125C65.1918 74.966 62.6948 76.0004 60.0911 76.0005H20.8182C18.2143 76.0005 15.7167 74.9662 13.8755 73.125C12.0342 71.2837 11 68.7862 11 66.1823ZM37.1813 59.6365V47.9016L32.9501 52.1328C31.672 53.4107 29.5999 53.4108 28.3219 52.1328C27.0438 50.8548 27.044 48.7827 28.3219 47.5046L38.1401 37.6864L38.2619 37.5704C39.5466 36.4093 41.53 36.4481 42.7683 37.6864L52.5865 47.5046C53.8646 48.7827 53.8646 50.8547 52.5865 52.1328C51.3084 53.4107 49.2364 53.4108 47.9583 52.1328L43.7271 47.9016V59.6365C43.7271 61.4438 42.262 62.9097 40.4547 62.9098C38.6472 62.9098 37.1813 61.4439 37.1813 59.6365ZM50.2729 20.3636C50.2729 21.2315 50.6171 22.0644 51.2308 22.6781C51.8445 23.2919 52.6773 23.6369 53.5453 23.6369H62.0088L50.2729 11.9011V20.3636ZM17.5448 66.1823L17.5496 66.3443C17.5897 67.1533 17.9282 67.9214 18.5037 68.4968C19.1174 69.1105 19.9503 69.4547 20.8182 69.4547H60.0911C60.9588 69.4546 61.7911 69.1103 62.4047 68.4968C63.0185 67.8831 63.3635 67.0502 63.3635 66.1823V30.1818H53.5453C50.9414 30.1818 48.4438 29.1476 46.6026 27.3063C44.7614 25.465 43.7271 22.9674 43.7271 20.3636V10.5453H20.8182C19.9502 10.5453 19.1174 10.8904 18.5037 11.5041C17.8899 12.1179 17.5448 12.9507 17.5448 13.8187V66.1823Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).FILE_RESPONSE]: `<path d="M11 36.7271V13.8182C11 11.2143 12.0342 8.71675 13.8755 6.87547C15.7167 5.0342 18.2143 4 20.8182 4H50.2729L50.4349 4.00384C51.2437 4.04397 52.0112 4.38267 52.5865 4.95785L68.9505 21.3219C69.5643 21.9356 69.9094 22.7685 69.9094 23.6365V66.1818C69.9094 68.7857 68.8742 71.2832 67.0329 73.1245C65.1917 74.9655 62.6948 75.9999 60.0911 76H20.8182C18.2143 76 15.7167 74.9657 13.8755 73.1245C12.0342 71.2832 11 68.7857 11 66.1818V56.3635C11 53.7596 12.0342 51.2621 13.8755 49.4208C15.7167 47.5796 18.2143 46.5453 20.8182 46.5453H35.8284L31.5943 42.3112C30.3162 41.0331 30.3162 38.9602 31.5943 37.6821C32.8724 36.404 34.9454 36.404 36.2234 37.6821L46.0417 47.5003C46.6204 48.079 46.9353 48.8211 46.9899 49.578C46.9957 49.6572 46.9995 49.7371 46.9995 49.8177C46.9995 50.7497 46.6093 51.59 45.9841 52.186L36.2234 61.9477C34.9454 63.2257 32.8724 63.2257 31.5943 61.9477C30.3162 60.6696 30.3162 58.5966 31.5943 57.3185L35.8217 53.0911H20.8182C19.9503 53.0911 19.1174 53.4353 18.5037 54.049C17.8899 54.6627 17.5448 55.4956 17.5448 56.3635V66.1818L17.5496 66.3438C17.5897 67.1528 17.9282 67.9209 18.5037 68.4963C19.1174 69.11 19.9503 69.4542 20.8182 69.4542H60.0911C60.9588 69.4541 61.7911 69.1098 62.4047 68.4963C63.0185 67.8826 63.3635 67.0498 63.3635 66.1818V30.1813H53.4945C50.8906 30.1813 48.393 29.1471 46.5518 27.3058C44.7105 25.4645 43.6763 22.967 43.6763 20.3631V10.5448H20.8182C19.9502 10.5448 19.1174 10.8899 18.5037 11.5037C17.8899 12.1174 17.5448 12.9502 17.5448 13.8182V36.7271C17.5448 38.5346 16.0799 39.9995 14.2724 39.9995C12.4649 39.9995 11 38.5346 11 36.7271ZM50.2211 20.3631C50.2211 21.2311 50.5662 22.0639 51.1799 22.6776C51.7937 23.2914 52.6265 23.6365 53.4945 23.6365H62.0088L50.2211 11.8488V20.3631Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).FILTERS]: `<path d="M67.8799 38.9479C67.8799 40.1901 66.8078 41.2401 65.536 41.2401H35.582C34.8425 41.2401 34.0366 41.6394 33.6373 42.2901C32.432 44.1978 30.3542 45.4474 27.9437 45.4474C25.5332 45.4474 23.3815 44.1978 22.2428 42.2901C21.8435 41.6394 21.1041 41.2401 20.2981 41.2401H15.344C14.0722 41.2401 13 40.1901 13 38.9479C13 37.7056 14.0722 36.6483 15.344 36.6483H20.2981C21.0375 36.6483 21.8435 36.2564 22.2428 35.5983C23.448 33.6906 25.5258 32.4483 27.9437 32.4483C30.3616 32.4483 32.432 33.6906 33.6373 35.5983C34.0366 36.2564 34.776 36.6483 35.582 36.6483H65.536C66.8078 36.6483 67.8799 37.6982 67.8799 38.9479ZM67.8799 54.8307C67.8799 56.0803 66.8078 57.1303 65.536 57.1303H61.1808C60.4414 57.1303 59.6354 57.5222 59.2361 58.1803C58.0308 60.088 55.9531 61.3302 53.5351 61.3302C51.1172 61.3302 48.9803 60.088 47.8416 58.1803C47.4423 57.5222 46.7029 57.1303 45.8969 57.1303H15.344C14.0722 57.1303 13 56.0803 13 54.8307C13 53.5811 14.0722 52.5385 15.344 52.5385H45.8969C46.6363 52.5385 47.4423 52.1392 47.8416 51.4811C49.0468 49.5808 51.1246 48.3312 53.5351 48.3312C55.9457 48.3312 58.0308 49.5808 59.2361 51.4811C59.6354 52.1392 60.3748 52.5385 61.1808 52.5385H65.536C66.8078 52.5385 67.8799 53.5885 67.8799 54.8307ZM67.8799 24.4995C67.8799 25.7492 66.8078 26.7991 65.5286 26.7991H61.1734C60.3674 26.7991 59.628 27.191 59.2213 27.8491C58.0826 29.7568 55.9383 30.9991 53.5204 30.9991C51.1024 30.9991 49.0247 29.7568 47.8194 27.8491C47.4127 27.191 46.6141 26.7991 45.8747 26.7991H15.344C14.0722 26.7991 13 25.7492 13 24.4995C13 23.2499 14.0722 22.2073 15.344 22.2073H45.9413C46.7472 22.2073 47.4793 21.808 47.886 21.1573C49.0247 19.2496 51.1764 18 53.5869 18C55.9974 18 58.0826 19.2496 59.2878 21.1573C59.6945 21.808 60.5005 22.2073 61.2399 22.2073H65.5286C66.8078 22.2073 67.8799 23.2573 67.8799 24.4995Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).FILTERS_ACTIVE]: `<path d="M67.8799 38.9479C67.8799 40.1901 66.8078 41.2401 65.536 41.2401H35.582C34.8425 41.2401 34.0366 41.6394 33.6373 42.2901C32.432 44.1978 30.3542 45.4474 27.9437 45.4474C25.5332 45.4474 23.3815 44.1978 22.2428 42.2901C21.8435 41.6394 21.1041 41.2401 20.2981 41.2401H15.344C14.0722 41.2401 13 40.1901 13 38.9479C13 37.7056 14.0722 36.6483 15.344 36.6483H20.2981C21.0375 36.6483 21.8435 36.2564 22.2428 35.5983C23.448 33.6906 25.5258 32.4483 27.9437 32.4483C30.3616 32.4483 32.432 33.6906 33.6373 35.5983C34.0366 36.2564 34.776 36.6483 35.582 36.6483H65.536C66.8078 36.6483 67.8799 37.6982 67.8799 38.9479ZM67.8799 54.8307C67.8799 56.0803 66.8078 57.1303 65.536 57.1303H61.1808C60.4414 57.1303 59.6354 57.5222 59.2361 58.1803C58.0308 60.088 55.9531 61.3302 53.5351 61.3302C51.1172 61.3302 48.9803 60.088 47.8416 58.1803C47.4423 57.5222 46.7029 57.1303 45.8969 57.1303H15.344C14.0722 57.1303 13 56.0803 13 54.8307C13 53.5811 14.0722 52.5385 15.344 52.5385H45.8969C46.6363 52.5385 47.4423 52.1392 47.8416 51.4811C49.0468 49.5808 51.1246 48.3312 53.5351 48.3312C55.9457 48.3312 58.0308 49.5808 59.2361 51.4811C59.6354 52.1392 60.3748 52.5385 61.1808 52.5385H65.536C66.8078 52.5385 67.8799 53.5885 67.8799 54.8307ZM67.8799 24.4995C67.8799 25.7492 66.8078 26.7991 65.5286 26.7991H61.1734C60.3674 26.7991 59.628 27.191 59.2213 27.8491C58.0826 29.7568 55.9383 30.9991 53.5204 30.9991C51.1024 30.9991 49.0247 29.7568 47.8194 27.8491C47.4127 27.191 46.6141 26.7991 45.8747 26.7991H15.344C14.0722 26.7991 13 25.7492 13 24.4995C13 23.2499 14.0722 22.2073 15.344 22.2073H45.9413C46.7472 22.2073 47.4793 21.808 47.886 21.1573C49.0247 19.2496 51.1764 18 53.5869 18C55.9974 18 58.0826 19.2496 59.2878 21.1573C59.6945 21.808 60.5005 22.2073 61.2399 22.2073H65.5286C66.8078 22.2073 67.8799 23.2573 67.8799 24.4995Z" />
        <path d="M71.1354 18.7297C74.3757 18.7297 77.0002 16.1052 77.0002 12.8649C77.0002 9.62452 74.3757 7 71.1354 7C67.895 7 65.2705 9.62452 65.2705 12.8649C65.2705 16.1052 67.895 18.7297 71.1354 18.7297Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).FLAG]: `<path d="M16.6188 72.6953C16.6188 73.607 16.3055 74.3857 15.6787 75.0314C15.052 75.6771 14.2733 76 13.3427 76C12.412 76 11.6144 75.6771 10.9686 75.0314C10.3229 74.3857 10 73.607 10 72.6953V7.31417C10 6.40253 10.3229 5.62385 10.9686 4.97811C11.6144 4.32287 12.4025 4 13.3427 4C14.2828 4 15.0615 4.31337 15.6787 4.94012C16.3055 5.56687 16.6188 6.35505 16.6188 7.31417V7.45661H66.5118C67.5184 7.45661 68.3825 7.81746 69.1042 8.53917C69.8259 9.26088 70.1868 10.144 70.1868 11.2076C70.1868 12.2712 69.7785 13.1543 68.9618 13.876L54.6321 26.9807C53.8629 27.655 53.464 28.5096 53.445 29.5352C53.4165 30.5703 53.7489 31.4724 54.4136 32.2321L68.9618 45.5553C69.731 46.2295 70.1393 47.0841 70.1868 48.1097C70.2343 49.1448 69.9114 50.0565 69.2182 50.8446C68.525 51.6328 67.6228 52.0317 66.5213 52.0317H16.6188V72.6953Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).GLOBE]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 10.5455C23.7326 10.5455 10.5453 23.7327 10.5453 40C10.5453 56.2673 23.7326 69.4545 40 69.4545C56.2674 69.4545 69.4547 56.2673 69.4547 40C69.4547 23.7327 56.2674 10.5455 40 10.5455ZM3.99983 40C3.99983 20.1177 20.1177 4 40 4C59.8823 4 76.0001 20.1177 76.0001 40C76.0001 59.8823 59.8823 76 40 76C20.1177 76 3.99983 59.8823 3.99983 40Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M3.99983 40C3.99983 38.1925 5.46509 36.7273 7.27257 36.7273H72.7274C74.5349 36.7273 76.0001 38.1925 76.0001 40C76.0001 41.8075 74.5349 43.2727 72.7274 43.2727H7.27257C5.46509 43.2727 3.99983 41.8075 3.99983 40Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M40 4C40.9194 4 41.7964 4.38671 42.4164 5.06552C51.1375 14.6132 56.0937 27.0035 56.363 39.9318C56.3639 39.9773 56.3639 40.0227 56.363 40.0682C56.0937 52.9965 51.1375 65.3869 42.4164 74.9345C41.7964 75.6133 40.9194 76 40 76C39.0806 76 38.2036 75.6133 37.5836 74.9345C28.8625 65.3869 23.9063 52.9965 23.637 40.0682C23.636 40.0227 23.636 39.9773 23.637 39.9318C23.9063 27.0035 28.8625 14.6132 37.5836 5.06552C38.2036 4.38671 39.0806 4 40 4ZM30.1825 40C30.4068 50.0631 33.8677 59.7514 40 67.6519C46.1323 59.7514 49.5932 50.0631 49.8175 40C49.5932 29.9369 46.1323 20.2486 40 12.3481C33.8677 20.2486 30.4068 29.9369 30.1825 40Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).HEART]: `<path fillRule="evenodd" clipRule="evenodd" d="M16.9463 8.60017C19.4904 7.54379 22.218 7 24.9727 7C27.7274 7 30.455 7.54379 32.999 8.60017C35.5431 9.65656 37.8536 11.2048 39.7981 13.156L39.809 13.1669L39.9998 13.3603L40.1906 13.167L40.2015 13.156C42.1459 11.2048 44.4564 9.65656 47.0005 8.60017C49.5446 7.54379 52.2722 7 55.0269 7C57.7816 7 60.5092 7.54379 63.0532 8.60017C65.5964 9.6562 67.9063 11.2037 69.8503 13.154C78.1733 21.4793 78.3584 35.2446 68.4961 45.2917L68.4749 45.3133L42.3122 71.4759C41.6989 72.0892 40.8671 72.4338 39.9998 72.4338C39.1324 72.4338 38.3006 72.0892 37.6873 71.4759L11.5033 45.2918C1.64106 35.2447 1.82622 21.4793 10.1493 13.154C12.0933 11.2037 14.4031 9.6562 16.9463 8.60017ZM24.9727 13.5407C23.0788 13.5407 21.2036 13.9145 19.4546 14.6408C17.7055 15.3671 16.117 16.4315 14.7802 17.7729L14.7762 17.777C9.23753 23.3157 8.57125 32.9584 16.1609 40.6994L39.9998 64.5385L63.8387 40.6994C71.4283 32.9584 70.762 23.3157 65.2234 17.777L65.2194 17.7729C63.8825 16.4315 62.2941 15.3671 60.545 14.6408C58.7959 13.9145 56.9207 13.5407 55.0269 13.5407C53.133 13.5407 51.2578 13.9145 49.5088 14.6408C47.762 15.3661 46.1754 16.4287 44.8397 17.7676C44.8379 17.7694 44.8362 17.7712 44.8344 17.7729L42.3271 20.3129C41.7126 20.9353 40.8744 21.2857 39.9998 21.2857C39.1251 21.2857 38.2869 20.9353 37.6724 20.3129L35.1652 17.7729C35.1634 17.7712 35.1616 17.7694 35.1599 17.7676C33.8242 16.4287 32.2376 15.3661 30.4908 14.6408C28.7417 13.9145 26.8665 13.5407 24.9727 13.5407Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).HEART_ACTIVE]: `<path fillRule="evenodd" clipRule="evenodd" d="M16.9466 8.60017C19.4906 7.54379 22.2182 7 24.9729 7C27.7276 7 30.4552 7.54379 32.9993 8.60017C35.5434 9.65656 37.8539 11.2048 39.7984 13.156L39.8092 13.1669L40 13.3603L40.1908 13.167L40.2017 13.156C42.1462 11.2048 44.4567 9.65656 47.0008 8.60017C49.5448 7.54379 52.2724 7 55.0271 7C57.7818 7 60.5094 7.54379 63.0535 8.60017C65.5967 9.6562 67.9065 11.2037 69.8505 13.154C78.1736 21.4793 78.3586 35.2446 68.4964 45.2917L68.4751 45.3133L42.3125 71.4759C41.6992 72.0892 40.8674 72.4338 40 72.4338C39.1327 72.4338 38.3009 72.0892 37.6876 71.4759L11.5036 45.2918C1.6413 35.2447 1.82647 21.4793 10.1495 13.154C12.0936 11.2037 14.4034 9.6562 16.9466 8.60017Z" />  /> `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).HOME]: `<path fillRule="evenodd" clipRule="evenodd" d="M37.7163 4.68935C38.898 3.77022 40.5528 3.77022 41.7346 4.68935L71.1874 27.5971C71.9846 28.2171 72.4508 29.1704 72.4508 30.1803V66.1783C72.4508 68.7821 71.4165 71.2792 69.5753 73.1204C67.7341 74.9615 65.237 75.9959 62.6332 75.9959H49.7083C49.6535 75.9986 49.5984 76 49.543 76C49.4876 76 49.4325 75.9986 49.3778 75.9959H30.073C30.0183 75.9986 29.9632 76 29.9078 76C29.8524 76 29.7973 75.9986 29.7425 75.9959H16.8176C14.2138 75.9959 11.7167 74.9615 9.87551 73.1204C8.03435 71.2792 7 68.7821 7 66.1783V30.1803C7 29.1704 7.46625 28.2171 8.2634 27.5971L37.7163 4.68935ZM33.1803 69.4508H46.2705V43.2746H33.1803V69.4508ZM52.8156 69.4508V40.002C52.8156 38.1947 51.3504 36.7295 49.543 36.7295H29.9078C28.1004 36.7295 26.6352 38.1947 26.6352 40.002V69.4508H16.8176C15.9497 69.4508 15.1173 69.106 14.5036 68.4923C13.8899 67.8786 13.5451 67.0462 13.5451 66.1783V31.7809L39.7254 11.4184L65.9057 31.7809V66.1783C65.9057 67.0462 65.5609 67.8786 64.9472 68.4923C64.3335 69.106 63.5011 69.4508 62.6332 69.4508H52.8156Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).IMAGE]: `<path fillRule="evenodd" clipRule="evenodd" d="M63.7857 66.7143C64.5624 66.7143 65.3073 66.4057 65.8565 65.8565C66.4057 65.3073 66.7143 64.5624 66.7143 63.7857V51.6987L57.2848 42.2692C56.7356 41.7204 55.9906 41.4117 55.2143 41.4117C54.4379 41.4117 53.6932 41.7201 53.1441 42.2689L28.6987 66.7143H63.7857ZM62.8398 36.7125L66.7143 40.587V39.7857C66.7143 38.4561 66.7141 36.7783 66.7139 34.9297C66.7138 34.468 66.7137 33.9956 66.7137 33.5153C66.7132 30.9605 66.7127 28.1827 66.7121 25.5982L66.71 15.7813C66.71 15.2977 66.66 14.9397 66.5405 14.6333C66.4247 14.3366 66.2302 14.0544 65.8887 13.7449C65.3053 13.292 65.0022 13.087 64.7415 12.9806C64.5012 12.8825 64.2702 12.8571 63.78 12.8571H15.7857C15.009 12.8571 14.2641 13.1657 13.7149 13.7149C13.1657 14.2641 12.8571 15.009 12.8571 15.7857V63.7857C12.8571 64.5624 13.1657 65.3073 13.7149 65.8565C14.2641 66.4057 15.009 66.7143 15.7857 66.7143H17.587L47.5884 36.7129C49.611 34.6909 52.3543 33.5546 55.2143 33.5546C57.5734 33.5546 59.8528 34.3275 61.714 35.733C62.0628 35.9964 62.3969 36.282 62.7141 36.5889C62.7563 36.6297 62.7982 36.6709 62.8398 36.7125ZM71.2536 7.99705C71.3123 8.05725 71.3638 8.11008 71.4087 8.15414C72.3193 9.04628 73.1236 9.93094 73.6902 11.1181C74.2584 12.3087 74.5697 13.7636 74.57 15.7812C74.5714 24.4954 74.5714 34.522 74.5714 39.7857V63.7857C74.5714 66.6463 73.4351 69.3897 71.4124 71.4124C69.3897 73.4351 66.6463 74.5714 63.7857 74.5714H15.7857C12.9252 74.5714 10.1818 73.4351 8.15906 71.4124C6.13635 69.3896 5 66.6463 5 63.7857V15.7857C5 12.9252 6.13635 10.1818 8.15906 8.15906C10.1818 6.13635 12.9252 5 15.7857 5L63 5.00001C65.8235 5.00001 67.7437 5.59539 69.0626 6.30457C70.2008 6.91655 70.8757 7.60916 71.2536 7.99705Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M24.318 28.318C22.5607 30.0754 22.5607 32.9246 24.318 34.682C26.0754 36.4393 28.9246 36.4393 30.682 34.682L34.9246 38.9246C30.8241 43.0251 24.1759 43.0251 20.0754 38.9246C15.9749 34.8241 15.9749 28.1759 20.0754 24.0754C24.1759 19.9749 30.8241 19.9749 34.9246 24.0754C39.0251 28.1759 39.0251 34.8241 34.9246 38.9246L30.682 34.682C32.4393 32.9246 32.4393 30.0754 30.682 28.318C28.9246 26.5607 26.0754 26.5607 24.318 28.318Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).IMAGE_UPLOAD]: `<path fillRule="evenodd" clipRule="evenodd" d="M62.2857 4C64.1793 4 65.7143 5.53502 65.7143 7.42857V14.2857H72.5714C74.465 14.2857 76 15.8207 76 17.7143C76 19.6078 74.465 21.1429 72.5714 21.1429H65.7143V28C65.7143 29.8935 64.1793 31.4286 62.2857 31.4286C60.3922 31.4286 58.8571 29.8935 58.8571 28V21.1429H52C50.1065 21.1429 48.5714 19.6078 48.5714 17.7143C48.5714 15.8207 50.1065 14.2857 52 14.2857H58.8571V7.42857C58.8571 5.53502 60.3922 4 62.2857 4ZM14.2857 14.2857C13.3764 14.2857 12.5043 14.6469 11.8613 15.2899C11.2184 15.9329 10.8571 16.805 10.8571 17.7143V65.7143C10.8571 66.6236 11.2184 67.4957 11.8613 68.1386C12.5043 68.7816 13.3764 69.1429 14.2857 69.1429H16.2941L46.4419 38.9951C48.3708 37.0668 50.9869 35.9832 53.7143 35.9832C56.4417 35.9832 59.0574 37.0664 60.9863 38.9947L65.7143 43.7227V41.7143C65.7143 39.8207 67.2493 38.2857 69.1429 38.2857C71.0364 38.2857 72.5714 39.8207 72.5714 41.7143V51.9966C72.5714 51.9989 72.5714 52.0011 72.5714 52.0034V65.7143C72.5714 68.4422 71.4878 71.0584 69.5588 72.9874C67.6299 74.9163 65.0137 76 62.2857 76H17.7176C17.7154 76 17.7132 76 17.7109 76H14.2857C11.5578 76 8.94156 74.9163 7.01262 72.9874C5.08367 71.0584 4 68.4422 4 65.7143V17.7143C4 14.9863 5.08367 12.3701 7.01262 10.4412C8.94156 8.51224 11.5578 7.42857 14.2857 7.42857H38.2857C40.1793 7.42857 41.7143 8.9636 41.7143 10.8571C41.7143 12.7507 40.1793 14.2857 38.2857 14.2857H14.2857ZM25.9916 69.1429H62.2857C63.195 69.1429 64.0671 68.7816 64.7101 68.1386C65.3531 67.4957 65.7143 66.6236 65.7143 65.7143V53.4202L56.1383 43.8442C55.4954 43.2016 54.6232 42.8403 53.7143 42.8403C52.8053 42.8403 51.9336 43.2013 51.2907 43.8438L25.9916 69.1429ZM28 28C26.1065 28 24.5714 29.535 24.5714 31.4286C24.5714 33.3221 26.1065 34.8571 28 34.8571C29.8935 34.8571 31.4286 33.3221 31.4286 31.4286C31.4286 29.535 29.8935 28 28 28ZM17.7143 31.4286C17.7143 25.7479 22.3194 21.1429 28 21.1429C33.6806 21.1429 38.2857 25.7479 38.2857 31.4286C38.2857 37.1092 33.6806 41.7143 28 41.7143C22.3194 41.7143 17.7143 37.1092 17.7143 31.4286Z" />
    `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).INFO]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 10.5455C23.7327 10.5455 10.5455 23.7327 10.5455 40C10.5455 56.2673 23.7327 69.4545 40 69.4545C56.2673 69.4545 69.4545 56.2673 69.4545 40C69.4545 23.7327 56.2673 10.5455 40 10.5455ZM4 40C4 20.1177 20.1177 4 40 4C59.8823 4 76 20.1177 76 40C76 59.8823 59.8823 76 40 76C20.1177 76 4 59.8823 4 40ZM36.7273 26.9091C36.7273 25.1016 38.1925 23.6364 40 23.6364H40.0327C41.8402 23.6364 43.3055 25.1016 43.3055 26.9091C43.3055 28.7166 41.8402 30.1818 40.0327 30.1818H40C38.1925 30.1818 36.7273 28.7166 36.7273 26.9091ZM40 36.7273C41.8075 36.7273 43.2727 38.1925 43.2727 40V53.0909C43.2727 54.8984 41.8075 56.3636 40 56.3636C38.1925 56.3636 36.7273 54.8984 36.7273 53.0909V40C36.7273 38.1925 38.1925 36.7273 40 36.7273Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).INPUT_DOTS]: `<path d="M69.4573 26.8176C69.456 25.0114 67.9887 23.5502 66.1822 23.5502H13.8178C12.0124 23.5515 10.5517 25.0123 10.5503 26.8176V53.0037C10.5517 54.809 12.0124 56.2698 13.8178 56.2711H66.1822C67.9887 56.2711 69.456 54.8099 69.4573 53.0037V26.8176ZM23.674 36.6355C25.4814 36.6355 26.9492 38.1032 26.9492 39.9107C26.9492 41.7181 25.4814 43.1858 23.674 43.1858H23.6357C21.8294 43.1844 20.3682 41.7172 20.3682 39.9107C20.3682 38.1041 21.8294 36.6369 23.6357 36.6355H23.674ZM40.0422 36.6355C41.8488 36.6364 43.3097 38.1038 43.3097 39.9107C43.3097 41.7175 41.8488 43.1849 40.0422 43.1858H40.0038C38.1964 43.1858 36.7287 41.7181 36.7287 39.9107C36.7287 38.1032 38.1964 36.6355 40.0038 36.6355H40.0422ZM56.4027 36.6355C58.2101 36.6355 59.6779 38.1032 59.6779 39.9107C59.6779 41.7181 58.2101 43.1858 56.4027 43.1858H56.3643C54.5569 43.1858 53.0892 41.7181 53.0892 39.9107C53.0892 38.1032 54.5569 36.6355 56.3643 36.6355H56.4027ZM76 53.0037C75.9986 58.4247 71.6036 62.8215 66.1822 62.8215H13.8178C8.39762 62.8201 4.00138 58.4239 4 53.0037V26.8176C4.00138 21.3974 8.39762 17.0012 13.8178 16.9998H66.1822C71.6036 16.9998 75.9986 21.3966 76 26.8176V53.0037Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).KEY]: `<path fillRule="evenodd" clipRule="evenodd" d="M75.9998 39.3415C75.9998 40.837 74.7875 42.0493 73.292 42.0493L68.3411 42.0493V50.8295C68.3411 52.325 67.1288 53.5373 65.6334 53.5373L52.2308 53.5373C50.7353 53.5373 49.523 52.325 49.523 50.8295L49.523 42.0493L39.006 42.0493C38.7986 43.4341 38.4261 44.7925 37.8942 46.0949C37.0167 48.2438 35.7228 50.198 34.087 51.8449C32.4511 53.4917 30.5057 54.7987 28.3626 55.6906C26.2196 56.5825 23.9213 57.0416 21.6 57.0416C19.2788 57.0416 16.9805 56.5825 14.8375 55.6906C12.6944 54.7987 10.749 53.4917 9.11314 51.8449C7.4773 50.198 6.18337 48.2438 5.30586 46.0949C4.42835 43.9459 3.9846 41.6446 4.00015 39.3234L4.00034 39.2945C4.08054 34.6802 5.96999 30.2821 9.26146 27.0473C12.5529 23.8126 16.9832 22 21.5981 22C26.213 22 30.6433 23.8126 33.9348 27.0473C36.5861 29.653 38.3277 33.0135 38.9467 36.6338L73.292 36.6338C74.7875 36.6338 75.9998 37.8461 75.9998 39.3415ZM33.7848 39.4905C33.7829 39.4567 33.7817 39.4227 33.7811 39.3886C33.7256 36.1941 32.4176 33.1493 30.1389 30.9098C27.8602 28.6703 24.7931 27.4155 21.5981 27.4155C18.4032 27.4155 15.3361 28.6704 13.0574 30.9098C10.7821 33.1459 9.47461 36.185 9.41541 39.3742C9.40659 40.9762 9.71378 42.5644 10.3195 44.0476C10.927 45.5354 11.8228 46.8883 12.9553 48.0284C14.0878 49.1685 15.4346 50.0734 16.9183 50.6908C18.4019 51.3083 19.993 51.6262 21.6001 51.6262C23.2071 51.6262 24.7982 51.3083 26.2818 50.6908C27.7655 50.0734 29.1123 49.1685 30.2448 48.0284C31.3773 46.8883 32.2731 45.5354 32.8806 44.0476C33.4717 42.6002 33.7785 41.053 33.7848 39.4905ZM54.9385 42.0493V48.1218H62.9256V42.0493L54.9385 42.0493Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LIBRARY]: `<path fillRule="evenodd" clipRule="evenodd" d="M3.99976 7.60003C3.99976 5.61179 5.61153 4 7.59976 4H32.7998C34.788 4 36.3998 5.61179 36.3998 7.60003V32.8002C36.3998 34.7885 34.788 36.4002 32.7998 36.4002H7.59976C5.61153 36.4002 3.99976 34.7885 3.99976 32.8002V7.60003ZM11.1998 11.2001V29.2002H29.1998V11.2001H11.1998ZM43.5998 7.60003C43.5998 5.61179 45.2115 4 47.1998 4H72.3998C74.388 4 75.9998 5.61179 75.9998 7.60003V32.8002C75.9998 34.7885 74.388 36.4002 72.3998 36.4002H47.1998C45.2115 36.4002 43.5998 34.7885 43.5998 32.8002V7.60003ZM50.7998 11.2001V29.2002H68.7998V11.2001H50.7998ZM3.99976 47.2003C3.99976 45.2121 5.61153 43.6003 7.59976 43.6003H32.7998C34.788 43.6003 36.3998 45.2121 36.3998 47.2003V72.4005C36.3998 74.3887 34.788 76.0005 32.7998 76.0005H7.59976C5.61153 76.0005 3.99976 74.3887 3.99976 72.4005V47.2003ZM11.1998 50.8003V68.8005H29.1998V50.8003H11.1998ZM43.5998 47.2003C43.5998 45.2121 45.2115 43.6003 47.1998 43.6003H72.3998C74.388 43.6003 75.9998 45.2121 75.9998 47.2003V72.4005C75.9998 74.3887 74.388 76.0005 72.3998 76.0005H47.1998C45.2115 76.0005 43.5998 74.3887 43.5998 72.4005V47.2003ZM50.7998 50.8003V68.8005H68.7998V50.8003H50.7998Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LIKE]: `<path fillRule="evenodd" clipRule="evenodd" d="M45.8038 13.9521C45.6862 14.017 45.4947 14.1868 45.3523 14.4713L36.3913 32.3672L36.3891 32.3717C35.8801 33.3946 35.1806 34.3053 34.3329 35.0574V65.4079C34.3329 66.225 34.9954 66.8875 35.8126 66.8875L60.2269 66.8875C60.8672 66.8875 61.4903 66.6798 62.0025 66.2957C62.5148 65.9115 62.8886 65.3715 63.0679 64.7568L69.9627 41.0835C70.0914 40.6424 70.1159 40.1764 70.0337 39.7244C69.9515 39.2724 69.7652 38.8457 69.4896 38.4782C69.2139 38.1107 68.8565 37.8124 68.4455 37.6069C68.0346 37.4014 67.5815 37.2945 67.1221 37.2945H55.5146C50.7225 37.2945 47.1948 32.8081 48.3251 28.1512L49.9529 21.4448L49.9556 21.4335C50.1833 20.5114 50.1996 19.5498 50.0034 18.6206C49.8072 17.6913 49.4036 16.8184 48.8227 16.067C48.2417 15.3157 47.4985 14.7053 46.6485 14.2815C46.3815 14.1484 46.1062 14.0348 45.8247 13.9412C45.8247 13.9412 45.8116 13.9478 45.8038 13.9521ZM40.06 11.8213C41.2107 9.5234 44.0877 7.15998 47.5934 8.2926C48.1736 8.48004 48.7406 8.71116 49.2893 8.98474C50.9374 9.8064 52.3785 10.9899 53.5049 12.4467C54.6313 13.9036 55.414 15.5962 55.7944 17.398C56.1743 19.1975 56.1432 21.0595 55.7034 22.8452L55.7017 22.8522L54.0767 29.5472C53.8507 30.4786 54.5562 31.3759 55.5146 31.3759H67.1221C68.5004 31.3759 69.8597 31.6968 71.0924 32.3131C72.3252 32.9295 73.3975 33.8244 74.2244 34.927C75.0514 36.0296 75.6103 37.3096 75.8568 38.6656C76.1033 40.0213 76.0309 41.4157 75.6452 42.7385L68.7501 66.4129C68.2122 68.257 67.0904 69.878 65.5537 71.0306C64.0169 72.1831 62.1479 72.8061 60.2269 72.8061L35.8126 72.8061C31.7266 72.8061 28.4143 69.4938 28.4143 65.4079V34.4977C28.4143 34.1723 28.4485 33.8478 28.5164 33.5296C28.7906 32.2442 29.5583 31.314 30.2926 30.7249C30.6264 30.4571 30.8993 30.1192 31.091 29.7334L31.095 29.7254L40.06 11.8213ZM21.7555 31.3758C23.3899 31.3758 24.7148 32.7007 24.7148 34.3351V69.8467C24.7148 71.4811 23.3899 72.806 21.7555 72.806L12.8779 72.8061C10.5234 72.8061 8.26525 71.8708 6.60031 70.2058C4.93538 68.5409 4.00003 66.2828 4.00003 63.9282V40.2538C4.00003 37.8992 4.93538 35.6411 6.60031 33.9761C8.26524 32.3112 10.5234 31.3759 12.8779 31.3759H21.0456C21.1656 31.3759 21.2839 31.383 21.4002 31.3969C21.5167 31.3829 21.6353 31.3758 21.7555 31.3758ZM18.7962 37.2945H12.8779C12.0931 37.2945 11.3404 37.6063 10.7854 38.1612C10.2304 38.7162 9.91864 39.4689 9.91864 40.2538V63.9282C9.91864 64.7131 10.2304 65.4658 10.7854 66.0208C11.3404 66.5757 12.0931 66.8875 12.8779 66.8875L18.7962 66.8875V37.2945Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LIKE_ACTIVE]: `<path fillRule="evenodd" clipRule="evenodd" d="M40.06 11.8213C41.2107 9.5234 44.0877 7.15998 47.5934 8.2926C48.1736 8.48004 48.7406 8.71116 49.2893 8.98474C50.9374 9.8064 52.3785 10.9899 53.5049 12.4467C54.6313 13.9036 55.414 15.5962 55.7944 17.398C56.1743 19.1975 56.1432 21.0595 55.7034 22.8452L55.7017 22.8522L54.0767 29.5472C53.8507 30.4786 54.5562 31.3759 55.5146 31.3759H67.1221C68.5004 31.3759 69.8597 31.6968 71.0924 32.3131C72.3252 32.9295 73.3975 33.8244 74.2244 34.927C75.0514 36.0296 75.6103 37.3096 75.8568 38.6656C76.1033 40.0213 76.0309 41.4157 75.6452 42.7385L68.7501 66.4129C68.2122 68.257 67.0904 69.878 65.5537 71.0306C64.0169 72.1831 62.1479 72.8061 60.2269 72.8061L35.8126 72.8061C31.7266 72.8061 28.4143 69.4938 28.4143 65.4079V34.4977C28.4143 34.1723 28.4485 33.8478 28.5164 33.5296C28.7906 32.2442 29.5583 31.314 30.2926 30.7249C30.6264 30.4571 30.8993 30.1192 31.091 29.7334L31.095 29.7254L40.06 11.8213ZM21.7555 31.3758C23.3899 31.3758 24.7148 32.7007 24.7148 34.3351V69.8467C24.7148 71.4811 23.3899 72.806 21.7555 72.806L12.8779 72.8061C10.5234 72.8061 8.26525 71.8708 6.60031 70.2058C4.93538 68.5409 4.00003 66.2828 4.00003 63.9282V40.2538C4.00003 37.8992 4.93538 35.6411 6.60031 33.9761C8.26524 32.3112 10.5234 31.3759 12.8779 31.3759H21.0456C21.1656 31.3759 21.2839 31.383 21.4002 31.3969C21.5167 31.3829 21.6353 31.3758 21.7555 31.3758Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LINK]: `<path fillRule="evenodd" clipRule="evenodd" d="M42.5492 9.54069C46.2719 5.94525 51.2578 3.95577 56.4332 4.00075C61.6085 4.04572 66.5591 6.12154 70.2188 9.78113C73.8784 13.4407 75.9543 18.3913 75.9992 23.5665C76.0442 28.7417 74.0547 33.7276 70.4592 37.4502L70.4195 37.4914L60.5504 47.3596C60.5502 47.3597 60.5505 47.3594 60.5504 47.3596C58.5494 49.3611 56.1411 50.9093 53.4894 51.8985C50.8375 52.8877 48.0039 53.295 45.1807 53.0928C42.3576 52.8906 39.6109 52.0837 37.1271 50.7266C34.6432 49.3696 32.4803 47.4943 30.785 45.2279C29.6967 43.773 29.9939 41.7114 31.4488 40.6232C32.9037 39.5349 34.9653 39.8321 36.0536 41.287C37.1838 42.7979 38.6257 44.0482 40.2816 44.9528C41.9375 45.8575 43.7686 46.3955 45.6507 46.5303C47.5328 46.6651 49.4219 46.3935 51.1898 45.734C52.9578 45.0746 54.5632 44.0426 55.8972 42.7081L65.7455 32.86C68.1306 30.3804 69.45 27.0648 69.4201 23.6237C69.3901 20.1735 68.0062 16.8731 65.5664 14.4334C63.1266 11.9937 59.8262 10.6098 56.376 10.5798C52.9332 10.5499 49.6162 11.8704 47.1361 14.2576L41.4957 19.8652C40.2072 21.1461 38.1243 21.14 36.8433 19.8516C35.5624 18.5632 35.5684 16.4803 36.8569 15.1993L42.5492 9.54069ZM26.5106 28.0379C29.1625 27.0487 31.9961 26.6414 34.8193 26.8436C37.6424 27.0458 40.3891 27.8527 42.8729 29.2097C45.3567 30.5668 47.5197 32.4421 49.215 34.7085C50.3033 36.1634 50.0061 38.225 48.5512 39.3132C47.0963 40.4014 45.0347 40.1042 43.9464 38.6494C42.8162 37.1384 41.3743 35.8882 39.7184 34.9835C38.0625 34.0789 36.2314 33.5409 34.3493 33.4061C32.4672 33.2713 30.5781 33.5429 28.8102 34.2023C27.0423 34.8618 25.4368 35.8938 24.1028 37.2283L14.2546 47.0763C11.8694 49.556 10.55 52.8715 10.5799 56.3127C10.6099 59.7629 11.9938 63.0632 14.4336 65.503C16.8734 67.9427 20.1738 69.3266 23.624 69.3566C27.0652 69.3865 30.3808 68.0671 32.8605 65.682L38.4646 60.078C39.7494 58.7933 41.8323 58.7933 43.117 60.078C44.4017 61.3627 44.4017 63.4456 43.117 64.7303L37.4512 70.3961C33.7285 73.9915 28.7422 75.9806 23.5668 75.9356C18.3915 75.8907 13.4409 73.8148 9.78123 70.1553C6.12158 66.4957 4.04572 61.5451 4.00075 56.3699C3.95577 51.1947 5.94529 46.2088 9.54079 42.4862L9.58051 42.445L19.4496 32.5768C19.4498 32.5767 19.4495 32.5769 19.4496 32.5768C21.4505 30.5753 23.8589 29.0271 26.5106 28.0379Z" />
    `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LINKED]: `<path fillRule="evenodd" clipRule="evenodd" d="M31.3103 8.96552C18.9696 8.96552 8.96552 18.9696 8.96552 31.3103C8.96552 40.1363 14.0826 47.7671 21.5119 51.3978C21.4242 50.507 21.3793 49.6036 21.3793 48.6896C21.3793 33.6066 33.6066 21.3793 48.6896 21.3793C49.6036 21.3793 50.507 21.4242 51.3978 21.5119C47.7671 14.0826 40.1363 8.96552 31.3103 8.96552ZM57.2516 22.7483C53.6597 11.8592 43.4028 4 31.3103 4C16.2273 4 4 16.2273 4 31.3103C4 43.4028 11.8592 53.6597 22.7483 57.2516C26.3403 68.1408 36.5972 76 48.6896 76C63.7727 76 76 63.7727 76 48.6896C76 36.5972 68.1408 26.3403 57.2516 22.7483ZM53.1998 26.8002C51.7431 26.5016 50.2347 26.3448 48.6896 26.3448C36.3489 26.3448 26.3448 36.3489 26.3448 48.6896C26.3448 50.2347 26.5016 51.7431 26.8002 53.1998C28.2569 53.4984 29.7653 53.6552 31.3103 53.6552C43.651 53.6552 53.6552 43.651 53.6552 31.3103C53.6552 29.7653 53.4984 28.2569 53.1998 26.8002ZM28.6022 58.4881C29.493 58.5758 30.3964 58.6207 31.3103 58.6207C46.3934 58.6207 58.6207 46.3934 58.6207 31.3103C58.6207 30.3964 58.5758 29.493 58.4881 28.6022C65.9174 32.2329 71.0345 39.8637 71.0345 48.6896C71.0345 61.0304 61.0304 71.0345 48.6896 71.0345C39.8637 71.0345 32.2329 65.9174 28.6022 58.4881Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LIST]: `<path fillRule="evenodd" clipRule="evenodd" d="M4 7.6C4 5.61177 5.61177 4 7.6 4H32.8C34.7882 4 36.4 5.61177 36.4 7.6V32.8C36.4 34.7882 34.7882 36.4 32.8 36.4H7.6C5.61177 36.4 4 34.7882 4 32.8V7.6ZM11.2 11.2V29.2H29.2V11.2H11.2ZM43.6 11.2C43.6 9.21177 45.2118 7.6 47.2 7.6H72.4C74.3882 7.6 76 9.21177 76 11.2C76 13.1882 74.3882 14.8 72.4 14.8H47.2C45.2118 14.8 43.6 13.1882 43.6 11.2ZM43.6 29.2C43.6 27.2118 45.2118 25.6 47.2 25.6H72.4C74.3882 25.6 76 27.2118 76 29.2C76 31.1882 74.3882 32.8 72.4 32.8H47.2C45.2118 32.8 43.6 31.1882 43.6 29.2ZM4 47.2C4 45.2118 5.61177 43.6 7.6 43.6H32.8C34.7882 43.6 36.4 45.2118 36.4 47.2V72.4C36.4 74.3882 34.7882 76 32.8 76H7.6C5.61177 76 4 74.3882 4 72.4V47.2ZM11.2 50.8V68.8H29.2V50.8H11.2ZM43.6 50.8C43.6 48.8118 45.2118 47.2 47.2 47.2H72.4C74.3882 47.2 76 48.8118 76 50.8C76 52.7882 74.3882 54.4 72.4 54.4H47.2C45.2118 54.4 43.6 52.7882 43.6 50.8ZM43.6 68.8C43.6 66.8118 45.2118 65.2 47.2 65.2H72.4C74.3882 65.2 76 66.8118 76 68.8C76 70.7882 74.3882 72.4 72.4 72.4H47.2C45.2118 72.4 43.6 70.7882 43.6 68.8Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LIST_ITEM]: `
        <path fillRule="evenodd" clipRule="evenodd" d="M13.8602 6.86016C15.6915 5.02883 18.1753 4 20.7652 4H48.6395C49.4899 4 50.3055 4.33783 50.9068 4.93916L68.9432 22.9756C69.5445 23.5769 69.8823 24.3925 69.8823 25.2429V66.2348C69.8823 68.8247 68.8535 71.3085 67.0222 73.1398C65.1909 74.9712 62.7071 76 60.1172 76H20.7652C18.1753 76 15.6915 74.9712 13.8602 73.1398C12.0288 71.3085 11 68.8247 11 66.2348V13.7652C11 11.1753 12.0288 8.69149 13.8602 6.86016ZM20.7652 10.4129C19.8761 10.4129 19.0235 10.7661 18.3948 11.3948C17.7662 12.0234 17.413 12.8761 17.413 13.7652V66.2348C17.413 67.1239 17.7662 67.9766 18.3948 68.6052C19.0235 69.2339 19.8761 69.5871 20.7652 69.5871H60.1172C61.0062 69.5871 61.8589 69.2339 62.4875 68.6052C63.1162 67.9766 63.4694 67.1239 63.4694 66.2348V26.5711L47.3113 10.4129H20.7652Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M46.9995 4C48.7704 4 50.206 5.43558 50.206 7.20647V23.6761H66.6755C68.4464 23.6761 69.882 25.1117 69.882 26.8826C69.882 28.6535 68.4464 30.0891 66.6755 30.0891H46.9995C45.2286 30.0891 43.7931 28.6535 43.7931 26.8826V7.20647C43.7931 5.43558 45.2286 4 46.9995 4Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LOCK]: `<path fillRule="evenodd" clipRule="evenodd" d="M24.9043 10.1024C29.0907 6.16303 34.7053 4 40.5 4C46.2947 4 51.9093 6.16303 56.0957 10.1024C60.2929 14.0519 62.7203 19.484 62.7203 25.2273V34.1473C66.2655 35.4437 69 38.7282 69 42.9545V66.5909C69 72.0938 64.3641 76 59.339 76H21.661C16.6359 76 12 72.0938 12 66.5909V42.9545C12 38.7282 14.7345 35.4437 18.2797 34.1473V25.2273C18.2797 19.484 20.7071 14.0519 24.9043 10.1024ZM25.0424 33.5455H55.9576V25.2273C55.9576 21.5674 54.4155 17.9815 51.5466 15.282C48.6671 12.5724 44.6981 11 40.5 11C36.3019 11 32.3329 12.5724 29.4534 15.282C26.5845 17.9815 25.0424 21.5674 25.0424 25.2273V33.5455ZM21.661 40.5455C19.7498 40.5455 18.7627 41.9305 18.7627 42.9545V66.5909C18.7627 67.615 19.7498 69 21.661 69H59.339C61.2502 69 62.2373 67.615 62.2373 66.5909V42.9545C62.2373 41.9305 61.2502 40.5455 59.339 40.5455H21.661Z"/>
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LOCKER]: `<path d="M72.8157 4H6.92448C5.31659 4 4.00006 5.31655 4.00006 6.93525V73.0755C4.00006 74.6835 5.31659 76 6.92448 76H72.8157C74.4344 76 75.7509 74.6835 75.7509 73.0755V6.93525C75.7509 5.31655 74.4344 4 72.8157 4ZM38.5104 69.9365H10.2578C10.1499 69.9365 10.0635 69.8501 10.0635 69.7422V61.6918H38.5104V69.9365ZM38.5104 55.6283H10.0635V10.2686C10.0635 10.1607 10.1499 10.0635 10.2578 10.0635H38.5104V55.6283ZM69.6767 69.7422C69.6767 69.8501 69.5903 69.9365 69.4824 69.9365H44.5739V61.6918H69.6767V69.7422ZM69.6767 55.6283H44.5739V10.0635H69.4824C69.5903 10.0635 69.6767 10.1607 69.6767 10.2686V55.6283Z" />
        <path d="M17.4028 18.6642H28.5609C29.3163 18.6642 29.9314 18.0491 29.9314 17.2937C29.9314 16.5383 29.3163 15.9232 28.5609 15.9232H17.4028C16.6474 15.9232 16.0323 16.5383 16.0323 17.2937C16.0323 18.0491 16.6474 18.6642 17.4028 18.6642Z"/>
        <path d="M17.4028 25.9269H28.5609C29.3163 25.9269 29.9314 25.3118 29.9314 24.5564C29.9314 23.801 29.3163 23.1967 28.5609 23.1967H17.4028C16.6474 23.1967 16.0323 23.801 16.0323 24.5564C16.0323 25.3118 16.6474 25.9269 17.4028 25.9269Z" />
        <path d="M17.4028 33.2003H28.5609C29.3163 33.2003 29.9314 32.5852 29.9314 31.8298C29.9314 31.0744 29.3163 30.4593 28.5609 30.4593H17.4028C16.6474 30.4593 16.0323 31.0744 16.0323 31.8298C16.0323 32.5852 16.6474 33.2003 17.4028 33.2003Z" />
        <path d="M16.3224 47.295C17.0778 47.295 17.6929 46.6799 17.6929 45.9245V38.9641C17.6929 38.2087 17.0778 37.5936 16.3224 37.5936C15.567 37.5936 14.9627 38.2087 14.9627 38.9641V45.9245C14.9627 46.6799 15.567 47.295 16.3224 47.295Z" />
        <path d="M50.6062 37.7769C49.8508 37.7769 49.2357 38.3812 49.2357 39.1366V46.097C49.2357 46.8524 49.8508 47.4675 50.6062 47.4675C51.3616 47.4675 51.9659 46.8524 51.9659 46.097V39.1366C51.9659 38.3812 51.3616 37.7769 50.6062 37.7769Z" />
        <path d="M62.8447 15.9232H51.6865C50.9311 15.9232 50.316 16.5383 50.316 17.2937C50.316 18.0491 50.9311 18.6642 51.6865 18.6642H62.8447C63.6 18.6642 64.2151 18.0491 64.2151 17.2937C64.2151 16.5383 63.6 15.9232 62.8447 15.9232Z" />
        <path d="M62.8447 23.1967H51.6865C50.9311 23.1967 50.316 23.801 50.316 24.5564C50.316 25.3118 50.9311 25.9269 51.6865 25.9269H62.8447C63.6 25.9269 64.2151 25.3118 64.2151 24.5564C64.2151 23.801 63.6 23.1967 62.8447 23.1967Z" />
        <path d="M62.8447 30.4593H51.6865C50.9311 30.4593 50.316 31.0744 50.316 31.8298C50.316 32.5852 50.9311 33.2003 51.6865 33.2003H62.8447C63.6 33.2003 64.2151 32.5852 64.2151 31.8298C64.2151 31.0744 63.6 30.4593 62.8447 30.4593Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).LOGOUT]: `<path fillRule="evenodd" clipRule="evenodd" d="M14.7999 11.2C13.8451 11.2 12.9295 11.5793 12.2544 12.2544C11.5792 12.9295 11.1999 13.8452 11.1999 14.8V65.2C11.1999 66.1548 11.5792 67.0705 12.2544 67.7456C12.9295 68.4207 13.8452 68.8 14.7999 68.8H29.1998C31.188 68.8 32.7998 70.4118 32.7998 72.4C32.7998 74.3882 31.188 76 29.1998 76H14.7999C11.9356 76 9.1886 74.8621 7.16322 72.8367C5.13785 70.8114 4 68.0643 4 65.2V14.8C4 11.9357 5.13784 9.18864 7.16322 7.16325C9.1886 5.13785 11.9356 4 14.7999 4H29.1998C31.188 4 32.7998 5.61177 32.7998 7.6C32.7998 9.58823 31.188 11.2 29.1998 11.2H14.7999ZM51.8541 19.4544C53.2599 18.0485 55.5393 18.0485 56.9452 19.4544L74.9451 37.4544C75.6202 38.1295 75.9995 39.0452 75.9995 40C75.9995 40.9548 75.6202 41.8705 74.9451 42.5456L56.9452 60.5456C55.5393 61.9515 53.2599 61.9515 51.8541 60.5456C50.4482 59.1397 50.4482 56.8603 51.8541 55.4544L63.7084 43.6H29.1998C27.2116 43.6 25.5998 41.9882 25.5998 40C25.5998 38.0118 27.2116 36.4 29.1998 36.4H63.7084L51.8541 24.5456C50.4482 23.1397 50.4482 20.8603 51.8541 19.4544Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).MAIL]: `<path fillRule="evenodd" clipRule="evenodd" d="M13.8184 17.5454C12.0259 17.5454 10.5457 19.0256 10.5457 20.8181V60.0905C10.5457 61.883 12.0259 63.3632 13.8184 63.3632H66.1816C67.9741 63.3632 69.4543 61.883 69.4543 60.0905V20.8181C69.4543 19.0256 67.9741 17.5454 66.1816 17.5454H13.8184ZM4.00027 20.8181C4.00027 15.4107 8.41094 11 13.8184 11H66.1816C71.589 11 75.9997 15.4107 75.9997 20.8181V60.0905C75.9997 65.498 71.589 69.9086 66.1816 69.9086H13.8184C8.41093 69.9086 4.00027 65.498 4.00027 60.0905V20.8181Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M4.59187 18.9413C5.62838 17.4606 7.66901 17.1005 9.14974 18.137L40 39.7322L70.8502 18.137C72.331 17.1005 74.3716 17.4606 75.4081 18.9413C76.4446 20.4221 76.0845 22.4627 74.6038 23.4992L41.8768 46.4081C40.7499 47.1969 39.2501 47.1969 38.1232 46.4081L5.3962 23.4992C3.91546 22.4627 3.55535 20.4221 4.59187 18.9413Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).MAP_PIN]: `<path fillRule="evenodd" clipRule="evenodd" d="M40 9.99999C26.7451 9.99999 15.9999 20.7451 15.9999 34C15.9999 43.2941 22.0472 52.3127 28.6779 59.3117C31.9318 62.7465 35.196 65.5584 37.6501 67.5125C38.5633 68.2398 39.3611 68.8455 40 69.3177C40.6389 68.8455 41.4367 68.2398 42.35 67.5125C44.804 65.5584 48.0682 62.7465 51.3222 59.3117C57.9529 52.3127 64.0001 43.2941 64.0001 34C64.0001 20.7451 53.2549 9.99999 40 9.99999ZM40 73C38.3359 75.4961 38.3351 75.4956 38.3343 75.495L38.3321 75.4935L38.3257 75.4893L38.3057 75.4759L38.237 75.4294C38.1786 75.3897 38.0952 75.3327 37.9886 75.259C37.7756 75.1114 37.4694 74.8964 37.0834 74.6175C36.3116 74.0602 35.2191 73.2466 33.9125 72.2062C31.304 70.129 27.8181 67.1285 24.3221 63.4382C17.4527 56.1872 9.99992 45.7058 9.99992 34C9.99992 17.4315 23.4314 4 40 4C56.5686 4 70.0001 17.4315 70.0001 34C70.0001 45.7058 62.5473 56.1872 55.6779 63.4382C52.1819 67.1285 48.696 70.129 46.0876 72.2062C44.7809 73.2466 43.6884 74.0602 42.9167 74.6175C42.5307 74.8964 42.2244 75.1114 42.0113 75.259C41.9048 75.3327 41.8215 75.3897 41.7631 75.4294L41.6943 75.4759L41.6743 75.4893L41.668 75.4935L41.6657 75.495C41.6649 75.4956 41.6641 75.4961 40 73ZM40 73L41.6641 75.4961C40.6564 76.168 39.3436 76.168 38.3359 75.4961L40 73ZM28 33.9999C28 27.3725 33.3726 21.9999 40.0001 21.9999C46.6275 21.9999 52.0001 27.3725 52.0001 33.9999C52.0001 40.6273 46.6275 45.9999 40.0001 45.9999C33.3726 45.9999 28 40.6273 28 33.9999ZM40.0001 27.9999C36.6863 27.9999 34.0001 30.6861 34.0001 33.9999C34.0001 37.3136 36.6863 39.9999 40.0001 39.9999C43.3137 39.9999 46.0001 37.3136 46.0001 33.9999C46.0001 30.6861 43.3137 27.9999 40.0001 27.9999Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).MAXIMISE]: `<path fillRule="evenodd" clipRule="evenodd" d="M47.2 7.6C47.2 5.61177 48.8117 4 50.8 4H72.3998C74.3881 4 75.9998 5.61177 75.9998 7.6V29.2C75.9998 31.1882 74.3881 32.8 72.3998 32.8C70.4116 32.8 68.7999 31.1882 68.7999 29.2V11.2H50.8C48.8117 11.2 47.2 9.58822 47.2 7.6Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M7.60015 47.2C9.58837 47.2 11.2001 48.8118 11.2001 50.8V68.8H29.2C31.1883 68.8 32.8 70.4118 32.8 72.4C32.8 74.3882 31.1883 76 29.2 76H7.60015C5.61194 76 4.00017 74.3882 4.00017 72.4V50.8C4.00017 48.8118 5.61194 47.2 7.60015 47.2Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M74.9454 5.05442C76.3513 6.4603 76.3513 8.7397 74.9454 10.1456L49.7455 35.3456C48.3397 36.7515 46.0603 36.7515 44.6544 35.3456C43.2485 33.9397 43.2485 31.6603 44.6544 30.2544L69.8543 5.05442C71.2602 3.64853 73.5395 3.64853 74.9454 5.05442Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M35.3456 44.6544C36.7515 46.0603 36.7515 48.3397 35.3456 49.7456L10.1457 74.9456C8.73984 76.3515 6.46046 76.3515 5.05458 74.9456C3.6487 73.5397 3.6487 71.2603 5.05458 69.8544L30.2545 44.6544C31.6603 43.2485 33.9397 43.2485 35.3456 44.6544Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).MENTIONS]: `<path fillRule="evenodd" clipRule="evenodd" d="M24.6185 7.45149C31.9646 3.97992 40.269 3.0955 48.1815 4.94204C56.094 6.78858 63.1491 11.2575 68.1998 17.6221C73.2504 23.9867 75.9995 31.8727 76 39.9977V43.2707C76 46.7426 74.6208 50.0723 72.1658 52.5273C69.7107 54.9824 66.381 56.3616 62.9091 56.3616C59.4372 56.3616 56.1075 54.9824 53.6524 52.5273C53.1328 52.0077 52.6613 51.4488 52.2409 50.8577C49.2433 54.2341 44.8701 56.3616 40 56.3616C30.9626 56.3616 23.6364 49.0353 23.6364 39.998C23.6364 30.9606 30.9626 23.6343 40 23.6343C43.6838 23.6343 47.0833 24.8516 49.8182 26.9059C49.8188 25.0989 51.2838 23.6343 53.0909 23.6343C54.8984 23.6343 56.3636 25.0996 56.3636 26.9071V43.2707C56.3636 45.0066 57.0533 46.6715 58.2808 47.899C59.5083 49.1265 61.1731 49.8161 62.9091 49.8161C64.6451 49.8161 66.3099 49.1265 67.5374 47.899C68.7649 46.6715 69.4546 45.0066 69.4546 43.2707V39.9982C69.4546 39.9981 69.4546 39.9982 69.4546 39.9982C69.4541 33.3504 67.2048 26.8981 63.0726 21.6908C58.9402 16.4834 53.1678 12.827 46.694 11.3162C40.2201 9.80541 33.4256 10.529 27.4151 13.3694C21.4047 16.2098 16.5318 20.9999 13.5889 26.9608C10.646 32.9217 9.80608 39.7028 11.2058 46.2016C12.6054 52.7004 16.1624 58.5346 21.2982 62.7555C26.4341 66.9765 32.8468 69.3359 39.4936 69.4502C46.1404 69.5645 52.6304 67.4269 57.9084 63.3851C59.3434 62.2861 61.3976 62.5586 62.4965 63.9936C63.5955 65.4286 63.323 67.4828 61.888 68.5817C55.4372 73.5218 47.505 76.1344 39.3811 75.9947C31.2572 75.855 23.4194 72.9712 17.1423 67.8123C10.8651 62.6534 6.51776 55.5227 4.80704 47.5798C3.09631 39.6368 4.12286 31.3487 7.71976 24.0632C11.3167 16.7776 17.2724 10.9231 24.6185 7.45149ZM49.8182 39.998C49.8182 34.5755 45.4224 30.1798 40 30.1798C34.5776 30.1798 30.1818 34.5755 30.1818 39.998C30.1818 45.4204 34.5776 49.8161 40 49.8161C45.4224 49.8161 49.8182 45.4204 49.8182 39.998Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).MENU]: `<path fillRule="evenodd" clipRule="evenodd" d="M4 16C4 13.7909 5.79086 12 8 12H72C74.2091 12 76 13.7909 76 16C76 18.2091 74.2091 20 72 20H8C5.79086 20 4 18.2091 4 16ZM4 40C4 37.7908 5.79086 36 8 36H72C74.2091 36 76 37.7908 76 40C76 42.2091 74.2091 44 72 44H8C5.79086 44 4 42.2091 4 40ZM4 64C4 61.7908 5.79086 60 8 60H72C74.2091 60 76 61.7908 76 64C76 66.2091 74.2091 67.9999 72 67.9999H8C5.79086 67.9999 4 66.2091 4 64Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).MENU_MORE]: `<path fillRule="evenodd" clipRule="evenodd" d="M32.0002 12C32.0002 7.58172 35.5819 4 40.0002 4C44.4186 4 48.0003 7.58172 48.0003 12C48.0003 16.4183 44.4186 20 40.0002 20C35.5819 20 32.0002 16.4183 32.0002 12ZM32.0002 40C32.0002 35.5817 35.5819 32 40.0002 32C44.4186 32 48.0003 35.5817 48.0003 40C48.0003 44.4183 44.4186 48 40.0002 48C35.5819 48 32.0002 44.4183 32.0002 40ZM32.0002 68C32.0002 63.5817 35.5819 60 40.0002 60C44.4186 60 48.0003 63.5817 48.0003 68C48.0003 72.4183 44.4186 76 40.0002 76C35.5819 76 32.0002 72.4183 32.0002 68Z"/>
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).MIDDOT]: `<path fillRule="evenodd" clipRule="evenodd" d="M22 40C22 30.0589 30.0589 22 40 22C49.9411 22 58 30.0589 58 40C58 49.9411 49.9411 58 40 58C30.0589 58 22 49.9411 22 40Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).MINIMISE]: `<path fillRule="evenodd" clipRule="evenodd" d="M69.8541 5.05442C71.2599 3.64853 73.5393 3.64853 74.9452 5.05442C76.3511 6.4603 76.3511 8.7397 74.9452 10.1456L55.8909 29.2H68.7997C70.7879 29.2 72.3996 30.8118 72.3996 32.8C72.3996 34.7882 70.7879 36.4 68.7997 36.4H47.1997C45.2115 36.4 43.5997 34.7882 43.5997 32.8V11.2C43.5997 9.21177 45.2115 7.6 47.1997 7.6C49.188 7.6 50.7997 9.21177 50.7997 11.2V24.1088L69.8541 5.05442ZM7.59988 47.2C7.59988 45.2118 9.21165 43.6 11.1999 43.6H32.7998C34.788 43.6 36.3998 45.2118 36.3998 47.2V68.8C36.3998 70.7882 34.788 72.4 32.7998 72.4C30.8116 72.4 29.1998 70.7882 29.1998 68.8V55.8912L10.1455 74.9456C8.73957 76.3515 6.46019 76.3515 5.0543 74.9456C3.64842 73.5397 3.64842 71.2603 5.0543 69.8544L24.1087 50.8H11.1999C9.21165 50.8 7.59988 49.1882 7.59988 47.2Z"/>
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ORDER_BOTTOM]: `<path fillRule="evenodd" clipRule="evenodd" d="M39.8 4C41.7882 4 43.4 5.61179 43.4 7.6V49.3088L58.8544 33.8544C60.2603 32.4485 62.5397 32.4485 63.9456 33.8544C65.3515 35.2603 65.3515 37.5397 63.9456 38.9456L42.3456 60.5456C40.9397 61.9515 38.6603 61.9515 37.2544 60.5456L15.6544 38.9456C14.2485 37.5397 14.2485 35.2603 15.6544 33.8544C17.0603 32.4485 19.3397 32.4485 20.7456 33.8544L36.2 49.3088V7.6C36.2 5.61179 37.8118 4 39.8 4ZM11 72.4C11 70.4121 12.6118 68.8 14.6 68.8H65C66.9882 68.8 68.6 70.4121 68.6 72.4C68.6 74.3879 66.9882 76 65 76H14.6C12.6118 76 11 74.3879 11 72.4Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).OLD_PHONE]: `<path d="M26.9091 13.8182C26.9091 12.9502 26.564 12.118 25.9503 11.5043C25.3365 10.8905 24.5043 10.5455 23.6364 10.5455H13.8182C12.9502 10.5455 12.118 10.8905 11.5043 11.5043C10.8905 12.118 10.5455 12.9502 10.5455 13.8182C10.5455 28.5739 16.4071 42.7252 26.8409 53.1591C37.2748 63.5929 51.4261 69.4545 66.1818 69.4545C67.0498 69.4545 67.882 69.1095 68.4957 68.4957C69.1095 67.882 69.4545 67.0498 69.4545 66.1818V56.3636C69.4545 55.4957 69.1095 54.6635 68.4957 54.0497C67.882 53.436 67.0498 53.0909 66.1818 53.0909H56.3636C55.8556 53.0909 55.3543 53.2089 54.8999 53.4361C54.4454 53.6633 54.0499 53.9938 53.745 54.4002C53.7395 54.4075 53.7346 54.4153 53.729 54.4226L52.5668 55.9439C51.6658 57.1257 50.3896 57.9658 48.9478 58.326C47.5047 58.6865 45.9817 58.5451 44.63 57.9244C44.6045 57.9126 44.5785 57.9005 44.5533 57.8881C34.8138 53.1081 26.9328 45.2356 22.1406 35.5021L22.1342 35.4904C21.4719 34.1315 21.3001 32.585 21.6484 31.114C21.9968 29.643 22.844 28.3379 24.0455 27.4205L24.0689 27.4034L25.5998 26.255C26.0062 25.9501 26.3367 25.5546 26.5639 25.1001C26.7911 24.6457 26.9091 24.1444 26.9091 23.6364V13.8182ZM33.4545 23.6364C33.4545 25.1606 33.0996 26.6644 32.418 28.0277C31.7364 29.3908 30.7469 30.5767 29.5277 31.4911L28.0181 32.6214C32.1593 41.0269 38.9593 47.8288 47.3615 51.9734L47.3636 51.9723L48.5259 50.4499C49.438 49.2411 50.6176 48.2595 51.9723 47.582C53.3356 46.9004 54.8394 46.5455 56.3636 46.5455H66.1818C68.7858 46.5455 71.2834 47.5795 73.1246 49.4208C74.9659 51.2621 76 53.7597 76 56.3636V66.1818C76 68.7858 74.9659 71.2834 73.1246 73.1246C71.2834 74.9659 68.7858 76 66.1818 76C49.6902 76 33.8744 69.4483 22.2131 57.7869C10.5517 46.1256 4 30.3098 4 13.8182C4 11.2142 5.03409 8.71662 6.87536 6.87536C8.71662 5.03409 11.2142 4 13.8182 4H23.6364C26.2403 4 28.7379 5.03409 30.5792 6.87536C32.4205 8.71662 33.4545 11.2142 33.4545 13.8182V23.6364Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ORDER_DOWN]: `<path fillRule="evenodd" clipRule="evenodd" d="M40.0001 4C42.4853 4 44.5001 6.01474 44.5001 8.50001V60.6361L68.3182 36.8181C70.0755 35.0607 72.9247 35.0607 74.6821 36.8181C76.4393 38.5754 76.4393 41.4247 74.6821 43.182L43.182 74.682C41.4247 76.4393 38.5755 76.4393 36.8181 74.682L5.31807 43.182C3.56064 41.4247 3.56064 38.5754 5.31807 36.8181C7.07542 35.0607 9.92464 35.0607 11.682 36.8181L35.5001 60.6361V8.50001C35.5001 6.01474 37.5148 4 40.0001 4Z" />
    `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ORDER_TOP]: `<path fillRule="evenodd" clipRule="evenodd" d="M11 7.6C11 5.61179 12.6118 4 14.6 4H65C66.9882 4 68.6 5.61179 68.6 7.6C68.6 9.58821 66.9882 11.2 65 11.2H14.6C12.6118 11.2 11 9.58821 11 7.6ZM37.2544 19.4544C38.6603 18.0485 40.9397 18.0485 42.3456 19.4544L63.9456 41.0544C65.3515 42.4603 65.3515 44.7397 63.9456 46.1456C62.5397 47.5515 60.2603 47.5515 58.8544 46.1456L43.4 30.6912V72.4C43.4 74.3879 41.7882 76 39.8 76C37.8118 76 36.2 74.3879 36.2 72.4V30.6912L20.7456 46.1456C19.3397 47.5515 17.0603 47.5515 15.6544 46.1456C14.2485 44.7397 14.2485 42.4603 15.6544 41.0544L37.2544 19.4544Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).ORDER_UP]: `<path fillRule="evenodd" clipRule="evenodd" d="M36.8181 5.31807C38.5754 3.56064 41.4246 3.56064 43.182 5.31807L74.6819 36.8181C76.4392 38.5754 76.4392 41.4246 74.6819 43.182C72.9246 44.9394 70.0754 44.9394 68.3181 43.182L44.5 19.364V71.5C44.5 73.9853 42.4853 76 40 76C37.5148 76 35.5 73.9853 35.5 71.5V19.364L11.682 43.182C9.92463 44.9394 7.07541 44.9394 5.31807 43.182C3.56064 41.4246 3.56064 38.5754 5.31807 36.8181L36.8181 5.31807Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).PASSKEY]: `<path d="M6 72.4V65.2C6 60.4261 7.89778 55.8491 11.2734 52.4734C14.6491 49.0978 19.2261 47.2 24 47.2H35.8793L36.2484 47.2176C38.0636 47.4021 39.4793 48.9361 39.4793 50.8C39.4793 52.6639 38.0636 54.1979 36.2484 54.3824L35.8793 54.4H24C21.1357 54.4 18.3895 55.5387 16.3641 57.5641C14.3387 59.5895 13.2 62.3357 13.2 65.2V72.4C13.2 74.3882 11.5882 76 9.6 76C7.61177 76 6 74.3882 6 72.4ZM52.8 65.2C52.8 63.2118 51.1882 61.6 49.2 61.6C47.2118 61.6 45.6 63.2118 45.6 65.2C45.6 67.1882 47.2118 68.8 49.2 68.8C51.1882 68.8 52.8 67.1882 52.8 65.2ZM45.6 22C45.6 16.0353 40.7647 11.2 34.8 11.2C28.8353 11.2 24 16.0353 24 22C24 27.9647 28.8353 32.8 34.8 32.8C40.7647 32.8 45.6 27.9647 45.6 22ZM60 65.2C60 71.1647 55.1647 76 49.2 76C43.2353 76 38.4 71.1647 38.4 65.2C38.4 59.2353 43.2353 54.4 49.2 54.4C50.8648 54.4 52.4359 54.7889 53.8441 55.4617L68.2547 41.0547C69.6606 39.6488 71.9394 39.6488 73.3453 41.0547C74.7512 42.4606 74.7512 44.7394 73.3453 46.1453L70.4906 49L73.3453 51.8547L73.5914 52.1289C74.7447 53.5429 74.6633 55.6273 73.3453 56.9453C72.0273 58.2633 69.9429 58.3447 68.5289 57.1914L68.2547 56.9453L65.4 54.0906L58.9348 60.5523C59.6088 61.9617 60 63.5335 60 65.2ZM52.8 22C52.8 31.9411 44.7411 40 34.8 40C24.8589 40 16.8 31.9411 16.8 22C16.8 12.0589 24.8589 4 34.8 4C44.7411 4 52.8 12.0589 52.8 22Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).PARAGRAPH]: `<path d="M57.9958 61.4018C59.9829 61.4018 61.5968 63.0092 61.5983 64.9959C61.5983 66.984 59.9839 68.5985 57.9958 68.5985H7.60253C5.61446 68.5985 4 66.984 4 64.9959C4.00152 63.0092 5.6154 61.4018 7.60253 61.4018H57.9958ZM50.7992 36.201C52.7872 36.201 54.4017 37.8155 54.4017 39.8035C54.4002 41.7903 52.7863 43.3976 50.7992 43.3976H7.60253C5.6154 43.3976 4.00152 41.7903 4 39.8035C4 37.8155 5.61446 36.201 7.60253 36.201H50.7992ZM72.3975 11.0002C74.3855 11.0002 76 12.6146 76 14.6027C76 16.5908 74.3855 18.2052 72.3975 18.2052H7.60253C5.61446 18.2052 4 16.5908 4 14.6027C4 12.6146 5.61446 11.0002 7.60253 11.0002H72.3975Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).PAUSE]: `<path fillRule="evenodd" clipRule="evenodd" d="M12 16C12 9.37258 17.3726 4 24 4C30.6274 4 36 9.37258 36 16V64C36 70.6274 30.6274 76 24 76C17.3726 76 12 70.6274 12 64V16Z"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M44 16C44 9.37258 49.3726 4 56 4C62.6274 4 68 9.37258 68 16V64C68 70.6274 62.6274 76 56 76C49.3726 76 44 70.6274 44 64V16Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).PENCIL]: `<path fillRule="evenodd" clipRule="evenodd" d="M57.3225 4.95856C58.6006 3.68048 60.6727 3.68048 61.9508 4.95856L75.0417 18.0495C76.3198 19.3275 76.3198 21.3997 75.0417 22.6778C73.7636 23.9559 71.6915 23.9559 70.4134 22.6778L57.3225 9.58689C56.0444 8.30881 56.0444 6.23664 57.3225 4.95856Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M47.5043 14.7767C48.7824 13.4987 50.8545 13.4987 52.1326 14.7767L65.2235 27.8676C66.5016 29.1457 66.5016 31.2179 65.2235 32.496L27.5872 70.1323C27.1845 70.535 26.6836 70.8257 26.1341 70.9755L8.13413 75.8846C7.00107 76.1936 5.7893 75.8718 4.95885 75.0414C4.12839 74.2109 3.80659 72.9992 4.11561 71.8661L9.0247 53.8661C9.17455 53.3166 9.46521 52.8158 9.86794 52.4131L47.5043 14.7767Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).PERSON]: `<path fillRule="evenodd" clipRule="evenodd" d="M39.8 11.2C33.8353 11.2 29 16.0353 29 22C29 27.9647 33.8353 32.8 39.8 32.8C45.7647 32.8 50.6001 27.9647 50.6001 22C50.6001 16.0353 45.7647 11.2 39.8 11.2ZM21.8 22C21.8 12.0589 29.8589 4 39.8 4C49.7412 4 57.8001 12.0589 57.8001 22C57.8001 31.9411 49.7412 40 39.8 40C29.8589 40 21.8 31.9411 21.8 22ZM16.272 52.4721C19.6477 49.0964 24.2261 47.2 29 47.2H50.6001C55.374 47.2 59.9524 49.0964 63.3281 52.4721C66.7037 55.8477 68.6001 60.4261 68.6001 65.2V72.4C68.6001 74.3882 66.9884 76 65.0001 76C63.0119 76 61.4001 74.3882 61.4001 72.4V65.2C61.4001 62.3357 60.2623 59.5886 58.2369 57.5633C56.2115 55.5379 53.4644 54.4 50.6001 54.4H29C26.1357 54.4 23.3886 55.5379 21.3632 57.5633C19.3378 59.5886 18.2 62.3357 18.2 65.2V72.4C18.2 74.3882 16.5882 76 14.6 76C12.6117 76 10.9999 74.3882 10.9999 72.4V65.2C10.9999 60.4261 12.8964 55.8477 16.272 52.4721Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).PHONE]: `<path fillRule="evenodd" clipRule="evenodd" d="M23.8182 10.5455C22.0107 10.5455 20.5455 12.0107 20.5455 13.8182V66.1818C20.5455 67.9893 22.0107 69.4545 23.8182 69.4545H56.5456C58.3531 69.4545 59.8183 67.9893 59.8183 66.1818V13.8182C59.8183 12.0107 58.3531 10.5455 56.5456 10.5455H23.8182ZM14 13.8182C14 8.39575 18.3957 4 23.8182 4H56.5456C61.968 4 66.3638 8.39575 66.3638 13.8182V66.1818C66.3638 71.6042 61.968 76 56.5456 76H23.8182C18.3957 76 14 71.6042 14 66.1818V13.8182ZM36.9091 59.6364C36.9091 57.8289 38.3744 56.3636 40.1819 56.3636H40.2146C42.0221 56.3636 43.4874 57.8289 43.4874 59.6364C43.4874 61.4438 42.0221 62.9091 40.2146 62.9091H40.1819C38.3744 62.9091 36.9091 61.4438 36.9091 59.6364Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).PLAY]: `<path fillRule="evenodd" clipRule="evenodd" d="M10 11.8632C10 5.65225 16.871 1.90105 22.0955 5.25964L65.8643 33.3965C70.6713 36.4866 70.6713 43.5133 65.8643 46.6035L22.0955 74.7404C16.871 78.099 10 74.3477 10 68.1368V11.8632Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).RECOVERY]: `<path fillRule="evenodd" clipRule="evenodd" d="M53.8001 15.5037C48.6443 12.3506 42.63 11.0907 36.7177 11.9106C30.8043 12.7307 25.3071 15.5882 21.1168 20.0522C16.9245 24.5182 14.2864 30.3323 13.6496 36.5671C13.4625 38.3985 11.8262 39.7315 9.99478 39.5444C8.16336 39.3574 6.83035 37.7211 7.01742 35.8896C7.80011 28.2269 11.0453 21.0406 16.2561 15.4895C21.4689 9.93629 28.3493 6.34065 35.8019 5.30713C43.2555 4.27346 50.8205 5.86693 57.2783 9.81634C63.7336 13.7642 68.6983 19.8295 71.4012 27.0191C74.1036 34.2073 74.3967 42.122 72.2361 49.5005C70.0752 56.88 65.5778 63.3174 59.4394 67.7637C53.2985 72.2117 45.8772 74.403 38.3679 73.9656C30.8591 73.5283 23.7276 70.4898 18.1136 65.3633L18.0878 65.3395L13.6668 61.216V68.3334C13.6668 70.1743 12.1744 71.6667 10.3335 71.6667C8.49255 71.6667 7.00017 70.1743 7.00017 68.3334V53.5488C7.00017 51.7079 8.49255 50.2155 10.3335 50.2155H24.3892C26.2302 50.2155 27.7225 51.7079 27.7225 53.5488C27.7225 55.3898 26.2302 56.8821 24.3892 56.8821H18.7944L22.6218 60.452C27.1235 64.5575 32.8062 66.9637 38.7556 67.3102C44.7102 67.6571 50.6166 65.9225 55.5287 62.3646C60.4432 58.8048 64.0831 53.6203 65.8381 47.6269C67.5935 41.6325 67.3541 35.1986 65.161 29.3651C62.9684 23.533 58.9585 18.6584 53.8001 15.5037Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M34.7542 29.2884C36.2966 27.8111 38.3651 27 40.5 27C42.6349 27 44.7034 27.8111 46.2458 29.2884C47.7921 30.7695 48.6864 32.8065 48.6864 34.9602V38.3052C49.9926 38.7914 51 40.0231 51 41.608V50.4716C51 52.5352 49.292 54 47.4407 54H33.5593C31.708 54 30 52.5352 30 50.4716V41.608C30 40.0231 31.0074 38.7914 32.3136 38.3052V34.9602C32.3136 32.8065 33.2079 30.7695 34.7542 29.2884ZM34.8051 38.0795H46.1949V34.9602C46.1949 33.5878 45.6268 32.2431 44.5698 31.2307C43.5089 30.2146 42.0467 29.625 40.5 29.625C38.9533 29.625 37.4911 30.2146 36.4302 31.2307C35.3732 32.2431 34.8051 33.5878 34.8051 34.9602V38.0795ZM33.5593 40.7045C32.8552 40.7045 32.4915 41.2239 32.4915 41.608V50.4716C32.4915 50.8556 32.8552 51.375 33.5593 51.375H47.4407C48.1448 51.375 48.5085 50.8556 48.5085 50.4716V41.608C48.5085 41.2239 48.1448 40.7045 47.4407 40.7045H33.5593Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).REPEAT]: `<path fillRule="evenodd" clipRule="evenodd" d="M52.8912 4.879C54.0626 3.70725 55.9621 3.70696 57.1339 4.87835L69.1376 16.8783C69.7003 17.441 70.0166 18.2041 70.0166 19C70.0166 19.7958 69.7003 20.559 69.1376 21.1216L57.1339 33.1216C55.9621 34.293 54.0626 34.2927 52.8912 33.121C51.7198 31.9492 51.7201 30.0497 52.8919 28.8783L59.7723 22L25.0037 22.0001C20.0303 22.0001 16 26.0304 16 31.0001V37C16 38.6569 14.6569 40 13 40C11.3432 40 10 38.6569 10 37V31.0001C10 22.715 16.7183 16.0001 25.0037 16.0001L59.7723 16L52.8919 9.12164C51.7201 7.95025 51.7198 6.05075 52.8912 4.879ZM67.0166 40C68.6735 40 70.0166 41.3432 70.0166 43V49C70.0166 57.2851 63.2984 64 55.0129 64H20.2443L27.1247 70.8784C28.2964 72.0497 28.2968 73.9492 27.1254 75.121C25.9539 76.2927 24.0544 76.2931 22.8827 75.1216L10.879 63.1217C10.3162 62.5591 10 61.7958 10 61.0001C10 60.2042 10.3162 59.441 10.879 58.8784L22.8827 46.8784C24.0544 45.707 25.9539 45.7074 27.1254 46.8791C28.2968 48.0508 28.2964 49.9503 27.1247 51.1217L20.2443 58H55.0129C59.9864 58 64.0166 53.9697 64.0166 49V43C64.0166 41.3432 65.3597 40 67.0166 40Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).RIBBON]: `<path d="M51.8478 28.8212C51.8478 35.3807 46.5202 40.7083 39.9299 40.7083C33.3397 40.7083 28.0428 35.3807 28.0428 28.8212C28.0428 22.2618 33.3704 16.9341 39.9299 16.9341C46.5202 16.9341 51.8478 22.2618 51.8478 28.8212ZM54.1267 43.8802L61.8872 42.4021L60.0087 35.4423L65.8906 30.7921L60.6862 25.2181L63.5194 17.6424L55.6049 15.4867L54.1267 7.4799L46.2122 10.4979L40.4534 4L35.095 10.0359L26.9958 6.83319L25.2404 14.8092L17.2027 16.9649L19.7588 23.8323L14 29.4063L19.7588 34.3644L17.7571 41.509L25.2404 43.2951L25.9487 46.1899L16.9564 71.5039L26.8418 68.9478L34.3251 76L39.9299 55.7057L46.089 76L52.7717 69.5637L63.7349 70.0257L53.5724 46.0975L54.1267 43.8494V43.8802ZM25.1172 28.8212C25.1172 20.6296 31.7691 13.9778 39.9607 13.9778C48.1523 13.9778 54.8042 20.6296 54.8042 28.8212C54.8042 37.0128 48.1523 43.6647 39.9607 43.6647C31.7999 43.6647 25.148 37.0128 25.148 28.8212H25.1172Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).RSS]: `<path fillRule="evenodd" clipRule="evenodd" d="M4 8C4 5.79086 5.79086 4 8 4C26.0347 4 43.3308 11.1643 56.0833 23.9167C68.8357 36.6692 76 53.9653 76 72C76 74.2091 74.2091 76 72 76C69.7909 76 68 74.2091 68 72C68 56.087 61.6786 40.8258 50.4264 29.5736C39.1742 18.3214 23.913 12 8 12C5.79086 12 4 10.2091 4 8ZM4 36C4 33.7909 5.79086 32 8 32C18.6087 32 28.7828 36.2143 36.2843 43.7157C43.7857 51.2172 48 61.3913 48 72C48 74.2091 46.2091 76 44 76C41.7909 76 40 74.2091 40 72C40 63.5131 36.6286 55.3737 30.6274 49.3726C24.6263 43.3714 16.4869 40 8 40C5.79086 40 4 38.2091 4 36ZM4 68C4 63.5817 7.58172 60 12 60C16.4183 60 20 63.5817 20 68C20 72.4183 16.4183 76 12 76C7.58172 76 4 72.4183 4 68Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SEARCH_GLASS]: `<path d="M74.875 70.2344L56.0313 51.3906C60.1094 46.4688 62.3594 40.1406 62.3594 33.25C62.3594 17.2188 49.1406 4 33.1094 4C16.9375 4 4 17.2188 4 33.25C4 49.4219 17.0781 62.5 33.1094 62.5C39.8594 62.5 46.1875 60.25 51.25 56.1719L70.0938 75.0156C70.7969 75.7188 71.6406 76 72.625 76C73.4688 76 74.3125 75.7188 74.875 75.0156C76.2813 73.75 76.2813 71.6406 74.875 70.2344ZM10.75 33.25C10.75 20.875 20.7344 10.75 33.25 10.75C45.625 10.75 55.75 20.875 55.75 33.25C55.75 45.7656 45.625 55.75 33.25 55.75C20.7344 55.75 10.75 45.7656 10.75 33.25Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SEND]: `<path d="M74.13 36.8274L9.74055 4.4528C6.50305 3.01392 2.9059 5.89165 4.34478 9.12915L13.3377 33.2302L54.3455 40.0649L13.3377 46.8995L4.34478 70.9996C3.2656 74.2371 6.50305 77.1156 9.74055 75.317L74.13 42.9424C76.648 41.8634 76.648 38.2663 74.13 36.8274Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SETTINGS]: `<path fillRule="evenodd" clipRule="evenodd" d="M32.1224 6.87568C33.9637 5.03441 36.461 4 39.0649 4H40.5049C43.1089 4 45.6062 5.03441 47.4474 6.87568C49.2887 8.71694 50.3231 11.2142 50.3231 13.8182V14.4039C50.3237 14.9778 50.4752 15.5415 50.7624 16.0384C51.0496 16.5352 51.4625 16.9479 51.9595 17.2348L51.9681 17.2398L53.3668 18.053L53.3702 18.055C53.8669 18.3409 54.43 18.4915 55.0031 18.4915C55.5776 18.4915 56.142 18.3402 56.6395 18.053C56.6713 18.0347 56.7034 18.0168 56.7358 17.9996L57.1835 17.7608C59.4256 16.4856 62.0803 16.1436 64.5737 16.8103C67.0863 17.4821 69.2297 19.1236 70.5333 21.3742L71.2562 22.6229C72.5558 24.8758 72.9084 27.5524 72.2365 30.0651C71.567 32.5687 69.9349 34.7058 67.6967 36.0107L67.2252 36.2936C67.2094 36.3031 67.1936 36.3124 67.1777 36.3216C66.6782 36.6099 66.2639 37.0251 65.9765 37.5251C65.6892 38.0251 65.539 38.5921 65.5413 39.1688L65.5414 39.1818L65.5413 40.8182L65.5413 40.8312C65.539 41.4079 65.6892 41.9749 65.9765 42.4749C66.2563 42.9617 66.6565 43.3681 67.1383 43.6553L67.5724 43.8868C67.6061 43.9048 67.6395 43.9234 67.6726 43.9426C69.9232 45.2462 71.5646 47.3896 72.2365 49.9022C72.9069 52.4093 72.5574 55.0796 71.2649 57.3294L70.5518 58.5934L70.5333 58.6258C69.2297 60.8764 67.0863 62.5178 64.5737 63.1897C62.0803 63.8564 59.4256 63.5144 57.1835 62.2392L56.7358 62.0004C56.7212 61.9926 56.7066 61.9847 56.6921 61.9767C56.6745 61.967 56.657 61.9571 56.6395 61.947C56.142 61.6597 55.5776 61.5085 55.0031 61.5085C54.43 61.5085 53.8669 61.6591 53.3702 61.945L53.3668 61.947L51.9681 62.7602L51.9595 62.7652C51.4625 63.0521 51.0496 63.4647 50.7624 63.9616C50.4752 64.4585 50.3237 65.0222 50.3231 65.5961V66.1818C50.3231 68.7858 49.2887 71.2831 47.4474 73.1243C45.6062 74.9656 43.1089 76 40.5049 76H39.0649C36.461 76 33.9637 74.9656 32.1224 73.1243C30.2811 71.2831 29.2467 68.7858 29.2467 66.1818L29.2467 65.5961L29.2467 65.5946C29.2459 65.0212 29.0944 64.4581 28.8074 63.9616C28.5202 63.4647 28.1074 63.0521 27.6104 62.7652L27.6018 62.7602L26.2031 61.947L26.1999 61.9451C25.7031 61.6591 25.14 61.5085 24.5667 61.5085C23.9922 61.5085 23.4279 61.6597 22.9304 61.947C22.8986 61.9653 22.8665 61.9832 22.8341 62.0004L22.3864 62.2392C20.1443 63.5144 17.4896 63.8564 14.9962 63.1897C12.4836 62.5178 10.3402 60.8764 9.03655 58.6258L8.31364 57.3771C7.01402 55.1242 6.66145 52.4476 7.33333 49.9349C8.00282 47.4312 9.63495 45.2942 11.8733 43.9893L12.3447 43.7064C12.3605 43.6969 12.3763 43.6876 12.3922 43.6784C12.8916 43.3901 13.306 42.9749 13.5933 42.4749C13.8807 41.9749 14.0308 41.4079 14.0286 40.8312L14.0285 40.8182V39.1606C14.0237 38.5924 13.8709 38.0351 13.5852 37.5437C13.2981 37.0499 12.8869 36.6399 12.3922 36.3543C12.3313 36.3192 12.2716 36.2821 12.2131 36.2431L11.7994 35.9672C9.59905 34.6586 7.99543 32.5411 7.33333 30.0651C6.66145 27.5524 7.01402 24.8758 8.31364 22.6229L9.03621 21.3748C10.3398 19.1241 12.4836 17.4822 14.9962 16.8103C17.4895 16.1436 20.1443 16.4856 22.3864 17.7608L22.8341 17.9996C22.8665 18.0168 22.8986 18.0347 22.9304 18.053C23.4279 18.3402 23.9922 18.4915 24.5667 18.4915C25.1398 18.4915 25.7029 18.341 26.1995 18.0551L26.2031 18.053L27.6104 17.2348C28.1074 16.9479 28.5202 16.5353 28.8074 16.0384C29.0944 15.5419 29.2459 14.9788 29.2467 14.4054L29.2467 14.4039L29.2467 13.8182C29.2467 11.2142 30.2811 8.71694 32.1224 6.87568ZM39.0649 10.5455C38.1969 10.5455 37.3645 10.8903 36.7508 11.504C36.137 12.1178 35.7922 12.9502 35.7922 13.8182L35.7922 14.4106C35.7904 16.1324 35.3359 17.8234 34.4743 19.314C33.6136 20.803 32.3768 22.0398 30.8879 22.9006L30.8831 22.9034L29.4758 23.7215C27.9833 24.5833 26.2902 25.0369 24.5667 25.0369C22.8635 25.0369 21.1899 24.5938 19.7102 23.7517L19.263 23.5132C19.2309 23.4961 19.1992 23.4785 19.1678 23.4603C18.4168 23.0271 17.5246 22.9096 16.687 23.1336C15.8497 23.3575 15.1354 23.9044 14.7008 24.6543V24.6543L13.9834 25.8935L13.9826 25.8949C13.55 26.6456 13.4328 27.5372 13.6566 28.3742C13.8806 29.2118 14.4277 29.9262 15.1779 30.3608C15.2374 30.3952 15.2958 30.4315 15.353 30.4697L15.7651 30.7444C17.2043 31.5981 18.4021 32.806 19.2438 34.2538C20.105 35.7351 20.5636 37.4159 20.5739 39.1293L20.574 39.1491V40.8125C20.5796 42.54 20.1292 44.2385 19.2684 45.7364C18.4113 47.2276 17.1778 48.4673 15.6912 49.3317L15.2214 49.6136C15.207 49.6223 15.1925 49.6308 15.1779 49.6392C14.4277 50.0738 13.8806 50.7882 13.6566 51.6258C13.4329 52.4626 13.55 53.354 13.9823 54.1046L13.9834 54.1065L14.7005 55.3451V55.3451C15.1351 56.095 15.8497 56.6425 16.687 56.8664C17.5246 57.0904 18.4168 56.9729 19.1678 56.5397C19.1992 56.5215 19.2309 56.5039 19.263 56.4868L19.7101 56.2484C21.1898 55.4062 22.8634 54.9631 24.5667 54.9631C26.2902 54.9631 27.9833 55.4167 29.4758 56.2785L29.4844 56.2834L30.8831 57.0966L30.8875 57.0992C32.3766 57.96 33.6135 59.1968 34.4743 60.686C35.3359 62.1766 35.7904 63.8676 35.7922 65.5894L35.7922 65.5927L35.7922 66.1818C35.7922 67.0498 36.137 67.8822 36.7508 68.496C37.3645 69.1097 38.1969 69.4545 39.0649 69.4545H40.5049C41.3729 69.4545 42.2053 69.1097 42.8191 68.496C43.4329 67.8822 43.7777 67.0498 43.7777 66.1818V65.5894C43.7794 63.8676 44.2339 62.1766 45.0956 60.686C45.9562 59.1971 47.1929 57.9603 48.6817 57.0996L48.6868 57.0966L50.0855 56.2834L50.094 56.2785C51.5866 55.4167 53.2797 54.9631 55.0031 54.9631C56.7064 54.9631 58.38 55.4062 59.8597 56.2483L60.3069 56.4868C60.3389 56.5039 60.3706 56.5215 60.4021 56.5397C61.1531 56.9729 62.0453 57.0904 62.8828 56.8664C63.7154 56.6438 64.4264 56.1018 64.8616 55.3584L65.5709 54.1011L65.5865 54.0738C66.0197 53.3228 66.1372 52.4306 65.9132 51.5931C65.6934 50.7708 65.162 50.0672 64.4329 49.6306L64.0012 49.4004C63.9689 49.3832 63.9368 49.3653 63.905 49.347C62.4067 48.482 61.1636 47.2364 60.3015 45.7364C59.4406 44.2385 58.9903 42.54 58.9959 40.8125V39.1875C58.9903 37.46 59.4406 35.7615 60.3015 34.2636C61.1585 32.7724 62.3922 31.5326 63.8787 30.6682L64.3484 30.3864C64.3534 30.3834 64.3584 30.3804 64.3634 30.3775C64.3729 30.3719 64.3824 30.3663 64.3919 30.3608C65.1421 29.9262 65.6893 29.2118 65.9132 28.3742C66.137 27.5373 66.0198 26.6459 65.5875 25.8953L65.5865 25.8935L64.8694 24.6549V24.6549C64.4348 23.905 63.7201 23.3575 62.8828 23.1336C62.0453 22.9096 61.1531 23.0271 60.4021 23.4603C60.3706 23.4785 60.3389 23.4961 60.3069 23.5132L59.8597 23.7517C58.38 24.5938 56.7064 25.0369 55.0031 25.0369C53.2797 25.0369 51.5866 24.5833 50.094 23.7215L50.0855 23.7166L48.6868 22.9034L48.6819 22.9006C47.193 22.0398 45.9563 20.803 45.0956 19.314C44.2339 17.8234 43.7794 16.1324 43.7777 14.4106V13.8182C43.7777 12.9502 43.4329 12.1178 42.8191 11.504C42.2053 10.8903 41.3729 10.5455 40.5049 10.5455H39.0649ZM39.7849 33.4545C36.17 33.4545 33.2395 36.385 33.2395 40C33.2395 43.615 36.17 46.5455 39.7849 46.5455C43.3999 46.5455 46.3304 43.6149 46.3304 40C46.3304 36.385 43.3999 33.4545 39.7849 33.4545ZM26.694 40C26.694 32.7701 32.555 26.9091 39.7849 26.9091C47.0149 26.9091 52.8759 32.7701 52.8759 40C52.8759 47.2299 47.0149 53.0909 39.7849 53.0909C32.555 53.0909 26.694 47.2299 26.694 40Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SHARE]: `<path fillRule="evenodd" clipRule="evenodd" d="M59.3638 10.5455C55.7489 10.5455 52.8184 13.476 52.8184 17.0909C52.8184 20.7059 55.7489 23.6364 59.3638 23.6364C62.9788 23.6364 65.9093 20.7059 65.9093 17.0909C65.9093 13.476 62.9788 10.5455 59.3638 10.5455ZM46.2729 17.0909C46.2729 9.861 52.1339 4 59.3638 4C66.5938 4 72.4548 9.861 72.4548 17.0909C72.4548 24.3208 66.5938 30.1818 59.3638 30.1818C52.1339 30.1818 46.2729 24.3208 46.2729 17.0909Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M20.0909 33.4545C16.476 33.4545 13.5455 36.385 13.5455 40C13.5455 43.615 16.476 46.5455 20.0909 46.5455C23.7059 46.5455 26.6364 43.615 26.6364 40C26.6364 36.385 23.7059 33.4545 20.0909 33.4545ZM6.99998 40C6.99998 32.7701 12.861 26.9091 20.0909 26.9091C27.3209 26.9091 33.1819 32.7701 33.1819 40C33.1819 47.2299 27.3209 53.0909 20.0909 53.0909C12.861 53.0909 6.99998 47.2299 6.99998 40Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M59.3638 56.3636C55.7489 56.3636 52.8184 59.2941 52.8184 62.9091C52.8184 66.524 55.7489 69.4545 59.3638 69.4545C62.9788 69.4545 65.9093 66.524 65.9093 62.9091C65.9093 59.2941 62.9788 56.3636 59.3638 56.3636ZM46.2729 62.9091C46.2729 55.6792 52.1339 49.8182 59.3638 49.8182C66.5938 49.8182 72.4548 55.6792 72.4548 62.9091C72.4548 70.139 66.5938 76 59.3638 76C52.1339 76 46.2729 70.139 46.2729 62.9091Z"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M25.7397 43.2941C26.6497 41.7324 28.6534 41.2041 30.2151 42.1142L52.5679 55.1396C54.1296 56.0496 54.6579 58.0533 53.7478 59.615C52.8378 61.1767 50.8341 61.705 49.2724 60.7949L26.9196 47.7695C25.3579 46.8595 24.8296 44.8557 25.7397 43.2941Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M53.7141 20.3832C54.6251 21.9443 54.0981 23.9483 52.537 24.8593L30.2169 37.8848C28.6558 38.7958 26.6517 38.2688 25.7407 36.7077C24.8297 35.1466 25.3567 33.1426 26.9178 32.2316L49.2379 19.2061C50.799 18.2951 52.803 18.8221 53.7141 20.3832Z"/>
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SKIP_BACK]: `<path fillRule="evenodd" clipRule="evenodd" d="M9.42047 4C11.3093 4 12.8405 5.53119 12.8405 7.42V20.2609L17.3927 16.1639L17.4195 16.14C23.1706 11.0725 30.4574 8.0839 38.1105 7.65377C45.7636 7.22364 53.3393 9.37692 59.622 13.7681C65.9047 18.1592 70.5302 24.5337 72.7561 31.8685C74.982 39.2034 74.6793 47.0733 71.8966 54.2156C69.1139 61.3578 64.0125 67.3581 57.4111 71.2538C50.8097 75.1494 43.0909 76.7145 35.4935 75.6978C27.896 74.6811 20.8603 71.1417 15.5154 65.6474C10.1706 60.1531 6.82634 53.0226 6.01945 45.4C5.82062 43.5217 7.18212 41.8379 9.06045 41.639C10.9388 41.4402 12.6227 42.8017 12.8215 44.68C13.467 50.7781 16.1424 56.4825 20.4183 60.8779C24.6942 65.2733 30.3227 68.1049 36.4007 68.9182C42.4787 69.7315 48.6537 68.4795 53.9348 65.363C59.216 62.2465 63.297 57.4462 65.5232 51.7324C67.7494 46.0187 67.9915 39.7227 66.2108 33.8548C64.4301 27.9869 60.7297 22.8874 55.7035 19.3744C50.6774 15.8615 44.6168 14.1389 38.4943 14.483C32.3776 14.8268 26.5535 17.2135 21.9546 21.2605L18.3329 24.52H29.9406C31.8294 24.52 33.3606 26.0512 33.3606 27.94C33.3606 29.8288 31.8294 31.36 29.9406 31.36H9.42047C7.53164 31.36 6.00045 29.8288 6.00045 27.94V7.42C6.00045 5.53119 7.53164 4 9.42047 4Z"/>
        <path d="M24.8106 43.0795V39.6829C26.4638 39.0617 27.8014 38.2301 28.8234 37.1881C29.8454 36.136 30.5468 34.7633 30.9275 33.07H34.4143V53.5399H30.8975V38.9465C29.2843 40.9905 27.2553 42.3682 24.8106 43.0795Z" />
        <path d="M38.1116 47.438H41.6885C41.909 49.6624 43.2817 50.7745 45.8066 50.7745C47.1392 50.7745 48.1712 50.4138 48.9027 49.6924C49.6341 48.971 49.9998 47.944 49.9998 46.6114V46.5513C49.9998 45.3189 49.6341 44.347 48.9027 43.6356C48.1812 42.9142 47.2043 42.5535 45.9719 42.5535C44.9199 42.5535 44.0482 42.7689 43.3568 43.1998C42.6755 43.6306 42.0893 44.2368 41.5984 45.0183L38.4873 43.0795L39.9602 33.1001H52.5247V36.3013H42.5452L41.8388 41.1408C42.951 40.0286 44.4189 39.4725 46.2425 39.4725C48.4668 39.4725 50.2653 40.1238 51.638 41.4263C53.0107 42.7188 53.697 44.4372 53.697 46.5814C53.697 48.8458 52.9856 50.6443 51.5629 51.9769C50.1501 53.3095 48.2464 53.9758 45.8517 53.9758C43.5672 53.9758 41.7036 53.3696 40.2608 52.1572C38.828 50.9449 38.1116 49.3718 38.1116 47.438Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SKIP_FORWARD]: `<path fillRule="evenodd" clipRule="evenodd" d="M70.8095 4C72.6983 4 74.2295 5.53119 74.2295 7.42V27.94C74.2295 29.8288 72.6983 31.36 70.8095 31.36H50.2894C48.4006 31.36 46.8694 29.8288 46.8694 27.94C46.8694 26.0512 48.4006 24.52 50.2894 24.52H67.3895V7.42C67.3895 5.53119 68.9207 4 70.8095 4Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M41.7357 14.483C35.6132 14.1389 29.5526 15.8615 24.5264 19.3744C19.5003 22.8874 15.7999 27.9869 14.0192 33.8548C12.2385 39.7227 12.4806 46.0187 14.7068 51.7324C16.9329 57.4462 21.014 62.2465 26.2952 65.363C31.5763 68.4795 37.7513 69.7315 43.8293 68.9182C49.9073 68.1049 55.5358 65.2733 59.8117 60.8779C64.0876 56.4825 66.763 50.7781 67.4085 44.68C67.6073 42.8017 69.2912 41.4402 71.1695 41.639C73.0479 41.8379 74.4094 43.5217 74.2105 45.4001C73.4036 53.0226 70.0594 60.1531 64.7146 65.6474C59.3697 71.1417 52.334 74.6811 44.7365 75.6978C37.1391 76.7145 29.4203 75.1494 22.8189 71.2538C16.2175 67.3581 11.1161 61.3578 8.3334 54.2156C5.55071 47.0733 5.24802 39.2034 7.47392 31.8685C9.69982 24.5337 14.3252 18.1592 20.608 13.7681C26.8907 9.37692 34.4664 7.22364 42.1195 7.65377C49.7726 8.0839 57.0594 11.0725 62.8105 16.14L62.8373 16.1639L73.0974 25.398C74.5013 26.6615 74.6152 28.8239 73.3516 30.2279C72.088 31.6318 69.9256 31.7456 68.5216 30.4821L58.2753 21.2604C53.6765 17.2134 47.8524 14.8268 41.7357 14.483Z" />
        <path d="M24.6393 43.0795V39.6829C26.2925 39.0617 27.6301 38.2301 28.6521 37.1881C29.6741 36.136 30.3755 34.7633 30.7562 33.07H34.243V53.5399H30.7262V38.9465C29.113 40.9905 27.084 42.3682 24.6393 43.0795Z" />
        <path d="M37.9403 47.438H41.5173C41.7377 49.6624 43.1104 50.7746 45.6353 50.7746C46.9679 50.7746 47.9999 50.4139 48.7314 49.6924C49.4628 48.971 49.8285 47.944 49.8285 46.6114V46.5513C49.8285 45.3189 49.4628 44.347 48.7314 43.6356C48.0099 42.9142 47.033 42.5535 45.8006 42.5535C44.7486 42.5535 43.8769 42.7689 43.1855 43.1998C42.5042 43.6306 41.918 44.2368 41.4271 45.0183L38.316 43.0795L39.7889 33.1001H52.3534V36.3013H42.3739L41.6676 41.1408C42.7797 40.0286 44.2476 39.4725 46.0712 39.4725C48.2955 39.4725 50.094 40.1238 51.4667 41.4263C52.8394 42.7188 53.5257 44.4372 53.5257 46.5814C53.5257 48.8458 52.8143 50.6443 51.3916 51.9769C49.9788 53.3095 48.0751 53.9758 45.6804 53.9758C43.3959 53.9758 41.5323 53.3696 40.0895 52.1573C38.6567 50.9449 37.9403 49.3718 37.9403 47.438Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SKIP_TO_FIRST]: `<path fillRule="evenodd" clipRule="evenodd" d="M38.4937 10.5063C40.5021 12.5147 40.5021 15.771 38.4937 17.7794L16.416 39.8571L38.4937 61.9349C40.5021 63.9433 40.5021 67.1996 38.4937 69.208C36.4853 71.2164 33.229 71.2164 31.2206 69.208L5.50631 43.4937C3.4979 41.4853 3.4979 38.229 5.50631 36.2206L31.2206 10.5063C33.229 8.4979 36.4853 8.4979 38.4937 10.5063ZM74.4937 10.5063C76.5021 12.5147 76.5021 15.771 74.4937 17.7794L52.416 39.8571L74.4937 61.9349C76.5021 63.9433 76.5021 67.1996 74.4937 69.208C72.4853 71.2164 69.229 71.2164 67.2206 69.208L41.5063 43.4937C39.4979 41.4853 39.4979 38.229 41.5063 36.2206L67.2206 10.5063C69.229 8.4979 72.4853 8.4979 74.4937 10.5063Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SKIP_TO_LAST]: `<path fillRule="evenodd" clipRule="evenodd" d="M5.50631 10.6489C7.51472 8.64048 10.771 8.64048 12.7794 10.6489L38.4937 36.3632C40.5021 38.3716 40.5021 41.6279 38.4937 43.6363L12.7794 69.3506C10.771 71.359 7.51472 71.359 5.50631 69.3506C3.4979 67.3421 3.4979 64.0859 5.50631 62.0775L27.584 39.9997L5.50631 17.922C3.4979 15.9136 3.4979 12.6573 5.50631 10.6489ZM41.5063 10.6489C43.5147 8.64048 46.771 8.64048 48.7794 10.6489L74.4937 36.3632C76.5021 38.3716 76.5021 41.6279 74.4937 43.6363L48.7794 69.3506C46.771 71.359 43.5147 71.359 41.5063 69.3506C39.4979 67.3421 39.4979 64.0859 41.5063 62.0775L63.584 39.9997L41.5063 17.922C39.4979 15.9136 39.4979 12.6573 41.5063 10.6489Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SKIP_TO_NEXT]: `<path fillRule="evenodd" clipRule="evenodd" d="M20.5063 5.50631C22.5147 3.4979 25.771 3.4979 27.7794 5.50631L58.6365 36.3635C60.645 38.3719 60.645 41.6281 58.6365 43.6365L27.7794 74.4937C25.771 76.5021 22.5147 76.5021 20.5063 74.4937C18.4979 72.4853 18.4979 69.229 20.5063 67.2206L47.7269 40L20.5063 12.7794C18.4979 10.771 18.4979 7.51472 20.5063 5.50631Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SKIP_TO_PREVIOUS]: `<path fillRule="evenodd" clipRule="evenodd" d="M58.6365 5.50631C60.645 7.51472 60.645 10.771 58.6365 12.7794L31.416 40L58.6365 67.2206C60.645 69.229 60.645 72.4853 58.6365 74.4937C56.6281 76.5021 53.3719 76.5021 51.3635 74.4937L20.5063 43.6365C18.4979 41.6281 18.4979 38.3719 20.5063 36.3635L51.3635 5.50631C53.3719 3.4979 56.6281 3.4979 58.6365 5.50631Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SMILEY_BELL]: `<path d="M22.4186 31.093C22.2632 32.2014 22.1763 33.3203 22.1587 34.4419H12.2041C11.3721 34.4419 10.6977 33.6922 10.6977 32.7674C10.6977 31.8427 11.3721 31.093 12.2041 31.093H22.4186Z" />
        <path d="M24.093 39.4651C24.0115 40.7087 23.8943 41.8201 23.7517 42.814H5.74235C4.78008 42.814 4 42.0643 4 41.1395C4 40.2148 4.78008 39.4651 5.74235 39.4651H24.093Z" />
        <path d="M22.4186 47.8372C21.4769 50.011 20.4349 50.8286 19.9334 51.1126L19.8164 51.186H14.2778C13.2253 51.186 12.3721 50.4364 12.3721 49.5116C12.3721 48.5869 13.2253 47.8372 14.2778 47.8372H22.4186Z" />
        <path d="M76 32.7674C76 33.6922 75.2656 34.4419 74.3597 34.4419H61.218C61.1995 33.3201 61.1033 32.201 60.9302 31.093H74.3597C74.7947 31.093 75.2119 31.2694 75.5196 31.5835C75.8272 31.8975 76 32.3234 76 32.7674Z" />
        <path d="M69.3014 41.0202C69.3157 41.4446 69.1561 41.8571 68.8579 42.1664C68.5597 42.4758 68.1475 42.6565 67.7125 42.6688L62.9119 42.814C62.7823 41.8773 62.6767 40.8 62.6046 39.6151L67.6357 39.4652C68.5323 39.4546 69.2728 40.1458 69.3014 41.0202Z" />
        <path d="M74.3256 47.8348C74.3256 48.759 73.5231 49.5089 72.5312 49.5116H64.3046C63.5329 48.4961 62.9576 47.3628 62.6046 46.1628H72.5312C73.521 46.1655 74.3227 46.9125 74.3256 47.8348Z" />
        <path d="M23.9918 36.1177C23.9918 48.217 21.2568 51.916 19.6041 52.9918C17.7785 54.2276 16.9705 56.5217 17.6146 58.6406C18.2587 60.7596 20.2032 62.2042 22.4025 62.1977H34.0641V62.3353C34.6328 66.4893 38.1484 69.5885 42.3099 69.6046C46.4715 69.6206 50.0105 66.5486 50.6107 62.3991V62.2665H60.9512C63.706 62.2477 65.9346 60.0021 65.9533 57.2263C65.9664 55.5536 65.1438 53.9863 63.7642 53.0557C62.0968 51.916 59.3765 48.217 59.3765 36.1865C59.3765 24.8879 52.5511 20.3881 47.5637 18.5017C47.6426 18.0803 47.6883 17.6532 47.7002 17.2245C47.7625 15.0221 46.632 12.9595 44.7488 11.8398C42.8655 10.7201 40.5271 10.7201 38.6439 11.8398C36.7607 12.9595 35.6302 15.0221 35.6925 17.2245C35.7027 17.6531 35.7468 18.0802 35.8241 18.5017C30.7977 20.2506 23.9918 24.824 23.9918 36.1177ZM42.3374 66.9038C40.1128 66.9167 38.0934 65.5961 37.1989 63.5437H47.5393C46.603 65.5891 44.5729 66.9004 42.3374 66.9038ZM41.6695 13.8006C42.5567 13.7913 43.4103 14.1423 44.0377 14.7745C44.6651 15.4066 45.0134 16.2667 45.0042 17.1606C45.0144 17.3415 44.993 17.5228 44.9408 17.6961C42.7611 17.2502 40.5146 17.2502 38.3348 17.6961C38.3348 17.4947 38.2666 17.3621 38.2666 17.1606C38.3089 15.2961 39.8186 13.8054 41.6695 13.8006ZM60.4149 53.5273C60.9131 54.2093 61.5231 54.8008 62.2187 55.2761C62.8676 55.7199 63.2649 56.4512 63.2864 57.2411C63.2706 58.534 62.2343 59.5782 60.9512 59.5941H22.3879C21.1048 59.5782 20.0684 58.534 20.0524 57.2411C20.0406 56.4424 20.446 55.6962 21.1203 55.2761C24.7914 52.7217 26.6586 46.3355 26.6586 36.1865C26.6586 25.9146 32.8648 21.9846 38.135 20.5109H38.2032C39.3528 20.1815 40.5426 20.0162 41.7378 20.0196C42.9141 20.0167 44.0837 20.199 45.2041 20.56H45.2723C50.4742 22.0338 56.7487 25.9637 56.7487 36.157C56.7487 42.5431 57.48 47.4555 58.9474 50.8107C59.3473 51.7624 59.8388 52.6722 60.4149 53.5273Z"/>
        <path d="M51.7209 39.4651C53.1081 39.4651 54.2326 38.3406 54.2326 36.9535C54.2326 35.5664 53.1081 34.4419 51.7209 34.4419C50.3338 34.4419 49.2093 35.5664 49.2093 36.9535C49.2093 38.3406 50.3338 39.4651 51.7209 39.4651Z" />
        <path d="M34.9767 39.4651C36.3639 39.4651 37.4884 38.3406 37.4884 36.9535C37.4884 35.5664 36.3639 34.4419 34.9767 34.4419C33.5896 34.4419 32.4651 35.5664 32.4651 36.9535C32.4651 38.3406 33.5896 39.4651 34.9767 39.4651Z" />
        <path d="M42.5341 46.1626C41.2073 46.1737 39.9297 45.7471 38.9831 44.9768C38.0365 44.2065 37.4987 43.1559 37.4884 42.0566C37.5313 41.5403 38.0494 41.1395 38.6741 41.1395C39.2989 41.1395 39.817 41.5403 39.8598 42.0566C39.8598 43.27 41.0471 44.2536 42.5116 44.2536C43.9762 44.2536 45.1634 43.27 45.1634 42.0566C45.2063 41.5403 45.7244 41.1395 46.3491 41.1395C46.9739 41.1395 47.492 41.5403 47.5349 42.0566C47.5133 44.3313 45.2798 46.1652 42.5341 46.1626Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SOCIAL_FACEBOOK]: `<path d="M23.1495 42.3472H30.9614V74.8387C30.9614 75.4802 31.4759 76 32.1109 76H45.3564C45.9913 76 46.5058 75.4802 46.5058 74.8387V42.5003H55.4864C56.0703 42.5003 56.5616 42.0576 56.6282 41.4716L57.9922 29.5098C58.0297 29.1807 57.9264 28.8511 57.7085 28.6043C57.4903 28.3571 57.1781 28.2157 56.8505 28.2157H46.5063V20.7175C46.5063 18.4571 47.7109 17.3109 50.0871 17.3109C50.4257 17.3109 56.8505 17.3109 56.8505 17.3109C57.4855 17.3109 58 16.7909 58 16.1497V5.16988C58 4.52839 57.4855 4.00859 56.8505 4.00859H47.5296C47.4638 4.00534 47.3178 4 47.1026 4C45.4853 4 39.8638 4.32075 35.4232 8.44797C30.503 13.0216 31.187 18.4978 31.3504 19.4473V28.2155H23.1495C22.5145 28.2155 22 28.7353 22 29.3767V41.1857C22 41.8272 22.5145 42.3472 23.1495 42.3472Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SOCIAL_LINKED_IN]: `<path d="M76 47.2003V73.2H60.5681V48.9416C60.5681 42.8477 58.336 38.6888 52.7502 38.6888C48.4861 38.6888 45.9485 41.4916 44.8321 44.2028C44.425 45.172 44.3203 46.5211 44.3203 47.8778V73.2H28.8831C28.8831 73.2 29.091 32.1142 28.8831 27.8574H44.3187V34.2845C44.2874 34.3326 44.2468 34.3844 44.2173 34.431H44.3187V34.2845C46.3695 31.1994 50.032 26.7922 58.2297 26.7922C68.3862 26.792 76 33.2728 76 47.2003ZM12.7352 6C7.45422 6 4 9.38337 4 13.8326C4 18.1849 7.35429 21.6709 12.5303 21.6709H12.6335C18.0168 21.6709 21.3647 18.1855 21.3647 13.8326C21.2632 9.38337 18.0168 6 12.7352 6ZM4.91683 73.2H20.3481V27.8574H4.91683V73.2Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SOCIAL_X]: `<path d="M46.9287 34.4871L73.1562 4H66.9411L44.1678 30.4715L25.9788 4H5L32.5053 44.0296L5 76H11.2154L35.2646 48.0452L54.4735 76H75.4523L46.9272 34.4871H46.9287ZM38.4158 44.3823L13.4549 8.67885H23.0014L66.944 71.5339H57.3975L38.4158 44.3838V44.3823Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).SPOTLIGHT]: `<path d="M71.4367 13.1308C72.5205 12.8299 73.6842 13.0549 74.5797 13.7355C75.4746 14.4163 76 15.4762 76 16.6007V59.8007C76 60.8926 75.5052 61.9265 74.6535 62.6097C73.8019 63.2928 72.6853 63.553 71.6195 63.3164L6.81953 48.9164C5.1724 48.5503 4 47.0881 4 45.4007V34.6007L4.04922 34.0066C4.27646 32.6451 5.27286 31.5097 6.63672 31.1308L71.4367 13.1308ZM11.2 37.3359V42.5109L68.8 55.3113V21.3363L11.2 37.3359Z"/>
<path d="M14.2104 48.7645C14.739 46.8481 16.7201 45.7225 18.6365 46.2508C20.5528 46.7795 21.6783 48.7607 21.1502 50.677C20.8977 51.5923 20.8293 52.5508 20.9463 53.493C21.0634 54.4344 21.3641 55.3433 21.8322 56.1684C22.3009 56.9941 22.929 57.7189 23.6779 58.3024C24.4269 58.8859 25.2834 59.319 26.1986 59.5715C27.1134 59.8237 28.0694 59.8923 29.0111 59.7754C29.9532 59.6584 30.8644 59.3581 31.69 58.8895C32.5155 58.4209 33.2406 57.7926 33.824 57.0438C34.4073 56.295 34.8372 55.4381 35.0896 54.5231L35.2057 54.175C35.8655 52.4738 37.7191 51.5147 39.5158 52.0094C41.4325 52.5381 42.5582 54.5225 42.0295 56.4391L41.8256 57.1176C41.3077 58.6891 40.5208 60.162 39.5018 61.47C38.3375 62.964 36.8916 64.2157 35.2443 65.1508C33.5963 66.0862 31.7776 66.6857 29.8971 66.9192C28.0168 67.1525 26.1091 67.0152 24.2826 66.5114C22.4559 66.0075 20.7466 65.1482 19.2518 63.9836C17.7569 62.819 16.5063 61.3707 15.5709 59.7227C14.6357 58.0748 14.0325 56.2593 13.799 54.3789C13.5656 52.4987 13.7066 50.591 14.2104 48.7645Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).THRIVE]: `<path d="M50.846 66.4053H33.3985V32.361C33.3934 31.7971 33.2714 31.24 33.0399 30.7229C32.8083 30.2059 32.472 29.7396 32.051 29.3519C31.658 28.9763 31.1902 28.6829 30.6764 28.4899C30.1625 28.2968 29.6134 28.208 29.063 28.2291C27.9558 28.2636 26.9051 28.7126 26.1301 29.4824C25.355 30.2523 24.9155 31.2836 24.9032 32.361V70.5458C24.9176 71.6373 25.3698 72.6801 26.1633 73.452C26.9568 74.2238 28.0288 74.6637 29.1509 74.6777H50.846C51.4259 74.6734 51.9988 74.555 52.5304 74.3297C53.062 74.1045 53.5413 73.777 53.9395 73.3669C54.3255 72.9846 54.6271 72.5296 54.8256 72.0297C55.0241 71.5298 55.1153 70.9957 55.0937 70.4603C55.0597 69.3828 54.5985 68.3599 53.8068 67.6057C53.0151 66.8514 51.9541 66.4244 50.846 66.4138" />
        <path d="M74.7025 6.13893C74.3256 5.76127 73.8758 5.46554 73.3809 5.27005C72.886 5.07457 72.3565 4.98349 71.8253 5.00245C70.7587 5.03468 69.7458 5.4812 68.9987 6.24856C68.2516 7.01591 67.8281 8.04461 67.8169 9.11933V27.1637H49.8966C48.8161 27.1777 47.7838 27.6162 47.0198 28.3858C46.2557 29.1554 45.8203 30.1951 45.8065 31.2834V49.6374C45.8116 50.1999 45.9294 50.7556 46.1529 51.2712C46.3763 51.7867 46.7008 52.2515 47.1068 52.6377C47.8268 53.3576 48.7976 53.7654 49.812 53.7742H49.984C51.0506 53.7412 52.0631 53.294 52.8097 52.5261C53.5563 51.7582 53.9791 50.7292 53.9895 49.6545V35.4173H71.9099C72.9906 35.4026 74.0229 34.9634 74.7869 34.1934C75.5508 33.4234 75.9861 32.3833 76 31.2948V9.13353C75.9937 8.57232 75.8756 8.0181 75.6527 7.50371C75.4298 6.98932 75.1067 6.52522 74.7025 6.13893Z" />
        <path d="M51.6218 11.8571C52.0055 11.4801 52.3054 11.0318 52.503 10.5394C52.7007 10.047 52.792 9.52093 52.7713 8.99339C52.7368 7.93077 52.2774 6.92208 51.4891 6.17795C50.7007 5.43383 49.6444 5.0118 48.5407 5H8.2335C7.11567 5.01382 6.04762 5.44749 5.25685 6.20862C4.46609 6.96976 4.01512 7.99821 4 9.07489V31.1018C4.00564 31.6581 4.12766 32.2077 4.35876 32.7175C4.58986 33.2274 4.9253 33.6872 5.34503 34.0694C6.09056 34.7802 7.09414 35.1834 8.14305 35.1935H8.32103C9.42623 35.1587 10.4745 34.7133 11.2463 33.9505C12.0181 33.1877 12.4535 32.1669 12.4612 31.1018V13.1526H48.5407C49.1183 13.1472 49.6889 13.0296 50.2182 12.807C50.7476 12.5844 51.225 12.2614 51.6218 11.8571Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).TOUCH_ID]: `<path d="M22.8129 56.0327C23.0184 55.4984 22.7513 54.8922 22.217 54.6765C21.6827 54.471 21.0766 54.7381 20.8608 55.2724C19.556 58.6218 17.3983 61.6014 14.6243 63.8823C14.1825 64.2521 14.1106 64.9097 14.4804 65.3515C14.6859 65.5981 14.9839 65.7316 15.2921 65.7316C15.5284 65.7316 15.7545 65.6597 15.9497 65.4953C19.0114 62.9884 21.3848 59.7212 22.8129 56.0327Z" />
        <path d="M15.3435 44.957L15.2203 44.392C15.0148 43.2618 14.8915 42.1213 14.8504 40.9809C14.8298 40.4055 14.3367 39.9534 13.7613 39.9843C13.1859 40.0048 12.7339 40.498 12.7647 41.0733C12.8263 42.5118 13.001 43.9604 13.2887 45.3783L13.3811 45.8098C14.0695 49.9915 12.5078 54.2348 9.26114 56.9883C8.81934 57.3582 8.76797 58.0157 9.13785 58.4575C9.34333 58.7041 9.64129 58.8274 9.93925 58.8274C10.1756 58.8274 10.4221 58.7452 10.6174 58.5808C14.5627 55.2417 16.3813 50.0223 15.3538 44.957H15.3435Z" />
        <path d="M11.0591 45.82L10.9461 45.2754C9.56936 37.7238 11.1413 30.0694 15.4052 23.648C19.7718 17.0827 26.4295 12.6031 34.1558 11.0414C37.4025 10.3838 40.7006 10.2811 43.9473 10.7126C44.5226 10.7845 45.0466 10.3838 45.1186 9.81872C45.2007 9.24336 44.7898 8.71937 44.2247 8.64745C40.7417 8.17483 37.2176 8.29812 33.7449 8.99677C25.4638 10.6612 18.3334 15.4593 13.6585 22.487C8.98372 29.5146 7.32955 37.9498 9.00427 46.231L9.07619 46.5597C9.43579 48.8817 8.71659 51.2654 7.10352 53.0017C6.71309 53.423 6.73364 54.0908 7.15489 54.4812C7.36038 54.6662 7.60696 54.7587 7.86382 54.7587C8.14123 54.7587 8.41863 54.6456 8.63439 54.4196C10.7715 52.1079 11.6859 48.892 11.0591 45.8097V45.82Z" />
        <path d="M41.0294 39.789C40.9164 39.2239 40.3616 38.854 39.7965 38.9671C39.2314 39.0801 38.8615 39.6349 38.9745 40.2C40.1766 46.1591 39.9711 52.1285 38.3581 57.9437C36.8169 63.4919 33.9915 68.7215 30.19 73.0573C29.8098 73.4888 29.8509 74.1464 30.2825 74.5265C30.4777 74.7012 30.7243 74.7834 30.9708 74.7834C31.2585 74.7834 31.5462 74.6601 31.7517 74.4238C35.7689 69.8517 38.7485 64.3447 40.3719 58.4883C42.0671 52.3545 42.2931 46.0563 41.0191 39.7685L41.0294 39.789Z"/>
        <path d="M28.1864 42.3781L28.0323 41.6178C27.1795 35.371 31.3406 29.4325 37.608 28.1687C38.7073 27.9427 39.8272 27.8811 40.9369 27.9632C41.5122 28.0043 42.0157 27.5831 42.0568 27.0077C42.0979 26.4324 41.6663 25.9289 41.091 25.8878C39.7861 25.7851 38.4813 25.8673 37.1867 26.1241C29.5323 27.6653 24.5596 35.145 26.1007 42.7994L26.2959 43.7857C27.6624 52.3545 24.5082 61.1082 17.9018 66.8208C17.4703 67.2009 17.4189 67.8585 17.7991 68.29C18.0045 68.5263 18.2922 68.6496 18.5902 68.6496C18.8368 68.6496 19.0731 68.5674 19.2786 68.3927C26.7069 61.961 30.118 51.9846 28.1761 42.3679L28.1864 42.3781Z" />
        <path d="M32.81 43.5391C32.7278 42.9638 32.2038 42.5631 31.6387 42.6453C31.0633 42.7275 30.6626 43.2514 30.7448 43.8165C32.0291 53.2689 28.618 62.8138 21.6212 69.3585C21.2 69.749 21.1794 70.4168 21.5698 70.838C21.7753 71.0538 22.0527 71.1668 22.3301 71.1668C22.587 71.1668 22.8438 71.0743 23.0391 70.8894C30.5188 63.8823 34.1764 53.6696 32.7997 43.5391H32.81Z" />
        <path d="M34.4127 59.4747C33.8785 59.2692 33.2723 59.5261 33.0565 60.0706C31.3818 64.3447 28.9159 68.1873 25.7104 71.4751C25.3097 71.8861 25.3199 72.5539 25.7309 72.9546C25.9364 73.1498 26.1933 73.2526 26.4604 73.2526C26.7275 73.2526 27.0049 73.1498 27.2104 72.9341C30.6112 69.4408 33.2414 65.3722 35.0086 60.8309C35.2141 60.2966 34.9573 59.6905 34.4127 59.4747Z" />
        <path d="M19.6176 44.0939L19.4532 43.272C18.282 35.9361 21.0869 28.5488 26.8919 23.8329C27.3337 23.4733 27.4056 22.8158 27.046 22.3637C26.6864 21.9116 26.0288 21.85 25.5767 22.2096C18.9395 27.5933 15.8675 36.1416 17.5628 44.5152L17.7066 45.2549C18.6108 51.0599 16.3607 56.8855 11.7372 60.5945C11.2852 60.9541 11.2132 61.6116 11.5831 62.0637C11.7886 62.3206 12.0968 62.4542 12.3948 62.4542C12.6208 62.4542 12.8571 62.3822 13.0523 62.2281C18.4875 57.8615 21.0047 50.9161 19.6279 44.1042L19.6176 44.0939Z"/>
        <path d="M35.471 17.5554C33.7346 17.9047 32.0394 18.4493 30.4366 19.189C29.9126 19.4253 29.6865 20.0521 29.9228 20.5761C30.1591 21.1001 30.7859 21.3261 31.3099 21.0898C32.7688 20.4219 34.2997 19.9288 35.882 19.6103C42.026 18.3774 48.3242 19.9391 53.1839 23.9152C53.3791 24.0693 53.6155 24.1515 53.8415 24.1515C54.1394 24.1515 54.4477 24.018 54.6532 23.7714C55.023 23.3296 54.9511 22.672 54.5093 22.3022C49.1667 17.9253 42.2315 16.2095 35.471 17.5657V17.5554Z" />
        <path d="M7.11383 48.1317C7.00081 47.6591 6.88779 47.1659 6.78505 46.683C6.77477 46.6214 6.75422 46.5597 6.73368 46.4981C5.25417 38.967 6.3227 31.3845 9.81598 24.5624C10.0831 24.0487 9.87762 23.4219 9.3639 23.1548C8.85019 22.8877 8.22345 23.0932 7.95632 23.6069C4.21646 30.9222 3.09656 39.0389 4.73018 47.1043C4.74045 47.1659 4.761 47.2378 4.79183 47.2995C4.8843 47.7516 4.98704 48.1934 5.10006 48.6351C5.21307 49.1078 5.6446 49.4263 6.11722 49.4263C6.19941 49.4263 6.2816 49.4263 6.3638 49.3954C6.92889 49.2619 7.26794 48.6865 7.1241 48.1317H7.11383Z" />
        <path d="M11.1618 20.2369C11.3467 20.3705 11.5625 20.4424 11.7783 20.4424C12.0968 20.4424 12.4153 20.2986 12.6208 20.0109C17.6244 13.1476 24.9705 8.45225 33.2927 6.77753C40.68 5.28775 48.1494 6.25354 54.8996 9.56188C55.4134 9.81874 56.0401 9.60297 56.297 9.08926C56.5538 8.57554 56.338 7.94881 55.8243 7.69195C48.6528 4.16785 40.7211 3.14042 32.8817 4.72267C24.0458 6.5104 16.2476 11.5037 10.9358 18.778C10.5967 19.2403 10.6995 19.8979 11.1618 20.2369Z" />
        <path d="M64.6499 35.0217L64.7527 35.5046C64.9376 36.4498 65.102 37.4156 65.2459 38.3608C65.3178 38.8746 65.7699 39.2547 66.2733 39.2547C66.3247 39.2547 66.376 39.2547 66.4274 39.2444C66.9925 39.1622 67.3932 38.628 67.311 38.0629C67.1466 36.9224 66.9411 35.7614 66.7048 34.621L66.5404 33.8299H66.5302C63.2115 19.5485 49.0638 10.3838 34.6078 13.2915C29.1213 14.4011 24.1793 17.1135 20.3162 21.1411C16.5455 25.0761 14.0591 29.9873 13.1344 35.3402C13.0317 35.9053 13.4118 36.4498 13.9872 36.5423C14.5523 36.645 15.0968 36.2649 15.1893 35.6895C16.0523 30.7476 18.3435 26.2166 21.8265 22.5795C25.3917 18.8602 29.9535 16.3532 35.0188 15.3258C48.622 12.5825 61.917 21.4185 64.6499 35.0217Z" />
        <path d="M49.5981 38.0527C49.0844 35.4841 47.5946 33.2751 45.4165 31.8264C43.2383 30.3778 40.6184 29.864 38.0601 30.3778C34.2072 31.1586 31.2071 34.1382 30.4057 37.9808C30.2927 38.5459 30.6523 39.1007 31.2173 39.2137C31.7824 39.337 32.3372 38.9671 32.4503 38.402C33.077 35.3814 35.4504 33.0285 38.471 32.4121C40.4951 32.0011 42.5499 32.4121 44.2658 33.5525C45.8685 34.6211 46.9987 36.2033 47.4713 38.063L47.5535 38.4534C48.17 41.4946 48.4782 44.5872 48.4885 47.6592C48.4885 48.2346 48.9611 48.6969 49.5365 48.6969C50.1118 48.6969 50.5845 48.2243 50.5742 47.6489C50.5742 44.731 50.2968 41.7925 49.7625 38.9055H49.7831L49.6084 38.0321L49.5981 38.0527Z" />
        <path d="M62.3486 35.0937C61.6705 31.9703 60.3759 29.0935 58.506 26.5249C58.167 26.0626 57.5094 25.9598 57.0471 26.2989C56.5847 26.6379 56.482 27.2955 56.821 27.7578C58.5882 30.1826 59.7903 32.9155 60.3862 35.8848L60.4376 36.1109C62.6363 47.2174 61.6705 58.6527 57.6327 69.1942C57.4272 69.7285 57.6943 70.3347 58.2389 70.5402C58.3622 70.5915 58.4855 70.6121 58.6088 70.6121C59.03 70.6121 59.4204 70.3552 59.5848 69.9442C63.787 58.961 64.7734 47.053 62.4411 35.4738L62.3589 35.0937H62.3486Z" />
        <path d="M66.7973 42.6659C66.222 42.707 65.7802 43.2001 65.8213 43.7755C66.2631 50.7107 65.5747 57.6253 63.787 64.3344C63.6431 64.8892 63.9719 65.4646 64.5267 65.6084C64.6192 65.629 64.7116 65.6393 64.7938 65.6393C65.2562 65.6393 65.6774 65.331 65.8007 64.8687C67.6501 57.9335 68.359 50.7929 67.907 43.6419C67.8659 43.0666 67.3727 42.6248 66.7973 42.6659Z" />
        <path d="M70.8043 32.8641H70.794C68.2871 22.0453 60.2526 13.2812 49.6186 9.88044C49.0741 9.70578 48.4782 10.0037 48.3035 10.5585C48.1288 11.1031 48.4268 11.699 48.9816 11.8737C59.1738 15.1409 66.8179 23.6789 68.9344 34.169L69.0577 34.7752C70.4344 41.9055 70.6707 49.1387 69.7871 56.2999C69.7152 56.8752 70.1262 57.389 70.6913 57.4609C70.7324 57.4609 70.7735 57.4609 70.8248 57.4609C71.3488 57.4609 71.7906 57.0705 71.8626 56.5465C72.8078 48.964 72.5098 41.2994 70.9892 33.7477L70.8043 32.8641Z" />
        <path d="M75.2737 32.8745C75.2634 32.8026 75.2428 32.7409 75.212 32.6793C73.3421 23.6789 68.1844 15.8294 60.6636 10.5483C60.1909 10.2196 59.5437 10.3326 59.2046 10.8052C58.8758 11.2778 58.9888 11.9251 59.4615 12.2642C66.6021 17.278 71.4824 24.7475 73.2085 33.306C73.2188 33.3676 73.2394 33.4293 73.2599 33.4807C73.7325 35.8643 73.938 38.2788 73.8969 40.683C73.8866 41.2583 74.3387 41.7412 74.9243 41.7515H74.9449C75.51 41.7515 75.9826 41.2994 75.9929 40.7241C76.0442 38.1144 75.8079 35.4739 75.2839 32.8847L75.2737 32.8745Z" />
        <path d="M45.478 39.8404H45.4986L45.3136 38.9157C45.026 37.4875 44.204 36.2649 42.9917 35.4635C41.7793 34.6621 40.3306 34.3744 38.9127 34.6621C35.9743 35.258 34.0735 38.1246 34.6592 41.063L34.8544 42.0494H34.8749C35.6044 46.3235 35.5222 50.6181 34.6181 54.8409C34.4948 55.406 34.8544 55.9608 35.4195 56.0841C35.9846 56.2074 36.5394 55.8478 36.6627 55.2827C37.7004 50.4538 37.7209 45.5221 36.7346 40.6418L36.6421 40.1897C36.5394 38.5458 37.6695 37.0355 39.3237 36.7067C40.197 36.532 41.0909 36.7067 41.8409 37.1999C42.4985 37.6314 42.9711 38.2787 43.1971 39.0184L43.2588 39.3267C45.7246 51.5428 42.7245 64.2008 35.0393 74.0334C34.6797 74.4854 34.7619 75.143 35.214 75.5026C35.4092 75.6464 35.6352 75.7286 35.8613 75.7286C36.1695 75.7286 36.4777 75.5951 36.6832 75.3279C44.5533 65.2591 47.7384 52.3751 45.478 39.8404Z"/>
        <path d="M54.0264 38.0321H54.0367L53.8723 37.1998C53.0504 33.1415 50.5023 29.6482 46.8857 27.6242C46.3823 27.3468 45.7453 27.5214 45.4679 28.0249C45.1905 28.5283 45.3651 29.1653 45.8686 29.4427C48.8379 31.0969 50.9647 33.9223 51.7455 37.2101L51.8277 37.6005C54.3244 50.0017 52.177 62.8343 45.7864 73.7354C45.4987 74.2285 45.6631 74.8758 46.1563 75.1635C46.3207 75.256 46.5056 75.3073 46.6803 75.3073C47.0399 75.3073 47.3892 75.1224 47.5844 74.7936C54.0983 63.6871 56.3792 50.6592 54.0367 38.0218L54.0264 38.0321Z" />
        <path d="M58.5368 57.1423C59.6362 50.464 59.554 43.6932 58.28 36.9943L58.1464 36.3265C56.1224 26.309 46.3412 19.8054 36.3237 21.8294C26.3063 23.8535 19.8129 33.6346 21.8266 43.6521L22.0116 44.5665C22.289 46.3645 22.3404 48.1831 22.1452 49.9811C22.0835 50.5565 22.4945 51.0702 23.0698 51.1318C23.6452 51.1935 24.1589 50.7825 24.2206 50.2071C24.4672 47.8954 24.3644 45.5426 23.8918 43.2411L23.7274 42.4295C22.4431 33.8401 28.1248 25.6207 36.7347 23.8843C45.5193 22.1171 54.1086 27.7372 56.0299 36.4498L56.0916 36.758C57.4375 43.4261 57.5608 50.1763 56.4717 56.8135C56.3792 57.3786 56.7594 57.9232 57.3347 58.0156C57.3964 58.0156 57.4478 58.0259 57.5094 58.0259C58.0129 58.0259 58.4546 57.6663 58.5368 57.1526V57.1423Z" />
        <path d="M49.3309 52.1798C48.7556 52.1181 48.2419 52.5291 48.1699 53.0942C47.3069 60.6561 44.5637 67.992 40.2382 74.3107C39.9094 74.7833 40.0327 75.4409 40.5053 75.7594C40.6902 75.8827 40.8957 75.9443 41.0909 75.9443C41.4197 75.9443 41.7485 75.7902 41.954 75.4922C46.4644 68.8961 49.3309 61.2315 50.2351 53.3305C50.2967 52.7551 49.8858 52.2414 49.3207 52.1695L49.3309 52.1798Z" />
        <path d="M56.6051 61.4062C56.0503 61.2624 55.475 61.5911 55.3311 62.146C54.4167 65.5776 53.153 68.9373 51.5913 72.1429C51.3344 72.6566 51.5502 73.2833 52.0742 73.5402C52.218 73.6121 52.3721 73.6429 52.5262 73.6429C52.9167 73.6429 53.2865 73.4272 53.4612 73.0573C55.0845 69.7284 56.3894 66.2454 57.3346 62.6802C57.4887 62.1254 57.1497 61.55 56.5949 61.4062H56.6051Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).UNLOCK]: `<path fillRule="evenodd" clipRule="evenodd" d="M16.8183 40C15.0108 40 13.5456 41.4652 13.5456 43.2727V66.1818C13.5456 67.9893 15.0108 69.4545 16.8183 69.4545H62.6363C64.4438 69.4545 65.909 67.9893 65.909 66.1818V43.2727C65.909 41.4652 64.4438 40 62.6363 40H16.8183ZM7.00012 43.2727C7.00012 37.8503 11.3959 33.4545 16.8183 33.4545H62.6363C68.0587 33.4545 72.4545 37.8503 72.4545 43.2727V66.1818C72.4545 71.6042 68.0587 76 62.6363 76H16.8183C11.3959 76 7.00012 71.6042 7.00012 66.1818V43.2727Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M39.7273 10.5455C36.2554 10.5455 32.9257 11.9247 30.4707 14.3797C28.0156 16.8347 26.6364 20.1644 26.6364 23.6364V36.7273C26.6364 38.5348 25.1712 40 23.3637 40C21.5562 40 20.091 38.5348 20.091 36.7273V23.6364C20.091 18.4285 22.1598 13.4339 25.8423 9.75136C29.5249 6.06883 34.5194 4 39.7273 4C44.9352 4 49.9297 6.06883 53.6123 9.75136C54.8903 11.0294 54.8903 13.1016 53.6123 14.3797C52.3342 15.6578 50.262 15.6578 48.9839 14.3797C46.5289 11.9247 43.1992 10.5455 39.7273 10.5455Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).USER_COG]: `<path fillRule="evenodd" clipRule="evenodd" d="M30.5468 13.6367C25.0488 13.6367 20.5917 18.0937 20.5917 23.5918C20.5917 29.0898 25.0488 33.5468 30.5468 33.5468C36.0448 33.5468 40.5019 29.0898 40.5019 23.5918C40.5019 18.0937 36.0448 13.6367 30.5468 13.6367ZM13.955 23.5918C13.955 14.4284 21.3834 7 30.5468 7C39.7102 7 47.1385 14.4284 47.1385 23.5918C47.1385 32.7551 39.7102 40.1835 30.5468 40.1835C21.3834 40.1835 13.955 32.7551 13.955 23.5918ZM66.1089 34.7022C67.8476 35.2818 68.7872 37.161 68.2076 38.8996L68.0758 39.2952C69.133 40.0432 70.076 40.9419 70.8735 41.96L71.4484 41.73C73.15 41.0494 75.0811 41.877 75.7618 43.5786C76.4424 45.2802 75.6148 47.2114 73.9132 47.8921L73.5278 48.0462C73.6358 48.7278 73.6918 49.4266 73.6918 50.1386C73.6918 50.6333 73.6648 51.1217 73.612 51.6024L73.7288 51.6414C75.4674 52.2209 76.4071 54.1001 75.8275 55.8388C75.248 57.5774 73.3688 58.517 71.6301 57.9375L71.251 57.8111C70.496 58.8751 69.5881 59.8231 68.5595 60.623L68.7932 61.2074C69.4739 62.909 68.6462 64.8402 66.9446 65.5208C65.243 66.2014 63.3119 65.3738 62.6312 63.6722L62.4644 63.2552C61.7975 63.3584 61.1142 63.4119 60.4184 63.4119C59.9196 63.4119 59.4272 63.3844 58.9427 63.3308L58.9098 63.4295C58.3302 65.1681 56.451 66.1078 54.7124 65.5282C52.9737 64.9487 52.0341 63.0694 52.6137 61.3308L52.7359 60.964C51.6875 60.2186 50.7521 59.3248 49.9602 58.3132L49.3626 58.5523C47.661 59.2329 45.7298 58.4052 45.0492 56.7036C44.3685 55.002 45.1962 53.0709 46.8978 52.3902L47.3082 52.226C47.2008 51.546 47.145 50.8488 47.145 50.1386C47.145 49.6545 47.1709 49.1766 47.2214 48.706L47.0808 48.6591C45.3422 48.0795 44.4026 46.2003 44.9821 44.4617C45.5616 42.723 47.4409 41.7834 49.1795 42.3629L49.5674 42.4922C50.3224 41.4227 51.2316 40.4697 52.2626 39.6657L52.0293 39.0827C51.3487 37.3811 52.1764 35.4499 53.878 34.7693C55.5796 34.0886 57.5107 34.9163 58.1914 36.6179L58.3541 37.0247C59.0268 36.9197 59.7163 36.8652 60.4184 36.8652C60.907 36.8652 61.3893 36.8915 61.8642 36.943L61.9115 36.8009C62.491 35.0623 64.3703 34.1227 66.1089 34.7022ZM57.0215 44.4359C57.2394 44.3967 57.4566 44.3351 57.6701 44.2497C57.9643 44.132 58.2323 43.9769 58.471 43.7922C59.0868 43.6034 59.7408 43.5018 60.4184 43.5018C62.8204 43.5018 64.9244 44.7779 66.0894 46.6891C66.1281 46.918 66.1917 47.1464 66.2814 47.3708C66.4059 47.6821 66.5723 47.9642 66.7715 48.2131C66.956 48.8225 67.0551 49.469 67.0551 50.1386C67.0551 52.573 65.7444 54.7012 63.7902 55.8561C63.576 55.8954 63.3625 55.9564 63.1525 56.0404C62.8659 56.155 62.6042 56.3051 62.3702 56.4836C61.7531 56.6732 61.0977 56.7752 60.4184 56.7752C59.604 56.7752 58.8237 56.6285 58.1028 56.3601C58.0224 56.3246 57.94 56.2919 57.8557 56.2624C56.5363 55.7096 55.4332 54.7427 54.7091 53.5243C54.6698 53.3185 54.6103 53.1134 54.5295 52.9115C54.4146 52.6241 54.264 52.3617 54.0848 52.1273C53.8879 51.4994 53.7817 50.8314 53.7817 50.1386C53.7817 47.7146 55.0812 45.5942 57.0215 44.4359ZM8.85961 51.6798C11.9712 48.5683 16.1913 46.8202 20.5918 46.8202H33.8652C35.6978 46.8202 37.1835 48.3059 37.1835 50.1386C37.1835 51.9712 35.6978 53.4569 33.8652 53.4569H20.5918C17.9515 53.4569 15.4194 54.5057 13.5525 56.3727C11.6855 58.2396 10.6367 60.7717 10.6367 63.412V70.0486C10.6367 71.8813 9.15102 73.367 7.31835 73.367C5.48568 73.367 4 71.8813 4 70.0486V63.412C4 59.0115 5.74805 54.7914 8.85961 51.6798Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).USER_NONE]: `<path fillRule="evenodd" clipRule="evenodd" d="M30.1815 13.5454C24.7591 13.5454 20.3634 17.9411 20.3634 23.3634C20.3634 28.7858 24.7591 33.1815 30.1815 33.1815C35.6038 33.1815 39.9995 28.7858 39.9995 23.3634C39.9995 17.9411 35.6038 13.5454 30.1815 13.5454ZM13.8181 23.3634C13.8181 14.3262 21.1442 7 30.1815 7C39.2188 7 46.5449 14.3262 46.5449 23.3634C46.5449 32.4007 39.2188 39.7269 30.1815 39.7269C21.1442 39.7269 13.8181 32.4007 13.8181 23.3634ZM54.0497 24.322C55.3278 23.0439 57.4 23.0439 58.678 24.322L64.5456 30.1896L70.4132 24.322C71.6912 23.0439 73.7634 23.0439 75.0414 24.322C76.3195 25.6 76.3195 27.6722 75.0414 28.9503L69.1739 34.8178L75.0414 40.6854C76.3195 41.9635 76.3195 44.0356 75.0414 45.3137C73.7634 46.5917 71.6912 46.5917 70.4132 45.3137L64.5456 39.4461L58.678 45.3137C57.4 46.5917 55.3278 46.5917 54.0497 45.3137C52.7717 44.0356 52.7717 41.9635 54.0497 40.6854L59.9173 34.8178L54.0497 28.9503C52.7717 27.6722 52.7717 25.6 54.0497 24.322ZM8.79274 51.065C11.8615 47.9962 16.0236 46.2722 20.3634 46.2722H39.9995C44.3394 46.2722 48.5015 47.9962 51.5702 51.065C54.639 54.1337 56.363 58.2958 56.363 62.6357V69.181C56.363 70.9885 54.8977 72.4537 53.0903 72.4537C51.2828 72.4537 49.8176 70.9885 49.8176 69.181V62.6357C49.8176 60.0317 48.7832 57.5345 46.942 55.6932C45.1007 53.852 42.6035 52.8176 39.9995 52.8176H20.3634C17.7595 52.8176 15.2623 53.852 13.421 55.6932C11.5798 57.5345 10.5454 60.0317 10.5454 62.6357V69.181C10.5454 70.9885 9.08014 72.4537 7.27269 72.4537C5.46523 72.4537 4 70.9885 4 69.181V62.6357C4 58.2958 5.724 54.1337 8.79274 51.065Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).USER_PASSKEY]: `<path d="M44.2613 21.3911C44.2611 15.6281 39.5892 10.956 33.8262 10.956C28.0633 10.9562 23.3913 15.6283 23.3911 21.3911C23.3911 27.1541 28.0632 31.826 33.8262 31.8262C39.5893 31.8262 44.2613 27.1543 44.2613 21.3911ZM51.2183 21.3911C51.2183 30.9963 43.4314 38.7833 33.8262 38.7833C24.2211 38.7831 16.4351 30.9962 16.4351 21.3911C16.4353 11.7862 24.2212 4.00018 33.8262 4C43.4313 4 51.2181 11.786 51.2183 21.3911Z" fill="black"/>
      <path d="M63.8011 48.2146C62.3182 48.0471 60.8219 48.3875 59.5577 49.1806C58.2935 49.9738 57.3364 51.173 56.842 52.5812C56.3475 53.9894 56.3459 55.5241 56.8369 56.9336C57.1438 57.8154 56.9193 58.7954 56.2591 59.4557L46.7962 68.9186C46.7319 68.9828 46.6953 69.0703 46.6953 69.1612V71.13H48.769V70.7876C48.7691 69.7736 49.172 68.801 49.889 68.084C50.6059 67.367 51.5786 66.9642 52.5925 66.9641H52.9349V66.6217C52.9349 65.6078 53.338 64.6352 54.0549 63.9181L54.1924 63.7877C54.8939 63.1524 55.8086 62.7982 56.7594 62.7982H56.9969C57.0877 62.7982 57.1752 62.7616 57.2394 62.6973L58.3705 61.5672L58.4979 61.448C59.153 60.8805 60.066 60.7014 60.8927 60.9894C62.3021 61.4804 63.8368 61.4787 65.2451 60.9843C66.6532 60.4899 67.8515 59.5317 68.6446 58.2675C69.4377 57.0032 69.7783 55.5072 69.6107 54.0242C69.443 52.5413 68.7775 51.1591 67.7224 50.1039C66.667 49.0485 65.2841 48.3822 63.8011 48.2146ZM57.805 68.0106C57.8049 69.0246 57.402 69.9972 56.685 70.7142C55.968 71.4311 54.9955 71.8341 53.9815 71.8341H53.6391V72.1765C53.6391 73.1906 53.2362 74.163 52.5192 74.8801C51.8021 75.5971 50.8296 76 49.8156 76H45.6497C44.6357 76 43.6632 75.597 42.9462 74.8801C42.2291 74.163 41.8263 73.1906 41.8263 72.1765V69.1601L41.8324 68.9013C41.8965 67.6131 42.4363 66.3904 43.3528 65.4742L51.8221 57.0049C51.4225 55.0002 51.5635 52.9149 52.2471 50.968C53.1067 48.5195 54.7721 46.4347 56.9704 45.0555C59.1686 43.6765 61.7698 43.0847 64.3483 43.3761C66.927 43.6676 69.3307 44.8255 71.1657 46.6605C73.0007 48.4955 74.1587 50.8994 74.4501 53.478C74.7415 56.0565 74.1488 58.6577 72.7697 60.8559C71.3906 63.054 69.3066 64.7195 66.8582 65.5792C64.911 66.2628 62.8254 66.4019 60.8203 66.0021L60.6838 66.1407C59.8988 66.9259 58.8883 67.433 57.805 67.603V68.0106Z" fill="black"/>
      <path d="M6 70.0885V63.1314C6.00009 58.519 7.8317 54.095 11.0932 50.8335C14.3547 47.572 18.7786 45.7404 23.3911 45.7403H45.3048C47.2258 45.7403 48.7838 47.2973 48.7838 49.2183C48.7838 51.1394 47.2258 52.6964 45.3048 52.6964H23.3911C20.6237 52.6964 17.9701 53.7966 16.0132 55.7535C14.0563 57.7104 12.9561 60.364 12.956 63.1314V70.0885C12.956 72.0095 11.3991 73.5665 9.47802 73.5665C7.55697 73.5665 6 72.0095 6 70.0885Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).USER_PLUS]: `<path fillRule="evenodd" clipRule="evenodd" d="M30.1818 13.5455C24.7594 13.5455 20.3636 17.9412 20.3636 23.3636C20.3636 28.7861 24.7594 33.1818 30.1818 33.1818C35.6042 33.1818 40 28.7861 40 23.3636C40 17.9412 35.6043 13.5455 30.1818 13.5455ZM13.8182 23.3636C13.8182 14.3262 21.1444 7 30.1818 7C39.2192 7 46.5455 14.3262 46.5455 23.3636C46.5455 32.401 39.2192 39.7273 30.1818 39.7273C21.1444 39.7273 13.8182 32.401 13.8182 23.3636ZM62.9091 23.3636C64.7166 23.3636 66.1818 24.8289 66.1818 26.6364V33.1818H72.7273C74.5347 33.1818 76 34.6471 76 36.4545C76 38.262 74.5347 39.7273 72.7273 39.7273H66.1818V46.2727C66.1818 48.0802 64.7166 49.5455 62.9091 49.5455C61.1016 49.5455 59.6364 48.0802 59.6364 46.2727V39.7273H53.0909C51.2834 39.7273 49.8182 38.262 49.8182 36.4545C49.8182 34.6471 51.2834 33.1818 53.0909 33.1818H59.6364V26.6364C59.6364 24.8289 61.1016 23.3636 62.9091 23.3636ZM8.7928 51.0655C11.8616 47.9968 16.0237 46.2727 20.3636 46.2727H40C44.3399 46.2727 48.5021 47.9968 51.5708 51.0655C54.6396 54.1343 56.3636 58.2965 56.3636 62.6364V69.1818C56.3636 70.9893 54.8984 72.4545 53.0909 72.4545C51.2834 72.4545 49.8182 70.9893 49.8182 69.1818V62.6364C49.8182 60.0324 48.7838 57.5351 46.9425 55.6939C45.1012 53.8526 42.6039 52.8182 40 52.8182H20.3636C17.7597 52.8182 15.2624 53.8526 13.4211 55.6939C11.5799 57.5351 10.5455 60.0324 10.5455 62.6364V69.1818C10.5455 70.9893 9.0802 72.4545 7.27273 72.4545C5.46525 72.4545 4 70.9893 4 69.1818V62.6364C4 58.2965 5.72402 54.1343 8.7928 51.0655Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).USER_SEARCH]: `<path d="M67.1458 58.86C67.1458 55.0738 64.0772 52.007 60.2913 52.0055C56.5042 52.0055 53.4288 55.0729 53.4288 58.86C53.4288 62.6471 56.5042 65.7145 60.2913 65.7145C61.9406 65.7139 63.4479 65.1264 64.6306 64.1556C64.7537 63.9713 64.9018 63.7959 65.0645 63.6333C65.227 63.4711 65.4029 63.3302 65.5868 63.2074C66.5591 62.0238 67.1458 60.5113 67.1458 58.86ZM46.5743 24.5715C46.5728 16.9985 40.4306 10.8625 32.8573 10.8625C25.2852 10.864 19.1497 16.9994 19.1483 24.5715C19.1483 32.1448 25.2843 38.2871 32.8573 38.2885C40.4315 38.2885 46.5743 32.1457 46.5743 24.5715ZM74.0003 58.86C74.0003 61.4015 73.2926 63.7702 72.0878 65.8109L76.4271 70.1502C77.7648 71.4885 77.7637 73.6568 76.4271 74.9958C75.0881 76.3347 72.9124 76.3347 71.5735 74.9958L67.2422 70.6645C65.2023 71.8688 62.8316 72.5766 60.2913 72.577C52.7171 72.577 46.5743 66.4342 46.5743 58.86C46.5743 51.2858 52.7171 45.143 60.2913 45.143C67.8643 45.1445 74.0003 51.2867 74.0003 58.86ZM53.4288 24.5715C53.4288 31.6841 49.8196 37.953 44.3323 41.6475C44.6568 42.3857 44.7335 43.2377 44.4689 44.0662C43.8917 45.8683 41.9646 46.8599 40.1617 46.2841C36.564 45.1352 32.7442 44.8517 29.0162 45.4564C25.289 46.0611 21.7559 47.537 18.7063 49.7636C15.656 51.9912 13.1769 54.914 11.4661 58.2814C9.75579 61.6483 8.86305 65.3694 8.86252 69.1458C8.86235 71.0392 7.32467 72.577 5.43126 72.577C3.53771 72.5769 1.99983 71.0393 2 69.1458C2.00053 64.2896 3.15139 59.5011 5.35091 55.1716C7.55047 50.8427 10.743 47.0907 14.6643 44.2269C16.46 42.9159 18.3895 41.8154 20.4099 40.9242C15.4819 37.166 12.2858 31.2475 12.2858 24.5715C12.2872 13.2123 21.4981 4.00145 32.8573 4C44.2177 4 53.4273 13.2114 53.4288 24.5715Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).USERS]: `<path fillRule="evenodd" clipRule="evenodd" d="M30.1821 13.5455C24.7596 13.5455 20.3639 17.9412 20.3639 23.3637C20.3639 28.7861 24.7596 33.1819 30.1821 33.1819C35.6045 33.1819 40.0002 28.7861 40.0002 23.3637C40.0002 17.9412 35.6045 13.5455 30.1821 13.5455ZM13.8184 23.3637C13.8184 14.3263 21.1447 7 30.1821 7C39.2194 7 46.5457 14.3263 46.5457 23.3637C46.5457 32.4011 39.2194 39.7274 30.1821 39.7274C21.1447 39.7274 13.8184 32.4011 13.8184 23.3637ZM49.9207 9.88642C50.369 8.13543 52.1519 7.0794 53.9029 7.52773C57.4228 8.42896 60.5426 10.4761 62.7705 13.3463C64.9984 16.2165 66.2077 19.7466 66.2077 23.38C66.2077 27.0135 64.9984 30.5436 62.7705 33.4138C60.5426 36.284 57.4228 38.3311 53.9029 39.2324C52.1519 39.6807 50.369 38.6247 49.9207 36.8737C49.4724 35.1227 50.5284 33.3398 52.2794 32.8914C54.3913 32.3507 56.2632 31.1224 57.6 29.4003C58.9367 27.6782 59.6623 25.5601 59.6623 23.38C59.6623 21.2 58.9367 19.0819 57.6 17.3598C56.2632 15.6377 54.3913 14.4094 52.2794 13.8687C50.5284 13.4203 49.4724 11.6374 49.9207 9.88642ZM8.79304 51.0656C11.8618 47.9969 16.024 46.2728 20.3639 46.2728H40.0002C44.3402 46.2728 48.5023 47.9969 51.5711 51.0656C54.6399 54.1344 56.3639 58.2966 56.3639 62.6365V69.182C56.3639 70.9895 54.8986 72.4547 53.0912 72.4547C51.2837 72.4547 49.8184 70.9895 49.8184 69.182V62.6365C49.8184 60.0326 48.784 57.5353 46.9427 55.694C45.1015 53.8527 42.6042 52.8183 40.0002 52.8183H20.3639C17.7599 52.8183 15.2626 53.8527 13.4214 55.694C11.5801 57.5353 10.5457 60.0326 10.5457 62.6365V69.182C10.5457 70.9895 9.08045 72.4547 7.27297 72.4547C5.46549 72.4547 4.00024 70.9895 4.00024 69.182V62.6365C4.00024 58.2966 5.72427 54.1344 8.79304 51.0656ZM59.7405 49.1528C60.1924 47.4028 61.9774 46.3503 63.7275 46.8022C67.238 47.7086 70.3481 49.7553 72.5695 52.6208C74.7908 55.4863 75.9975 59.0084 76.0002 62.6341V69.182C76.0002 70.9895 74.535 72.4547 72.7275 72.4547C70.92 72.4547 69.4548 70.9895 69.4548 69.182V62.639C69.4532 60.4635 68.7291 58.3503 67.3963 56.631C66.0635 54.9117 64.1975 53.6837 62.0911 53.1398C60.3411 52.688 59.2887 50.9029 59.7405 49.1528Z"/>`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).VIDEO]: `<path fillRule="evenodd" clipRule="evenodd" d="M14.8648 11.7143C13.1251 11.7143 11.7148 13.1246 11.7148 14.8643V65.1357C11.7148 66.8754 13.1251 68.2857 14.8648 68.2857H65.1362C66.8759 68.2857 68.2862 66.8754 68.2862 65.1357V14.8643C68.2862 13.1246 66.8759 11.7143 65.1362 11.7143H14.8648ZM4.00051 14.8643C4.00051 8.86411 8.86462 4 14.8648 4H65.1362C71.1364 4 76.0005 8.86411 76.0005 14.8643V65.1357C76.0005 71.1359 71.1364 76 65.1362 76H14.8648C8.86462 76 4.00051 71.1359 4.00051 65.1357V14.8643Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M23.9272 4C26.0574 4 27.7843 5.7269 27.7843 7.85714V72.1429C27.7843 74.2731 26.0574 76 23.9272 76C21.797 76 20.0701 74.2731 20.0701 72.1429V7.85714C20.0701 5.7269 21.797 4 23.9272 4Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M56.0732 4C58.2034 4 59.9303 5.7269 59.9303 7.85714V72.1429C59.9303 74.2731 58.2034 76 56.0732 76C53.9429 76 52.216 74.2731 52.216 72.1429V7.85714C52.216 5.7269 53.9429 4 56.0732 4Z"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M4.0002 40.0031C4.0002 37.8729 5.7271 36.146 7.85734 36.146H72.143C74.2733 36.146 76.0002 37.8729 76.0002 40.0031C76.0002 42.1334 74.2733 43.8603 72.143 43.8603H7.85734C5.7271 43.8603 4.0002 42.1334 4.0002 40.0031Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M4.00051 23.9336C4.00051 21.8034 5.72741 20.0765 7.85765 20.0765H23.9291C26.0593 20.0765 27.7862 21.8034 27.7862 23.9336C27.7862 26.0638 26.0593 27.7907 23.9291 27.7907H7.85765C5.72741 27.7907 4.00051 26.0638 4.00051 23.9336Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M4.00051 56.0727C4.00051 53.9424 5.72741 52.2155 7.85765 52.2155H23.9291C26.0593 52.2155 27.7862 53.9424 27.7862 56.0727C27.7862 58.2029 26.0593 59.9298 23.9291 59.9298H7.85765C5.72741 59.9298 4.00051 58.2029 4.00051 56.0727Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M52.216 56.0727C52.216 53.9424 53.9429 52.2155 56.0732 52.2155H72.1446C74.2749 52.2155 76.0018 53.9424 76.0018 56.0727C76.0018 58.2029 74.2749 59.9298 72.1446 59.9298H56.0732C53.9429 59.9298 52.216 58.2029 52.216 56.0727Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M52.216 23.9336C52.216 21.8034 53.9429 20.0765 56.0732 20.0765H72.1446C74.2749 20.0765 76.0018 21.8034 76.0018 23.9336C76.0018 26.0638 74.2749 27.7907 72.1446 27.7907H56.0732C53.9429 27.7907 52.216 26.0638 52.216 23.9336Z" />
        `,
    [(0, $99899ff752f57db8$export$356109f9df11377f).WARNING]: `<path fillRule="evenodd" clipRule="evenodd" d="M34.6586 8.35983C36.187 7.46923 37.9243 7 39.6932 7C41.4622 7 43.1995 7.46923 44.7278 8.35983C46.2546 9.24949 47.5184 10.5278 48.3905 12.0646C48.3914 12.0662 48.3923 12.0679 48.3932 12.0695L75.0466 58.713C75.048 58.7154 75.0494 58.7177 75.0507 58.7201C75.9253 60.2378 76.3859 61.9587 76.3864 63.7104C76.3868 65.4649 75.9257 67.1887 75.0492 68.7085C74.1727 70.2284 72.9118 71.491 71.3931 72.3694C69.8743 73.2478 68.1511 73.7112 66.3966 73.713H13.0736C11.3162 73.7259 9.58637 73.2755 8.05836 72.407C6.52563 71.5358 5.25046 70.2748 4.36212 68.752C3.47378 67.2291 3.00384 65.4984 2.99993 63.7354C2.99604 61.9751 3.45684 60.2451 4.33572 58.7201C4.33711 58.7177 4.3385 58.7153 4.33989 58.7129L30.9932 12.0695C30.9943 12.0675 30.9954 12.0656 30.9965 12.0636C31.8686 10.5273 33.1321 9.24929 34.6586 8.35983ZM39.6932 13.6667C39.1036 13.6667 38.5245 13.8231 38.015 14.1199C37.5056 14.4168 37.084 14.8435 36.7932 15.3565L36.7874 15.3668L10.1207 62.0335L10.1132 62.0465C9.81937 62.5554 9.66528 63.133 9.66658 63.7206C9.66788 64.3083 9.82453 64.8852 10.1206 65.3928C10.4168 65.9004 10.8418 66.3208 11.3527 66.6112C11.8636 66.9016 12.4423 67.0517 13.0299 67.0465L13.0599 67.0463H66.3898C66.9746 67.0457 67.549 66.8913 68.0553 66.5985C68.5615 66.3057 68.9818 65.8848 69.274 65.3782C69.5662 64.8715 69.7199 64.297 69.7197 63.7121C69.7196 63.1273 69.5656 62.5528 69.2731 62.0463L69.2658 62.0335L42.5991 15.3668L42.5932 15.3565C42.3025 14.8435 41.8809 14.4168 41.3714 14.1199C40.862 13.8231 40.2829 13.6667 39.6932 13.6667ZM39.7266 27.0463C41.5675 27.0463 43.0599 28.5387 43.0599 30.3797V43.713C43.0599 45.5539 41.5675 47.0463 39.7266 47.0463C37.8856 47.0463 36.3932 45.5539 36.3932 43.713V30.3797C36.3932 28.5387 37.8856 27.0463 39.7266 27.0463ZM36.3932 57.0463C36.3932 55.2054 37.8856 53.713 39.7266 53.713H39.7599C41.6008 53.713 43.0932 55.2054 43.0932 57.0463C43.0932 58.8873 41.6008 60.3797 39.7599 60.3797H39.7266C37.8856 60.3797 36.3932 58.8873 36.3932 57.0463Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).WARNING_BADGE]: `<path fillRule="evenodd" clipRule="evenodd" d="M40.0961 10.6716C34.0444 15.9508 25.1395 20.3626 17.5445 20.3626V43.2682C17.5445 50.5847 20.0667 55.9024 24.0456 59.9775C28.1135 64.1438 33.8524 67.1547 40.4383 69.4289L40.5122 69.4555C47.0734 67.1658 52.7963 64.1495 56.8566 59.9836C60.8335 55.9035 63.3557 50.5845 63.3557 43.2682V20.3626C55.7632 20.3626 46.8911 15.9858 40.8037 10.6714C40.7042 10.5894 40.5792 10.5445 40.4501 10.5445C40.3208 10.5445 40.1956 10.5895 40.0961 10.6716ZM35.8376 5.70205C37.1234 4.60355 38.759 4 40.4501 4C42.1412 4 43.7768 4.60355 45.0625 5.70205L45.0909 5.72629L45.0907 5.72645C50.4556 10.4169 57.8678 13.8182 63.3557 13.8182C65.0914 13.8182 66.756 14.5077 67.9833 15.735C69.2106 16.9623 69.9001 18.6269 69.9001 20.3626V43.2682C69.9001 52.313 66.6959 59.265 61.5432 64.5515C56.4796 69.7468 49.6798 73.1907 42.6396 75.6446L42.6128 75.6539L42.6128 75.6538C41.2017 76.132 39.6701 76.1142 38.2711 75.6042C31.2229 73.1671 24.4253 69.7342 19.363 64.5495C14.2042 59.266 11 52.3129 11 43.2682V20.3626C11 18.6269 11.6895 16.9623 12.9168 15.735C14.1442 14.5077 15.8088 13.8182 17.5445 13.8182C23.03 13.8182 30.475 10.3863 35.8104 5.72557L35.8375 5.7019L35.8376 5.70205ZM40.4501 23.6348C42.2573 23.6348 43.7223 25.0999 43.7223 26.9071V39.996C43.7223 41.8032 42.2573 43.2682 40.4501 43.2682C38.6429 43.2682 37.1778 41.8032 37.1778 39.996V26.9071C37.1778 25.0999 38.6429 23.6348 40.4501 23.6348ZM37.1778 53.0849C37.1778 51.2777 38.6429 49.8127 40.4501 49.8127H40.4828C42.29 49.8127 43.755 51.2777 43.755 53.0849C43.755 54.8921 42.29 56.3571 40.4828 56.3571H40.4501C38.6429 56.3571 37.1778 54.8921 37.1778 53.0849Z" />`,
    [(0, $99899ff752f57db8$export$356109f9df11377f).WEBPAGE]: `<path fillRule="evenodd" clipRule="evenodd" d="M4 16.55C4 11.828 7.82796 8 12.55 8H67.45C72.172 8 76 11.828 76 16.55V63.35C76 68.072 72.172 71.9 67.45 71.9H12.55C7.82797 71.9 4 68.072 4 63.35V16.55ZM12.55 14.3C11.3074 14.3 10.3 15.3074 10.3 16.55V26.1029H69.7V16.55C69.7 15.3074 68.6926 14.3 67.45 14.3H12.55ZM69.7 32.4029H30.707V65.6H67.45C68.6926 65.6 69.7 64.5926 69.7 63.35V32.4029ZM24.407 65.6V32.4029H10.3V63.35C10.3 64.5926 11.3074 65.6 12.55 65.6H24.407Z" />`
};


const $d17de690eab2b398$var$Icon = ({ iconName: iconName, className: className = "", color: color = "black", sizeInPx: sizeInPx = "24" })=>{
    //certain icons contain a number of paths.
    //each path will require styling applied to it
    const paths = (0, $ac411418a6b9347a$export$66f32c9c70bb3715)(iconName);
    const pathElements = (0, $ac411418a6b9347a$export$a6898a2c052ba3c8)(paths?.paths || paths);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        "data-testid": "thrive-icon",
        className: `thrive-icon ${className ?? ""}`,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fillRule: "evenodd",
            viewBox: "0 0 80 80",
            width: `${sizeInPx}px`,
            height: `${sizeInPx}px`,
            "aria-hidden": true,
            children: pathElements.map((pathElement, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                    d: pathElement,
                    fill: color
                }, index))
        })
    });
};
var $d17de690eab2b398$export$2e2bcd8739ae039 = $d17de690eab2b398$var$Icon;


const $16ff9019b7cd6544$var$CommentButton = ({ isDisabled: isDisabled, ariaLabel: ariaLabel, onButtonClick: onButtonClick, includeText: includeText, isActive: isActive, isReply: isReply, buttonText: buttonText })=>{
    const text = isReply ? "Reply" : "Comment";
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
        className: `social-comment-button`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: isActive ? (0, $99899ff752f57db8$export$356109f9df11377f).COMMENT_ACTIVE : (0, $99899ff752f57db8$export$356109f9df11377f).COMMENT,
                sizeInPx: "12"
            }),
            includeText && (buttonText ?? text)
        ]
    });
};
var $16ff9019b7cd6544$export$2e2bcd8739ae039 = $16ff9019b7cd6544$var$CommentButton;



parcelRequire("aqdBs");


const $e7c83e8ff916283f$var$CommentsButton = ({ isDisabled: isDisabled, ariaLabel: ariaLabel, onButtonClick: onButtonClick, includeText: includeText, isActive: isActive, numberOfComments: numberOfComments, buttonText: buttonText, isReply: isReply })=>{
    const text = isReply ? numberOfComments === 1 ? `1 reply` : `${numberOfComments} replies` : numberOfComments === 1 ? `1 comment` : `${numberOfComments} comments`;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
        className: `social-comments-button`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: isActive ? (0, $99899ff752f57db8$export$356109f9df11377f).COMMENT_ACTIVE : (0, $99899ff752f57db8$export$356109f9df11377f).COMMENT,
                sizeInPx: "12"
            }),
            includeText && (buttonText ?? text)
        ]
    });
};
var $e7c83e8ff916283f$export$2e2bcd8739ae039 = $e7c83e8ff916283f$var$CommentsButton;



parcelRequire("aqdBs");


const $213c5c1d133f2051$var$LikeButton = ({ isDisabled: isDisabled, ariaLabel: ariaLabel, onButtonClick: onButtonClick, includeText: includeText, isActive: isActive, colour: colour, className: className, buttonText: buttonText })=>{
    const text = isActive ? "Liked" : "Like";
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
        className: `social-like-button ${className ?? ""}`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: isActive ? (0, $99899ff752f57db8$export$356109f9df11377f).LIKE_ACTIVE : (0, $99899ff752f57db8$export$356109f9df11377f).LIKE,
                sizeInPx: "12",
                color: colour
            }),
            includeText && (buttonText ?? text)
        ]
    });
};
var $213c5c1d133f2051$export$2e2bcd8739ae039 = $213c5c1d133f2051$var$LikeButton;



parcelRequire("aqdBs");


const $9d2208c2b156e79d$var$LikesButton = ({ isDisabled: isDisabled, ariaLabel: ariaLabel, onButtonClick: onButtonClick, includeText: includeText, isActive: isActive, numberOfLikes: numberOfLikes, buttonText: buttonText })=>{
    const text = numberOfLikes === 1 ? `1 like` : `${numberOfLikes} likes`;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
        className: `social-likes-button`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: isActive ? (0, $99899ff752f57db8$export$356109f9df11377f).LIKE_ACTIVE : (0, $99899ff752f57db8$export$356109f9df11377f).LIKE,
                sizeInPx: "12"
            }),
            includeText && (buttonText ?? text)
        ]
    });
};
var $9d2208c2b156e79d$export$2e2bcd8739ae039 = $9d2208c2b156e79d$var$LikesButton;



parcelRequire("aqdBs");
const $47d3a6358e9b885d$var$BoldTextButton = ({ isDisabled: isDisabled, ariaLabel: ariaLabel, onButtonClick: onButtonClick, link: link, text: text, openInNewTab: openInNewTab = true })=>{
    if (link) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("a", {
        className: `bold-text-button ${isDisabled ? 'disabled' : ''}`,
        "aria-label": ariaLabel,
        href: isDisabled ? undefined : link,
        target: openInNewTab ? "_blank" : undefined,
        rel: "noopener noreferrer",
        onClick: (e)=>isDisabled && e.preventDefault(),
        children: text
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `bold-text-button`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        type: "button",
        children: text
    });
};
var $47d3a6358e9b885d$export$2e2bcd8739ae039 = $47d3a6358e9b885d$var$BoldTextButton;



parcelRequire("aqdBs");
const $77c3c92fda4f2fa4$var$BasicButton = ({ content: content, ariaLabel: ariaLabel, className: className, isClassicThriveStyle: isClassicThriveStyle = false, isDisabled: isDisabled = false, onButtonClick: onButtonClick, isLink: isLink, linkUrl: linkUrl, openInNewTab: openInNewTab = false })=>{
    if (isLink) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("a", {
        className: `basic-button ${isClassicThriveStyle && 'classic-style-button'} ${className ?? ""} ${isDisabled && "disabled-style-link"}`,
        "aria-label": ariaLabel,
        href: linkUrl,
        target: openInNewTab ? "_blank" : undefined,
        rel: openInNewTab ? "noopener noreferrer" : undefined,
        children: content
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `basic-button ${isClassicThriveStyle && 'classic-style-button'} ${className ?? ""}`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        type: 'button',
        children: content
    });
};
var $77c3c92fda4f2fa4$export$2e2bcd8739ae039 = $77c3c92fda4f2fa4$var$BasicButton;



parcelRequire("aqdBs");


const $92422dd4a3678f16$var$MenuButton = ({ isDisabled: isDisabled, ariaLabel: ariaLabel, onButtonClick: onButtonClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `menu-button`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).MENU_MORE,
            sizeInPx: "12",
            color: "var(--thriveLightSlate)"
        })
    });
};
var $92422dd4a3678f16$export$2e2bcd8739ae039 = $92422dd4a3678f16$var$MenuButton;



parcelRequire("aqdBs");
const $a25bbe6803f2a647$var$PanelButton = ({ content: content, ariaLabel: ariaLabel, className: className, isDisabled: isDisabled = false, onButtonClick: onButtonClick })=>{
    if (!content) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `panel-button ${className ?? ""}`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        type: 'button',
        children: content
    });
};
var $a25bbe6803f2a647$export$2e2bcd8739ae039 = $a25bbe6803f2a647$var$PanelButton;



parcelRequire("aqdBs");

const $6fdd0991e8159fdf$var$IconButton = ({ ariaLabel: ariaLabel, className: className, isDisabled: isDisabled = false, onButtonClick: onButtonClick, iconName: iconName, parentRef: parentRef })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `icon-button ${className ?? ""}`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        type: 'button',
        ref: parentRef,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
            iconName: iconName,
            sizeInPx: "12",
            color: "var(--thriveCharcoal)"
        })
    });
};
var $6fdd0991e8159fdf$export$2e2bcd8739ae039 = $6fdd0991e8159fdf$var$IconButton;



parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");
const $18b395e50fc09130$var$BasicToolTip = ({ children: children, className: className, text: text })=>{
    const [visible, setVisible] = (0, $aqdBs.useState)(false);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
        className: `basic-tooltip-wrapper ${className ?? ""}`,
        onMouseEnter: ()=>setVisible(true),
        onMouseLeave: ()=>setVisible(false),
        children: [
            children,
            visible && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "basic-tooltip",
                children: text
            })
        ]
    });
};
var $18b395e50fc09130$export$2e2bcd8739ae039 = $18b395e50fc09130$var$BasicToolTip;



const $dc304fc67c196f10$var$IconButtonWithTooltip = ({ ariaLabel: ariaLabel, className: className, isDisabled: isDisabled = false, onButtonClick: onButtonClick, iconName: iconName, tooltipText: tooltipText })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: `app-icon-tooltip-wrapper`,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $18b395e50fc09130$export$2e2bcd8739ae039), {
            text: tooltipText,
            className: className,
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6fdd0991e8159fdf$export$2e2bcd8739ae039), {
                ariaLabel: ariaLabel,
                iconName: iconName,
                isDisabled: isDisabled,
                onButtonClick: onButtonClick
            })
        })
    });
};
var $dc304fc67c196f10$export$2e2bcd8739ae039 = $dc304fc67c196f10$var$IconButtonWithTooltip;



parcelRequire("aqdBs");


const $3de1f4d816bebd2d$var$FilterStyleButton = ({ className: className, isDisabled: isDisabled, ariaLabel: ariaLabel, onButtonClick: onButtonClick, content: content })=>{
    const defaultContent = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            "Filter ",
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).FILTERS,
                color: "var(--thriveSky)",
                sizeInPx: "16"
            })
        ]
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `filter-style-button ${className ?? ""}`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        children: content ?? defaultContent
    });
};
var $3de1f4d816bebd2d$export$2e2bcd8739ae039 = $3de1f4d816bebd2d$var$FilterStyleButton;



parcelRequire("aqdBs");

const $7dd2fa8764b346f3$var$CancelConfirmPanel = ({ cancelContent: cancelContent, confirmContent: confirmContent, ariaLabelCancel: ariaLabelCancel, ariaLabelConfirm: ariaLabelConfirm, panelClassName: panelClassName, confirmIsDisabled: confirmIsDisabled = false, onCancelClick: onCancelClick, onConfirmClick: onConfirmClick, confirmLinkUrl: confirmLinkUrl, cancelLinkUrl: cancelLinkUrl })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `cancel-confirm-panel ${panelClassName ?? ""}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                className: "button-panel-cancel cancel-button-style",
                content: cancelContent,
                ariaLabel: ariaLabelCancel,
                isLink: cancelLinkUrl !== undefined,
                linkUrl: cancelLinkUrl ?? undefined,
                onButtonClick: onCancelClick ?? undefined
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                className: "button-panel-confirm thrive-navy-style",
                content: confirmContent,
                ariaLabel: ariaLabelConfirm,
                isDisabled: confirmIsDisabled,
                isLink: confirmLinkUrl !== undefined,
                linkUrl: confirmLinkUrl ?? undefined,
                onButtonClick: onConfirmClick ?? undefined
            })
        ]
    });
};
var $7dd2fa8764b346f3$export$2e2bcd8739ae039 = $7dd2fa8764b346f3$var$CancelConfirmPanel;



parcelRequire("aqdBs");


const $6c765ca802f88a49$var$CloseButton = ({ ariaLabel: ariaLabel, onButtonClick: onButtonClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: "close-button",
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        type: 'button',
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CLOSE,
            sizeInPx: "10",
            color: "var(--thriveLightSlate)"
        })
    });
};
var $6c765ca802f88a49$export$2e2bcd8739ae039 = $6c765ca802f88a49$var$CloseButton;



parcelRequire("aqdBs");


const $2e2ff2c6a2668ac8$var$DismissablePillButton = ({ className: className, isDisabled: isDisabled, ariaLabel: ariaLabel, onButtonClick: onButtonClick, content: content })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
        className: `dismissable-pill-style-button ${className ?? ""}`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                children: content
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "icon-wrapper",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CLOSE,
                    color: "var(--thriveGreyLight)",
                    sizeInPx: "6"
                })
            })
        ]
    });
};
var $2e2ff2c6a2668ac8$export$2e2bcd8739ae039 = $2e2ff2c6a2668ac8$var$DismissablePillButton;




var $aqdBs = parcelRequire("aqdBs");

var $152ced39134e6095$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["UP"] = "UP";
    Direction["DOWN"] = "DOWN";
    Direction["BOTH"] = "BOTH";
    return Direction;
}({});



parcelRequire("aqdBs");

function $20d1bcaabc3da16f$export$a339b9dfcf153d0e(direction) {
    if (direction === (0, $152ced39134e6095$export$cacd6541cfeeb6c1).DOWN) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.29289 14.2929C6.68342 13.9024 7.31658 13.9024 7.70711 14.2929L12 18.5858L16.2929 14.2929C16.6834 13.9024 17.3166 13.9024 17.7071 14.2929C18.0976 14.6834 18.0976 15.3166 17.7071 15.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L6.29289 15.7071C5.90237 15.3166 5.90237 14.6834 6.29289 14.2929Z",
                fill: "#343D4C"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                opacity: "0.4",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711C17.3166 10.0976 16.6834 10.0976 16.2929 9.70711L12 5.41421L7.70711 9.70711C7.31658 10.0976 6.68342 10.0976 6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289L11.2929 3.29289Z",
                fill: "#343D4C"
            })
        ]
    });
    else if (direction === (0, $152ced39134e6095$export$cacd6541cfeeb6c1).UP) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                opacity: "0.4",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.29289 14.2929C6.68342 13.9024 7.31658 13.9024 7.70711 14.2929L12 18.5858L16.2929 14.2929C16.6834 13.9024 17.3166 13.9024 17.7071 14.2929C18.0976 14.6834 18.0976 15.3166 17.7071 15.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L6.29289 15.7071C5.90237 15.3166 5.90237 14.6834 6.29289 14.2929Z",
                fill: "#343D4C"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711C17.3166 10.0976 16.6834 10.0976 16.2929 9.70711L12 5.41421L7.70711 9.70711C7.31658 10.0976 6.68342 10.0976 6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289L11.2929 3.29289Z",
                fill: "#343D4C"
            })
        ]
    });
    else return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                opacity: "0.4",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.29289 14.2929C6.68342 13.9024 7.31658 13.9024 7.70711 14.2929L12 18.5858L16.2929 14.2929C16.6834 13.9024 17.3166 13.9024 17.7071 14.2929C18.0976 14.6834 18.0976 15.3166 17.7071 15.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L6.29289 15.7071C5.90237 15.3166 5.90237 14.6834 6.29289 14.2929Z",
                fill: "#343D4C"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                opacity: "0.4",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711C17.3166 10.0976 16.6834 10.0976 16.2929 9.70711L12 5.41421L7.70711 9.70711C7.31658 10.0976 6.68342 10.0976 6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289L11.2929 3.29289Z",
                fill: "#343D4C"
            })
        ]
    });
}



var $aqdBs = parcelRequire("aqdBs");
const $006deecf5b91ed7a$export$40bf77e055859e12 = (elementShowing, ref, onHideElement)=>{
    (0, $aqdBs.useEffect)(()=>{
        const handleMouseDown = (event)=>{
            if (elementShowing && ref.current && !ref.current.contains(event.target)) onHideElement();
        };
        document.addEventListener("click", handleMouseDown);
        return ()=>{
            document.removeEventListener("click", handleMouseDown);
        };
    }, [
        elementShowing
    ]);
};


const $e0ba5d8cacf44ce0$var$ToggleSelectButton = ({ selectedItem: selectedItem, defaultTitle: defaultTitle, className: className, ariaLabel: ariaLabel, toggleDisabled: toggleDisabled = false, buttonList: buttonList })=>{
    const ref = (0, $aqdBs.useRef)(null);
    const [showToggleList, setShowToggleList] = (0, $aqdBs.useState)(false);
    (0, $006deecf5b91ed7a$export$40bf77e055859e12)(showToggleList, ref, ()=>{
        setShowToggleList(false);
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: 'toggle-select-container',
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                    className: "toggle-select-button-content",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "toggle-select-label",
                            children: selectedItem?.text || defaultTitle || ""
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "toggle-select-icon",
                            children: (0, $20d1bcaabc3da16f$export$a339b9dfcf153d0e)((0, $152ced39134e6095$export$cacd6541cfeeb6c1).BOTH)
                        })
                    ]
                }),
                ariaLabel: ariaLabel,
                className: `toggle-select-button ${className ?? ""}`,
                isDisabled: toggleDisabled || !buttonList || !buttonList?.length,
                onButtonClick: ()=>setShowToggleList(!showToggleList)
            }),
            showToggleList && buttonList && buttonList.length > 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: `toggle-select-button-list ${buttonList.length === 1 ? "single-button" : ""}`,
                children: buttonList?.map((button, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                        className: `toggle-select-button-list-item ${button.id === selectedItem?.id ? "toggle-select-button-selected" : ""} `,
                        content: button.text,
                        ariaLabel: button.label,
                        isDisabled: button.isDisabled,
                        onButtonClick: ()=>{
                            setShowToggleList(!showToggleList);
                            button.onButtonClick?.();
                        }
                    }, index))
            })
        ]
    });
};
var $e0ba5d8cacf44ce0$export$2e2bcd8739ae039 = $e0ba5d8cacf44ce0$var$ToggleSelectButton;



parcelRequire("aqdBs");
const $40073b7c6bbbe3b7$var$BasicCheckBox = ({ id: id, isChecked: isChecked, onChange: onChange, label: label, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("label", {
        className: "basic-checkbox-wrapper",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("svg", {
                className: "basic-checkbox-symbol",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("symbol", {
                    id: "check",
                    viewBox: "0 0 18 6",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("polyline", {
                        points: "2 6 4.5 8 9.5 1",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    })
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: `basic-checkbox-container ${isDisabled ? "disabled-checkbox" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                        className: "basic-checkbox-input",
                        disabled: isDisabled,
                        id: id,
                        type: "checkbox",
                        checked: isChecked,
                        onChange: onChange,
                        "aria-label": label,
                        "aria-checked": isChecked
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "basic-checkbox",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("svg", {
                                width: "12px",
                                height: "10px",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("use", {
                                    xlinkHref: "#check"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "label-text",
                children: label
            })
        ]
    });
};
var $40073b7c6bbbe3b7$export$2e2bcd8739ae039 = $40073b7c6bbbe3b7$var$BasicCheckBox;



parcelRequire("aqdBs");


const $999fec80ee3c1a2f$var$MinimiseButton = ({ ariaLabel: ariaLabel, className: className, isDisabled: isDisabled = false, onButtonClick: onButtonClick, text: text, hideText: hideText = false })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "minimise-button-wrapper",
        children: [
            !hideText && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "minimise-button-text",
                children: text || "Minimise"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6fdd0991e8159fdf$export$2e2bcd8739ae039), {
                className: `icon-button-squared minimise-button ${className}`,
                ariaLabel: ariaLabel,
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).DASH,
                isDisabled: isDisabled,
                onButtonClick: onButtonClick
            })
        ]
    });
};
var $999fec80ee3c1a2f$export$2e2bcd8739ae039 = $999fec80ee3c1a2f$var$MinimiseButton;



parcelRequire("aqdBs");



const $cad81e1fbe2eabcd$var$UpDownButtonPanel = ({ panelClassName: panelClassName, upDisabled: upDisabled, downDisabled: downDisabled, upText: upText, downText: downText, ariaLabelUp: ariaLabelUp, ariaLabelDown: ariaLabelDown, onUpClick: onUpClick, onDownClick: onDownClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `up-down-button-panel-wrapper ${panelClassName ?? ""}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                className: "up-down-button-panel-button move-up-button",
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                            className: "arrow-icon",
                            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ARROW_LEFT,
                            sizeInPx: "10",
                            color: "var(--thriveNavy)"
                        }),
                        upText || ""
                    ]
                }),
                ariaLabel: ariaLabelUp,
                isDisabled: upDisabled,
                onButtonClick: onUpClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                className: "up-down-button-panel-button move-down-button",
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                            className: "arrow-icon",
                            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ARROW_LEFT,
                            sizeInPx: "10",
                            color: "var(--thriveNavy)"
                        }),
                        downText || ""
                    ]
                }),
                ariaLabel: ariaLabelDown,
                isDisabled: downDisabled,
                onButtonClick: onDownClick
            })
        ]
    });
};
var $cad81e1fbe2eabcd$export$2e2bcd8739ae039 = $cad81e1fbe2eabcd$var$UpDownButtonPanel;



parcelRequire("aqdBs");

const $24574102f99226d2$var$TagButton = ({ content: content, closeAriaLabel: closeAriaLabel, className: className, isDisabled: isDisabled = false, onButtonClick: onButtonClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `tag-button ${className} ${isDisabled ? "disabled-tag-button" : ""}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                children: content
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6c765ca802f88a49$export$2e2bcd8739ae039), {
                ariaLabel: closeAriaLabel,
                onButtonClick: onButtonClick
            })
        ]
    });
};
var $24574102f99226d2$export$2e2bcd8739ae039 = $24574102f99226d2$var$TagButton;



parcelRequire("aqdBs");
function $03e6740d6e55e43f$var$getClassNames(useAppThemeColors, useTranslucentButton) {
    let className = "";
    if (useAppThemeColors) className += 'app-theme-button';
    if (useTranslucentButton) className += 'translucent-button';
    return className;
}
const $03e6740d6e55e43f$export$88f4b32f49c3a335 = ({ onClick: onClick, text: text, label: label, isDisabled: isDisabled, useAppThemeColors: useAppThemeColors, useTranslucentButton: useTranslucentButton })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `button-full-width-action ${$03e6740d6e55e43f$var$getClassNames(useAppThemeColors, useTranslucentButton)}`,
        onClick: onClick,
        "aria-label": label,
        disabled: isDisabled,
        type: "button",
        children: text
    });
};



parcelRequire("aqdBs");
const $4c30a3ed7dc0e182$var$BasicRadioButton = ({ id: id, text: text, isChecked: isChecked, onClick: onClick, className: className })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
        className: `basic-radio-button ${className ? className : ""}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                id: `radio-button-${id}`,
                className: "basic-radio-button-input",
                onChange: onClick,
                type: "radio",
                checked: isChecked
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: `radio-button-${id}`,
                className: "basic-radio-button-text",
                children: text
            })
        ]
    }, `basic-radio-button-${id}`);
};
var $4c30a3ed7dc0e182$export$2e2bcd8739ae039 = $4c30a3ed7dc0e182$var$BasicRadioButton;




var $aqdBs = parcelRequire("aqdBs");


const $4b97d87de183123c$var$CopyToClipboard = ({ className: className, textToCopy: textToCopy, iconOnly: iconOnly })=>{
    const [copyState, setCopyState] = (0, $aqdBs.useState)('ready');
    async function handleClick() {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopyState('success');
        } catch  {
            setCopyState('fail');
        } finally{
            setTimeout(()=>{
                setCopyState('ready');
            }, 3000);
        }
    }
    const getButtonContents = ()=>{
        switch(copyState){
            case 'ready':
                return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                    children: [
                        !iconOnly && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: "Copy to clipboard"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).COPY,
                            color: "var(--thriveGreyDark)",
                            sizeInPx: "16"
                        })
                    ]
                });
            case 'success':
                return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                    children: [
                        !iconOnly && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: "Copied to clipboard"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CIRCLE_CHECK,
                            color: "var(--thriveWhite)",
                            sizeInPx: "16"
                        })
                    ]
                });
            case 'fail':
                return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                    children: [
                        !iconOnly && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: "Could not copy"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CIRCLE_CLOSE,
                            color: "var(--thriveWhite)",
                            sizeInPx: "16"
                        })
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `basic-button TC-c2c-button ${copyState} ${className ?? ''}`,
        name: "copy to clipboard",
        onClick: handleClick,
        "aria-label": 'copy to clipboard',
        disabled: copyState !== 'ready',
        children: getButtonContents()
    });
};
var $4b97d87de183123c$export$2e2bcd8739ae039 = $4b97d87de183123c$var$CopyToClipboard;



parcelRequire("aqdBs");

parcelRequire("aqdBs");

const $8a059148c42829bb$var$AppHeader = ({ appName: appName })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "app-header",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).MENU,
                sizeInPx: "14"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                className: "app-banner-title",
                children: appName || "Your App Name"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "right-panel",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).SEARCH_GLASS,
                        sizeInPx: "14"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).BELL,
                        sizeInPx: "14"
                    })
                ]
            })
        ]
    });
};
var $8a059148c42829bb$export$2e2bcd8739ae039 = $8a059148c42829bb$var$AppHeader;



parcelRequire("aqdBs");

var $08ad158b6af5f82e$export$28064ee355a535f2 = /*#__PURE__*/ function(ImageSize) {
    ImageSize[ImageSize["Thumbnail"] = 160] = "Thumbnail";
    ImageSize[ImageSize["XS"] = 240] = "XS";
    ImageSize[ImageSize["S"] = 360] = "S";
    ImageSize[ImageSize["M"] = 540] = "M";
    ImageSize[ImageSize["L"] = 720] = "L";
    ImageSize[ImageSize["XL"] = 1080] = "XL";
    ImageSize[ImageSize["XXL"] = 1440] = "XXL";
    return ImageSize;
}({});
function $08ad158b6af5f82e$export$262361d19184a16a(widthInPx, imageUrl) {
    let imageWidth;
    if (widthInPx < 160) imageWidth = 160;
    else if (widthInPx < 240) imageWidth = 240;
    else if (widthInPx < 360) imageWidth = 360;
    else if (widthInPx < 540) imageWidth = 540;
    else if (widthInPx < 720) imageWidth = 720;
    else if (widthInPx < 1080) imageWidth = 1080;
    else imageWidth = 1440;
    return `${imageUrl}?width=${imageWidth}&quality=70&upscale=false`;
}


const $a0af7d3cadab7a6a$var$AppContent = ({ appContent: appContent })=>{
    if (!appContent?.length) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "loading-app-preview-content-wrapper",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).THRIVE,
            color: "var(--thriveChalk)",
            sizeInPx: "40"
        })
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "app-preview-content-wrapper",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "hero-content-item",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "content-item",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                            src: (0, $08ad158b6af5f82e$export$262361d19184a16a)(239, appContent[0].featuredImageUrl),
                            alt: appContent[0].title
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                            className: "overlay",
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                                className: "hero-content-title",
                                children: appContent[0].title
                            })
                        })
                    ]
                }, 0)
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "grid",
                children: appContent.slice(1).map((item, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "content-item",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                                src: (0, $08ad158b6af5f82e$export$262361d19184a16a)(113, item.featuredImageUrl),
                                alt: item.title
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                className: "overlay",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                    className: "content-title",
                                    children: item.title
                                })
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $a0af7d3cadab7a6a$export$2e2bcd8739ae039 = $a0af7d3cadab7a6a$var$AppContent;


const $d8a6047e9aec9794$var$MobileAppPreview = ({ appName: appName, appContent: appContent })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "mobile-app-preview-container",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "mock-camera-panel"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "preview-content-wrapper",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $8a059148c42829bb$export$2e2bcd8739ae039), {
                        appName: appName
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $a0af7d3cadab7a6a$export$2e2bcd8739ae039), {
                        appContent: appContent
                    })
                ]
            })
        ]
    });
};
var $d8a6047e9aec9794$export$2e2bcd8739ae039 = $d8a6047e9aec9794$var$MobileAppPreview;





parcelRequire("aqdBs");
const $8f626dbc4ca855b7$var$ThriveAppLogo = ()=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("svg", {
        "data-testid": "thrive-app-logo",
        className: "thrive-app-logo",
        width: "92",
        height: "30",
        viewBox: "0 0 92 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("g", {
                clipPath: "url(#clip0_2389_404)",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M20.1698 26.4383H12.6577V11.7803C12.6555 11.5375 12.603 11.2976 12.5033 11.075C12.4036 10.8524 12.2588 10.6516 12.0775 10.4847C11.9083 10.323 11.7069 10.1967 11.4857 10.1136C11.2644 10.0304 11.028 9.99223 10.791 10.0013C10.3143 10.0161 9.86192 10.2095 9.52822 10.5409C9.19452 10.8724 9.00528 11.3164 9 11.7803V28.221C9.00621 28.6909 9.20088 29.1399 9.54252 29.4723C9.88416 29.8046 10.3457 29.994 10.8288 30H20.1698C20.4195 29.9981 20.6662 29.9472 20.895 29.8502C21.1239 29.7532 21.3303 29.6122 21.5017 29.4356C21.6679 29.271 21.7978 29.0751 21.8833 28.8599C21.9687 28.6447 22.008 28.4147 21.9987 28.1842C21.984 27.7203 21.7855 27.2798 21.4446 26.9551C21.1037 26.6304 20.6469 26.4465 20.1698 26.4419",
                        fill: "#FF0064"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M30.4413 0.490372C30.2791 0.327767 30.0854 0.20044 29.8723 0.116273C29.6592 0.0321065 29.4313 -0.00710825 29.2025 0.00105691C28.7433 0.0149298 28.3072 0.207183 27.9856 0.537573C27.6639 0.867962 27.4815 1.31088 27.4767 1.7736V9.54269H19.761C19.2958 9.54872 18.8514 9.73753 18.5224 10.0689C18.1934 10.4002 18.006 10.8479 18 11.3165V19.2189C18.0022 19.4611 18.0529 19.7003 18.1491 19.9223C18.2453 20.1443 18.3851 20.3444 18.5599 20.5107C18.8699 20.8206 19.2878 20.9962 19.7246 21H19.7987C20.2579 20.9858 20.6938 20.7932 21.0153 20.4626C21.3368 20.132 21.5188 20.689 21.5233 19.2262V13.0963H29.239C29.7043 13.09 30.1487 12.9009 30.4777 12.5694C30.8066 12.2378 30.994 11.79 31 11.3214V1.77972C30.9973 1.53808 30.9464 1.29946 30.8505 1.07799C30.7545 0.856512 30.6154 0.656694 30.4413 0.490372Z",
                        fill: "#B7D2E5"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M20.5038 2.95235C20.669 2.79006 20.7982 2.59701 20.8833 2.38501C20.9684 2.17301 21.0077 1.94651 20.9988 1.71938C20.9839 1.26186 20.7861 0.827561 20.4467 0.507174C20.1073 0.186786 19.6525 0.00508025 19.1773 0H1.82276C1.34147 0.0059499 0.881613 0.192668 0.541145 0.52038C0.200678 0.848091 0.00650904 1.2909 0 1.75447L0 11.2383C0.00242896 11.4778 0.0549635 11.7144 0.154464 11.9339C0.253966 12.1535 0.398391 12.3514 0.579112 12.516C0.900102 12.822 1.3322 12.9956 1.78381 13H1.86044C2.33629 12.985 2.78765 12.7932 3.11995 12.4648C3.45224 12.1364 3.63969 11.6968 3.643 11.2383V3.51014H19.1773C19.4259 3.50781 19.6716 3.4572 19.8995 3.36137C20.1274 3.26553 20.333 3.12642 20.5038 2.95235Z",
                        fill: "#203554"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M45.9974 14.3465H43.2033V17.6225C43.2021 17.8695 43.2162 18.1163 43.2453 18.3617C43.2674 18.5644 43.3322 18.7607 43.4358 18.9387C43.5412 19.1082 43.7011 19.2405 43.8916 19.3158C44.1506 19.4134 44.428 19.4584 44.7061 19.4478C44.9289 19.4442 45.1514 19.4274 45.3721 19.3976C45.6002 19.3817 45.818 19.3007 45.9974 19.165V21.6956C45.6416 21.8176 45.2722 21.8995 44.8966 21.9394C44.524 21.9792 44.1495 21.9993 43.7747 21.9998C43.2761 22.004 42.7789 21.9495 42.2943 21.8376C41.869 21.7401 41.4675 21.5646 41.112 21.3209C40.7733 21.0812 40.5024 20.7645 40.3238 20.3995C40.1216 19.9671 40.0241 19.4965 40.0388 19.0229V14.3465H38V11.9152H40.0322V9H43.2059V11.9152H46L45.9974 14.3465Z",
                        fill: "#121F2D"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M49.8842 7V13.6663H49.9235C49.9981 13.4617 50.1091 13.2734 50.2506 13.1108C50.4119 12.9192 50.5998 12.7532 50.8081 12.6182C51.047 12.4627 51.3057 12.3425 51.5769 12.2611C51.8888 12.1661 52.2127 12.1192 52.5379 12.1219C53.2693 12.1219 53.8594 12.2377 54.3083 12.4692C54.7371 12.6837 55.0999 13.0166 55.3564 13.431C55.6176 13.8741 55.7905 14.3665 55.865 14.8793C55.9578 15.4763 56.003 16.0801 55.9998 16.6847V21.9988H53.1157V17.2771C53.1157 16.9988 53.1061 16.7114 53.087 16.415C53.0703 16.1329 53.012 15.8551 52.9139 15.5911C52.8234 15.3481 52.6702 15.1352 52.4711 14.9754C52.2717 14.8165 51.9876 14.7377 51.6151 14.7377C51.3014 14.7235 50.9896 14.7953 50.7114 14.9458C50.4883 15.0763 50.3051 15.2687 50.1826 15.5012C50.0574 15.7451 49.9765 16.0106 49.9438 16.2845C49.9045 16.587 49.8849 16.8918 49.8853 17.197V22H47V7H49.8842Z",
                        fill: "#121F2D"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M58 12.2406H61.0723V13.8073H61.1129C61.3832 13.2701 61.7823 12.8052 62.276 12.4524C62.7277 12.1508 63.2942 12 63.9755 12C64.1534 12 64.3301 12.0075 64.5081 12.0199C64.6743 12.0313 64.8391 12.0584 65 12.101V14.8518C64.7887 14.7864 64.5729 14.736 64.3543 14.701C64.1344 14.6669 63.9121 14.6502 63.6895 14.6511C63.1022 14.6511 62.6362 14.7313 62.2913 14.8917C61.9682 15.0373 61.6946 15.2709 61.5032 15.5648C61.3092 15.8798 61.1869 16.2323 61.1447 16.598C61.0879 17.0374 61.0607 17.4801 61.0634 17.923V22H58V12.2406Z",
                        fill: "#121F2D"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M66 8.79341C66.0004 8.49831 66.0615 8.20787 66.1779 7.94776C66.2943 7.68765 66.4624 7.46589 66.6674 7.30209C66.8724 7.13829 67.1079 7.0375 67.3532 7.00862C67.5985 6.97974 67.8459 7.02367 68.0736 7.13653C68.3013 7.24938 68.5023 7.42768 68.6588 7.65566C68.8153 7.88363 68.9225 8.15427 68.9708 8.44363C69.0192 8.733 69.0073 9.03217 68.9361 9.3147C68.865 9.59724 68.7368 9.85442 68.5629 10.0635C68.3532 10.3156 68.0857 10.4875 67.7944 10.5573C67.503 10.6271 67.2009 10.5918 66.9264 10.4557C66.6518 10.3196 66.4172 10.089 66.2523 9.79307C66.0874 9.49713 65.9996 9.1492 66 8.79341ZM66.2068 11.9546H68.7964V22H66.2068V11.9546Z",
                        fill: "#121F2D"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M71 12H74.2258L76.6854 18.7893H76.7249L78.9892 12H82L78.1685 22H75.007L71 12Z",
                        fill: "#121F2D"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
                        d: "M91.537 20.1223C91.0538 20.7249 90.4264 21.2026 89.7099 21.5135C88.9919 21.8345 88.2113 22.0004 87.4216 21.9999C86.6996 22.0043 85.9824 21.885 85.3028 21.6472C84.6643 21.4261 84.0775 21.083 83.5766 20.6379C83.0838 20.1947 82.6908 19.6563 82.4225 19.0571C82.1436 18.4054 82 17.7063 82 17.0001C82 16.294 82.1436 15.5949 82.4225 14.9432C82.6909 14.344 83.0839 13.8057 83.5766 13.3624C84.0775 12.9173 84.6643 12.5742 85.3028 12.3531C85.9824 12.1153 86.6996 11.9959 87.4216 12.0004C88.0718 11.992 88.717 12.112 89.3185 12.3531C89.8729 12.5777 90.3675 12.9229 90.7643 13.3624C91.1735 13.8248 91.4841 14.3623 91.6779 14.9432C91.9003 15.6067 92.0089 16.3015 91.9994 16.9995V17.9201H85.0124C85.1098 18.4398 85.3859 18.9116 85.7951 19.2577C86.2114 19.5952 86.7398 19.7725 87.2807 19.7563C87.7224 19.7706 88.1586 19.6586 88.5358 19.434C88.8835 19.2121 89.1864 18.9298 89.4294 18.6011L91.537 20.1223ZM88.9845 15.9306C88.9958 15.6964 88.9573 15.4623 88.8715 15.2432C88.7857 15.0242 88.6545 14.8247 88.486 14.6575C88.312 14.4823 88.1023 14.3448 87.8704 14.2537C87.6386 14.1626 87.3897 14.1199 87.1399 14.1285C86.838 14.1225 86.5379 14.1759 86.2575 14.2853C86.0173 14.3807 85.7963 14.5165 85.6044 14.6866C85.4261 14.8462 85.2828 15.0394 85.1831 15.2545C85.0827 15.4673 85.0248 15.6967 85.0124 15.9306H88.9845Z",
                        fill: "#121F2D"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("clipPath", {
                    id: "clip0_2389_404",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("rect", {
                        width: "92",
                        height: "30",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $8f626dbc4ca855b7$export$2e2bcd8739ae039 = $8f626dbc4ca855b7$var$ThriveAppLogo;


var $863e66effdc9f2ef$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["List"] = "list";
    MediaType["Page"] = "page";
    MediaType["Rss"] = "rss";
    MediaType["Contact"] = "contact";
    MediaType["Web"] = "web";
    MediaType["Image"] = "image";
    MediaType["File"] = "file";
    MediaType["Video"] = "video";
    MediaType["NotAccepted"] = "notAccepted";
    MediaType["Audio"] = "audio";
    MediaType["Form"] = "form";
    return MediaType;
}({});




parcelRequire("aqdBs");


parcelRequire("aqdBs");


const $148789daa09d146e$var$UserActivityImage = ({ activity: activity })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: `user-activity-image-wrapper ${activity}`,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
            className: (0, $ac411418a6b9347a$export$dd97b7e27ecaf77d)(activity),
            iconName: (0, $ac411418a6b9347a$export$dd97b7e27ecaf77d)(activity),
            sizeInPx: "10"
        })
    });
};
var $148789daa09d146e$export$2e2bcd8739ae039 = $148789daa09d146e$var$UserActivityImage;




const $47ed5cd728295a18$var$UserActivityProfileImage = ({ profileImageUrl: profileImageUrl, userActivity: userActivity, secondProfileImageUrl: secondProfileImageUrl, defaultSecondProfileImage: defaultSecondProfileImage })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `user-activity-profile-image-wrapper`,
        "aria-hidden": "true",
        children: [
            profileImageUrl ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                src: (0, $08ad158b6af5f82e$export$262361d19184a16a)(30, profileImageUrl),
                className: `profile-image`,
                alt: ""
            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                className: "default-no-user-icon",
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).USER_NONE,
                sizeInPx: "14",
                color: "var(--thriveLightSlate)"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $148789daa09d146e$export$2e2bcd8739ae039), {
                activity: userActivity
            }),
            secondProfileImageUrl && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                src: (0, $08ad158b6af5f82e$export$262361d19184a16a)(30, secondProfileImageUrl),
                className: `second-profile-image`,
                alt: ""
            }),
            defaultSecondProfileImage && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                className: "default-no-user-icon second-default-image",
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).USER_NONE,
                sizeInPx: "14",
                color: "var(--thriveLightSlate)"
            })
        ]
    });
};
var $47ed5cd728295a18$export$2e2bcd8739ae039 = $47ed5cd728295a18$var$UserActivityProfileImage;




parcelRequire("aqdBs");



const $d2ec2685372d52e3$var$ProfileImage = ({ profileImageUrl: profileImageUrl, className: className, secondProfileImageUrl: secondProfileImageUrl, isSquareImage: isSquareImage, defaultSecondProfileImage: defaultSecondProfileImage })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `tc-profile-image-wrapper ${className ?? ""} ${isSquareImage ? "square-image" : ""}`,
        "aria-hidden": "true",
        children: [
            profileImageUrl ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                src: (0, $08ad158b6af5f82e$export$262361d19184a16a)(30, profileImageUrl),
                className: `profile-image`,
                alt: ""
            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                className: "default-no-user-icon",
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).USER_NONE,
                sizeInPx: "14",
                color: "var(--thriveLightSlate)"
            }),
            secondProfileImageUrl && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                src: (0, $08ad158b6af5f82e$export$262361d19184a16a)(30, secondProfileImageUrl),
                className: `second-profile-image`,
                alt: ""
            }),
            defaultSecondProfileImage && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                className: "default-no-user-icon",
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).USER_NONE,
                sizeInPx: "14",
                color: "var(--thriveLightSlate)"
            })
        ]
    });
};
var $d2ec2685372d52e3$export$2e2bcd8739ae039 = $d2ec2685372d52e3$var$ProfileImage;



parcelRequire("aqdBs");


const $69973fa24a75f995$var$ContentImagePreviewPanel = ({ className: className, mediaItems: mediaItems, maxVisible: maxVisible, totalMediaItems: totalMediaItems })=>{
    if (!Array.isArray(mediaItems) || mediaItems.length === 0) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    const extraCount = totalMediaItems > maxVisible ? totalMediaItems - maxVisible : 0;
    const displayedImages = Array.isArray(mediaItems) ? mediaItems.slice(0, maxVisible) : [];
    const handleImageError = (event)=>{
        const target = event.target;
        target.style.display = "none";
    };
    function isLastVisibleItem(index) {
        return index === maxVisible - 1 && extraCount > 0;
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: `content-image-preview-panel ${className ?? ""}`,
        children: displayedImages.map((image, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: `image-wrapper`,
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                        src: `${image?.thumbnail?.url}?size=thumbnail`,
                        alt: `content preview ${index + 1} of ${displayedImages.length}`,
                        className: "content-image-preview-item",
                        onError: handleImageError
                    }),
                    isLastVisibleItem(index) ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "content-image-preview-item-overlay",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                            className: "item-overlay-count",
                            children: [
                                "+",
                                extraCount
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: `content-image-preview-item-icon-overlay ${!image?.url && "imageless"}`,
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "item-overlay-icon",
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                                iconName: (0, $ac411418a6b9347a$export$c0fec09c9ba54f32)(image.mediaType),
                                color: "var(--thriveWhite)",
                                sizeInPx: "12"
                            })
                        })
                    })
                ]
            }, image.url))
    });
};
var $69973fa24a75f995$export$2e2bcd8739ae039 = $69973fa24a75f995$var$ContentImagePreviewPanel;



parcelRequire("aqdBs");

parcelRequire("aqdBs");


const $a22649361e5add3c$var$AppIcon = ({ imageUrl: imageUrl, appName: appName, isDefault: isDefault })=>{
    if (!imageUrl || isDefault) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
        className: "app-image default-app-icon",
        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).THRIVE,
        sizeInPx: "14",
        color: "var(--thriveGreyDark)"
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
        "data-tooltip-id": "app-image-tooltip",
        src: imageUrl,
        className: `app-image`,
        alt: appName ?? "App Icon"
    });
};
var $a22649361e5add3c$export$2e2bcd8739ae039 = $a22649361e5add3c$var$AppIcon;



const $12b27b891819c540$var$AppIconWithTooltip = ({ imageUrl: imageUrl, className: className, appName: appName })=>{
    if (!appName) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $a22649361e5add3c$export$2e2bcd8739ae039), {
        imageUrl: imageUrl
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: `app-icon-tooltip-wrapper ${className ?? ""}`,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $18b395e50fc09130$export$2e2bcd8739ae039), {
            text: appName,
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $a22649361e5add3c$export$2e2bcd8739ae039), {
                imageUrl: imageUrl,
                appName: appName
            })
        })
    });
};
var $12b27b891819c540$export$2e2bcd8739ae039 = $12b27b891819c540$var$AppIconWithTooltip;



parcelRequire("aqdBs");
const $ca39da2b81a57b70$var$InformationOval = ({ information: information })=>{
    if (!information) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: `information-oval`,
        children: information
    });
};
var $ca39da2b81a57b70$export$2e2bcd8739ae039 = $ca39da2b81a57b70$var$InformationOval;




parcelRequire("aqdBs");


const $6b55b7249683e3c7$var$ActionFeedbackBanner = ({ feedbackType: feedbackType, feedbackMessage: feedbackMessage })=>{
    if (!feedbackType) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `action-feedback-wrapper ${feedbackType}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: (0, $ac411418a6b9347a$export$636f3250b1105469)(feedbackType),
                sizeInPx: "12",
                color: "white"
            }),
            feedbackMessage && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "action-feedback-message",
                children: feedbackMessage
            })
        ]
    });
};
var $6b55b7249683e3c7$export$2e2bcd8739ae039 = $6b55b7249683e3c7$var$ActionFeedbackBanner;



parcelRequire("aqdBs");
const $7d8dea94b6bc3655$var$MutedInformationPanel = ({ information: information, className: className })=>{
    if (!information) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: `muted-information-panel ${className ?? ""}`,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
            className: "muted-information-message",
            children: information
        })
    });
};
var $7d8dea94b6bc3655$export$2e2bcd8739ae039 = $7d8dea94b6bc3655$var$MutedInformationPanel;



parcelRequire("aqdBs");



const $e40b52f31d492688$var$MediaInfo = ({ className: className, profileImageUrl: profileImageUrl, displayName: displayName, mediaTitle: mediaTitle, date: date })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `media-info-wrapper ${className}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "left-panel",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d2ec2685372d52e3$export$2e2bcd8739ae039), {
                    profileImageUrl: profileImageUrl,
                    isSquareImage: true
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "right-panel",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "user-data",
                        children: displayName
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                        className: "media-data",
                        children: [
                            mediaTitle,
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).MIDDOT,
                                sizeInPx: "8",
                                className: "mid-dot",
                                color: "var(--thriveLightSlate)"
                            }),
                            date
                        ]
                    })
                ]
            })
        ]
    });
};
var $e40b52f31d492688$export$2e2bcd8739ae039 = $e40b52f31d492688$var$MediaInfo;



parcelRequire("aqdBs");


function $8d0dff8c1266969a$var$getIconColor(type) {
    switch(type){
        case 'info':
            return 'var(--thriveCharcoal)';
        case 'warning':
        case 'error':
            return 'var(--thriveRed)';
    }
}
const $8d0dff8c1266969a$var$InformationContainer = ({ type: type = 'info', className: className, children: children })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `thrive-components-information-container ${className ? className : ''}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: `icon-wrapper ${type}`,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).INFO,
                    color: $8d0dff8c1266969a$var$getIconColor(type),
                    sizeInPx: "12"
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "message-wrapper",
                children: children
            })
        ]
    });
};
var $8d0dff8c1266969a$export$2e2bcd8739ae039 = $8d0dff8c1266969a$var$InformationContainer;



parcelRequire("aqdBs");



const $dcbebb9f0858c5be$var$AlertError = ({ className: className, alertMessage: alertMessage })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `alert-error-container ${className}`,
        "data-testid": "alert-error",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "alert-error-icon",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ALERT_INFO,
                    color: "white"
                })
            }),
            alertMessage
        ]
    });
};
var $dcbebb9f0858c5be$export$2e2bcd8739ae039 = $dcbebb9f0858c5be$var$AlertError;



parcelRequire("aqdBs");
const $3e6b5cf652b3eebc$var$LoadingSpinner = ({ size: size })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "lds-spinner",
        "data-testid": "lds-spinner",
        style: {
            height: `${size}px`,
            width: `${size}px`,
            margin: '8px auto'
        },
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {})
        ]
    });
};
var $3e6b5cf652b3eebc$export$2e2bcd8739ae039 = $3e6b5cf652b3eebc$var$LoadingSpinner;



parcelRequire("aqdBs");

const $e5b40fe31a2f6533$var$CommentTextInput = ({ className: className, profilePictureUrl: profilePictureUrl, placeholderText: placeholderText, commentString: commentString, setCommentString: setCommentString })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `comment-text-input-wrapper ${className ?? ""} `,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: "comment-input",
                className: "sr-only",
                children: "Add a comment"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d2ec2685372d52e3$export$2e2bcd8739ae039), {
                profileImageUrl: profilePictureUrl
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                type: "text",
                id: "comment-input",
                className: "comment-input",
                placeholder: placeholderText,
                value: commentString,
                onChange: (e)=>setCommentString(e.target.value),
                "aria-label": "Input Comment Text"
            })
        ]
    });
};
var $e5b40fe31a2f6533$export$2e2bcd8739ae039 = $e5b40fe31a2f6533$var$CommentTextInput;



parcelRequire("aqdBs");
const $e6534d004b9f2161$var$BasicTextInput = ({ id: id, className: className, labelText: labelText, labelIsHidden: labelIsHidden, placeholderText: placeholderText, textString: textString, setTextString: setTextString, maxLength: maxLength, isDisabled: isDisabled, isReadOnly: isReadOnly, type: type = 'text', autofocus: autofocus = false, onReturnPressed: onReturnPressed, inputMode: inputMode = "text", onBlur: onBlur })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `basic-text-input-wrapper ${className ?? ""} `,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: `basic-text-input-${id || ''}`,
                className: `${labelIsHidden ? "sr-only" : ""} basic-text-input-label`,
                children: labelText
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                type: type,
                id: `basic-text-input-${id || ''}`,
                className: "basic-text-input",
                placeholder: placeholderText,
                value: textString,
                onChange: (e)=>setTextString(e.target.value),
                "aria-label": "Add your Text",
                maxLength: maxLength,
                disabled: isDisabled,
                readOnly: isReadOnly,
                autoFocus: autofocus,
                inputMode: inputMode,
                onBlur: onBlur,
                onKeyDown: (e)=>{
                    if (e.code === 'Enter') onReturnPressed?.();
                }
            }, id ? `basic-text-input-${id}` : '')
        ]
    });
};
var $e6534d004b9f2161$export$2e2bcd8739ae039 = $e6534d004b9f2161$var$BasicTextInput;



parcelRequire("aqdBs");


const $507a5404dfb22592$var$SimpleSearchInput = ({ className: className, ariaLabel: ariaLabel, placeholder: placeholder, setSearchString: setSearchString, searchString: searchString })=>{
    const handleInputChange = (event)=>{
        setSearchString(event.target.value);
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `simple-search-string-input-container ${className}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).SEARCH_GLASS,
                color: "#9E9E9E",
                sizeInPx: "12"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                id: "simple-search-input",
                className: "search-string-input",
                type: "text",
                title: "Search Input",
                value: searchString,
                placeholder: placeholder ?? "Search",
                onInput: handleInputChange
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: "simple-search-input sr-only",
                children: ariaLabel
            })
        ]
    });
};
var $507a5404dfb22592$export$2e2bcd8739ae039 = $507a5404dfb22592$var$SimpleSearchInput;



parcelRequire("aqdBs");

const $3589b82d99d444aa$var$BasicEmailInput = ({ id: id, className: className, labelText: labelText, labelIsHidden: labelIsHidden, placeholderText: placeholderText, textString: textString, setTextString: setTextString, maxLength: maxLength, isDisabled: isDisabled, isReadOnly: isReadOnly, buttonContent: buttonContent, onButtonClick: onButtonClick })=>{
    const isValidEmail = (email)=>{
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    const isButtonDisabled = !textString || !isValidEmail(textString);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `basic-email-input-wrapper ${className ?? ""} `,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: `basic-email-input-${id || ''}`,
                className: `${labelIsHidden ? "sr-only" : ""} basic-email-input-label`,
                children: labelText
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                type: "email",
                id: `basic-email-input-${id || ''}`,
                className: "basic-text-input",
                placeholder: placeholderText,
                value: textString,
                onChange: (e)=>setTextString(e.target.value),
                "aria-label": "Add your Text",
                maxLength: maxLength,
                disabled: isDisabled,
                readOnly: isReadOnly
            }, id ? `basic-email-input-${id}` : ''),
            buttonContent && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                isDisabled: isButtonDisabled || isDisabled,
                onButtonClick: onButtonClick,
                content: buttonContent,
                ariaLabel: "Save Email",
                className: "basic-email-button"
            })
        ]
    });
};
var $3589b82d99d444aa$export$2e2bcd8739ae039 = $3589b82d99d444aa$var$BasicEmailInput;



parcelRequire("aqdBs");

const $ffcf0c75a9a39428$var$BasicAddInput = ({ id: id, className: className, labelText: labelText, labelIsHidden: labelIsHidden, placeholderText: placeholderText, textString: textString, setTextString: setTextString, maxLength: maxLength, isDisabled: isDisabled, isReadOnly: isReadOnly, buttonContent: buttonContent, onButtonClick: onButtonClick })=>{
    const isButtonDisabled = !textString;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `basic-add-input-wrapper ${className ?? ""} `,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: `basic-add-input-${id || ''}`,
                className: `${labelIsHidden ? "sr-only" : ""} basic-add-input-label`,
                children: labelText
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                id: `basic-add-input-${id || ''}`,
                className: "basic-add-input",
                placeholder: placeholderText,
                value: textString,
                onChange: (e)=>setTextString(e.target.value),
                "aria-label": "Add your Text",
                maxLength: maxLength,
                disabled: isDisabled,
                readOnly: isReadOnly
            }, id ? `basic-add-input-${id}` : ''),
            buttonContent && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                isDisabled: isButtonDisabled || isDisabled,
                onButtonClick: onButtonClick,
                content: buttonContent,
                ariaLabel: "Add",
                className: "add-button"
            })
        ]
    });
};
var $ffcf0c75a9a39428$export$2e2bcd8739ae039 = $ffcf0c75a9a39428$var$BasicAddInput;



parcelRequire("aqdBs");
const $7a12567db1abadc9$var$BasicTextArea = ({ value: value, setValue: setValue, className: className, isDisabled: isDisabled = false, placeholder: placeholder, maxLength: maxLength })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "tc-textarea-wrapper",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("textarea", {
                className: `tc-textarea${className ?? ''}`,
                placeholder: placeholder ?? '',
                value: value,
                onChange: (e)=>setValue(e.target.value),
                disabled: isDisabled,
                maxLength: maxLength
            }),
            !!maxLength && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                className: "tc-length-counter",
                children: [
                    value.length,
                    " / ",
                    maxLength
                ]
            })
        ]
    });
};
var $7a12567db1abadc9$export$2e2bcd8739ae039 = $7a12567db1abadc9$var$BasicTextArea;




var $aqdBs = parcelRequire("aqdBs");
const $d61fe6f2232d7722$var$CodeInput = ({ codeLength: codeLength = 5, size: size = 42, onChange: onChange })=>{
    const [code, setCode] = (0, $aqdBs.useState)([]);
    const digitRefs = (0, $aqdBs.useRef)([]);
    (0, $aqdBs.useEffect)(()=>{
        setCode(new Array(codeLength).fill(""));
    }, [
        codeLength
    ]);
    function handleCodeInput(value, index) {
        const upperValue = value.toUpperCase().slice(0, 1);
        const newCode = code.map((v, idx)=>idx === index ? upperValue : v);
        setCode(newCode);
        onChange?.(newCode.join(""));
        if (upperValue && index < codeLength - 1) digitRefs.current[index + 1]?.focus();
    }
    function handleKeyPress(event, index) {
        if (digitRefs) {
            if (index > 0 && (event.key === "Backspace" && !code[index] || event.key === "ArrowLeft")) digitRefs.current[index - 1]?.focus();
            else if (index < codeLength && (!Number.isNaN(+event.key) && code[index] || event.key === "ArrowRight")) digitRefs.current[index + 1]?.focus();
        }
    }
    //means you can paste the code in
    function handlePaste(event) {
        event.preventDefault();
        const pastedCode = event.clipboardData.getData("text");
        const codeDigits = pastedCode.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, codeLength).split("");
        if (!codeDigits.length) return;
        const newCode = new Array(codeLength).fill("");
        codeDigits.forEach((digit, index)=>{
            newCode[index] = digit;
            if (digitRefs.current[index]) digitRefs.current[index].value = digit;
        });
        setCode(newCode);
        onChange?.(newCode.join(""));
        const nextIndex = Math.min(codeDigits.length, codeLength - 1);
        digitRefs.current[nextIndex]?.focus();
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "tc-code-Input",
        children: code.map((value, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                style: {
                    "--input-character-size": `${size}px`
                },
                "data-testid": "recovery-form-code-input-item",
                className: "tc-code-input-item",
                "aria-label": `Input verification code value at index ${index + 1}`,
                type: "text",
                ref: (el)=>{
                    digitRefs.current[index] = el;
                },
                autoFocus: index === 0,
                id: `input-${index}`,
                value: value,
                maxLength: 1,
                pattern: "[a-zA-Z0-9]{1}",
                inputMode: "numeric",
                onKeyDown: (e)=>{
                    if (e.ctrlKey || e.metaKey) return;
                    const isValid = /^[a-zA-Z0-9]$/.test(e.key);
                    if (!isValid && e.key.length === 1) e.preventDefault();
                },
                onChange: (event)=>handleCodeInput(event.target.value.toUpperCase(), index),
                onKeyUp: (event)=>handleKeyPress(event, index),
                onFocus: (e)=>e.target.select(),
                onPaste: handlePaste
            }, `code-input-character-${index}`))
    });
};
var $d61fe6f2232d7722$export$2e2bcd8739ae039 = $d61fe6f2232d7722$var$CodeInput;




var $aqdBs = parcelRequire("aqdBs");


const $7826de2efe53ea39$export$2e6ece086e693fb = ({ id: id, label: label, isPassword: isPassword, setValue: setValue, defaultValue: defaultValue, placeholder: placeholder, autoComplete: autoComplete, onReturnPressed: onReturnPressed, onBlur: onBlur, disabled: disabled })=>{
    const [v, setV] = (0, $aqdBs.useState)(defaultValue ?? '');
    const [hidePassword, setHidePassword] = (0, $aqdBs.useState)(isPassword);
    (0, $aqdBs.useEffect)(()=>{
        setValue(v);
    }, [
        v
    ]);
    function handlePasswordToggle() {
        setHidePassword(!hidePassword);
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "thrive-component-form-element text-with-label",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                id: id,
                className: isPassword ? "text-input-area password" : "text-input-area",
                type: hidePassword ? 'password' : 'text',
                placeholder: placeholder,
                value: v,
                onChange: (e)=>setV(e.target.value),
                autoComplete: autoComplete,
                onKeyDown: (e)=>{
                    if (e.code === 'Enter') onReturnPressed?.();
                },
                onBlur: onBlur ?? undefined,
                disabled: disabled
            }),
            isPassword && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                name: hidePassword ? 'show password' : 'hide password',
                "aria-label": hidePassword ? 'show password' : 'hide password',
                className: "reveal-password-button",
                onClick: handlePasswordToggle,
                type: 'button',
                disabled: disabled,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                    iconName: hidePassword ? (0, $99899ff752f57db8$export$356109f9df11377f).EYE_ON : (0, $99899ff752f57db8$export$356109f9df11377f).EYE_OFF,
                    sizeInPx: "22"
                })
            })
        ]
    });
};



parcelRequire("aqdBs");


const $9b94a43019bc17e6$var$AddInputPanelWithTags = ({ onRemoveItem: onRemoveItem, list: list, textString: textString, setTextString: setTextString, onAddTextClick: onAddTextClick, textInputLabel: textInputLabel, inputPlaceholder: inputPlaceholder })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "input-panel-tags",
                children: list.map((listItem, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $24574102f99226d2$export$2e2bcd8739ae039), {
                        content: listItem.title,
                        closeAriaLabel: `Remove ${listItem.title} from selection`,
                        onButtonClick: ()=>onRemoveItem(listItem.id)
                    }, `${listItem.title}-${index}`))
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ffcf0c75a9a39428$export$2e2bcd8739ae039), {
                className: "add-input-panel-input",
                id: "add-input-panel-input",
                labelText: textInputLabel ?? "",
                labelIsHidden: !textInputLabel,
                placeholderText: inputPlaceholder,
                setTextString: setTextString,
                textString: textString,
                buttonContent: "Add",
                onButtonClick: ()=>onAddTextClick()
            })
        ]
    });
};
var $9b94a43019bc17e6$export$2e2bcd8739ae039 = $9b94a43019bc17e6$var$AddInputPanelWithTags;




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
//basic validation to cut down on API calls
function $12efab610886518b$export$545d3ff10156d8f4(phoneNumber) {
    // Check the length of the cleaned number
    if (phoneNumber.length < 7 || phoneNumber.length > 15) return false;
    // Check if the number starts with a "+" sign (for international numbers)
    if (phoneNumber.startsWith("+") && phoneNumber.length < 11) return false;
    return true;
}
function $12efab610886518b$export$2cb106e106c2eb66(originalNumber, newNumber) {
    if (!newNumber) return false;
    //sanitize phone numbers by removing spaces
    const sanitizedOriginalNumber = originalNumber.replace(/\s/g, '');
    const sanitizedNewNumber = newNumber.replace(/\s/g, '');
    //will return true if numbers are different
    return sanitizedOriginalNumber !== sanitizedNewNumber;
}
const $12efab610886518b$export$10b95f20cee1ec4c = [
    {
        "ISOCountryCode": "AF",
        "name": "Afghanistan",
        "dialCode": "93"
    },
    {
        "ISOCountryCode": "AL",
        "name": "Albania",
        "dialCode": "355"
    },
    {
        "ISOCountryCode": "DZ",
        "name": "Algeria",
        "dialCode": "213"
    },
    {
        "ISOCountryCode": "AS",
        "name": "American Samoa",
        "dialCode": "1684"
    },
    {
        "ISOCountryCode": "AD",
        "name": "Andorra",
        "dialCode": "376"
    },
    {
        "ISOCountryCode": "AO",
        "name": "Angola",
        "dialCode": "244"
    },
    {
        "ISOCountryCode": "AI",
        "name": "Anguilla",
        "dialCode": "1264"
    },
    {
        "ISOCountryCode": "AG",
        "name": "Antigua & Barbuda",
        "dialCode": "1268"
    },
    {
        "ISOCountryCode": "AR",
        "name": "Argentina",
        "dialCode": "54"
    },
    {
        "ISOCountryCode": "AM",
        "name": "Armenia",
        "dialCode": "374"
    },
    {
        "ISOCountryCode": "AW",
        "name": "Aruba",
        "dialCode": "297"
    },
    {
        "ISOCountryCode": "AC",
        "name": "Ascension Island",
        "dialCode": "247"
    },
    {
        "ISOCountryCode": "AU",
        "name": "Australia",
        "dialCode": "61"
    },
    {
        "ISOCountryCode": "AT",
        "name": "Austria",
        "dialCode": "43"
    },
    {
        "ISOCountryCode": "AZ",
        "name": "Azerbaijan",
        "dialCode": "994"
    },
    {
        "ISOCountryCode": "BS",
        "name": "Bahamas",
        "dialCode": "1242"
    },
    {
        "ISOCountryCode": "BH",
        "name": "Bahrain",
        "dialCode": "973"
    },
    {
        "ISOCountryCode": "BD",
        "name": "Bangladesh",
        "dialCode": "880"
    },
    {
        "ISOCountryCode": "BB",
        "name": "Barbados",
        "dialCode": "1246"
    },
    {
        "ISOCountryCode": "BY",
        "name": "Belarus",
        "dialCode": "375"
    },
    {
        "ISOCountryCode": "BE",
        "name": "Belgium",
        "dialCode": "32"
    },
    {
        "ISOCountryCode": "BZ",
        "name": "Belize",
        "dialCode": "501"
    },
    {
        "ISOCountryCode": "BJ",
        "name": "Benin",
        "dialCode": "229"
    },
    {
        "ISOCountryCode": "BM",
        "name": "Bermuda",
        "dialCode": "1441"
    },
    {
        "ISOCountryCode": "BT",
        "name": "Bhutan",
        "dialCode": "975"
    },
    {
        "ISOCountryCode": "BO",
        "name": "Bolivia",
        "dialCode": "591"
    },
    {
        "ISOCountryCode": "BA",
        "name": "Bosnia & Herzegovina",
        "dialCode": "387"
    },
    {
        "ISOCountryCode": "BW",
        "name": "Botswana",
        "dialCode": "267"
    },
    {
        "ISOCountryCode": "BR",
        "name": "Brazil",
        "dialCode": "55"
    },
    {
        "ISOCountryCode": "IO",
        "name": "British Indian Ocean Territory",
        "dialCode": "246"
    },
    {
        "ISOCountryCode": "VG",
        "name": "British Virgin Islands",
        "dialCode": "1284"
    },
    {
        "ISOCountryCode": "BN",
        "name": "Brunei",
        "dialCode": "673"
    },
    {
        "ISOCountryCode": "BG",
        "name": "Bulgaria",
        "dialCode": "359"
    },
    {
        "ISOCountryCode": "BF",
        "name": "Burkina Faso",
        "dialCode": "226"
    },
    {
        "ISOCountryCode": "BI",
        "name": "Burundi",
        "dialCode": "257"
    },
    {
        "ISOCountryCode": "KH",
        "name": "Cambodia",
        "dialCode": "855"
    },
    {
        "ISOCountryCode": "CM",
        "name": "Cameroon",
        "dialCode": "237"
    },
    {
        "ISOCountryCode": "CA",
        "name": "Canada",
        "dialCode": "1"
    },
    {
        "ISOCountryCode": "CV",
        "name": "Cape Verde",
        "dialCode": "238"
    },
    {
        "ISOCountryCode": "BQ",
        "name": "Caribbean Netherlands",
        "dialCode": "599"
    },
    {
        "ISOCountryCode": "KY",
        "name": "Cayman Islands",
        "dialCode": "1345"
    },
    {
        "ISOCountryCode": "CF",
        "name": "Central African Republic",
        "dialCode": "236"
    },
    {
        "ISOCountryCode": "TD",
        "name": "Chad",
        "dialCode": "235"
    },
    {
        "ISOCountryCode": "CL",
        "name": "Chile",
        "dialCode": "56"
    },
    {
        "ISOCountryCode": "CN",
        "name": "China",
        "dialCode": "86"
    },
    {
        "ISOCountryCode": "CX",
        "name": "Christmas Island",
        "dialCode": "61"
    },
    {
        "ISOCountryCode": "CC",
        "name": "Cocos (Keeling) Islands",
        "dialCode": "61"
    },
    {
        "ISOCountryCode": "CO",
        "name": "Colombia",
        "dialCode": "57"
    },
    {
        "ISOCountryCode": "KM",
        "name": "Comoros",
        "dialCode": "269"
    },
    {
        "ISOCountryCode": "CD",
        "name": "Congo - Kinshasa",
        "dialCode": "243"
    },
    {
        "ISOCountryCode": "CG",
        "name": "Congo - Brazzaville",
        "dialCode": "242"
    },
    {
        "ISOCountryCode": "CK",
        "name": "Cook Islands",
        "dialCode": "682"
    },
    {
        "ISOCountryCode": "CR",
        "name": "Costa Rica",
        "dialCode": "506"
    },
    {
        "ISOCountryCode": "HR",
        "name": "Croatia",
        "dialCode": "385"
    },
    {
        "ISOCountryCode": "CU",
        "name": "Cuba",
        "dialCode": "53"
    },
    {
        "ISOCountryCode": "CW",
        "name": "Cura\xe7ao",
        "dialCode": "599"
    },
    {
        "ISOCountryCode": "CY",
        "name": "Cyprus",
        "dialCode": "357"
    },
    {
        "ISOCountryCode": "CZ",
        "name": "Czechia",
        "dialCode": "420"
    },
    {
        "ISOCountryCode": "CI",
        "name": "C\xf4te d'Ivoire",
        "dialCode": "225"
    },
    {
        "ISOCountryCode": "DK",
        "name": "Denmark",
        "dialCode": "45"
    },
    {
        "ISOCountryCode": "DJ",
        "name": "Djibouti",
        "dialCode": "253"
    },
    {
        "ISOCountryCode": "DM",
        "name": "Dominica",
        "dialCode": "1767"
    },
    {
        "ISOCountryCode": "DO",
        "name": "Dominican Republic",
        "dialCode": "1"
    },
    {
        "ISOCountryCode": "EC",
        "name": "Ecuador",
        "dialCode": "593"
    },
    {
        "ISOCountryCode": "EG",
        "name": "Egypt",
        "dialCode": "20"
    },
    {
        "ISOCountryCode": "SV",
        "name": "El Salvador",
        "dialCode": "503"
    },
    {
        "ISOCountryCode": "GQ",
        "name": "Equatorial Guinea",
        "dialCode": "240"
    },
    {
        "ISOCountryCode": "ER",
        "name": "Eritrea",
        "dialCode": "291"
    },
    {
        "ISOCountryCode": "EE",
        "name": "Estonia",
        "dialCode": "372"
    },
    {
        "ISOCountryCode": "ET",
        "name": "Ethiopia",
        "dialCode": "251"
    },
    {
        "ISOCountryCode": "FK",
        "name": "Falkland Islands",
        "dialCode": "500"
    },
    {
        "ISOCountryCode": "FO",
        "name": "Faroe Islands",
        "dialCode": "298"
    },
    {
        "ISOCountryCode": "FJ",
        "name": "Fiji",
        "dialCode": "679"
    },
    {
        "ISOCountryCode": "FI",
        "name": "Finland",
        "dialCode": "358"
    },
    {
        "ISOCountryCode": "FR",
        "name": "France",
        "dialCode": "33"
    },
    {
        "ISOCountryCode": "GF",
        "name": "French Guiana",
        "dialCode": "594"
    },
    {
        "ISOCountryCode": "PF",
        "name": "French Polynesia",
        "dialCode": "689"
    },
    {
        "ISOCountryCode": "GA",
        "name": "Gabon",
        "dialCode": "241"
    },
    {
        "ISOCountryCode": "GM",
        "name": "Gambia",
        "dialCode": "220"
    },
    {
        "ISOCountryCode": "GE",
        "name": "Georgia",
        "dialCode": "995"
    },
    {
        "ISOCountryCode": "DE",
        "name": "Germany",
        "dialCode": "49"
    },
    {
        "ISOCountryCode": "GH",
        "name": "Ghana",
        "dialCode": "233"
    },
    {
        "ISOCountryCode": "GI",
        "name": "Gibraltar",
        "dialCode": "350"
    },
    {
        "ISOCountryCode": "GR",
        "name": "Greece",
        "dialCode": "30"
    },
    {
        "ISOCountryCode": "GL",
        "name": "Greenland",
        "dialCode": "299"
    },
    {
        "ISOCountryCode": "GD",
        "name": "Grenada",
        "dialCode": "1473"
    },
    {
        "ISOCountryCode": "GP",
        "name": "Guadeloupe",
        "dialCode": "590"
    },
    {
        "ISOCountryCode": "GU",
        "name": "Guam",
        "dialCode": "1671"
    },
    {
        "ISOCountryCode": "GT",
        "name": "Guatemala",
        "dialCode": "502"
    },
    {
        "ISOCountryCode": "GG",
        "name": "Guernsey",
        "dialCode": "44"
    },
    {
        "ISOCountryCode": "GN",
        "name": "Guinea",
        "dialCode": "224"
    },
    {
        "ISOCountryCode": "GW",
        "name": "Guinea-Bissau",
        "dialCode": "245"
    },
    {
        "ISOCountryCode": "GY",
        "name": "Guyana",
        "dialCode": "592"
    },
    {
        "ISOCountryCode": "HT",
        "name": "Haiti",
        "dialCode": "509"
    },
    {
        "ISOCountryCode": "HN",
        "name": "Honduras",
        "dialCode": "504"
    },
    {
        "ISOCountryCode": "HK",
        "name": "Hong Kong",
        "dialCode": "852"
    },
    {
        "ISOCountryCode": "HU",
        "name": "Hungary",
        "dialCode": "36"
    },
    {
        "ISOCountryCode": "IS",
        "name": "Iceland",
        "dialCode": "354"
    },
    {
        "ISOCountryCode": "IN",
        "name": "India",
        "dialCode": "91"
    },
    {
        "ISOCountryCode": "ID",
        "name": "Indonesia",
        "dialCode": "62"
    },
    {
        "ISOCountryCode": "IR",
        "name": "Iran",
        "dialCode": "98"
    },
    {
        "ISOCountryCode": "IQ",
        "name": "Iraq",
        "dialCode": "964"
    },
    {
        "ISOCountryCode": "IE",
        "name": "Ireland",
        "dialCode": "353"
    },
    {
        "ISOCountryCode": "IM",
        "name": "Isle of Man",
        "dialCode": "44"
    },
    {
        "ISOCountryCode": "IL",
        "name": "Israel",
        "dialCode": "972"
    },
    {
        "ISOCountryCode": "IT",
        "name": "Italy",
        "dialCode": "39"
    },
    {
        "ISOCountryCode": "JM",
        "name": "Jamaica",
        "dialCode": "1876"
    },
    {
        "ISOCountryCode": "JP",
        "name": "Japan",
        "dialCode": "81"
    },
    {
        "ISOCountryCode": "JE",
        "name": "Jersey",
        "dialCode": "44"
    },
    {
        "ISOCountryCode": "JO",
        "name": "Jordan",
        "dialCode": "962"
    },
    {
        "ISOCountryCode": "KZ",
        "name": "Kazakhstan",
        "dialCode": "7"
    },
    {
        "ISOCountryCode": "KE",
        "name": "Kenya",
        "dialCode": "254"
    },
    {
        "ISOCountryCode": "KI",
        "name": "Kiribati",
        "dialCode": "686"
    },
    {
        "ISOCountryCode": "XK",
        "name": "Kosovo",
        "dialCode": "383"
    },
    {
        "ISOCountryCode": "KW",
        "name": "Kuwait",
        "dialCode": "965"
    },
    {
        "ISOCountryCode": "KG",
        "name": "Kyrgyzstan",
        "dialCode": "996"
    },
    {
        "ISOCountryCode": "LA",
        "name": "Laos",
        "dialCode": "856"
    },
    {
        "ISOCountryCode": "LV",
        "name": "Latvia",
        "dialCode": "371"
    },
    {
        "ISOCountryCode": "LB",
        "name": "Lebanon",
        "dialCode": "961"
    },
    {
        "ISOCountryCode": "LS",
        "name": "Lesotho",
        "dialCode": "266"
    },
    {
        "ISOCountryCode": "LR",
        "name": "Liberia",
        "dialCode": "231"
    },
    {
        "ISOCountryCode": "LY",
        "name": "Libya",
        "dialCode": "218"
    },
    {
        "ISOCountryCode": "LI",
        "name": "Liechtenstein",
        "dialCode": "423"
    },
    {
        "ISOCountryCode": "LT",
        "name": "Lithuania",
        "dialCode": "370"
    },
    {
        "ISOCountryCode": "LU",
        "name": "Luxembourg",
        "dialCode": "352"
    },
    {
        "ISOCountryCode": "MO",
        "name": "Macau",
        "dialCode": "853"
    },
    {
        "ISOCountryCode": "MK",
        "name": "North Macedonia",
        "dialCode": "389"
    },
    {
        "ISOCountryCode": "MG",
        "name": "Madagascar",
        "dialCode": "261"
    },
    {
        "ISOCountryCode": "MW",
        "name": "Malawi",
        "dialCode": "265"
    },
    {
        "ISOCountryCode": "MY",
        "name": "Malaysia",
        "dialCode": "60"
    },
    {
        "ISOCountryCode": "MV",
        "name": "Maldives",
        "dialCode": "960"
    },
    {
        "ISOCountryCode": "ML",
        "name": "Mali",
        "dialCode": "223"
    },
    {
        "ISOCountryCode": "MT",
        "name": "Malta",
        "dialCode": "356"
    },
    {
        "ISOCountryCode": "MH",
        "name": "Marshall Islands",
        "dialCode": "692"
    },
    {
        "ISOCountryCode": "MQ",
        "name": "Martinique",
        "dialCode": "596"
    },
    {
        "ISOCountryCode": "MR",
        "name": "Mauritania",
        "dialCode": "222"
    },
    {
        "ISOCountryCode": "MU",
        "name": "Mauritius",
        "dialCode": "230"
    },
    {
        "ISOCountryCode": "YT",
        "name": "Mayotte",
        "dialCode": "262"
    },
    {
        "ISOCountryCode": "MX",
        "name": "Mexico",
        "dialCode": "52"
    },
    {
        "ISOCountryCode": "FM",
        "name": "Micronesia",
        "dialCode": "691"
    },
    {
        "ISOCountryCode": "MD",
        "name": "Moldova",
        "dialCode": "373"
    },
    {
        "ISOCountryCode": "MC",
        "name": "Monaco",
        "dialCode": "377"
    },
    {
        "ISOCountryCode": "MN",
        "name": "Mongolia",
        "dialCode": "976"
    },
    {
        "ISOCountryCode": "ME",
        "name": "Montenegro",
        "dialCode": "382"
    },
    {
        "ISOCountryCode": "MS",
        "name": "Montserrat",
        "dialCode": "1664"
    },
    {
        "ISOCountryCode": "MA",
        "name": "Morocco",
        "dialCode": "212"
    },
    {
        "ISOCountryCode": "MZ",
        "name": "Mozambique",
        "dialCode": "258"
    },
    {
        "ISOCountryCode": "MM",
        "name": "Myanmar",
        "dialCode": "95"
    },
    {
        "ISOCountryCode": "NA",
        "name": "Namibia",
        "dialCode": "264"
    },
    {
        "ISOCountryCode": "NR",
        "name": "Nauru",
        "dialCode": "674"
    },
    {
        "ISOCountryCode": "NP",
        "name": "Nepal",
        "dialCode": "977"
    },
    {
        "ISOCountryCode": "NL",
        "name": "Netherlands",
        "dialCode": "31"
    },
    {
        "ISOCountryCode": "NC",
        "name": "New Caledonia",
        "dialCode": "687"
    },
    {
        "ISOCountryCode": "NZ",
        "name": "New Zealand",
        "dialCode": "64"
    },
    {
        "ISOCountryCode": "NI",
        "name": "Nicaragua",
        "dialCode": "505"
    },
    {
        "ISOCountryCode": "NE",
        "name": "Niger",
        "dialCode": "227"
    },
    {
        "ISOCountryCode": "NG",
        "name": "Nigeria",
        "dialCode": "234"
    },
    {
        "ISOCountryCode": "NU",
        "name": "Niue",
        "dialCode": "683"
    },
    {
        "ISOCountryCode": "NF",
        "name": "Norfolk Island",
        "dialCode": "672"
    },
    {
        "ISOCountryCode": "KP",
        "name": "North Korea",
        "dialCode": "850"
    },
    {
        "ISOCountryCode": "MP",
        "name": "Northern Mariana Islands",
        "dialCode": "1670"
    },
    {
        "ISOCountryCode": "NO",
        "name": "Norway",
        "dialCode": "47"
    },
    {
        "ISOCountryCode": "OM",
        "name": "Oman",
        "dialCode": "968"
    },
    {
        "ISOCountryCode": "PK",
        "name": "Pakistan",
        "dialCode": "92"
    },
    {
        "ISOCountryCode": "PW",
        "name": "Palau",
        "dialCode": "680"
    },
    {
        "ISOCountryCode": "PS",
        "name": "Palestine",
        "dialCode": "970"
    },
    {
        "ISOCountryCode": "PA",
        "name": "Panama",
        "dialCode": "507"
    },
    {
        "ISOCountryCode": "PG",
        "name": "Papua New Guinea",
        "dialCode": "675"
    },
    {
        "ISOCountryCode": "PY",
        "name": "Paraguay",
        "dialCode": "595"
    },
    {
        "ISOCountryCode": "PE",
        "name": "Peru",
        "dialCode": "51"
    },
    {
        "ISOCountryCode": "PH",
        "name": "Philippines",
        "dialCode": "63"
    },
    {
        "ISOCountryCode": "PL",
        "name": "Poland",
        "dialCode": "48"
    },
    {
        "ISOCountryCode": "PT",
        "name": "Portugal",
        "dialCode": "351"
    },
    {
        "ISOCountryCode": "PR",
        "name": "Puerto Rico",
        "dialCode": "1"
    },
    {
        "ISOCountryCode": "QA",
        "name": "Qatar",
        "dialCode": "974"
    },
    {
        "ISOCountryCode": "RO",
        "name": "Romania",
        "dialCode": "40"
    },
    {
        "ISOCountryCode": "RU",
        "name": "Russia",
        "dialCode": "7"
    },
    {
        "ISOCountryCode": "RW",
        "name": "Rwanda",
        "dialCode": "250"
    },
    {
        "ISOCountryCode": "RE",
        "name": "R\xe9union",
        "dialCode": "262"
    },
    {
        "ISOCountryCode": "BL",
        "name": "Saint Barth\xe9lemy",
        "dialCode": "590"
    },
    {
        "ISOCountryCode": "SH",
        "name": "Saint Helena",
        "dialCode": "290"
    },
    {
        "ISOCountryCode": "KN",
        "name": "Saint Kitts & Nevis",
        "dialCode": "1869"
    },
    {
        "ISOCountryCode": "LC",
        "name": "Saint Lucia",
        "dialCode": "1758"
    },
    {
        "ISOCountryCode": "MF",
        "name": "Saint Martin",
        "dialCode": "590"
    },
    {
        "ISOCountryCode": "PM",
        "name": "Saint Pierre & Miquelon",
        "dialCode": "508"
    },
    {
        "ISOCountryCode": "VC",
        "name": "Saint Vincent & the Grenadines",
        "dialCode": "1784"
    },
    {
        "ISOCountryCode": "WS",
        "name": "Samoa",
        "dialCode": "685"
    },
    {
        "ISOCountryCode": "SM",
        "name": "San Marino",
        "dialCode": "378"
    },
    {
        "ISOCountryCode": "SA",
        "name": "Saudi Arabia",
        "dialCode": "966"
    },
    {
        "ISOCountryCode": "SN",
        "name": "Senegal",
        "dialCode": "221"
    },
    {
        "ISOCountryCode": "RS",
        "name": "Serbia",
        "dialCode": "381"
    },
    {
        "ISOCountryCode": "SC",
        "name": "Seychelles",
        "dialCode": "248"
    },
    {
        "ISOCountryCode": "SL",
        "name": "Sierra Leone",
        "dialCode": "232"
    },
    {
        "ISOCountryCode": "SG",
        "name": "Singapore",
        "dialCode": "65"
    },
    {
        "ISOCountryCode": "SX",
        "name": "Sint Maarten",
        "dialCode": "1721"
    },
    {
        "ISOCountryCode": "SK",
        "name": "Slovakia",
        "dialCode": "421"
    },
    {
        "ISOCountryCode": "SI",
        "name": "Slovenia",
        "dialCode": "386"
    },
    {
        "ISOCountryCode": "SB",
        "name": "Solomon Islands",
        "dialCode": "677"
    },
    {
        "ISOCountryCode": "SO",
        "name": "Somalia",
        "dialCode": "252"
    },
    {
        "ISOCountryCode": "ZA",
        "name": "South Africa",
        "dialCode": "27"
    },
    {
        "ISOCountryCode": "KR",
        "name": "South Korea",
        "dialCode": "82"
    },
    {
        "ISOCountryCode": "SS",
        "name": "South Sudan",
        "dialCode": "211"
    },
    {
        "ISOCountryCode": "ES",
        "name": "Spain",
        "dialCode": "34"
    },
    {
        "ISOCountryCode": "LK",
        "name": "Sri Lanka",
        "dialCode": "94"
    },
    {
        "ISOCountryCode": "SD",
        "name": "Sudan",
        "dialCode": "249"
    },
    {
        "ISOCountryCode": "SR",
        "name": "Suriname",
        "dialCode": "597"
    },
    {
        "ISOCountryCode": "SJ",
        "name": "Svalbard & Jan Mayen",
        "dialCode": "47"
    },
    {
        "ISOCountryCode": "SZ",
        "name": "Eswatini",
        "dialCode": "268"
    },
    {
        "ISOCountryCode": "SE",
        "name": "Sweden",
        "dialCode": "46"
    },
    {
        "ISOCountryCode": "CH",
        "name": "Switzerland",
        "dialCode": "41"
    },
    {
        "ISOCountryCode": "SY",
        "name": "Syria",
        "dialCode": "963"
    },
    {
        "ISOCountryCode": "ST",
        "name": "S\xe3o Tom\xe9 & Pr\xedncipe",
        "dialCode": "239"
    },
    {
        "ISOCountryCode": "TW",
        "name": "Taiwan",
        "dialCode": "886"
    },
    {
        "ISOCountryCode": "TJ",
        "name": "Tajikistan",
        "dialCode": "992"
    },
    {
        "ISOCountryCode": "TZ",
        "name": "Tanzania",
        "dialCode": "255"
    },
    {
        "ISOCountryCode": "TH",
        "name": "Thailand",
        "dialCode": "66"
    },
    {
        "ISOCountryCode": "TL",
        "name": "Timor-Leste",
        "dialCode": "670"
    },
    {
        "ISOCountryCode": "TG",
        "name": "Togo",
        "dialCode": "228"
    },
    {
        "ISOCountryCode": "TK",
        "name": "Tokelau",
        "dialCode": "690"
    },
    {
        "ISOCountryCode": "TO",
        "name": "Tonga",
        "dialCode": "676"
    },
    {
        "ISOCountryCode": "TT",
        "name": "Trinidad & Tobago",
        "dialCode": "1868"
    },
    {
        "ISOCountryCode": "TA",
        "name": "Tristan da Cunha",
        "dialCode": "290"
    },
    {
        "ISOCountryCode": "TN",
        "name": "Tunisia",
        "dialCode": "216"
    },
    {
        "ISOCountryCode": "TR",
        "name": "T\xfcrkiye",
        "dialCode": "90"
    },
    {
        "ISOCountryCode": "TM",
        "name": "Turkmenistan",
        "dialCode": "993"
    },
    {
        "ISOCountryCode": "TC",
        "name": "Turks & Caicos Islands",
        "dialCode": "1649"
    },
    {
        "ISOCountryCode": "TV",
        "name": "Tuvalu",
        "dialCode": "688"
    },
    {
        "ISOCountryCode": "VI",
        "name": "U.S. Virgin Islands",
        "dialCode": "1340"
    },
    {
        "ISOCountryCode": "UG",
        "name": "Uganda",
        "dialCode": "256"
    },
    {
        "ISOCountryCode": "UA",
        "name": "Ukraine",
        "dialCode": "380"
    },
    {
        "ISOCountryCode": "AE",
        "name": "United Arab Emirates",
        "dialCode": "971"
    },
    {
        "ISOCountryCode": "GB",
        "name": "United Kingdom",
        "dialCode": "44"
    },
    {
        "ISOCountryCode": "US",
        "name": "United States",
        "dialCode": "1"
    },
    {
        "ISOCountryCode": "UY",
        "name": "Uruguay",
        "dialCode": "598"
    },
    {
        "ISOCountryCode": "UZ",
        "name": "Uzbekistan",
        "dialCode": "998"
    },
    {
        "ISOCountryCode": "VU",
        "name": "Vanuatu",
        "dialCode": "678"
    },
    {
        "ISOCountryCode": "VA",
        "name": "Vatican City",
        "dialCode": "39"
    },
    {
        "ISOCountryCode": "VE",
        "name": "Venezuela",
        "dialCode": "58"
    },
    {
        "ISOCountryCode": "VN",
        "name": "Vietnam",
        "dialCode": "84"
    },
    {
        "ISOCountryCode": "WF",
        "name": "Wallis & Futuna",
        "dialCode": "681"
    },
    {
        "ISOCountryCode": "EH",
        "name": "Western Sahara",
        "dialCode": "212"
    },
    {
        "ISOCountryCode": "YE",
        "name": "Yemen",
        "dialCode": "967"
    },
    {
        "ISOCountryCode": "ZM",
        "name": "Zambia",
        "dialCode": "260"
    },
    {
        "ISOCountryCode": "ZW",
        "name": "Zimbabwe",
        "dialCode": "263"
    },
    {
        "ISOCountryCode": "AX",
        "name": "\xc5land Islands",
        "dialCode": "358"
    }
];
function $12efab610886518b$export$d43173606887dab3(localisedCountryNames) {
    return $12efab610886518b$export$10b95f20cee1ec4c.map((country)=>{
        return {
            value: country.ISOCountryCode,
            label: `${$12efab610886518b$export$64d92d620a3afdf(country.ISOCountryCode)} ${$12efab610886518b$var$getCountryLocalisedCountryName(localisedCountryNames, country.ISOCountryCode, country.name)} (+${country.dialCode})`
        };
    });
}
function $12efab610886518b$export$64d92d620a3afdf(code) {
    const codePoints = code.toUpperCase().split('').map((char)=>127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
}
function $12efab610886518b$export$4243670e46683f46(isoCode) {
    return $12efab610886518b$export$10b95f20cee1ec4c.find((el)=>el.ISOCountryCode === isoCode);
}
function $12efab610886518b$var$getCountryLocalisedCountryName(localisedCountrynames, isoCode, defaultCountryName) {
    if (localisedCountrynames[`Countries.${isoCode}`]) return localisedCountrynames[`Countries.${isoCode}`];
    return defaultCountryName;
}
function $12efab610886518b$export$8702a91932e94f59() {
    const location = navigator.language?.split("-")[1] || 'GB';
    const prefix = $12efab610886518b$export$10b95f20cee1ec4c.find((c)=>c.ISOCountryCode === location).dialCode;
    return {
        location: location,
        prefix: prefix
    };
}


const $41703b1a5cfec03b$var$UsePhoneNumberInput = (defaultData)=>{
    const [formData, setFormData] = (0, $aqdBs.useState)({
        countryCode: "",
        prefix: "",
        phoneNumber: ""
    });
    //setting default values on load
    (0, $aqdBs.useEffect)(()=>{
        if (defaultData) {
            const { location: location, prefix: prefix } = (0, $12efab610886518b$export$8702a91932e94f59)();
            setFormData({
                countryCode: defaultData.countryCode || location,
                prefix: prefix,
                phoneNumber: defaultData.phoneNumber || ""
            });
        }
    }, [
        defaultData
    ]);
    //on countrycode selection
    const handleCountryCode = (value)=>{
        const data = (0, $12efab610886518b$export$4243670e46683f46)(value);
        if (data?.ISOCountryCode) setFormData({
            ...formData,
            countryCode: data.ISOCountryCode,
            prefix: data.dialCode
        });
    };
    return {
        hidePhoneNumberInput: !defaultData,
        handleCountryCode: handleCountryCode,
        formData: formData,
        setFormData: setFormData
    };
};
var $41703b1a5cfec03b$export$2e2bcd8739ae039 = $41703b1a5cfec03b$var$UsePhoneNumberInput;




//icons




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
const $111ec9a9285ccd09$var$useDebounce = (value, delay)=>{
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = (0, $aqdBs.useState)(value);
    (0, $aqdBs.useEffect)(()=>{
        // Update debounced value after delay
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
};
var $111ec9a9285ccd09$export$2e2bcd8739ae039 = $111ec9a9285ccd09$var$useDebounce;


const $98e52e47dd432de8$var$useCountrySelectDropdown = ({ defaultValue: defaultValue, options: options, setValue: setValue, id: id, canDeselect: canDeselect })=>{
    const dropdownRef = (0, $aqdBs.useRef)(undefined);
    const [showDropdown, setShowDropdown] = (0, $aqdBs.useState)(false);
    const [activeElement, setActiveElement] = (0, $aqdBs.useState)('');
    const [selectedElement, setSelectedElement] = (0, $aqdBs.useState)(defaultValue);
    const [focusIndex, setFocusIndex] = (0, $aqdBs.useState)(0);
    const [typeAhead, setTypeAhead] = (0, $aqdBs.useState)('');
    const debouncedString = (0, $111ec9a9285ccd09$export$2e2bcd8739ae039)(typeAhead, 500);
    (0, $aqdBs.useEffect)(()=>{
        if (debouncedString) {
            const searchIndex = options.findIndex((el)=>el.label.split(' ')[1].toLowerCase().startsWith(debouncedString.toLowerCase()));
            if (searchIndex > 0) setFocusIndex(searchIndex);
        }
        setTypeAhead('');
    }, [
        debouncedString
    ]);
    (0, $aqdBs.useEffect)(()=>{
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setShowDropdown(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0, $aqdBs.useEffect)(()=>{
        setValue(selectedElement);
    }, [
        selectedElement
    ]);
    (0, $aqdBs.useEffect)(()=>{
        setSelectedElement(defaultValue);
    }, [
        defaultValue
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (!showDropdown) {
            setActiveElement(``);
            setFocusIndex(0);
        }
    }, [
        showDropdown
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (showDropdown) setAndFocusNextElement(getElementName(focusIndex));
    }, [
        focusIndex,
        showDropdown
    ]);
    function handleKeyPressOnButton(e) {
        switch(e.code){
            case 'ArrowDown':
            case 'ArrowUp':
            case 'Space':
            case 'Enter':
            case 'Home':
            case 'End':
                e.preventDefault();
                setShowDropdown(!showDropdown);
                setFocusIndex(e.code === 'End' ? options.length - 1 : 0);
                break;
            case 'Tab':
                setShowDropdown(false);
                document.getElementById(`${id}-open-menu-button`)?.focus();
                break;
        }
    }
    function handleKeyPressInList(e) {
        e.preventDefault();
        switch(e.code){
            case 'Tab':
                setSelectedElement(canDeselect && `${options[focusIndex].value}` === selectedElement ? '' : `${options[focusIndex].value}`);
                setShowDropdown(false);
                document.getElementById(`${id}-open-menu-button`)?.focus();
                break;
            case 'Enter':
            case 'Space':
                setSelectedElement(canDeselect && `${options[focusIndex].value}` === selectedElement ? '' : `${options[focusIndex].value}`);
                setShowDropdown(false);
                document.getElementById(`${id}-open-menu-button`)?.focus();
                break;
            case 'ArrowDown':
                e.preventDefault();
                setFocusIndex(focusIndex + 1 >= options.length ? 0 : focusIndex + 1);
                break;
            case 'ArrowUp':
                e.preventDefault();
                setFocusIndex(focusIndex - 1 < 0 ? options.length - 1 : focusIndex - 1);
                break;
            case 'Home':
                e.preventDefault();
                setFocusIndex(0);
                break;
            case 'End':
                e.preventDefault();
                setFocusIndex(options.length - 1);
                break;
            case 'Esc':
                setShowDropdown(false);
                document.getElementById(`${id}-open-menu-button`)?.focus();
                break;
            default:
                setTypeAhead(typeAhead + e.key);
        }
    }
    function setAndFocusNextElement(elementId) {
        if (!elementId) return;
        const element = document.getElementById(elementId);
        if (element) element.focus();
    }
    function getElementName(index) {
        return `${id}-option-${index}`;
    }
    return {
        dropdownRef: dropdownRef,
        setShowDropdown: setShowDropdown,
        showDropdown: showDropdown,
        activeElement: activeElement,
        handleKeyPressOnButton: handleKeyPressOnButton,
        selectedElement: selectedElement,
        setActiveElement: setActiveElement,
        setSelectedElement: setSelectedElement,
        handleKeyPressInList: handleKeyPressInList
    };
};
var $98e52e47dd432de8$export$2e2bcd8739ae039 = $98e52e47dd432de8$var$useCountrySelectDropdown;


const $4e6fca597a335bf6$var$CountrySelectDropdown = ({ id: id, setValue: setValue, buttonLabel: buttonLabel, options: options, defaultValue: defaultValue, canDeselect: canDeselect, buttonAriaLabel: buttonAriaLabel })=>{
    const { dropdownRef: dropdownRef, setShowDropdown: setShowDropdown, showDropdown: showDropdown, activeElement: activeElement, handleKeyPressOnButton: handleKeyPressOnButton, selectedElement: selectedElement, setActiveElement: setActiveElement, setSelectedElement: setSelectedElement, handleKeyPressInList: handleKeyPressInList } = (0, $98e52e47dd432de8$export$2e2bcd8739ae039)({
        defaultValue: defaultValue,
        options: options,
        setValue: setValue,
        id: id,
        canDeselect: canDeselect
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "country-select-drop-down-button-container",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
                id: `${id}-open-menu-button`,
                name: `${buttonLabel} select`,
                "aria-label": buttonAriaLabel,
                className: "country-select-dd-button",
                onClick: ()=>{
                    setShowDropdown(!showDropdown);
                },
                role: "combobox",
                "aria-controls": id,
                "aria-owns": id,
                "aria-expanded": showDropdown,
                "aria-activedescendant": activeElement,
                onKeyDown: (e)=>handleKeyPressOnButton(e),
                type: 'button',
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "country-select-button-label",
                        children: buttonLabel
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CHEVRON_RIGHT,
                        sizeInPx: "7",
                        color: "var(--thriveOffBlack)",
                        className: "chevron-down"
                    })
                ]
            }),
            showDropdown && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "country-select-drop-down-container",
                id: id,
                role: "listbox",
                children: options.map((el, idx)=>{
                    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        tabIndex: -1,
                        className: `country-select-dd-option ${selectedElement === el.value ? 'selected' : activeElement === `${id}-option-${idx}` ? 'active' : ''}`,
                        id: `${id}-option-${idx}`,
                        role: "option",
                        onMouseOver: ()=>{
                            setActiveElement(`${id}-option-${idx}`);
                        },
                        onClick: ()=>{
                            setSelectedElement(canDeselect && el.value === selectedElement ? '' : `${el.value}`);
                            setShowDropdown(false);
                        },
                        onKeyDown: (e)=>handleKeyPressInList(e),
                        onFocus: ()=>setActiveElement(`${id}-option-${idx}`),
                        children: el.label
                    }, `${id}-option-${idx}`);
                })
            })
        ]
    });
};
var $4e6fca597a335bf6$export$2e2bcd8739ae039 = $4e6fca597a335bf6$var$CountrySelectDropdown;


const $1d5e4a41c262533f$var$PhoneNumberInput = ({ defaultData: defaultData, phoneNumber: phoneNumber, setPhoneNumberData: setPhoneNumberData, darkText: darkText, PhoneNumberInputStrings: PhoneNumberInputStrings, localisedCountryNames: localisedCountryNames })=>{
    const { hidePhoneNumberInput: hidePhoneNumberInput, handleCountryCode: handleCountryCode, formData: formData, setFormData: setFormData } = (0, $41703b1a5cfec03b$export$2e2bcd8739ae039)(defaultData);
    if (hidePhoneNumberInput) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    (0, $aqdBs.useEffect)(()=>{
        setPhoneNumberData(formData);
    }, [
        formData.countryCode,
        formData.phoneNumber,
        formData.prefix
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: `phone-number-input-container ${!darkText && 'is-dark'}`,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: "phone-number-input-form",
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "phone-number-input-div",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4e6fca597a335bf6$export$2e2bcd8739ae039), {
                        id: "country-select",
                        setValue: (val)=>handleCountryCode(val),
                        buttonLabel: (0, $12efab610886518b$export$64d92d620a3afdf)(formData.countryCode),
                        options: (0, $12efab610886518b$export$d43173606887dab3)(localisedCountryNames),
                        defaultValue: formData.countryCode,
                        buttonAriaLabel: `select country - ${formData.countryCode} selected`
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                        className: "phone-number-input",
                        id: "phone-number-input",
                        "data-testid": "phone-number-input",
                        "aria-label": PhoneNumberInputStrings?.AriaLabel,
                        placeholder: phoneNumber || PhoneNumberInputStrings?.Placeholder,
                        type: "tel",
                        onInput: (e)=>{
                            const number = e.currentTarget.value.replace(/\D/g, "");
                            setFormData({
                                ...formData,
                                phoneNumber: number
                            });
                        },
                        value: formData.phoneNumber
                    })
                ]
            })
        })
    });
};
var $1d5e4a41c262533f$export$2e2bcd8739ae039 = $1d5e4a41c262533f$var$PhoneNumberInput;



parcelRequire("aqdBs");
const $629fb6072920a7a2$var$CheckboxList = ({ title: title, items: items, className: className = '' })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `checkbox-list-wrapper ${className}`,
        children: [
            title && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                className: "checkbox-list-title",
                children: title
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("ul", {
                className: "checkbox-list",
                children: items.map((item)=>{
                    const key = `${item.text}-${item.value}`.split(' ').join('-');
                    const checkboxId = `checkbox-item-${key}`;
                    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("li", {
                        className: `checkbox-list-item ${item.disabled ? 'disabled-style' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                                type: "checkbox",
                                id: checkboxId,
                                className: "checkbox-input",
                                checked: item.checked,
                                disabled: item.disabled,
                                onChange: (e)=>{
                                    e.preventDefault();
                                    item.onChange();
                                },
                                "aria-checked": item.checked,
                                "aria-disabled": item.disabled
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                                className: "checkbox-label-text",
                                htmlFor: checkboxId,
                                onClick: (e)=>{
                                    e.preventDefault();
                                    item.onChange();
                                },
                                children: item.text
                            })
                        ]
                    }, `checkbox-list-item-${key}`);
                })
            })
        ]
    });
};
var $629fb6072920a7a2$export$2e2bcd8739ae039 = $629fb6072920a7a2$var$CheckboxList;




var $aqdBs = parcelRequire("aqdBs");
const $d3935e1099933189$var$SelectItemList = ({ items: items, showCheckbox: showCheckbox, handleClick: handleClick })=>{
    const [focusedIndex, setFocusedIndex] = (0, $aqdBs.useState)(0);
    const listRef = (0, $aqdBs.useRef)(null);
    const handleKeyDown = (event, index)=>{
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                setFocusedIndex((prev)=>prev === null ? 0 : Math.min(prev + 1, items.length - 1));
                break;
            case "ArrowUp":
                event.preventDefault();
                setFocusedIndex((prev)=>prev === null ? 0 : Math.max(prev - 1, 0));
                break;
            case "Enter":
            case " ":
                event.preventDefault();
                handleClick(index);
                break;
            case "Escape":
                setFocusedIndex(null);
            default:
                break;
        }
    };
    const handleItemClick = (e, index)=>{
        e.preventDefault();
        handleClick(index);
    };
    (0, $aqdBs.useEffect)(()=>{
        if (focusedIndex !== null && listRef.current) {
            const focusedItem = listRef.current.children[focusedIndex];
            if (focusedItem) {
                focusedItem.scrollIntoView({
                    block: 'nearest'
                });
                const listItemElement = focusedItem.querySelector('.select-list-item');
                if (listItemElement) listItemElement.focus(); // Focus the button itself
            }
        }
    }, [
        focusedIndex
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("ul", {
        ref: listRef,
        className: `select-list ${items.length === 1 ? 'single-item' : ''}`,
        role: "menu",
        children: items.map((item, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
                className: `select-list-item ${item.isSelected && 'is-selected'}`,
                onClick: (e)=>handleItemClick(e, index),
                onKeyDown: (event)=>handleKeyDown(event, index),
                role: "menuitem",
                tabIndex: 0,
                "aria-disabled": item?.isDisabled,
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "list-content",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                                className: "header",
                                children: [
                                    item.header,
                                    " ",
                                    item?.tooltipIcon
                                ]
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                className: "content",
                                children: item.content
                            })
                        ]
                    }),
                    showCheckbox && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "custom-checkbox",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                                type: "checkbox",
                                checked: item.isSelected,
                                readOnly: true,
                                tabIndex: -1,
                                "aria-label": `Select ${item.header}`,
                                disabled: item?.isDisabled
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                className: "custom-list-checkmark"
                            })
                        ]
                    })
                ]
            }, index))
    });
};
var $d3935e1099933189$export$2e2bcd8739ae039 = $d3935e1099933189$var$SelectItemList;




var $aqdBs = parcelRequire("aqdBs");

parcelRequire("aqdBs");




parcelRequire("aqdBs");


const $2f997fb995af20df$var$DragButton = ({ dragRef: dragRef, className: className })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        ref: dragRef,
        className: `drag-button ${className ?? ""}`,
        "aria-hidden": "true",
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).DRAG,
            color: "#999EA5",
            sizeInPx: "12"
        })
    });
};
var $2f997fb995af20df$export$2e2bcd8739ae039 = $2f997fb995af20df$var$DragButton;




var $aqdBs = parcelRequire("aqdBs");
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function $22090dc29d3a2da1$export$f5708dca728d7177(condition, format, ...args) {
    if ($22090dc29d3a2da1$var$isProduction()) {
        if (format === undefined) throw new Error('invariant requires an error message argument');
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $22090dc29d3a2da1$var$isProduction() {
    return false;
}


var $c7e0a6ffc4b4ae5b$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$c7e0a6ffc4b4ae5b$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
const $c30917fa9ef9f7d8$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $aqdBs.useLayoutEffect) : (0, $aqdBs.useEffect);


function $0007bfa09c594dfb$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $aqdBs.useState)(()=>collect(monitor));
    const updateCollected = (0, $aqdBs.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($c7e0a6ffc4b4ae5b$exports)))(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, $c30917fa9ef9f7d8$export$700979bc83e7db82)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}



function $6c53859fa0486416$export$f34439a5e43bd79c(monitor, collect, onCollect) {
    const [collected, updateCollected] = (0, $0007bfa09c594dfb$export$e32e64a4387f290a)(monitor, collect, onCollect);
    (0, $c30917fa9ef9f7d8$export$700979bc83e7db82)(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}


function $03038c571975e443$export$a55a4e3c0acb6f15(collector, monitor, connector) {
    return (0, $6c53859fa0486416$export$f34439a5e43bd79c)(monitor, collector || (()=>({})), ()=>connector.reconnect());
}



var $aqdBs = parcelRequire("aqdBs");
function $2f34505569b563a5$export$f16a07909151e918(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== 'function') memoDeps.push(arg);
    return (0, $aqdBs.useMemo)(()=>{
        return typeof arg === 'function' ? arg() : arg;
    }, memoDeps);
}



var $aqdBs = parcelRequire("aqdBs");
function $7b3e766f19d01a39$export$90c397533e0cc6(connector) {
    return (0, $aqdBs.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $7b3e766f19d01a39$export$a66b3011bc8970d6(connector) {
    return (0, $aqdBs.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}



var $aqdBs = parcelRequire("aqdBs");
function $d90a4931040dec5e$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}


function $4c80abe330f35cf4$export$4f9f5282de18fc69(obj) {
    return obj !== null && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current');
}




var $aqdBs = parcelRequire("aqdBs");
function $6272e89497aa74bd$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') return;
    const displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + `You can either wrap ${displayName} into a <div>, or turn it into a ` + 'drag source or a drop target itself.');
}
function $6272e89497aa74bd$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $aqdBs.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $6272e89497aa74bd$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $6272e89497aa74bd$var$cloneWithRef(element, ref);
    };
}
function $6272e89497aa74bd$export$d8dcaf80ab4f6cb7(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith('Ref')) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $6272e89497aa74bd$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $6272e89497aa74bd$var$setRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else ref.current = node;
}
function $6272e89497aa74bd$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof previousRef !== 'string', "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $aqdBs.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $aqdBs.cloneElement)(element, {
        ref: (node)=>{
            $6272e89497aa74bd$var$setRef(previousRef, node);
            $6272e89497aa74bd$var$setRef(newRef, node);
        }
    });
}


class $839234a1e03a3595$export$9a7176fb37ab5028 {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !(0, $d90a4931040dec5e$export$d36bdfa510afb180)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !(0, $d90a4931040dec5e$export$d36bdfa510afb180)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = (0, $6272e89497aa74bd$export$d8dcaf80ab4f6cb7)({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ((0, $4c80abe330f35cf4$export$4f9f5282de18fc69)(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ((0, $4c80abe330f35cf4$export$4f9f5282de18fc69)(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
const $f57957e5437c5761$export$2d5c5ceac203fc1e = (0, $aqdBs.createContext)({
    dragDropManager: undefined
});


function $b2c740964fc4e407$export$49db7e1a057ab0fa() {
    const { dragDropManager: dragDropManager } = (0, $aqdBs.useContext)((0, $f57957e5437c5761$export$2d5c5ceac203fc1e));
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(dragDropManager != null, 'Expected drag drop context');
    return dragDropManager;
}



function $be0b095d88337257$export$a5dfa024c6f78e86(dragSourceOptions, dragPreviewOptions) {
    const manager = (0, $b2c740964fc4e407$export$49db7e1a057ab0fa)();
    const connector = (0, $aqdBs.useMemo)(()=>new (0, $839234a1e03a3595$export$9a7176fb37ab5028)(manager.getBackend()), [
        manager
    ]);
    (0, $c30917fa9ef9f7d8$export$700979bc83e7db82)(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, $c30917fa9ef9f7d8$export$700979bc83e7db82)(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}



var $aqdBs = parcelRequire("aqdBs");

let $9308de7c53953931$var$isCallingCanDrag = false;
let $9308de7c53953931$var$isCallingIsDragging = false;
class $9308de7c53953931$export$af934094fb48ddf {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(!$9308de7c53953931$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $9308de7c53953931$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $9308de7c53953931$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(!$9308de7c53953931$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $9308de7c53953931$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $9308de7c53953931$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}



function $8ff8b36035a76bf5$export$82f95eab323fcd7a() {
    const manager = (0, $b2c740964fc4e407$export$49db7e1a057ab0fa)();
    return (0, $aqdBs.useMemo)(()=>new (0, $9308de7c53953931$export$af934094fb48ddf)(manager), [
        manager
    ]);
}


function $8067ca214b8e18a2$export$38b18180ae58b09b(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $8067ca214b8e18a2$export$51c814b9e17958c(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}





var $aqdBs = parcelRequire("aqdBs");
class $57715723aa9a3f88$export$680f0a3c92f9d645 {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === 'object') result = spec.item;
        else if (typeof spec.item === 'function') result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === 'boolean') return spec.canDrag;
        else if (typeof spec.canDrag === 'function') return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}


function $c68be380cfe66be3$export$cdddb20adb7aad5c(spec, monitor, connector) {
    const handler = (0, $aqdBs.useMemo)(()=>new (0, $57715723aa9a3f88$export$680f0a3c92f9d645)(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $aqdBs.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}




var $aqdBs = parcelRequire("aqdBs");
function $49b5f9750d7db540$export$dec3a5d742510a3f(spec) {
    return (0, $aqdBs.useMemo)(()=>{
        const result = spec.type;
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(result != null, 'spec.type must be defined');
        return result;
    }, [
        spec
    ]);
}


function $137d3aa64b0d6942$export$1bdd19ff5ac2e03c(spec, monitor, connector) {
    const manager = (0, $b2c740964fc4e407$export$49db7e1a057ab0fa)();
    const handler = (0, $c68be380cfe66be3$export$cdddb20adb7aad5c)(spec, monitor, connector);
    const itemType = (0, $49b5f9750d7db540$export$dec3a5d742510a3f)(spec);
    (0, $c30917fa9ef9f7d8$export$700979bc83e7db82)(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = (0, $8067ca214b8e18a2$export$51c814b9e17958c)(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}


function $4de504bcfcc89199$export$7941f8aafa4b6021(specArg, deps) {
    const spec = (0, $2f34505569b563a5$export$f16a07909151e918)(specArg, deps);
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = (0, $8ff8b36035a76bf5$export$82f95eab323fcd7a)();
    const connector = (0, $be0b095d88337257$export$a5dfa024c6f78e86)(spec.options, spec.previewOptions);
    (0, $137d3aa64b0d6942$export$1bdd19ff5ac2e03c)(spec, monitor, connector);
    return [
        (0, $03038c571975e443$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $7b3e766f19d01a39$export$90c397533e0cc6)(connector),
        (0, $7b3e766f19d01a39$export$a66b3011bc8970d6)(connector)
    ];
}




var $aqdBs = parcelRequire("aqdBs");
function $dd8dfe5bc9a53eee$export$c914595a34b9504a(connector) {
    return (0, $aqdBs.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}



var $aqdBs = parcelRequire("aqdBs");



class $a10c6d8ab2241f6a$export$ed6d7b7bc55193cf {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !(0, $d90a4931040dec5e$export$d36bdfa510afb180)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = (0, $6272e89497aa74bd$export$d8dcaf80ab4f6cb7)({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ((0, $4c80abe330f35cf4$export$4f9f5282de18fc69)(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}




function $8df0f3a8f19950f8$export$29242ded1aad6df7(options) {
    const manager = (0, $b2c740964fc4e407$export$49db7e1a057ab0fa)();
    const connector = (0, $aqdBs.useMemo)(()=>new (0, $a10c6d8ab2241f6a$export$ed6d7b7bc55193cf)(manager.getBackend()), [
        manager
    ]);
    (0, $c30917fa9ef9f7d8$export$700979bc83e7db82)(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}



var $aqdBs = parcelRequire("aqdBs");

let $bb62f54f7cd36151$var$isCallingCanDrop = false;
class $bb62f54f7cd36151$export$9fe8834769ae8ddf {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(!$bb62f54f7cd36151$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $bb62f54f7cd36151$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $bb62f54f7cd36151$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}



function $5038d76470766f6e$export$f0c0ad05844dec3b() {
    const manager = (0, $b2c740964fc4e407$export$49db7e1a057ab0fa)();
    return (0, $aqdBs.useMemo)(()=>new (0, $bb62f54f7cd36151$export$9fe8834769ae8ddf)(manager), [
        manager
    ]);
}







var $aqdBs = parcelRequire("aqdBs");
function $efab81d784673b4b$export$2a5cc7f0ac8651d0(spec) {
    const { accept: accept } = spec;
    return (0, $aqdBs.useMemo)(()=>{
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(spec.accept != null, 'accept must be defined');
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}



var $aqdBs = parcelRequire("aqdBs");
class $b66e0bcb682f3445$export$f26a17703f5cb233 {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}


function $02e28c3c0602dd0f$export$5967d4bb72ce3c0(spec, monitor) {
    const dropTarget = (0, $aqdBs.useMemo)(()=>new (0, $b66e0bcb682f3445$export$f26a17703f5cb233)(spec, monitor), [
        monitor
    ]);
    (0, $aqdBs.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}


function $562bdf368784a95b$export$b31a008bfacf9de1(spec, monitor, connector) {
    const manager = (0, $b2c740964fc4e407$export$49db7e1a057ab0fa)();
    const dropTarget = (0, $02e28c3c0602dd0f$export$5967d4bb72ce3c0)(spec, monitor);
    const accept = (0, $efab81d784673b4b$export$2a5cc7f0ac8651d0)(spec);
    (0, $c30917fa9ef9f7d8$export$700979bc83e7db82)(function registerDropTarget() {
        const [handlerId, unregister] = (0, $8067ca214b8e18a2$export$38b18180ae58b09b)(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join('|')
    ]);
}


function $7f734ad0ca199756$export$ccdee5eaf73cf661(specArg, deps) {
    const spec = (0, $2f34505569b563a5$export$f16a07909151e918)(specArg, deps);
    const monitor = (0, $5038d76470766f6e$export$f0c0ad05844dec3b)();
    const connector = (0, $8df0f3a8f19950f8$export$29242ded1aad6df7)(spec.options);
    (0, $562bdf368784a95b$export$b31a008bfacf9de1)(spec, monitor, connector);
    return [
        (0, $03038c571975e443$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $dd8dfe5bc9a53eee$export$c914595a34b9504a)(connector)
    ];
}


const $3b05b82a27d12e9f$var$UseTextOptionListItem = ({ index: index, hoverIndex: hoverIndex, containerRef: containerRef, moveListItem: moveListItem, setHoverIndex: setHoverIndex, dragAndDropAction: dragAndDropAction })=>{
    const rowRef = (0, $aqdBs.useRef)(null);
    const dragRef = (0, $aqdBs.useRef)(null);
    // Drag logic
    const [{ isDragging: isDragging }, drag, preview] = (0, $4de504bcfcc89199$export$7941f8aafa4b6021)({
        type: "ROW",
        item: {
            index: index
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            }),
        end: ()=>{
            setHoverIndex(null);
        }
    });
    drag(dragRef);
    const [, drop] = (0, $7f734ad0ca199756$export$ccdee5eaf73cf661)({
        accept: "ROW",
        hover (item) {
            if (!rowRef.current) return;
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) return;
            moveListItem(dragIndex, hoverIndex, false);
            setHoverIndex(hoverIndex);
            item.index = hoverIndex;
        },
        drop () {
            setHoverIndex(null);
            dragAndDropAction?.(hoverIndex ?? 0);
        }
    });
    (0, $aqdBs.useEffect)(()=>{
        preview(drop(rowRef));
    }, [
        preview,
        drop
    ]);
    (0, $aqdBs.useEffect)(()=>{
        document.body.style.cursor = isDragging ? "grabbing" : "inherit";
    }, [
        isDragging
    ]);
    (0, $aqdBs.useEffect)(()=>{
        const handleDragLeave = (event)=>{
            if (containerRef.current && !containerRef.current.contains(event.relatedTarget)) setHoverIndex(null);
        };
        containerRef?.current.addEventListener('dragleave', handleDragLeave);
        return ()=>containerRef?.current.addEventListener('dragleave', handleDragLeave);
    }, [
        containerRef
    ]);
    return {
        isDragging: isDragging,
        dragRef: dragRef,
        rowRef: rowRef
    };
};
var $3b05b82a27d12e9f$export$2e2bcd8739ae039 = $3b05b82a27d12e9f$var$UseTextOptionListItem;


const $cde1d49daeb32ecd$var$TextOptionListItem = ({ id: id, text: text, placeholderText: placeholderText, index: index, hoverIndex: hoverIndex, onEditOptionText: onEditOptionText, onDeleteOptionClick: onDeleteOptionClick, containerRef: containerRef, moveListItem: moveListItem, setHoverIndex: setHoverIndex, dragAndDropAction: dragAndDropAction, key: key })=>{
    const { isDragging: isDragging, dragRef: dragRef, rowRef: rowRef } = (0, $3b05b82a27d12e9f$export$2e2bcd8739ae039)({
        index: index,
        hoverIndex: hoverIndex,
        containerRef: containerRef,
        moveListItem: moveListItem,
        setHoverIndex: setHoverIndex,
        dragAndDropAction: dragAndDropAction
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("li", {
        ref: rowRef,
        className: `text-option-list-item ${isDragging ? "is-dragging" : ""}  ${index === hoverIndex ? "is-hovering" : ""}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e6534d004b9f2161$export$2e2bcd8739ae039), {
                className: "text-option-input",
                labelText: `Option text input at index ${id}`,
                labelIsHidden: true,
                placeholderText: placeholderText || "Option",
                textString: text,
                setTextString: (text)=>onEditOptionText(id, text)
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                className: "remove-text-option-button",
                ariaLabel: "remove option from list",
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).BIN,
                    color: "var(--thriveGreyDark)",
                    sizeInPx: "12"
                }),
                onButtonClick: ()=>onDeleteOptionClick(id)
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2f997fb995af20df$export$2e2bcd8739ae039), {
                dragRef: dragRef,
                className: "text-option-drag-and-drop"
            })
        ]
    }, key);
};
var $cde1d49daeb32ecd$export$2e2bcd8739ae039 = $cde1d49daeb32ecd$var$TextOptionListItem;



function $2a5cffbf708a3282$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2a5cffbf708a3282$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a5cffbf708a3282$export$2e2bcd8739ae039(o);
}



function $16388b0fad38caf5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2a5cffbf708a3282$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2a5cffbf708a3282$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $f9015ae936f7ff26$export$2e2bcd8739ae039(t) {
    var i = (0, $16388b0fad38caf5$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $2a5cffbf708a3282$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $2453772600aeac3c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $f9015ae936f7ff26$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $b938bd31b64185a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b938bd31b64185a8$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b938bd31b64185a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2453772600aeac3c$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b938bd31b64185a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $7ce27f1e58e53b02$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $7ce27f1e58e53b02$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $7ce27f1e58e53b02$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $7ce27f1e58e53b02$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $7ce27f1e58e53b02$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $7ce27f1e58e53b02$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $7ce27f1e58e53b02$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $7ce27f1e58e53b02$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $7ce27f1e58e53b02$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($7ce27f1e58e53b02$var$isDate(val)) return 'date';
    if ($7ce27f1e58e53b02$var$isError(val)) return 'error';
    var constructorName = $7ce27f1e58e53b02$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $7ce27f1e58e53b02$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $7ce27f1e58e53b02$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $7ce27f1e58e53b02$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $7ce27f1e58e53b02$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $7ce27f1e58e53b02$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(1));
        return enhancer($7ce27f1e58e53b02$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$7ce27f1e58e53b02$var$isPlainObject(action)) throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $7ce27f1e58e53b02$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$7ce27f1e58e53b02$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $7ce27f1e58e53b02$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$7ce27f1e58e53b02$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $7ce27f1e58e53b02$export$8928921ea2d3b126 = $7ce27f1e58e53b02$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $7ce27f1e58e53b02$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $7ce27f1e58e53b02$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $7ce27f1e58e53b02$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$7ce27f1e58e53b02$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $7ce27f1e58e53b02$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $7ce27f1e58e53b02$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $7ce27f1e58e53b02$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $7ce27f1e58e53b02$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $7ce27f1e58e53b02$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $7ce27f1e58e53b02$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $7ce27f1e58e53b02$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $7ce27f1e58e53b02$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $7ce27f1e58e53b02$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $7ce27f1e58e53b02$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $7ce27f1e58e53b02$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $7ce27f1e58e53b02$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $7ce27f1e58e53b02$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($7ce27f1e58e53b02$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $7ce27f1e58e53b02$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $b938bd31b64185a8$export$2e2bcd8739ae039)((0, $b938bd31b64185a8$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $cbf3d2ed9ee4a17c$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split('.').reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
function $cbf3d2ed9ee4a17c$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $cbf3d2ed9ee4a17c$export$844ec244b1367d54(input) {
    return typeof input === 'string';
}
function $cbf3d2ed9ee4a17c$export$a6cdc56e425d0d0a(input) {
    return typeof input === 'object';
}
function $cbf3d2ed9ee4a17c$export$6444ef5cd411280c(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
function $cbf3d2ed9ee4a17c$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}


const $503525bf43e76fe8$export$3fc3a33e48b33945 = 'dnd-core/INIT_COORDS';
const $503525bf43e76fe8$export$98f9b4193e6b55e6 = 'dnd-core/BEGIN_DRAG';
const $503525bf43e76fe8$export$22d1d88e2de0d0e0 = 'dnd-core/PUBLISH_DRAG_SOURCE';
const $503525bf43e76fe8$export$9d358706ccac3727 = 'dnd-core/HOVER';
const $503525bf43e76fe8$export$b4af72c40fd57063 = 'dnd-core/DROP';
const $503525bf43e76fe8$export$d300627d16aeb9cc = 'dnd-core/END_DRAG';


function $c9eade03ff5aa431$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $503525bf43e76fe8$export$3fc3a33e48b33945),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}



const $a01eeb461bb04ff5$var$ResetCoordinatesAction = {
    type: (0, $503525bf43e76fe8$export$3fc3a33e48b33945),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $a01eeb461bb04ff5$export$d6542eb0d76867d6(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true, clientOffset: clientOffset, getSourceClientOffset: getSourceClientOffset } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch((0, $c9eade03ff5aa431$export$844048139dfc906d)(clientOffset));
        $a01eeb461bb04ff5$var$verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $a01eeb461bb04ff5$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($a01eeb461bb04ff5$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error('getSourceClientOffset must be defined');
            $a01eeb461bb04ff5$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch((0, $c9eade03ff5aa431$export$844048139dfc906d)(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $a01eeb461bb04ff5$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $503525bf43e76fe8$export$98f9b4193e6b55e6),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $a01eeb461bb04ff5$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    sourceIds.forEach(function(sourceId) {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
    });
}
function $a01eeb461bb04ff5$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function $a01eeb461bb04ff5$var$verifyItemIsObject(item) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)((0, $cbf3d2ed9ee4a17c$export$a6cdc56e425d0d0a)(item), 'Item must be an object.');
}
function $a01eeb461bb04ff5$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}





function $a95da55c26edac69$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a95da55c26edac69$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $a95da55c26edac69$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $a95da55c26edac69$export$9f5cbae8d079dda0(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $a95da55c26edac69$var$verifyInvariants(monitor);
        const targetIds = $a95da55c26edac69$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $a95da55c26edac69$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: (0, $503525bf43e76fe8$export$b4af72c40fd57063),
                payload: {
                    dropResult: $a95da55c26edac69$var$_objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $a95da55c26edac69$var$verifyInvariants(monitor) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(monitor.isDragging(), 'Cannot call drop while not dragging.');
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function $a95da55c26edac69$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $a95da55c26edac69$var$verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $a95da55c26edac69$var$verifyDropResultType(dropResult) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof dropResult === 'undefined' || (0, $cbf3d2ed9ee4a17c$export$a6cdc56e425d0d0a)(dropResult), 'Drop result must either be an object or undefined.');
}
function $a95da55c26edac69$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}




function $280b33eda5c13386$export$2f5c7d4805260fdf(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $280b33eda5c13386$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, $503525bf43e76fe8$export$d300627d16aeb9cc)
        };
    };
}
function $280b33eda5c13386$var$verifyIsDragging(monitor) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}



function $6154fd064dbbb564$export$2d6239ff106f142f(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}



function $46c4ba0165a0fd00$export$2f85b44a1d72ad03(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset } = {}) {
        $46c4ba0165a0fd00$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        $46c4ba0165a0fd00$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $46c4ba0165a0fd00$var$checkInvariants(targetIds, monitor, registry);
        $46c4ba0165a0fd00$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $503525bf43e76fe8$export$9d358706ccac3727),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $46c4ba0165a0fd00$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function $46c4ba0165a0fd00$var$checkInvariants(targetIds, monitor, registry) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(monitor.isDragging(), 'Cannot call hover while not dragging.');
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(!monitor.didDrop(), 'Cannot call hover after drop.');
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        const target = registry.getTarget(targetId);
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(target, 'Expected targetIds to be registered.');
    }
}
function $46c4ba0165a0fd00$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!(0, $6154fd064dbbb564$export$2d6239ff106f142f)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $46c4ba0165a0fd00$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}



function $5b9ba9502ebbd91c$export$1675a481db21e714(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $503525bf43e76fe8$export$22d1d88e2de0d0e0)
        };
        return;
    };
}



function $46ed18ae7ab87410$export$ac1b80e79f04247f(manager) {
    return {
        beginDrag: (0, $a01eeb461bb04ff5$export$d6542eb0d76867d6)(manager),
        publishDragSource: (0, $5b9ba9502ebbd91c$export$1675a481db21e714)(manager),
        hover: (0, $46c4ba0165a0fd00$export$2f85b44a1d72ad03)(manager),
        drop: (0, $a95da55c26edac69$export$9f5cbae8d079dda0)(manager),
        endDrag: (0, $280b33eda5c13386$export$2f5c7d4805260fdf)(manager)
    };
}


class $dfaeecb328a84cda$export$1141bbf61324c55f {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== 'undefined') dispatch(action);
            };
        }
        const actions = (0, $46ed18ae7ab87410$export$ac1b80e79f04247f)(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}



/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $83ea2676be55a5cd$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $83ea2676be55a5cd$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $83ea2676be55a5cd$export$b6a5970fca17c71e(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset, initialSourceClientOffset: initialSourceClientOffset } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $83ea2676be55a5cd$export$4e2d2ead65e5f7e3($83ea2676be55a5cd$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $83ea2676be55a5cd$export$b57ee1a41eb1620b(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $83ea2676be55a5cd$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}



const $8107b7236ba0163a$export$c53d0f541b41b88e = [];
const $8107b7236ba0163a$export$61b49a5ae59d663 = [];
$8107b7236ba0163a$export$c53d0f541b41b88e.__IS_NONE__ = true;
$8107b7236ba0163a$export$61b49a5ae59d663.__IS_ALL__ = true;
function $8107b7236ba0163a$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $8107b7236ba0163a$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $8107b7236ba0163a$export$61b49a5ae59d663 || typeof handlerIds === 'undefined') return true;
    const commonIds = (0, $cbf3d2ed9ee4a17c$export$bc86dfbf7795668c)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}



class $4ab117844a4965ac$export$e220263e518daaed {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds } = options;
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof listener === 'function', 'listener must be a function.');
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $8107b7236ba0163a$export$3347776eeed47180)(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof listener === 'function', 'listener must be a function.');
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return (0, $6154fd064dbbb564$export$2d6239ff106f142f)(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !(0, $6154fd064dbbb564$export$2d6239ff106f142f)(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return (0, $83ea2676be55a5cd$export$b6a5970fca17c71e)(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return (0, $83ea2676be55a5cd$export$b57ee1a41eb1620b)(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}


/* eslint-disable no-restricted-globals, @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-non-null-assertion */ // Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $0908b486b9d30097$var$scope = typeof $parcel$global !== 'undefined' ? $parcel$global : self;
const $0908b486b9d30097$var$BrowserMutationObserver = $0908b486b9d30097$var$scope.MutationObserver || $0908b486b9d30097$var$scope.WebKitMutationObserver;
function $0908b486b9d30097$export$27a7cafb047f3c77(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $0908b486b9d30097$export$2785f4493cc9ca62(callback) {
    let toggle = 1;
    const observer = new $0908b486b9d30097$var$BrowserMutationObserver(callback);
    const node = document.createTextNode('');
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $0908b486b9d30097$export$29545a1340296ce3 = typeof $0908b486b9d30097$var$BrowserMutationObserver === 'function' ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$0908b486b9d30097$export$2785f4493cc9ca62 : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$0908b486b9d30097$export$27a7cafb047f3c77;


class $58ed4f158f2ea9bc$export$d3f0708de0e313ed {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (0, $0908b486b9d30097$export$29545a1340296ce3)(this.flush);
        this.requestErrorThrow = (0, $0908b486b9d30097$export$27a7cafb047f3c77)(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js


// `call`, just like a function.
class $3114f99a52dc9716$export$c84b69da61b33d93 {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}


class $dd88b374bc07b152$export$4577931b6c22c63b {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new (0, $3114f99a52dc9716$export$c84b69da61b33d93)(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}


const $022594bcab818d52$var$asapQueue = new (0, $58ed4f158f2ea9bc$export$d3f0708de0e313ed)();
const $022594bcab818d52$var$taskFactory = new (0, $dd88b374bc07b152$export$4577931b6c22c63b)($022594bcab818d52$var$asapQueue.registerPendingError);
function $022594bcab818d52$export$dc4d482300a341e1(task) {
    $022594bcab818d52$var$asapQueue.enqueueTask($022594bcab818d52$var$taskFactory.create(task));
}









const $835af049218a5a52$export$b36933c81fb1c092 = 'dnd-core/ADD_SOURCE';
const $835af049218a5a52$export$2c313542981556ae = 'dnd-core/ADD_TARGET';
const $835af049218a5a52$export$13332566b98b8783 = 'dnd-core/REMOVE_SOURCE';
const $835af049218a5a52$export$82ace346d17d8869 = 'dnd-core/REMOVE_TARGET';
function $835af049218a5a52$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $835af049218a5a52$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $835af049218a5a52$export$9dd68fe78f37278b(targetId) {
    return {
        type: $835af049218a5a52$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $835af049218a5a52$export$c724aacd61334138(sourceId) {
    return {
        type: $835af049218a5a52$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $835af049218a5a52$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $835af049218a5a52$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}



function $e86b57745f30d0f5$export$a7a13c013ce18993(source) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function $e86b57745f30d0f5$export$77d3cd1340fdeb5a(target) {
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof target.hover === 'function', 'Expected hover to be a function.');
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function $e86b57745f30d0f5$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$e86b57745f30d0f5$export$831a593efd22380d(t, false));
        return;
    }
    (0, $22090dc29d3a2da1$export$f5708dca728d7177)(typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}


var $ecd8735293b54d53$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($ecd8735293b54d53$export$bb8f0843d7d66cb0 || ($ecd8735293b54d53$export$bb8f0843d7d66cb0 = {}));


let $217074eeabee91e9$var$nextUniqueId = 0;
function $217074eeabee91e9$export$dbfb29c8f2c7bb44() {
    return $217074eeabee91e9$var$nextUniqueId++;
}


function $111a6115778bc3e5$var$getNextHandlerId(role) {
    const id = (0, $217074eeabee91e9$export$dbfb29c8f2c7bb44)().toString();
    switch(role){
        case (0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).SOURCE:
            return `S${id}`;
        case (0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $111a6115778bc3e5$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return (0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).SOURCE;
        case 'T':
            return (0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $111a6115778bc3e5$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done, value: [, value] } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $111a6115778bc3e5$export$60ceab237232d5db {
    addSource(type, source) {
        (0, $e86b57745f30d0f5$export$831a593efd22380d)(type);
        (0, $e86b57745f30d0f5$export$a7a13c013ce18993)(source);
        const sourceId = this.addHandler((0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).SOURCE, type, source);
        this.store.dispatch((0, $835af049218a5a52$export$bc333c64f07a75c4)(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        (0, $e86b57745f30d0f5$export$831a593efd22380d)(type, true);
        (0, $e86b57745f30d0f5$export$77d3cd1340fdeb5a)(target);
        const targetId = this.addHandler((0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).TARGET, type, target);
        this.store.dispatch((0, $835af049218a5a52$export$9dd68fe78f37278b)(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $111a6115778bc3e5$var$mapContainsValue(this.dragSources, handler) || $111a6115778bc3e5$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(this.isSourceId(sourceId), 'Expected a valid source ID.');
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(this.isSourceId(sourceId), 'Expected a valid source ID.');
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $111a6115778bc3e5$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).SOURCE;
    }
    isTargetId(handlerId) {
        const role = $111a6115778bc3e5$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).TARGET;
    }
    removeSource(sourceId) {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(this.getSource(sourceId), 'Expected an existing source.');
        this.store.dispatch((0, $835af049218a5a52$export$c724aacd61334138)(sourceId));
        (0, $022594bcab818d52$export$dc4d482300a341e1)(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(this.getTarget(targetId), 'Expected an existing target.');
        this.store.dispatch((0, $835af049218a5a52$export$20ae7ec87f7f8696)(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(source, 'Expected an existing source.');
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(this.pinnedSource, 'No source is pinned at the time.');
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $111a6115778bc3e5$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === (0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).SOURCE) this.dragSources.set(id, handler);
        else if (role === (0, $ecd8735293b54d53$export$bb8f0843d7d66cb0).TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}






const $6436e4652b930284$export$2116cbe61f6a442a = (a, b)=>a === b;
function $6436e4652b930284$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $6436e4652b930284$export$94fd53d40f0652a(a, b, isEqual = $6436e4652b930284$export$2116cbe61f6a442a) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}



function $4baecf9aef0e611a$export$533b26079ad0b4b(_state = (0, $8107b7236ba0163a$export$c53d0f541b41b88e), action) {
    switch(action.type){
        case 0, $503525bf43e76fe8$export$9d358706ccac3727:
            break;
        case 0, $835af049218a5a52$export$b36933c81fb1c092:
        case 0, $835af049218a5a52$export$2c313542981556ae:
        case 0, $835af049218a5a52$export$82ace346d17d8869:
        case 0, $835af049218a5a52$export$13332566b98b8783:
            return 0, $8107b7236ba0163a$export$c53d0f541b41b88e;
        case 0, $503525bf43e76fe8$export$98f9b4193e6b55e6:
        case 0, $503525bf43e76fe8$export$22d1d88e2de0d0e0:
        case 0, $503525bf43e76fe8$export$d300627d16aeb9cc:
        case 0, $503525bf43e76fe8$export$b4af72c40fd57063:
        default:
            return 0, $8107b7236ba0163a$export$61b49a5ae59d663;
    }
    const { targetIds: targetIds = [], prevTargetIds: prevTargetIds = [] } = action.payload;
    const result = (0, $cbf3d2ed9ee4a17c$export$6444ef5cd411280c)(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !(0, $6436e4652b930284$export$94fd53d40f0652a)(targetIds, prevTargetIds);
    if (!didChange) return 0, $8107b7236ba0163a$export$c53d0f541b41b88e;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}




function $2c7026fa011827d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2c7026fa011827d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $2c7026fa011827d4$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $2c7026fa011827d4$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $2c7026fa011827d4$export$533b26079ad0b4b(state = $2c7026fa011827d4$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $503525bf43e76fe8$export$3fc3a33e48b33945:
        case 0, $503525bf43e76fe8$export$98f9b4193e6b55e6:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $503525bf43e76fe8$export$9d358706ccac3727:
            if ((0, $6436e4652b930284$export$102b20725d4d2263)(state.clientOffset, payload.clientOffset)) return state;
            return $2c7026fa011827d4$var$_objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, $503525bf43e76fe8$export$d300627d16aeb9cc:
        case 0, $503525bf43e76fe8$export$b4af72c40fd57063:
            return $2c7026fa011827d4$var$initialState;
        default:
            return state;
    }
}





function $1e96b6381f0f74a7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1e96b6381f0f74a7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $1e96b6381f0f74a7$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $1e96b6381f0f74a7$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $1e96b6381f0f74a7$export$533b26079ad0b4b(state = $1e96b6381f0f74a7$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $503525bf43e76fe8$export$98f9b4193e6b55e6:
            return $1e96b6381f0f74a7$var$_objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $503525bf43e76fe8$export$22d1d88e2de0d0e0:
            return $1e96b6381f0f74a7$var$_objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, $503525bf43e76fe8$export$9d358706ccac3727:
            return $1e96b6381f0f74a7$var$_objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, $835af049218a5a52$export$82ace346d17d8869:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $1e96b6381f0f74a7$var$_objectSpread({}, state, {
                targetIds: (0, $cbf3d2ed9ee4a17c$export$5d14bf425b37f49e)(state.targetIds, payload.targetId)
            });
        case 0, $503525bf43e76fe8$export$b4af72c40fd57063:
            return $1e96b6381f0f74a7$var$_objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $503525bf43e76fe8$export$d300627d16aeb9cc:
            return $1e96b6381f0f74a7$var$_objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}



function $62538f158d8f9cc0$export$533b26079ad0b4b(state = 0, action) {
    switch(action.type){
        case 0, $835af049218a5a52$export$b36933c81fb1c092:
        case 0, $835af049218a5a52$export$2c313542981556ae:
            return state + 1;
        case 0, $835af049218a5a52$export$13332566b98b8783:
        case 0, $835af049218a5a52$export$82ace346d17d8869:
            return state - 1;
        default:
            return state;
    }
}


function $7a456725883dde71$export$533b26079ad0b4b(state = 0) {
    return state + 1;
}


function $5534cbcc7be7b617$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5534cbcc7be7b617$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $5534cbcc7be7b617$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $5534cbcc7be7b617$export$533b26079ad0b4b(state = {}, action) {
    return {
        dirtyHandlerIds: (0, $4baecf9aef0e611a$export$533b26079ad0b4b)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $5534cbcc7be7b617$var$_objectSpread({}, action.payload, {
                prevTargetIds: (0, $cbf3d2ed9ee4a17c$export$3988ae62b71be9a3)(state, 'dragOperation.targetIds', [])
            })
        }),
        dragOffset: (0, $2c7026fa011827d4$export$533b26079ad0b4b)(state.dragOffset, action),
        refCount: (0, $62538f158d8f9cc0$export$533b26079ad0b4b)(state.refCount, action),
        dragOperation: (0, $1e96b6381f0f74a7$export$533b26079ad0b4b)(state.dragOperation, action),
        stateId: (0, $7a456725883dde71$export$533b26079ad0b4b)(state.stateId)
    };
}


function $aecb1ed7526a483c$export$ff47aa43d5fd3e5d(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $aecb1ed7526a483c$var$makeStoreInstance(debugMode);
    const monitor = new (0, $4ab117844a4965ac$export$e220263e518daaed)(store, new (0, $111a6115778bc3e5$export$60ceab237232d5db)(store));
    const manager = new (0, $dfaeecb328a84cda$export$1141bbf61324c55f)(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $aecb1ed7526a483c$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $7ce27f1e58e53b02$export$f51a9068ac82ea43)((0, $5534cbcc7be7b617$export$533b26079ad0b4b), debugMode && reduxDevTools && reduxDevTools({
        name: 'dnd-core',
        instanceId: 'dnd-core'
    }));
}



var $aqdBs = parcelRequire("aqdBs");

function $d90be0009da8926e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d90be0009da8926e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d90be0009da8926e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $d90be0009da8926e$var$refCount = 0;
const $d90be0009da8926e$var$INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
var $d90be0009da8926e$export$9861489d68213f9c = /*#__PURE__*/ (0, $aqdBs.memo)(function DndProvider(_param) {
    var { children: children } = _param, props = $d90be0009da8926e$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $d90be0009da8926e$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $aqdBs.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $d90be0009da8926e$var$getGlobalContext();
            ++$d90be0009da8926e$var$refCount;
            return ()=>{
                if (--$d90be0009da8926e$var$refCount === 0) context[$d90be0009da8926e$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f57957e5437c5761$export$2d5c5ceac203fc1e).Provider, {
        value: manager,
        children: children
    });
});
function $d90be0009da8926e$var$getDndContextValue(props) {
    if ('manager' in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $d90be0009da8926e$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $d90be0009da8926e$var$createSingletonDndContext(backend, context = $d90be0009da8926e$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$d90be0009da8926e$var$INSTANCE_SYM]) ctx[$d90be0009da8926e$var$INSTANCE_SYM] = {
        dragDropManager: (0, $aecb1ed7526a483c$export$ff47aa43d5fd3e5d)(backend, context, options, debugMode)
    };
    return ctx[$d90be0009da8926e$var$INSTANCE_SYM];
}
function $d90be0009da8926e$var$getGlobalContext() {
    return typeof $parcel$global !== 'undefined' ? $parcel$global : window;
}



var $59a60ccd3c3bfc99$export$77315d8e4e38ac8f;
(function(ListenerType) {
    ListenerType["mouse"] = "mouse";
    ListenerType["touch"] = "touch";
    ListenerType["keyboard"] = "keyboard";
})($59a60ccd3c3bfc99$export$77315d8e4e38ac8f || ($59a60ccd3c3bfc99$export$77315d8e4e38ac8f = {}));


class $eccae392ebc8d0c7$export$2b3a268803e49e64 {
    get delay() {
        var _delay;
        return (_delay = this.args.delay) !== null && _delay !== void 0 ? _delay : 0;
    }
    get scrollAngleRanges() {
        return this.args.scrollAngleRanges;
    }
    get getDropTargetElementsAtPoint() {
        return this.args.getDropTargetElementsAtPoint;
    }
    get ignoreContextMenu() {
        var _ignoreContextMenu;
        return (_ignoreContextMenu = this.args.ignoreContextMenu) !== null && _ignoreContextMenu !== void 0 ? _ignoreContextMenu : false;
    }
    get enableHoverOutsideTarget() {
        var _enableHoverOutsideTarget;
        return (_enableHoverOutsideTarget = this.args.enableHoverOutsideTarget) !== null && _enableHoverOutsideTarget !== void 0 ? _enableHoverOutsideTarget : false;
    }
    get enableKeyboardEvents() {
        var _enableKeyboardEvents;
        return (_enableKeyboardEvents = this.args.enableKeyboardEvents) !== null && _enableKeyboardEvents !== void 0 ? _enableKeyboardEvents : false;
    }
    get enableMouseEvents() {
        var _enableMouseEvents;
        return (_enableMouseEvents = this.args.enableMouseEvents) !== null && _enableMouseEvents !== void 0 ? _enableMouseEvents : false;
    }
    get enableTouchEvents() {
        var _enableTouchEvents;
        return (_enableTouchEvents = this.args.enableTouchEvents) !== null && _enableTouchEvents !== void 0 ? _enableTouchEvents : true;
    }
    get touchSlop() {
        return this.args.touchSlop || 0;
    }
    get delayTouchStart() {
        var ref, ref1;
        var ref2, ref3;
        return (ref3 = (ref2 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayTouchStart) !== null && ref2 !== void 0 ? ref2 : (ref1 = this.args) === null || ref1 === void 0 ? void 0 : ref1.delay) !== null && ref3 !== void 0 ? ref3 : 0;
    }
    get delayMouseStart() {
        var ref, ref4;
        var ref5, ref6;
        return (ref6 = (ref5 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayMouseStart) !== null && ref5 !== void 0 ? ref5 : (ref4 = this.args) === null || ref4 === void 0 ? void 0 : ref4.delay) !== null && ref6 !== void 0 ? ref6 : 0;
    }
    get window() {
        if (this.context && this.context.window) return this.context.window;
        else if (typeof window !== 'undefined') return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : ref.document) return this.context.document;
        if (this.window) return this.window.document;
        return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.args) === null || ref === void 0 ? void 0 : ref.rootElement) || this.document;
    }
    constructor(args, context){
        this.args = args;
        this.context = context;
    }
}


function $c0fbee0a01c8f7d5$export$9f17032d917177de(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}
function $c0fbee0a01c8f7d5$export$7c909de71a662f4d(x1, y1, x2, y2, angleRanges) {
    if (!angleRanges) return false;
    const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;
    for(let i = 0; i < angleRanges.length; ++i){
        const ar = angleRanges[i];
        if (ar && (ar.start == null || angle >= ar.start) && (ar.end == null || angle <= ar.end)) return true;
    }
    return false;
}


// Used for MouseEvent.buttons (note the s on the end).
const $8a56f2b59a5cc4ca$var$MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4
};
// Used for e.button (note the lack of an s on the end).
const $8a56f2b59a5cc4ca$var$MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2
};
function $8a56f2b59a5cc4ca$export$c64909add7c8d190(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === $8a56f2b59a5cc4ca$var$MouseButton.Left;
}
function $8a56f2b59a5cc4ca$export$23bc6ab5d304a5(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & $8a56f2b59a5cc4ca$var$MouseButtons.Left) === 0;
}
function $8a56f2b59a5cc4ca$export$c4dfce035d43d1e0(e) {
    return !!e.targetTouches;
}


const $b5e52a22ebbe6053$var$ELEMENT_NODE = 1;
function $b5e52a22ebbe6053$export$8419e8612027b1d8(node) {
    const el = node.nodeType === $b5e52a22ebbe6053$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return undefined;
    const { top: top, left: left } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $b5e52a22ebbe6053$export$149d0d89063ea9ba(e, lastTargetTouchFallback) {
    if (e.targetTouches.length === 1) return $b5e52a22ebbe6053$export$710c829989c68339(e.targetTouches[0]);
    else if (lastTargetTouchFallback && e.touches.length === 1) {
        if (e.touches[0].target === lastTargetTouchFallback.target) return $b5e52a22ebbe6053$export$710c829989c68339(e.touches[0]);
    }
    return;
}
function $b5e52a22ebbe6053$export$710c829989c68339(e, lastTargetTouchFallback) {
    if ((0, $8a56f2b59a5cc4ca$export$c4dfce035d43d1e0)(e)) return $b5e52a22ebbe6053$export$149d0d89063ea9ba(e, lastTargetTouchFallback);
    else return {
        x: e.clientX,
        y: e.clientY
    };
}



const $1e2fd00a88c567de$export$a8f436d4c8f15a1f = (()=>{
    // simular to jQuery's test
    let supported = false;
    try {
        addEventListener('test', ()=>{
        // do nothing
        }, Object.defineProperty({}, 'passive', {
            get () {
                supported = true;
                return true;
            }
        }));
    } catch (e) {
    // do nothing
    }
    return supported;
})();


const $3fc1afa3222179dd$var$eventNames = {
    [(0, $59a60ccd3c3bfc99$export$77315d8e4e38ac8f).mouse]: {
        start: 'mousedown',
        move: 'mousemove',
        end: 'mouseup',
        contextmenu: 'contextmenu'
    },
    [(0, $59a60ccd3c3bfc99$export$77315d8e4e38ac8f).touch]: {
        start: 'touchstart',
        move: 'touchmove',
        end: 'touchend'
    },
    [(0, $59a60ccd3c3bfc99$export$77315d8e4e38ac8f).keyboard]: {
        keydown: 'keydown'
    }
};
class $3fc1afa3222179dd$export$d96f7f27c2e7d149 {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref;
        return {
            sourceNodes: this.sourceNodes.size,
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            targetNodes: this.targetNodes.size,
            dragOverTargetIds: ((ref = this.dragOverTargetIds) === null || ref === void 0 ? void 0 : ref.length) || 0
        };
    }
    // public for test
    get document() {
        return this.options.document;
    }
    setup() {
        const root = this.options.rootElement;
        if (!root) return;
        (0, $22090dc29d3a2da1$export$f5708dca728d7177)(!$3fc1afa3222179dd$export$d96f7f27c2e7d149.isSetUp, 'Cannot have two Touch backends at the same time.');
        $3fc1afa3222179dd$export$d96f7f27c2e7d149.isSetUp = true;
        this.addEventListener(root, 'start', this.getTopMoveStartHandler());
        this.addEventListener(root, 'start', this.handleTopMoveStartCapture, true);
        this.addEventListener(root, 'move', this.handleTopMove);
        this.addEventListener(root, 'move', this.handleTopMoveCapture, true);
        this.addEventListener(root, 'end', this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.addEventListener(root, 'contextmenu', this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.addEventListener(root, 'keydown', this.handleCancelOnEscape, true);
    }
    teardown() {
        const root = this.options.rootElement;
        if (!root) return;
        $3fc1afa3222179dd$export$d96f7f27c2e7d149.isSetUp = false;
        this._mouseClientOffset = {};
        this.removeEventListener(root, 'start', this.handleTopMoveStartCapture, true);
        this.removeEventListener(root, 'start', this.handleTopMoveStart);
        this.removeEventListener(root, 'move', this.handleTopMoveCapture, true);
        this.removeEventListener(root, 'move', this.handleTopMove);
        this.removeEventListener(root, 'end', this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.removeEventListener(root, 'contextmenu', this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.removeEventListener(root, 'keydown', this.handleCancelOnEscape, true);
        this.uninstallSourceNodeRemovalObserver();
    }
    addEventListener(subject, event, handler, capture = false) {
        const options = (0, $1e2fd00a88c567de$export$a8f436d4c8f15a1f) ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $3fc1afa3222179dd$var$eventNames[listenerType][event];
            if (evt) subject.addEventListener(evt, handler, options);
        });
    }
    removeEventListener(subject, event, handler, capture = false) {
        const options = (0, $1e2fd00a88c567de$export$a8f436d4c8f15a1f) ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $3fc1afa3222179dd$var$eventNames[listenerType][event];
            if (evt) subject.removeEventListener(evt, handler, options);
        });
    }
    connectDragSource(sourceId, node) {
        const handleMoveStart = this.handleMoveStart.bind(this, sourceId);
        this.sourceNodes.set(sourceId, node);
        this.addEventListener(node, 'start', handleMoveStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.removeEventListener(node, 'start', handleMoveStart);
        };
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDropTarget(targetId, node) {
        const root = this.options.rootElement;
        if (!this.document || !root) return ()=>{
        /* noop */ };
        const handleMove = (e)=>{
            if (!this.document || !root || !this.monitor.isDragging()) return;
            let coords;
            /**
			 * Grab the coordinates for the current mouse/touch position
			 */ switch(e.type){
                case $3fc1afa3222179dd$var$eventNames.mouse.move:
                    coords = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    break;
                case $3fc1afa3222179dd$var$eventNames.touch.move:
                    var ref, ref1;
                    coords = {
                        x: ((ref = e.touches[0]) === null || ref === void 0 ? void 0 : ref.clientX) || 0,
                        y: ((ref1 = e.touches[0]) === null || ref1 === void 0 ? void 0 : ref1.clientY) || 0
                    };
                    break;
            }
            /**
			 * Use the coordinates to grab the element the drag ended on.
			 * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
			 */ const droppedOn = coords != null ? this.document.elementFromPoint(coords.x, coords.y) : undefined;
            const childMatch = droppedOn && node.contains(droppedOn);
            if (droppedOn === node || childMatch) return this.handleMove(e, targetId);
        };
        /**
		 * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
		 */ this.addEventListener(this.document.body, 'move', handleMove);
        this.targetNodes.set(targetId, node);
        return ()=>{
            if (this.document) {
                this.targetNodes.delete(targetId);
                this.removeEventListener(this.document.body, 'move', handleMove);
            }
        };
    }
    getTopMoveStartHandler() {
        if (!this.options.delayTouchStart && !this.options.delayMouseStart) return this.handleTopMoveStart;
        return this.handleTopMoveStartDelay;
    }
    installSourceNodeRemovalObserver(node) {
        this.uninstallSourceNodeRemovalObserver();
        this.draggedSourceNode = node;
        this.draggedSourceNodeRemovalObserver = new MutationObserver(()=>{
            if (node && !node.parentElement) {
                this.resurrectSourceNode();
                this.uninstallSourceNodeRemovalObserver();
            }
        });
        if (!node || !node.parentElement) return;
        this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
            childList: true
        });
    }
    resurrectSourceNode() {
        if (this.document && this.draggedSourceNode) {
            this.draggedSourceNode.style.display = 'none';
            this.draggedSourceNode.removeAttribute('data-reactid');
            this.document.body.appendChild(this.draggedSourceNode);
        }
    }
    uninstallSourceNodeRemovalObserver() {
        if (this.draggedSourceNodeRemovalObserver) this.draggedSourceNodeRemovalObserver.disconnect();
        this.draggedSourceNodeRemovalObserver = undefined;
        this.draggedSourceNode = undefined;
    }
    constructor(manager, context, options){
        this.getSourceClientOffset = (sourceId)=>{
            const element = this.sourceNodes.get(sourceId);
            return element && (0, $b5e52a22ebbe6053$export$8419e8612027b1d8)(element);
        };
        this.handleTopMoveStartCapture = (e)=>{
            if (!(0, $8a56f2b59a5cc4ca$export$c64909add7c8d190)(e)) return;
            this.moveStartSourceIds = [];
        };
        this.handleMoveStart = (sourceId)=>{
            // Just because we received an event doesn't necessarily mean we need to collect drag sources.
            // We only collect start collecting drag sources on touch and left mouse events.
            if (Array.isArray(this.moveStartSourceIds)) this.moveStartSourceIds.unshift(sourceId);
        };
        this.handleTopMoveStart = (e)=>{
            if (!(0, $8a56f2b59a5cc4ca$export$c64909add7c8d190)(e)) return;
            // Don't prematurely preventDefault() here since it might:
            // 1. Mess up scrolling
            // 2. Mess up long tap (which brings up context menu)
            // 3. If there's an anchor link as a child, tap won't be triggered on link
            const clientOffset = (0, $b5e52a22ebbe6053$export$710c829989c68339)(e);
            if (clientOffset) {
                if ((0, $8a56f2b59a5cc4ca$export$c4dfce035d43d1e0)(e)) this.lastTargetTouchFallback = e.targetTouches[0];
                this._mouseClientOffset = clientOffset;
            }
            this.waitingForDelay = false;
        };
        this.handleTopMoveStartDelay = (e)=>{
            if (!(0, $8a56f2b59a5cc4ca$export$c64909add7c8d190)(e)) return;
            const delay = e.type === $3fc1afa3222179dd$var$eventNames.touch.start ? this.options.delayTouchStart : this.options.delayMouseStart;
            this.timeout = setTimeout(this.handleTopMoveStart.bind(this, e), delay);
            this.waitingForDelay = true;
        };
        this.handleTopMoveCapture = ()=>{
            this.dragOverTargetIds = [];
        };
        this.handleMove = (_evt, targetId)=>{
            if (this.dragOverTargetIds) this.dragOverTargetIds.unshift(targetId);
        };
        this.handleTopMove = (e1)=>{
            if (this.timeout) clearTimeout(this.timeout);
            if (!this.document || this.waitingForDelay) return;
            const { moveStartSourceIds: moveStartSourceIds, dragOverTargetIds: dragOverTargetIds } = this;
            const enableHoverOutsideTarget = this.options.enableHoverOutsideTarget;
            const clientOffset = (0, $b5e52a22ebbe6053$export$710c829989c68339)(e1, this.lastTargetTouchFallback);
            if (!clientOffset) return;
            // If the touch move started as a scroll, or is is between the scroll angles
            if (this._isScrolling || !this.monitor.isDragging() && (0, $c0fbee0a01c8f7d5$export$7c909de71a662f4d)(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y, this.options.scrollAngleRanges)) {
                this._isScrolling = true;
                return;
            }
            // If we're not dragging and we've moved a little, that counts as a drag start
            if (!this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
            this._mouseClientOffset.hasOwnProperty('x') && moveStartSourceIds && (0, $c0fbee0a01c8f7d5$export$9f17032d917177de)(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y) > (this.options.touchSlop ? this.options.touchSlop : 0)) {
                this.moveStartSourceIds = undefined;
                this.actions.beginDrag(moveStartSourceIds, {
                    clientOffset: this._mouseClientOffset,
                    getSourceClientOffset: this.getSourceClientOffset,
                    publishSource: false
                });
            }
            if (!this.monitor.isDragging()) return;
            const sourceNode = this.sourceNodes.get(this.monitor.getSourceId());
            this.installSourceNodeRemovalObserver(sourceNode);
            this.actions.publishDragSource();
            if (e1.cancelable) e1.preventDefault();
            // Get the node elements of the hovered DropTargets
            const dragOverTargetNodes = (dragOverTargetIds || []).map((key)=>this.targetNodes.get(key)).filter((e)=>!!e);
            // Get the a ordered list of nodes that are touched by
            const elementsAtPoint = this.options.getDropTargetElementsAtPoint ? this.options.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : this.document.elementsFromPoint(clientOffset.x, clientOffset.y);
            // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)
            const elementsAtPointExtended = [];
            for(const nodeId in elementsAtPoint){
                // eslint-disable-next-line no-prototype-builtins
                if (!elementsAtPoint.hasOwnProperty(nodeId)) continue;
                let currentNode = elementsAtPoint[nodeId];
                if (currentNode != null) elementsAtPointExtended.push(currentNode);
                while(currentNode){
                    currentNode = currentNode.parentElement;
                    if (currentNode && elementsAtPointExtended.indexOf(currentNode) === -1) elementsAtPointExtended.push(currentNode);
                }
            }
            const orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
            .filter((node)=>dragOverTargetNodes.indexOf(node) > -1) // Map back the nodes elements to targetIds
            .map((node)=>this._getDropTargetId(node)) // Filter off possible null rows
            .filter((node)=>!!node).filter((id, index, ids)=>ids.indexOf(id) === index);
            // Invoke hover for drop targets when source node is still over and pointer is outside
            if (enableHoverOutsideTarget) for(const targetId in this.targetNodes){
                const targetNode = this.targetNodes.get(targetId);
                if (sourceNode && targetNode && targetNode.contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
                    orderedDragOverTargetIds.unshift(targetId);
                    break;
                }
            }
            // Reverse order because dnd-core reverse it before calling the DropTarget drop methods
            orderedDragOverTargetIds.reverse();
            this.actions.hover(orderedDragOverTargetIds, {
                clientOffset: clientOffset
            });
        };
        /**
	 *
	 * visible for testing
	 */ this._getDropTargetId = (node)=>{
            const keys = this.targetNodes.keys();
            let next = keys.next();
            while(next.done === false){
                const targetId = next.value;
                if (node === this.targetNodes.get(targetId)) return targetId;
                else next = keys.next();
            }
            return undefined;
        };
        this.handleTopMoveEndCapture = (e)=>{
            this._isScrolling = false;
            this.lastTargetTouchFallback = undefined;
            if (!(0, $8a56f2b59a5cc4ca$export$23bc6ab5d304a5)(e)) return;
            if (!this.monitor.isDragging() || this.monitor.didDrop()) {
                this.moveStartSourceIds = undefined;
                return;
            }
            if (e.cancelable) e.preventDefault();
            this._mouseClientOffset = {};
            this.uninstallSourceNodeRemovalObserver();
            this.actions.drop();
            this.actions.endDrag();
        };
        this.handleCancelOnEscape = (e)=>{
            if (e.key === 'Escape' && this.monitor.isDragging()) {
                this._mouseClientOffset = {};
                this.uninstallSourceNodeRemovalObserver();
                this.actions.endDrag();
            }
        };
        this.options = new (0, $eccae392ebc8d0c7$export$2b3a268803e49e64)(options, context);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.sourceNodes = new Map();
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.targetNodes = new Map();
        this.listenerTypes = [];
        this._mouseClientOffset = {};
        this._isScrolling = false;
        if (this.options.enableMouseEvents) this.listenerTypes.push((0, $59a60ccd3c3bfc99$export$77315d8e4e38ac8f).mouse);
        if (this.options.enableTouchEvents) this.listenerTypes.push((0, $59a60ccd3c3bfc99$export$77315d8e4e38ac8f).touch);
        if (this.options.enableKeyboardEvents) this.listenerTypes.push((0, $59a60ccd3c3bfc99$export$77315d8e4e38ac8f).keyboard);
    }
}



const $1f1d51a0d4192edb$export$b4d0180dbe086f87 = function createBackend(manager, context = {}, options = {}) {
    return new (0, $3fc1afa3222179dd$export$d96f7f27c2e7d149)(manager, context, options);
};



const $72065eb7505b2e7a$var$TextOptionList = ({ optionList: optionList, setOptionList: setOptionList, optionListTitle: optionListTitle, showOptionListTitle: showOptionListTitle, optionPlaceholderText: optionPlaceholderText, optionLimit: optionLimit })=>{
    const containerRef = (0, $aqdBs.useRef)(null);
    const [hoverIndex, setHoverIndex] = (0, $aqdBs.useState)(null);
    const optionLimitHasBeenMet = !!optionLimit && optionLimit === optionList.length;
    const hasUnfinishedOptions = optionList.some((opt)=>!opt.text || opt.text.trim() === "");
    const addOptionsIsDisabled = optionLimitHasBeenMet || hasUnfinishedOptions;
    function onAddOptionClick() {
        const maxId = optionList.length > 0 ? Math.max(...optionList.map((option)=>option.id)) : 0;
        const newOption = {
            id: maxId + 1,
            text: ""
        };
        setOptionList([
            ...optionList,
            newOption
        ]);
    }
    function onEditOptionText(id, text) {
        const updatedOptions = optionList.map((option)=>option.id === id ? {
                ...option,
                text: text
            } : option);
        setOptionList(updatedOptions);
    }
    function onDeleteOptionClick(optionId) {
        const updatedOptionList = optionList.filter((option)=>option.id !== optionId);
        setOptionList(updatedOptionList);
    }
    function moveListItem(dragIndex, hoverIndex) {
        const dragRow = optionList[dragIndex];
        const updatedOptionList = [
            ...optionList
        ];
        updatedOptionList.splice(dragIndex, 1);
        updatedOptionList.splice(hoverIndex, 0, dragRow);
        setOptionList(updatedOptionList);
        setHoverIndex(null);
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d90be0009da8926e$export$9861489d68213f9c), {
        backend: (0, $1f1d51a0d4192edb$export$b4d0180dbe086f87),
        options: {
            enableMouseEvents: true
        },
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: "text-option-list-container",
            ref: containerRef,
            children: [
                showOptionListTitle && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                    children: optionListTitle || "Options"
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("ul", {
                    className: `text-option-list`,
                    children: optionList.map((option, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $cde1d49daeb32ecd$export$2e2bcd8739ae039), {
                            id: option.id,
                            text: option.text,
                            index: index,
                            onEditOptionText: onEditOptionText,
                            onDeleteOptionClick: ()=>onDeleteOptionClick(option.id),
                            containerRef: containerRef,
                            moveListItem: moveListItem,
                            hoverIndex: hoverIndex,
                            setHoverIndex: setHoverIndex,
                            placeholderText: optionPlaceholderText
                        }, `${option.id}-${option.id}`))
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $a25bbe6803f2a647$export$2e2bcd8739ae039), {
                    className: "add-option-panel-button",
                    isDisabled: addOptionsIsDisabled,
                    content: "+ Add Option",
                    ariaLabel: "Add an option to the list",
                    onButtonClick: ()=>onAddOptionClick()
                })
            ]
        })
    });
};
var $72065eb7505b2e7a$export$2e2bcd8739ae039 = $72065eb7505b2e7a$var$TextOptionList;




var $aqdBs = parcelRequire("aqdBs");
const $87c2d16114fb0356$var$SelectButtonList = ({ buttons: buttons = [], className: className = '', allButtonOnClick: allButtonOnClick, fixedPosition: fixedPosition })=>{
    const [focusedIndex, setFocusedIndex] = (0, $aqdBs.useState)(0);
    const listRef = (0, $aqdBs.useRef)(null);
    const handleKeyDown = (event)=>{
        if (focusedIndex === null) return;
        switch(event.key){
            case 'ArrowDown':
                event.preventDefault();
                setFocusedIndex((prev)=>prev === null ? 0 : Math.min(prev + 1, buttons.length - 1));
                break;
            case 'ArrowUp':
                event.preventDefault();
                setFocusedIndex((prev)=>prev === null ? 0 : Math.max(prev - 1, 0));
                break;
            case 'Enter':
            case ' ':
                event.preventDefault();
                handleClick(buttons[focusedIndex].onClick);
                break;
            case 'Escape':
                setFocusedIndex(null);
                break;
            default:
                break;
        }
    };
    (0, $aqdBs.useEffect)(()=>{
        if (focusedIndex !== null && listRef.current) {
            const focusedItem = listRef.current.children[focusedIndex];
            if (focusedItem) {
                focusedItem?.scrollIntoView?.({
                    block: 'nearest'
                });
                const buttonElement = focusedItem.querySelector('button');
                if (buttonElement) buttonElement.focus(); // Focus the button itself
            }
        }
    }, [
        focusedIndex
    ]);
    // Conditionally render the list only if there are buttons
    if (!buttons || buttons.length === 0) return null;
    function handleClick(buttonOnClick) {
        buttonOnClick();
        if (allButtonOnClick) allButtonOnClick();
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("ul", {
        ref: listRef,
        className: `select-button-list ${buttons.length === 1 ? 'single-button' : ''} ${className} ${fixedPosition ? 'fixed-position' : ''}`,
        role: "listbox",
        "aria-activedescendant": focusedIndex !== null ? `button-${focusedIndex}` : undefined,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        style: fixedPosition || undefined,
        children: buttons.map((button, index)=>button && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("li", {
                id: `button-${index}`,
                className: "select-button-list-item",
                role: "option",
                "aria-selected": focusedIndex === index,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                    type: "button",
                    className: `select-button ${button.isSelected && `selected-button`}`,
                    onClick: (e)=>handleClick(()=>button.onClick(e)),
                    disabled: button?.isDisabled,
                    children: button.content
                })
            }, index))
    });
};
var $87c2d16114fb0356$export$2e2bcd8739ae039 = $87c2d16114fb0356$var$SelectButtonList;



parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();


function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;



var $aqdBs = parcelRequire("aqdBs");
var $6cb8be828609ef6d$exports = {};
'use strict';
var $1e4007cd53dccfef$exports = {};
'use strict';
const $1e4007cd53dccfef$var$copyProperty = (to, from, property, ignoreNonConfigurable)=>{
    // `Function#length` should reflect the parameters of `to` not `from` since we keep its body.
    // `Function#prototype` is non-writable and non-configurable so can never be modified.
    if (property === 'length' || property === 'prototype') return;
    // `Function#arguments` and `Function#caller` should not be copied. They were reported to be present in `Reflect.ownKeys` for some devices in React Native (#41), so we explicitly ignore them here.
    if (property === 'arguments' || property === 'caller') return;
    const toDescriptor = Object.getOwnPropertyDescriptor(to, property);
    const fromDescriptor = Object.getOwnPropertyDescriptor(from, property);
    if (!$1e4007cd53dccfef$var$canCopyProperty(toDescriptor, fromDescriptor) && ignoreNonConfigurable) return;
    Object.defineProperty(to, property, fromDescriptor);
};
// `Object.defineProperty()` throws if the property exists, is not configurable and either:
//  - one its descriptors is changed
//  - it is non-writable and its value is changed
const $1e4007cd53dccfef$var$canCopyProperty = function(toDescriptor, fromDescriptor) {
    return toDescriptor === undefined || toDescriptor.configurable || toDescriptor.writable === fromDescriptor.writable && toDescriptor.enumerable === fromDescriptor.enumerable && toDescriptor.configurable === fromDescriptor.configurable && (toDescriptor.writable || toDescriptor.value === fromDescriptor.value);
};
const $1e4007cd53dccfef$var$changePrototype = (to, from)=>{
    const fromPrototype = Object.getPrototypeOf(from);
    if (fromPrototype === Object.getPrototypeOf(to)) return;
    Object.setPrototypeOf(to, fromPrototype);
};
const $1e4007cd53dccfef$var$wrappedToString = (withName, fromBody)=>`/* Wrapped ${withName}*/\n${fromBody}`;
const $1e4007cd53dccfef$var$toStringDescriptor = Object.getOwnPropertyDescriptor(Function.prototype, 'toString');
const $1e4007cd53dccfef$var$toStringName = Object.getOwnPropertyDescriptor(Function.prototype.toString, 'name');
// We call `from.toString()` early (not lazily) to ensure `from` can be garbage collected.
// We use `bind()` instead of a closure for the same reason.
// Calling `from.toString()` early also allows caching it in case `to.toString()` is called several times.
const $1e4007cd53dccfef$var$changeToString = (to, from, name)=>{
    const withName = name === '' ? '' : `with ${name.trim()}() `;
    const newToString = $1e4007cd53dccfef$var$wrappedToString.bind(null, withName, from.toString());
    // Ensure `to.toString.toString` is non-enumerable and has the same `same`
    Object.defineProperty(newToString, 'name', $1e4007cd53dccfef$var$toStringName);
    Object.defineProperty(to, 'toString', {
        ...$1e4007cd53dccfef$var$toStringDescriptor,
        value: newToString
    });
};
const $1e4007cd53dccfef$var$mimicFn = (to, from, { ignoreNonConfigurable: ignoreNonConfigurable = false } = {})=>{
    const { name: name } = to;
    for (const property of Reflect.ownKeys(from))$1e4007cd53dccfef$var$copyProperty(to, from, property, ignoreNonConfigurable);
    $1e4007cd53dccfef$var$changePrototype(to, from);
    $1e4007cd53dccfef$var$changeToString(to, from, name);
    return to;
};
$1e4007cd53dccfef$exports = $1e4007cd53dccfef$var$mimicFn;


var $1ae0de67ba03c56f$exports = {};
"use strict";
var $1ae0de67ba03c56f$var$__awaiter = $1ae0de67ba03c56f$exports && $1ae0de67ba03c56f$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1ae0de67ba03c56f$var$__importDefault = $1ae0de67ba03c56f$exports && $1ae0de67ba03c56f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1ae0de67ba03c56f$exports, "__esModule", {
    value: true
});

const $1ae0de67ba03c56f$var$p_defer_1 = $1ae0de67ba03c56f$var$__importDefault((parcelRequire("fFeqb")));
function $1ae0de67ba03c56f$var$mapAgeCleaner(map, property = 'maxAge') {
    let processingKey;
    let processingTimer;
    let processingDeferred;
    const cleanup = ()=>$1ae0de67ba03c56f$var$__awaiter(this, void 0, void 0, function*() {
            if (processingKey !== undefined) // If we are already processing an item, we can safely exit
            return;
            const setupTimer = (item)=>$1ae0de67ba03c56f$var$__awaiter(this, void 0, void 0, function*() {
                    processingDeferred = $1ae0de67ba03c56f$var$p_defer_1.default();
                    const delay = item[1][property] - Date.now();
                    if (delay <= 0) {
                        // Remove the item immediately if the delay is equal to or below 0
                        map.delete(item[0]);
                        processingDeferred.resolve();
                        return;
                    }
                    // Keep track of the current processed key
                    processingKey = item[0];
                    processingTimer = setTimeout(()=>{
                        // Remove the item when the timeout fires
                        map.delete(item[0]);
                        if (processingDeferred) processingDeferred.resolve();
                    }, delay);
                    // tslint:disable-next-line:strict-type-predicates
                    if (typeof processingTimer.unref === 'function') // Don't hold up the process from exiting
                    processingTimer.unref();
                    return processingDeferred.promise;
                });
            try {
                for (const entry of map)yield setupTimer(entry);
            } catch (_a) {
            // Do nothing if an error occurs, this means the timer was cleaned up and we should stop processing
            }
            processingKey = undefined;
        });
    const reset = ()=>{
        processingKey = undefined;
        if (processingTimer !== undefined) {
            clearTimeout(processingTimer);
            processingTimer = undefined;
        }
        if (processingDeferred !== undefined) {
            processingDeferred.reject(undefined);
            processingDeferred = undefined;
        }
    };
    const originalSet = map.set.bind(map);
    map.set = (key, value)=>{
        if (map.has(key)) // If the key already exist, remove it so we can add it back at the end of the map.
        map.delete(key);
        // Call the original `map.set`
        const result = originalSet(key, value);
        // If we are already processing a key and the key added is the current processed key, stop processing it
        if (processingKey && processingKey === key) reset();
        // Always run the cleanup method in case it wasn't started yet
        cleanup(); // tslint:disable-line:no-floating-promises
        return result;
    };
    cleanup(); // tslint:disable-line:no-floating-promises
    return map;
}
$1ae0de67ba03c56f$exports.default = $1ae0de67ba03c56f$var$mapAgeCleaner;
// Add support for CJS
$1ae0de67ba03c56f$exports = $1ae0de67ba03c56f$var$mapAgeCleaner;
$1ae0de67ba03c56f$exports.default = $1ae0de67ba03c56f$var$mapAgeCleaner;


const $6cb8be828609ef6d$var$decoratorInstanceMap = new WeakMap();
const $6cb8be828609ef6d$var$cacheStore = new WeakMap();
/**
[Memoize](https://en.wikipedia.org/wiki/Memoization) functions - An optimization used to speed up consecutive function calls by caching the result of calls with identical input.

@param fn - Function to be memoized.

@example
```
import mem = require('mem');

let i = 0;
const counter = () => ++i;
const memoized = mem(counter);

memoized('foo');
//=> 1

// Cached as it's the same arguments
memoized('foo');
//=> 1

// Not cached anymore as the arguments changed
memoized('bar');
//=> 2

memoized('bar');
//=> 2
```
*/ const $6cb8be828609ef6d$var$mem = (fn, { cacheKey: cacheKey, cache: cache = new Map(), maxAge: maxAge } = {})=>{
    if (typeof maxAge === 'number') // TODO: Drop after https://github.com/SamVerschueren/map-age-cleaner/issues/5
    // @ts-expect-error
    $1ae0de67ba03c56f$exports(cache);
    const memoized = function(...arguments_) {
        const key = cacheKey ? cacheKey(arguments_) : arguments_[0];
        const cacheItem = cache.get(key);
        if (cacheItem) return cacheItem.data;
        const result = fn.apply(this, arguments_);
        cache.set(key, {
            data: result,
            maxAge: maxAge ? Date.now() + maxAge : Number.POSITIVE_INFINITY
        });
        return result;
    };
    $1e4007cd53dccfef$exports(memoized, fn, {
        ignoreNonConfigurable: true
    });
    $6cb8be828609ef6d$var$cacheStore.set(memoized, cache);
    return memoized;
};
/**
@returns A [decorator](https://github.com/tc39/proposal-decorators) to memoize class methods or static class methods.

@example
```
import mem = require('mem');

class Example {
    index = 0

    @mem.decorator()
    counter() {
        return ++this.index;
    }
}

class ExampleWithOptions {
    index = 0

    @mem.decorator({maxAge: 1000})
    counter() {
        return ++this.index;
    }
}
```
*/ $6cb8be828609ef6d$var$mem.decorator = (options = {})=>(target, propertyKey, descriptor)=>{
        const input = target[propertyKey];
        if (typeof input !== 'function') throw new TypeError('The decorated value must be a function');
        delete descriptor.value;
        delete descriptor.writable;
        descriptor.get = function() {
            if (!$6cb8be828609ef6d$var$decoratorInstanceMap.has(this)) {
                const value = $6cb8be828609ef6d$var$mem(input, options);
                $6cb8be828609ef6d$var$decoratorInstanceMap.set(this, value);
                return value;
            }
            return $6cb8be828609ef6d$var$decoratorInstanceMap.get(this);
        };
    };
/**
Clear all cached data of a memoized function.

@param fn - Memoized function.
*/ $6cb8be828609ef6d$var$mem.clear = (fn)=>{
    const cache = $6cb8be828609ef6d$var$cacheStore.get(fn);
    if (!cache) throw new TypeError('Can\'t clear a function that was not memoized!');
    if (typeof cache.clear !== 'function') throw new TypeError('The cache Map can\'t be cleared!');
    cache.clear();
};
$6cb8be828609ef6d$exports = $6cb8be828609ef6d$var$mem;


function $ef112bbbb1f1a0f9$var$isString(el) {
    return typeof el === 'string';
}
function $ef112bbbb1f1a0f9$var$isUnique(el, index, arr) {
    return arr.indexOf(el) === index;
}
function $ef112bbbb1f1a0f9$var$isAllLowerCase(el) {
    return el.toLowerCase() === el;
}
function $ef112bbbb1f1a0f9$var$fixCommas(el) {
    return el.indexOf(',') === -1 ? el : el.split(',');
}
function $ef112bbbb1f1a0f9$var$normalizeLocale(locale) {
    if (!locale) return locale;
    if (locale === 'C' || locale === 'posix' || locale === 'POSIX') return 'en-US';
    // If there's a dot (.) in the locale, it's likely in the format of "en-US.UTF-8", so we only take the first part
    if (locale.indexOf('.') !== -1) {
        var _a = locale.split('.')[0], actualLocale = _a === void 0 ? '' : _a;
        return $ef112bbbb1f1a0f9$var$normalizeLocale(actualLocale);
    }
    // If there's an at sign (@) in the locale, it's likely in the format of "en-US@posix", so we only take the first part
    if (locale.indexOf('@') !== -1) {
        var _b = locale.split('@')[0], actualLocale = _b === void 0 ? '' : _b;
        return $ef112bbbb1f1a0f9$var$normalizeLocale(actualLocale);
    }
    // If there's a dash (-) in the locale and it's not all lower case, it's already in the format of "en-US", so we return it
    if (locale.indexOf('-') === -1 || !$ef112bbbb1f1a0f9$var$isAllLowerCase(locale)) return locale;
    var _c = locale.split('-'), splitEl1 = _c[0], _d = _c[1], splitEl2 = _d === void 0 ? '' : _d;
    return "".concat(splitEl1, "-").concat(splitEl2.toUpperCase());
}
function $ef112bbbb1f1a0f9$var$getUserLocalesInternal(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.useFallbackLocale, useFallbackLocale = _c === void 0 ? true : _c, _d = _b.fallbackLocale, fallbackLocale = _d === void 0 ? 'en-US' : _d;
    var languageList = [];
    if (typeof navigator !== 'undefined') {
        var rawLanguages = navigator.languages || [];
        var languages = [];
        for(var _i = 0, rawLanguages_1 = rawLanguages; _i < rawLanguages_1.length; _i++){
            var rawLanguagesItem = rawLanguages_1[_i];
            languages = languages.concat($ef112bbbb1f1a0f9$var$fixCommas(rawLanguagesItem));
        }
        var rawLanguage = navigator.language;
        var language = rawLanguage ? $ef112bbbb1f1a0f9$var$fixCommas(rawLanguage) : rawLanguage;
        languageList = languageList.concat(languages, language);
    }
    if (useFallbackLocale) languageList.push(fallbackLocale);
    return languageList.filter($ef112bbbb1f1a0f9$var$isString).map($ef112bbbb1f1a0f9$var$normalizeLocale).filter($ef112bbbb1f1a0f9$var$isUnique);
}
var $ef112bbbb1f1a0f9$export$2709d88c05bbce73 = (0, (/*@__PURE__*/$parcel$interopDefault($6cb8be828609ef6d$exports)))($ef112bbbb1f1a0f9$var$getUserLocalesInternal, {
    cacheKey: JSON.stringify
});
function $ef112bbbb1f1a0f9$var$getUserLocaleInternal(options) {
    return $ef112bbbb1f1a0f9$export$2709d88c05bbce73(options)[0] || null;
}
var $ef112bbbb1f1a0f9$export$a6ea185b366483aa = (0, (/*@__PURE__*/$parcel$interopDefault($6cb8be828609ef6d$exports)))($ef112bbbb1f1a0f9$var$getUserLocaleInternal, {
    cacheKey: JSON.stringify
});
var $ef112bbbb1f1a0f9$export$2e2bcd8739ae039 = $ef112bbbb1f1a0f9$export$a6ea185b366483aa;


/**
 * Utils
 */ function $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var previousPeriod = getPeriod(date) + offset;
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $21f5a45f3ee49568$var$makeGetEnd(getBeginOfNextPeriod) {
    return function makeGetEndInternal(date) {
        return new Date(getBeginOfNextPeriod(date).getTime() - 1);
    };
}
function $21f5a45f3ee49568$var$makeGetRange(getStart, getEnd) {
    return function makeGetRangeInternal(date) {
        return [
            getStart(date),
            getEnd(date)
        ];
    };
}
function $21f5a45f3ee49568$export$5846dc2d57a5c860(date) {
    if (date instanceof Date) return date.getFullYear();
    if (typeof date === 'number') return date;
    var year = parseInt(date, 10);
    if (typeof date === 'string' && !isNaN(year)) return year;
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $21f5a45f3ee49568$export$6ce1b5acc29cb53b(date) {
    if (date instanceof Date) return date.getMonth();
    throw new Error("Failed to get month from date: ".concat(date, "."));
}
function $21f5a45f3ee49568$export$a8575fd59bc333e3(date) {
    if (date instanceof Date) return date.getMonth() + 1;
    throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
}
function $21f5a45f3ee49568$export$aa350b96d91cd94(date) {
    if (date instanceof Date) return date.getDate();
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $21f5a45f3ee49568$export$257b40f71c07d58f(date) {
    if (date instanceof Date) return date.getHours();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var hoursString = datePieces[0];
            if (hoursString) {
                var hours = parseInt(hoursString, 10);
                if (!isNaN(hours)) return hours;
            }
        }
    }
    throw new Error("Failed to get hours from date: ".concat(date, "."));
}
function $21f5a45f3ee49568$export$b7f1bc3ea3ac4145(date) {
    if (date instanceof Date) return date.getMinutes();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var minutesString = datePieces[1] || '0';
            var minutes = parseInt(minutesString, 10);
            if (!isNaN(minutes)) return minutes;
        }
    }
    throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
function $21f5a45f3ee49568$export$5e9417507ff28427(date) {
    if (date instanceof Date) return date.getSeconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var seconds = parseInt(secondsWithMillisecondsString, 10);
            if (!isNaN(seconds)) return seconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $21f5a45f3ee49568$export$b8e4380f312797af(date) {
    if (date instanceof Date) return date.getMilliseconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var millisecondsString = secondsWithMillisecondsString.split('.')[1] || '0';
            var milliseconds = parseInt(millisecondsString, 10);
            if (!isNaN(milliseconds)) return milliseconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $21f5a45f3ee49568$export$34dd42d02ca37c6b(date) {
    var year = $21f5a45f3ee49568$export$5846dc2d57a5c860(date);
    var centuryStartYear = year + (-year + 1) % 100;
    var centuryStartDate = new Date();
    centuryStartDate.setFullYear(centuryStartYear, 0, 1);
    centuryStartDate.setHours(0, 0, 0, 0);
    return centuryStartDate;
}
var $21f5a45f3ee49568$export$e65b64b0f80e225a = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$34dd42d02ca37c6b, -100);
var $21f5a45f3ee49568$export$3e300bd96d747c8a = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$34dd42d02ca37c6b, 100);
var $21f5a45f3ee49568$export$43c2109e18ca667b = $21f5a45f3ee49568$var$makeGetEnd($21f5a45f3ee49568$export$3e300bd96d747c8a);
var $21f5a45f3ee49568$export$4d124431cf7f00b5 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$43c2109e18ca667b, -100);
var $21f5a45f3ee49568$export$2663e0ade48d35a9 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$43c2109e18ca667b, 100);
var $21f5a45f3ee49568$export$a4332dc3f9de051f = $21f5a45f3ee49568$var$makeGetRange($21f5a45f3ee49568$export$34dd42d02ca37c6b, $21f5a45f3ee49568$export$43c2109e18ca667b);
function $21f5a45f3ee49568$export$8bb35b885d308e78(date) {
    var year = $21f5a45f3ee49568$export$5846dc2d57a5c860(date);
    var decadeStartYear = year + (-year + 1) % 10;
    var decadeStartDate = new Date();
    decadeStartDate.setFullYear(decadeStartYear, 0, 1);
    decadeStartDate.setHours(0, 0, 0, 0);
    return decadeStartDate;
}
var $21f5a45f3ee49568$export$e43f83f55f1766fa = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$8bb35b885d308e78, -10);
var $21f5a45f3ee49568$export$8266d1a140c33d17 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$8bb35b885d308e78, 10);
var $21f5a45f3ee49568$export$aa0bfba5bfc33956 = $21f5a45f3ee49568$var$makeGetEnd($21f5a45f3ee49568$export$8266d1a140c33d17);
var $21f5a45f3ee49568$export$93edec1b41903921 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$aa0bfba5bfc33956, -10);
var $21f5a45f3ee49568$export$112141384c9d3d6b = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$aa0bfba5bfc33956, 10);
var $21f5a45f3ee49568$export$35cef0a1278b17e1 = $21f5a45f3ee49568$var$makeGetRange($21f5a45f3ee49568$export$8bb35b885d308e78, $21f5a45f3ee49568$export$aa0bfba5bfc33956);
function $21f5a45f3ee49568$export$bbcf6a6951bb3c3a(date) {
    var year = $21f5a45f3ee49568$export$5846dc2d57a5c860(date);
    var yearStartDate = new Date();
    yearStartDate.setFullYear(year, 0, 1);
    yearStartDate.setHours(0, 0, 0, 0);
    return yearStartDate;
}
var $21f5a45f3ee49568$export$97fe927b771a6825 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$bbcf6a6951bb3c3a, -1);
var $21f5a45f3ee49568$export$fed82860795beff7 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$bbcf6a6951bb3c3a, 1);
var $21f5a45f3ee49568$export$248ddd7fb95e4a56 = $21f5a45f3ee49568$var$makeGetEnd($21f5a45f3ee49568$export$fed82860795beff7);
var $21f5a45f3ee49568$export$639fe5fbfbb704d0 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$248ddd7fb95e4a56, -1);
var $21f5a45f3ee49568$export$952396487caf69e5 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighbor($21f5a45f3ee49568$export$5846dc2d57a5c860, $21f5a45f3ee49568$export$248ddd7fb95e4a56, 1);
var $21f5a45f3ee49568$export$17e213d8c10b7032 = $21f5a45f3ee49568$var$makeGetRange($21f5a45f3ee49568$export$bbcf6a6951bb3c3a, $21f5a45f3ee49568$export$248ddd7fb95e4a56);
/**
 * Month
 */ function $21f5a45f3ee49568$var$makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborMonthInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = $21f5a45f3ee49568$export$5846dc2d57a5c860(date);
        var month = $21f5a45f3ee49568$export$6ce1b5acc29cb53b(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, 1);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $21f5a45f3ee49568$export$c7002b157c9b9e95(date) {
    var year = $21f5a45f3ee49568$export$5846dc2d57a5c860(date);
    var month = $21f5a45f3ee49568$export$6ce1b5acc29cb53b(date);
    var monthStartDate = new Date();
    monthStartDate.setFullYear(year, month, 1);
    monthStartDate.setHours(0, 0, 0, 0);
    return monthStartDate;
}
var $21f5a45f3ee49568$export$e1815383d4029267 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighborMonth($21f5a45f3ee49568$export$c7002b157c9b9e95, -1);
var $21f5a45f3ee49568$export$21b7c773284d5b43 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighborMonth($21f5a45f3ee49568$export$c7002b157c9b9e95, 1);
var $21f5a45f3ee49568$export$6f306f93ccbcd612 = $21f5a45f3ee49568$var$makeGetEnd($21f5a45f3ee49568$export$21b7c773284d5b43);
var $21f5a45f3ee49568$export$b4b5df1ab9a8303b = $21f5a45f3ee49568$var$makeGetEdgeOfNeighborMonth($21f5a45f3ee49568$export$6f306f93ccbcd612, -1);
var $21f5a45f3ee49568$export$98f1c9e60dc0189 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighborMonth($21f5a45f3ee49568$export$6f306f93ccbcd612, 1);
var $21f5a45f3ee49568$export$c59fdbf3ad20e694 = $21f5a45f3ee49568$var$makeGetRange($21f5a45f3ee49568$export$c7002b157c9b9e95, $21f5a45f3ee49568$export$6f306f93ccbcd612);
/**
 * Day
 */ function $21f5a45f3ee49568$var$makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborDayInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = $21f5a45f3ee49568$export$5846dc2d57a5c860(date);
        var month = $21f5a45f3ee49568$export$6ce1b5acc29cb53b(date);
        var day = $21f5a45f3ee49568$export$aa350b96d91cd94(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, day);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $21f5a45f3ee49568$export$ef6b506418c2b397(date) {
    var year = $21f5a45f3ee49568$export$5846dc2d57a5c860(date);
    var month = $21f5a45f3ee49568$export$6ce1b5acc29cb53b(date);
    var day = $21f5a45f3ee49568$export$aa350b96d91cd94(date);
    var dayStartDate = new Date();
    dayStartDate.setFullYear(year, month, day);
    dayStartDate.setHours(0, 0, 0, 0);
    return dayStartDate;
}
var $21f5a45f3ee49568$export$4f27323eaab2ccfd = $21f5a45f3ee49568$var$makeGetEdgeOfNeighborDay($21f5a45f3ee49568$export$ef6b506418c2b397, -1);
var $21f5a45f3ee49568$export$78c5682078b46db4 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighborDay($21f5a45f3ee49568$export$ef6b506418c2b397, 1);
var $21f5a45f3ee49568$export$7b798396f3e38cd7 = $21f5a45f3ee49568$var$makeGetEnd($21f5a45f3ee49568$export$78c5682078b46db4);
var $21f5a45f3ee49568$export$fde0c09caefdfd4a = $21f5a45f3ee49568$var$makeGetEdgeOfNeighborDay($21f5a45f3ee49568$export$7b798396f3e38cd7, -1);
var $21f5a45f3ee49568$export$f991202e82da93a1 = $21f5a45f3ee49568$var$makeGetEdgeOfNeighborDay($21f5a45f3ee49568$export$7b798396f3e38cd7, 1);
var $21f5a45f3ee49568$export$adb5aef569605e64 = $21f5a45f3ee49568$var$makeGetRange($21f5a45f3ee49568$export$ef6b506418c2b397, $21f5a45f3ee49568$export$7b798396f3e38cd7);
function $21f5a45f3ee49568$export$f645ddd439eb259d(date) {
    return $21f5a45f3ee49568$export$aa350b96d91cd94($21f5a45f3ee49568$export$6f306f93ccbcd612(date));
}
function $21f5a45f3ee49568$var$padStart(num, val) {
    if (val === void 0) val = 2;
    var numStr = "".concat(num);
    if (numStr.length >= val) return num;
    return "0000".concat(numStr).slice(-val);
}
function $21f5a45f3ee49568$export$aefe158a7bd76d23(date) {
    var hours = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$257b40f71c07d58f(date));
    var minutes = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$b7f1bc3ea3ac4145(date));
    return "".concat(hours, ":").concat(minutes);
}
function $21f5a45f3ee49568$export$52113457154e5fc(date) {
    var hours = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$257b40f71c07d58f(date));
    var minutes = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$b7f1bc3ea3ac4145(date));
    var seconds = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$5e9417507ff28427(date));
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
function $21f5a45f3ee49568$export$6f885d58ae224c35(date) {
    var year = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$5846dc2d57a5c860(date), 4);
    var month = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$a8575fd59bc333e3(date));
    return "".concat(year, "-").concat(month);
}
function $21f5a45f3ee49568$export$ce780a31b7197841(date) {
    var year = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$5846dc2d57a5c860(date), 4);
    var month = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$a8575fd59bc333e3(date));
    var day = $21f5a45f3ee49568$var$padStart($21f5a45f3ee49568$export$aa350b96d91cd94(date));
    return "".concat(year, "-").concat(month, "-").concat(day);
}
function $21f5a45f3ee49568$export$98f36b76519fd86(date) {
    return "".concat($21f5a45f3ee49568$export$ce780a31b7197841(date), "T").concat($21f5a45f3ee49568$export$52113457154e5fc(date));
}


var $b70b56bd93db2f08$var$_a;
var $b70b56bd93db2f08$export$26fa441040070c35 = {
    GREGORY: 'gregory',
    HEBREW: 'hebrew',
    ISLAMIC: 'islamic',
    ISO_8601: 'iso8601'
};
var $b70b56bd93db2f08$export$c75dd2712cca6e92 = {
    ARABIC: 'Arabic',
    HEBREW: 'Hebrew',
    ISO_8601: 'ISO 8601',
    US: 'US'
};
var $b70b56bd93db2f08$export$e4e5576db5b8e30f = ($b70b56bd93db2f08$var$_a = {}, $b70b56bd93db2f08$var$_a[$b70b56bd93db2f08$export$26fa441040070c35.GREGORY] = [
    'en-CA',
    'en-US',
    'es-AR',
    'es-BO',
    'es-CL',
    'es-CO',
    'es-CR',
    'es-DO',
    'es-EC',
    'es-GT',
    'es-HN',
    'es-MX',
    'es-NI',
    'es-PA',
    'es-PE',
    'es-PR',
    'es-SV',
    'es-VE',
    'pt-BR'
], $b70b56bd93db2f08$var$_a[$b70b56bd93db2f08$export$26fa441040070c35.HEBREW] = [
    'he',
    'he-IL'
], $b70b56bd93db2f08$var$_a[$b70b56bd93db2f08$export$26fa441040070c35.ISLAMIC] = [
    // ar-LB, ar-MA intentionally missing
    'ar',
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LY',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SD',
    'ar-SY',
    'ar-YE',
    'dv',
    'dv-MV',
    'ps',
    'ps-AR'
], $b70b56bd93db2f08$var$_a);
var $b70b56bd93db2f08$export$ecc24ef5795d74f8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];



var $7476c89b4ce72ab5$var$formatterCache = new Map();
function $7476c89b4ce72ab5$var$getFormatter(options) {
    return function formatter(locale, date) {
        var localeWithDefault = locale || (0, $ef112bbbb1f1a0f9$export$2e2bcd8739ae039)();
        if (!$7476c89b4ce72ab5$var$formatterCache.has(localeWithDefault)) $7476c89b4ce72ab5$var$formatterCache.set(localeWithDefault, new Map());
        var formatterCacheLocale = $7476c89b4ce72ab5$var$formatterCache.get(localeWithDefault);
        if (!formatterCacheLocale.has(options)) formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault || undefined, options).format);
        return formatterCacheLocale.get(options)(date);
    };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 * @returns {Date} Date with hour set to 12.
 */ function $7476c89b4ce72ab5$var$toSafeHour(date) {
    var safeDate = new Date(date);
    return new Date(safeDate.setHours(12));
}
function $7476c89b4ce72ab5$var$getSafeFormatter(options) {
    return function(locale, date) {
        return $7476c89b4ce72ab5$var$getFormatter(options)(locale, $7476c89b4ce72ab5$var$toSafeHour(date));
    };
}
var $7476c89b4ce72ab5$var$formatDateOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
};
var $7476c89b4ce72ab5$var$formatDayOptions = {
    day: 'numeric'
};
var $7476c89b4ce72ab5$var$formatLongDateOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};
var $7476c89b4ce72ab5$var$formatMonthOptions = {
    month: 'long'
};
var $7476c89b4ce72ab5$var$formatMonthYearOptions = {
    month: 'long',
    year: 'numeric'
};
var $7476c89b4ce72ab5$var$formatShortWeekdayOptions = {
    weekday: 'short'
};
var $7476c89b4ce72ab5$var$formatWeekdayOptions = {
    weekday: 'long'
};
var $7476c89b4ce72ab5$var$formatYearOptions = {
    year: 'numeric'
};
var $7476c89b4ce72ab5$export$3ae94a2503e890a1 = $7476c89b4ce72ab5$var$getSafeFormatter($7476c89b4ce72ab5$var$formatDateOptions);
var $7476c89b4ce72ab5$export$a7f242eff11c1345 = $7476c89b4ce72ab5$var$getSafeFormatter($7476c89b4ce72ab5$var$formatDayOptions);
var $7476c89b4ce72ab5$export$322b36d80aef60ca = $7476c89b4ce72ab5$var$getSafeFormatter($7476c89b4ce72ab5$var$formatLongDateOptions);
var $7476c89b4ce72ab5$export$d0536c8e7f45796e = $7476c89b4ce72ab5$var$getSafeFormatter($7476c89b4ce72ab5$var$formatMonthOptions);
var $7476c89b4ce72ab5$export$18f8ccbe37e54acd = $7476c89b4ce72ab5$var$getSafeFormatter($7476c89b4ce72ab5$var$formatMonthYearOptions);
var $7476c89b4ce72ab5$export$7ebe25e42481bc02 = $7476c89b4ce72ab5$var$getSafeFormatter($7476c89b4ce72ab5$var$formatShortWeekdayOptions);
var $7476c89b4ce72ab5$export$407180b957f39d7e = $7476c89b4ce72ab5$var$getSafeFormatter($7476c89b4ce72ab5$var$formatWeekdayOptions);
var $7476c89b4ce72ab5$export$2979e79cc7cbf15b = $7476c89b4ce72ab5$var$getSafeFormatter($7476c89b4ce72ab5$var$formatYearOptions);


var $1e71737657997e6e$var$SUNDAY = (0, $b70b56bd93db2f08$export$ecc24ef5795d74f8)[0];
var $1e71737657997e6e$var$FRIDAY = (0, $b70b56bd93db2f08$export$ecc24ef5795d74f8)[5];
var $1e71737657997e6e$var$SATURDAY = (0, $b70b56bd93db2f08$export$ecc24ef5795d74f8)[6];
function $1e71737657997e6e$export$2061056d06d7cdf7(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601:
            // Shifts days of the week so that Monday is 0, Sunday is 6
            return (weekday + 6) % 7;
        case (0, $b70b56bd93db2f08$export$26fa441040070c35).ISLAMIC:
            return (weekday + 1) % 7;
        case (0, $b70b56bd93db2f08$export$26fa441040070c35).HEBREW:
        case (0, $b70b56bd93db2f08$export$26fa441040070c35).GREGORY:
            return weekday;
        default:
            throw new Error('Unsupported calendar type.');
    }
}
function $1e71737657997e6e$export$5fc0cc931278f768(date) {
    var beginOfCentury = (0, $21f5a45f3ee49568$export$34dd42d02ca37c6b)(date);
    return (0, $21f5a45f3ee49568$export$5846dc2d57a5c860)(beginOfCentury);
}
function $1e71737657997e6e$export$59fb6e4ffa904295(date) {
    var beginOfDecade = (0, $21f5a45f3ee49568$export$8bb35b885d308e78)(date);
    return (0, $21f5a45f3ee49568$export$5846dc2d57a5c860)(beginOfDecade);
}
function $1e71737657997e6e$export$84e707e5f485f282(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601;
    var year = (0, $21f5a45f3ee49568$export$5846dc2d57a5c860)(date);
    var monthIndex = (0, $21f5a45f3ee49568$export$6ce1b5acc29cb53b)(date);
    var day = date.getDate() - $1e71737657997e6e$export$2061056d06d7cdf7(date, calendarType);
    return new Date(year, monthIndex, day);
}
function $1e71737657997e6e$export$b59889984706b7a7(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601;
    var calendarTypeForWeekNumber = calendarType === (0, $b70b56bd93db2f08$export$26fa441040070c35).GREGORY ? (0, $b70b56bd93db2f08$export$26fa441040070c35).GREGORY : (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601;
    var beginOfWeek = $1e71737657997e6e$export$84e707e5f485f282(date, calendarType);
    var year = (0, $21f5a45f3ee49568$export$5846dc2d57a5c860)(date) + 1;
    var dayInWeekOne;
    var beginOfFirstWeek;
    // Look for the first week one that does not come after a given date
    do {
        dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601 ? 4 : 1);
        beginOfFirstWeek = $1e71737657997e6e$export$84e707e5f485f282(dayInWeekOne, calendarType);
        year -= 1;
    }while (date < beginOfFirstWeek);
    return Math.round((beginOfWeek.getTime() - beginOfFirstWeek.getTime()) / (8.64e7 * 7)) + 1;
}
function $1e71737657997e6e$export$700a64ae37cbc741(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $21f5a45f3ee49568$export$34dd42d02ca37c6b)(date);
        case 'decade':
            return (0, $21f5a45f3ee49568$export$8bb35b885d308e78)(date);
        case 'year':
            return (0, $21f5a45f3ee49568$export$bbcf6a6951bb3c3a)(date);
        case 'month':
            return (0, $21f5a45f3ee49568$export$c7002b157c9b9e95)(date);
        case 'day':
            return (0, $21f5a45f3ee49568$export$ef6b506418c2b397)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$fac7f4c8b12617ff(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $21f5a45f3ee49568$export$e65b64b0f80e225a)(date);
        case 'decade':
            return (0, $21f5a45f3ee49568$export$e43f83f55f1766fa)(date);
        case 'year':
            return (0, $21f5a45f3ee49568$export$97fe927b771a6825)(date);
        case 'month':
            return (0, $21f5a45f3ee49568$export$e1815383d4029267)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$19193c1f2d841d47(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $21f5a45f3ee49568$export$3e300bd96d747c8a)(date);
        case 'decade':
            return (0, $21f5a45f3ee49568$export$8266d1a140c33d17)(date);
        case 'year':
            return (0, $21f5a45f3ee49568$export$fed82860795beff7)(date);
        case 'month':
            return (0, $21f5a45f3ee49568$export$21b7c773284d5b43)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$b514bf5935bed2bf(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $21f5a45f3ee49568$export$e43f83f55f1766fa)(date, -100);
        case 'year':
            return (0, $21f5a45f3ee49568$export$97fe927b771a6825)(date, -10);
        case 'month':
            return (0, $21f5a45f3ee49568$export$e1815383d4029267)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$2805b7ce8402b644(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $21f5a45f3ee49568$export$8266d1a140c33d17)(date, 100);
        case 'year':
            return (0, $21f5a45f3ee49568$export$fed82860795beff7)(date, 10);
        case 'month':
            return (0, $21f5a45f3ee49568$export$21b7c773284d5b43)(date, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$946298ccd438a697(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $21f5a45f3ee49568$export$43c2109e18ca667b)(date);
        case 'decade':
            return (0, $21f5a45f3ee49568$export$aa0bfba5bfc33956)(date);
        case 'year':
            return (0, $21f5a45f3ee49568$export$248ddd7fb95e4a56)(date);
        case 'month':
            return (0, $21f5a45f3ee49568$export$6f306f93ccbcd612)(date);
        case 'day':
            return (0, $21f5a45f3ee49568$export$7b798396f3e38cd7)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$3030eb755e02a078(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $21f5a45f3ee49568$export$4d124431cf7f00b5)(date);
        case 'decade':
            return (0, $21f5a45f3ee49568$export$93edec1b41903921)(date);
        case 'year':
            return (0, $21f5a45f3ee49568$export$639fe5fbfbb704d0)(date);
        case 'month':
            return (0, $21f5a45f3ee49568$export$b4b5df1ab9a8303b)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$d34b1dc45bd5f1d3(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $21f5a45f3ee49568$export$93edec1b41903921)(date, -100);
        case 'year':
            return (0, $21f5a45f3ee49568$export$639fe5fbfbb704d0)(date, -10);
        case 'month':
            return (0, $21f5a45f3ee49568$export$b4b5df1ab9a8303b)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$fef151b94550e9f5(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $21f5a45f3ee49568$export$a4332dc3f9de051f)(date);
        case 'decade':
            return (0, $21f5a45f3ee49568$export$35cef0a1278b17e1)(date);
        case 'year':
            return (0, $21f5a45f3ee49568$export$17e213d8c10b7032)(date);
        case 'month':
            return (0, $21f5a45f3ee49568$export$c59fdbf3ad20e694)(date);
        case 'day':
            return (0, $21f5a45f3ee49568$export$adb5aef569605e64)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $1e71737657997e6e$export$3a3e6dbcaf74641d(rangeType, date1, date2) {
    var rawNextValue = [
        date1,
        date2
    ].sort(function(a, b) {
        return a.getTime() - b.getTime();
    });
    return [
        $1e71737657997e6e$export$700a64ae37cbc741(rangeType, rawNextValue[0]),
        $1e71737657997e6e$export$946298ccd438a697(rangeType, rawNextValue[1])
    ];
}
function $1e71737657997e6e$var$toYearLabel(locale, formatYear, dates) {
    if (formatYear === void 0) formatYear = (0, $7476c89b4ce72ab5$export$2979e79cc7cbf15b);
    return dates.map(function(date) {
        return formatYear(locale, date);
    }).join(" \u2013 ");
}
function $1e71737657997e6e$export$a05bb87f2c518835(locale, formatYear, date) {
    return $1e71737657997e6e$var$toYearLabel(locale, formatYear, (0, $21f5a45f3ee49568$export$a4332dc3f9de051f)(date));
}
function $1e71737657997e6e$export$2e69ef6076209750(locale, formatYear, date) {
    return $1e71737657997e6e$var$toYearLabel(locale, formatYear, (0, $21f5a45f3ee49568$export$35cef0a1278b17e1)(date));
}
function $1e71737657997e6e$export$12e2595dc60a5d5(date) {
    return date.getDay() === new Date().getDay();
}
function $1e71737657997e6e$export$618d60ea299da42(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $b70b56bd93db2f08$export$26fa441040070c35).ISLAMIC:
        case (0, $b70b56bd93db2f08$export$26fa441040070c35).HEBREW:
            return weekday === $1e71737657997e6e$var$FRIDAY || weekday === $1e71737657997e6e$var$SATURDAY;
        case (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601:
        case (0, $b70b56bd93db2f08$export$26fa441040070c35).GREGORY:
            return weekday === $1e71737657997e6e$var$SATURDAY || weekday === $1e71737657997e6e$var$SUNDAY;
        default:
            throw new Error('Unsupported calendar type.');
    }
}



'use client';
var $34afc81d0ab58ae4$var$className = 'react-calendar__navigation';
function $34afc81d0ab58ae4$export$2e2bcd8739ae039(_a) {
    var activeStartDate = _a.activeStartDate, drillUp = _a.drillUp, _b = _a.formatMonthYear, formatMonthYear = _b === void 0 ? (0, $7476c89b4ce72ab5$export$18f8ccbe37e54acd) : _b, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $7476c89b4ce72ab5$export$2979e79cc7cbf15b) : _c, locale = _a.locale, maxDate = _a.maxDate, minDate = _a.minDate, _d = _a.navigationAriaLabel, navigationAriaLabel = _d === void 0 ? '' : _d, navigationAriaLive = _a.navigationAriaLive, navigationLabel = _a.navigationLabel, _e = _a.next2AriaLabel, next2AriaLabel = _e === void 0 ? '' : _e, _f = _a.next2Label, next2Label = _f === void 0 ? "\xbb" : _f, _g = _a.nextAriaLabel, nextAriaLabel = _g === void 0 ? '' : _g, _h = _a.nextLabel, nextLabel = _h === void 0 ? "\u203A" : _h, _j = _a.prev2AriaLabel, prev2AriaLabel = _j === void 0 ? '' : _j, _k = _a.prev2Label, prev2Label = _k === void 0 ? "\xab" : _k, _l = _a.prevAriaLabel, prevAriaLabel = _l === void 0 ? '' : _l, _m = _a.prevLabel, prevLabel = _m === void 0 ? "\u2039" : _m, setActiveStartDate = _a.setActiveStartDate, showDoubleView = _a.showDoubleView, view = _a.view, views = _a.views;
    var drillUpAvailable = views.indexOf(view) > 0;
    var shouldShowPrevNext2Buttons = view !== 'century';
    var previousActiveStartDate = (0, $1e71737657997e6e$export$fac7f4c8b12617ff)(view, activeStartDate);
    var previousActiveStartDate2 = shouldShowPrevNext2Buttons ? (0, $1e71737657997e6e$export$b514bf5935bed2bf)(view, activeStartDate) : undefined;
    var nextActiveStartDate = (0, $1e71737657997e6e$export$19193c1f2d841d47)(view, activeStartDate);
    var nextActiveStartDate2 = shouldShowPrevNext2Buttons ? (0, $1e71737657997e6e$export$2805b7ce8402b644)(view, activeStartDate) : undefined;
    var prevButtonDisabled = function() {
        if (previousActiveStartDate.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $1e71737657997e6e$export$3030eb755e02a078)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function() {
        if (previousActiveStartDate2.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $1e71737657997e6e$export$d34b1dc45bd5f1d3)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
    var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;
    function onClickPrevious() {
        setActiveStartDate(previousActiveStartDate, 'prev');
    }
    function onClickPrevious2() {
        setActiveStartDate(previousActiveStartDate2, 'prev2');
    }
    function onClickNext() {
        setActiveStartDate(nextActiveStartDate, 'next');
    }
    function onClickNext2() {
        setActiveStartDate(nextActiveStartDate2, 'next2');
    }
    function renderLabel(date) {
        var label = function() {
            switch(view){
                case 'century':
                    return (0, $1e71737657997e6e$export$a05bb87f2c518835)(locale, formatYear, date);
                case 'decade':
                    return (0, $1e71737657997e6e$export$2e69ef6076209750)(locale, formatYear, date);
                case 'year':
                    return formatYear(locale, date);
                case 'month':
                    return formatMonthYear(locale, date);
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        return navigationLabel ? navigationLabel({
            date: date,
            label: label,
            locale: locale || (0, $ef112bbbb1f1a0f9$export$a6ea185b366483aa)() || undefined,
            view: view
        }) : label;
    }
    function renderButton() {
        var labelClassName = "".concat($34afc81d0ab58ae4$var$className, "__label");
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", {
            "aria-label": navigationAriaLabel,
            "aria-live": navigationAriaLive,
            className: labelClassName,
            disabled: !drillUpAvailable,
            onClick: drillUp,
            style: {
                flexGrow: 1
            },
            type: "button"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
        }, renderLabel(activeStartDate)), showDoubleView ? (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
            className: "".concat(labelClassName, "__divider")
        }, " \u2013 "), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
        }, renderLabel(nextActiveStartDate))) : null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: $34afc81d0ab58ae4$var$className
    }, prev2Label !== null && shouldShowPrevNext2Buttons ? (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", {
        "aria-label": prev2AriaLabel,
        className: "".concat($34afc81d0ab58ae4$var$className, "__arrow ").concat($34afc81d0ab58ae4$var$className, "__prev2-button"),
        disabled: prev2ButtonDisabled,
        onClick: onClickPrevious2,
        type: "button"
    }, prev2Label) : null, prevLabel !== null && (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", {
        "aria-label": prevAriaLabel,
        className: "".concat($34afc81d0ab58ae4$var$className, "__arrow ").concat($34afc81d0ab58ae4$var$className, "__prev-button"),
        disabled: prevButtonDisabled,
        onClick: onClickPrevious,
        type: "button"
    }, prevLabel), renderButton(), nextLabel !== null && (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", {
        "aria-label": nextAriaLabel,
        className: "".concat($34afc81d0ab58ae4$var$className, "__arrow ").concat($34afc81d0ab58ae4$var$className, "__next-button"),
        disabled: nextButtonDisabled,
        onClick: onClickNext,
        type: "button"
    }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons ? (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", {
        "aria-label": next2AriaLabel,
        className: "".concat($34afc81d0ab58ae4$var$className, "__arrow ").concat($34afc81d0ab58ae4$var$className, "__next2-button"),
        disabled: next2ButtonDisabled,
        onClick: onClickNext2,
        type: "button"
    }, next2Label) : null);
}



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
var $06787a45e0165459$var$__assign = undefined && undefined.__assign || function() {
    $06787a45e0165459$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $06787a45e0165459$var$__assign.apply(this, arguments);
};
var $06787a45e0165459$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $06787a45e0165459$var$toPercent(num) {
    return "".concat(num, "%");
}
function $06787a45e0165459$export$2e2bcd8739ae039(_a) {
    var children = _a.children, className = _a.className, count = _a.count, direction = _a.direction, offset = _a.offset, style = _a.style, wrap = _a.wrap, otherProps = $06787a45e0165459$var$__rest(_a, [
        "children",
        "className",
        "count",
        "direction",
        "offset",
        "style",
        "wrap"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", $06787a45e0165459$var$__assign({
        className: className,
        style: $06787a45e0165459$var$__assign({
            display: 'flex',
            flexDirection: direction,
            flexWrap: wrap ? 'wrap' : 'nowrap'
        }, style)
    }, otherProps), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Children.map(children, function(child, index) {
        var marginInlineStart = offset && index === 0 ? $06787a45e0165459$var$toPercent(100 * offset / count) : null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(child, $06787a45e0165459$var$__assign($06787a45e0165459$var$__assign({}, child.props), {
            style: {
                flexBasis: $06787a45e0165459$var$toPercent(100 / count),
                flexShrink: 0,
                flexGrow: 0,
                overflow: 'hidden',
                marginLeft: marginInlineStart,
                marginInlineStart: marginInlineStart,
                marginInlineEnd: 0
            }
        }));
    }));
}


var $9abc3dc86fc6eb1f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9abc3dc86fc6eb1f$var$__DEV__ = false;
var $9abc3dc86fc6eb1f$var$warning = function() {};
if ($9abc3dc86fc6eb1f$var$__DEV__) {
    var $9abc3dc86fc6eb1f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9abc3dc86fc6eb1f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9abc3dc86fc6eb1f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$9abc3dc86fc6eb1f$exports = $9abc3dc86fc6eb1f$var$warning;




var $c0dd79cc9c7f4c96$var$_a;
function $c0dd79cc9c7f4c96$export$cf95c51b03f10bae(value, min, max) {
    if (min && min > value) return min;
    if (max && max < value) return max;
    return value;
}
function $c0dd79cc9c7f4c96$export$7c4e06fee2f75722(value, range) {
    return range[0] <= value && range[1] >= value;
}
function $c0dd79cc9c7f4c96$export$eecb2aa703319c46(greaterRange, smallerRange) {
    return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function $c0dd79cc9c7f4c96$export$2e215bb7f5401ba1(range1, range2) {
    return $c0dd79cc9c7f4c96$export$7c4e06fee2f75722(range1[0], range2) || $c0dd79cc9c7f4c96$export$7c4e06fee2f75722(range1[1], range2);
}
function $c0dd79cc9c7f4c96$var$getRangeClassNames(valueRange, dateRange, baseClassName) {
    var isRange = $c0dd79cc9c7f4c96$export$2e215bb7f5401ba1(dateRange, valueRange);
    var classes = [];
    if (isRange) {
        classes.push(baseClassName);
        var isRangeStart = $c0dd79cc9c7f4c96$export$7c4e06fee2f75722(valueRange[0], dateRange);
        var isRangeEnd = $c0dd79cc9c7f4c96$export$7c4e06fee2f75722(valueRange[1], dateRange);
        if (isRangeStart) classes.push("".concat(baseClassName, "Start"));
        if (isRangeEnd) classes.push("".concat(baseClassName, "End"));
        if (isRangeStart && isRangeEnd) classes.push("".concat(baseClassName, "BothEnds"));
    }
    return classes;
}
function $c0dd79cc9c7f4c96$var$isCompleteValue(value) {
    if (Array.isArray(value)) return value[0] !== null && value[1] !== null;
    return value !== null;
}
function $c0dd79cc9c7f4c96$export$8b25b190354ee282(args) {
    if (!args) throw new Error('args is required');
    var value = args.value, date = args.date, hover = args.hover;
    var className = 'react-calendar__tile';
    var classes = [
        className
    ];
    if (!date) return classes;
    var now = new Date();
    var dateRange = function() {
        if (Array.isArray(date)) return date;
        var dateType = args.dateType;
        if (!dateType) throw new Error('dateType is required when date is not an array of two dates');
        return (0, $1e71737657997e6e$export$fef151b94550e9f5)(dateType, date);
    }();
    if ($c0dd79cc9c7f4c96$export$7c4e06fee2f75722(now, dateRange)) classes.push("".concat(className, "--now"));
    if (!value || !$c0dd79cc9c7f4c96$var$isCompleteValue(value)) return classes;
    var valueRange = function() {
        if (Array.isArray(value)) return value;
        var valueType = args.valueType;
        if (!valueType) throw new Error('valueType is required when value is not an array of two dates');
        return (0, $1e71737657997e6e$export$fef151b94550e9f5)(valueType, value);
    }();
    if ($c0dd79cc9c7f4c96$export$eecb2aa703319c46(valueRange, dateRange)) classes.push("".concat(className, "--active"));
    else if ($c0dd79cc9c7f4c96$export$2e215bb7f5401ba1(valueRange, dateRange)) classes.push("".concat(className, "--hasActive"));
    var valueRangeClassNames = $c0dd79cc9c7f4c96$var$getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
    classes.push.apply(classes, valueRangeClassNames);
    var valueArray = Array.isArray(value) ? value : [
        value
    ];
    if (hover && valueArray.length === 1) {
        var hoverRange = hover > valueRange[0] ? [
            valueRange[0],
            hover
        ] : [
            hover,
            valueRange[0]
        ];
        var hoverRangeClassNames = $c0dd79cc9c7f4c96$var$getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
        classes.push.apply(classes, hoverRangeClassNames);
    }
    return classes;
}
var $c0dd79cc9c7f4c96$var$calendarTypeMap = ($c0dd79cc9c7f4c96$var$_a = {}, $c0dd79cc9c7f4c96$var$_a[(0, $b70b56bd93db2f08$export$c75dd2712cca6e92).ARABIC] = (0, $b70b56bd93db2f08$export$26fa441040070c35).ISLAMIC, $c0dd79cc9c7f4c96$var$_a[(0, $b70b56bd93db2f08$export$c75dd2712cca6e92).HEBREW] = (0, $b70b56bd93db2f08$export$26fa441040070c35).HEBREW, $c0dd79cc9c7f4c96$var$_a[(0, $b70b56bd93db2f08$export$c75dd2712cca6e92).ISO_8601] = (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601, $c0dd79cc9c7f4c96$var$_a[(0, $b70b56bd93db2f08$export$c75dd2712cca6e92).US] = (0, $b70b56bd93db2f08$export$26fa441040070c35).GREGORY, $c0dd79cc9c7f4c96$var$_a);
function $c0dd79cc9c7f4c96$var$isDeprecatedCalendarType(calendarType) {
    return calendarType !== undefined && calendarType in (0, $b70b56bd93db2f08$export$c75dd2712cca6e92);
}
var $c0dd79cc9c7f4c96$var$warned = false;
function $c0dd79cc9c7f4c96$export$52aa1e9fb4a280ce(calendarTypeOrDeprecatedCalendarType) {
    if ($c0dd79cc9c7f4c96$var$isDeprecatedCalendarType(calendarTypeOrDeprecatedCalendarType)) {
        var calendarType = $c0dd79cc9c7f4c96$var$calendarTypeMap[calendarTypeOrDeprecatedCalendarType];
        (0, (/*@__PURE__*/$parcel$interopDefault($9abc3dc86fc6eb1f$exports)))($c0dd79cc9c7f4c96$var$warned, "Specifying calendarType=\"".concat(calendarTypeOrDeprecatedCalendarType, "\" is deprecated. Use calendarType=\"").concat(calendarType, "\" instead."));
        $c0dd79cc9c7f4c96$var$warned = true;
        return calendarType;
    }
    return calendarTypeOrDeprecatedCalendarType;
}


function $9ee991abc77d5261$export$2e2bcd8739ae039(_a) {
    var className = _a.className, _b = _a.count, count = _b === void 0 ? 3 : _b, dateTransform = _a.dateTransform, dateType = _a.dateType, end = _a.end, hover = _a.hover, offset = _a.offset, renderTile = _a.renderTile, start = _a.start, _c = _a.step, step = _c === void 0 ? 1 : _c, value = _a.value, valueType = _a.valueType;
    var tiles = [];
    for(var point = start; point <= end; point += step){
        var date = dateTransform(point);
        tiles.push(renderTile({
            classes: (0, $c0dd79cc9c7f4c96$export$8b25b190354ee282)({
                date: date,
                dateType: dateType,
                hover: hover,
                value: value,
                valueType: valueType
            }),
            date: date
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $06787a45e0165459$export$2e2bcd8739ae039), {
        className: className,
        count: count,
        offset: offset,
        wrap: true
    }, tiles);
}



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

function $0d1563031ac5c10b$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, children = props.children, classes = props.classes, date = props.date, formatAbbr = props.formatAbbr, locale = props.locale, maxDate = props.maxDate, maxDateTransform = props.maxDateTransform, minDate = props.minDate, minDateTransform = props.minDateTransform, onClick = props.onClick, onMouseOver = props.onMouseOver, style = props.style, tileClassNameProps = props.tileClassName, tileContentProps = props.tileContent, tileDisabled = props.tileDisabled, view = props.view;
    var tileClassName = (0, $aqdBs.useMemo)(function() {
        var args = {
            activeStartDate: activeStartDate,
            date: date,
            view: view
        };
        return typeof tileClassNameProps === 'function' ? tileClassNameProps(args) : tileClassNameProps;
    }, [
        activeStartDate,
        date,
        tileClassNameProps,
        view
    ]);
    var tileContent = (0, $aqdBs.useMemo)(function() {
        var args = {
            activeStartDate: activeStartDate,
            date: date,
            view: view
        };
        return typeof tileContentProps === 'function' ? tileContentProps(args) : tileContentProps;
    }, [
        activeStartDate,
        date,
        tileContentProps,
        view
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
            activeStartDate: activeStartDate,
            date: date,
            view: view
        }),
        onClick: onClick ? function(event) {
            return onClick(date, event);
        } : undefined,
        onFocus: onMouseOver ? function() {
            return onMouseOver(date);
        } : undefined,
        onMouseOver: onMouseOver ? function() {
            return onMouseOver(date);
        } : undefined,
        style: style,
        type: "button"
    }, formatAbbr ? (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
    }, children) : children, tileContent);
}




var $bc21b1485a1652a4$var$__assign = undefined && undefined.__assign || function() {
    $bc21b1485a1652a4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc21b1485a1652a4$var$__assign.apply(this, arguments);
};
var $bc21b1485a1652a4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bc21b1485a1652a4$var$className = 'react-calendar__century-view__decades__decade';
function $bc21b1485a1652a4$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, currentCentury = _a.currentCentury, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $7476c89b4ce72ab5$export$2979e79cc7cbf15b) : _c, otherProps = $bc21b1485a1652a4$var$__rest(_a, [
        "classes",
        "currentCentury",
        "formatYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    var classesProps = [];
    if (classes) classesProps.push.apply(classesProps, classes);
    if ($bc21b1485a1652a4$var$className) classesProps.push($bc21b1485a1652a4$var$className);
    if ((0, $21f5a45f3ee49568$export$34dd42d02ca37c6b)(date).getFullYear() !== currentCentury) classesProps.push("".concat($bc21b1485a1652a4$var$className, "--neighboringCentury"));
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $0d1563031ac5c10b$export$2e2bcd8739ae039), $bc21b1485a1652a4$var$__assign({}, otherProps, {
        classes: classesProps,
        maxDateTransform: (0, $21f5a45f3ee49568$export$aa0bfba5bfc33956),
        minDateTransform: (0, $21f5a45f3ee49568$export$8bb35b885d308e78),
        view: "century"
    }), (0, $1e71737657997e6e$export$2e69ef6076209750)(locale, formatYear, date));
}



var $55761eef785c21b4$var$__assign = undefined && undefined.__assign || function() {
    $55761eef785c21b4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $55761eef785c21b4$var$__assign.apply(this, arguments);
};
var $55761eef785c21b4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $55761eef785c21b4$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, showNeighboringCentury = props.showNeighboringCentury, value = props.value, valueType = props.valueType, otherProps = $55761eef785c21b4$var$__rest(props, [
        "activeStartDate",
        "hover",
        "showNeighboringCentury",
        "value",
        "valueType"
    ]);
    var start = (0, $1e71737657997e6e$export$5fc0cc931278f768)(activeStartDate);
    var end = start + (showNeighboringCentury ? 119 : 99);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $9ee991abc77d5261$export$2e2bcd8739ae039), {
        className: "react-calendar__century-view__decades",
        dateTransform: (0, $21f5a45f3ee49568$export$8bb35b885d308e78),
        dateType: "decade",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $55761eef785c21b4$var$__rest(_a, [
                "date"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $bc21b1485a1652a4$export$2e2bcd8739ae039), $55761eef785c21b4$var$__assign({
                key: date.getTime()
            }, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                currentCentury: start,
                date: date
            }));
        },
        start: start,
        step: 10,
        value: value,
        valueType: valueType
    });
}




var $440b477dd2568968$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $440b477dd2568968$var$calendarTypes = Object.values((0, $b70b56bd93db2f08$export$26fa441040070c35));
var $440b477dd2568968$var$deprecatedCalendarTypes = Object.values((0, $b70b56bd93db2f08$export$c75dd2712cca6e92));
var $440b477dd2568968$var$allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var $440b477dd2568968$export$9780328ce60eac34 = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf($440b477dd2568968$var$__spreadArray($440b477dd2568968$var$__spreadArray([], $440b477dd2568968$var$calendarTypes, true), $440b477dd2568968$var$deprecatedCalendarTypes, true));
var $440b477dd2568968$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string)
]);
var $440b477dd2568968$export$283839a53860a2f5 = function isMinDate(props, propName, componentName) {
    var _a = props, _b = propName, minDate = _a[_b];
    if (!minDate) return null;
    if (!(minDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof minDate, "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var maxDate = props.maxDate;
    if (maxDate && minDate > maxDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof minDate, "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    return null;
};
var $440b477dd2568968$export$20075fd45e42d41c = function isMaxDate(props, propName, componentName) {
    var _a = props, _b = propName, maxDate = _a[_b];
    if (!maxDate) return null;
    if (!(maxDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof maxDate, "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var minDate = props.minDate;
    if (minDate && maxDate < minDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof maxDate, "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    return null;
};
var $440b477dd2568968$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).exact({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).any
    })
]);
var $440b477dd2568968$var$isRange = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).instanceOf(Date),
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        null
    ])
]).isRequired);
var $440b477dd2568968$export$2fb7a00a48619649 = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).instanceOf(Date),
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        null
    ]),
    $440b477dd2568968$var$isRange
]);
var $440b477dd2568968$export$bf6a8a97c2633c68 = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf($440b477dd2568968$var$allViews));
var $440b477dd2568968$export$7c1393839656cd16 = function isView(props, propName, componentName) {
    var _a = props, _b = propName, view = _a[_b];
    if (view !== undefined && (typeof view !== 'string' || $440b477dd2568968$var$allViews.indexOf(view) === -1)) return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat($440b477dd2568968$var$allViews.map(function(a) {
        return "\"".concat(a, "\"");
    }).join(', '), "]."));
    // Everything is fine
    return null;
};
$440b477dd2568968$export$7c1393839656cd16.isRequired = function isViewIsRequired(props, propName, componentName, location, propFullName) {
    var _a = props, _b = propName, view = _a[_b];
    if (!view) return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
    return $440b477dd2568968$export$7c1393839656cd16(props, propName, componentName, location, propFullName);
};
var $440b477dd2568968$export$382f6fb00c4220 = function(type) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf(type);
};
var $440b477dd2568968$export$61cce6a131f71246 = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).instanceOf(Date).isRequired,
    hover: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).instanceOf(Date),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    maxDate: $440b477dd2568968$export$20075fd45e42d41c,
    minDate: $440b477dd2568968$export$283839a53860a2f5,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
        $440b477dd2568968$export$d53f3db2f43345df
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node
    ]),
    value: $440b477dd2568968$export$2fb7a00a48619649,
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'century',
        'decade',
        'year',
        'month',
        'day'
    ]).isRequired
};
var $440b477dd2568968$export$8571f7299c7936ad = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).instanceOf(Date).isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired).isRequired,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).instanceOf(Date).isRequired,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    maxDate: $440b477dd2568968$export$20075fd45e42d41c,
    minDate: $440b477dd2568968$export$283839a53860a2f5,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ])),
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
        $440b477dd2568968$export$d53f3db2f43345df
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node
    ]),
    tileDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func
};


var $6537232d923b2afe$var$__assign = undefined && undefined.__assign || function() {
    $6537232d923b2afe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6537232d923b2afe$var$__assign.apply(this, arguments);
};
/**
 * Displays a given century.
 */ var $6537232d923b2afe$var$CenturyView = function CenturyView(props) {
    function renderDecades() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $55761eef785c21b4$export$2e2bcd8739ae039), $6537232d923b2afe$var$__assign({}, props));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "react-calendar__century-view"
    }, renderDecades());
};
$6537232d923b2afe$var$CenturyView.propTypes = $6537232d923b2afe$var$__assign($6537232d923b2afe$var$__assign({}, (0, $440b477dd2568968$export$61cce6a131f71246)), {
    showNeighboringCentury: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool
});
var $6537232d923b2afe$export$2e2bcd8739ae039 = $6537232d923b2afe$var$CenturyView;



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");



var $be5a12decb274527$var$__assign = undefined && undefined.__assign || function() {
    $be5a12decb274527$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be5a12decb274527$var$__assign.apply(this, arguments);
};
var $be5a12decb274527$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $be5a12decb274527$var$className = 'react-calendar__decade-view__years__year';
function $be5a12decb274527$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, currentDecade = _a.currentDecade, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $7476c89b4ce72ab5$export$2979e79cc7cbf15b) : _c, otherProps = $be5a12decb274527$var$__rest(_a, [
        "classes",
        "currentDecade",
        "formatYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    var classesProps = [];
    if (classes) classesProps.push.apply(classesProps, classes);
    if ($be5a12decb274527$var$className) classesProps.push($be5a12decb274527$var$className);
    if ((0, $21f5a45f3ee49568$export$8bb35b885d308e78)(date).getFullYear() !== currentDecade) classesProps.push("".concat($be5a12decb274527$var$className, "--neighboringDecade"));
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $0d1563031ac5c10b$export$2e2bcd8739ae039), $be5a12decb274527$var$__assign({}, otherProps, {
        classes: classesProps,
        maxDateTransform: (0, $21f5a45f3ee49568$export$248ddd7fb95e4a56),
        minDateTransform: (0, $21f5a45f3ee49568$export$bbcf6a6951bb3c3a),
        view: "decade"
    }), formatYear(locale, date));
}



var $50975149e6956930$var$__assign = undefined && undefined.__assign || function() {
    $50975149e6956930$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $50975149e6956930$var$__assign.apply(this, arguments);
};
var $50975149e6956930$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $50975149e6956930$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, showNeighboringDecade = props.showNeighboringDecade, value = props.value, valueType = props.valueType, otherProps = $50975149e6956930$var$__rest(props, [
        "activeStartDate",
        "hover",
        "showNeighboringDecade",
        "value",
        "valueType"
    ]);
    var start = (0, $1e71737657997e6e$export$59fb6e4ffa904295)(activeStartDate);
    var end = start + (showNeighboringDecade ? 11 : 9);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $9ee991abc77d5261$export$2e2bcd8739ae039), {
        className: "react-calendar__decade-view__years",
        dateTransform: (0, $21f5a45f3ee49568$export$bbcf6a6951bb3c3a),
        dateType: "year",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $50975149e6956930$var$__rest(_a, [
                "date"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $be5a12decb274527$export$2e2bcd8739ae039), $50975149e6956930$var$__assign({
                key: date.getTime()
            }, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                currentDecade: start,
                date: date
            }));
        },
        start: start,
        value: value,
        valueType: valueType
    });
}



var $915f7bee255baead$var$__assign = undefined && undefined.__assign || function() {
    $915f7bee255baead$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $915f7bee255baead$var$__assign.apply(this, arguments);
};
/**
 * Displays a given decade.
 */ var $915f7bee255baead$var$DecadeView = function DecadeView(props) {
    function renderYears() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $50975149e6956930$export$2e2bcd8739ae039), $915f7bee255baead$var$__assign({}, props));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "react-calendar__decade-view"
    }, renderYears());
};
$915f7bee255baead$var$DecadeView.propTypes = $915f7bee255baead$var$__assign($915f7bee255baead$var$__assign({}, (0, $440b477dd2568968$export$61cce6a131f71246)), {
    showNeighboringDecade: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool
});
var $915f7bee255baead$export$2e2bcd8739ae039 = $915f7bee255baead$var$DecadeView;



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");



var $9b6ca955314c45c5$var$__assign = undefined && undefined.__assign || function() {
    $9b6ca955314c45c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9b6ca955314c45c5$var$__assign.apply(this, arguments);
};
var $9b6ca955314c45c5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9b6ca955314c45c5$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9b6ca955314c45c5$var$className = 'react-calendar__year-view__months__month';
function $9b6ca955314c45c5$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, _c = _a.formatMonth, formatMonth = _c === void 0 ? (0, $7476c89b4ce72ab5$export$d0536c8e7f45796e) : _c, _d = _a.formatMonthYear, formatMonthYear = _d === void 0 ? (0, $7476c89b4ce72ab5$export$18f8ccbe37e54acd) : _d, otherProps = $9b6ca955314c45c5$var$__rest(_a, [
        "classes",
        "formatMonth",
        "formatMonthYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $0d1563031ac5c10b$export$2e2bcd8739ae039), $9b6ca955314c45c5$var$__assign({}, otherProps, {
        classes: $9b6ca955314c45c5$var$__spreadArray($9b6ca955314c45c5$var$__spreadArray([], classes, true), [
            $9b6ca955314c45c5$var$className
        ], false),
        formatAbbr: formatMonthYear,
        maxDateTransform: (0, $21f5a45f3ee49568$export$6f306f93ccbcd612),
        minDateTransform: (0, $21f5a45f3ee49568$export$c7002b157c9b9e95),
        view: "year"
    }), formatMonth(locale, date));
}


var $27836ee959c58f81$var$__assign = undefined && undefined.__assign || function() {
    $27836ee959c58f81$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27836ee959c58f81$var$__assign.apply(this, arguments);
};
var $27836ee959c58f81$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $27836ee959c58f81$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, value = props.value, valueType = props.valueType, otherProps = $27836ee959c58f81$var$__rest(props, [
        "activeStartDate",
        "hover",
        "value",
        "valueType"
    ]);
    var start = 0;
    var end = 11;
    var year = (0, $21f5a45f3ee49568$export$5846dc2d57a5c860)(activeStartDate);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $9ee991abc77d5261$export$2e2bcd8739ae039), {
        className: "react-calendar__year-view__months",
        dateTransform: function(monthIndex) {
            var date = new Date();
            date.setFullYear(year, monthIndex, 1);
            return (0, $21f5a45f3ee49568$export$c7002b157c9b9e95)(date);
        },
        dateType: "month",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $27836ee959c58f81$var$__rest(_a, [
                "date"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $9b6ca955314c45c5$export$2e2bcd8739ae039), $27836ee959c58f81$var$__assign({
                key: date.getTime()
            }, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                date: date
            }));
        },
        start: start,
        value: value,
        valueType: valueType
    });
}



var $283f22a66ccd3451$var$__assign = undefined && undefined.__assign || function() {
    $283f22a66ccd3451$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $283f22a66ccd3451$var$__assign.apply(this, arguments);
};
/**
 * Displays a given year.
 */ var $283f22a66ccd3451$var$YearView = function YearView(props) {
    function renderMonths() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $27836ee959c58f81$export$2e2bcd8739ae039), $283f22a66ccd3451$var$__assign({}, props));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "react-calendar__year-view"
    }, renderMonths());
};
$283f22a66ccd3451$var$YearView.propTypes = $283f22a66ccd3451$var$__assign({}, (0, $440b477dd2568968$export$61cce6a131f71246));
var $283f22a66ccd3451$export$2e2bcd8739ae039 = $283f22a66ccd3451$var$YearView;



var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");





var $15bc7892311afc9c$var$__assign = undefined && undefined.__assign || function() {
    $15bc7892311afc9c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15bc7892311afc9c$var$__assign.apply(this, arguments);
};
var $15bc7892311afc9c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $15bc7892311afc9c$var$className = 'react-calendar__month-view__days__day';
function $15bc7892311afc9c$export$2e2bcd8739ae039(_a) {
    var calendarTypeOrDeprecatedCalendarType = _a.calendarType, _b = _a.classes, classes = _b === void 0 ? [] : _b, currentMonthIndex = _a.currentMonthIndex, _c = _a.formatDay, formatDay = _c === void 0 ? (0, $7476c89b4ce72ab5$export$a7f242eff11c1345) : _c, _d = _a.formatLongDate, formatLongDate = _d === void 0 ? (0, $7476c89b4ce72ab5$export$322b36d80aef60ca) : _d, otherProps = $15bc7892311afc9c$var$__rest(_a, [
        "calendarType",
        "classes",
        "currentMonthIndex",
        "formatDay",
        "formatLongDate"
    ]);
    var calendarType = (0, $c0dd79cc9c7f4c96$export$52aa1e9fb4a280ce)(calendarTypeOrDeprecatedCalendarType);
    var date = otherProps.date, locale = otherProps.locale;
    var classesProps = [];
    if (classes) classesProps.push.apply(classesProps, classes);
    if ($15bc7892311afc9c$var$className) classesProps.push($15bc7892311afc9c$var$className);
    if ((0, $1e71737657997e6e$export$618d60ea299da42)(date, calendarType)) classesProps.push("".concat($15bc7892311afc9c$var$className, "--weekend"));
    if (date.getMonth() !== currentMonthIndex) classesProps.push("".concat($15bc7892311afc9c$var$className, "--neighboringMonth"));
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $0d1563031ac5c10b$export$2e2bcd8739ae039), $15bc7892311afc9c$var$__assign({}, otherProps, {
        classes: classesProps,
        formatAbbr: formatLongDate,
        maxDateTransform: (0, $21f5a45f3ee49568$export$7b798396f3e38cd7),
        minDateTransform: (0, $21f5a45f3ee49568$export$ef6b506418c2b397),
        view: "month"
    }), formatDay(locale, date));
}




var $67fae221711ef16f$var$__assign = undefined && undefined.__assign || function() {
    $67fae221711ef16f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67fae221711ef16f$var$__assign.apply(this, arguments);
};
var $67fae221711ef16f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $67fae221711ef16f$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarTypeOrDeprecatedCalendarType = props.calendarType, hover = props.hover, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, showNeighboringMonth = props.showNeighboringMonth, value = props.value, valueType = props.valueType, otherProps = $67fae221711ef16f$var$__rest(props, [
        "activeStartDate",
        "calendarType",
        "hover",
        "showFixedNumberOfWeeks",
        "showNeighboringMonth",
        "value",
        "valueType"
    ]);
    var calendarType = (0, $c0dd79cc9c7f4c96$export$52aa1e9fb4a280ce)(calendarTypeOrDeprecatedCalendarType);
    var year = (0, $21f5a45f3ee49568$export$5846dc2d57a5c860)(activeStartDate);
    var monthIndex = (0, $21f5a45f3ee49568$export$6ce1b5acc29cb53b)(activeStartDate);
    var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
    var dayOfWeek = (0, $1e71737657997e6e$export$2061056d06d7cdf7)(activeStartDate, calendarType);
    var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
    /**
     * Defines on which day of the month the grid shall start. If we simply show current
     * month, we obviously start on day one, but if showNeighboringMonth is set to
     * true, we need to find the beginning of the week the first day of the month is in.
     */ var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
    /**
     * Defines on which day of the month the grid shall end. If we simply show current
     * month, we need to stop on the last day of the month, but if showNeighboringMonth
     * is set to true, we need to find the end of the week the last day of the month is in.
     */ var end = function() {
        if (showFixedNumberOfWeeks) // Always show 6 weeks
        return start + 42 - 1;
        var daysInMonth = (0, $21f5a45f3ee49568$export$f645ddd439eb259d)(activeStartDate);
        if (showNeighboringMonth) {
            var activeEndDate = new Date();
            activeEndDate.setFullYear(year, monthIndex, daysInMonth);
            activeEndDate.setHours(0, 0, 0, 0);
            var daysUntilEndOfTheWeek = 7 - (0, $1e71737657997e6e$export$2061056d06d7cdf7)(activeEndDate, calendarType) - 1;
            return daysInMonth + daysUntilEndOfTheWeek;
        }
        return daysInMonth;
    }();
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $9ee991abc77d5261$export$2e2bcd8739ae039), {
        className: "react-calendar__month-view__days",
        count: 7,
        dateTransform: function(day) {
            var date = new Date();
            date.setFullYear(year, monthIndex, day);
            return (0, $21f5a45f3ee49568$export$ef6b506418c2b397)(date);
        },
        dateType: "day",
        hover: hover,
        end: end,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $67fae221711ef16f$var$__rest(_a, [
                "date"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $15bc7892311afc9c$export$2e2bcd8739ae039), $67fae221711ef16f$var$__assign({
                key: date.getTime()
            }, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                calendarType: calendarTypeOrDeprecatedCalendarType,
                currentMonthIndex: monthIndex,
                date: date
            }));
        },
        offset: offset,
        start: start,
        value: value,
        valueType: valueType
    });
}



var $aqdBs = parcelRequire("aqdBs");






var $3608d37c36aff74b$var$className = 'react-calendar__month-view__weekdays';
var $3608d37c36aff74b$var$weekdayClassName = "".concat($3608d37c36aff74b$var$className, "__weekday");
function $3608d37c36aff74b$export$2e2bcd8739ae039(props) {
    var calendarTypeOrDeprecatedCalendarType = props.calendarType, _a = props.formatShortWeekday, formatShortWeekday = _a === void 0 ? (0, $7476c89b4ce72ab5$export$7ebe25e42481bc02) : _a, _b = props.formatWeekday, formatWeekday = _b === void 0 ? (0, $7476c89b4ce72ab5$export$407180b957f39d7e) : _b, locale = props.locale, onMouseLeave = props.onMouseLeave;
    var calendarType = (0, $c0dd79cc9c7f4c96$export$52aa1e9fb4a280ce)(calendarTypeOrDeprecatedCalendarType);
    var anyDate = new Date();
    var beginOfMonth = (0, $21f5a45f3ee49568$export$c7002b157c9b9e95)(anyDate);
    var year = (0, $21f5a45f3ee49568$export$5846dc2d57a5c860)(beginOfMonth);
    var monthIndex = (0, $21f5a45f3ee49568$export$6ce1b5acc29cb53b)(beginOfMonth);
    var weekdays = [];
    for(var weekday = 1; weekday <= 7; weekday += 1){
        var weekdayDate = new Date(year, monthIndex, weekday - (0, $1e71737657997e6e$export$2061056d06d7cdf7)(beginOfMonth, calendarType));
        var abbr = formatWeekday(locale, weekdayDate);
        weekdays.push((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
            key: weekday,
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)($3608d37c36aff74b$var$weekdayClassName, (0, $1e71737657997e6e$export$12e2595dc60a5d5)(weekdayDate) && "".concat($3608d37c36aff74b$var$weekdayClassName, "--current"), (0, $1e71737657997e6e$export$618d60ea299da42)(weekdayDate, calendarType) && "".concat($3608d37c36aff74b$var$weekdayClassName, "--weekend"))
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("abbr", {
            "aria-label": abbr,
            title: abbr
        }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $06787a45e0165459$export$2e2bcd8739ae039), {
        className: $3608d37c36aff74b$var$className,
        count: 7,
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave
    }, weekdays);
}



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");
var $28a9f84c85d978f8$var$__assign = undefined && undefined.__assign || function() {
    $28a9f84c85d978f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28a9f84c85d978f8$var$__assign.apply(this, arguments);
};
var $28a9f84c85d978f8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $28a9f84c85d978f8$var$className = 'react-calendar__tile';
function $28a9f84c85d978f8$export$2e2bcd8739ae039(props) {
    var onClickWeekNumber = props.onClickWeekNumber, weekNumber = props.weekNumber;
    var children = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", null, weekNumber);
    if (onClickWeekNumber) {
        var date_1 = props.date, onClickWeekNumber_1 = props.onClickWeekNumber, weekNumber_1 = props.weekNumber, otherProps = $28a9f84c85d978f8$var$__rest(props, [
            "date",
            "onClickWeekNumber",
            "weekNumber"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", $28a9f84c85d978f8$var$__assign({}, otherProps, {
            className: $28a9f84c85d978f8$var$className,
            onClick: function(event) {
                return onClickWeekNumber_1(weekNumber_1, date_1, event);
            },
            type: "button"
        }), children);
    } else {
        var date = props.date, onClickWeekNumber_2 = props.onClickWeekNumber, weekNumber_2 = props.weekNumber, otherProps = $28a9f84c85d978f8$var$__rest(props, [
            "date",
            "onClickWeekNumber",
            "weekNumber"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", $28a9f84c85d978f8$var$__assign({}, otherProps, {
            className: $28a9f84c85d978f8$var$className
        }), children);
    }
}





function $996042ce2c9118a2$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarTypeOrDeprecatedCalendarType = props.calendarType, onClickWeekNumber = props.onClickWeekNumber, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var calendarType = (0, $c0dd79cc9c7f4c96$export$52aa1e9fb4a280ce)(calendarTypeOrDeprecatedCalendarType);
    var numberOfWeeks = function() {
        if (showFixedNumberOfWeeks) return 6;
        var numberOfDays = (0, $21f5a45f3ee49568$export$f645ddd439eb259d)(activeStartDate);
        var startWeekday = (0, $1e71737657997e6e$export$2061056d06d7cdf7)(activeStartDate, calendarType);
        var days = numberOfDays - (7 - startWeekday);
        return 1 + Math.ceil(days / 7);
    }();
    var dates = function() {
        var year = (0, $21f5a45f3ee49568$export$5846dc2d57a5c860)(activeStartDate);
        var monthIndex = (0, $21f5a45f3ee49568$export$6ce1b5acc29cb53b)(activeStartDate);
        var day = (0, $21f5a45f3ee49568$export$aa350b96d91cd94)(activeStartDate);
        var result = [];
        for(var index = 0; index < numberOfWeeks; index += 1)result.push((0, $1e71737657997e6e$export$84e707e5f485f282)(new Date(year, monthIndex, day + index * 7), calendarType));
        return result;
    }();
    var weekNumbers = dates.map(function(date) {
        return (0, $1e71737657997e6e$export$b59889984706b7a7)(date, calendarType);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $06787a45e0165459$export$2e2bcd8739ae039), {
        className: "react-calendar__month-view__weekNumbers",
        count: numberOfWeeks,
        direction: "column",
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave,
        style: {
            flexBasis: 'calc(100% * (1 / 8)',
            flexShrink: 0
        }
    }, weekNumbers.map(function(weekNumber, weekIndex) {
        var date = dates[weekIndex];
        if (!date) throw new Error('date is not defined');
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $28a9f84c85d978f8$export$2e2bcd8739ae039), {
            key: weekNumber,
            date: date,
            onClickWeekNumber: onClickWeekNumber,
            weekNumber: weekNumber
        });
    }));
}




var $fbf1fee65a3871e9$var$__assign = undefined && undefined.__assign || function() {
    $fbf1fee65a3871e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fbf1fee65a3871e9$var$__assign.apply(this, arguments);
};
var $fbf1fee65a3871e9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $fbf1fee65a3871e9$var$getCalendarTypeFromLocale(locale) {
    if (locale) for(var _i = 0, _a = Object.entries((0, $b70b56bd93db2f08$export$e4e5576db5b8e30f)); _i < _a.length; _i++){
        var _b = _a[_i], calendarType = _b[0], locales = _b[1];
        if (locales.includes(locale)) return calendarType;
    }
    return (0, $b70b56bd93db2f08$export$26fa441040070c35).ISO_8601;
}
/**
 * Displays a given month.
 */ var $fbf1fee65a3871e9$var$MonthView = function MonthView(props) {
    var activeStartDate = props.activeStartDate, locale = props.locale, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var _a = props.calendarType, calendarType = _a === void 0 ? $fbf1fee65a3871e9$var$getCalendarTypeFromLocale(locale) : _a, formatShortWeekday = props.formatShortWeekday, formatWeekday = props.formatWeekday, onClickWeekNumber = props.onClickWeekNumber, showWeekNumbers = props.showWeekNumbers, childProps = $fbf1fee65a3871e9$var$__rest(props, [
        "calendarType",
        "formatShortWeekday",
        "formatWeekday",
        "onClickWeekNumber",
        "showWeekNumbers"
    ]);
    function renderWeekdays() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $3608d37c36aff74b$export$2e2bcd8739ae039), {
            calendarType: calendarType,
            formatShortWeekday: formatShortWeekday,
            formatWeekday: formatWeekday,
            locale: locale,
            onMouseLeave: onMouseLeave
        });
    }
    function renderWeekNumbers() {
        if (!showWeekNumbers) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $996042ce2c9118a2$export$2e2bcd8739ae039), {
            activeStartDate: activeStartDate,
            calendarType: calendarType,
            onClickWeekNumber: onClickWeekNumber,
            onMouseLeave: onMouseLeave,
            showFixedNumberOfWeeks: showFixedNumberOfWeeks
        });
    }
    function renderDays() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $67fae221711ef16f$export$2e2bcd8739ae039), $fbf1fee65a3871e9$var$__assign({
            calendarType: calendarType
        }, childProps));
    }
    var className = 'react-calendar__month-view';
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : '')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end'
        }
    }, renderWeekNumbers(), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        style: {
            flexGrow: 1,
            width: '100%'
        }
    }, renderWeekdays(), renderDays())));
};
$fbf1fee65a3871e9$var$MonthView.propTypes = $fbf1fee65a3871e9$var$__assign($fbf1fee65a3871e9$var$__assign({}, (0, $440b477dd2568968$export$61cce6a131f71246)), {
    calendarType: (0, $440b477dd2568968$export$9780328ce60eac34),
    formatDay: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatLongDate: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showNeighboringMonth: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showWeekNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool
});
var $fbf1fee65a3871e9$export$2e2bcd8739ae039 = $fbf1fee65a3871e9$var$MonthView;





'use client';
var $36fe28a98a501db3$var$__assign = undefined && undefined.__assign || function() {
    $36fe28a98a501db3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36fe28a98a501db3$var$__assign.apply(this, arguments);
};
var $36fe28a98a501db3$var$baseClassName = 'react-calendar';
var $36fe28a98a501db3$var$allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var $36fe28a98a501db3$var$allValueTypes = [
    'decade',
    'year',
    'month',
    'day'
];
var $36fe28a98a501db3$var$defaultMinDate = new Date();
$36fe28a98a501db3$var$defaultMinDate.setFullYear(1, 0, 1);
$36fe28a98a501db3$var$defaultMinDate.setHours(0, 0, 0, 0);
var $36fe28a98a501db3$var$defaultMaxDate = new Date(8.64e15);
function $36fe28a98a501db3$var$toDate(value) {
    if (value instanceof Date) return value;
    return new Date(value);
}
/**
 * Returns views array with disallowed values cut off.
 */ function $36fe28a98a501db3$var$getLimitedViews(minDetail, maxDetail) {
    return $36fe28a98a501db3$var$allViews.slice($36fe28a98a501db3$var$allViews.indexOf(minDetail), $36fe28a98a501db3$var$allViews.indexOf(maxDetail) + 1);
}
/**
 * Determines whether a given view is allowed with currently applied settings.
 */ function $36fe28a98a501db3$var$isViewAllowed(view, minDetail, maxDetail) {
    var views = $36fe28a98a501db3$var$getLimitedViews(minDetail, maxDetail);
    return views.indexOf(view) !== -1;
}
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */ function $36fe28a98a501db3$var$getView(view, minDetail, maxDetail) {
    if (!view) return maxDetail;
    if ($36fe28a98a501db3$var$isViewAllowed(view, minDetail, maxDetail)) return view;
    return maxDetail;
}
/**
 * Returns value type that can be returned with currently applied settings.
 */ function $36fe28a98a501db3$var$getValueType(view) {
    var index = $36fe28a98a501db3$var$allViews.indexOf(view);
    return $36fe28a98a501db3$var$allValueTypes[index];
}
function $36fe28a98a501db3$var$getValue(value, index) {
    var rawValue = Array.isArray(value) ? value[index] : value;
    if (!rawValue) return null;
    var valueDate = $36fe28a98a501db3$var$toDate(rawValue);
    if (isNaN(valueDate.getTime())) throw new Error("Invalid date: ".concat(value));
    return valueDate;
}
function $36fe28a98a501db3$var$getDetailValue(_a, index) {
    var value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, maxDetail = _a.maxDetail;
    var valuePiece = $36fe28a98a501db3$var$getValue(value, index);
    if (!valuePiece) return null;
    var valueType = $36fe28a98a501db3$var$getValueType(maxDetail);
    var detailValueFrom = function() {
        switch(index){
            case 0:
                return (0, $1e71737657997e6e$export$700a64ae37cbc741)(valueType, valuePiece);
            case 1:
                return (0, $1e71737657997e6e$export$946298ccd438a697)(valueType, valuePiece);
            default:
                throw new Error("Invalid index value: ".concat(index));
        }
    }();
    return (0, $c0dd79cc9c7f4c96$export$cf95c51b03f10bae)(detailValueFrom, minDate, maxDate);
}
var $36fe28a98a501db3$var$getDetailValueFrom = function(args) {
    return $36fe28a98a501db3$var$getDetailValue(args, 0);
};
var $36fe28a98a501db3$var$getDetailValueTo = function(args) {
    return $36fe28a98a501db3$var$getDetailValue(args, 1);
};
var $36fe28a98a501db3$var$getDetailValueArray = function(args) {
    return [
        $36fe28a98a501db3$var$getDetailValueFrom,
        $36fe28a98a501db3$var$getDetailValueTo
    ].map(function(fn) {
        return fn(args);
    });
};
function $36fe28a98a501db3$var$getActiveStartDate(_a) {
    var maxDate = _a.maxDate, maxDetail = _a.maxDetail, minDate = _a.minDate, minDetail = _a.minDetail, value = _a.value, view = _a.view;
    var rangeType = $36fe28a98a501db3$var$getView(view, minDetail, maxDetail);
    var valueFrom = $36fe28a98a501db3$var$getDetailValueFrom({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
    }) || new Date();
    return (0, $1e71737657997e6e$export$700a64ae37cbc741)(rangeType, valueFrom);
}
function $36fe28a98a501db3$var$getInitialActiveStartDate(_a) {
    var activeStartDate = _a.activeStartDate, defaultActiveStartDate = _a.defaultActiveStartDate, defaultValue = _a.defaultValue, defaultView = _a.defaultView, maxDate = _a.maxDate, maxDetail = _a.maxDetail, minDate = _a.minDate, minDetail = _a.minDetail, value = _a.value, view = _a.view;
    var rangeType = $36fe28a98a501db3$var$getView(view, minDetail, maxDetail);
    var valueFrom = activeStartDate || defaultActiveStartDate;
    if (valueFrom) return (0, $1e71737657997e6e$export$700a64ae37cbc741)(rangeType, valueFrom);
    return $36fe28a98a501db3$var$getActiveStartDate({
        maxDate: maxDate,
        maxDetail: maxDetail,
        minDate: minDate,
        minDetail: minDetail,
        value: value || defaultValue,
        view: view || defaultView
    });
}
function $36fe28a98a501db3$var$getIsSingleValue(value) {
    return value && (!Array.isArray(value) || value.length === 1);
}
function $36fe28a98a501db3$var$areDatesEqual(date1, date2) {
    return date1 instanceof Date && date2 instanceof Date && date1.getTime() === date2.getTime();
}
var $36fe28a98a501db3$var$Calendar = (0, $aqdBs.forwardRef)(function Calendar(props, ref) {
    var activeStartDateProps = props.activeStartDate, allowPartialRange = props.allowPartialRange, calendarType = props.calendarType, className = props.className, defaultActiveStartDate = props.defaultActiveStartDate, defaultValue = props.defaultValue, defaultView = props.defaultView, formatDay = props.formatDay, formatLongDate = props.formatLongDate, formatMonth = props.formatMonth, formatMonthYear = props.formatMonthYear, formatShortWeekday = props.formatShortWeekday, formatWeekday = props.formatWeekday, formatYear = props.formatYear, _a = props.goToRangeStartOnSelect, goToRangeStartOnSelect = _a === void 0 ? true : _a, inputRef = props.inputRef, locale = props.locale, _b = props.maxDate, maxDate = _b === void 0 ? $36fe28a98a501db3$var$defaultMaxDate : _b, _c = props.maxDetail, maxDetail = _c === void 0 ? 'month' : _c, _d = props.minDate, minDate = _d === void 0 ? $36fe28a98a501db3$var$defaultMinDate : _d, _e = props.minDetail, minDetail = _e === void 0 ? 'century' : _e, navigationAriaLabel = props.navigationAriaLabel, navigationAriaLive = props.navigationAriaLive, navigationLabel = props.navigationLabel, next2AriaLabel = props.next2AriaLabel, next2Label = props.next2Label, nextAriaLabel = props.nextAriaLabel, nextLabel = props.nextLabel, onActiveStartDateChange = props.onActiveStartDateChange, onChangeProps = props.onChange, onClickDay = props.onClickDay, onClickDecade = props.onClickDecade, onClickMonth = props.onClickMonth, onClickWeekNumber = props.onClickWeekNumber, onClickYear = props.onClickYear, onDrillDown = props.onDrillDown, onDrillUp = props.onDrillUp, onViewChange = props.onViewChange, prev2AriaLabel = props.prev2AriaLabel, prev2Label = props.prev2Label, prevAriaLabel = props.prevAriaLabel, prevLabel = props.prevLabel, _f = props.returnValue, returnValue = _f === void 0 ? 'start' : _f, selectRange = props.selectRange, showDoubleView = props.showDoubleView, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, _g = props.showNavigation, showNavigation = _g === void 0 ? true : _g, showNeighboringCentury = props.showNeighboringCentury, showNeighboringDecade = props.showNeighboringDecade, _h = props.showNeighboringMonth, showNeighboringMonth = _h === void 0 ? true : _h, showWeekNumbers = props.showWeekNumbers, tileClassName = props.tileClassName, tileContent = props.tileContent, tileDisabled = props.tileDisabled, valueProps = props.value, viewProps = props.view;
    var _j = (0, $aqdBs.useState)(defaultActiveStartDate), activeStartDateState = _j[0], setActiveStartDateState = _j[1];
    var _k = (0, $aqdBs.useState)(null), hoverState = _k[0], setHoverState = _k[1];
    var _l = (0, $aqdBs.useState)(Array.isArray(defaultValue) ? defaultValue.map(function(el) {
        return el !== null ? $36fe28a98a501db3$var$toDate(el) : null;
    }) : defaultValue !== null && defaultValue !== undefined ? $36fe28a98a501db3$var$toDate(defaultValue) : null), valueState = _l[0], setValueState = _l[1];
    var _m = (0, $aqdBs.useState)(defaultView), viewState = _m[0], setViewState = _m[1];
    var activeStartDate = activeStartDateProps || activeStartDateState || $36fe28a98a501db3$var$getInitialActiveStartDate({
        activeStartDate: activeStartDateProps,
        defaultActiveStartDate: defaultActiveStartDate,
        defaultValue: defaultValue,
        defaultView: defaultView,
        maxDate: maxDate,
        maxDetail: maxDetail,
        minDate: minDate,
        minDetail: minDetail,
        value: valueProps,
        view: viewProps
    });
    var value = function() {
        var rawValue = function() {
            // In the middle of range selection, use value from state
            if (selectRange && $36fe28a98a501db3$var$getIsSingleValue(valueState)) return valueState;
            return valueProps !== undefined ? valueProps : valueState;
        }();
        if (!rawValue) return null;
        return Array.isArray(rawValue) ? rawValue.map(function(el) {
            return el !== null ? $36fe28a98a501db3$var$toDate(el) : null;
        }) : rawValue !== null ? $36fe28a98a501db3$var$toDate(rawValue) : null;
    }();
    var valueType = $36fe28a98a501db3$var$getValueType(maxDetail);
    var view = $36fe28a98a501db3$var$getView(viewProps || viewState, minDetail, maxDetail);
    var views = $36fe28a98a501db3$var$getLimitedViews(minDetail, maxDetail);
    var hover = selectRange ? hoverState : null;
    var drillDownAvailable = views.indexOf(view) < views.length - 1;
    var drillUpAvailable = views.indexOf(view) > 0;
    var getProcessedValue = (0, $aqdBs.useCallback)(function(value) {
        var processFunction = function() {
            switch(returnValue){
                case 'start':
                    return $36fe28a98a501db3$var$getDetailValueFrom;
                case 'end':
                    return $36fe28a98a501db3$var$getDetailValueTo;
                case 'range':
                    return $36fe28a98a501db3$var$getDetailValueArray;
                default:
                    throw new Error('Invalid returnValue.');
            }
        }();
        return processFunction({
            maxDate: maxDate,
            maxDetail: maxDetail,
            minDate: minDate,
            value: value
        });
    }, [
        maxDate,
        maxDetail,
        minDate,
        returnValue
    ]);
    var setActiveStartDate = (0, $aqdBs.useCallback)(function(nextActiveStartDate, action) {
        setActiveStartDateState(nextActiveStartDate);
        var args = {
            action: action,
            activeStartDate: nextActiveStartDate,
            value: value,
            view: view
        };
        if (onActiveStartDateChange && !$36fe28a98a501db3$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
    }, [
        activeStartDate,
        onActiveStartDateChange,
        value,
        view
    ]);
    var onClickTile = (0, $aqdBs.useCallback)(function(value, event) {
        var callback = function() {
            switch(view){
                case 'century':
                    return onClickDecade;
                case 'decade':
                    return onClickYear;
                case 'year':
                    return onClickMonth;
                case 'month':
                    return onClickDay;
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        if (callback) callback(value, event);
    }, [
        onClickDay,
        onClickDecade,
        onClickMonth,
        onClickYear,
        view
    ]);
    var drillDown = (0, $aqdBs.useCallback)(function(nextActiveStartDate, event) {
        if (!drillDownAvailable) return;
        onClickTile(nextActiveStartDate, event);
        var nextView = views[views.indexOf(view) + 1];
        if (!nextView) throw new Error('Attempted to drill down from the lowest view.');
        setActiveStartDateState(nextActiveStartDate);
        setViewState(nextView);
        var args = {
            action: 'drillDown',
            activeStartDate: nextActiveStartDate,
            value: value,
            view: nextView
        };
        if (onActiveStartDateChange && !$36fe28a98a501db3$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onViewChange && view !== nextView) onViewChange(args);
        if (onDrillDown) onDrillDown(args);
    }, [
        activeStartDate,
        drillDownAvailable,
        onActiveStartDateChange,
        onClickTile,
        onDrillDown,
        onViewChange,
        value,
        view,
        views
    ]);
    var drillUp = (0, $aqdBs.useCallback)(function() {
        if (!drillUpAvailable) return;
        var nextView = views[views.indexOf(view) - 1];
        if (!nextView) throw new Error('Attempted to drill up from the highest view.');
        var nextActiveStartDate = (0, $1e71737657997e6e$export$700a64ae37cbc741)(nextView, activeStartDate);
        setActiveStartDateState(nextActiveStartDate);
        setViewState(nextView);
        var args = {
            action: 'drillUp',
            activeStartDate: nextActiveStartDate,
            value: value,
            view: nextView
        };
        if (onActiveStartDateChange && !$36fe28a98a501db3$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onViewChange && view !== nextView) onViewChange(args);
        if (onDrillUp) onDrillUp(args);
    }, [
        activeStartDate,
        drillUpAvailable,
        onActiveStartDateChange,
        onDrillUp,
        onViewChange,
        value,
        view,
        views
    ]);
    var onChange = (0, $aqdBs.useCallback)(function(rawNextValue, event) {
        var previousValue = value;
        onClickTile(rawNextValue, event);
        var isFirstValueInRange = selectRange && !$36fe28a98a501db3$var$getIsSingleValue(previousValue);
        var nextValue;
        if (selectRange) {
            // Range selection turned on
            if (isFirstValueInRange) // Value has 0 or 2 elements - either way we're starting a new array
            // First value
            nextValue = (0, $1e71737657997e6e$export$700a64ae37cbc741)(valueType, rawNextValue);
            else {
                if (!previousValue) throw new Error('previousValue is required');
                if (Array.isArray(previousValue)) throw new Error('previousValue must not be an array');
                // Second value
                nextValue = (0, $1e71737657997e6e$export$3a3e6dbcaf74641d)(valueType, previousValue, rawNextValue);
            }
        } else // Range selection turned off
        nextValue = getProcessedValue(rawNextValue);
        var nextActiveStartDate = // Range selection turned off
        !selectRange || // Range selection turned on, first value
        isFirstValueInRange || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
        goToRangeStartOnSelect ? $36fe28a98a501db3$var$getActiveStartDate({
            maxDate: maxDate,
            maxDetail: maxDetail,
            minDate: minDate,
            minDetail: minDetail,
            value: nextValue,
            view: view
        }) : null;
        event.persist();
        setActiveStartDateState(nextActiveStartDate);
        setValueState(nextValue);
        var args = {
            action: 'onChange',
            activeStartDate: nextActiveStartDate,
            value: nextValue,
            view: view
        };
        if (onActiveStartDateChange && !$36fe28a98a501db3$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onChangeProps) {
            if (selectRange) {
                var isSingleValue = $36fe28a98a501db3$var$getIsSingleValue(nextValue);
                if (!isSingleValue) onChangeProps(nextValue || null, event);
                else if (allowPartialRange) {
                    if (Array.isArray(nextValue)) throw new Error('value must not be an array');
                    onChangeProps([
                        nextValue || null,
                        null
                    ], event);
                }
            } else onChangeProps(nextValue || null, event);
        }
    }, [
        activeStartDate,
        allowPartialRange,
        getProcessedValue,
        goToRangeStartOnSelect,
        maxDate,
        maxDetail,
        minDate,
        minDetail,
        onActiveStartDateChange,
        onChangeProps,
        onClickTile,
        selectRange,
        value,
        valueType,
        view
    ]);
    function onMouseOver(nextHover) {
        setHoverState(nextHover);
    }
    function onMouseLeave() {
        setHoverState(null);
    }
    (0, $aqdBs.useImperativeHandle)(ref, function() {
        return {
            activeStartDate: activeStartDate,
            drillDown: drillDown,
            drillUp: drillUp,
            onChange: onChange,
            setActiveStartDate: setActiveStartDate,
            value: value,
            view: view
        };
    }, [
        activeStartDate,
        drillDown,
        drillUp,
        onChange,
        setActiveStartDate,
        value,
        view
    ]);
    function renderContent(next) {
        var currentActiveStartDate = next ? (0, $1e71737657997e6e$export$19193c1f2d841d47)(view, activeStartDate) : (0, $1e71737657997e6e$export$700a64ae37cbc741)(view, activeStartDate);
        var onClick = drillDownAvailable ? drillDown : onChange;
        var commonProps = {
            activeStartDate: currentActiveStartDate,
            hover: hover,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            onClick: onClick,
            onMouseOver: selectRange ? onMouseOver : undefined,
            tileClassName: tileClassName,
            tileContent: tileContent,
            tileDisabled: tileDisabled,
            value: value,
            valueType: valueType
        };
        switch(view){
            case 'century':
                return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $6537232d923b2afe$export$2e2bcd8739ae039), $36fe28a98a501db3$var$__assign({
                    formatYear: formatYear,
                    showNeighboringCentury: showNeighboringCentury
                }, commonProps));
            case 'decade':
                return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $915f7bee255baead$export$2e2bcd8739ae039), $36fe28a98a501db3$var$__assign({
                    formatYear: formatYear,
                    showNeighboringDecade: showNeighboringDecade
                }, commonProps));
            case 'year':
                return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $283f22a66ccd3451$export$2e2bcd8739ae039), $36fe28a98a501db3$var$__assign({
                    formatMonth: formatMonth,
                    formatMonthYear: formatMonthYear
                }, commonProps));
            case 'month':
                return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $fbf1fee65a3871e9$export$2e2bcd8739ae039), $36fe28a98a501db3$var$__assign({
                    calendarType: calendarType,
                    formatDay: formatDay,
                    formatLongDate: formatLongDate,
                    formatShortWeekday: formatShortWeekday,
                    formatWeekday: formatWeekday,
                    onClickWeekNumber: onClickWeekNumber,
                    onMouseLeave: selectRange ? onMouseLeave : undefined,
                    showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== 'undefined' ? showFixedNumberOfWeeks : showDoubleView,
                    showNeighboringMonth: showNeighboringMonth,
                    showWeekNumbers: showWeekNumbers
                }, commonProps));
            default:
                throw new Error("Invalid view: ".concat(view, "."));
        }
    }
    function renderNavigation() {
        if (!showNavigation) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $34afc81d0ab58ae4$export$2e2bcd8739ae039), {
            activeStartDate: activeStartDate,
            drillUp: drillUp,
            formatMonthYear: formatMonthYear,
            formatYear: formatYear,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            navigationAriaLabel: navigationAriaLabel,
            navigationAriaLive: navigationAriaLive,
            navigationLabel: navigationLabel,
            next2AriaLabel: next2AriaLabel,
            next2Label: next2Label,
            nextAriaLabel: nextAriaLabel,
            nextLabel: nextLabel,
            prev2AriaLabel: prev2AriaLabel,
            prev2Label: prev2Label,
            prevAriaLabel: prevAriaLabel,
            prevLabel: prevLabel,
            setActiveStartDate: setActiveStartDate,
            showDoubleView: showDoubleView,
            view: view,
            views: views
        });
    }
    var valueArray = Array.isArray(value) ? value : [
        value
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)($36fe28a98a501db3$var$baseClassName, selectRange && valueArray.length === 1 && "".concat($36fe28a98a501db3$var$baseClassName, "--selectRange"), showDoubleView && "".concat($36fe28a98a501db3$var$baseClassName, "--doubleView"), className),
        ref: inputRef
    }, renderNavigation(), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat($36fe28a98a501db3$var$baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : undefined,
        onMouseLeave: selectRange ? onMouseLeave : undefined
    }, renderContent(), showDoubleView ? renderContent(true) : null));
});
var $36fe28a98a501db3$var$isActiveStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).instanceOf(Date);
var $36fe28a98a501db3$var$isValue = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).instanceOf(Date)
]);
var $36fe28a98a501db3$var$isValueOrValueArray = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
    $36fe28a98a501db3$var$isValue,
    (0, $440b477dd2568968$export$382f6fb00c4220)($36fe28a98a501db3$var$isValue)
]);
$36fe28a98a501db3$var$Calendar.propTypes = {
    activeStartDate: $36fe28a98a501db3$var$isActiveStartDate,
    allowPartialRange: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    calendarType: (0, $440b477dd2568968$export$9780328ce60eac34),
    className: (0, $440b477dd2568968$export$d53f3db2f43345df),
    defaultActiveStartDate: $36fe28a98a501db3$var$isActiveStartDate,
    defaultValue: $36fe28a98a501db3$var$isValueOrValueArray,
    defaultView: (0, $440b477dd2568968$export$7c1393839656cd16),
    formatDay: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatLongDate: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatMonth: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatMonthYear: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    goToRangeStartOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    inputRef: (0, $440b477dd2568968$export$4f9f5282de18fc69),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    maxDate: (0, $440b477dd2568968$export$20075fd45e42d41c),
    maxDetail: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf($36fe28a98a501db3$var$allViews),
    minDate: (0, $440b477dd2568968$export$283839a53860a2f5),
    minDetail: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf($36fe28a98a501db3$var$allViews),
    navigationAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    navigationAriaLive: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'off',
        'polite',
        'assertive'
    ]),
    navigationLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    next2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    next2Label: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node,
    nextAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    nextLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node,
    onActiveStartDateChange: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onClickDay: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onClickDecade: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onClickMonth: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onClickYear: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onDrillDown: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onDrillUp: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    prev2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    prev2Label: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node,
    prevAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    prevLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node,
    returnValue: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'start',
        'end',
        'range'
    ]),
    selectRange: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showDoubleView: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showNeighboringCentury: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showNeighboringDecade: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showNeighboringMonth: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    showWeekNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
        (0, $440b477dd2568968$export$d53f3db2f43345df)
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node
    ]),
    tileDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    value: $36fe28a98a501db3$var$isValueOrValueArray,
    view: (0, $440b477dd2568968$export$7c1393839656cd16)
};
var $36fe28a98a501db3$export$2e2bcd8739ae039 = $36fe28a98a501db3$var$Calendar;







var $48a523487962db5d$export$2e2bcd8739ae039 = (0, $36fe28a98a501db3$export$2e2bcd8739ae039);


function $1e1c7d4643f39110$export$641a04a9069d1ad9(d1, d2) {
    if (d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()) return true;
    return false;
}


const $6aa5d42573ef7723$var$ReactCalendar = ({ className: className, selectedDates: selectedDates, setSelectedDates: setSelectedDates, isSelectPastOnly: isSelectPastOnly, isSelectFutureOnly: isSelectFutureOnly, isSingleDateSelect: isSingleDateSelect })=>{
    function dateClick(date) {
        let sorted = [];
        if (selectedDates?.length === 2) selectedDates = [];
        if (selectedDates) sorted = [
            ...selectedDates,
            date
        ].sort((a, b)=>a.getTime() - b.getTime());
        else sorted = [
            date
        ];
        if (sorted.length >= 2) {
            if ((0, $1e1c7d4643f39110$export$641a04a9069d1ad9)(sorted[0], sorted[1])) sorted = [
                sorted[0]
            ];
        }
        setSelectedDates(sorted);
    }
    function formatDefaultValue() {
        const value = [];
        if (selectedDates?.[0]) value.push(new Date(selectedDates[0].toDateString()));
        if (selectedDates?.[1]) value.push(new Date(selectedDates[1].toDateString()));
        if (value.length === 1) return value[0];
        else if (value.length === 2) return value;
        return undefined;
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "thrive-react-calendar",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $48a523487962db5d$export$2e2bcd8739ae039), {
            className: className,
            onClickDay: (value)=>dateClick(value),
            showWeekNumbers: true,
            showNeighboringMonth: false,
            selectRange: isSingleDateSelect ? false : true,
            minDate: isSelectFutureOnly ? new Date() : undefined,
            maxDate: isSelectPastOnly ? new Date() : undefined,
            maxDetail: "month",
            minDetail: "month",
            prev2Label: null,
            next2Label: null,
            value: formatDefaultValue()
        })
    });
};
var $6aa5d42573ef7723$export$2e2bcd8739ae039 = $6aa5d42573ef7723$var$ReactCalendar;



parcelRequire("aqdBs");
//interfaces
parcelRequire("aqdBs");

var $0b85c913d3449887$export$15e2613b7548a974 = /*#__PURE__*/ function(SimpleSortBy) {
    SimpleSortBy["ASCENDING"] = "asc";
    SimpleSortBy["DESCENDING"] = "desc";
    SimpleSortBy["NONE"] = "none";
    return SimpleSortBy;
}({});



const $a06811ac38b16956$var$UseDirectionalToggle = ({ direction: direction, sortAscending: sortAscending, sortDescending: sortDescending, defaultSort: defaultSort, onRemoveDefaultSort: onRemoveDefaultSort, ascendingLabel: ascendingLabel, descendingLabel: descendingLabel })=>{
    const directionOrDefault = ()=>{
        if (defaultSort && !direction) return defaultSort === (0, $0b85c913d3449887$export$15e2613b7548a974).ASCENDING ? (0, $152ced39134e6095$export$cacd6541cfeeb6c1).UP : (0, $152ced39134e6095$export$cacd6541cfeeb6c1).DOWN;
        else if (!defaultSort && !direction) return (0, $152ced39134e6095$export$cacd6541cfeeb6c1).BOTH;
        else return direction;
    };
    const handleClick = ()=>{
        onRemoveDefaultSort?.();
        if (directionOrDefault() === (0, $152ced39134e6095$export$cacd6541cfeeb6c1).DOWN) sortAscending();
        else sortDescending();
    };
    const getAriaLabel = ()=>{
        if (directionOrDefault() === (0, $152ced39134e6095$export$cacd6541cfeeb6c1).DOWN) return ascendingLabel ?? "Sort ascending";
        else return descendingLabel ?? "Sort descending";
    };
    const getToggleIcon = ()=>{
        return (0, $20d1bcaabc3da16f$export$a339b9dfcf153d0e)(directionOrDefault());
    };
    return {
        handleClick: handleClick,
        getAriaLabel: getAriaLabel,
        getToggleIcon: getToggleIcon
    };
};
var $a06811ac38b16956$export$2e2bcd8739ae039 = $a06811ac38b16956$var$UseDirectionalToggle;


const $09f39afba0120afd$var$DirectionalToggle = ({ direction: direction, sortAscending: sortAscending, sortDescending: sortDescending, text: text, defaultSort: defaultSort, onRemoveDefaultSort: onRemoveDefaultSort, ascendingLabel: ascendingLabel, descendingLabel: descendingLabel })=>{
    const { getAriaLabel: getAriaLabel, handleClick: handleClick, getToggleIcon: getToggleIcon } = (0, $a06811ac38b16956$export$2e2bcd8739ae039)({
        direction: direction,
        sortAscending: sortAscending,
        sortDescending: sortDescending,
        text: text,
        defaultSort: defaultSort,
        onRemoveDefaultSort: onRemoveDefaultSort,
        ascendingLabel: ascendingLabel,
        descendingLabel: descendingLabel
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
        className: "toggle-caret",
        "aria-label": getAriaLabel(),
        onClick: handleClick,
        children: [
            text && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                children: text
            }),
            getToggleIcon()
        ]
    });
};
var $09f39afba0120afd$export$2e2bcd8739ae039 = $09f39afba0120afd$var$DirectionalToggle;



parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");
const $b7308e1127420eda$var$UseInfiniteScroll = (getMoreContent, infiniteScrollFetchCondition)=>{
    const infiniteScrollRef = (0, $aqdBs.useRef)(null);
    (0, $aqdBs.useEffect)(()=>{
        if (getMoreContent) {
            const observer = new IntersectionObserver((entries)=>{
                if (entries[0].isIntersecting && infiniteScrollFetchCondition) getMoreContent();
            }, {
                root: null,
                rootMargin: "20px",
                threshold: 1.0
            });
            if (infiniteScrollRef.current) observer.observe(infiniteScrollRef.current);
            return ()=>{
                if (infiniteScrollRef.current) observer.unobserve(infiniteScrollRef.current);
            };
        }
    }, [
        getMoreContent
    ]);
    return infiniteScrollRef;
};
var $b7308e1127420eda$export$2e2bcd8739ae039 = $b7308e1127420eda$var$UseInfiniteScroll;


const $f1d9551d5ff95bb3$var$UseSimpleTable = (tableRows, isInfiniteScroll, getMoreContent, maxContentLength, noDataMessage, infiniteScrollFetchCondition)=>{
    const [rowContent, setRowContent] = (0, $aqdBs.useState)([]);
    const [openMenu, setOpenMenu] = (0, $aqdBs.useState)(false);
    const [controlIndex, setControlIndex] = (0, $aqdBs.useState)(undefined);
    const [hoverIndex, setHoverIndex] = (0, $aqdBs.useState)(null);
    const [isLoadingMore, setIsLoadingMore] = (0, $aqdBs.useState)(false);
    const containerRef = (0, $aqdBs.useRef)(null);
    const [defaultSortIsUnchecked, setDefaultSortIsUnchecked] = (0, $aqdBs.useState)(false);
    const infiniteScrollRef = (0, $b7308e1127420eda$export$2e2bcd8739ae039)(getMoreContent, infiniteScrollFetchCondition ?? false) ?? undefined;
    const displayedContent = isInfiniteScroll ? rowContent : rowContent.slice(0, maxContentLength);
    const noContentMessage = noDataMessage ?? "No data found.";
    const showNoContentMessage = !tableRows || tableRows.length < 1;
    const hasControlsColumn = hasControls(rowContent);
    const [toggleDirections, setToggleDirections] = (0, $aqdBs.useState)({});
    const handleToggleDirection = (columnIndex, direction)=>{
        setToggleDirections((prev)=>{
            const newDirections = {
                ...prev
            };
            Object.keys(newDirections).forEach((key)=>{
                newDirections[parseInt(key)] = (0, $152ced39134e6095$export$cacd6541cfeeb6c1).BOTH;
            });
            newDirections[columnIndex] = direction;
            return newDirections;
        });
    };
    (0, $aqdBs.useEffect)(()=>{
        setRowContent(tableRows);
    }, [
        tableRows
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (infiniteScrollFetchCondition && isInfiniteScroll) setIsLoadingMore(true);
        else setIsLoadingMore(false);
    }, [
        isInfiniteScroll,
        infiniteScrollFetchCondition
    ]);
    function moveRow(dragIndex, hoverIndex, isPageChange) {
        const dragRow = rowContent[dragIndex];
        const updatedRowContent = [
            ...rowContent
        ];
        updatedRowContent.splice(dragIndex, 1);
        if (!isPageChange) updatedRowContent.splice(hoverIndex, 0, dragRow);
        setRowContent(updatedRowContent);
        setHoverIndex(null);
    }
    function hasControls(rows) {
        return rows.some((row)=>row?.controls?.some((control)=>control?.content !== undefined && control.content !== null));
    }
    return {
        rowContent: rowContent,
        noContentMessage: noContentMessage,
        showNoContentMessage: showNoContentMessage,
        infiniteScrollRef: infiniteScrollRef,
        displayedContent: displayedContent,
        hasControlsColumn: hasControlsColumn,
        controlIndex: controlIndex,
        setControlIndex: setControlIndex,
        toggleDirections: toggleDirections,
        handleToggleDirection: handleToggleDirection,
        containerRef: containerRef,
        setHoverIndex: setHoverIndex,
        hoverIndex: hoverIndex,
        moveRow: moveRow,
        openMenu: openMenu,
        setOpenMenu: setOpenMenu,
        defaultSortIsUnchecked: defaultSortIsUnchecked,
        setDefaultSortIsUnchecked: setDefaultSortIsUnchecked,
        isLoadingMore: isLoadingMore
    };
};
var $f1d9551d5ff95bb3$export$2e2bcd8739ae039 = $f1d9551d5ff95bb3$var$UseSimpleTable;







var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");
const $5eed7a488f7fba11$var$useDetectClick = (className, callBack, containsOnly)=>{
    // Detect if user has clicked a specific class in the tree with event bubbling
    (0, $aqdBs.useEffect)(()=>{
        function clickListener(e) {
            if (inTree(e)) callBack(true);
            else callBack(false);
        }
        function inTree(e) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) for (const p of path){
                // Find only this classname
                if (containsOnly) {
                    if (typeof p.className === 'string') {
                        if (Array.isArray(p.className.split(' ')) && p.className.split(' ').find((x)=>x === className)) return true;
                    }
                } else if (p.className === className) return true;
            }
            return false;
        }
        window.addEventListener('click', clickListener);
        return ()=>{
            window.removeEventListener('click', clickListener);
        };
    }, [
        className
    ]);
};
const $5eed7a488f7fba11$export$73e0398176b55a74 = (className)=>{
    // Detect if user has clicked a specific class in the tree with event bubbling
    const [classClicked, setClassClicked] = (0, $aqdBs.useState)(false);
    (0, $aqdBs.useEffect)(()=>{
        function clickListener(e) {
            if (inTree(e)) setClassClicked(true);
            else setClassClicked(false);
        }
        function inTree(e) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) for(let i = 0; i < path.length; i++){
                if (path[i].className === className) return true;
            }
            return false;
        }
        window.addEventListener('click', clickListener);
        return ()=>{
            window.removeEventListener('click', clickListener);
        };
    }, [
        className
    ]);
    return classClicked;
};
var $5eed7a488f7fba11$export$2e2bcd8739ae039 = $5eed7a488f7fba11$var$useDetectClick;



parcelRequire("aqdBs");

parcelRequire("aqdBs");

//interfaces
const $4d67f8bccc541d56$var$DragAndDropControls = ({ className: className, color: color, iconName: iconName, text: text })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `button-content ${className}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                iconName: iconName,
                sizeInPx: "12",
                color: `${color ?? "#0570B6"}`
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                children: text
            })
        ]
    });
};
var $4d67f8bccc541d56$export$2e2bcd8739ae039 = $4d67f8bccc541d56$var$DragAndDropControls;



const $6e6a0c5ece655250$export$9b5f151db75c5b97 = ({ index: index, rowContentLength: rowContentLength, paginationInformation: paginationInformation, isPaginated: isPaginated, handleButtonMove: handleButtonMove })=>{
    if (!isPaginated) {
        const totalItems = paginationInformation?.totalItems ?? 0;
        return [
            index !== 0 && {
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_TOP,
                    text: "Send to top"
                }),
                onClick: ()=>handleButtonMove(index, 0)
            },
            index !== 0 && {
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_UP,
                    text: "Move up"
                }),
                onClick: ()=>handleButtonMove(index, index - 1)
            },
            index !== totalItems - 1 && {
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_DOWN,
                    text: "Move down"
                }),
                onClick: ()=>handleButtonMove(index, index + 1)
            },
            index !== totalItems - 1 && {
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_BOTTOM,
                    text: "Send to bottom"
                }),
                onClick: ()=>handleButtonMove(index, totalItems)
            }
        ].filter(Boolean);
    }
    // Paginated version
    const currentPage = paginationInformation?.currentPage ?? 1;
    const totalPages = paginationInformation?.totalPages ?? 1;
    const totalItems = paginationInformation?.totalItems ?? 0;
    const resultsPerPage = paginationInformation?.resultsPerPage ?? 0;
    const isNotPageOne = currentPage > 1;
    const isNotLastPage = currentPage < totalPages;
    const previousIndex = index - 1;
    const nextIndex = index + 1;
    const lastIndex = totalItems;
    const isFirstItemButNotPageOne = index === 0 && isNotPageOne;
    const paginationPreviousIndex = isNotPageOne ? (currentPage - 1) * resultsPerPage + previousIndex : previousIndex;
    const paginationNextIndex = isNotPageOne ? (currentPage - 1) * resultsPerPage + nextIndex : nextIndex;
    const moveToNextPageIndex = currentPage * resultsPerPage;
    const moveToPreviousPageIndex = (currentPage - 2) * resultsPerPage;
    return [
        index !== 0 || isFirstItemButNotPageOne ? {
            content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_TOP,
                text: "Send to top"
            }),
            onClick: ()=>handleButtonMove(index, 0, isNotPageOne)
        } : undefined,
        index !== 0 || isFirstItemButNotPageOne ? {
            content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_UP,
                text: "Move up"
            }),
            onClick: ()=>handleButtonMove(index, paginationPreviousIndex, isFirstItemButNotPageOne)
        } : undefined,
        index !== rowContentLength - 1 ? {
            content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_DOWN,
                text: "Move down"
            }),
            onClick: ()=>handleButtonMove(index, paginationNextIndex, false)
        } : undefined,
        index !== rowContentLength - 1 ? {
            content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_BOTTOM,
                text: "Send to bottom"
            }),
            onClick: ()=>handleButtonMove(index, lastIndex, isNotLastPage)
        } : undefined,
        isNotPageOne ? {
            content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_UP,
                text: "Move to previous page"
            }),
            onClick: ()=>handleButtonMove(index, moveToPreviousPageIndex, true)
        } : undefined,
        totalPages > 1 && isNotLastPage ? {
            content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4d67f8bccc541d56$export$2e2bcd8739ae039), {
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ORDER_DOWN,
                text: "Move to next page"
            }),
            onClick: ()=>handleButtonMove(index, moveToNextPageIndex, true)
        } : undefined
    ].filter(Boolean);
};





const $cadf6efaac1a81f7$var$DragAndDropRow = ({ containerRef: containerRef, row: row, index: index, hoverIndex: hoverIndex, controlIndex: controlIndex, setControlIndex: setControlIndex, moveRow: moveRow, rowContentLength: rowContentLength, setHoverIndex: setHoverIndex, openMenu: openMenu, setOpenMenu: setOpenMenu, dragAndDropAction: dragAndDropAction, isPaginated: isPaginated, paginationInformation: paginationInformation })=>{
    const ref = (0, $aqdBs.useRef)(null);
    const controlCellRef = (0, $aqdBs.useRef)(null);
    const menuRef = (0, $aqdBs.useRef)(null);
    const dragRef = (0, $aqdBs.useRef)(null);
    const dragAndDropControls = (0, $6e6a0c5ece655250$export$9b5f151db75c5b97)({
        index: index,
        rowContentLength: rowContentLength,
        paginationInformation: paginationInformation,
        isPaginated: isPaginated,
        handleButtonMove: handleButtonMove
    });
    // Drag logic
    const [{ isDragging: isDragging }, drag, preview] = (0, $4de504bcfcc89199$export$7941f8aafa4b6021)({
        type: "ROW",
        item: {
            index: index
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            }),
        end: ()=>{
            setHoverIndex(null);
        }
    });
    drag(dragRef);
    const [, drop] = (0, $7f734ad0ca199756$export$ccdee5eaf73cf661)({
        accept: "ROW",
        hover (item) {
            if (!ref.current) return;
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) return;
            moveRow(dragIndex, hoverIndex, false);
            setHoverIndex(hoverIndex);
            item.index = hoverIndex;
        },
        drop () {
            setHoverIndex(null);
            dragAndDropAction?.(hoverIndex ?? 0);
        }
    });
    (0, $aqdBs.useEffect)(()=>{
        preview(drop(ref));
    }, [
        preview,
        drop
    ]);
    (0, $aqdBs.useEffect)(()=>{
        document.body.style.cursor = isDragging ? "grabbing" : "inherit";
    }, [
        isDragging
    ]);
    (0, $aqdBs.useEffect)(()=>{
        const handleDragLeave = (event)=>{
            if (containerRef.current && !containerRef.current.contains(event.relatedTarget)) setHoverIndex(null);
        };
        containerRef?.current.addEventListener('dragleave', handleDragLeave);
        return ()=>containerRef?.current.addEventListener('dragleave', handleDragLeave);
    }, [
        containerRef
    ]);
    (0, $5eed7a488f7fba11$export$2e2bcd8739ae039)("control-cell", (clickedInCell)=>{
        if (!clickedInCell) setOpenMenu(false);
    });
    function handleButtonMove(index, newIndex, isNewPageMove) {
        dragAndDropAction?.(newIndex);
        moveRow(index, newIndex, isNewPageMove);
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
        ref: ref,
        className: `drag-item ${isDragging ? "is-dragging" : ""}  ${index === hoverIndex ? "is-hovering" : ""}`,
        children: [
            row.content.map((cell, cellIndex)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                    children: cell
                }, cellIndex)),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
                className: "rc-control-cell",
                ref: controlCellRef,
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                        type: "button",
                        ref: dragRef,
                        className: "drag-and-drop-controller",
                        "aria-hidden": "true",
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).DRAG,
                            color: "#999EA5",
                            sizeInPx: "12"
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                        type: "button",
                        className: "simple-table-menu",
                        "aria-label": "Open menu",
                        onClick: ()=>{
                            setOpenMenu(!openMenu);
                            setControlIndex(index);
                        },
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).MENU_MORE,
                            color: "#343D4C",
                            sizeInPx: "12"
                        })
                    }),
                    controlIndex === index && openMenu && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        ref: menuRef,
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $87c2d16114fb0356$export$2e2bcd8739ae039), {
                            className: "drag-and-drop-list",
                            allButtonOnClick: ()=>setOpenMenu(false),
                            buttons: [
                                ...dragAndDropControls,
                                ...row.controls ?? []
                            ].filter(Boolean)
                        })
                    })
                ]
            })
        ]
    });
};
var $cadf6efaac1a81f7$export$2e2bcd8739ae039 = $cadf6efaac1a81f7$var$DragAndDropRow;



parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");




const $cdb1266955124ede$var$SimpleTableMenu = ({ isControlIndex: isControlIndex, setControlIndex: setControlIndex, buttons: buttons })=>{
    const [showMenu, setShowMenu] = (0, $aqdBs.useState)(false);
    const ref = (0, $aqdBs.useRef)(null);
    const handleBlur = (event)=>{
        if (ref.current && !ref.current.contains(event.relatedTarget)) setShowMenu(false);
    };
    (0, $006deecf5b91ed7a$export$40bf77e055859e12)(showMenu, ref, ()=>{
        setShowMenu(false);
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
        className: "control-cell",
        ref: ref,
        onBlur: handleBlur,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                type: "button",
                className: "rc-simple-table-menu",
                "aria-label": "Open menu",
                onClick: ()=>{
                    setControlIndex();
                    setShowMenu(!showMenu);
                },
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).MENU_MORE,
                    color: "#343D4C",
                    sizeInPx: "12"
                })
            }),
            isControlIndex && showMenu && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $87c2d16114fb0356$export$2e2bcd8739ae039), {
                className: "simple-controls drag-and-drop-list",
                buttons: buttons ?? [],
                allButtonOnClick: ()=>setShowMenu(false)
            })
        ]
    });
};
var $cdb1266955124ede$export$2e2bcd8739ae039 = $cdb1266955124ede$var$SimpleTableMenu;


const $2137746671ea1e1e$var$SimpleRow = ({ row: row, rowIndex: rowIndex, setControlIndex: setControlIndex, isControlIndex: isControlIndex, hasControlsColumn: hasControlsColumn })=>{
    const hasControls = row.controls?.some((control)=>control.content !== undefined) ?? false;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
        className: 'rc-simple-row',
        children: [
            row.content.map((cell, cellIndex)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                    children: cell
                }, rowIndex - cellIndex)),
            hasControls ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $cdb1266955124ede$export$2e2bcd8739ae039), {
                isControlIndex: isControlIndex,
                setControlIndex: setControlIndex,
                buttons: row.controls
            }) : hasControlsColumn && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {})
        ]
    });
};
var $2137746671ea1e1e$export$2e2bcd8739ae039 = $2137746671ea1e1e$var$SimpleRow;


const $0d1b649a92039ce8$var$SimpleTable = ({ simpleTableContent: simpleTableContent, noDataMessage: noDataMessage, isInfiniteScroll: isInfiniteScroll = false, maxContentLength: maxContentLength, getMoreContent: getMoreContent, isDragAndDrop: isDragAndDrop = false, isPaginated: isPaginated = false, paginationInformation: paginationInformation, infiniteScrollFetchCondition: infiniteScrollFetchCondition, isLoading: isLoading = true, hideActionsColumn: hideActionsColumn })=>{
    const { noContentMessage: noContentMessage, showNoContentMessage: showNoContentMessage, infiniteScrollRef: infiniteScrollRef, displayedContent: displayedContent, hasControlsColumn: hasControlsColumn, controlIndex: controlIndex, setControlIndex: setControlIndex, toggleDirections: toggleDirections, handleToggleDirection: handleToggleDirection, containerRef: containerRef, setHoverIndex: setHoverIndex, hoverIndex: hoverIndex, moveRow: moveRow, openMenu: openMenu, setOpenMenu: setOpenMenu, defaultSortIsUnchecked: defaultSortIsUnchecked, setDefaultSortIsUnchecked: setDefaultSortIsUnchecked, isLoadingMore: isLoadingMore } = (0, $f1d9551d5ff95bb3$export$2e2bcd8739ae039)(simpleTableContent.rows, isInfiniteScroll, getMoreContent, maxContentLength, noDataMessage, infiniteScrollFetchCondition);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d90be0009da8926e$export$9861489d68213f9c), {
        backend: (0, $1f1d51a0d4192edb$export$b4d0180dbe086f87),
        options: {
            enableMouseEvents: true
        },
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: "rc-simple-table-wrapper",
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("table", {
                    className: "rc-simple-table",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("thead", {
                            className: `rc-simple-table-header`,
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                children: [
                                    simpleTableContent.columns.map((column, index)=>column ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                            children: column.isToggleButton ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $09f39afba0120afd$export$2e2bcd8739ae039), {
                                                direction: toggleDirections[index],
                                                sortAscending: ()=>(handleToggleDirection(index, (0, $152ced39134e6095$export$cacd6541cfeeb6c1).UP), column.onSortAscendingClick()),
                                                sortDescending: ()=>(handleToggleDirection(index, (0, $152ced39134e6095$export$cacd6541cfeeb6c1).DOWN), column.onSortDescendingClick()),
                                                text: column.title,
                                                defaultSort: defaultSortIsUnchecked ? undefined : column.defaultSort,
                                                onRemoveDefaultSort: ()=>setDefaultSortIsUnchecked(true)
                                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
                                                children: column.title
                                            })
                                        }, index) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                            className: "rc-empty-column"
                                        })),
                                    (isDragAndDrop || hasControlsColumn || isLoading) && !hideActionsColumn && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                        className: "rc-controls-column",
                                        children: "Actions"
                                    })
                                ]
                            }, 100)
                        }),
                        isLoading ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("tbody", {
                            className: "rc-full-width",
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                    className: "rc-no-data-cell",
                                    colSpan: simpleTableContent.columns.length + (isDragAndDrop || hasControlsColumn ? 1 : 0),
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                        id: "no-data-message",
                                        className: "rc-no-data-message",
                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                                            size: 22
                                        })
                                    })
                                })
                            })
                        }) : showNoContentMessage ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("tbody", {
                            className: "full-width",
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                    className: "rc-no-data-cell",
                                    colSpan: simpleTableContent.columns.length + (isDragAndDrop || hasControlsColumn ? 1 : 0),
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                        id: "no-data-message",
                                        className: "rc-no-data-message",
                                        children: noContentMessage
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tbody", {
                            className: `rc-simple-table-body ${isDragAndDrop && "drag-and-drop"} `,
                            children: [
                                isDragAndDrop ? displayedContent.map((row, rowIndex)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $cadf6efaac1a81f7$export$2e2bcd8739ae039), {
                                        index: rowIndex,
                                        row: row,
                                        containerRef: containerRef,
                                        hoverIndex: hoverIndex,
                                        controlIndex: controlIndex,
                                        setControlIndex: setControlIndex,
                                        moveRow: moveRow,
                                        rowContentLength: displayedContent.length,
                                        setHoverIndex: setHoverIndex,
                                        openMenu: openMenu,
                                        setOpenMenu: setOpenMenu,
                                        dragAndDropAction: row.dragAndDropAction,
                                        isPaginated: isPaginated,
                                        paginationInformation: paginationInformation
                                    }, rowIndex)) : displayedContent.map((row, rowIndex)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2137746671ea1e1e$export$2e2bcd8739ae039), {
                                        setControlIndex: ()=>setControlIndex(rowIndex),
                                        row: row,
                                        isControlIndex: rowIndex === controlIndex,
                                        rowIndex: rowIndex,
                                        hasControlsColumn: hasControlsColumn
                                    }, rowIndex)),
                                isLoadingMore && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                    className: "rc-no-data-cell rc-load-more-spinner",
                                    colSpan: simpleTableContent.columns.length + (isDragAndDrop || hasControlsColumn ? 1 : 0),
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                                        size: 8
                                    })
                                })
                            ]
                        })
                    ]
                }),
                isInfiniteScroll && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    "data-testid": "rc-infinite-scroll",
                    ref: infiniteScrollRef
                })
            ]
        })
    });
};
var $0d1b649a92039ce8$export$2e2bcd8739ae039 = $0d1b649a92039ce8$var$SimpleTable;




var $aqdBs = parcelRequire("aqdBs");
var $38af657cf5703adc$exports = {};
"use strict";
Object.defineProperty($38af657cf5703adc$exports, "__esModule", {
    value: true
});
var $cd451b2c9b830821$exports = {};
"use strict";
Object.defineProperty($cd451b2c9b830821$exports, "__esModule", {
    value: true
});
$cd451b2c9b830821$exports.bodyOpenClassName = $cd451b2c9b830821$exports.portalClassName = undefined;
var $cd451b2c9b830821$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $cd451b2c9b830821$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $aqdBs = parcelRequire("aqdBs");
var $cd451b2c9b830821$var$_react2 = $cd451b2c9b830821$var$_interopRequireDefault($aqdBs);

var $cd451b2c9b830821$var$_reactDom2 = $cd451b2c9b830821$var$_interopRequireDefault($e813d4480671d45c$exports);

var $cd451b2c9b830821$var$_propTypes2 = $cd451b2c9b830821$var$_interopRequireDefault($38b29c2dc0019b47$exports);
var $bab24ac4dbfa6573$exports = {};
"use strict";
Object.defineProperty($bab24ac4dbfa6573$exports, "__esModule", {
    value: true
});
var $bab24ac4dbfa6573$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $bab24ac4dbfa6573$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $bab24ac4dbfa6573$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $aqdBs = parcelRequire("aqdBs");

var $bab24ac4dbfa6573$var$_propTypes2 = $bab24ac4dbfa6573$var$_interopRequireDefault($38b29c2dc0019b47$exports);
var $b5e323ac7ff15f03$exports = {};
"use strict";
Object.defineProperty($b5e323ac7ff15f03$exports, "__esModule", {
    value: true
});
$b5e323ac7ff15f03$exports.resetState = $b5e323ac7ff15f03$var$resetState;
$b5e323ac7ff15f03$exports.log = $b5e323ac7ff15f03$var$log;
$b5e323ac7ff15f03$exports.handleBlur = $b5e323ac7ff15f03$var$handleBlur;
$b5e323ac7ff15f03$exports.handleFocus = $b5e323ac7ff15f03$var$handleFocus;
$b5e323ac7ff15f03$exports.markForFocusLater = $b5e323ac7ff15f03$var$markForFocusLater;
$b5e323ac7ff15f03$exports.returnFocus = $b5e323ac7ff15f03$var$returnFocus;
$b5e323ac7ff15f03$exports.popWithoutFocus = $b5e323ac7ff15f03$var$popWithoutFocus;
$b5e323ac7ff15f03$exports.setupScopedFocus = $b5e323ac7ff15f03$var$setupScopedFocus;
$b5e323ac7ff15f03$exports.teardownScopedFocus = $b5e323ac7ff15f03$var$teardownScopedFocus;
var $4065fbd561b080ed$exports = {};
"use strict";
Object.defineProperty($4065fbd561b080ed$exports, "__esModule", {
    value: true
});
$4065fbd561b080ed$exports.default = $4065fbd561b080ed$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $4065fbd561b080ed$var$DISPLAY_NONE = "none";
var $4065fbd561b080ed$var$DISPLAY_CONTENTS = "contents";
// match the whole word to prevent fuzzy searching
var $4065fbd561b080ed$var$tabbableNode = /^(input|select|textarea|button|object|iframe)$/;
function $4065fbd561b080ed$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $4065fbd561b080ed$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $4065fbd561b080ed$var$DISPLAY_CONTENTS && $4065fbd561b080ed$var$isNotOverflowing(element, style) : displayValue === $4065fbd561b080ed$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $4065fbd561b080ed$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($4065fbd561b080ed$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $4065fbd561b080ed$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $4065fbd561b080ed$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $4065fbd561b080ed$var$visible(element);
}
function $4065fbd561b080ed$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $4065fbd561b080ed$var$focusable(element, !isTabIndexNaN);
}
function $4065fbd561b080ed$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $4065fbd561b080ed$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($4065fbd561b080ed$var$tabbable);
}
$4065fbd561b080ed$exports = $4065fbd561b080ed$exports["default"];


var $b5e323ac7ff15f03$var$_tabbable2 = $b5e323ac7ff15f03$var$_interopRequireDefault($4065fbd561b080ed$exports);
function $b5e323ac7ff15f03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b5e323ac7ff15f03$var$focusLaterElements = [];
var $b5e323ac7ff15f03$var$modalElement = null;
var $b5e323ac7ff15f03$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $b5e323ac7ff15f03$var$resetState() {
    $b5e323ac7ff15f03$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $b5e323ac7ff15f03$var$log() {}
/* eslint-enable no-console */ function $b5e323ac7ff15f03$var$handleBlur() {
    $b5e323ac7ff15f03$var$needToFocus = true;
}
function $b5e323ac7ff15f03$var$handleFocus() {
    if ($b5e323ac7ff15f03$var$needToFocus) {
        $b5e323ac7ff15f03$var$needToFocus = false;
        if (!$b5e323ac7ff15f03$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($b5e323ac7ff15f03$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $b5e323ac7ff15f03$var$_tabbable2.default)($b5e323ac7ff15f03$var$modalElement)[0] || $b5e323ac7ff15f03$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $b5e323ac7ff15f03$var$markForFocusLater() {
    $b5e323ac7ff15f03$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $b5e323ac7ff15f03$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($b5e323ac7ff15f03$var$focusLaterElements.length !== 0) {
            toFocus = $b5e323ac7ff15f03$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $b5e323ac7ff15f03$var$popWithoutFocus() {
    $b5e323ac7ff15f03$var$focusLaterElements.length > 0 && $b5e323ac7ff15f03$var$focusLaterElements.pop();
}
function $b5e323ac7ff15f03$var$setupScopedFocus(element) {
    $b5e323ac7ff15f03$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $b5e323ac7ff15f03$var$handleBlur, false);
        document.addEventListener("focus", $b5e323ac7ff15f03$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $b5e323ac7ff15f03$var$handleBlur);
        document.attachEvent("onFocus", $b5e323ac7ff15f03$var$handleFocus);
    }
}
function $b5e323ac7ff15f03$var$teardownScopedFocus() {
    $b5e323ac7ff15f03$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $b5e323ac7ff15f03$var$handleBlur);
        document.removeEventListener("focus", $b5e323ac7ff15f03$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $b5e323ac7ff15f03$var$handleBlur);
        document.detachEvent("onFocus", $b5e323ac7ff15f03$var$handleFocus);
    }
}


var $bab24ac4dbfa6573$var$focusManager = $bab24ac4dbfa6573$var$_interopRequireWildcard($b5e323ac7ff15f03$exports);
var $b8e16f7db8e76a20$exports = {};
"use strict";
Object.defineProperty($b8e16f7db8e76a20$exports, "__esModule", {
    value: true
});
$b8e16f7db8e76a20$exports.default = $b8e16f7db8e76a20$var$scopeTab;

var $b8e16f7db8e76a20$var$_tabbable2 = $b8e16f7db8e76a20$var$_interopRequireDefault($4065fbd561b080ed$exports);
function $b8e16f7db8e76a20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b8e16f7db8e76a20$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $b8e16f7db8e76a20$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $b8e16f7db8e76a20$var$scopeTab(node, event) {
    var tabbable = (0, $b8e16f7db8e76a20$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $b8e16f7db8e76a20$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$b8e16f7db8e76a20$exports = $b8e16f7db8e76a20$exports["default"];


var $bab24ac4dbfa6573$var$_scopeTab2 = $bab24ac4dbfa6573$var$_interopRequireDefault($b8e16f7db8e76a20$exports);
var $a2f64bcd5fb13303$exports = {};
"use strict";
Object.defineProperty($a2f64bcd5fb13303$exports, "__esModule", {
    value: true
});
$a2f64bcd5fb13303$exports.resetState = $a2f64bcd5fb13303$var$resetState;
$a2f64bcd5fb13303$exports.log = $a2f64bcd5fb13303$var$log;
$a2f64bcd5fb13303$exports.assertNodeList = $a2f64bcd5fb13303$var$assertNodeList;
$a2f64bcd5fb13303$exports.setElement = $a2f64bcd5fb13303$var$setElement;
$a2f64bcd5fb13303$exports.validateElement = $a2f64bcd5fb13303$var$validateElement;
$a2f64bcd5fb13303$exports.hide = $a2f64bcd5fb13303$var$hide;
$a2f64bcd5fb13303$exports.show = $a2f64bcd5fb13303$var$show;
$a2f64bcd5fb13303$exports.documentNotReadyOrSSRTesting = $a2f64bcd5fb13303$var$documentNotReadyOrSSRTesting;

var $a2f64bcd5fb13303$var$_warning2 = $a2f64bcd5fb13303$var$_interopRequireDefault($9abc3dc86fc6eb1f$exports);
var $19eb54b7b33abc48$exports = {};
"use strict";
Object.defineProperty($19eb54b7b33abc48$exports, "__esModule", {
    value: true
});
$19eb54b7b33abc48$exports.canUseDOM = $19eb54b7b33abc48$exports.SafeNodeList = $19eb54b7b33abc48$exports.SafeHTMLCollection = undefined;
var $822aa0c1608d8eaf$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if ($822aa0c1608d8eaf$exports) $822aa0c1608d8eaf$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $19eb54b7b33abc48$var$_exenv2 = $19eb54b7b33abc48$var$_interopRequireDefault($822aa0c1608d8eaf$exports);
function $19eb54b7b33abc48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $19eb54b7b33abc48$var$EE = $19eb54b7b33abc48$var$_exenv2.default;
var $19eb54b7b33abc48$var$SafeHTMLElement = $19eb54b7b33abc48$var$EE.canUseDOM ? window.HTMLElement : {};
var $19eb54b7b33abc48$var$SafeHTMLCollection = $19eb54b7b33abc48$exports.SafeHTMLCollection = $19eb54b7b33abc48$var$EE.canUseDOM ? window.HTMLCollection : {};
var $19eb54b7b33abc48$var$SafeNodeList = $19eb54b7b33abc48$exports.SafeNodeList = $19eb54b7b33abc48$var$EE.canUseDOM ? window.NodeList : {};
var $19eb54b7b33abc48$var$canUseDOM = $19eb54b7b33abc48$exports.canUseDOM = $19eb54b7b33abc48$var$EE.canUseDOM;
$19eb54b7b33abc48$exports.default = $19eb54b7b33abc48$var$SafeHTMLElement;


function $a2f64bcd5fb13303$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a2f64bcd5fb13303$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $a2f64bcd5fb13303$var$resetState() {
    if ($a2f64bcd5fb13303$var$globalElement) {
        if ($a2f64bcd5fb13303$var$globalElement.removeAttribute) $a2f64bcd5fb13303$var$globalElement.removeAttribute("aria-hidden");
        else if ($a2f64bcd5fb13303$var$globalElement.length != null) $a2f64bcd5fb13303$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($a2f64bcd5fb13303$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $a2f64bcd5fb13303$var$globalElement = null;
}
/* istanbul ignore next */ function $a2f64bcd5fb13303$var$log() {
    var check;
}
/* eslint-enable no-console */ function $a2f64bcd5fb13303$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $a2f64bcd5fb13303$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $19eb54b7b33abc48$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $a2f64bcd5fb13303$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $a2f64bcd5fb13303$var$globalElement = useElement || $a2f64bcd5fb13303$var$globalElement;
    return $a2f64bcd5fb13303$var$globalElement;
}
function $a2f64bcd5fb13303$var$validateElement(appElement) {
    var el = appElement || $a2f64bcd5fb13303$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $a2f64bcd5fb13303$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $a2f64bcd5fb13303$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $a2f64bcd5fb13303$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $a2f64bcd5fb13303$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $a2f64bcd5fb13303$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $a2f64bcd5fb13303$var$documentNotReadyOrSSRTesting() {
    $a2f64bcd5fb13303$var$globalElement = null;
}


var $bab24ac4dbfa6573$var$ariaAppHider = $bab24ac4dbfa6573$var$_interopRequireWildcard($a2f64bcd5fb13303$exports);
var $8c390205b5d1c2e8$exports = {};
"use strict";
Object.defineProperty($8c390205b5d1c2e8$exports, "__esModule", {
    value: true
});
$8c390205b5d1c2e8$exports.resetState = $8c390205b5d1c2e8$var$resetState;
$8c390205b5d1c2e8$exports.log = $8c390205b5d1c2e8$var$log;
var $8c390205b5d1c2e8$var$htmlClassList = {};
var $8c390205b5d1c2e8$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $8c390205b5d1c2e8$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $8c390205b5d1c2e8$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $8c390205b5d1c2e8$var$htmlClassList)$8c390205b5d1c2e8$var$removeClass(htmlElement, $8c390205b5d1c2e8$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $8c390205b5d1c2e8$var$docBodyClassList)$8c390205b5d1c2e8$var$removeClass(body, $8c390205b5d1c2e8$var$docBodyClassList[_cls]);
    $8c390205b5d1c2e8$var$htmlClassList = {};
    $8c390205b5d1c2e8$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $8c390205b5d1c2e8$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $8c390205b5d1c2e8$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $8c390205b5d1c2e8$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $8c390205b5d1c2e8$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $8c390205b5d1c2e8$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $8c390205b5d1c2e8$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $8c390205b5d1c2e8$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $8c390205b5d1c2e8$var$add = $8c390205b5d1c2e8$exports.add = function add(element, classString) {
    return $8c390205b5d1c2e8$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $8c390205b5d1c2e8$var$htmlClassList : $8c390205b5d1c2e8$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $8c390205b5d1c2e8$var$remove = $8c390205b5d1c2e8$exports.remove = function remove(element, classString) {
    return $8c390205b5d1c2e8$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $8c390205b5d1c2e8$var$htmlClassList : $8c390205b5d1c2e8$var$docBodyClassList, classString.split(" "));
};


var $bab24ac4dbfa6573$var$classList = $bab24ac4dbfa6573$var$_interopRequireWildcard($8c390205b5d1c2e8$exports);

var $bab24ac4dbfa6573$var$_safeHTMLElement2 = $bab24ac4dbfa6573$var$_interopRequireDefault($19eb54b7b33abc48$exports);
var $23f6cb9a79d440df$exports = {};
"use strict";
Object.defineProperty($23f6cb9a79d440df$exports, "__esModule", {
    value: true
});
$23f6cb9a79d440df$exports.log = $23f6cb9a79d440df$var$log;
$23f6cb9a79d440df$exports.resetState = $23f6cb9a79d440df$var$resetState;
function $23f6cb9a79d440df$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $23f6cb9a79d440df$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $23f6cb9a79d440df$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $23f6cb9a79d440df$var$portalOpenInstances = new $23f6cb9a79d440df$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $23f6cb9a79d440df$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($23f6cb9a79d440df$var$portalOpenInstances.openInstances.length);
    $23f6cb9a79d440df$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $23f6cb9a79d440df$var$resetState() {
    $23f6cb9a79d440df$var$portalOpenInstances = new $23f6cb9a79d440df$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $23f6cb9a79d440df$exports.default = $23f6cb9a79d440df$var$portalOpenInstances;


var $bab24ac4dbfa6573$var$_portalOpenInstances2 = $bab24ac4dbfa6573$var$_interopRequireDefault($23f6cb9a79d440df$exports);
var $306709c8c9977671$exports = {};
"use strict";
Object.defineProperty($306709c8c9977671$exports, "__esModule", {
    value: true
});
$306709c8c9977671$exports.resetState = $306709c8c9977671$var$resetState;
$306709c8c9977671$exports.log = $306709c8c9977671$var$log;

var $306709c8c9977671$var$_portalOpenInstances2 = $306709c8c9977671$var$_interopRequireDefault($23f6cb9a79d440df$exports);
function $306709c8c9977671$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $306709c8c9977671$var$before = void 0, $306709c8c9977671$var$after = void 0, $306709c8c9977671$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $306709c8c9977671$var$resetState() {
    var _arr = [
        $306709c8c9977671$var$before,
        $306709c8c9977671$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $306709c8c9977671$var$before = $306709c8c9977671$var$after = null;
    $306709c8c9977671$var$instances = [];
}
/* istanbul ignore next */ function $306709c8c9977671$var$log() {
    console.log("bodyTrap ----------");
    console.log($306709c8c9977671$var$instances.length);
    var _arr2 = [
        $306709c8c9977671$var$before,
        $306709c8c9977671$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $306709c8c9977671$var$focusContent() {
    if ($306709c8c9977671$var$instances.length === 0) return;
    $306709c8c9977671$var$instances[$306709c8c9977671$var$instances.length - 1].focusContent();
}
function $306709c8c9977671$var$bodyTrap(eventType, openInstances) {
    if (!$306709c8c9977671$var$before && !$306709c8c9977671$var$after) {
        $306709c8c9977671$var$before = document.createElement("div");
        $306709c8c9977671$var$before.setAttribute("data-react-modal-body-trap", "");
        $306709c8c9977671$var$before.style.position = "absolute";
        $306709c8c9977671$var$before.style.opacity = "0";
        $306709c8c9977671$var$before.setAttribute("tabindex", "0");
        $306709c8c9977671$var$before.addEventListener("focus", $306709c8c9977671$var$focusContent);
        $306709c8c9977671$var$after = $306709c8c9977671$var$before.cloneNode();
        $306709c8c9977671$var$after.addEventListener("focus", $306709c8c9977671$var$focusContent);
    }
    $306709c8c9977671$var$instances = openInstances;
    if ($306709c8c9977671$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $306709c8c9977671$var$before) document.body.insertBefore($306709c8c9977671$var$before, document.body.firstChild);
        if (document.body.lastChild !== $306709c8c9977671$var$after) document.body.appendChild($306709c8c9977671$var$after);
    } else {
        // Remove focus trap
        if ($306709c8c9977671$var$before.parentElement) $306709c8c9977671$var$before.parentElement.removeChild($306709c8c9977671$var$before);
        if ($306709c8c9977671$var$after.parentElement) $306709c8c9977671$var$after.parentElement.removeChild($306709c8c9977671$var$after);
    }
}
$306709c8c9977671$var$_portalOpenInstances2.default.subscribe($306709c8c9977671$var$bodyTrap);


function $bab24ac4dbfa6573$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $bab24ac4dbfa6573$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bab24ac4dbfa6573$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bab24ac4dbfa6573$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bab24ac4dbfa6573$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $bab24ac4dbfa6573$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $bab24ac4dbfa6573$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $bab24ac4dbfa6573$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $bab24ac4dbfa6573$var$ariaHiddenInstances = 0;
var $bab24ac4dbfa6573$var$ModalPortal = function(_Component) {
    $bab24ac4dbfa6573$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $bab24ac4dbfa6573$var$_classCallCheck(this, ModalPortal);
        var _this = $bab24ac4dbfa6573$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $bab24ac4dbfa6573$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $bab24ac4dbfa6573$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $bab24ac4dbfa6573$var$ariaHiddenInstances > 0) {
                $bab24ac4dbfa6573$var$ariaHiddenInstances -= 1;
                if ($bab24ac4dbfa6573$var$ariaHiddenInstances === 0) $bab24ac4dbfa6573$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $bab24ac4dbfa6573$var$focusManager.returnFocus(_this.props.preventScroll);
                    $bab24ac4dbfa6573$var$focusManager.teardownScopedFocus();
                } else $bab24ac4dbfa6573$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $bab24ac4dbfa6573$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $bab24ac4dbfa6573$var$focusManager.setupScopedFocus(_this.node);
                    $bab24ac4dbfa6573$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($bab24ac4dbfa6573$var$isTabKey(event)) (0, $bab24ac4dbfa6573$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $bab24ac4dbfa6573$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $bab24ac4dbfa6573$var$_typeof(additional)) === "object" ? additional : {
                base: $bab24ac4dbfa6573$var$CLASS_NAMES[which],
                afterOpen: $bab24ac4dbfa6573$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $bab24ac4dbfa6573$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $bab24ac4dbfa6573$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $bab24ac4dbfa6573$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $bab24ac4dbfa6573$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $bab24ac4dbfa6573$var$ariaHiddenInstances += 1;
                    $bab24ac4dbfa6573$var$ariaAppHider.hide(appElement);
                }
                $bab24ac4dbfa6573$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $bab24ac4dbfa6573$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $bab24ac4dbfa6573$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $bab24ac4dbfa6573$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $bab24ac4dbfa6573$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($aqdBs.Component);
$bab24ac4dbfa6573$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$bab24ac4dbfa6573$var$ModalPortal.propTypes = {
    isOpen: $bab24ac4dbfa6573$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $bab24ac4dbfa6573$var$_propTypes2.default.shape({
        content: $bab24ac4dbfa6573$var$_propTypes2.default.object,
        overlay: $bab24ac4dbfa6573$var$_propTypes2.default.object
    }),
    style: $bab24ac4dbfa6573$var$_propTypes2.default.shape({
        content: $bab24ac4dbfa6573$var$_propTypes2.default.object,
        overlay: $bab24ac4dbfa6573$var$_propTypes2.default.object
    }),
    className: $bab24ac4dbfa6573$var$_propTypes2.default.oneOfType([
        $bab24ac4dbfa6573$var$_propTypes2.default.string,
        $bab24ac4dbfa6573$var$_propTypes2.default.object
    ]),
    overlayClassName: $bab24ac4dbfa6573$var$_propTypes2.default.oneOfType([
        $bab24ac4dbfa6573$var$_propTypes2.default.string,
        $bab24ac4dbfa6573$var$_propTypes2.default.object
    ]),
    parentSelector: $bab24ac4dbfa6573$var$_propTypes2.default.func,
    bodyOpenClassName: $bab24ac4dbfa6573$var$_propTypes2.default.string,
    htmlOpenClassName: $bab24ac4dbfa6573$var$_propTypes2.default.string,
    ariaHideApp: $bab24ac4dbfa6573$var$_propTypes2.default.bool,
    appElement: $bab24ac4dbfa6573$var$_propTypes2.default.oneOfType([
        $bab24ac4dbfa6573$var$_propTypes2.default.instanceOf($bab24ac4dbfa6573$var$_safeHTMLElement2.default),
        $bab24ac4dbfa6573$var$_propTypes2.default.instanceOf($19eb54b7b33abc48$exports.SafeHTMLCollection),
        $bab24ac4dbfa6573$var$_propTypes2.default.instanceOf($19eb54b7b33abc48$exports.SafeNodeList),
        $bab24ac4dbfa6573$var$_propTypes2.default.arrayOf($bab24ac4dbfa6573$var$_propTypes2.default.instanceOf($bab24ac4dbfa6573$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $bab24ac4dbfa6573$var$_propTypes2.default.func,
    onAfterClose: $bab24ac4dbfa6573$var$_propTypes2.default.func,
    onRequestClose: $bab24ac4dbfa6573$var$_propTypes2.default.func,
    closeTimeoutMS: $bab24ac4dbfa6573$var$_propTypes2.default.number,
    shouldFocusAfterRender: $bab24ac4dbfa6573$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $bab24ac4dbfa6573$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $bab24ac4dbfa6573$var$_propTypes2.default.bool,
    preventScroll: $bab24ac4dbfa6573$var$_propTypes2.default.bool,
    role: $bab24ac4dbfa6573$var$_propTypes2.default.string,
    contentLabel: $bab24ac4dbfa6573$var$_propTypes2.default.string,
    aria: $bab24ac4dbfa6573$var$_propTypes2.default.object,
    data: $bab24ac4dbfa6573$var$_propTypes2.default.object,
    children: $bab24ac4dbfa6573$var$_propTypes2.default.node,
    shouldCloseOnEsc: $bab24ac4dbfa6573$var$_propTypes2.default.bool,
    overlayRef: $bab24ac4dbfa6573$var$_propTypes2.default.func,
    contentRef: $bab24ac4dbfa6573$var$_propTypes2.default.func,
    id: $bab24ac4dbfa6573$var$_propTypes2.default.string,
    overlayElement: $bab24ac4dbfa6573$var$_propTypes2.default.func,
    contentElement: $bab24ac4dbfa6573$var$_propTypes2.default.func,
    testId: $bab24ac4dbfa6573$var$_propTypes2.default.string
};
$bab24ac4dbfa6573$exports.default = $bab24ac4dbfa6573$var$ModalPortal;
$bab24ac4dbfa6573$exports = $bab24ac4dbfa6573$exports["default"];


var $cd451b2c9b830821$var$_ModalPortal2 = $cd451b2c9b830821$var$_interopRequireDefault($bab24ac4dbfa6573$exports);

var $cd451b2c9b830821$var$ariaAppHider = $cd451b2c9b830821$var$_interopRequireWildcard($a2f64bcd5fb13303$exports);

var $cd451b2c9b830821$var$_safeHTMLElement2 = $cd451b2c9b830821$var$_interopRequireDefault($19eb54b7b33abc48$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $cd451b2c9b830821$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $cd451b2c9b830821$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cd451b2c9b830821$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cd451b2c9b830821$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cd451b2c9b830821$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $cd451b2c9b830821$var$portalClassName = $cd451b2c9b830821$exports.portalClassName = "ReactModalPortal";
var $cd451b2c9b830821$var$bodyOpenClassName = $cd451b2c9b830821$exports.bodyOpenClassName = "ReactModal__Body--open";
var $cd451b2c9b830821$var$isReact16 = $19eb54b7b33abc48$exports.canUseDOM && $cd451b2c9b830821$var$_reactDom2.default.createPortal !== undefined;
var $cd451b2c9b830821$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $cd451b2c9b830821$var$getCreatePortal = function getCreatePortal() {
    return $cd451b2c9b830821$var$isReact16 ? $cd451b2c9b830821$var$_reactDom2.default.createPortal : $cd451b2c9b830821$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $cd451b2c9b830821$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $cd451b2c9b830821$var$Modal = function(_Component) {
    $cd451b2c9b830821$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $cd451b2c9b830821$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $cd451b2c9b830821$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$cd451b2c9b830821$var$isReact16 && $cd451b2c9b830821$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $cd451b2c9b830821$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $cd451b2c9b830821$var$getCreatePortal();
            var portal = createPortal(_this, $cd451b2c9b830821$var$_react2.default.createElement($cd451b2c9b830821$var$_ModalPortal2.default, $cd451b2c9b830821$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $cd451b2c9b830821$var$_possibleConstructorReturn(_this, _ret);
    }
    $cd451b2c9b830821$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$19eb54b7b33abc48$exports.canUseDOM) return;
                if (!$cd451b2c9b830821$var$isReact16) this.node = $cd451b2c9b830821$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $cd451b2c9b830821$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$cd451b2c9b830821$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $cd451b2c9b830821$var$getParentElement(prevProps.parentSelector);
                var nextParent = $cd451b2c9b830821$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$19eb54b7b33abc48$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$cd451b2c9b830821$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$19eb54b7b33abc48$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$19eb54b7b33abc48$exports.canUseDOM || !$cd451b2c9b830821$var$isReact16) return null;
                if (!this.node && $cd451b2c9b830821$var$isReact16) this.node = $cd451b2c9b830821$var$createHTMLElement("div");
                var createPortal = $cd451b2c9b830821$var$getCreatePortal();
                return createPortal($cd451b2c9b830821$var$_react2.default.createElement($cd451b2c9b830821$var$_ModalPortal2.default, $cd451b2c9b830821$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $cd451b2c9b830821$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($aqdBs.Component);
$cd451b2c9b830821$var$Modal.propTypes = {
    isOpen: $cd451b2c9b830821$var$_propTypes2.default.bool.isRequired,
    style: $cd451b2c9b830821$var$_propTypes2.default.shape({
        content: $cd451b2c9b830821$var$_propTypes2.default.object,
        overlay: $cd451b2c9b830821$var$_propTypes2.default.object
    }),
    portalClassName: $cd451b2c9b830821$var$_propTypes2.default.string,
    bodyOpenClassName: $cd451b2c9b830821$var$_propTypes2.default.string,
    htmlOpenClassName: $cd451b2c9b830821$var$_propTypes2.default.string,
    className: $cd451b2c9b830821$var$_propTypes2.default.oneOfType([
        $cd451b2c9b830821$var$_propTypes2.default.string,
        $cd451b2c9b830821$var$_propTypes2.default.shape({
            base: $cd451b2c9b830821$var$_propTypes2.default.string.isRequired,
            afterOpen: $cd451b2c9b830821$var$_propTypes2.default.string.isRequired,
            beforeClose: $cd451b2c9b830821$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $cd451b2c9b830821$var$_propTypes2.default.oneOfType([
        $cd451b2c9b830821$var$_propTypes2.default.string,
        $cd451b2c9b830821$var$_propTypes2.default.shape({
            base: $cd451b2c9b830821$var$_propTypes2.default.string.isRequired,
            afterOpen: $cd451b2c9b830821$var$_propTypes2.default.string.isRequired,
            beforeClose: $cd451b2c9b830821$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $cd451b2c9b830821$var$_propTypes2.default.oneOfType([
        $cd451b2c9b830821$var$_propTypes2.default.instanceOf($cd451b2c9b830821$var$_safeHTMLElement2.default),
        $cd451b2c9b830821$var$_propTypes2.default.instanceOf($19eb54b7b33abc48$exports.SafeHTMLCollection),
        $cd451b2c9b830821$var$_propTypes2.default.instanceOf($19eb54b7b33abc48$exports.SafeNodeList),
        $cd451b2c9b830821$var$_propTypes2.default.arrayOf($cd451b2c9b830821$var$_propTypes2.default.instanceOf($cd451b2c9b830821$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $cd451b2c9b830821$var$_propTypes2.default.func,
    onRequestClose: $cd451b2c9b830821$var$_propTypes2.default.func,
    closeTimeoutMS: $cd451b2c9b830821$var$_propTypes2.default.number,
    ariaHideApp: $cd451b2c9b830821$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $cd451b2c9b830821$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $cd451b2c9b830821$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $cd451b2c9b830821$var$_propTypes2.default.bool,
    preventScroll: $cd451b2c9b830821$var$_propTypes2.default.bool,
    parentSelector: $cd451b2c9b830821$var$_propTypes2.default.func,
    aria: $cd451b2c9b830821$var$_propTypes2.default.object,
    data: $cd451b2c9b830821$var$_propTypes2.default.object,
    role: $cd451b2c9b830821$var$_propTypes2.default.string,
    contentLabel: $cd451b2c9b830821$var$_propTypes2.default.string,
    shouldCloseOnEsc: $cd451b2c9b830821$var$_propTypes2.default.bool,
    overlayRef: $cd451b2c9b830821$var$_propTypes2.default.func,
    contentRef: $cd451b2c9b830821$var$_propTypes2.default.func,
    id: $cd451b2c9b830821$var$_propTypes2.default.string,
    overlayElement: $cd451b2c9b830821$var$_propTypes2.default.func,
    contentElement: $cd451b2c9b830821$var$_propTypes2.default.func
};
$cd451b2c9b830821$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $cd451b2c9b830821$var$portalClassName,
    bodyOpenClassName: $cd451b2c9b830821$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $cd451b2c9b830821$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $cd451b2c9b830821$var$_react2.default.createElement("div", props, children);
    }
};
$cd451b2c9b830821$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $51cb67738c4a415e$export$cea1c58a6db52bca)($cd451b2c9b830821$var$Modal);
$cd451b2c9b830821$exports.default = $cd451b2c9b830821$var$Modal;


var $38af657cf5703adc$var$_Modal2 = $38af657cf5703adc$var$_interopRequireDefault($cd451b2c9b830821$exports);
function $38af657cf5703adc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$38af657cf5703adc$exports.default = $38af657cf5703adc$var$_Modal2.default;
$38af657cf5703adc$exports = $38af657cf5703adc$exports["default"];



const $1111679e247bdc13$var$ThriveModal = ({ showModal: showModal, className: className, headerContent: headerContent, bodyContent: bodyContent, footerContent: footerContent, onCloseClick: onCloseClick, isFullPageModal: isFullPageModal, canEscapeClose: canEscapeClose, parentSelector: parentSelector })=>{
    const autoClose = ()=>{
        if (canEscapeClose) onCloseClick();
    };
    (0, $aqdBs.useEffect)(()=>{
        if (showModal) document.body.style.overflowY = "hidden";
        else document.body.style.overflowY = "initial";
        return ()=>{
            document.body.style.overflowY = "initial";
        };
    }, [
        showModal
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($38af657cf5703adc$exports))), {
        style: {
            overlay: {
                zIndex: 50
            }
        },
        closeTimeoutMS: 200,
        isOpen: showModal,
        parentSelector: parentSelector ?? undefined,
        contentLabel: "",
        className: `thrive-modal thrive-basic-modal-wrapper ${className ?? ""}`,
        overlayClassName: `thrive-modal-overlay ${isFullPageModal ? 'fullpage-modal' : ''}`,
        onRequestClose: ()=>{
            autoClose();
        },
        ariaHideApp: false,
        aria: {
            labelledby: "thrive-modal-labelled-by"
        },
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                id: "thrive-modal-labelled-by",
                className: `thrive-basic-modal-header`,
                children: [
                    headerContent ?? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "blank"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6c765ca802f88a49$export$2e2bcd8739ae039), {
                        onButtonClick: onCloseClick,
                        ariaLabel: 'Close Modal'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: `thrive-basic-modal-body`,
                children: bodyContent ?? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {})
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: `thrive-basic-modal-footer`,
                children: footerContent ?? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {})
            })
        ]
    });
};
var $1111679e247bdc13$export$2e2bcd8739ae039 = $1111679e247bdc13$var$ThriveModal;



parcelRequire("aqdBs");


const $11aea663cfdf3032$var$CancelConfirmModal = ({ className: className, isAlertStyle: isAlertStyle, headerContent: headerContent, bodyContent: bodyContent, onCloseClick: onCloseClick, cancelButtonText: cancelButtonText, cancelButtonAriaLabel: cancelButtonAriaLabel, confirmButtonText: confirmButtonText, confirmButtonAriaLabel: confirmButtonAriaLabel, onCancelClick: onCancelClick, onConfirmClick: onConfirmClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1111679e247bdc13$export$2e2bcd8739ae039), {
        showModal: true,
        className: `cancel-confirm-modal ${className}`,
        headerContent: headerContent,
        bodyContent: bodyContent,
        footerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $7dd2fa8764b346f3$export$2e2bcd8739ae039), {
            panelClassName: `cancel-confirm-modal-panel ${isAlertStyle ? "alert-style" : ""}`,
            cancelContent: cancelButtonText,
            confirmContent: confirmButtonText,
            ariaLabelCancel: cancelButtonAriaLabel,
            ariaLabelConfirm: confirmButtonAriaLabel,
            onCancelClick: onCancelClick,
            onConfirmClick: onConfirmClick
        }),
        onCloseClick: onCloseClick
    });
};
var $11aea663cfdf3032$export$2e2bcd8739ae039 = $11aea663cfdf3032$var$CancelConfirmModal;



parcelRequire("aqdBs");


const $bd9f10e600337858$var$MediaModal = ({ className: className, profileImageUrl: profileImageUrl, userDisplayName: userDisplayName, mediaTitle: mediaTitle, mediaUploadDate: mediaUploadDate, mediaContent: mediaContent, onCloseClick: onCloseClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1111679e247bdc13$export$2e2bcd8739ae039), {
        showModal: true,
        className: `media-modal ${className}`,
        headerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e40b52f31d492688$export$2e2bcd8739ae039), {
            profileImageUrl: profileImageUrl,
            displayName: userDisplayName,
            mediaTitle: mediaTitle,
            date: mediaUploadDate
        }),
        bodyContent: mediaContent,
        footerContent: undefined,
        onCloseClick: onCloseClick
    });
};
var $bd9f10e600337858$export$2e2bcd8739ae039 = $bd9f10e600337858$var$MediaModal;



parcelRequire("aqdBs");


const $30054f024f354ece$var$ButtonSelectModal = ({ className: className, title: title, buttonList: buttonList, onCloseClick: onCloseClick, footerContent: footerContent })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1111679e247bdc13$export$2e2bcd8739ae039), {
        showModal: true,
        className: `button-select-modal ${className}`,
        headerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
            className: "button-select-modal-header",
            children: title
        }),
        bodyContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: "button-select-modal-body",
            children: buttonList && buttonList.length > 0 ? buttonList?.map((button, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                    className: "button-select-modal-button",
                    content: button.text,
                    ariaLabel: button.label,
                    isDisabled: button.isDisabled,
                    onButtonClick: button.onButtonClick
                }, index)) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                className: "button-select-no-options",
                children: "No options available"
            })
        }),
        footerContent: footerContent,
        onCloseClick: onCloseClick
    });
};
var $30054f024f354ece$export$2e2bcd8739ae039 = $30054f024f354ece$var$ButtonSelectModal;




var $aqdBs = parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");




const $349b906776f3155f$var$DraggableItem = ({ item: item, index: index, moveItem: moveItem, onMoveUp: onMoveUp, onMoveDown: onMoveDown, isFirst: isFirst, isLast: isLast })=>{
    const ref = (0, $aqdBs.useRef)(null);
    const [{ isDragging: isDragging }, drag] = (0, $4de504bcfcc89199$export$7941f8aafa4b6021)({
        type: "CONTENT_ITEM",
        item: {
            index: index
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            }),
        end: ()=>{}
    });
    const [, drop] = (0, $7f734ad0ca199756$export$ccdee5eaf73cf661)({
        accept: "CONTENT_ITEM",
        hover (dragged) {
            if (dragged.index === index) return;
            const rect = ref.current?.getBoundingClientRect();
            if (!rect) return;
            moveItem(dragged.index, index);
            dragged.index = index; // mutate to keep in sync
        }
    });
    drag(drop(ref));
    (0, $aqdBs.useEffect)(()=>{
        if (isDragging) document.body.classList.add('is-dragging-cursor');
        else document.body.classList.remove('is-dragging-cursor');
        return ()=>document.body.classList.remove('is-dragging-cursor');
    }, [
        isDragging
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("li", {
        ref: ref,
        className: `content-item`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                className: "left-panel",
                draggable: false,
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2f997fb995af20df$export$2e2bcd8739ae039), {
                        dragRef: undefined,
                        className: "content-drag-button"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "content-title",
                        children: item.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $cad81e1fbe2eabcd$export$2e2bcd8739ae039), {
                panelClassName: "right-panel",
                ariaLabelUp: "Move Content Up",
                ariaLabelDown: "Move Content Down",
                upDisabled: isFirst,
                downDisabled: isLast,
                onUpClick: onMoveUp,
                onDownClick: onMoveDown
            })
        ]
    });
};
const $349b906776f3155f$var$ContentOrderSetter = ({ content: content, setContent: setContent })=>{
    const moveItem = (from, to)=>{
        const newContent = [
            ...content
        ];
        const [dragged] = newContent.splice(from, 1);
        newContent.splice(to, 0, dragged);
        setContent(newContent);
    };
    const moveContentItemUp = (index)=>{
        if (index === 0) return;
        const newContent = [
            ...content
        ];
        [newContent[index - 1], newContent[index]] = [
            newContent[index],
            newContent[index - 1]
        ];
        setContent(newContent);
    };
    const moveContentItemDown = (index)=>{
        if (index === content.length - 1) return;
        const newContent = [
            ...content
        ];
        [newContent[index], newContent[index + 1]] = [
            newContent[index + 1],
            newContent[index]
        ];
        setContent(newContent);
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d90be0009da8926e$export$9861489d68213f9c), {
        backend: (0, $1f1d51a0d4192edb$export$b4d0180dbe086f87),
        options: {
            enableMouseEvents: true
        },
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("ul", {
            className: "content-order-setter-container",
            children: content.map((item, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($349b906776f3155f$var$DraggableItem, {
                    item: item,
                    index: index,
                    moveItem: moveItem,
                    onMoveUp: ()=>moveContentItemUp(index),
                    onMoveDown: ()=>moveContentItemDown(index),
                    isFirst: index === 0,
                    isLast: index === content.length - 1
                }, item.id))
        })
    });
};
var $349b906776f3155f$export$2e2bcd8739ae039 = $349b906776f3155f$var$ContentOrderSetter;


const $fbf70050c337e031$var$ReorderContentTilesModal = ({ showModal: showModal, onHideModal: onHideModal, setContentTileOrder: setContentTileOrder, contentTiles: contentTiles })=>{
    const [tempContentTiles, setTempContentTiles] = (0, $aqdBs.useState)([
        ...contentTiles
    ]);
    (0, $aqdBs.useEffect)(()=>{
        setTempContentTiles([
            ...contentTiles
        ]);
    }, [
        contentTiles,
        showModal
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1111679e247bdc13$export$2e2bcd8739ae039), {
        showModal: showModal,
        canEscapeClose: true,
        className: "reorder-content-tiles-modal",
        headerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
            className: "reorder-content-header",
            children: "Reorder tiles"
        }),
        bodyContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: "reorder-content-modal-body",
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    className: "reorder-explainer",
                    children: "Drag tiles to reorder them, or use the arrow buttons to move them up and down."
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    className: "content-order-component",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $349b906776f3155f$export$2e2bcd8739ae039), {
                        content: tempContentTiles,
                        setContent: setTempContentTiles
                    })
                })
            ]
        }),
        footerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
            className: "save-content-order-button",
            content: "Done",
            ariaLabel: "Done",
            onButtonClick: ()=>setContentTileOrder(tempContentTiles)
        }),
        onCloseClick: onHideModal
    });
};
var $fbf70050c337e031$export$2e2bcd8739ae039 = $fbf70050c337e031$var$ReorderContentTilesModal;




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
function $6409cf54678342f0$var$u() {
    return ($6409cf54678342f0$var$u = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }).apply(this, arguments);
}
function $6409cf54678342f0$var$c(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)r.indexOf(t = a[n]) >= 0 || (o[t] = e[t]);
    return o;
}
function $6409cf54678342f0$var$i(e) {
    var t = (0, $aqdBs.useRef)(e), n = (0, $aqdBs.useRef)(function(e) {
        t.current && t.current(e);
    });
    return t.current = e, n.current;
}
var $6409cf54678342f0$var$s = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = 1), e > t ? t : e < r ? r : e;
}, $6409cf54678342f0$var$f = function(e) {
    return "touches" in e;
}, $6409cf54678342f0$var$v = function(e) {
    return e && e.ownerDocument.defaultView || self;
}, $6409cf54678342f0$var$d = function(e, r, t) {
    var n = e.getBoundingClientRect(), o = $6409cf54678342f0$var$f(r) ? function(e, r) {
        for(var t = 0; t < e.length; t++)if (e[t].identifier === r) return e[t];
        return e[0];
    }(r.touches, t) : r;
    return {
        left: $6409cf54678342f0$var$s((o.pageX - (n.left + $6409cf54678342f0$var$v(e).pageXOffset)) / n.width),
        top: $6409cf54678342f0$var$s((o.pageY - (n.top + $6409cf54678342f0$var$v(e).pageYOffset)) / n.height)
    };
}, $6409cf54678342f0$var$h = function(e) {
    !$6409cf54678342f0$var$f(e) && e.preventDefault();
}, $6409cf54678342f0$var$m = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).memo(function(o) {
    var a = o.onMove, l = o.onKey, s = $6409cf54678342f0$var$c(o, [
        "onMove",
        "onKey"
    ]), m = (0, $aqdBs.useRef)(null), g = $6409cf54678342f0$var$i(a), p = $6409cf54678342f0$var$i(l), b = (0, $aqdBs.useRef)(null), _ = (0, $aqdBs.useRef)(!1), x = (0, $aqdBs.useMemo)(function() {
        var e = function(e) {
            $6409cf54678342f0$var$h(e), ($6409cf54678342f0$var$f(e) ? e.touches.length > 0 : e.buttons > 0) && m.current ? g($6409cf54678342f0$var$d(m.current, e, b.current)) : t(!1);
        }, r = function() {
            return t(!1);
        };
        function t(t) {
            var n = _.current, o = $6409cf54678342f0$var$v(m.current), a = t ? o.addEventListener : o.removeEventListener;
            a(n ? "touchmove" : "mousemove", e), a(n ? "touchend" : "mouseup", r);
        }
        return [
            function(e) {
                var r = e.nativeEvent, n = m.current;
                if (n && ($6409cf54678342f0$var$h(r), !function(e, r) {
                    return r && !$6409cf54678342f0$var$f(e);
                }(r, _.current) && n)) {
                    if ($6409cf54678342f0$var$f(r)) {
                        _.current = !0;
                        var o = r.changedTouches || [];
                        o.length && (b.current = o[0].identifier);
                    }
                    n.focus(), g($6409cf54678342f0$var$d(n, r, b.current)), t(!0);
                }
            },
            function(e) {
                var r = e.which || e.keyCode;
                r < 37 || r > 40 || (e.preventDefault(), p({
                    left: 39 === r ? .05 : 37 === r ? -0.05 : 0,
                    top: 40 === r ? .05 : 38 === r ? -0.05 : 0
                }));
            },
            t
        ];
    }, [
        p,
        g
    ]), C = x[0], E = x[1], H = x[2];
    return (0, $aqdBs.useEffect)(function() {
        return H;
    }, [
        H
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", $6409cf54678342f0$var$u({}, s, {
        onTouchStart: C,
        onMouseDown: C,
        className: "react-colorful__interactive",
        ref: m,
        onKeyDown: E,
        tabIndex: 0,
        role: "slider"
    }));
}), $6409cf54678342f0$var$g = function(e) {
    return e.filter(Boolean).join(" ");
}, $6409cf54678342f0$var$p = function(r) {
    var t = r.color, n = r.left, o = r.top, a = void 0 === o ? .5 : o, l = $6409cf54678342f0$var$g([
        "react-colorful__pointer",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: l,
        style: {
            top: 100 * a + "%",
            left: 100 * n + "%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "react-colorful__pointer-fill",
        style: {
            backgroundColor: t
        }
    }));
}, $6409cf54678342f0$var$b = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = Math.pow(10, r)), Math.round(t * e) / t;
}, $6409cf54678342f0$var$_ = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $6409cf54678342f0$var$x = function(e) {
    return $6409cf54678342f0$var$L($6409cf54678342f0$var$C(e));
}, $6409cf54678342f0$var$C = function(e) {
    return "#" === e[0] && (e = e.substring(1)), e.length < 6 ? {
        r: parseInt(e[0] + e[0], 16),
        g: parseInt(e[1] + e[1], 16),
        b: parseInt(e[2] + e[2], 16),
        a: 4 === e.length ? $6409cf54678342f0$var$b(parseInt(e[3] + e[3], 16) / 255, 2) : 1
    } : {
        r: parseInt(e.substring(0, 2), 16),
        g: parseInt(e.substring(2, 4), 16),
        b: parseInt(e.substring(4, 6), 16),
        a: 8 === e.length ? $6409cf54678342f0$var$b(parseInt(e.substring(6, 8), 16) / 255, 2) : 1
    };
}, $6409cf54678342f0$var$E = function(e, r) {
    return void 0 === r && (r = "deg"), Number(e) * ($6409cf54678342f0$var$_[r] || 1);
}, $6409cf54678342f0$var$H = function(e) {
    var r = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $6409cf54678342f0$var$N({
        h: $6409cf54678342f0$var$E(r[1], r[2]),
        s: Number(r[3]),
        l: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $6409cf54678342f0$var$M = $6409cf54678342f0$var$H, $6409cf54678342f0$var$N = function(e) {
    var r = e.s, t = e.l;
    return {
        h: e.h,
        s: (r *= (t < 50 ? t : 100 - t) / 100) > 0 ? 2 * r / (t + r) * 100 : 0,
        v: t + r,
        a: e.a
    };
}, $6409cf54678342f0$var$w = function(e) {
    return $6409cf54678342f0$var$K($6409cf54678342f0$var$I(e));
}, $6409cf54678342f0$var$y = function(e) {
    var r = e.s, t = e.v, n = e.a, o = (200 - r) * t / 100;
    return {
        h: $6409cf54678342f0$var$b(e.h),
        s: $6409cf54678342f0$var$b(o > 0 && o < 200 ? r * t / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
        l: $6409cf54678342f0$var$b(o / 2),
        a: $6409cf54678342f0$var$b(n, 2)
    };
}, $6409cf54678342f0$var$q = function(e) {
    var r = $6409cf54678342f0$var$y(e);
    return "hsl(" + r.h + ", " + r.s + "%, " + r.l + "%)";
}, $6409cf54678342f0$var$k = function(e) {
    var r = $6409cf54678342f0$var$y(e);
    return "hsla(" + r.h + ", " + r.s + "%, " + r.l + "%, " + r.a + ")";
}, $6409cf54678342f0$var$I = function(e) {
    var r = e.h, t = e.s, n = e.v, o = e.a;
    r = r / 360 * 6, t /= 100, n /= 100;
    var a = Math.floor(r), l = n * (1 - t), u = n * (1 - (r - a) * t), c = n * (1 - (1 - r + a) * t), i = a % 6;
    return {
        r: $6409cf54678342f0$var$b(255 * [
            n,
            u,
            l,
            l,
            c,
            n
        ][i]),
        g: $6409cf54678342f0$var$b(255 * [
            c,
            n,
            n,
            u,
            l,
            l
        ][i]),
        b: $6409cf54678342f0$var$b(255 * [
            l,
            l,
            c,
            n,
            n,
            u
        ][i]),
        a: $6409cf54678342f0$var$b(o, 2)
    };
}, $6409cf54678342f0$var$O = function(e) {
    var r = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $6409cf54678342f0$var$A({
        h: $6409cf54678342f0$var$E(r[1], r[2]),
        s: Number(r[3]),
        v: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $6409cf54678342f0$var$j = $6409cf54678342f0$var$O, $6409cf54678342f0$var$z = function(e) {
    var r = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $6409cf54678342f0$var$L({
        r: Number(r[1]) / (r[2] ? 100 / 255 : 1),
        g: Number(r[3]) / (r[4] ? 100 / 255 : 1),
        b: Number(r[5]) / (r[6] ? 100 / 255 : 1),
        a: void 0 === r[7] ? 1 : Number(r[7]) / (r[8] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $6409cf54678342f0$var$B = $6409cf54678342f0$var$z, $6409cf54678342f0$var$D = function(e) {
    var r = e.toString(16);
    return r.length < 2 ? "0" + r : r;
}, $6409cf54678342f0$var$K = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = o < 1 ? $6409cf54678342f0$var$D($6409cf54678342f0$var$b(255 * o)) : "";
    return "#" + $6409cf54678342f0$var$D(r) + $6409cf54678342f0$var$D(t) + $6409cf54678342f0$var$D(n) + a;
}, $6409cf54678342f0$var$L = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = Math.max(r, t, n), l = a - Math.min(r, t, n), u = l ? a === r ? (t - n) / l : a === t ? 2 + (n - r) / l : 4 + (r - t) / l : 0;
    return {
        h: $6409cf54678342f0$var$b(60 * (u < 0 ? u + 6 : u)),
        s: $6409cf54678342f0$var$b(a ? l / a * 100 : 0),
        v: $6409cf54678342f0$var$b(a / 255 * 100),
        a: o
    };
}, $6409cf54678342f0$var$A = function(e) {
    return {
        h: $6409cf54678342f0$var$b(e.h),
        s: $6409cf54678342f0$var$b(e.s),
        v: $6409cf54678342f0$var$b(e.v),
        a: $6409cf54678342f0$var$b(e.a, 2)
    };
}, $6409cf54678342f0$var$S = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).memo(function(r) {
    var t = r.hue, n = r.onChange, o = $6409cf54678342f0$var$g([
        "react-colorful__hue",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$m, {
        onMove: function(e) {
            n({
                h: 360 * e.left
            });
        },
        onKey: function(e) {
            n({
                h: $6409cf54678342f0$var$s(t + 360 * e.left, 0, 360)
            });
        },
        "aria-label": "Hue",
        "aria-valuenow": $6409cf54678342f0$var$b(t),
        "aria-valuemax": "360",
        "aria-valuemin": "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$p, {
        className: "react-colorful__hue-pointer",
        left: t / 360,
        color: $6409cf54678342f0$var$q({
            h: t,
            s: 100,
            v: 100,
            a: 1
        })
    })));
}), $6409cf54678342f0$var$T = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).memo(function(r) {
    var t = r.hsva, n = r.onChange, o = {
        backgroundColor: $6409cf54678342f0$var$q({
            h: t.h,
            s: 100,
            v: 100,
            a: 1
        })
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "react-colorful__saturation",
        style: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$m, {
        onMove: function(e) {
            n({
                s: 100 * e.left,
                v: 100 - 100 * e.top
            });
        },
        onKey: function(e) {
            n({
                s: $6409cf54678342f0$var$s(t.s + 100 * e.left, 0, 100),
                v: $6409cf54678342f0$var$s(t.v - 100 * e.top, 0, 100)
            });
        },
        "aria-label": "Color",
        "aria-valuetext": "Saturation " + $6409cf54678342f0$var$b(t.s) + "%, Brightness " + $6409cf54678342f0$var$b(t.v) + "%"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$p, {
        className: "react-colorful__saturation-pointer",
        top: 1 - t.v / 100,
        left: t.s / 100,
        color: $6409cf54678342f0$var$q(t)
    })));
}), $6409cf54678342f0$var$F = function(e, r) {
    if (e === r) return !0;
    for(var t in e)if (e[t] !== r[t]) return !1;
    return !0;
}, $6409cf54678342f0$var$P = function(e, r) {
    return e.replace(/\s/g, "") === r.replace(/\s/g, "");
}, $6409cf54678342f0$var$X = function(e, r) {
    return e.toLowerCase() === r.toLowerCase() || $6409cf54678342f0$var$F($6409cf54678342f0$var$C(e), $6409cf54678342f0$var$C(r));
};
function $6409cf54678342f0$var$Y(e, t, l) {
    var u = $6409cf54678342f0$var$i(l), c = (0, $aqdBs.useState)(function() {
        return e.toHsva(t);
    }), s = c[0], f = c[1], v = (0, $aqdBs.useRef)({
        color: t,
        hsva: s
    });
    (0, $aqdBs.useEffect)(function() {
        if (!e.equal(t, v.current.color)) {
            var r = e.toHsva(t);
            v.current = {
                hsva: r,
                color: t
            }, f(r);
        }
    }, [
        t,
        e
    ]), (0, $aqdBs.useEffect)(function() {
        var r;
        $6409cf54678342f0$var$F(s, v.current.hsva) || e.equal(r = e.fromHsva(s), v.current.color) || (v.current = {
            hsva: s,
            color: r
        }, u(r));
    }, [
        s,
        e,
        u
    ]);
    var d = (0, $aqdBs.useCallback)(function(e) {
        f(function(r) {
            return Object.assign({}, r, e);
        });
    }, []);
    return [
        s,
        d
    ];
}
var $6409cf54678342f0$var$R, $6409cf54678342f0$var$V = "undefined" != typeof window ? (0, $aqdBs.useLayoutEffect) : (0, $aqdBs.useEffect), $6409cf54678342f0$var$$ = function() {
    return $6409cf54678342f0$var$R || ("undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0);
}, $6409cf54678342f0$export$c5f670b24c0ae95a = function(e) {
    $6409cf54678342f0$var$R = e;
}, $6409cf54678342f0$var$J = new Map, $6409cf54678342f0$var$Q = function(e) {
    $6409cf54678342f0$var$V(function() {
        var r = e.current ? e.current.ownerDocument : document;
        if (void 0 !== r && !$6409cf54678342f0$var$J.has(r)) {
            var t = r.createElement("style");
            t.innerHTML = '.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}', $6409cf54678342f0$var$J.set(r, t);
            var n = $6409cf54678342f0$var$$();
            n && t.setAttribute("nonce", n), r.head.appendChild(t);
        }
    }, []);
}, $6409cf54678342f0$var$U = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $6409cf54678342f0$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $aqdBs.useRef)(null);
    $6409cf54678342f0$var$Q(f);
    var v = $6409cf54678342f0$var$Y(o, l, i), d = v[0], h = v[1], m = $6409cf54678342f0$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", $6409cf54678342f0$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$S, {
        hue: d.h,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $6409cf54678342f0$var$W = {
    defaultColor: "000",
    toHsva: $6409cf54678342f0$var$x,
    fromHsva: function(e) {
        return $6409cf54678342f0$var$w({
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        });
    },
    equal: $6409cf54678342f0$var$X
}, $6409cf54678342f0$export$a3bc3c32746e9f3a = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$U, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$W
    }));
}, $6409cf54678342f0$var$ee = function(r) {
    var t = r.className, n = r.hsva, o = r.onChange, a = {
        backgroundImage: "linear-gradient(90deg, " + $6409cf54678342f0$var$k(Object.assign({}, n, {
            a: 0
        })) + ", " + $6409cf54678342f0$var$k(Object.assign({}, n, {
            a: 1
        })) + ")"
    }, l = $6409cf54678342f0$var$g([
        "react-colorful__alpha",
        t
    ]), u = $6409cf54678342f0$var$b(100 * n.a);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "react-colorful__alpha-gradient",
        style: a
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$m, {
        onMove: function(e) {
            o({
                a: e.left
            });
        },
        onKey: function(e) {
            o({
                a: $6409cf54678342f0$var$s(n.a + e.left)
            });
        },
        "aria-label": "Alpha",
        "aria-valuetext": u + "%",
        "aria-valuenow": u,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$p, {
        className: "react-colorful__alpha-pointer",
        left: n.a,
        color: $6409cf54678342f0$var$k(n)
    })));
}, $6409cf54678342f0$var$re = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $6409cf54678342f0$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $aqdBs.useRef)(null);
    $6409cf54678342f0$var$Q(f);
    var v = $6409cf54678342f0$var$Y(o, l, i), d = v[0], h = v[1], m = $6409cf54678342f0$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", $6409cf54678342f0$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$S, {
        hue: d.h,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$ee, {
        hsva: d,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $6409cf54678342f0$var$te = {
    defaultColor: "0001",
    toHsva: $6409cf54678342f0$var$x,
    fromHsva: $6409cf54678342f0$var$w,
    equal: $6409cf54678342f0$var$X
}, $6409cf54678342f0$export$ac2f77823341da45 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$re, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$te
    }));
}, $6409cf54678342f0$var$oe = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0,
        a: 1
    },
    toHsva: $6409cf54678342f0$var$N,
    fromHsva: $6409cf54678342f0$var$y,
    equal: $6409cf54678342f0$var$F
}, $6409cf54678342f0$export$ee0b0fc8d408da1d = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$re, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$oe
    }));
}, $6409cf54678342f0$var$le = {
    defaultColor: "hsla(0, 0%, 0%, 1)",
    toHsva: $6409cf54678342f0$var$H,
    fromHsva: $6409cf54678342f0$var$k,
    equal: $6409cf54678342f0$var$P
}, $6409cf54678342f0$export$989f0248ad966033 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$re, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$le
    }));
}, $6409cf54678342f0$var$ce = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0
    },
    toHsva: function(e) {
        return $6409cf54678342f0$var$N({
            h: e.h,
            s: e.s,
            l: e.l,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            h: (r = $6409cf54678342f0$var$y(e)).h,
            s: r.s,
            l: r.l
        };
    },
    equal: $6409cf54678342f0$var$F
}, $6409cf54678342f0$export$c737d6c85aab3af7 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$U, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$ce
    }));
}, $6409cf54678342f0$var$se = {
    defaultColor: "hsl(0, 0%, 0%)",
    toHsva: $6409cf54678342f0$var$M,
    fromHsva: $6409cf54678342f0$var$q,
    equal: $6409cf54678342f0$var$P
}, $6409cf54678342f0$export$f4f988c96ece960 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$U, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$se
    }));
}, $6409cf54678342f0$var$ve = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    },
    toHsva: function(e) {
        return e;
    },
    fromHsva: $6409cf54678342f0$var$A,
    equal: $6409cf54678342f0$var$F
}, $6409cf54678342f0$export$a2298f22bee4c5fd = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$re, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$ve
    }));
}, $6409cf54678342f0$var$he = {
    defaultColor: "hsva(0, 0%, 0%, 1)",
    toHsva: $6409cf54678342f0$var$O,
    fromHsva: function(e) {
        var r = $6409cf54678342f0$var$A(e);
        return "hsva(" + r.h + ", " + r.s + "%, " + r.v + "%, " + r.a + ")";
    },
    equal: $6409cf54678342f0$var$P
}, $6409cf54678342f0$export$b2c7d62665b7ee26 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$re, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$he
    }));
}, $6409cf54678342f0$var$ge = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0
    },
    toHsva: function(e) {
        return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        };
    },
    fromHsva: function(e) {
        var r = $6409cf54678342f0$var$A(e);
        return {
            h: r.h,
            s: r.s,
            v: r.v
        };
    },
    equal: $6409cf54678342f0$var$F
}, $6409cf54678342f0$export$580e7249020ee39f = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$U, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$ge
    }));
}, $6409cf54678342f0$var$be = {
    defaultColor: "hsv(0, 0%, 0%)",
    toHsva: $6409cf54678342f0$var$j,
    fromHsva: function(e) {
        var r = $6409cf54678342f0$var$A(e);
        return "hsv(" + r.h + ", " + r.s + "%, " + r.v + "%)";
    },
    equal: $6409cf54678342f0$var$P
}, $6409cf54678342f0$export$ef09412d0ef04fda = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$U, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$be
    }));
}, $6409cf54678342f0$var$xe = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    },
    toHsva: $6409cf54678342f0$var$L,
    fromHsva: $6409cf54678342f0$var$I,
    equal: $6409cf54678342f0$var$F
}, $6409cf54678342f0$export$e9c07ef2be187cb1 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$re, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$xe
    }));
}, $6409cf54678342f0$var$Ee = {
    defaultColor: "rgba(0, 0, 0, 1)",
    toHsva: $6409cf54678342f0$var$z,
    fromHsva: function(e) {
        var r = $6409cf54678342f0$var$I(e);
        return "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + r.a + ")";
    },
    equal: $6409cf54678342f0$var$P
}, $6409cf54678342f0$export$be07dcc7abc11a36 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$re, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$Ee
    }));
}, $6409cf54678342f0$var$Me = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0
    },
    toHsva: function(e) {
        return $6409cf54678342f0$var$L({
            r: e.r,
            g: e.g,
            b: e.b,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            r: (r = $6409cf54678342f0$var$I(e)).r,
            g: r.g,
            b: r.b
        };
    },
    equal: $6409cf54678342f0$var$F
}, $6409cf54678342f0$export$5ac2ba36722d4bd2 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$U, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$Me
    }));
}, $6409cf54678342f0$var$we = {
    defaultColor: "rgb(0, 0, 0)",
    toHsva: $6409cf54678342f0$var$B,
    fromHsva: function(e) {
        var r = $6409cf54678342f0$var$I(e);
        return "rgb(" + r.r + ", " + r.g + ", " + r.b + ")";
    },
    equal: $6409cf54678342f0$var$P
}, $6409cf54678342f0$export$9d70f030bf44a214 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$U, $6409cf54678342f0$var$u({}, r, {
        colorModel: $6409cf54678342f0$var$we
    }));
}, $6409cf54678342f0$var$qe = /^#?([0-9A-F]{3,8})$/i, $6409cf54678342f0$var$ke = function(r) {
    var t = r.color, l = void 0 === t ? "" : t, s = r.onChange, f = r.onBlur, v = r.escape, d = r.validate, h = r.format, m = r.process, g = $6409cf54678342f0$var$c(r, [
        "color",
        "onChange",
        "onBlur",
        "escape",
        "validate",
        "format",
        "process"
    ]), p = (0, $aqdBs.useState)(function() {
        return v(l);
    }), b = p[0], _ = p[1], x = $6409cf54678342f0$var$i(s), C = $6409cf54678342f0$var$i(f), E = (0, $aqdBs.useCallback)(function(e) {
        var r = v(e.target.value);
        _(r), d(r) && x(m ? m(r) : r);
    }, [
        v,
        m,
        d,
        x
    ]), H = (0, $aqdBs.useCallback)(function(e) {
        d(e.target.value) || _(v(l)), C(e);
    }, [
        l,
        v,
        d,
        C
    ]);
    return (0, $aqdBs.useEffect)(function() {
        _(v(l));
    }, [
        l,
        v
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("input", $6409cf54678342f0$var$u({}, g, {
        value: h ? h(b) : b,
        spellCheck: "false",
        onChange: E,
        onBlur: H
    }));
}, $6409cf54678342f0$var$Ie = function(e) {
    return "#" + e;
}, $6409cf54678342f0$export$9219d762117624b6 = function(r) {
    var t = r.prefixed, n = r.alpha, o = $6409cf54678342f0$var$c(r, [
        "prefixed",
        "alpha"
    ]), l = (0, $aqdBs.useCallback)(function(e) {
        return e.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
    }, [
        n
    ]), i = (0, $aqdBs.useCallback)(function(e) {
        return function(e, r) {
            var t = $6409cf54678342f0$var$qe.exec(e), n = t ? t[1].length : 0;
            return 3 === n || 6 === n || !!r && 4 === n || !!r && 8 === n;
        }(e, n);
    }, [
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($6409cf54678342f0$var$ke, $6409cf54678342f0$var$u({}, o, {
        escape: l,
        format: t ? $6409cf54678342f0$var$Ie : void 0,
        process: $6409cf54678342f0$var$Ie,
        validate: i
    }));
};





const $54457c10740ec912$var$ColourPicker = ({ pickerLabel: pickerLabel, setHasError: setHasError, color: color, setColor: setColor, isDisabled: isDisabled })=>{
    const [showPicker, setShowPicker] = (0, $aqdBs.useState)(false);
    const [hexError, setHexError] = (0, $aqdBs.useState)("");
    const debounceColor = (0, $111ec9a9285ccd09$export$2e2bcd8739ae039)(color, 500);
    // Validate colour with debounced value
    (0, $aqdBs.useEffect)(()=>{
        if (debounceColor && !/^[0-9A-F]{6}$/i.test(debounceColor)) {
            setHexError("Invalid hex code");
            setHasError(true);
        } else {
            setHexError("");
            setHasError(false);
        }
    }, [
        debounceColor
    ]);
    (0, $5eed7a488f7fba11$export$2e2bcd8739ae039)("colour-container", (clickedInPicker)=>{
        if (!clickedInPicker) setShowPicker(false);
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "colour-picker",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: "colour-input",
                className: "colour-picker-label",
                children: pickerLabel ?? "COLOUR"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "colour-container",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "colour-input-container",
                        onClick: ()=>{
                            setShowPicker(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                className: "hex",
                                children: "#"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                                id: "colour-input",
                                disabled: isDisabled,
                                type: "text",
                                value: color,
                                maxLength: 6,
                                onChange: (e)=>{
                                    setColor(e.target.value);
                                    setShowPicker(false);
                                }
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                className: "colour-rep",
                                style: {
                                    backgroundColor: `#${color}`
                                }
                            })
                        ]
                    }),
                    hexError && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "error-hex",
                        children: hexError
                    }),
                    showPicker && !isDisabled && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "picker-container-wrapper",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                            className: "picker-container",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6c765ca802f88a49$export$2e2bcd8739ae039), {
                                    ariaLabel: 'Close Picker',
                                    onButtonClick: ()=>setShowPicker(false)
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6409cf54678342f0$export$a3bc3c32746e9f3a), {
                                    color: color,
                                    onChange: (color)=>setColor(color.replace('#', ''))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $54457c10740ec912$export$2e2bcd8739ae039 = $54457c10740ec912$var$ColourPicker;




var $aqdBs = parcelRequire("aqdBs");

parcelRequire("aqdBs");
var $82210236098fe899$export$b4d121cf5102ad47 = /*#__PURE__*/ function(ThemeColours) {
    ThemeColours["Red"] = "E63946";
    ThemeColours["Coral"] = "FF595E";
    ThemeColours["Orange"] = "F77F00";
    ThemeColours["Yellow"] = "FCBF49";
    ThemeColours["Teal"] = "2A9D8F";
    ThemeColours["Ice"] = "A8DADC";
    ThemeColours["Navy"] = "1D3557";
    ThemeColours["DarkTeal"] = "264653";
    ThemeColours["Blue"] = "457B9D";
    ThemeColours["BrightBlue"] = "1982C4";
    ThemeColours["Purple"] = "6A4C93";
    ThemeColours["Lilac"] = "C77DFF";
    ThemeColours["Lime"] = "8AC926";
    ThemeColours["Crimson"] = "D62828";
    ThemeColours["DeepBlue"] = "023E8A";
    return ThemeColours;
}({});
const $82210236098fe899$export$c0de0e66d4ee305d = [
    "E63946",
    "FF595E",
    "F77F00",
    "FCBF49",
    "2A9D8F",
    "A8DADC",
    "1D3557",
    "264653"
];
const $82210236098fe899$export$b2de28df74fa4029 = [
    "457B9D",
    "1982C4",
    "6A4C93",
    "C77DFF",
    "8AC926",
    "D62828",
    "023E8A"
];


const $5eea587969fca707$var$getColourName = (value)=>Object.entries((0, $82210236098fe899$export$b4d121cf5102ad47)).find(([, v])=>v === value)?.[0];
const $5eea587969fca707$var$ColourButton = ({ colour: colour, setColour: setColour, isSelected: isSelected })=>{
    const colourName = $5eea587969fca707$var$getColourName(colour);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `colour-button ${isSelected ? "selected" : ""}`,
        style: {
            background: `#${colour}`
        },
        onClick: setColour,
        "aria-label": `Select ${colourName}`
    }, colour);
};
var $5eea587969fca707$export$2e2bcd8739ae039 = $5eea587969fca707$var$ColourButton;





const $5bfe664b76233744$var$ThemeColourPicker = ({ colour: colour, setColour: setColour })=>{
    const dropdownWrapperRef = (0, $aqdBs.useRef)(null);
    const [showDropdownColourPicker, setShowDropdownColourPicker] = (0, $aqdBs.useState)(false);
    const presetColours = [
        ...(0, $82210236098fe899$export$c0de0e66d4ee305d),
        ...(0, $82210236098fe899$export$b2de28df74fa4029)
    ];
    const isPresetColour = presetColours.includes(colour);
    (0, $006deecf5b91ed7a$export$40bf77e055859e12)(showDropdownColourPicker, dropdownWrapperRef, ()=>{
        setShowDropdownColourPicker(false);
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "theme-colour-container",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                children: "Theme colour"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "colour-grid",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "row",
                        children: (0, $82210236098fe899$export$c0de0e66d4ee305d).map((colourButton)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5eea587969fca707$export$2e2bcd8739ae039), {
                                colour: colourButton,
                                setColour: ()=>setColour(colourButton),
                                isSelected: colourButton === colour
                            }, colourButton))
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            (0, $82210236098fe899$export$b2de28df74fa4029).map((colourButton)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5eea587969fca707$export$2e2bcd8739ae039), {
                                    colour: colourButton,
                                    setColour: ()=>setColour(colourButton),
                                    isSelected: colourButton === colour
                                }, colourButton)),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                className: "add-button-wrapper",
                                ref: dropdownWrapperRef,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                        className: `colour-button add-button ${!isPresetColour ? "selected-add-button" : ""}`,
                                        onClick: ()=>setShowDropdownColourPicker(!showDropdownColourPicker),
                                        children: "+"
                                    }),
                                    showDropdownColourPicker && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                        className: "colour-picker-container",
                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $54457c10740ec912$export$2e2bcd8739ae039), {
                                            setHasError: ()=>{},
                                            color: colour,
                                            setColor: setColour
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5bfe664b76233744$export$2e2bcd8739ae039 = $5bfe664b76233744$var$ThemeColourPicker;



parcelRequire("aqdBs");
const $49dab41383383447$var$DividerLine = ()=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "divider-line"
    });
};
var $49dab41383383447$export$2e2bcd8739ae039 = $49dab41383383447$var$DividerLine;




var $aqdBs = parcelRequire("aqdBs");

parcelRequire("aqdBs");

const $c0816f2ea950ae9f$var$AddExtraConditionButton = ({ content: content, ariaLabel: ariaLabel, onAddConditionClick: onAddConditionClick })=>{
    if (!onAddConditionClick) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
        className: "add-condition-button",
        content: content,
        ariaLabel: ariaLabel,
        onButtonClick: onAddConditionClick
    });
};
var $c0816f2ea950ae9f$export$2e2bcd8739ae039 = $c0816f2ea950ae9f$var$AddExtraConditionButton;



parcelRequire("aqdBs");

parcelRequire("aqdBs");




const $d1d99b05721f1b31$var$ToggleConditionalValue = ({ conditions: conditions, onAddConditionalValueClick: onAddConditionalValueClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "toggle-item",
        children: [
            conditions.map((toggle, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: `${index !== 0 && "toggle-wrapper"}`,
                    children: [
                        index === 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                            className: "toggle-label",
                            children: toggle.label || " "
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                            className: "toggle-option",
                            children: [
                                index !== 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6fdd0991e8159fdf$export$2e2bcd8739ae039), {
                                    className: "cancel-option-button",
                                    ariaLabel: '',
                                    onButtonClick: ()=>toggle.removeOption?.(),
                                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CIRCLE_CLOSE
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e0ba5d8cacf44ce0$export$2e2bcd8739ae039), {
                                    selectedItem: toggle.selectedItem,
                                    defaultTitle: toggle.defaultTitle || "",
                                    ariaLabel: toggle.ariaLabel,
                                    buttonList: toggle.buttonList
                                })
                            ]
                        })
                    ]
                }, `${index}-${toggle.id}`)),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                className: "add-toggle-button",
                content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "add-icon",
                            children: "+"
                        }),
                        "or"
                    ]
                }),
                ariaLabel: "add an additional OR condition",
                onButtonClick: ()=>onAddConditionalValueClick?.()
            })
        ]
    });
};
var $d1d99b05721f1b31$export$2e2bcd8739ae039 = $d1d99b05721f1b31$var$ToggleConditionalValue;



parcelRequire("aqdBs");




parcelRequire("aqdBs");
/**
 * 
 *  Fairly Niche Text input, only sets the value when the input loses focus 
 *  Deeply rendering componets can cause on change events to refresh the dom
 *  too much, meaning elements lose focus and other weird behaviour
 *  adding this for thos situations
 *  
 */ const $bbada9794904f787$var$OnBlurTextInput = ({ id: id, className: className, labelText: labelText, labelIsHidden: labelIsHidden, placeholderText: placeholderText, textString: textString, setTextString: setTextString, maxLength: maxLength, isDisabled: isDisabled, isReadOnly: isReadOnly })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `basic-text-input-wrapper ${className ?? ""} `,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: "basic-text-input",
                className: `${labelIsHidden ? "sr-only" : ""} basic-text-input-label`,
                children: labelText
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                type: "text",
                id: `basic-text-input-${id || ''}`,
                className: "basic-text-input",
                placeholder: placeholderText,
                defaultValue: textString,
                onBlur: (e)=>setTextString(e.target.value),
                "aria-label": "Add your Text",
                maxLength: maxLength,
                disabled: isDisabled,
                readOnly: isReadOnly
            }, id ? `basic-text-input-${id}` : '')
        ]
    });
};
var $bbada9794904f787$export$2e2bcd8739ae039 = $bbada9794904f787$var$OnBlurTextInput;


const $6e9b988cf3c3d0f3$var$TextConditionalValue = ({ conditions: conditions })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "toggle-item",
        children: conditions.map((condition, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: `${index !== 0 && "toggle-wrapper"}`,
                children: [
                    condition.label && index === 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                        className: "toggle-label",
                        children: condition.label
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                        className: "toggle-option",
                        children: [
                            condition.label && index !== 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6fdd0991e8159fdf$export$2e2bcd8739ae039), {
                                className: "cancel-option-button",
                                ariaLabel: '',
                                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CIRCLE_CLOSE,
                                onButtonClick: ()=>condition.removeOption?.()
                            }),
                            condition.updateOnBlur ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $bbada9794904f787$export$2e2bcd8739ae039), {
                                id: condition.id,
                                labelText: condition.ariaLabel,
                                placeholderText: condition.placeholderText ?? "Value",
                                textString: condition.text,
                                setTextString: condition.setTextInput,
                                labelIsHidden: true
                            }, `${condition.id}-input`) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e6534d004b9f2161$export$2e2bcd8739ae039), {
                                id: condition.id,
                                labelText: condition.ariaLabel,
                                placeholderText: condition.placeholderText ?? "Value",
                                textString: condition.text,
                                setTextString: condition.setTextInput,
                                labelIsHidden: true
                            }, `${condition.id}-input`)
                        ]
                    })
                ]
            }, `${condition.id}-wrapper`))
    });
};
var $6e9b988cf3c3d0f3$export$2e2bcd8739ae039 = $6e9b988cf3c3d0f3$var$TextConditionalValue;


const $970171d1be24debc$var$ConditionalValue = ({ textConditions: textConditions, toggleConditions: toggleConditions, onAddConditionalValueClick: onAddConditionalValueClick })=>{
    if (!textConditions && !toggleConditions) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    if (toggleConditions) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d1d99b05721f1b31$export$2e2bcd8739ae039), {
        conditions: toggleConditions,
        onAddConditionalValueClick: onAddConditionalValueClick
    });
    else if (textConditions) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6e9b988cf3c3d0f3$export$2e2bcd8739ae039), {
        conditions: textConditions
    });
};
var $970171d1be24debc$export$2e2bcd8739ae039 = $970171d1be24debc$var$ConditionalValue;



parcelRequire("aqdBs");

const $2525e2a4ab146f02$var$ToggleCondition = ({ condition: condition })=>{
    const { selectedItem: selectedItem, defaultTitle: defaultTitle, ariaLabel: ariaLabel, className: className, toggleDisabled: toggleDisabled, buttonList: buttonList, label: label } = condition;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "toggle-item",
        children: [
            label && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                className: "toggle-label",
                children: label
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e0ba5d8cacf44ce0$export$2e2bcd8739ae039), {
                className: className,
                selectedItem: selectedItem,
                defaultTitle: defaultTitle || '',
                ariaLabel: ariaLabel,
                buttonList: buttonList,
                toggleDisabled: toggleDisabled
            })
        ]
    });
};
var $2525e2a4ab146f02$export$2e2bcd8739ae039 = $2525e2a4ab146f02$var$ToggleCondition;



parcelRequire("aqdBs");



const $2ebde839b65c3c84$var$RemoveConditionButton = ({ showButton: showButton, buttonLabel: buttonLabel, onButtonClick: onButtonClick })=>{
    if (!showButton) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
        className: "remove-condition-button",
        ariaLabel: buttonLabel ?? 'Remove Condition',
        content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).BIN,
            sizeInPx: "12",
            color: "var(--thriveGreyDark)"
        }),
        onButtonClick: onButtonClick
    });
};
var $2ebde839b65c3c84$export$2e2bcd8739ae039 = $2ebde839b65c3c84$var$RemoveConditionButton;



const $5df894d183466204$var$ConditionalLogicPanel = ({ panelClassName: panelClassName, title: title, toggleItems: toggleItems, removeConditionButtonLabel: removeConditionButtonLabel, onAddConditionClick: onAddConditionClick, onRemoveConditionClick: onRemoveConditionClick, combinator: combinator, setCombinator: setCombinator })=>{
    const buttons = (parentId)=>[
            {
                id: parentId + 1,
                isDisabled: false,
                label: 'and',
                onButtonClick: ()=>{
                    setCombinator?.('and');
                },
                text: 'and'
            },
            {
                id: parentId + 2,
                isDisabled: false,
                label: 'or',
                onButtonClick: ()=>{
                    setCombinator?.('or');
                },
                text: 'or'
            }
        ];
    const selectedItemIndex = combinator === 'and' ? 0 : 1;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `conditional-logic-panel ${panelClassName ?? ''}`,
        children: [
            title && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                className: "title",
                children: title
            }),
            toggleItems.map((item, index)=>{
                const { conditionOne: conditionOne, conditionTwo: conditionTwo, textConditions: textConditions, toggleConditions: toggleConditions, addToggleOption: addToggleOption } = item;
                return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                            className: `toggle-row toggle-row-id-${item.id} ${textConditions || toggleConditions ? 'two-rows' : 'one-row'}`,
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2525e2a4ab146f02$export$2e2bcd8739ae039), {
                                    condition: conditionOne
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                    className: "condition-two-and-three-container",
                                    children: [
                                        conditionTwo && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2525e2a4ab146f02$export$2e2bcd8739ae039), {
                                            condition: conditionTwo
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $970171d1be24debc$export$2e2bcd8739ae039), {
                                            textConditions: textConditions,
                                            toggleConditions: toggleConditions,
                                            onAddConditionalValueClick: addToggleOption
                                        })
                                    ]
                                })
                            ]
                        }),
                        toggleItems.length > 1 && index < toggleItems.length - 1 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                            className: "add-remove-condition-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e0ba5d8cacf44ce0$export$2e2bcd8739ae039), {
                                    className: 'change-condition-button',
                                    selectedItem: buttons(Number(item.id))[selectedItemIndex],
                                    defaultTitle: '',
                                    ariaLabel: 'select condition type',
                                    buttonList: buttons(Number(item.id)),
                                    toggleDisabled: index !== 0
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2ebde839b65c3c84$export$2e2bcd8739ae039), {
                                    showButton: toggleItems.length > 1,
                                    buttonLabel: removeConditionButtonLabel,
                                    onButtonClick: ()=>onRemoveConditionClick(toggleItems[index + 1])
                                })
                            ]
                        })
                    ]
                }, item.id || index);
            }),
            !!onAddConditionClick && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0816f2ea950ae9f$export$2e2bcd8739ae039), {
                content: toggleItems.length < 1 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
                    children: "+ Add Condition"
                }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "add-icon",
                            children: "+"
                        }),
                        " ",
                        buttons(0)[selectedItemIndex].label
                    ]
                }),
                ariaLabel: 'Add an additional condition',
                onAddConditionClick: onAddConditionClick ?? undefined
            })
        ]
    });
};
var $5df894d183466204$export$2e2bcd8739ae039 = $5df894d183466204$var$ConditionalLogicPanel;



parcelRequire("aqdBs");

parcelRequire("aqdBs");


parcelRequire("aqdBs");

var $15c1b765cda4698a$export$3c4356130c0e31a3 = /*#__PURE__*/ function(FormElementType) {
    FormElementType["SHORT_TEXT"] = "Short Text";
    FormElementType["LONG_TEXT"] = "Long Text";
    FormElementType["DROPDOWN"] = "Dropdown";
    FormElementType["USER_SELECT"] = "User Select";
    FormElementType["CHECKBOX"] = "Checkbox";
    FormElementType["IMAGE_SELECT"] = "Image Select";
    FormElementType["VIDEO_SELECT"] = "Video Select";
    FormElementType["FILE_SELECT"] = "File Select";
    FormElementType["SUBMIT_BUTTON"] = "Submit Button";
    FormElementType["CHOICE_BUTTON"] = "Choice Button";
    FormElementType["VIEW_FORM_BUTTON"] = "View Form Button";
    return FormElementType;
}({});
var $15c1b765cda4698a$export$7709c3af9fb2cb90 = /*#__PURE__*/ function(ValidationRules) {
    ValidationRules["TITLE_IS_REQUIRED"] = "titleIsRequired";
    ValidationRules["RULES_ARE_INVALID"] = "rulesAreInvalid";
    ValidationRules["DROPDOWN_REQUIRES_OPTIONSETS"] = "dropDownRequiresOptionSets";
    ValidationRules["MUST_HAVE_AT_LEAST_1_OPTION"] = "mustHaveAtLeastOneOption";
    ValidationRules["OPTIONS_MUST_HAVE_LABEL_TEXT"] = "optionsMustHaveLabelText";
    ValidationRules["CONDITIONAL_EXPRESSION_IS_INVALID"] = "condtionalExpressionIsInvalid";
    return ValidationRules;
}({});


function $178768d4bb479bc6$export$4d784c6ebd08a6f7(elementType) {
    switch(elementType){
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).SHORT_TEXT:
            return (0, $99899ff752f57db8$export$356109f9df11377f).DASH;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).LONG_TEXT:
            return (0, $99899ff752f57db8$export$356109f9df11377f).PARAGRAPH;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).DROPDOWN:
            return (0, $99899ff752f57db8$export$356109f9df11377f).INPUT_DOTS;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).USER_SELECT:
            return (0, $99899ff752f57db8$export$356109f9df11377f).USER_SEARCH;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).CHECKBOX:
            return (0, $99899ff752f57db8$export$356109f9df11377f).CHECKBOX;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).IMAGE_SELECT:
            return (0, $99899ff752f57db8$export$356109f9df11377f).IMAGE;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).VIDEO_SELECT:
            return (0, $99899ff752f57db8$export$356109f9df11377f).VIDEO;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).FILE_SELECT:
            return (0, $99899ff752f57db8$export$356109f9df11377f).FILE_UPLOAD;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).SUBMIT_BUTTON:
            return (0, $99899ff752f57db8$export$356109f9df11377f).DASH;
        case (0, $15c1b765cda4698a$export$3c4356130c0e31a3).CHOICE_BUTTON:
            return (0, $99899ff752f57db8$export$356109f9df11377f).CHOICE_PILL;
        default:
            return (0, $99899ff752f57db8$export$356109f9df11377f).DASH;
    }
}



const $109aaff7be037717$var$ElementTypeInformation = ({ className: className, elementType: elementType, withBrackets: withBrackets })=>{
    const elementTypeText = withBrackets ? `(${elementType})` : elementType;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `element-type-information ${className} ${elementType.replaceAll(' ', '-')}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                className: "element-type-icon",
                iconName: (0, $178768d4bb479bc6$export$4d784c6ebd08a6f7)(elementType),
                sizeInPx: "12",
                color: "var(--thriveGreyDark)"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "element-type-text",
                children: elementTypeText
            })
        ]
    });
};
var $109aaff7be037717$export$2e2bcd8739ae039 = $109aaff7be037717$var$ElementTypeInformation;


const $c0038c3942dae0f0$var$FormElementMenuButton = ({ elementType: elementType, ariaLabel: ariaLabel, onButtonClick: onButtonClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
        className: "form-element-menu-button",
        content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $109aaff7be037717$export$2e2bcd8739ae039), {
            elementType: elementType
        }),
        ariaLabel: ariaLabel,
        onButtonClick: onButtonClick
    });
};
var $c0038c3942dae0f0$export$2e2bcd8739ae039 = $c0038c3942dae0f0$var$FormElementMenuButton;




const $11d25889721fc7c3$var$FormElementSelectMenu = ({ onShortTextClick: onShortTextClick, onLongTextClick: onLongTextClick, onDropdownClick: onDropdownClick, onUserSelectClick: onUserSelectClick, onCheckboxClick: onCheckboxClick, onImageSelectClick: onImageSelectClick, onVideoSelectClick: onVideoSelectClick, onFileSelectClick: onFileSelectClick, onChoiceButtonClick: onChoiceButtonClick, isOpen: isOpen, handleClose: handleClose, containerRef: containerRef })=>{
    (0, $006deecf5b91ed7a$export$40bf77e055859e12)(isOpen, containerRef, handleClose);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "form-element-select-menu",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).SHORT_TEXT,
                ariaLabel: 'Add a short text element to form',
                onButtonClick: onShortTextClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).LONG_TEXT,
                ariaLabel: 'Add a long text element to form',
                onButtonClick: onLongTextClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).DROPDOWN,
                ariaLabel: 'Add a dropdown element to form',
                onButtonClick: onDropdownClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).CHOICE_BUTTON,
                ariaLabel: 'Add a choice button element to form',
                onButtonClick: onChoiceButtonClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).USER_SELECT,
                ariaLabel: 'Add a user select element to form',
                onButtonClick: onUserSelectClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).CHECKBOX,
                ariaLabel: 'Add a checkbox element to form',
                onButtonClick: onCheckboxClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).IMAGE_SELECT,
                ariaLabel: 'Add an image select element to form',
                onButtonClick: onImageSelectClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).VIDEO_SELECT,
                ariaLabel: 'Add a video select element to form',
                onButtonClick: onVideoSelectClick
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c0038c3942dae0f0$export$2e2bcd8739ae039), {
                elementType: (0, $15c1b765cda4698a$export$3c4356130c0e31a3).FILE_SELECT,
                ariaLabel: 'Add a file select element to form',
                onButtonClick: onFileSelectClick
            })
        ]
    });
};
var $11d25889721fc7c3$export$2e2bcd8739ae039 = $11d25889721fc7c3$var$FormElementSelectMenu;



parcelRequire("aqdBs");

const $d753e79cbdb6a277$var$ConditionCheckboxPanel = ({ formElementId: formElementId, isRequiredElement: isRequiredElement, setIsRequiredElement: setIsRequiredElement, conditionalRuleEnabled: conditionalRuleEnabled, setConditionalRuleEnabled: setConditionalRuleEnabled })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "condition-checkbox-panel",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: "checkboxes",
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $40073b7c6bbbe3b7$export$2e2bcd8739ae039), {
                    id: `required-checkbox-for-input-${formElementId}`,
                    isChecked: isRequiredElement,
                    onChange: setIsRequiredElement,
                    label: 'Required'
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $40073b7c6bbbe3b7$export$2e2bcd8739ae039), {
                    id: `condition-enable-checkbox-for-input-${formElementId}`,
                    isChecked: conditionalRuleEnabled,
                    onChange: setConditionalRuleEnabled,
                    label: 'Add Conditional Logic'
                })
            ]
        })
    });
};
var $d753e79cbdb6a277$export$2e2bcd8739ae039 = $d753e79cbdb6a277$var$ConditionCheckboxPanel;



parcelRequire("aqdBs");



const $86bf147a286ef1e8$var$MinimisedElementDetails = ({ elementType: elementType, labelText: labelText, isRequiredElement: isRequiredElement, onDeleteElementClick: onDeleteElementClick, onEditElementClick: onEditElementClick, dragRef: dragRef, validationErrors: validationErrors })=>{
    const hasValidationErrors = (validationErrors?.length ?? 0) >= 1;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `form-element-details-wrapper ${hasValidationErrors ? 'form-validation-errors' : ''}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "form-element-type-details",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h3", {
                        className: "form-element-label-text",
                        onClick: onEditElementClick,
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') onEditElementClick();
                        },
                        children: [
                            labelText,
                            isRequiredElement ? "*" : ""
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $109aaff7be037717$export$2e2bcd8739ae039), {
                        className: "reversed-elements",
                        elementType: elementType,
                        withBrackets: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "form-element-control-panel",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6fdd0991e8159fdf$export$2e2bcd8739ae039), {
                        ariaLabel: 'Remove Form Element',
                        className: 'icon-button-squared control-button',
                        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).BIN,
                        onButtonClick: onDeleteElementClick
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6fdd0991e8159fdf$export$2e2bcd8739ae039), {
                        ariaLabel: 'Edit Form Element',
                        className: 'icon-button-squared control-button',
                        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).PENCIL,
                        onButtonClick: onEditElementClick
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6fdd0991e8159fdf$export$2e2bcd8739ae039), {
                        ariaLabel: 'Drag to Reorder Element',
                        className: 'icon-button-squared control-button drag',
                        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).DRAG,
                        parentRef: dragRef
                    })
                ]
            })
        ]
    });
};
var $86bf147a286ef1e8$export$2e2bcd8739ae039 = $86bf147a286ef1e8$var$MinimisedElementDetails;



parcelRequire("aqdBs");






const $91998629ce5d1fb0$var$EditElementDetails = ({ elementType: elementType, labelText: labelText, setLabelText: setLabelText, isRequiredElement: isRequiredElement, isFirstElement: isFirstElement, isLastElement: isLastElement, formElementComponent: formElementComponent, onMoveElementUp: onMoveElementUp, onMoveElementDown: onMoveElementDown, rulesComponent: rulesComponent, onSaveClick: onSaveClick, onDeleteElementClick: onDeleteElementClick, conditionalCheckboxPanel: conditionalCheckboxPanel, advancedOptions: advancedOptions, validationErrors: validationErrors })=>{
    const titleIsInvalid = validationErrors?.includes((0, $15c1b765cda4698a$export$7709c3af9fb2cb90).TITLE_IS_REQUIRED);
    const hasValidationErrors = (validationErrors?.length ?? 0) >= 1;
    const titleMaxLength = [
        (0, $15c1b765cda4698a$export$3c4356130c0e31a3).FILE_SELECT,
        (0, $15c1b765cda4698a$export$3c4356130c0e31a3).IMAGE_SELECT,
        (0, $15c1b765cda4698a$export$3c4356130c0e31a3).VIDEO_SELECT
    ].includes(elementType) ? 20 : 512;
    function showValidationError(label) {
        return titleIsInvalid && !label.trim() || label.length >= 513;
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `form-element-edit-details-wrapper ${hasValidationErrors ? 'form-validation-errors' : ''}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "header-panel",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "header-details",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h3", {
                                className: "header-label-text",
                                children: [
                                    labelText,
                                    isRequiredElement ? "*" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $109aaff7be037717$export$2e2bcd8739ae039), {
                                className: "reversed-elements",
                                elementType: elementType,
                                withBrackets: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $cad81e1fbe2eabcd$export$2e2bcd8739ae039), {
                        upDisabled: isFirstElement,
                        downDisabled: isLastElement,
                        ariaLabelUp: 'Move element up in the form order',
                        ariaLabelDown: 'Move element down in the form order',
                        onUpClick: onMoveElementUp,
                        onDownClick: onMoveElementDown
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e6534d004b9f2161$export$2e2bcd8739ae039), {
                className: `form-element-label-input ${showValidationError(labelText) ? 'form-builder-error' : ''}`,
                labelText: `${elementType.toUpperCase()} LABEL*`,
                placeholderText: 'Describe your input here',
                textString: labelText,
                setTextString: setLabelText,
                maxLength: titleMaxLength + 1,
                autofocus: true
            }),
            titleIsInvalid && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "error-text",
                children: "Label is required"
            }),
            labelText.length > titleMaxLength && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                className: "error-text",
                children: [
                    "Please enter a maximum of ",
                    titleMaxLength,
                    " characters"
                ]
            }),
            formElementComponent,
            advancedOptions,
            conditionalCheckboxPanel,
            rulesComponent,
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "button-panel edit-element-button-panel",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                        ariaLabel: "Remove Field from form",
                        className: "full-width-remove-button",
                        content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).BIN,
                                    color: "var(--thriveCharcoal)",
                                    sizeInPx: "12"
                                }),
                                " Remove Field"
                            ]
                        }),
                        onButtonClick: onDeleteElementClick
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                        ariaLabel: "Done",
                        content: "Done",
                        onButtonClick: onSaveClick,
                        isClassicThriveStyle: true,
                        className: "thrive-navy-style"
                    })
                ]
            })
        ]
    });
};
var $91998629ce5d1fb0$export$2e2bcd8739ae039 = $91998629ce5d1fb0$var$EditElementDetails;



parcelRequire("aqdBs");



const $f7032d897ddf6dfe$var$AdvancedSettingsButton = ({ showAdvancedOptions: showAdvancedOptions, setShowAdvancedOptions: setShowAdvancedOptions })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $a25bbe6803f2a647$export$2e2bcd8739ae039), {
        className: "advanced-settings-button",
        content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "advanced-options-button-text",
                    children: "Advanced Options"
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                    className: `${showAdvancedOptions ? "show-advanced-options" : ""}`,
                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CHEVRON_DOWN,
                    color: "var(--thriveGreyDark)",
                    sizeInPx: "9"
                })
            ]
        }),
        ariaLabel: `${showAdvancedOptions ? "Hide advanced options for form element." : "Show advanced options for form element."}`,
        onButtonClick: setShowAdvancedOptions
    });
};
var $f7032d897ddf6dfe$export$2e2bcd8739ae039 = $f7032d897ddf6dfe$var$AdvancedSettingsButton;



parcelRequire("aqdBs");

const $84d9d78cc4b24ec5$var$AddFormOptionButton = ({ hideButton: hideButton, text: text, ariaLabel: ariaLabel, onButtonClick: onButtonClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
        className: `add-form-option-button ${hideButton ? 'hidden' : ''}`,
        content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "add-icon",
                    children: "+"
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "add-form-option-button-text",
                    children: text || "Add Form Option"
                })
            ]
        }),
        ariaLabel: ariaLabel,
        onButtonClick: onButtonClick
    });
};
var $84d9d78cc4b24ec5$export$2e2bcd8739ae039 = $84d9d78cc4b24ec5$var$AddFormOptionButton;




var $aqdBs = parcelRequire("aqdBs");

parcelRequire("aqdBs");



const $2014190ade5a3ba1$var$EditSubmitButtonDetails = ({ placeholderText: placeholderText, submitButtonText: submitButtonText, setSubmitButtonText: setSubmitButtonText, onContinueClick: onContinueClick, validationErrors: validationErrors, type: type })=>{
    const titleIsInvalid = validationErrors?.includes((0, $15c1b765cda4698a$export$7709c3af9fb2cb90).TITLE_IS_REQUIRED);
    const hasValidationErrors = (validationErrors?.length ?? 0) >= 1;
    function showValidationError(label) {
        return hasValidationErrors || label.length >= 21;
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `form-element-edit-details-wrapper edit-submit-button-details ${showValidationError(submitButtonText) ? 'form-validation-errors' : ''}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "header-panel",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                        className: "header-label-text",
                        children: submitButtonText
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "element-type-text",
                        children: `(${type})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e6534d004b9f2161$export$2e2bcd8739ae039), {
                className: "form-element-label-input",
                labelText: `${type?.toUpperCase()}`,
                placeholderText: placeholderText,
                textString: submitButtonText,
                setTextString: setSubmitButtonText,
                maxLength: 21,
                autofocus: true
            }),
            titleIsInvalid && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                className: "error-text",
                children: [
                    type,
                    " text is required"
                ]
            }),
            submitButtonText.length >= 21 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "error-text",
                children: "Please enter a maximum of 20 characters"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "button-panel",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                    ariaLabel: "Done",
                    className: "thrive-navy-style full-width-continue-button",
                    content: "Done",
                    onButtonClick: onContinueClick,
                    isClassicThriveStyle: true
                })
            })
        ]
    });
};
var $2014190ade5a3ba1$export$2e2bcd8739ae039 = $2014190ade5a3ba1$var$EditSubmitButtonDetails;



parcelRequire("aqdBs");


const $b6d8af8f2581d5fa$var$SubmitButtonDetails = ({ submitButtonText: submitButtonText, onEditClick: onEditClick, validationErrors: validationErrors, type: type })=>{
    const hasValidationErrors = (validationErrors?.length ?? 0) >= 1;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `submit-button-details form-element-details-wrapper ${hasValidationErrors ? 'form-validation-errors' : ''}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "form-element-type-details",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                        className: "form-element-label-text",
                        onClick: onEditClick,
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') onEditClick();
                        },
                        children: submitButtonText
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "element-type-text",
                        children: `(${type})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6fdd0991e8159fdf$export$2e2bcd8739ae039), {
                ariaLabel: `Edit ${type} Text`,
                className: 'icon-button-squared control-button',
                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).PENCIL,
                onButtonClick: onEditClick
            })
        ]
    });
};
var $b6d8af8f2581d5fa$export$2e2bcd8739ae039 = $b6d8af8f2581d5fa$var$SubmitButtonDetails;


const $573a796474fc699f$var$FormButtonElement = ({ submitButtonText: submitButtonText, setSubmitButtonText: setSubmitButtonText, validationErrors: validationErrors, formButtonType: formButtonType })=>{
    const [isEditMode, setIsEditMode] = (0, $aqdBs.useState)(false);
    return isEditMode ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2014190ade5a3ba1$export$2e2bcd8739ae039), {
        type: formButtonType,
        placeholderText: "Enter your text here",
        submitButtonText: submitButtonText,
        setSubmitButtonText: setSubmitButtonText,
        onContinueClick: ()=>setIsEditMode(false),
        validationErrors: validationErrors
    }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $b6d8af8f2581d5fa$export$2e2bcd8739ae039), {
        type: formButtonType,
        submitButtonText: submitButtonText,
        onEditClick: ()=>setIsEditMode(true),
        validationErrors: validationErrors
    });
};
var $573a796474fc699f$export$2e2bcd8739ae039 = $573a796474fc699f$var$FormButtonElement;




var $aqdBs = parcelRequire("aqdBs");



parcelRequire("aqdBs");

const $9555c36064c6b392$var$BasicFormElementModal = ({ headerText: headerText, questionText: questionText, onCloseClick: onCloseClick, onConfirmClick: onConfirmClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $11aea663cfdf3032$export$2e2bcd8739ae039), {
        className: "form-builder-modal",
        isAlertStyle: true,
        headerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: "form-builder-modal-header",
            children: headerText
        }),
        bodyContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: "form-builder-modal-question",
            children: questionText
        }),
        onCloseClick: onCloseClick,
        cancelButtonText: "Cancel",
        cancelButtonAriaLabel: "Cancel and close modal",
        confirmButtonText: "Confirm",
        confirmButtonAriaLabel: "Confirm and close modal",
        onCancelClick: onCloseClick,
        onConfirmClick: onConfirmClick
    });
};
var $9555c36064c6b392$export$2e2bcd8739ae039 = $9555c36064c6b392$var$BasicFormElementModal;




const $789d380f7cb8cbc1$var$FormElementWidget = ({ elementType: elementType, labelText: labelText, setLabelText: setLabelText, formElementId: formElementId, isRequiredElement: isRequiredElement, conditionalCheckboxPanel: conditionalCheckboxPanel, onSaveClick: onSaveClick, onDeleteElementClick: onDeleteElementClick, onDragElementClick: onDragElementClick, formElementComponent: formElementComponent, isFirstElement: isFirstElement, isLastElement: isLastElement, onMoveElementDown: onMoveElementDown, onMoveElementUp: onMoveElementUp, isEditModeOpen: isEditModeOpen, setIsEditModeOpen: setIsEditModeOpen, rulesComponent: rulesComponent, advancedOptions: advancedOptions, validationErrors: validationErrors, index: index })=>{
    const [showDeleteModal, setShowDeleteModal] = (0, $aqdBs.useState)(false);
    const ref = (0, $aqdBs.useRef)(null);
    // Drag
    const [{ isDragging: isDragging }, drag] = (0, $4de504bcfcc89199$export$7941f8aafa4b6021)({
        type: 'FormWidget',
        item: {
            index: index
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            }),
        end: ()=>{}
    });
    // Drop
    const [{ isOver: isOver }, drop] = (0, $7f734ad0ca199756$export$ccdee5eaf73cf661)({
        accept: 'FormWidget',
        hover (item, monitor) {
            if (!ref.current) return;
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) return;
            const hoverRect = ref.current.getBoundingClientRect();
            const hoverMiddleY = (hoverRect.bottom - hoverRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverRect.top;
            // Only trigger move when cursor crosses halfway
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
            onDragElementClick?.(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
        collect: (monitor)=>({
                isOver: monitor.isOver()
            })
    });
    // Attach both
    drop(ref);
    // Cursor styling
    (0, $aqdBs.useEffect)(()=>{
        if (isDragging) document.body.classList.add('is-dragging-cursor');
        else document.body.classList.remove('is-dragging-cursor');
        return ()=>document.body.classList.remove('is-dragging-cursor');
    }, [
        isDragging
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `form-element-wrapper ${isDragging && "is-hovering"}  ${isOver && "is-dragging"}`,
        ref: ref,
        children: [
            isEditModeOpen ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $91998629ce5d1fb0$export$2e2bcd8739ae039), {
                elementType: elementType,
                labelText: labelText,
                setLabelText: setLabelText,
                isRequiredElement: isRequiredElement,
                formElementId: formElementId,
                formElementComponent: formElementComponent,
                isFirstElement: isFirstElement,
                isLastElement: isLastElement,
                onMoveElementUp: onMoveElementUp,
                onMoveElementDown: onMoveElementDown,
                rulesComponent: rulesComponent,
                onDeleteElementClick: ()=>setShowDeleteModal(true),
                onSaveClick: onSaveClick,
                conditionalCheckboxPanel: conditionalCheckboxPanel,
                advancedOptions: advancedOptions,
                validationErrors: validationErrors
            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $86bf147a286ef1e8$export$2e2bcd8739ae039), {
                elementType: elementType,
                labelText: labelText || "INCOMPLETED ELEMENT",
                isRequiredElement: isRequiredElement,
                onDeleteElementClick: ()=>setShowDeleteModal(true),
                onEditElementClick: ()=>setIsEditModeOpen?.(),
                dragRef: drag,
                validationErrors: validationErrors
            }),
            showDeleteModal && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $9555c36064c6b392$export$2e2bcd8739ae039), {
                headerText: 'Delete form field',
                questionText: 'Are you sure you want to delete this form field?',
                onCloseClick: ()=>setShowDeleteModal(false),
                onConfirmClick: ()=>{
                    setShowDeleteModal(false);
                    onDeleteElementClick();
                }
            })
        ]
    }, `formElement-${formElementId}`);
};
var $789d380f7cb8cbc1$export$2e2bcd8739ae039 = $789d380f7cb8cbc1$var$FormElementWidget;




var $aqdBs = parcelRequire("aqdBs");

const $500fafd599874c84$var$AdditionOptionsContainer = ({ defaultAdvancedSettings: defaultAdvancedSettings = false, children: children })=>{
    const [showAdvancedOptions, setShowAdvancedOptions] = (0, $aqdBs.useState)(defaultAdvancedSettings);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "collapsable-options-container",
        children: [
            showAdvancedOptions && children,
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f7032d897ddf6dfe$export$2e2bcd8739ae039), {
                showAdvancedOptions: showAdvancedOptions,
                setShowAdvancedOptions: ()=>setShowAdvancedOptions(!showAdvancedOptions)
            })
        ]
    });
};
var $500fafd599874c84$export$2e2bcd8739ae039 = $500fafd599874c84$var$AdditionOptionsContainer;




parcelRequire("aqdBs");


const $3f801bf0f4145175$var$FormElementListWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d90be0009da8926e$export$9861489d68213f9c), {
        backend: (0, $1f1d51a0d4192edb$export$b4d0180dbe086f87),
        options: {
            enableMouseEvents: true
        },
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: "form-builder-wrapper",
            children: children
        })
    });
};
var $3f801bf0f4145175$export$2e2bcd8739ae039 = $3f801bf0f4145175$var$FormElementListWrapper;



parcelRequire("aqdBs");



const $d7fff4c179f916d6$var$ConditionalEmailPanel = ({ emailTextInput: emailTextInput, setEmailTextInput: setEmailTextInput, handleAddEmailClick: handleAddEmailClick, children: children, title: title, emailRecipientsList: emailRecipientsList, removeEmailFromList: removeEmailFromList, className: className })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `conditional-email-wrapper conditional-logic-panel ${className ?? ''}`,
        children: [
            children,
            title && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "recipients-panel",
                children: emailRecipientsList.map((email, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $24574102f99226d2$export$2e2bcd8739ae039), {
                        content: email,
                        closeAriaLabel: `Remove ${email} from recipients`,
                        onButtonClick: ()=>removeEmailFromList(email)
                    }, `${email}-${index}`))
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3589b82d99d444aa$export$2e2bcd8739ae039), {
                className: "form-settings-email-input",
                id: "form-settings-email-input",
                labelText: "Insert Email Address",
                labelIsHidden: true,
                placeholderText: "E.g. name@company.com",
                setTextString: setEmailTextInput,
                textString: emailTextInput,
                buttonContent: "Add Email",
                onButtonClick: handleAddEmailClick
            })
        ]
    });
};
var $d7fff4c179f916d6$export$2e2bcd8739ae039 = $d7fff4c179f916d6$var$ConditionalEmailPanel;



parcelRequire("aqdBs");
const $cbe1b71c8029194e$var$BasicBreadcrumbs = ({ breadCrumbs: breadCrumbs })=>{
    if (!breadCrumbs.length) return null;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("nav", {
        id: "basic-breadcrumb-container",
        className: "basic-breadcrumb-container",
        "aria-label": "Navigate through the nested content",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("ol", {
            className: "basic-breadcrumb-list",
            children: breadCrumbs.map((crumb, index)=>{
                const isLast = index === breadCrumbs.length - 1;
                return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("li", {
                    className: "basic-breadcrumb-item",
                    children: isLast ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        "aria-current": "page",
                        className: "basic-breadcrumb-title",
                        children: crumb.title
                    }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                type: "button",
                                className: "basic-breadcrumb-button",
                                onClick: ()=>{
                                    crumb.onClick?.();
                                    if (crumb.url) window.location.href = crumb.url;
                                },
                                children: crumb.title
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                className: "basic-breadcrumb-chevron",
                                children: " \u203A "
                            })
                        ]
                    })
                }, index);
            })
        })
    });
};
var $cbe1b71c8029194e$export$2e2bcd8739ae039 = $cbe1b71c8029194e$var$BasicBreadcrumbs;



parcelRequire("aqdBs");
const $79563d007d2277a3$var$MinimalBreadcrumb = ({ currentStep: currentStep, totalSteps: totalSteps })=>{
    const steps = Array.from({
        length: totalSteps
    }, (_, i)=>i + 1);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "minimal-breadcrumb",
        children: steps.map((step)=>{
            let className = "";
            if (step < currentStep) className = "completed-step";
            else if (step === currentStep) className = "current-step";
            else className = "not-started-breadcrumb";
            return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                "data-testid": "minimal-breadcrumb",
                className: `breadcrumb-step ${className}`
            }, step);
        })
    });
};
var $79563d007d2277a3$export$2e2bcd8739ae039 = $79563d007d2277a3$var$MinimalBreadcrumb;




var $aqdBs = parcelRequire("aqdBs");

const $80e8adf065685a4b$export$b81307378eaf5d41 = ({ showToast: showToast = true, closeToast: closeToast, toastOptions: toastOptions, children: children })=>{
    (0, $aqdBs.useEffect)(()=>{
        if (showToast) setTimeout(()=>{
            closeToast();
            toastOptions?.toastCompletionCallback?.();
        }, 5000);
    }, [
        showToast
    ]);
    if (!showToast) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {});
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "tcl-toast-wrapper",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: `tcl-toast ${toastOptions?.type}`,
            children: [
                !!toastOptions?.icon && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                            iconName: toastOptions?.icon,
                            sizeInPx: "20",
                            color: "var(--thriveWhite)"
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    children: children
                })
            ]
        })
    });
};



var $aqdBs = parcelRequire("aqdBs");
const $2fe82a700229b9d4$var$useCountDown = ({ initialValue: initialValue, tickInSeconds: tickInSeconds, onCountdownComplete: onCountdownComplete, startCountDown: startCountDown = true })=>{
    const [timer, setTimer] = (0, $aqdBs.useState)(initialValue);
    const timeoutRef = (0, $aqdBs.useRef)(0);
    function cleanUp() {
        if (timeoutRef.current) {
            clearInterval(timeoutRef.current);
            timeoutRef.current = null;
        }
    }
    (0, $aqdBs.useEffect)(()=>{
        if (!startCountDown) return ()=>{
            cleanUp();
        };
        if (timeoutRef.current) clearInterval(timeoutRef.current);
        if (timer <= 0) {
            onCountdownComplete?.();
            return ()=>{
                cleanUp();
            };
        }
        timeoutRef.current = setTimeout(()=>{
            setTimer(timer - 1);
        }, tickInSeconds * 1000);
        return ()=>{
            cleanUp();
        };
    }, [
        timer,
        startCountDown
    ]);
    (0, $aqdBs.useEffect)(()=>{
        setTimer(initialValue);
    }, [
        initialValue
    ]);
    return timer;
};
var $2fe82a700229b9d4$export$2e2bcd8739ae039 = $2fe82a700229b9d4$var$useCountDown;



parcelRequire("aqdBs");


const $8ec5087727f1768e$var$SearchBarButton = ({ isDisabled: isDisabled, onClickButton: onClickButton, buttonLabel: buttonLabel, iconColor: iconColor })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        id: "thrive-component-search-bar-button",
        className: "thrive-component-search-bar-button",
        type: "button",
        onClick: onClickButton,
        "aria-label": buttonLabel,
        disabled: isDisabled,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
            iconName: (0, $99899ff752f57db8$export$356109f9df11377f).SEARCH_GLASS,
            color: `${iconColor ?? "var(--thriveWhite)"}`,
            sizeInPx: "28"
        })
    });
};
var $8ec5087727f1768e$export$2e2bcd8739ae039 = $8ec5087727f1768e$var$SearchBarButton;



parcelRequire("aqdBs");
const $c110b1a577dc0fea$var$SearchBarInput = ({ placeholderText: placeholderText, ariaLabel: ariaLabel, searchInput: searchInput, setSearchInput: setSearchInput, handleKeyDown: handleKeyDown })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
        id: "thrive-component-search-bar-input",
        className: "thrive-component-search-bar-input",
        type: "text",
        placeholder: placeholderText,
        autoComplete: "off",
        "aria-label": ariaLabel,
        value: searchInput,
        onChange: (e)=>setSearchInput(e.target.value),
        onKeyDown: handleKeyDown
    });
};
var $c110b1a577dc0fea$export$2e2bcd8739ae039 = $c110b1a577dc0fea$var$SearchBarInput;



parcelRequire("aqdBs");


const $5a4c56672dbf2c51$var$SearchBar = ({ className: className = "", placeholderText: placeholderText, ariaLabel: ariaLabel, searchInput: searchInput, setSearchInput: setSearchInput, onClickSearch: onClickSearch, buttonLabel: buttonLabel, buttonIconColor: buttonIconColor })=>{
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") onClickSearch();
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `thrive-component-search-bar-wrapper ${className}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c110b1a577dc0fea$export$2e2bcd8739ae039), {
                placeholderText: placeholderText,
                ariaLabel: ariaLabel,
                searchInput: searchInput,
                setSearchInput: setSearchInput,
                handleKeyDown: handleKeyDown
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $8ec5087727f1768e$export$2e2bcd8739ae039), {
                onClickButton: onClickSearch,
                buttonLabel: buttonLabel,
                iconColor: buttonIconColor
            })
        ]
    });
};
var $5a4c56672dbf2c51$export$2e2bcd8739ae039 = $5a4c56672dbf2c51$var$SearchBar;





var $994acc88dfceac67$export$46542447417a4445 = /*#__PURE__*/ function(SignUpSteps) {
    SignUpSteps["ONBOARDING"] = "ONBOARDING";
    SignUpSteps["DETAILS"] = "DETAILS";
    SignUpSteps["DESIGN"] = "DESIGN";
    SignUpSteps["DOWNLOAD"] = "DOWNLOAD";
    SignUpSteps["REDIRECTOR"] = "REDIRECTOR";
    return SignUpSteps;
}({});
const $994acc88dfceac67$export$5edc7b7ed75aa907 = {
    ["ONBOARDING"]: "/self-serve-onboarding",
    ["DETAILS"]: "/self-serve-details",
    ["DESIGN"]: "/self-serve-design",
    ["DOWNLOAD"]: "/self-serve-download",
    ["REDIRECTOR"]: "/app-store-redirector"
};
const $994acc88dfceac67$export$91296963ba4f2238 = 4;



var $aqdBs = parcelRequire("aqdBs");
/*
	we pass the observable into the hook
	and initialise state with the observable values
*/ function $32faeec8c8ee057e$var$useObservable(observable) {
    const [state, setState] = (0, $aqdBs.useState)(observable.value);
    (0, $aqdBs.useEffect)(()=>{
        const setValueFromObservable = (value)=>{
            setState(value);
        };
        observable.subscribe(setValueFromObservable);
        return ()=>{
            observable.unsubscribe(setValueFromObservable);
        };
    }, [
        observable
    ]); // include observable as dependency
    return state;
}
var $32faeec8c8ee057e$export$2e2bcd8739ae039 = $32faeec8c8ee057e$var$useObservable;


function $49df3a8477bb0a2a$export$77cea355fa80b5f4(initialValue) {
    /* 
	   our observable maintains its own value, as well as an array of any
	   functions 'subscribed' to it, it will fire all these functions later
	*/ let value = initialValue;
    let subscribers = [];
    /* when we subscribe we add a new function to this array*/ const subscribe = (subscriber)=>{
        subscribers = [
            ...subscribers,
            subscriber
        ];
    };
    /* when we unsub we remove the function from the array*/ const unsubscribe = (subscriber)=>{
        subscribers = subscribers.filter((fn)=>fn !== subscriber);
    };
    const update = (updater)=>{
        /*
	    if we pass a function as an updater we run that function, otherwise we set 
	    the value i.e. you could pass something like (value) => value.toUpperCase()
	    if for whatever reason you wanted to update a string to uppercase, or you
	    can just pass it a value. Once it sets the value it runs all the subscribed function
	    with the new value
	    */ if (updater instanceof Function) value = updater(value);
        else value = updater;
        subscribers?.forEach((subscriber)=>subscriber(value));
    };
    /*
			we return a readonly version of the observable to make the code more secure
		*/ return Object.freeze({
        get value () {
            return value;
        },
        update: update,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    });
}





const $829cfafaa485b58a$export$186758cd0f27e996 = {
    isLightColor: $829cfafaa485b58a$export$94fcbb60fb75553c,
    hexToRgba: $829cfafaa485b58a$export$9665a07d9187b414
};
function $829cfafaa485b58a$export$94fcbb60fb75553c(hex) {
    const rgba = $829cfafaa485b58a$var$parseHex(hex);
    if (!rgba) return false;
    if (rgba.alpha <= 0) return true;
    return $829cfafaa485b58a$var$srgbLuma(rgba) > 0.673;
}
function $829cfafaa485b58a$export$9665a07d9187b414(hex, manualOpacity) {
    const rgba = $829cfafaa485b58a$var$parseHex(hex);
    if (!rgba) throw new Error("Invalid hex color");
    if (manualOpacity !== undefined) rgba.alpha = Math.round(manualOpacity * 255);
    return rgba;
}
function $829cfafaa485b58a$var$parseHex(hex) {
    let cleaned = hex.replace("#", "");
    if (cleaned.length === 3) cleaned = cleaned.split("").map((c)=>c + c).join("");
    if (cleaned.length !== 6 && cleaned.length !== 8) return null;
    const r = parseInt(cleaned.substring(0, 2), 16);
    const g = parseInt(cleaned.substring(2, 4), 16);
    const b = parseInt(cleaned.substring(4, 6), 16);
    const a = cleaned.length === 8 ? parseInt(cleaned.substring(6, 8), 16) : 255;
    return {
        red: r,
        green: g,
        blue: b,
        alpha: a
    };
}
function $829cfafaa485b58a$var$srgbLuma(c) {
    return (0.2126 * c.red + 0.7152 * c.green + 0.0722 * c.blue) / 255;
}



class $c9048c433f8ddaa9$export$64455f3371ee8fd6 {
    currentStep = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)((0, $994acc88dfceac67$export$46542447417a4445).ONBOARDING);
    cmsUrl = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(null);
    createAppForm = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(null);
    //app style and content
    colour = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)('203554');
    fontColour = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("#ffffff");
    appName = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("Welcome! \uD83C\uDF8A");
    orgShortName = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    contentTiles = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)([]);
    code = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    checkIfUserIsVerified() {
        return !!this.code?.value;
    }
    setUpdateCode(code) {
        this.code.update(code);
        this.createAppForm.update((current)=>({
                ...current ?? {},
                code: code
            }));
    }
    getCurrentStep() {
        return this.currentStep.value;
    }
    setCurrentStep = (step)=>{
        this.currentStep.update(step);
    };
    getCmsLink() {
        return this.cmsUrl?.value ?? null;
    }
    setAppName = (name)=>{
        this.appName.update(name);
        this.createAppForm.update((current)=>({
                ...current ?? {},
                appName: name
            }));
    };
    setOrgShortName = (name)=>{
        this.orgShortName.update(name);
        this.createAppForm.update((current)=>({
                ...current ?? {},
                orgShortName: name
            }));
    };
    updateContentTiles = (content)=>{
        const fallbackContent = content ?? [];
        this.contentTiles.update(fallbackContent);
        const orderedIds = fallbackContent.map((tile)=>tile.id);
        this.createAppForm.update((current)=>({
                ...current ?? {},
                orderedContentIds: orderedIds
            }));
    };
    saveUserDetailsToForm = (formData)=>{
        this.createAppForm.update((current)=>({
                ...current ?? {},
                ...formData
            }));
    };
    updateCmsUrl = (cmsUrl)=>{
        this.cmsUrl.update(cmsUrl);
    };
    setColour = (color)=>{
        this.colour.update(color);
        const isLight = (0, $829cfafaa485b58a$export$94fcbb60fb75553c)(color);
        this.fontColour.update(isLight ? "#343D4C" : "#ffffff");
        this.createAppForm.update((current)=>({
                ...current ?? {},
                themeHex: `#${color}`
            }));
    };
}
const $c9048c433f8ddaa9$export$17c3d14100f89581 = new $c9048c433f8ddaa9$export$64455f3371ee8fd6();



const $c133cb7ba0384653$var$NavBar = ({})=>{
    const currentStep = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)((0, $c9048c433f8ddaa9$export$17c3d14100f89581).currentStep);
    const stepValues = Object.values((0, $994acc88dfceac67$export$46542447417a4445));
    const currentStepNumber = stepValues.indexOf(currentStep);
    //onrefresh of page this will ensure correct breadcrumb is shown
    (0, $aqdBs.useEffect)(()=>{
        const step = Object.keys((0, $994acc88dfceac67$export$5edc7b7ed75aa907)).find((key)=>(0, $994acc88dfceac67$export$5edc7b7ed75aa907)[key] === location.pathname);
        if (step) (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setCurrentStep(step);
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "nav-bar",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $8f626dbc4ca855b7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $79563d007d2277a3$export$2e2bcd8739ae039), {
                currentStep: currentStepNumber + 1,
                totalSteps: (0, $994acc88dfceac67$export$91296963ba4f2238)
            })
        ]
    });
};
var $c133cb7ba0384653$export$2e2bcd8739ae039 = $c133cb7ba0384653$var$NavBar;




var $aqdBs = parcelRequire("aqdBs");
var $e1c9151c0619a5ff$export$2332bccde38c8493 = /*#__PURE__*/ function(IENVIRONMENT) {
    IENVIRONMENT["QA"] = "QA";
    IENVIRONMENT["PRODUCTION"] = "PRODUCTION";
    IENVIRONMENT["LOCAL"] = "LOCAL";
    IENVIRONMENT["FEATURE"] = "FEATURE";
    return IENVIRONMENT;
}({});
class $e1c9151c0619a5ff$var$EnvService {
    ENVIRONMENT = undefined;
    FEATURENAME = undefined;
}
const $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3 = new $e1c9151c0619a5ff$var$EnvService();


'use strict';
function $b1693a4c864a9984$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $78ee239a048a0eda$var$toString } = Object.prototype;
const { getPrototypeOf: $78ee239a048a0eda$var$getPrototypeOf } = Object;
const { iterator: $78ee239a048a0eda$var$iterator, toStringTag: $78ee239a048a0eda$var$toStringTag } = Symbol;
const $78ee239a048a0eda$var$kindOf = ((cache)=>(thing)=>{
        const str = $78ee239a048a0eda$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $78ee239a048a0eda$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$78ee239a048a0eda$var$kindOf(thing) === type;
};
const $78ee239a048a0eda$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $78ee239a048a0eda$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $78ee239a048a0eda$var$isUndefined = $78ee239a048a0eda$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $78ee239a048a0eda$var$isBuffer(val) {
    return val !== null && !$78ee239a048a0eda$var$isUndefined(val) && val.constructor !== null && !$78ee239a048a0eda$var$isUndefined(val.constructor) && $78ee239a048a0eda$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $78ee239a048a0eda$var$isArrayBuffer = $78ee239a048a0eda$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $78ee239a048a0eda$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $78ee239a048a0eda$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $78ee239a048a0eda$var$isString = $78ee239a048a0eda$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $78ee239a048a0eda$var$isFunction = $78ee239a048a0eda$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $78ee239a048a0eda$var$isNumber = $78ee239a048a0eda$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $78ee239a048a0eda$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $78ee239a048a0eda$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $78ee239a048a0eda$var$isPlainObject = (val)=>{
    if ($78ee239a048a0eda$var$kindOf(val) !== 'object') return false;
    const prototype = $78ee239a048a0eda$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($78ee239a048a0eda$var$toStringTag in val) && !($78ee239a048a0eda$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $78ee239a048a0eda$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$78ee239a048a0eda$var$isObject(val) || $78ee239a048a0eda$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $78ee239a048a0eda$var$isDate = $78ee239a048a0eda$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $78ee239a048a0eda$var$isFile = $78ee239a048a0eda$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $78ee239a048a0eda$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $78ee239a048a0eda$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $78ee239a048a0eda$var$isBlob = $78ee239a048a0eda$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $78ee239a048a0eda$var$isFileList = $78ee239a048a0eda$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $78ee239a048a0eda$var$isStream = (val)=>$78ee239a048a0eda$var$isObject(val) && $78ee239a048a0eda$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $78ee239a048a0eda$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $78ee239a048a0eda$var$G = $78ee239a048a0eda$var$getGlobal();
const $78ee239a048a0eda$var$FormDataCtor = typeof $78ee239a048a0eda$var$G.FormData !== 'undefined' ? $78ee239a048a0eda$var$G.FormData : undefined;
const $78ee239a048a0eda$var$isFormData = (thing)=>{
    let kind;
    return thing && ($78ee239a048a0eda$var$FormDataCtor && thing instanceof $78ee239a048a0eda$var$FormDataCtor || $78ee239a048a0eda$var$isFunction(thing.append) && ((kind = $78ee239a048a0eda$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $78ee239a048a0eda$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $78ee239a048a0eda$var$isURLSearchParams = $78ee239a048a0eda$var$kindOfTest('URLSearchParams');
const [$78ee239a048a0eda$var$isReadableStream, $78ee239a048a0eda$var$isRequest, $78ee239a048a0eda$var$isResponse, $78ee239a048a0eda$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($78ee239a048a0eda$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $78ee239a048a0eda$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $78ee239a048a0eda$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($78ee239a048a0eda$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($78ee239a048a0eda$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $78ee239a048a0eda$var$findKey(obj, key) {
    if ($78ee239a048a0eda$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $78ee239a048a0eda$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $78ee239a048a0eda$var$isContextDefined = (context)=>!$78ee239a048a0eda$var$isUndefined(context) && context !== $78ee239a048a0eda$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $78ee239a048a0eda$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $78ee239a048a0eda$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $78ee239a048a0eda$var$findKey(result, key) || key;
        if ($78ee239a048a0eda$var$isPlainObject(result[targetKey]) && $78ee239a048a0eda$var$isPlainObject(val)) result[targetKey] = $78ee239a048a0eda$var$merge(result[targetKey], val);
        else if ($78ee239a048a0eda$var$isPlainObject(val)) result[targetKey] = $78ee239a048a0eda$var$merge({}, val);
        else if ($78ee239a048a0eda$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$78ee239a048a0eda$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $78ee239a048a0eda$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $78ee239a048a0eda$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $78ee239a048a0eda$var$forEach(b, (val, key)=>{
        if (thisArg && $78ee239a048a0eda$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $b1693a4c864a9984$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $78ee239a048a0eda$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $78ee239a048a0eda$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $78ee239a048a0eda$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $78ee239a048a0eda$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $78ee239a048a0eda$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $78ee239a048a0eda$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($78ee239a048a0eda$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$78ee239a048a0eda$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $78ee239a048a0eda$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $78ee239a048a0eda$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $78ee239a048a0eda$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$78ee239a048a0eda$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $78ee239a048a0eda$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $78ee239a048a0eda$var$isHTMLForm = $78ee239a048a0eda$var$kindOfTest('HTMLFormElement');
const $78ee239a048a0eda$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $78ee239a048a0eda$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $78ee239a048a0eda$var$isRegExp = $78ee239a048a0eda$var$kindOfTest('RegExp');
const $78ee239a048a0eda$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $78ee239a048a0eda$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $78ee239a048a0eda$var$freezeMethods = (obj)=>{
    $78ee239a048a0eda$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($78ee239a048a0eda$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$78ee239a048a0eda$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $78ee239a048a0eda$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $78ee239a048a0eda$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $78ee239a048a0eda$var$noop = ()=>{};
const $78ee239a048a0eda$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $78ee239a048a0eda$var$isSpecCompliantForm(thing) {
    return !!(thing && $78ee239a048a0eda$var$isFunction(thing.append) && thing[$78ee239a048a0eda$var$toStringTag] === 'FormData' && thing[$78ee239a048a0eda$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $78ee239a048a0eda$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($78ee239a048a0eda$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($78ee239a048a0eda$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $78ee239a048a0eda$var$isArray(source) ? [] : {};
                $78ee239a048a0eda$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$78ee239a048a0eda$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $78ee239a048a0eda$var$isAsyncFn = $78ee239a048a0eda$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $78ee239a048a0eda$var$isThenable = (thing)=>thing && ($78ee239a048a0eda$var$isObject(thing) || $78ee239a048a0eda$var$isFunction(thing)) && $78ee239a048a0eda$var$isFunction(thing.then) && $78ee239a048a0eda$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $78ee239a048a0eda$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $78ee239a048a0eda$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $78ee239a048a0eda$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $78ee239a048a0eda$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $78ee239a048a0eda$var$isFunction($78ee239a048a0eda$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $78ee239a048a0eda$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($78ee239a048a0eda$var$_global) : $78ee239a048a0eda$var$_setImmediate;
// *********************
const $78ee239a048a0eda$var$isIterable = (thing)=>thing != null && $78ee239a048a0eda$var$isFunction(thing[$78ee239a048a0eda$var$iterator]);
var $78ee239a048a0eda$export$2e2bcd8739ae039 = {
    isArray: $78ee239a048a0eda$var$isArray,
    isArrayBuffer: $78ee239a048a0eda$var$isArrayBuffer,
    isBuffer: $78ee239a048a0eda$var$isBuffer,
    isFormData: $78ee239a048a0eda$var$isFormData,
    isArrayBufferView: $78ee239a048a0eda$var$isArrayBufferView,
    isString: $78ee239a048a0eda$var$isString,
    isNumber: $78ee239a048a0eda$var$isNumber,
    isBoolean: $78ee239a048a0eda$var$isBoolean,
    isObject: $78ee239a048a0eda$var$isObject,
    isPlainObject: $78ee239a048a0eda$var$isPlainObject,
    isEmptyObject: $78ee239a048a0eda$var$isEmptyObject,
    isReadableStream: $78ee239a048a0eda$var$isReadableStream,
    isRequest: $78ee239a048a0eda$var$isRequest,
    isResponse: $78ee239a048a0eda$var$isResponse,
    isHeaders: $78ee239a048a0eda$var$isHeaders,
    isUndefined: $78ee239a048a0eda$var$isUndefined,
    isDate: $78ee239a048a0eda$var$isDate,
    isFile: $78ee239a048a0eda$var$isFile,
    isReactNativeBlob: $78ee239a048a0eda$var$isReactNativeBlob,
    isReactNative: $78ee239a048a0eda$var$isReactNative,
    isBlob: $78ee239a048a0eda$var$isBlob,
    isRegExp: $78ee239a048a0eda$var$isRegExp,
    isFunction: $78ee239a048a0eda$var$isFunction,
    isStream: $78ee239a048a0eda$var$isStream,
    isURLSearchParams: $78ee239a048a0eda$var$isURLSearchParams,
    isTypedArray: $78ee239a048a0eda$var$isTypedArray,
    isFileList: $78ee239a048a0eda$var$isFileList,
    forEach: $78ee239a048a0eda$var$forEach,
    merge: $78ee239a048a0eda$var$merge,
    extend: $78ee239a048a0eda$var$extend,
    trim: $78ee239a048a0eda$var$trim,
    stripBOM: $78ee239a048a0eda$var$stripBOM,
    inherits: $78ee239a048a0eda$var$inherits,
    toFlatObject: $78ee239a048a0eda$var$toFlatObject,
    kindOf: $78ee239a048a0eda$var$kindOf,
    kindOfTest: $78ee239a048a0eda$var$kindOfTest,
    endsWith: $78ee239a048a0eda$var$endsWith,
    toArray: $78ee239a048a0eda$var$toArray,
    forEachEntry: $78ee239a048a0eda$var$forEachEntry,
    matchAll: $78ee239a048a0eda$var$matchAll,
    isHTMLForm: $78ee239a048a0eda$var$isHTMLForm,
    hasOwnProperty: $78ee239a048a0eda$var$hasOwnProperty,
    hasOwnProp: $78ee239a048a0eda$var$hasOwnProperty,
    reduceDescriptors: $78ee239a048a0eda$var$reduceDescriptors,
    freezeMethods: $78ee239a048a0eda$var$freezeMethods,
    toObjectSet: $78ee239a048a0eda$var$toObjectSet,
    toCamelCase: $78ee239a048a0eda$var$toCamelCase,
    noop: $78ee239a048a0eda$var$noop,
    toFiniteNumber: $78ee239a048a0eda$var$toFiniteNumber,
    findKey: $78ee239a048a0eda$var$findKey,
    global: $78ee239a048a0eda$var$_global,
    isContextDefined: $78ee239a048a0eda$var$isContextDefined,
    isSpecCompliantForm: $78ee239a048a0eda$var$isSpecCompliantForm,
    toJSONObject: $78ee239a048a0eda$var$toJSONObject,
    isAsyncFn: $78ee239a048a0eda$var$isAsyncFn,
    isThenable: $78ee239a048a0eda$var$isThenable,
    setImmediate: $78ee239a048a0eda$var$_setImmediate,
    asap: $78ee239a048a0eda$var$asap,
    isIterable: $78ee239a048a0eda$var$isIterable
};







'use strict';
class $9e5fe95990c915ca$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $9e5fe95990c915ca$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $78ee239a048a0eda$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$9e5fe95990c915ca$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$9e5fe95990c915ca$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$9e5fe95990c915ca$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$9e5fe95990c915ca$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$9e5fe95990c915ca$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$9e5fe95990c915ca$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$9e5fe95990c915ca$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$9e5fe95990c915ca$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$9e5fe95990c915ca$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$9e5fe95990c915ca$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$9e5fe95990c915ca$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$9e5fe95990c915ca$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $9e5fe95990c915ca$export$2e2bcd8739ae039 = $9e5fe95990c915ca$var$AxiosError;


// eslint-disable-next-line strict
var $ec5c5cd9bd9cd9f3$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf);
    else return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $4a6eda7d0e4e0857$export$d622b2ad8d90c771($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $0996803aa5c1f80e$require$Buffer = $8dff54558831dec9$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $0996803aa5c1f80e$var$isVisitable(thing) {
    return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $0996803aa5c1f80e$var$removeBrackets(key) {
    return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $0996803aa5c1f80e$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $0996803aa5c1f80e$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $0996803aa5c1f80e$var$isFlatArray(arr) {
    return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(arr) && !arr.some($0996803aa5c1f80e$var$isVisitable);
}
const $0996803aa5c1f80e$var$predicates = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).toFlatObject((0, $78ee239a048a0eda$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $0996803aa5c1f80e$var$toFormData(obj, formData, options) {
    if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $ec5c5cd9bd9cd9f3$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $0996803aa5c1f80e$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isReactNative(formData) && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($0996803aa5c1f80e$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(value) && $0996803aa5c1f80e$var$isFlatArray(value) || ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFileList(value) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $0996803aa5c1f80e$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $0996803aa5c1f80e$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($0996803aa5c1f80e$var$isVisitable(value)) return true;
        formData.append($0996803aa5c1f80e$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($0996803aa5c1f80e$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $0996803aa5c1f80e$var$isVisitable
    });
    function build(value, path) {
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $0996803aa5c1f80e$export$2e2bcd8739ae039 = $0996803aa5c1f80e$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $63bdd9686cd7accf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $63bdd9686cd7accf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $0996803aa5c1f80e$export$2e2bcd8739ae039)(params, this, options);
}
const $63bdd9686cd7accf$var$prototype = $63bdd9686cd7accf$var$AxiosURLSearchParams.prototype;
$63bdd9686cd7accf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$63bdd9686cd7accf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $63bdd9686cd7accf$var$encode);
    } : $63bdd9686cd7accf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $63bdd9686cd7accf$export$2e2bcd8739ae039 = $63bdd9686cd7accf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $f416296b3684bfa6$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $f416296b3684bfa6$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $f416296b3684bfa6$var$encode;
    const _options = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $63bdd9686cd7accf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $7a952e03d12bfe59$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $7a952e03d12bfe59$export$2e2bcd8739ae039 = $7a952e03d12bfe59$var$InterceptorManager;





'use strict';
var $fde4b154a795581d$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $c1862ed3ae746000$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $63bdd9686cd7accf$export$2e2bcd8739ae039);


'use strict';
var $a3a31ddcdde13748$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $319a0c913db6247d$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $f0d0803e3c7cd90e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $c1862ed3ae746000$export$2e2bcd8739ae039,
        FormData: $a3a31ddcdde13748$export$2e2bcd8739ae039,
        Blob: $319a0c913db6247d$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $4349a8907b58cae3$exports = {};

$parcel$export($4349a8907b58cae3$exports, "hasBrowserEnv", () => $4349a8907b58cae3$export$c4996c4b7b93b0bf);
$parcel$export($4349a8907b58cae3$exports, "navigator", () => $4349a8907b58cae3$export$ec7c8efa7f5790ae);
$parcel$export($4349a8907b58cae3$exports, "hasStandardBrowserEnv", () => $4349a8907b58cae3$export$c0bcc9250309d66);
$parcel$export($4349a8907b58cae3$exports, "hasStandardBrowserWebWorkerEnv", () => $4349a8907b58cae3$export$c81692cf5af97dac);
$parcel$export($4349a8907b58cae3$exports, "origin", () => $4349a8907b58cae3$export$f710a83a91838a36);
const $4349a8907b58cae3$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $4349a8907b58cae3$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $4349a8907b58cae3$export$c0bcc9250309d66 = $4349a8907b58cae3$export$c4996c4b7b93b0bf && (!$4349a8907b58cae3$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($4349a8907b58cae3$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $4349a8907b58cae3$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $4349a8907b58cae3$export$f710a83a91838a36 = $4349a8907b58cae3$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $416ace012c072a43$export$2e2bcd8739ae039 = {
    ...$4349a8907b58cae3$exports,
    ...(0, $f0d0803e3c7cd90e$export$2e2bcd8739ae039)
};


'use strict';
function $b326b5fde005fee6$export$2e2bcd8739ae039(data, options) {
    return (0, $0996803aa5c1f80e$export$2e2bcd8739ae039)(data, new (0, $416ace012c072a43$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $416ace012c072a43$export$2e2bcd8739ae039).isNode && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $f8ee42a77a727047$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $f8ee42a77a727047$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $f8ee42a77a727047$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $f8ee42a77a727047$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFormData(formData) && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($f8ee42a77a727047$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $f8ee42a77a727047$export$2e2bcd8739ae039 = $f8ee42a77a727047$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $120f23bd7e8530fb$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $120f23bd7e8530fb$var$defaults = {
    transitional: (0, $fde4b154a795581d$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $f8ee42a77a727047$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isBuffer(data) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isStream(data) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFile(data) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isBlob(data) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $b326b5fde005fee6$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $0996803aa5c1f80e$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $120f23bd7e8530fb$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $120f23bd7e8530fb$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isResponse(data) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).from(e, (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $416ace012c072a43$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $416ace012c072a43$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $120f23bd7e8530fb$var$defaults.headers[method] = {};
});
var $120f23bd7e8530fb$export$2e2bcd8739ae039 = $120f23bd7e8530fb$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $ccf6b972169bf301$var$ignoreDuplicateOf = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $ccf6b972169bf301$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $ccf6b972169bf301$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $3f893c67fbb34f4e$var$$internals = Symbol('internals');
const $3f893c67fbb34f4e$var$isValidHeaderValue = (value)=>!/[\r\n]/.test(value);
function $3f893c67fbb34f4e$var$assertValidHeaderValue(value, header) {
    if (value === false || value == null) return;
    if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(value)) {
        value.forEach((v)=>$3f893c67fbb34f4e$var$assertValidHeaderValue(v, header));
        return;
    }
    if (!$3f893c67fbb34f4e$var$isValidHeaderValue(String(value))) throw new Error(`Invalid character in header content ["${header}"]`);
}
function $3f893c67fbb34f4e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $3f893c67fbb34f4e$var$stripTrailingCRLF(str) {
    let end = str.length;
    while(end > 0){
        const charCode = str.charCodeAt(end - 1);
        if (charCode !== 10 && charCode !== 13) break;
        end -= 1;
    }
    return end === str.length ? str : str.slice(0, end);
}
function $3f893c67fbb34f4e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(value) ? value.map($3f893c67fbb34f4e$var$normalizeValue) : $3f893c67fbb34f4e$var$stripTrailingCRLF(String(value));
}
function $3f893c67fbb34f4e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $3f893c67fbb34f4e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $3f893c67fbb34f4e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $3f893c67fbb34f4e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $3f893c67fbb34f4e$var$buildAccessors(obj, header) {
    const accessorName = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $3f893c67fbb34f4e$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $3f893c67fbb34f4e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) {
                $3f893c67fbb34f4e$var$assertValidHeaderValue(_value, _header);
                self[key || _header] = $3f893c67fbb34f4e$var$normalizeValue(_value);
            }
        }
        const setHeaders = (headers, _rewrite)=>(0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$3f893c67fbb34f4e$var$isValidHeaderName(header)) setHeaders((0, $ccf6b972169bf301$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isObject(header) && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $3f893c67fbb34f4e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $3f893c67fbb34f4e$var$parseTokens(value);
                if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $3f893c67fbb34f4e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $3f893c67fbb34f4e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $3f893c67fbb34f4e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $3f893c67fbb34f4e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $3f893c67fbb34f4e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $3f893c67fbb34f4e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $3f893c67fbb34f4e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $3f893c67fbb34f4e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$3f893c67fbb34f4e$var$$internals] = this[$3f893c67fbb34f4e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $3f893c67fbb34f4e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $3f893c67fbb34f4e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$3f893c67fbb34f4e$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $78ee239a048a0eda$export$2e2bcd8739ae039).reduceDescriptors($3f893c67fbb34f4e$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $78ee239a048a0eda$export$2e2bcd8739ae039).freezeMethods($3f893c67fbb34f4e$var$AxiosHeaders);
var $3f893c67fbb34f4e$export$2e2bcd8739ae039 = $3f893c67fbb34f4e$var$AxiosHeaders;


'use strict';
function $fbb8265fdb8bc1ff$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $120f23bd7e8530fb$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $76ae36ba33bf1438$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $71dc56eba2858968$var$CanceledError extends (0, $9e5fe95990c915ca$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $71dc56eba2858968$export$2e2bcd8739ae039 = $71dc56eba2858968$var$CanceledError;







'use strict';
function $5bc15bc56edbd3ae$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $519df408b69a1550$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0da67aea7d8ef854$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0da67aea7d8ef854$export$2e2bcd8739ae039 = $0da67aea7d8ef854$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $d224897c8123c243$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $d224897c8123c243$export$2e2bcd8739ae039 = $d224897c8123c243$var$throttle;



const $7d0a5f47a7744a33$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $0da67aea7d8ef854$export$2e2bcd8739ae039)(50, 250);
    return (0, $d224897c8123c243$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $7d0a5f47a7744a33$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $7d0a5f47a7744a33$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $78ee239a048a0eda$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $f554613fd129f6e6$export$2e2bcd8739ae039 = (0, $416ace012c072a43$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $416ace012c072a43$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $416ace012c072a43$export$2e2bcd8739ae039).origin), (0, $416ace012c072a43$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $416ace012c072a43$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $298a31adf644324b$export$2e2bcd8739ae039 = (0, $416ace012c072a43$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $6c2afd1d1cad6693$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $473206c7180b6150$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $3691d10c7e38e909$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $6c2afd1d1cad6693$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $473206c7180b6150$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $8956e6a33eb405a6$var$headersToObject = (thing)=>thing instanceof (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $8956e6a33eb405a6$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isPlainObject(target) && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($8956e6a33eb405a6$var$headersToObject(a), $8956e6a33eb405a6$var$headersToObject(b), prop, true)
    };
    (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $d15d3a178bfbc306$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $8956e6a33eb405a6$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $f416296b3684bfa6$export$2e2bcd8739ae039)((0, $3691d10c7e38e909$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $416ace012c072a43$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $416ace012c072a43$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $416ace012c072a43$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $f554613fd129f6e6$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $298a31adf644324b$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $bf54d5b03b57a809$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $bf54d5b03b57a809$export$2e2bcd8739ae039 = $bf54d5b03b57a809$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $d15d3a178bfbc306$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $5bc15bc56edbd3ae$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)('Request aborted', (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)(msg, (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $fde4b154a795581d$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ETIMEDOUT : (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $7d0a5f47a7744a33$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $7d0a5f47a7744a33$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $71dc56eba2858968$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $519df408b69a1550$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $416ace012c072a43$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $3e44e0776ea3afc5$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $9e5fe95990c915ca$export$2e2bcd8739ae039) ? err : new (0, $71dc56eba2858968$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $78ee239a048a0eda$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $3e44e0776ea3afc5$export$2e2bcd8739ae039 = $3e44e0776ea3afc5$var$composeSignals;


const $d9c4dcd35ae15768$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $d9c4dcd35ae15768$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $d9c4dcd35ae15768$var$readStream(iterable))yield* $d9c4dcd35ae15768$export$71b051935044bd5d(chunk, chunkSize);
};
const $d9c4dcd35ae15768$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $d9c4dcd35ae15768$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $d9c4dcd35ae15768$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $609744c9dca4d8c4$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $609744c9dca4d8c4$var$isFunction } = (0, $78ee239a048a0eda$export$2e2bcd8739ae039);
const $609744c9dca4d8c4$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $78ee239a048a0eda$export$2e2bcd8739ae039).global);
const { ReadableStream: $609744c9dca4d8c4$var$ReadableStream, TextEncoder: $609744c9dca4d8c4$var$TextEncoder } = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).global;
const $609744c9dca4d8c4$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $609744c9dca4d8c4$var$factory = (env)=>{
    env = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $609744c9dca4d8c4$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $609744c9dca4d8c4$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $609744c9dca4d8c4$var$isFunction(Request);
    const isResponseSupported = $609744c9dca4d8c4$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $609744c9dca4d8c4$var$isFunction($609744c9dca4d8c4$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $609744c9dca4d8c4$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $609744c9dca4d8c4$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $609744c9dca4d8c4$var$test(()=>{
        let duplexAccessed = false;
        const body = new $609744c9dca4d8c4$var$ReadableStream();
        const hasContentType = new Request((0, $416ace012c072a43$export$2e2bcd8739ae039).origin, {
            body: body,
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $609744c9dca4d8c4$var$test(()=>(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $416ace012c072a43$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $d15d3a178bfbc306$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $3e44e0776ea3afc5$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $7d0a5f47a7744a33$export$d9fadd12586c18d6)(requestContentLength, (0, $7d0a5f47a7744a33$export$c1b28109d46c3592)((0, $7d0a5f47a7744a33$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $d9c4dcd35ae15768$export$b0119225647bd83)(_request.body, $609744c9dca4d8c4$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $7d0a5f47a7744a33$export$d9fadd12586c18d6)(responseContentLength, (0, $7d0a5f47a7744a33$export$c1b28109d46c3592)((0, $7d0a5f47a7744a33$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $d9c4dcd35ae15768$export$b0119225647bd83)(response.body, $609744c9dca4d8c4$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $78ee239a048a0eda$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $5bc15bc56edbd3ae$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)('Network Error', (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $609744c9dca4d8c4$var$seedCache = new Map();
const $609744c9dca4d8c4$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $609744c9dca4d8c4$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $609744c9dca4d8c4$var$factory(env));
        map = target;
    }
    return target;
};
const $609744c9dca4d8c4$var$adapter = $609744c9dca4d8c4$export$3105c6651375d4fa();
var $609744c9dca4d8c4$export$2e2bcd8739ae039 = $609744c9dca4d8c4$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $75f507809b793311$var$knownAdapters = {
    http: (0, $ec5c5cd9bd9cd9f3$export$2e2bcd8739ae039),
    xhr: (0, $bf54d5b03b57a809$export$2e2bcd8739ae039),
    fetch: {
        get: $609744c9dca4d8c4$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach($75f507809b793311$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $75f507809b793311$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $75f507809b793311$var$isResolvedHandle = (adapter)=>(0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $75f507809b793311$var$getAdapter(adapters, config) {
    adapters = (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$75f507809b793311$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $75f507809b793311$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($75f507809b793311$var$renderReason).join('\n') : ' ' + $75f507809b793311$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $75f507809b793311$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $75f507809b793311$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $75f507809b793311$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $2508f3de5382b984$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $71dc56eba2858968$export$2e2bcd8739ae039)(null, config);
}
function $2508f3de5382b984$export$2e2bcd8739ae039(config) {
    $2508f3de5382b984$var$throwIfCancellationRequested(config);
    config.headers = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $fbb8265fdb8bc1ff$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $75f507809b793311$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $120f23bd7e8530fb$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $2508f3de5382b984$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $fbb8265fdb8bc1ff$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $76ae36ba33bf1438$export$2e2bcd8739ae039)(reason)) {
            $2508f3de5382b984$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $fbb8265fdb8bc1ff$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $7c03476c3effce91$export$a4ad2735b021c132 = "1.15.0";



'use strict';
const $514f93f8dde996cd$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $514f93f8dde996cd$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $514f93f8dde996cd$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $514f93f8dde996cd$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $7c03476c3effce91$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$514f93f8dde996cd$var$deprecatedWarnings[opt]) {
            $514f93f8dde996cd$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$514f93f8dde996cd$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $514f93f8dde996cd$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)('options must be an object', (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $9e5fe95990c915ca$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $9e5fe95990c915ca$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $514f93f8dde996cd$export$2e2bcd8739ae039 = {
    assertOptions: $514f93f8dde996cd$var$assertOptions,
    validators: $514f93f8dde996cd$var$validators
};




'use strict';
const $9a98543e8bd7d95e$var$validators = (0, $514f93f8dde996cd$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $9a98543e8bd7d95e$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $7a952e03d12bfe59$export$2e2bcd8739ae039)(),
            response: new (0, $7a952e03d12bfe59$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $8956e6a33eb405a6$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $514f93f8dde996cd$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $9a98543e8bd7d95e$var$validators.transitional($9a98543e8bd7d95e$var$validators.boolean),
            forcedJSONParsing: $9a98543e8bd7d95e$var$validators.transitional($9a98543e8bd7d95e$var$validators.boolean),
            clarifyTimeoutError: $9a98543e8bd7d95e$var$validators.transitional($9a98543e8bd7d95e$var$validators.boolean),
            legacyInterceptorReqResOrdering: $9a98543e8bd7d95e$var$validators.transitional($9a98543e8bd7d95e$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $514f93f8dde996cd$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $9a98543e8bd7d95e$var$validators.function,
                serialize: $9a98543e8bd7d95e$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $514f93f8dde996cd$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $9a98543e8bd7d95e$var$validators.spelling('baseURL'),
            withXsrfToken: $9a98543e8bd7d95e$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $fde4b154a795581d$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $2508f3de5382b984$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $2508f3de5382b984$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $8956e6a33eb405a6$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $3691d10c7e38e909$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $f416296b3684bfa6$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $9a98543e8bd7d95e$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $8956e6a33eb405a6$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $78ee239a048a0eda$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $8956e6a33eb405a6$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $9a98543e8bd7d95e$var$Axios.prototype[method] = generateHTTPMethod();
    $9a98543e8bd7d95e$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $9a98543e8bd7d95e$export$2e2bcd8739ae039 = $9a98543e8bd7d95e$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $8f0d0c116d26343b$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $71dc56eba2858968$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $8f0d0c116d26343b$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $8f0d0c116d26343b$export$2e2bcd8739ae039 = $8f0d0c116d26343b$var$CancelToken;






'use strict';
function $3541cd1ecb66020b$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $c0170b1b91bf9fc9$export$2e2bcd8739ae039(payload) {
    return (0, $78ee239a048a0eda$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $e6fd820b3798c750$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($e6fd820b3798c750$var$HttpStatusCode).forEach(([key, value])=>{
    $e6fd820b3798c750$var$HttpStatusCode[value] = key;
});
var $e6fd820b3798c750$export$2e2bcd8739ae039 = $e6fd820b3798c750$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $819d8cc37f99af41$var$createInstance(defaultConfig) {
    const context = new (0, $9a98543e8bd7d95e$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $b1693a4c864a9984$export$2e2bcd8739ae039)((0, $9a98543e8bd7d95e$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $78ee239a048a0eda$export$2e2bcd8739ae039).extend(instance, (0, $9a98543e8bd7d95e$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $78ee239a048a0eda$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $819d8cc37f99af41$var$createInstance((0, $8956e6a33eb405a6$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $819d8cc37f99af41$var$axios = $819d8cc37f99af41$var$createInstance((0, $120f23bd7e8530fb$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$819d8cc37f99af41$var$axios.Axios = (0, $9a98543e8bd7d95e$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$819d8cc37f99af41$var$axios.CanceledError = (0, $71dc56eba2858968$export$2e2bcd8739ae039);
$819d8cc37f99af41$var$axios.CancelToken = (0, $8f0d0c116d26343b$export$2e2bcd8739ae039);
$819d8cc37f99af41$var$axios.isCancel = (0, $76ae36ba33bf1438$export$2e2bcd8739ae039);
$819d8cc37f99af41$var$axios.VERSION = (0, $7c03476c3effce91$export$a4ad2735b021c132);
$819d8cc37f99af41$var$axios.toFormData = (0, $0996803aa5c1f80e$export$2e2bcd8739ae039);
// Expose AxiosError class
$819d8cc37f99af41$var$axios.AxiosError = (0, $9e5fe95990c915ca$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$819d8cc37f99af41$var$axios.Cancel = $819d8cc37f99af41$var$axios.CanceledError;
// Expose all/spread
$819d8cc37f99af41$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$819d8cc37f99af41$var$axios.spread = (0, $3541cd1ecb66020b$export$2e2bcd8739ae039);
// Expose isAxiosError
$819d8cc37f99af41$var$axios.isAxiosError = (0, $c0170b1b91bf9fc9$export$2e2bcd8739ae039);
// Expose mergeConfig
$819d8cc37f99af41$var$axios.mergeConfig = (0, $8956e6a33eb405a6$export$2e2bcd8739ae039);
$819d8cc37f99af41$var$axios.AxiosHeaders = (0, $3f893c67fbb34f4e$export$2e2bcd8739ae039);
$819d8cc37f99af41$var$axios.formToJSON = (thing)=>(0, $f8ee42a77a727047$export$2e2bcd8739ae039)((0, $78ee239a048a0eda$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$819d8cc37f99af41$var$axios.getAdapter = (0, $75f507809b793311$export$2e2bcd8739ae039).getAdapter;
$819d8cc37f99af41$var$axios.HttpStatusCode = (0, $e6fd820b3798c750$export$2e2bcd8739ae039);
$819d8cc37f99af41$var$axios.default = $819d8cc37f99af41$var$axios;
var // this module should only have a default export
$819d8cc37f99af41$export$2e2bcd8739ae039 = $819d8cc37f99af41$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c55db13f3132a5c0$export$1c00760e9e5a4e95, AxiosError: $c55db13f3132a5c0$export$c1fbed17c2f6a328, CanceledError: $c55db13f3132a5c0$export$1ab0c6b20d94fa14, isCancel: $c55db13f3132a5c0$export$3b22524397b493c6, CancelToken: $c55db13f3132a5c0$export$fd08e3cb425f0d61, VERSION: $c55db13f3132a5c0$export$a4ad2735b021c132, all: $c55db13f3132a5c0$export$84bf76cd7afc7469, Cancel: $c55db13f3132a5c0$export$848c9b7ead0df967, isAxiosError: $c55db13f3132a5c0$export$fbafdbe06a5b5a9a, spread: $c55db13f3132a5c0$export$3ae0fd4797ed47c8, toFormData: $c55db13f3132a5c0$export$10ae0d317ea97f8b, AxiosHeaders: $c55db13f3132a5c0$export$4e7d6ff0f3e6520, HttpStatusCode: $c55db13f3132a5c0$export$a972f69c851492b3, formToJSON: $c55db13f3132a5c0$export$86d7c59254d6a2c9, getAdapter: $c55db13f3132a5c0$export$17ddc20a97d669e2, mergeConfig: $c55db13f3132a5c0$export$7ec1ebcfa9d8bd6a } = (0, $819d8cc37f99af41$export$2e2bcd8739ae039);


var $e5d2a3ae662f5d2e$exports = {};

$parcel$export($e5d2a3ae662f5d2e$exports, "create", () => $e5d2a3ae662f5d2e$export$185802fd694ee1f5, (v) => $e5d2a3ae662f5d2e$export$185802fd694ee1f5 = v);
$parcel$export($e5d2a3ae662f5d2e$exports, "toCanvas", () => $e5d2a3ae662f5d2e$export$f87f6982d1fd4f81, (v) => $e5d2a3ae662f5d2e$export$f87f6982d1fd4f81 = v);
$parcel$export($e5d2a3ae662f5d2e$exports, "toDataURL", () => $e5d2a3ae662f5d2e$export$723e4939e5a27c8, (v) => $e5d2a3ae662f5d2e$export$723e4939e5a27c8 = v);
$parcel$export($e5d2a3ae662f5d2e$exports, "toString", () => $e5d2a3ae662f5d2e$export$f84e8e69fd4488a5, (v) => $e5d2a3ae662f5d2e$export$f84e8e69fd4488a5 = v);
var $e5d2a3ae662f5d2e$export$185802fd694ee1f5;
var $e5d2a3ae662f5d2e$export$f87f6982d1fd4f81;
var $e5d2a3ae662f5d2e$export$723e4939e5a27c8;
// only svg for now.
var $e5d2a3ae662f5d2e$export$f84e8e69fd4488a5;
var $38aec60e008fa351$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$38aec60e008fa351$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $96cdee29c4ef344c$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $3c0c059760123098$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $3c0c059760123098$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $3c0c059760123098$export$ed1d66da50968976;
var $3c0c059760123098$export$6733b14783f975c2;
var $3c0c059760123098$export$ce5b1274f8597fa0;
var $3c0c059760123098$export$43dd553ecded716d;
let $3c0c059760123098$var$toSJISFunction;
const $3c0c059760123098$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$3c0c059760123098$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$3c0c059760123098$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $3c0c059760123098$var$CODEWORDS_COUNT[version];
};
$3c0c059760123098$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$3c0c059760123098$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $3c0c059760123098$var$toSJISFunction = f;
};
$3c0c059760123098$export$ce5b1274f8597fa0 = function() {
    return typeof $3c0c059760123098$var$toSJISFunction !== 'undefined';
};
$3c0c059760123098$export$43dd553ecded716d = function toSJIS(kanji) {
    return $3c0c059760123098$var$toSJISFunction(kanji);
};


var $0d86d6c290a07c1c$export$61196ced6d74a310;
var $0d86d6c290a07c1c$export$3a1a48c8f6ef640e;
var $0d86d6c290a07c1c$export$3722cfe417b6ed86;
var $0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd;
var $0d86d6c290a07c1c$export$1ea939691cdc45b8;
var $0d86d6c290a07c1c$export$6788812c4e6611e6;
$0d86d6c290a07c1c$export$61196ced6d74a310 = {
    bit: 1
};
$0d86d6c290a07c1c$export$3a1a48c8f6ef640e = {
    bit: 0
};
$0d86d6c290a07c1c$export$3722cfe417b6ed86 = {
    bit: 3
};
$0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $0d86d6c290a07c1c$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $0d86d6c290a07c1c$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $0d86d6c290a07c1c$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $0d86d6c290a07c1c$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$0d86d6c290a07c1c$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$0d86d6c290a07c1c$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($0d86d6c290a07c1c$export$1ea939691cdc45b8(value)) return value;
    try {
        return $0d86d6c290a07c1c$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $c33b7439ba8b2a6c$exports = {};
function $c33b7439ba8b2a6c$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$c33b7439ba8b2a6c$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$c33b7439ba8b2a6c$exports = $c33b7439ba8b2a6c$var$BitBuffer;


var $5158baa00c8f4fa8$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $5158baa00c8f4fa8$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $5158baa00c8f4fa8$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $5158baa00c8f4fa8$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $5158baa00c8f4fa8$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $5158baa00c8f4fa8$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$5158baa00c8f4fa8$exports = $5158baa00c8f4fa8$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $ac0face0132a0e67$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $ac0face0132a0e67$export$c39457c570f2b189;

var $ac0face0132a0e67$require$getSymbolSize = $3c0c059760123098$export$8d4a06d3facd414b;
$ac0face0132a0e67$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $ac0face0132a0e67$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$ac0face0132a0e67$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $ac0face0132a0e67$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $0e214d44dead0105$export$c39457c570f2b189;

var $0e214d44dead0105$require$getSymbolSize = $3c0c059760123098$export$8d4a06d3facd414b;
const $0e214d44dead0105$var$FINDER_PATTERN_SIZE = 7;
$0e214d44dead0105$export$c39457c570f2b189 = function getPositions(version) {
    const size = $0e214d44dead0105$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $0e214d44dead0105$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $0e214d44dead0105$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $ab013ad757fb013d$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $ab013ad757fb013d$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $ab013ad757fb013d$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $ab013ad757fb013d$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $ab013ad757fb013d$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $ab013ad757fb013d$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $ab013ad757fb013d$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $ab013ad757fb013d$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $ab013ad757fb013d$export$fe9625aaceb0e563;
$ab013ad757fb013d$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $ab013ad757fb013d$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$ab013ad757fb013d$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$ab013ad757fb013d$export$6788812c4e6611e6 = function from(value) {
    return $ab013ad757fb013d$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$ab013ad757fb013d$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $ab013ad757fb013d$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $ab013ad757fb013d$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $ab013ad757fb013d$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $ab013ad757fb013d$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$ab013ad757fb013d$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $ab013ad757fb013d$var$PenaltyScores.N2;
};
$ab013ad757fb013d$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $ab013ad757fb013d$var$PenaltyScores.N3;
};
$ab013ad757fb013d$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $ab013ad757fb013d$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $ab013ad757fb013d$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$ab013ad757fb013d$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $ab013ad757fb013d$var$getMaskAt(pattern, row, col));
    }
};
$ab013ad757fb013d$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($ab013ad757fb013d$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $ab013ad757fb013d$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $ab013ad757fb013d$export$a5fd3a02c14d0b3e(data) + $ab013ad757fb013d$export$9a9385107a518e46(data) + $ab013ad757fb013d$export$ade754353f0dc75e(data) + $ab013ad757fb013d$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $ab013ad757fb013d$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $c525c70215eeca0c$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $c525c70215eeca0c$export$683d1b3e8a1a8438;

const $c525c70215eeca0c$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $c525c70215eeca0c$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$c525c70215eeca0c$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $0d86d6c290a07c1c$export$61196ced6d74a310:
            return $c525c70215eeca0c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $0d86d6c290a07c1c$export$3a1a48c8f6ef640e:
            return $c525c70215eeca0c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $0d86d6c290a07c1c$export$3722cfe417b6ed86:
            return $c525c70215eeca0c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd:
            return $c525c70215eeca0c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$c525c70215eeca0c$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $0d86d6c290a07c1c$export$61196ced6d74a310:
            return $c525c70215eeca0c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $0d86d6c290a07c1c$export$3a1a48c8f6ef640e:
            return $c525c70215eeca0c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $0d86d6c290a07c1c$export$3722cfe417b6ed86:
            return $c525c70215eeca0c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd:
            return $c525c70215eeca0c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $93334cf51ca9c9c3$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $a1eabc4d156beeb3$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $a1eabc4d156beeb3$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $a1eabc4d156beeb3$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $8bbcff3e9321f949$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $8bbcff3e9321f949$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $8bbcff3e9321f949$export$6e3a27864ab166fe;
const $8bbcff3e9321f949$var$EXP_TABLE = new Uint8Array(512);
const $8bbcff3e9321f949$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $8bbcff3e9321f949$var$EXP_TABLE[i] = x;
        $8bbcff3e9321f949$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$8bbcff3e9321f949$var$EXP_TABLE[i] = $8bbcff3e9321f949$var$EXP_TABLE[i - 255];
})();
$8bbcff3e9321f949$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $8bbcff3e9321f949$var$LOG_TABLE[n];
};
$8bbcff3e9321f949$export$b310ec824aaee37f = function exp(n) {
    return $8bbcff3e9321f949$var$EXP_TABLE[n];
};
$8bbcff3e9321f949$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $8bbcff3e9321f949$var$EXP_TABLE[$8bbcff3e9321f949$var$LOG_TABLE[x] + $8bbcff3e9321f949$var$LOG_TABLE[y]];
};


$a1eabc4d156beeb3$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $8bbcff3e9321f949$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$a1eabc4d156beeb3$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $8bbcff3e9321f949$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$a1eabc4d156beeb3$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $a1eabc4d156beeb3$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $8bbcff3e9321f949$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $93334cf51ca9c9c3$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $93334cf51ca9c9c3$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $a1eabc4d156beeb3$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $93334cf51ca9c9c3$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $a1eabc4d156beeb3$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$93334cf51ca9c9c3$exports = $93334cf51ca9c9c3$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $ae92eaec358ee6d6$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $ae92eaec358ee6d6$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $ae92eaec358ee6d6$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $ae92eaec358ee6d6$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $57b99d0a6afdc424$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $57b99d0a6afdc424$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $57b99d0a6afdc424$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $57b99d0a6afdc424$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $57b99d0a6afdc424$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $dd482bca37708faa$export$1ea939691cdc45b8;
$dd482bca37708faa$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $1ed07c57a1550335$export$a4d452c2363c8e12;
var $1ed07c57a1550335$export$9df7c29d562bab83;
var $1ed07c57a1550335$export$8f4bf8f7eb581284;
var $1ed07c57a1550335$export$4d318981b5a83836;
var $1ed07c57a1550335$export$376a9ed239d6c1c8;
var $1ed07c57a1550335$export$175f16aef75a4569;
var $1ed07c57a1550335$export$50b7f9bf92c74274;
var $1ed07c57a1550335$export$4ba5f52893b4ac97;
const $1ed07c57a1550335$var$numeric = '[0-9]+';
const $1ed07c57a1550335$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $1ed07c57a1550335$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$1ed07c57a1550335$var$kanji = $1ed07c57a1550335$var$kanji.replace(/u/g, '\\u');
const $1ed07c57a1550335$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $1ed07c57a1550335$var$kanji + ')(?:.|[\r\n]))+';
$1ed07c57a1550335$export$a4d452c2363c8e12 = new RegExp($1ed07c57a1550335$var$kanji, 'g');
$1ed07c57a1550335$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$1ed07c57a1550335$export$8f4bf8f7eb581284 = new RegExp($1ed07c57a1550335$var$byte, 'g');
$1ed07c57a1550335$export$4d318981b5a83836 = new RegExp($1ed07c57a1550335$var$numeric, 'g');
$1ed07c57a1550335$export$376a9ed239d6c1c8 = new RegExp($1ed07c57a1550335$var$alphanumeric, 'g');
const $1ed07c57a1550335$var$TEST_KANJI = new RegExp('^' + $1ed07c57a1550335$var$kanji + '$');
const $1ed07c57a1550335$var$TEST_NUMERIC = new RegExp('^' + $1ed07c57a1550335$var$numeric + '$');
const $1ed07c57a1550335$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$1ed07c57a1550335$export$175f16aef75a4569 = function testKanji(str) {
    return $1ed07c57a1550335$var$TEST_KANJI.test(str);
};
$1ed07c57a1550335$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $1ed07c57a1550335$var$TEST_NUMERIC.test(str);
};
$1ed07c57a1550335$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $1ed07c57a1550335$var$TEST_ALPHANUMERIC.test(str);
};


$57b99d0a6afdc424$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$57b99d0a6afdc424$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$57b99d0a6afdc424$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$57b99d0a6afdc424$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$57b99d0a6afdc424$export$bb410559a65d3418 = {
    bit: -1
};
$57b99d0a6afdc424$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$dd482bca37708faa$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$57b99d0a6afdc424$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($1ed07c57a1550335$export$50b7f9bf92c74274(dataStr)) return $57b99d0a6afdc424$export$4d318981b5a83836;
    else if ($1ed07c57a1550335$export$4ba5f52893b4ac97(dataStr)) return $57b99d0a6afdc424$export$376a9ed239d6c1c8;
    else if ($1ed07c57a1550335$export$175f16aef75a4569(dataStr)) return $57b99d0a6afdc424$export$a4d452c2363c8e12;
    else return $57b99d0a6afdc424$export$8f4bf8f7eb581284;
};
$57b99d0a6afdc424$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$57b99d0a6afdc424$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $57b99d0a6afdc424$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $57b99d0a6afdc424$export$4d318981b5a83836;
        case 'alphanumeric':
            return $57b99d0a6afdc424$export$376a9ed239d6c1c8;
        case 'kanji':
            return $57b99d0a6afdc424$export$a4d452c2363c8e12;
        case 'byte':
            return $57b99d0a6afdc424$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$57b99d0a6afdc424$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($57b99d0a6afdc424$export$1ea939691cdc45b8(value)) return value;
    try {
        return $57b99d0a6afdc424$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $ae92eaec358ee6d6$var$G18 = 7973;
const $ae92eaec358ee6d6$var$G18_BCH = $3c0c059760123098$export$ed1d66da50968976($ae92eaec358ee6d6$var$G18);
function $ae92eaec358ee6d6$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $ae92eaec358ee6d6$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $ae92eaec358ee6d6$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $57b99d0a6afdc424$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $ae92eaec358ee6d6$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $ae92eaec358ee6d6$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $ae92eaec358ee6d6$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $ae92eaec358ee6d6$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $ae92eaec358ee6d6$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $57b99d0a6afdc424$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$ae92eaec358ee6d6$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($dd482bca37708faa$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$ae92eaec358ee6d6$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$dd482bca37708faa$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $57b99d0a6afdc424$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $3c0c059760123098$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $c525c70215eeca0c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $57b99d0a6afdc424$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $ae92eaec358ee6d6$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $57b99d0a6afdc424$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $57b99d0a6afdc424$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $57b99d0a6afdc424$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $57b99d0a6afdc424$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$ae92eaec358ee6d6$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $0d86d6c290a07c1c$export$6788812c4e6611e6(errorCorrectionLevel, $0d86d6c290a07c1c$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $ae92eaec358ee6d6$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $ae92eaec358ee6d6$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$ae92eaec358ee6d6$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$dd482bca37708faa$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($3c0c059760123098$export$ed1d66da50968976(d) - $ae92eaec358ee6d6$var$G18_BCH >= 0)d ^= $ae92eaec358ee6d6$var$G18 << $3c0c059760123098$export$ed1d66da50968976(d) - $ae92eaec358ee6d6$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $f2fabc9649342799$export$eee5438974ef6f0e;

const $f2fabc9649342799$var$G15 = 1335;
const $f2fabc9649342799$var$G15_MASK = 21522;
const $f2fabc9649342799$var$G15_BCH = $3c0c059760123098$export$ed1d66da50968976($f2fabc9649342799$var$G15);
$f2fabc9649342799$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($3c0c059760123098$export$ed1d66da50968976(d) - $f2fabc9649342799$var$G15_BCH >= 0)d ^= $f2fabc9649342799$var$G15 << $3c0c059760123098$export$ed1d66da50968976(d) - $f2fabc9649342799$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $f2fabc9649342799$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $e76504f6730aa999$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $e76504f6730aa999$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $e76504f6730aa999$export$89ab1afb9839589b;

var $9431ccf630768e9c$exports = {};

function $9431ccf630768e9c$var$NumericData(data) {
    this.mode = $57b99d0a6afdc424$export$4d318981b5a83836;
    this.data = data.toString();
}
$9431ccf630768e9c$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$9431ccf630768e9c$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9431ccf630768e9c$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $9431ccf630768e9c$var$NumericData.getBitsLength(this.data.length);
};
$9431ccf630768e9c$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$9431ccf630768e9c$exports = $9431ccf630768e9c$var$NumericData;


var $e1996a7391d2fae7$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $e1996a7391d2fae7$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $e1996a7391d2fae7$var$AlphanumericData(data) {
    this.mode = $57b99d0a6afdc424$export$376a9ed239d6c1c8;
    this.data = data;
}
$e1996a7391d2fae7$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$e1996a7391d2fae7$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$e1996a7391d2fae7$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $e1996a7391d2fae7$var$AlphanumericData.getBitsLength(this.data.length);
};
$e1996a7391d2fae7$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $e1996a7391d2fae7$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $e1996a7391d2fae7$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($e1996a7391d2fae7$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$e1996a7391d2fae7$exports = $e1996a7391d2fae7$var$AlphanumericData;


var $b086cdb22c772d6f$exports = {};

function $b086cdb22c772d6f$var$ByteData(data) {
    this.mode = $57b99d0a6afdc424$export$8f4bf8f7eb581284;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$b086cdb22c772d6f$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$b086cdb22c772d6f$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b086cdb22c772d6f$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $b086cdb22c772d6f$var$ByteData.getBitsLength(this.data.length);
};
$b086cdb22c772d6f$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$b086cdb22c772d6f$exports = $b086cdb22c772d6f$var$ByteData;


var $9ce94abdf224fcfd$exports = {};


function $9ce94abdf224fcfd$var$KanjiData(data) {
    this.mode = $57b99d0a6afdc424$export$a4d452c2363c8e12;
    this.data = data;
}
$9ce94abdf224fcfd$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$9ce94abdf224fcfd$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9ce94abdf224fcfd$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $9ce94abdf224fcfd$var$KanjiData.getBitsLength(this.data.length);
};
$9ce94abdf224fcfd$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $3c0c059760123098$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$9ce94abdf224fcfd$exports = $9ce94abdf224fcfd$var$KanjiData;




var $66317a2f62ebddf7$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $66317a2f62ebddf7$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $66317a2f62ebddf7$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $66317a2f62ebddf7$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $66317a2f62ebddf7$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $66317a2f62ebddf7$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$66317a2f62ebddf7$exports = $66317a2f62ebddf7$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $e76504f6730aa999$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $e76504f6730aa999$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $e76504f6730aa999$var$getSegmentsFromString(dataStr) {
    const numSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$4d318981b5a83836, $57b99d0a6afdc424$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$376a9ed239d6c1c8, $57b99d0a6afdc424$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($3c0c059760123098$export$ce5b1274f8597fa0()) {
        byteSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$8f4bf8f7eb581284, $57b99d0a6afdc424$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$a4d452c2363c8e12, $57b99d0a6afdc424$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$9df7c29d562bab83, $57b99d0a6afdc424$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $e76504f6730aa999$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $57b99d0a6afdc424$export$4d318981b5a83836:
            return $9431ccf630768e9c$exports.getBitsLength(length);
        case $57b99d0a6afdc424$export$376a9ed239d6c1c8:
            return $e1996a7391d2fae7$exports.getBitsLength(length);
        case $57b99d0a6afdc424$export$a4d452c2363c8e12:
            return $9ce94abdf224fcfd$exports.getBitsLength(length);
        case $57b99d0a6afdc424$export$8f4bf8f7eb581284:
            return $b086cdb22c772d6f$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $e76504f6730aa999$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $e76504f6730aa999$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $57b99d0a6afdc424$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $57b99d0a6afdc424$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $57b99d0a6afdc424$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$8f4bf8f7eb581284,
                        length: $e76504f6730aa999$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $57b99d0a6afdc424$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$8f4bf8f7eb581284,
                        length: $e76504f6730aa999$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $e76504f6730aa999$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $e76504f6730aa999$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $e76504f6730aa999$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $e76504f6730aa999$var$getSegmentBitsLength(node.length, node.mode) + 4 + $57b99d0a6afdc424$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $e76504f6730aa999$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $57b99d0a6afdc424$export$1bd4c93ffb42e55e(data);
    mode = $57b99d0a6afdc424$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $57b99d0a6afdc424$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $57b99d0a6afdc424$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $57b99d0a6afdc424$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $57b99d0a6afdc424$export$a4d452c2363c8e12 && !$3c0c059760123098$export$ce5b1274f8597fa0()) mode = $57b99d0a6afdc424$export$8f4bf8f7eb581284;
    switch(mode){
        case $57b99d0a6afdc424$export$4d318981b5a83836:
            return new $9431ccf630768e9c$exports(data);
        case $57b99d0a6afdc424$export$376a9ed239d6c1c8:
            return new $e1996a7391d2fae7$exports(data);
        case $57b99d0a6afdc424$export$a4d452c2363c8e12:
            return new $9ce94abdf224fcfd$exports(data);
        case $57b99d0a6afdc424$export$8f4bf8f7eb581284:
            return new $b086cdb22c772d6f$exports(data);
    }
}
$e76504f6730aa999$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($e76504f6730aa999$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($e76504f6730aa999$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$e76504f6730aa999$export$3004f64547af360e = function fromString(data, version) {
    const segs = $e76504f6730aa999$var$getSegmentsFromString(data, $3c0c059760123098$export$ce5b1274f8597fa0());
    const nodes = $e76504f6730aa999$var$buildNodes(segs);
    const graph = $e76504f6730aa999$var$buildGraph(nodes, version);
    const path = $66317a2f62ebddf7$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $e76504f6730aa999$export$571d59b505e6bb4e($e76504f6730aa999$var$mergeSegments(optimizedSegs));
};
$e76504f6730aa999$export$89ab1afb9839589b = function rawSplit(data) {
    return $e76504f6730aa999$export$571d59b505e6bb4e($e76504f6730aa999$var$getSegmentsFromString(data, $3c0c059760123098$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $96cdee29c4ef344c$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $0e214d44dead0105$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $96cdee29c4ef344c$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $96cdee29c4ef344c$var$setupAlignmentPattern(matrix, version) {
    const pos = $ac0face0132a0e67$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $96cdee29c4ef344c$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $ae92eaec358ee6d6$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $96cdee29c4ef344c$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $f2fabc9649342799$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $96cdee29c4ef344c$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $96cdee29c4ef344c$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $c33b7439ba8b2a6c$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $57b99d0a6afdc424$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $3c0c059760123098$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $c525c70215eeca0c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $96cdee29c4ef344c$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $96cdee29c4ef344c$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $3c0c059760123098$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $c525c70215eeca0c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $c525c70215eeca0c$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $93334cf51ca9c9c3$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $96cdee29c4ef344c$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $e76504f6730aa999$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $e76504f6730aa999$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $ae92eaec358ee6d6$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $e76504f6730aa999$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $ae92eaec358ee6d6$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $96cdee29c4ef344c$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $3c0c059760123098$export$8d4a06d3facd414b(version);
    const modules = new $5158baa00c8f4fa8$exports(moduleCount);
    // Add function modules
    $96cdee29c4ef344c$var$setupFinderPattern(modules, version);
    $96cdee29c4ef344c$var$setupTimingPattern(modules);
    $96cdee29c4ef344c$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $96cdee29c4ef344c$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $96cdee29c4ef344c$var$setupVersionInfo(modules, version);
    // Add data codewords
    $96cdee29c4ef344c$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $ab013ad757fb013d$export$fe9625aaceb0e563(modules, $96cdee29c4ef344c$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $ab013ad757fb013d$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $96cdee29c4ef344c$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$96cdee29c4ef344c$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $0d86d6c290a07c1c$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $0d86d6c290a07c1c$export$6788812c4e6611e6(options.errorCorrectionLevel, $0d86d6c290a07c1c$export$3a1a48c8f6ef640e);
        version = $ae92eaec358ee6d6$export$6788812c4e6611e6(options.version);
        mask = $ab013ad757fb013d$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $3c0c059760123098$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $96cdee29c4ef344c$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $80d9e22a657d988d$export$b3890eb0ae9dca99;
var $80d9e22a657d988d$export$c3e5526bbaf70a25;
var $861b45120a86cc31$export$d2312e68e1f5ad00;
var $861b45120a86cc31$export$5cdac61cf538712e;
var $861b45120a86cc31$export$c3a1a1f268a8142b;
var $861b45120a86cc31$export$83136f57c739c5f3;
function $861b45120a86cc31$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$861b45120a86cc31$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $861b45120a86cc31$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $861b45120a86cc31$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$861b45120a86cc31$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$861b45120a86cc31$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $861b45120a86cc31$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$861b45120a86cc31$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $861b45120a86cc31$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $80d9e22a657d988d$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $80d9e22a657d988d$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$80d9e22a657d988d$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $80d9e22a657d988d$var$getCanvasElement();
    opts = $861b45120a86cc31$export$d2312e68e1f5ad00(opts);
    const size = $861b45120a86cc31$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $861b45120a86cc31$export$83136f57c739c5f3(image.data, qrData, opts);
    $80d9e22a657d988d$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$80d9e22a657d988d$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $80d9e22a657d988d$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $50025a8fe93b5848$export$b3890eb0ae9dca99;

function $50025a8fe93b5848$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $50025a8fe93b5848$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $50025a8fe93b5848$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $50025a8fe93b5848$var$svgCmd('M', col + margin, 0.5 + row + margin) : $50025a8fe93b5848$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $50025a8fe93b5848$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$50025a8fe93b5848$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $861b45120a86cc31$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $50025a8fe93b5848$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $50025a8fe93b5848$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $50025a8fe93b5848$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $e5d2a3ae662f5d2e$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$38aec60e008fa351$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $96cdee29c4ef344c$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $96cdee29c4ef344c$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$e5d2a3ae662f5d2e$export$185802fd694ee1f5 = $96cdee29c4ef344c$export$185802fd694ee1f5;
$e5d2a3ae662f5d2e$export$f87f6982d1fd4f81 = $e5d2a3ae662f5d2e$var$renderCanvas.bind(null, $80d9e22a657d988d$export$b3890eb0ae9dca99);
$e5d2a3ae662f5d2e$export$723e4939e5a27c8 = $e5d2a3ae662f5d2e$var$renderCanvas.bind(null, $80d9e22a657d988d$export$c3e5526bbaf70a25);
$e5d2a3ae662f5d2e$export$f84e8e69fd4488a5 = $e5d2a3ae662f5d2e$var$renderCanvas.bind(null, function(data, _, opts) {
    return $50025a8fe93b5848$export$b3890eb0ae9dca99(data, opts);
});




class $4db43c6ab8dfea40$export$104354007fbf0d8 {
    axiosInstance;
    constructor(){
        this.axiosInstance = this.setUpAxios();
    }
    getAPIBaseURL() {
        switch((0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).ENVIRONMENT){
            case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).QA:
                return `https://api.tab-qa.com/`;
            case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).PRODUCTION:
                return `https://api.theappbuilder.com/`;
            case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).LOCAL:
                return `https://api.tab-dev.com/`;
            case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).FEATURE:
                return `https://api.${(0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).FEATURENAME}.tab-feature.com/`;
            default:
                return '##DevApiUrl##';
        }
    }
    setUpAxios = ()=>{
        let axiosInstance = this.axiosInstance;
        const baseUrlHasChanged = this.getAPIBaseURL();
        if (!this.axiosInstance || baseUrlHasChanged) axiosInstance = (0, $819d8cc37f99af41$export$2e2bcd8739ae039).create({
            baseURL: this.getAPIBaseURL()
        });
        // if token
        /*if(axiosInstance?.defaults?.headers?.common) {
            axiosInstance.defaults.headers.common['Authorization'] =  `Bearer ${localStorage.getItem('token')}`
        }
        */ return axiosInstance;
    };
    get = (url, options)=>{
        return this.setUpAxios().get(url, options);
    };
    post(url, payload, options) {
        return this.setUpAxios().post(url, payload, options);
    }
    put = (url, payload, options)=>{
        return this.setUpAxios().put(url, payload, options);
    };
    del = (url, options)=>{
        return this.setUpAxios().delete(url, options);
    };
    generateQR = async (text)=>{
        try {
            return await (0, (/*@__PURE__*/$parcel$interopDefault($e5d2a3ae662f5d2e$exports))).toDataURL(text);
        } catch (err) {
            return Promise.reject(err);
        }
    };
    getQRCodeUrl = async ()=>{
        return await this.generateQR(`${globalThis.location.origin}${(0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).REDIRECTOR]}`);
    };
}
const $4db43c6ab8dfea40$var$HTTP = new $4db43c6ab8dfea40$export$104354007fbf0d8();
var $4db43c6ab8dfea40$export$2e2bcd8739ae039 = $4db43c6ab8dfea40$var$HTTP;


const $038ce1f953eebf86$var$DevControls = ()=>{
    const [showDevControls, setShowDevControls] = (0, $aqdBs.useState)(false);
    if (!showDevControls) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        style: {
            position: 'fixed',
            bottom: 0,
            right: 0,
            padding: '16px'
        },
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
            onClick: ()=>{
                setShowDevControls(true);
            },
            children: "change environment details"
        })
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        style: {
            position: 'fixed',
            bottom: 0,
            right: 0,
            padding: '16px'
        },
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    marginBottom: '8px'
                },
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '16px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                                children: " select environment"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("select", {
                                value: (0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).ENVIRONMENT,
                                onChange: (e)=>(0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).ENVIRONMENT = e.target.value,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                        value: undefined,
                                        children: " none selected"
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                        value: (0, $e1c9151c0619a5ff$export$2332bccde38c8493).QA,
                                        children: "QA"
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                        value: (0, $e1c9151c0619a5ff$export$2332bccde38c8493).PRODUCTION,
                                        children: "Production"
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                        value: (0, $e1c9151c0619a5ff$export$2332bccde38c8493).FEATURE,
                                        children: "Feature"
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                        value: (0, $e1c9151c0619a5ff$export$2332bccde38c8493).LOCAL,
                                        children: "Local"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '16px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                                children: "enter feature name"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                                type: "text",
                                value: (0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).FEATURENAME,
                                onChange: (e)=>(0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).FEATURENAME = e.target.value
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '16px'
                },
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                        onClick: ()=>(0, $4db43c6ab8dfea40$export$2e2bcd8739ae039).get('/api/organization/tab/exists').catch(()=>{}),
                        children: "test"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                        onClick: ()=>{
                            setShowDevControls(false);
                        },
                        children: "hide dev controls"
                    })
                ]
            })
        ]
    });
};
var $038ce1f953eebf86$export$2e2bcd8739ae039 = $038ce1f953eebf86$var$DevControls;



const $6ef136a4babdb9db$var$SignUpMain = ({ router: router })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("main", {
        id: `app-container`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c133cb7ba0384653$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $341c792fffde747f$export$323e4fc2fa4753fb), {
                router: router
            }),
            globalThis.localStorage.getItem('isLocalDev') === 'true' && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $038ce1f953eebf86$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6ef136a4babdb9db$export$2e2bcd8739ae039 = $6ef136a4babdb9db$var$SignUpMain;



parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");


let $87a40fad12754c0d$var$navigate;
function $87a40fad12754c0d$export$73e05a5d9169884(navFn) {
    $87a40fad12754c0d$var$navigate = navFn;
}
function $87a40fad12754c0d$export$971646e43cc4a11b(path, options) {
    if (!$87a40fad12754c0d$var$navigate) {
        console.warn("\u26A0\uFE0F navigate called before router initialized");
        return;
    }
    $87a40fad12754c0d$var$navigate(path, options);
}




function $b7215fe592db8ea7$export$c44a731078af0b81() {
    return (0, $4db43c6ab8dfea40$export$2e2bcd8739ae039).get(`/api/self-sign-up/defaultContent`);
}
function $b7215fe592db8ea7$export$61eec6b36fede6fe(params) {
    return (0, $4db43c6ab8dfea40$export$2e2bcd8739ae039).post(`/api/self-sign-up/validate`, params);
}
function $b7215fe592db8ea7$export$9e1b0960750c7d85(params) {
    return (0, $4db43c6ab8dfea40$export$2e2bcd8739ae039).post(`/api/self-sign-up/code`, params);
}
function $b7215fe592db8ea7$export$4e373c34abfa8c68(params) {
    return (0, $4db43c6ab8dfea40$export$2e2bcd8739ae039).post(`/api/self-sign-up/create`, params);
}


class $33faf7692bf52aba$export$77e0a965259136c6 {
    title = 'Create your Thrive app';
    subtitle = "We\u2019ll set up a fully working demo app tailored to your company. It takes 2 minutes, and there\u2019s no payment required.";
    information = "Free 30-day trial \xb7 No credit card needed";
    button = "Get started";
    appTitle = "Welcome! \uD83C\uDF8A";
    defaultContent = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)([]);
    async getStarted() {
        (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setColour("203554");
        const res = await (0, $b7215fe592db8ea7$export$c44a731078af0b81)().catch((err)=>{
            console.error(err);
        });
        if (res?.data) (0, $c9048c433f8ddaa9$export$17c3d14100f89581).updateContentTiles(res.data.content);
    }
    onButtonClick() {
        (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setCurrentStep((0, $994acc88dfceac67$export$46542447417a4445).DETAILS);
        (0, $87a40fad12754c0d$export$971646e43cc4a11b)((0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).DETAILS]);
    }
}



//illustration
var $66ac7d40f95dc822$exports = {};
$66ac7d40f95dc822$exports = import.meta.resolve("gREvh");


var $2266e2b03eac0cfa$exports = {};
$2266e2b03eac0cfa$exports = import.meta.resolve("ippnK");


var $f2dcab3bd4130b1e$exports = {};
$f2dcab3bd4130b1e$exports = import.meta.resolve("c4DOq");


var $5c96630d33cee100$exports = {};
$5c96630d33cee100$exports = import.meta.resolve("d2SJN");





var $aqdBs = parcelRequire("aqdBs");


/**
 * Load navigate into navigator service, needs to be called on route level components to allow programmatic navigation
 * useNavigates navigate function is hoisted to global scope by this hook so can navigateTo can be called anywhere
 * in the app
 */ const $16173df52a25ecc6$var$useNavigatorSetup = ()=>{
    const navigate = (0, $341c792fffde747f$export$9770f232ac06a008)();
    (0, $aqdBs.useEffect)(()=>{
        (0, $87a40fad12754c0d$export$73e05a5d9169884)(navigate);
    }, [
        navigate
    ]);
};
var $16173df52a25ecc6$export$2e2bcd8739ae039 = $16173df52a25ecc6$var$useNavigatorSetup;



var $aqdBs = parcelRequire("aqdBs");
const $187df3f279454e87$var$useScrollToTop = ()=>{
    (0, $aqdBs.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
};
var $187df3f279454e87$export$2e2bcd8739ae039 = $187df3f279454e87$var$useScrollToTop;



const $33b694e50d542f45$var$GetStarted = ({})=>{
    const [GSM] = (0, $aqdBs.useState)(()=>new (0, $33faf7692bf52aba$export$77e0a965259136c6)());
    (0, $187df3f279454e87$export$2e2bcd8739ae039)();
    (0, $16173df52a25ecc6$export$2e2bcd8739ae039)();
    (0, $aqdBs.useEffect)(()=>{
        GSM.getStarted();
    }, []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "get-started-page page-container",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "get-started-container",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                        className: "get-started-illustration",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($66ac7d40f95dc822$exports))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                        className: "get-started-heading",
                        children: GSM.title
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                        className: "get-started-sub-heading",
                        children: GSM.subtitle
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                        className: "get-started-information",
                        children: GSM.information
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                        className: "get-started-button",
                        content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                            children: [
                                GSM.button,
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ARROW_LEFT,
                                    className: "right-arrow",
                                    color: "var(--thriveWhite)",
                                    sizeInPx: "14"
                                })
                            ]
                        }),
                        ariaLabel: GSM.button,
                        onButtonClick: GSM.onButtonClick
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "video-mobile-app",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("video", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5c96630d33cee100$exports))),
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    playsInline: true,
                    "aria-hidden": "true",
                    tabIndex: -1
                })
            })
        ]
    });
};
var $33b694e50d542f45$export$2e2bcd8739ae039 = $33b694e50d542f45$var$GetStarted;




var $aqdBs = parcelRequire("aqdBs");


const $46f0fe630b3c2459$var$freeEmailProviders = [
    "gmail.com",
    "googlemail.com",
    "yahoo.com",
    "ymail.com",
    "rocketmail.com",
    "outlook.com",
    "hotmail.com",
    "live.com",
    "msn.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "qq.com",
    "163.com",
    "126.com",
    "mail.ru",
    "rambler.ru",
    "yandex.com",
    "gmx.com",
    "gmx.net",
    "web.de",
    "t-online.de",
    "freenet.de",
    "mail.com",
    "inbox.com",
    "protonmail.com",
    "proton.me",
    "aol.com",
    "att.net",
    "bellsouth.net",
    "sbcglobal.net",
    "verizon.net",
    "comcast.net",
    "cox.net",
    "earthlink.net",
    "juno.com",
    "charter.net",
    "hotmail.co.uk",
    "hotmail.fr",
    "hotmail.de",
    "yahoo.co.uk",
    "yahoo.ca",
    "yahoo.com.au",
    "yahoo.co.jp",
    "yahoo.co.id",
    "yahoo.com.sg",
    "zoho.com",
    "fastmail.com",
    "tutanota.com",
    "mailfence.com",
    "safe-mail.net",
    "hushmail.com",
    "iname.com",
    "lavabit.com",
    "pobox.com",
    "1mail.net",
    "1freeemail.com",
    "email.com",
    "bigstring.com",
    "games.com",
    "love.com",
    "wow.com",
    "ygm.com",
    "optonline.net",
    "ntlworld.com",
    "shaw.ca",
    "optusnet.com.au",
    "telenet.be",
    "planet.nl",
    "aliceadsl.fr",
    "club-internet.fr",
    "voila.fr",
    "blueyonder.co.uk",
    "sky.com",
    "zonnet.nl",
    "tin.it",
    "live.it",
    "arcor.de",
    "hetnet.nl"
];
const $46f0fe630b3c2459$export$c38c3b2fe15c12d6 = (email)=>{
    // Basic email format check
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    if (!emailRegex.test(email)) return 'Invalid_Email';
    // Extract domain
    const domain = email.split("@")[1].toLowerCase();
    // Reject free providers
    return $46f0fe630b3c2459$var$freeEmailProviders.includes(domain) ? 'Free_Email' : 'Work_Email';
};
const $46f0fe630b3c2459$export$ee1eddc83cf94aa9 = (value)=>{
    return /\s/.test(value);
};
const $46f0fe630b3c2459$export$4d2a7159fda5dc93 = (value)=>{
    let passwordIncludes = [];
    // At least one uppercase & lowercase char
    if (/[A-Z]/.test(value) && /[a-z]/.test(value)) passwordIncludes.push('uppercaseAndLowercase');
    // At least one number used
    if (/\d/.test(value)) passwordIncludes.push('number');
    // At least ene special char
    if (/[^A-Za-z0-9]+/.test(value)) passwordIncludes.push('specialChar');
    // Minimum 8 characters
    if (value.length > 8) passwordIncludes.push('maxLength');
    return {
        passwordIsValid: passwordIncludes.length === 4,
        passwordIncludes: passwordIncludes
    };
};





class $bd6d7f18d512f6f2$export$7aca2f7df3551cb6 {
    title = 'Tell us about you';
    subtitle = 'We just need a few details to set up your demo workspace.';
    userFormHeading = 'YOU';
    workspaceFormHeading = "YOUR WORKSPACE";
    button = "Create app & continue";
    buttonIsDisabled = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(true);
    //FORM VALS
    firstName = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    lastName = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    workspaceName = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    password = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    emailAddress = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    emailError = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    validationCode = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)("");
    termsAndConditionsAgreed = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    passwordIsValid = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    passwordElementsCompleted = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)([]);
    industry = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(undefined);
    //validation
    validateCases = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    validateNumber = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    validateSpecialChar = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    validateLength = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    showValidationModal = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    showTermsAndConditionsModal = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    errorList = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)([]);
    formHasBeenChanged = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    codeIsInvalid = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    countdown = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(0);
    resendTimer;
    addError = (field)=>{
        if (!this.errorList.value.includes(field)) this.errorList.update([
            ...this.errorList.value,
            field
        ]);
    };
    removeError = (field)=>{
        this.errorList.update(this.errorList.value.filter((e)=>e !== field));
    };
    validateField = (field)=>{
        switch(field){
            case "firstName":
                if (this.firstName.value.trim().length === 0) this.addError(field);
                else this.removeError(field);
                break;
            case "lastName":
                if (this.lastName.value.trim().length === 0) this.addError(field);
                else this.removeError(field);
                break;
            case "emailAddress":
                if (this.emailAddress.value.trim().length === 0) {
                    this.emailError.update("Valid email address is required");
                    this.addError(field);
                } else this.removeError(field);
                break;
            case "emailAddressValidity":
                if (this.emailAddress.value.trim().length === 0 || !this.emailAddress.value.includes("@")) {
                    this.emailError.update("Valid email address is required");
                    this.addError("emailAddress");
                } else this.removeError("emailAddress");
                break;
            case "workspaceName":
                if (this.workspaceName.value.trim().length === 0) this.addError(field);
                else this.removeError(field);
                break;
            case "password":
                if (!this.passwordIsValid.value) this.addError(field);
                else this.removeError(field);
                break;
            case "industry":
                if (!this.industry.value) this.addError(field);
                else this.removeError(field);
                break;
        }
    };
    updateField = (observable, val, field)=>{
        observable.update(val);
        this.validateField(field);
        this.checkIfButtonIsDisabled();
        this.formHasBeenChanged.update(true);
    };
    hasValue(value) {
        return value !== undefined && value !== null && value.trim().length > 0;
    }
    setFirstname = (val)=>{
        this.updateField(this.firstName, val, "firstName");
    };
    setLastname = (val)=>{
        this.updateField(this.lastName, val, "lastName");
    };
    setEmailAddress = (val)=>{
        this.emailError.update("");
        this.updateField(this.emailAddress, val, "emailAddress");
    };
    setWorkspaceName = (val)=>{
        this.updateField(this.workspaceName, val, "workspaceName");
    };
    setTermsAndConditionsAgreed = (isAgreed)=>{
        this.termsAndConditionsAgreed.update(isAgreed);
        this.checkIfButtonIsDisabled();
        this.formHasBeenChanged.update(true);
    };
    setIndustry = (industry)=>{
        this.industry.update(industry);
        this.validateField("industry");
        this.checkIfButtonIsDisabled();
        this.formHasBeenChanged.update(true);
    };
    setPassword = (val)=>{
        this.password.update(val);
        (0, $46f0fe630b3c2459$export$4d2a7159fda5dc93)(val);
        const { passwordIsValid: passwordIsValid, passwordIncludes: passwordIncludes } = (0, $46f0fe630b3c2459$export$4d2a7159fda5dc93)(val);
        // update password validation observables
        this.passwordIsValid.update(passwordIsValid);
        this.passwordElementsCompleted.update(passwordIncludes);
        this.validateCases.update(passwordIncludes.includes('uppercaseAndLowercase'));
        this.validateNumber.update(passwordIncludes.includes('number'));
        this.validateSpecialChar.update(passwordIncludes.includes('specialChar'));
        this.validateLength.update(passwordIncludes.includes('maxLength'));
        this.checkIfButtonIsDisabled();
    };
    checkIfButtonIsDisabled = ()=>{
        const isFormComplete = this.hasValue(this.firstName.value) && this.hasValue(this.lastName.value) && this.hasValue(this.emailAddress.value) && this.hasValue(this.workspaceName.value) && this.hasValue(this.password.value) && this.industry.value !== undefined && this.termsAndConditionsAgreed.value;
        const isPasswordValid = this.passwordIsValid.value;
        this.buttonIsDisabled.update(!(isFormComplete && isPasswordValid));
    };
    onAgreeClick = ()=>{
        this.setShowTermsAndConditionsModal(false);
        this.termsAndConditionsAgreed.update(true);
    };
    setShowTermsAndConditionsModal = (show)=>{
        this.showTermsAndConditionsModal.update(show);
    };
    setValidationCode = (code)=>{
        this.codeIsInvalid.update(false);
        this.validationCode.update(code);
    };
    onButtonClick = async ()=>{
        const res = await (0, $b7215fe592db8ea7$export$61eec6b36fede6fe)({
            emailAddress: this.emailAddress.value,
            firstName: this.firstName.value
        }).catch((error)=>{
            this.emailError.update(error.response?.data?.message || "Something went wrong with validating your email");
            this.addError("emailAddress");
        });
        if (res?.status === 200) this.showValidationModal.update(true);
    };
    onHideValidationModal = ()=>{
        this.showValidationModal.update(false);
        this.codeIsInvalid.update(false);
    };
    startResendCountdown = ()=>{
        this.countdown.update(30);
        if (this.resendTimer) clearInterval(this.resendTimer);
        this.resendTimer = setInterval(()=>{
            const current = this.countdown.value;
            if (current <= 1) {
                clearInterval(this.resendTimer);
                this.countdown.update(0);
            } else this.countdown.update(current - 1);
        }, 1000);
    };
    onResendCodeClick = ()=>{
        this.startResendCountdown();
        this.onButtonClick();
    };
    onValidateClick = async ()=>{
        const params = {
            code: this.validationCode.value,
            companyName: this.workspaceName.value,
            industry: this.industry.value
        };
        const res = await (0, $b7215fe592db8ea7$export$9e1b0960750c7d85)(params).catch(()=>{
            this.codeIsInvalid.update(true);
        });
        if (res?.data) {
            //update form
            const form = {
                code: this.validationCode.value,
                firstName: this.firstName.value,
                lastName: this.lastName.value,
                emailAddress: this.emailAddress.value,
                password: this.password.value,
                companyName: this.workspaceName.value,
                numberOfEmployees: 1,
                phoneNumber: "00000000000",
                industry: this.industry.value
            };
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setUpdateCode(this.validationCode.value);
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).saveUserDetailsToForm(form);
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).updateContentTiles(res.data.content);
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setAppName(res.data.appName);
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setOrgShortName(res.data.orgShortName);
            //navigate to next step
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setCurrentStep((0, $994acc88dfceac67$export$46542447417a4445).DESIGN);
            (0, $87a40fad12754c0d$export$971646e43cc4a11b)((0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).DESIGN]);
        }
    };
}




parcelRequire("aqdBs");


parcelRequire("aqdBs");


parcelRequire("aqdBs");
const $afa447d0bd83a314$export$71c56c718a357b5 = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
    children: [
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "TheAppBuilder Ltd \u2013 Terms of Service"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "Thank you for choosing TheAppBuilder. These Terms of Service, together with the Services Order Form, set out the terms and conditions on which TheAppBuilder Ltd provides its subscription software services and professional services. Please read this document carefully."
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "1. Definitions"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "1.1. Except to the extent expressly provided otherwise, in these Terms of Service:"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CAccount\u201D means an account enabling a Client Administrative User to access and use the Hosted Services (including accounts for different types of Client Administrative User with varying access privileges);"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CAffiliate\u201D means an entity that Controls, is Controlled by, or is under common Control with the relevant entity;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CAgreement\u201D means the agreement between the Provider and the Client for the provision of Services, comprising one or more Services Order Forms, these Terms of Service, and their respective annexes and schedules;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CBusiness Day\u201D means any weekday other than a bank or public holiday in England;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CBusiness Hours\u201D means the hours of 09:00 to 17:00 GMT/BST on a Business Day;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CCCN\u201D means a change control notice issued in accordance with Clause 10;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CCCN Consideration Period\u201D means the period of 10 Business Days following the receipt by a party of the relevant CCN from the other party;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CChange\u201D means any change to the scope of the Services;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CCharges\u201D means all of the amounts specified in the relevant Services Order Form for the Services;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CClient\u201D means the person or entity identified as such on the Services Order Form;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CClient Administrative User\u201D means any and all persons, whether or not employees of the Client, authorised by the Client to use the Platform and/or Hosted Services via an Account;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CClient Content\u201D means all content (including information, data, articles, documents, brochures, presentations, pictures, images, videos, audio visual works, other informational materials and any comments) provided to the Provider by the Client in connection with the Services; uploaded to or stored on the Platform by the Client; transmitted by the Platform at the instigation of the Client; supplied by the Client to the Provider for uploading to, transmission by or storage on the Platform; or generated by the Platform as a result of the use of the Hosted Services by the Client;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CClient Indemnity Event\u201D has the meaning given to it in Clause 17.5;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CClient Personal Data\u201D means any Personal Data that is processed by the Provider as a processor on behalf of the Client in the course of providing the Services, as described more fully in Schedule 6 (Data processing information);"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CClient Systems\u201D means the hardware and software systems of the Client that interact with, or may reasonably be expected to interact with, the Hosted Services;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CConfidential Information\u201D means:"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "(a) any information disclosed directly or indirectly by one party (the \u201Cdisclosing party\u201D) to the other party (the \u201C recipient\u201D) at any time before the termination of the Agreement (whether disclosed in writing, orally or otherwise) that at the time of disclosure:"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "(i) was marked or described as \u201Cconfidential\u201D; or"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "(ii) should have been reasonably understood by the recipient to be confidential; and"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "(b) the Client Content (which shall be the Confidential Information of the Client; and"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "(c) the terms of the Agreement (which shall be the Confidential Information of the Provider);"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CControl\u201D means the legal power to control (directly or indirectly) the management of an entity (and \u201CControlled\u201D should be construed accordingly);"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CCreated App(s)\u201D means any mobile software application(s) created by the Client using the Hosted Services, with or without assistance from the Provider;"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
            children: "\u201CCustomization\u201D means a customization of the Hosted Services by the Provider for the Client, whether made through the development, configuration or integration of software or otherwise;"
        })
    ]
});



const $d26dc023962be031$var$TermsAndConditionsModal = ({ showModal: showModal, onHideModal: onHideModal, onAgreeClick: onAgreeClick })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1111679e247bdc13$export$2e2bcd8739ae039), {
        showModal: showModal,
        canEscapeClose: true,
        className: "terms-and-conditions-modal",
        headerContent: "Terms & Conditions",
        bodyContent: (0, $afa447d0bd83a314$export$71c56c718a357b5),
        footerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                className: "i-agree-button",
                content: "I Agree",
                ariaLabel: "I Agree",
                onButtonClick: onAgreeClick
            })
        }),
        onCloseClick: onHideModal
    });
};
var $d26dc023962be031$export$2e2bcd8739ae039 = $d26dc023962be031$var$TermsAndConditionsModal;


const $e2fb0d15e5938506$var$TermsAndConditions = ({ termsAndConditionsAgreed: termsAndConditionsAgreed, setTermsAndConditionsAgreed: setTermsAndConditionsAgreed, setShowTermsAndConditionsModal: setShowTermsAndConditionsModal, showTermsAndConditionsModal: showTermsAndConditionsModal, setHideTermsAndConditionsModal: setHideTermsAndConditionsModal })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "terms-and-conditions-wrapper",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $40073b7c6bbbe3b7$export$2e2bcd8739ae039), {
                id: "terms-and-conditions-checkbox",
                isChecked: termsAndConditionsAgreed,
                onChange: ()=>setTermsAndConditionsAgreed(!termsAndConditionsAgreed),
                label: "I agree to the"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                content: "Terms & Conditions",
                className: "terms-and-conditions-button",
                ariaLabel: "Terms & Conditions",
                onButtonClick: setShowTermsAndConditionsModal
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d26dc023962be031$export$2e2bcd8739ae039), {
                onAgreeClick: ()=>{
                    setTermsAndConditionsAgreed(true);
                    setHideTermsAndConditionsModal();
                },
                showModal: showTermsAndConditionsModal,
                onHideModal: setHideTermsAndConditionsModal
            })
        ]
    });
};
var $e2fb0d15e5938506$export$2e2bcd8739ae039 = $e2fb0d15e5938506$var$TermsAndConditions;




var $aqdBs = parcelRequire("aqdBs");
var $c157f72660e35fc8$export$fbfbcccba0238ac9 = /*#__PURE__*/ function(IndustryType) {
    IndustryType["LocalAuthority"] = "Local Authority";
    IndustryType["Healthcare"] = "Healthcare";
    IndustryType["Construction"] = "Construction";
    IndustryType["Facilities"] = "Facilities Management";
    IndustryType["Retail"] = "Retail";
    IndustryType["FMCG"] = "FMCG";
    IndustryType["Manufacturing"] = "Manufacturing";
    IndustryType["Engineering"] = "Engineering";
    IndustryType["EmergencyServices"] = "Emergency Services";
    IndustryType["Transport"] = "Transportation";
    IndustryType["Hospitality"] = "Hospitality";
    IndustryType["Other"] = "Other";
    return IndustryType;
}({});




var $aqdBs = parcelRequire("aqdBs");
const $7c38a68248735307$export$40bf77e055859e12 = (elementShowing, ref, onHideElement)=>{
    (0, $aqdBs.useEffect)(()=>{
        const handleMouseDown = (event)=>{
            if (elementShowing && ref.current && !ref.current.contains(event.target)) onHideElement();
        };
        document.addEventListener("click", handleMouseDown);
        return ()=>{
            document.removeEventListener("click", handleMouseDown);
        };
    }, [
        elementShowing
    ]);
};


const $ac4112311088ff35$var$SelectIndustry = ({ industry: industry, setIndustry: setIndustry, validateIndustry: validateIndustry, showError: showError })=>{
    const [showIndustryDropdown, setShowIndustryDropdown] = (0, $aqdBs.useState)(false);
    const dropdownRef = (0, $aqdBs.useRef)(null);
    const industryDropdown = (0, $aqdBs.useMemo)(()=>{
        return Object.entries((0, $c157f72660e35fc8$export$fbfbcccba0238ac9)).map(([key, value])=>({
                content: value,
                onClick: ()=>{
                    setIndustry(key);
                    setShowIndustryDropdown(false);
                },
                isSelected: industry === key,
                key: key
            }));
    }, [
        industry
    ]);
    (0, $7c38a68248735307$export$40bf77e055859e12)(showIndustryDropdown, dropdownRef, ()=>{
        setShowIndustryDropdown(false), validateIndustry();
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: `select-industry input-wrapper ${showError ? "error-styling" : ""}`,
            ref: dropdownRef,
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "select-industry-label",
                    children: "Industry"
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                    className: `select-industry-button`,
                    ariaLabel: "Select your workspace's industry",
                    onButtonClick: ()=>setShowIndustryDropdown(!showIndustryDropdown),
                    content: (0, $c157f72660e35fc8$export$fbfbcccba0238ac9)[industry] || /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                        children: [
                            "Select an industry",
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                                iconName: (0, $99899ff752f57db8$export$356109f9df11377f).CHEVRON_DOWN,
                                className: "down-caret",
                                color: "var(--thriveGreyDark)",
                                sizeInPx: "12"
                            })
                        ]
                    })
                }),
                showError && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "error-indicator",
                    children: "Industry is required"
                }),
                showIndustryDropdown && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $87c2d16114fb0356$export$2e2bcd8739ae039), {
                    buttons: industryDropdown,
                    className: "industry-select-button-list",
                    allButtonOnClick: ()=>setShowIndustryDropdown(false)
                })
            ]
        })
    });
};
var $ac4112311088ff35$export$2e2bcd8739ae039 = $ac4112311088ff35$var$SelectIndustry;



parcelRequire("aqdBs");

//interfaces


const $5bf5060420f61464$var$LinkStyleButton = ({ content: content, className: className, isDisabled: isDisabled = false, ariaLabel: ariaLabel, onButtonClick: onButtonClick, isLink: isLink, linkUrl: linkUrl })=>{
    if (isLink) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("a", {
        className: `link-style-button ${className} ${isDisabled && "disabled-style-link"}`,
        "aria-label": ariaLabel,
        href: linkUrl,
        children: content
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        className: `link-style-button ${className} ${isDisabled && "disabled-style-link"}`,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        onClick: onButtonClick,
        children: content
    });
};
var $5bf5060420f61464$export$2e2bcd8739ae039 = $5bf5060420f61464$var$LinkStyleButton;



const $1a0430c815fb52cf$var$ValidationModal = ({ showModal: showModal, onHideModal: onHideModal, emailAddress: emailAddress, code: code, countDown: countDown, setCode: setCode, onResendCodeClick: onResendCodeClick, onValidateClick: onValidateClick, invalidCode: invalidCode })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1111679e247bdc13$export$2e2bcd8739ae039), {
        showModal: showModal,
        canEscapeClose: true,
        className: "validation-modal",
        headerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    className: "email-icon",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).MAIL,
                        sizeInPx: "24",
                        color: "var(--thrivePink"
                    })
                }),
                "Verify your email"
            ]
        }),
        bodyContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: "code-explainer",
            children: [
                "We've sent a 6 digit code to",
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "email-address",
                    children: emailAddress || "email address"
                })
            ]
        }),
        footerContent: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d61fe6f2232d7722$export$2e2bcd8739ae039), {
                    codeLength: 6,
                    size: 40,
                    onChange: setCode
                }),
                invalidCode && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "error-indicator",
                    children: "Code is invalid, try again"
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                    className: "verify-button",
                    content: "Verify",
                    ariaLabel: "Verify",
                    isDisabled: code.length < 6,
                    onButtonClick: onValidateClick
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "resend-information",
                    children: [
                        "Didn't receive a code?",
                        countDown !== 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                            className: "resend-countdown",
                            children: [
                                "Resend code in ",
                                countDown,
                                "s"
                            ]
                        }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                            className: "resend-code-button",
                            content: "Resend code",
                            ariaLabel: "Resend code",
                            onButtonClick: onResendCodeClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5bf5060420f61464$export$2e2bcd8739ae039), {
                    content: "Go back",
                    className: "go-back-button",
                    ariaLabel: "Close modal",
                    onButtonClick: onHideModal
                })
            ]
        }),
        onCloseClick: onHideModal
    });
};
var $1a0430c815fb52cf$export$2e2bcd8739ae039 = $1a0430c815fb52cf$var$ValidationModal;



parcelRequire("aqdBs");


parcelRequire("aqdBs");

const $999e5a0122079bf7$var$PasswordValidationIndicators = ({ validateCases: validateCases, validateNumber: validateNumber, validateSpecialChar: validateSpecialChar, validateLength: validateLength })=>{
    const renderItem = (isValid, text)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("li", {
            className: isValid ? "valid" : "invalid",
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                    sizeInPx: "10",
                    iconName: isValid ? (0, $99899ff752f57db8$export$356109f9df11377f).CHECK : (0, $99899ff752f57db8$export$356109f9df11377f).DASH,
                    color: isValid ? "var(--thriveGreen)" : "var(--thriveGreyDark)"
                }),
                text
            ]
        });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("ul", {
        className: "password-includes-validation",
        children: [
            renderItem(validateCases, "Upper & lowercase letters"),
            renderItem(validateNumber, "At least one number"),
            renderItem(validateSpecialChar, "At least one special character"),
            renderItem(validateLength, "Minimum 8 characters")
        ]
    });
};
var $999e5a0122079bf7$export$2e2bcd8739ae039 = $999e5a0122079bf7$var$PasswordValidationIndicators;


const $894b5a01761bbc7d$var$Password = ({ showError: showError, setPassword: setPassword, password: password, validateField: validateField, validateCases: validateCases, validateNumber: validateNumber, validateSpecialChar: validateSpecialChar, validateLength: validateLength })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: `${showError ? "error-styling" : ""}`,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $7826de2efe53ea39$export$2e6ece086e693fb), {
                    id: "create-password",
                    label: "Password",
                    isPassword: true,
                    setValue: setPassword,
                    defaultValue: password,
                    placeholder: "",
                    onBlur: validateField
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $999e5a0122079bf7$export$2e2bcd8739ae039), {
                validateCases: validateCases,
                validateNumber: validateNumber,
                validateSpecialChar: validateSpecialChar,
                validateLength: validateLength
            })
        ]
    });
};
var $894b5a01761bbc7d$export$2e2bcd8739ae039 = $894b5a01761bbc7d$var$Password;



parcelRequire("aqdBs");

const $1394791459670163$var$FormTextInput = ({ id: id, label: label, value: value, setValue: setValue, errorMessage: errorMessage, onBlur: onBlur, type: type, showError: showError, placeholder: placeholder = "" })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "input-wrapper",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e6534d004b9f2161$export$2e2bcd8739ae039), {
                id: id,
                labelText: label,
                placeholderText: placeholder,
                textString: value,
                setTextString: setValue,
                type: type || "text",
                className: showError ? "error-styling" : "",
                onBlur: onBlur,
                maxLength: 265
            }),
            showError && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "error-indicator",
                children: errorMessage
            })
        ]
    });
};
var $1394791459670163$export$2e2bcd8739ae039 = $1394791459670163$var$FormTextInput;



var $aqdBs = parcelRequire("aqdBs");
function $4fcc4b05ac470037$export$d9c11dc682bb51a1(show) {
    (0, $aqdBs.useEffect)(()=>{
        if (!show) return;
        const handleBeforeUnload = (event)=>{
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        show
    ]);
}






const $6d04aed25cfde5d1$var$Details = ()=>{
    (0, $16173df52a25ecc6$export$2e2bcd8739ae039)();
    const [DM] = (0, $aqdBs.useState)(()=>new (0, $bd6d7f18d512f6f2$export$7aca2f7df3551cb6)());
    //inputs
    const emailAddress = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.emailAddress);
    const password = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.password);
    const countdown = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.countdown);
    const industry = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.industry);
    const termsAndConditionsAgreed = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.termsAndConditionsAgreed);
    const validationCode = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.validationCode);
    //validation
    const validateCases = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.validateCases);
    const validateNumber = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.validateNumber);
    const validateSpecialChar = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.validateSpecialChar);
    const validateLength = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.validateLength);
    const buttonIsDisabled = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.buttonIsDisabled);
    const errorList = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.errorList);
    const emailError = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.emailError);
    const formHasBeenChanged = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.formHasBeenChanged);
    const codeIsInvalid = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.codeIsInvalid);
    //modals
    const showTermsAndConditionsModal = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.showTermsAndConditionsModal);
    const showValidationModal = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.showValidationModal);
    (0, $4fcc4b05ac470037$export$d9c11dc682bb51a1)(formHasBeenChanged);
    (0, $187df3f279454e87$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "details-page page-container",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "details-container",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                        className: "details-heading",
                        children: DM.title
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                        className: "details-sub-heading",
                        children: DM.subtitle
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("form", {
                        className: "reg-form",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                className: "details-form-heading",
                                children: DM.userFormHeading
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                className: "name-input-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1394791459670163$export$2e2bcd8739ae039), {
                                        id: "first-name",
                                        label: "First Name",
                                        value: DM.firstName.value,
                                        setValue: DM.setFirstname,
                                        errorMessage: "First name is required",
                                        onBlur: ()=>DM.validateField("firstName"),
                                        showError: !!errorList.includes("firstName")
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1394791459670163$export$2e2bcd8739ae039), {
                                        id: "last-name",
                                        label: "Last Name",
                                        value: DM.lastName.value,
                                        setValue: DM.setLastname,
                                        errorMessage: "Last name is required",
                                        onBlur: ()=>DM.validateField("lastName"),
                                        showError: !!errorList.includes("lastName")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1394791459670163$export$2e2bcd8739ae039), {
                                id: "email-address",
                                label: "Email Address",
                                type: "email",
                                value: emailAddress,
                                setValue: DM.setEmailAddress,
                                errorMessage: emailError,
                                onBlur: ()=>DM.validateField("emailAddressValidity"),
                                showError: !!errorList.includes("emailAddress")
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $894b5a01761bbc7d$export$2e2bcd8739ae039), {
                                showError: !!errorList.includes("password"),
                                setPassword: DM.setPassword,
                                password: password,
                                validateField: ()=>DM.validateField("password"),
                                validateCases: validateCases,
                                validateNumber: validateNumber,
                                validateSpecialChar: validateSpecialChar,
                                validateLength: validateLength
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                className: "details-form-heading",
                                children: DM.workspaceFormHeading
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1394791459670163$export$2e2bcd8739ae039), {
                                id: "workspace-name",
                                label: "Workspace Name",
                                value: DM.workspaceName.value,
                                placeholder: "e.g yourcompanyname",
                                setValue: DM.setWorkspaceName,
                                errorMessage: "Workspace name is required",
                                onBlur: ()=>DM.validateField("workspaceName"),
                                showError: !!errorList.includes("workspaceName")
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ac4112311088ff35$export$2e2bcd8739ae039), {
                                industry: industry,
                                setIndustry: (value)=>DM.setIndustry(value),
                                showError: !!errorList.includes("industry"),
                                validateIndustry: ()=>DM.validateField("industry")
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e2fb0d15e5938506$export$2e2bcd8739ae039), {
                                termsAndConditionsAgreed: termsAndConditionsAgreed,
                                setTermsAndConditionsAgreed: DM.setTermsAndConditionsAgreed,
                                setShowTermsAndConditionsModal: ()=>DM.setShowTermsAndConditionsModal(!showTermsAndConditionsModal),
                                showTermsAndConditionsModal: showTermsAndConditionsModal,
                                setHideTermsAndConditionsModal: ()=>DM.setShowTermsAndConditionsModal(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                        className: `details-button`,
                        content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                            children: [
                                DM.button,
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ARROW_LEFT,
                                    className: "right-arrow",
                                    color: "var(--thriveWhite)",
                                    sizeInPx: "14"
                                })
                            ]
                        }),
                        ariaLabel: DM.button,
                        onButtonClick: DM.onButtonClick,
                        isDisabled: buttonIsDisabled
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1a0430c815fb52cf$export$2e2bcd8739ae039), {
                showModal: showValidationModal,
                onHideModal: ()=>DM.onHideValidationModal(),
                emailAddress: emailAddress,
                code: validationCode,
                countDown: countdown,
                setCode: DM.setValidationCode,
                onResendCodeClick: ()=>DM.onResendCodeClick(),
                onValidateClick: ()=>DM.onValidateClick(),
                invalidCode: codeIsInvalid
            })
        ]
    });
};
var $6d04aed25cfde5d1$export$2e2bcd8739ae039 = $6d04aed25cfde5d1$var$Details;




var $aqdBs = parcelRequire("aqdBs");





class $2f6d89a4a364aaf5$export$4d71f70c1bf344cd {
    title = 'Customise your demo app';
    subtitle = 'Pick a colour and rearrange tiles to make it yours.';
    reorderButton = "Reorder tiles";
    button = "Save & continue";
    showReorderContentTilesModal = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    loading = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    showErrorBanner = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    onReorderTilesClick = ()=>{
        this.showReorderContentTilesModal.update(true);
    };
    hideReorderContentTilesModal = ()=>{
        this.showReorderContentTilesModal.update(false);
    };
    onSaveContentOrderClick = (content)=>{
        (0, $c9048c433f8ddaa9$export$17c3d14100f89581).updateContentTiles(content);
        this.showReorderContentTilesModal.update(false);
    };
    showTemporaryError = ()=>{
        this.showErrorBanner.update(true);
        setTimeout(()=>{
            this.showErrorBanner.update(false);
        }, 6000);
    };
    onContinueClick = async ()=>{
        const form = (0, $c9048c433f8ddaa9$export$17c3d14100f89581).createAppForm.value;
        if (!form) return;
        this.loading.update(true);
        const res = await (0, $b7215fe592db8ea7$export$4e373c34abfa8c68)(form).catch(()=>{
            this.showTemporaryError();
            this.loading.update(false);
        });
        if (res?.data) {
            this.loading.update(false);
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).updateCmsUrl(res.data.loginUrl);
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setOrgShortName(res.data.orgShortName);
            //navigate to next step
            (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setCurrentStep((0, $994acc88dfceac67$export$46542447417a4445).DOWNLOAD);
            (0, $87a40fad12754c0d$export$971646e43cc4a11b)((0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).DOWNLOAD]);
        }
    };
}









const $97e9b630cb3b7fc4$var$Design = ()=>{
    const [DM] = (0, $aqdBs.useState)(()=>new (0, $2f6d89a4a364aaf5$export$4d71f70c1bf344cd)());
    const showModal = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.showReorderContentTilesModal);
    const colour = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)((0, $c9048c433f8ddaa9$export$17c3d14100f89581).colour);
    const fontColour = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)((0, $c9048c433f8ddaa9$export$17c3d14100f89581).fontColour);
    const contentTiles = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)((0, $c9048c433f8ddaa9$export$17c3d14100f89581).contentTiles);
    const appName = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)((0, $c9048c433f8ddaa9$export$17c3d14100f89581).appName);
    const loading = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.loading);
    const showBanner = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.showErrorBanner);
    (0, $aqdBs.useEffect)(()=>{
        (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setColour("203554");
    }, []);
    (0, $16173df52a25ecc6$export$2e2bcd8739ae039)();
    (0, $4fcc4b05ac470037$export$d9c11dc682bb51a1)(true);
    (0, $187df3f279454e87$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "design-page page-container",
        style: {
            "--brandColor": `#${colour}`,
            "--brandFontColor": fontColour
        },
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "design-container",
                children: loading ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                    size: 10
                }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                            className: "design-heading",
                            children: DM.title
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                            className: "design-sub-heading",
                            children: DM.subtitle
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5bfe664b76233744$export$2e2bcd8739ae039), {
                            colour: colour,
                            setColour: (0, $c9048c433f8ddaa9$export$17c3d14100f89581).setColour
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                            className: `reorder-button`,
                            content: DM.reorderButton,
                            ariaLabel: DM.reorderButton,
                            onButtonClick: DM.onReorderTilesClick
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                            className: `design-button`,
                            content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                children: [
                                    DM.button,
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                                        iconName: (0, $99899ff752f57db8$export$356109f9df11377f).ARROW_LEFT,
                                        className: "right-arrow",
                                        color: "var(--thriveWhite)",
                                        sizeInPx: "14"
                                    })
                                ]
                            }),
                            ariaLabel: DM.button,
                            onButtonClick: DM.onContinueClick
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $fbf70050c337e031$export$2e2bcd8739ae039), {
                            showModal: showModal,
                            onHideModal: DM.hideReorderContentTilesModal,
                            setContentTileOrder: DM.onSaveContentOrderClick,
                            contentTiles: contentTiles
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d8a6047e9aec9794$export$2e2bcd8739ae039), {
                appContent: contentTiles,
                appName: appName
            }),
            showBanner && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6b55b7249683e3c7$export$2e2bcd8739ae039), {
                feedbackType: (0, $4c5a25ac8a95113d$export$9142130869e22063).ERROR,
                feedbackMessage: "Something went wrong"
            })
        ]
    });
};
var $97e9b630cb3b7fc4$export$2e2bcd8739ae039 = $97e9b630cb3b7fc4$var$Design;




var $aqdBs = parcelRequire("aqdBs");



function $8e7f83eb78a740d0$export$257b2d10b709d8ef(params) {
    const payload = `grant_type=password&username=${encodeURIComponent(params.username)}&password=${encodeURIComponent(params.password)}`;
    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Organization: params.orgShortName,
        Authorisation: null
    };
    return (0, $4db43c6ab8dfea40$export$2e2bcd8739ae039).post(`/token`, payload, {
        headers: headers
    });
}




function $e1e012f89018bf3e$export$929c25f09f7eb20() {
    switch((0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).ENVIRONMENT){
        case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).QA:
            return `https://appcenter.tab-qa.com/apps/thrive-test-android/`;
        case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).PRODUCTION:
            return "https://play.google.com/store/apps/details?id=com.thriveapp.thriveapp";
        case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).FEATURE:
            return `https://appcenter.${(0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).FEATURENAME}.tab-feature.com/apps/tf-${(0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).FEATURENAME}-android/`;
        default:
            return "##AndroidStoreUrl##";
    }
}
function $e1e012f89018bf3e$export$c068cf9cc4ccb363() {
    switch((0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).ENVIRONMENT){
        case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).QA:
            return `https://appcenter.tab-qa.com/apps/thrive-test-ios/`;
        case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).PRODUCTION:
            return "https://apps.apple.com/gb/app/thrive-app/id1513335003";
        case (0, $e1c9151c0619a5ff$export$2332bccde38c8493).FEATURE:
            return `https://appcenter.${(0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).FEATURENAME}.tab-feature.com/apps/tf-${(0, $e1c9151c0619a5ff$export$a7b6bc01c63cdfc3).FEATURENAME}-ios/`;
        default:
            return "##AppStoreUrl##";
    }
}



class $84ac23f9ae43ea96$export$fc63070cd68706d2 {
    title = 'See your customised workspace in your hands';
    subtitle = 'Your demo app is ready! Follow the steps below to experience it.';
    stepOneHeader = "Download Thrive";
    stepOneInstructions = "Get the Thrive app on your phone to see your customised workspace.";
    stepTwoHeader = "Log in with your organisation name";
    stepThreeHeader = "Manage your content and users";
    stepThreeInstructions = "Log in to your Thrive workspace to add content, manage users, and explore the platform.";
    button = "Log in to Thrive Workspace";
    showErrorBanner = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)(false);
    QRCode = (0, $49df3a8477bb0a2a$export$77cea355fa80b5f4)('');
    showTemporaryError = ()=>{
        this.showErrorBanner.update(true);
        setTimeout(()=>{
            this.showErrorBanner.update(false);
        }, 6000);
    };
    setQrCode = async ()=>{
        const code = await (0, $4db43c6ab8dfea40$export$2e2bcd8739ae039).getQRCodeUrl();
        this.QRCode.update(code);
    };
    onAppStoreClick() {
        const appStoreUrl = (0, $e1e012f89018bf3e$export$c068cf9cc4ccb363)();
        globalThis.open(appStoreUrl, "_blank", "noopener,noreferrer");
    }
    onGooglePlayClick() {
        const googlePlayUrl = (0, $e1e012f89018bf3e$export$929c25f09f7eb20)();
        globalThis.open(googlePlayUrl, "_blank", "noopener,noreferrer");
    }
    onNavigateToCMSClick = async ()=>{
        const params = {
            username: (0, $c9048c433f8ddaa9$export$17c3d14100f89581).createAppForm.value?.emailAddress ?? "",
            password: (0, $c9048c433f8ddaa9$export$17c3d14100f89581).createAppForm.value?.password ?? "",
            orgShortName: (0, $c9048c433f8ddaa9$export$17c3d14100f89581).createAppForm.value?.orgShortName ?? ""
        };
        const res = await (0, $8e7f83eb78a740d0$export$257b2d10b709d8ef)(params).catch(()=>{
            this.showTemporaryError();
        });
        if (res) {
            //redirect to CMS logged in
            const url = (0, $c9048c433f8ddaa9$export$17c3d14100f89581).cmsUrl.value;
            let cmsQueryparams = `authcallbacklogin.html?access_token=${res.data?.access_token}&refresh_token=${res.data?.refresh_token}&returnPath=${url}`;
            if (url) globalThis.open(`${url}/${cmsQueryparams}`, '_blank');
        }
    };
}









const $b28d260fa3919710$var$Download = ()=>{
    const [DM] = (0, $aqdBs.useState)(new (0, $84ac23f9ae43ea96$export$fc63070cd68706d2)());
    const brandColor = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)((0, $c9048c433f8ddaa9$export$17c3d14100f89581).colour);
    const brandFontColor = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)((0, $c9048c433f8ddaa9$export$17c3d14100f89581).fontColour);
    const orgShortName = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)((0, $c9048c433f8ddaa9$export$17c3d14100f89581).orgShortName);
    const showBanner = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.showErrorBanner);
    const QRCode = (0, $32faeec8c8ee057e$export$2e2bcd8739ae039)(DM.QRCode);
    (0, $16173df52a25ecc6$export$2e2bcd8739ae039)();
    (0, $4fcc4b05ac470037$export$d9c11dc682bb51a1)(true);
    (0, $187df3f279454e87$export$2e2bcd8739ae039)();
    (0, $aqdBs.useEffect)(()=>{
        DM.setQrCode();
    }, []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "download-page page-container",
        style: {
            "--brandColor": `#${brandColor}`,
            "--brandFontColor": brandFontColor
        },
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "download-container",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                        className: "download-heading",
                        children: DM.title
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                        className: "download-sub-heading",
                        children: DM.subtitle
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "step-container",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                className: "step-button",
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                className: "step-information",
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                        className: "download-step",
                                        children: DM.stepOneHeader
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                        className: "download-instruction",
                                        children: DM.stepOneInstructions
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                        className: "app-button-panel",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                                className: "app-store-button",
                                                onClick: DM.onAppStoreClick,
                                                "aria-label": "Go to App Store",
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f2dcab3bd4130b1e$exports))),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                                className: "google-play-button",
                                                onClick: DM.onGooglePlayClick,
                                                "aria-label": "Go to Google Play Store",
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2266e2b03eac0cfa$exports))),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                className: "qr-code-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                                                        className: "qr-code",
                                                        src: QRCode,
                                                        alt: "QR code for app store"
                                                    }),
                                                    "Scan to download"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "step-container",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                className: "step-button",
                                children: "2"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                className: "step-information",
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                        className: "download-step",
                                        children: DM.stepTwoHeader
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                        className: "org-information-panel",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h4", {
                                                children: "YOUR ORGANISATION NAME"
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                                className: "org-name",
                                                children: orgShortName
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("p", {
                                                className: "org-instructions",
                                                children: [
                                                    "When you open the Thrive app for the first time, enter",
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                                        className: "org-name-background",
                                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                                            children: orgShortName
                                                        })
                                                    }),
                                                    "as your Organisation name to access your customised workspace."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "step-container",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                className: "step-button",
                                children: "3"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                className: "step-information",
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                        className: "download-step",
                                        children: DM.stepThreeHeader
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                        className: "download-instruction",
                                        children: DM.stepThreeInstructions
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $77c3c92fda4f2fa4$export$2e2bcd8739ae039), {
                                        className: "thrive-navigate-button",
                                        onButtonClick: DM.onNavigateToCMSClick,
                                        content: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d17de690eab2b398$export$2e2bcd8739ae039), {
                                                    iconName: (0, $99899ff752f57db8$export$356109f9df11377f).COMPUTER_EXTERNAL,
                                                    color: "var(--thriveCharcoal)",
                                                    sizeInPx: "14"
                                                }),
                                                DM.button
                                            ]
                                        }),
                                        ariaLabel: DM.button
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showBanner && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6b55b7249683e3c7$export$2e2bcd8739ae039), {
                feedbackType: (0, $4c5a25ac8a95113d$export$9142130869e22063).ERROR,
                feedbackMessage: "Something went wrong with log in"
            })
        ]
    });
};
var $b28d260fa3919710$export$2e2bcd8739ae039 = $b28d260fa3919710$var$Download;




var $aqdBs = parcelRequire("aqdBs");


const $6083650ec8fee152$var$AppStoreRedirector = ()=>{
    (0, $aqdBs.useEffect)(()=>{
        const device = navigator.userAgent || navigator.vendor;
        const googlePlayUrl = (0, $e1e012f89018bf3e$export$929c25f09f7eb20)();
        const appStoreUrl = (0, $e1e012f89018bf3e$export$c068cf9cc4ccb363)();
        const fallbackUrl = `${window.location.origin}/self-serve-onboarding`;
        if (/android/i.test(device)) window.location.replace(googlePlayUrl);
        else if (/iPad|iPhone|iPod|Mac OS/i.test(device)) window.location.replace(appStoreUrl);
        else window.location.replace(fallbackUrl);
    }, []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
        size: 10
    });
};
var $6083650ec8fee152$export$2e2bcd8739ae039 = $6083650ec8fee152$var$AppStoreRedirector;






async function $e2e79da01b20675d$export$c31fe5e9a26fbfbd({ request: request }) {
    const userIsVerified = (0, $c9048c433f8ddaa9$export$17c3d14100f89581).checkIfUserIsVerified();
    const hasCreatedApp = (0, $c9048c433f8ddaa9$export$17c3d14100f89581).getCmsLink();
    const url = new URL(request.url);
    const pathname = url.pathname;
    const step = Object.keys((0, $994acc88dfceac67$export$5edc7b7ed75aa907)).find((key)=>(0, $994acc88dfceac67$export$5edc7b7ed75aa907)[key] === pathname);
    if (!step) return null;
    let target = null;
    if (hasCreatedApp) target = (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).DOWNLOAD];
    else if (userIsVerified) target = (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).DESIGN];
    else if (step === (0, $994acc88dfceac67$export$46542447417a4445).DOWNLOAD || step === (0, $994acc88dfceac67$export$46542447417a4445).DESIGN) target = (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).ONBOARDING];
    else target = (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[step];
    if (target === pathname) return null;
    return (0, $341c792fffde747f$export$89e12c5b50f7529d)(target);
}


const $4d9f1a11a5ea4a5e$var$createRouter = ()=>(0, $341c792fffde747f$export$1f3f55432a00e06d)([
        {
            path: "/",
            element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $341c792fffde747f$export$444b3ab0cb9aec40), {
                to: (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).ONBOARDING],
                replace: true
            }),
            loader: (0, $e2e79da01b20675d$export$c31fe5e9a26fbfbd),
            hydrateFallbackElement: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                size: 22
            })
        },
        {
            path: (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).ONBOARDING],
            element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $33b694e50d542f45$export$2e2bcd8739ae039), {}),
            loader: (0, $e2e79da01b20675d$export$c31fe5e9a26fbfbd),
            hydrateFallbackElement: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                size: 22
            })
        },
        {
            path: (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).DETAILS],
            element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6d04aed25cfde5d1$export$2e2bcd8739ae039), {}),
            loader: (0, $e2e79da01b20675d$export$c31fe5e9a26fbfbd),
            hydrateFallbackElement: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                size: 22
            })
        },
        {
            path: (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).DESIGN],
            element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $97e9b630cb3b7fc4$export$2e2bcd8739ae039), {}),
            loader: (0, $e2e79da01b20675d$export$c31fe5e9a26fbfbd),
            hydrateFallbackElement: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                size: 22
            })
        },
        {
            path: (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).DOWNLOAD],
            element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $b28d260fa3919710$export$2e2bcd8739ae039), {}),
            loader: (0, $e2e79da01b20675d$export$c31fe5e9a26fbfbd),
            hydrateFallbackElement: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                size: 22
            })
        },
        {
            path: (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).REDIRECTOR],
            element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6083650ec8fee152$export$2e2bcd8739ae039), {}),
            loader: (0, $e2e79da01b20675d$export$c31fe5e9a26fbfbd),
            hydrateFallbackElement: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                size: 22
            })
        },
        {
            path: "*",
            element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $341c792fffde747f$export$444b3ab0cb9aec40), {
                to: (0, $994acc88dfceac67$export$5edc7b7ed75aa907)[(0, $994acc88dfceac67$export$46542447417a4445).ONBOARDING],
                replace: true
            }),
            loader: (0, $e2e79da01b20675d$export$c31fe5e9a26fbfbd),
            hydrateFallbackElement: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e6b5cf652b3eebc$export$2e2bcd8739ae039), {
                size: 22
            })
        }
    ]);
var $4d9f1a11a5ea4a5e$export$2e2bcd8739ae039 = $4d9f1a11a5ea4a5e$var$createRouter;


const $02f5a29b8384e330$var$container = document.getElementById("root");
const $02f5a29b8384e330$var$root = (0, $c920eedc27eaef64$export$882461b6382ed46c)($02f5a29b8384e330$var$container);
$02f5a29b8384e330$var$root.render(/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6ef136a4babdb9db$export$2e2bcd8739ae039), {
    router: (0, $4d9f1a11a5ea4a5e$export$2e2bcd8739ae039)()
}));


//# sourceMappingURL=signup.abca55ff.js.map
